import * as React$1 from 'react';
import React__default, { memo as memo$1, useEffect, useState, useRef, isValidElement, PureComponent, Component, useCallback, useMemo, createElement, useLayoutEffect, createRef, forwardRef, createContext, useContext, useId as useId$1, useInsertionEffect as useInsertionEffect$1, Fragment, Children } from 'react';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { findDOMNode as findDOMNode$1 } from 'react-dom';
import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$u = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.progress {\n  display: flex;\n}\n\n.progress-ring {\n  margin-right: 0.8rem;\n  height: 1.6rem;\n}\n.progress-ring svg .progress-ring__background {\n  fill: none;\n  stroke-width: 1.5;\n}\n.progress-ring svg .progress-ring__progress {\n  fill: none;\n  stroke-dasharray: 45;\n  stroke-dashoffset: 100;\n  stroke-linecap: round;\n  stroke-width: 1.5;\n  transition: stroke-dashoffset 1s ease-in-out;\n}\n.progress-ring svg .progress-ring__check {\n  stroke-dasharray: 100 100;\n  stroke-dashoffset: 100;\n}\n.progress-ring polyline[class~=active] {\n  animation: check-animated 1s;\n}\n\n.progress-percent {\n  font-family: Roboto, sans-serif;\n  font-size: 1.2rem;\n  font-weight: 500;\n  line-height: 1.6rem;\n}\n\n.progress-ring__text-color__black {\n  color: #333333;\n}\n.progress-ring__text-color__white {\n  color: #ffffff;\n}\n.progress-ring__text-color__grey {\n  color: #d6d6d6;\n}\n.progress-ring__text-color__common {\n  color: #254e5f;\n}\n.progress-ring__text-color__info {\n  color: #5bc0de;\n}\n.progress-ring__text-color__success {\n  color: #8bc34a;\n}\n.progress-ring__text-color__warning {\n  color: #dcae1d;\n}\n.progress-ring__text-color__error {\n  color: #d12e34;\n}\n.progress-ring__text-color__default {\n  color: #254e5f;\n}\n.progress-ring__text-color__ofd {\n  color: #4ba1a5;\n}\n.progress-ring__text-color__edo {\n  color: #f5a91b;\n}\n.progress-ring__text-color__epd {\n  color: #f5a91b;\n}\n.progress-ring__text-color__gosotchet {\n  color: #488bca;\n}\n.progress-ring__text-color__td {\n  color: #ea8242;\n}\n.progress-ring__text-color__marking {\n  color: #4bb9ba;\n}\n.progress-ring__text-color__check-index {\n  color: #5bc0de;\n}\n.progress-ring__text-color__big-data {\n  color: #5ab8c5;\n}\n.progress-ring__text-color__arenda {\n  color: #d58576;\n}\n.progress-ring__text-color__integrations {\n  color: #797ca4;\n}\n.progress-ring__text-color__onec {\n  color: #e36052;\n}\n.progress-ring__text-color__mchd {\n  color: #626ab7;\n}\n.progress-ring__text-color__elk {\n  color: #577590;\n}\n\n.progress-ring__stroke__black {\n  stroke: #333333;\n}\n.progress-ring__stroke__white {\n  stroke: #ffffff;\n}\n.progress-ring__stroke__grey {\n  stroke: #d6d6d6;\n}\n.progress-ring__stroke__common {\n  stroke: #254e5f;\n}\n.progress-ring__stroke__info {\n  stroke: #5bc0de;\n}\n.progress-ring__stroke__success {\n  stroke: #8bc34a;\n}\n.progress-ring__stroke__warning {\n  stroke: #dcae1d;\n}\n.progress-ring__stroke__error {\n  stroke: #d12e34;\n}\n.progress-ring__stroke__default {\n  stroke: #254e5f;\n}\n.progress-ring__stroke__ofd {\n  stroke: #4ba1a5;\n}\n.progress-ring__stroke__edo {\n  stroke: #f5a91b;\n}\n.progress-ring__stroke__epd {\n  stroke: #f5a91b;\n}\n.progress-ring__stroke__gosotchet {\n  stroke: #488bca;\n}\n.progress-ring__stroke__td {\n  stroke: #ea8242;\n}\n.progress-ring__stroke__marking {\n  stroke: #4bb9ba;\n}\n.progress-ring__stroke__check-index {\n  stroke: #5bc0de;\n}\n.progress-ring__stroke__big-data {\n  stroke: #5ab8c5;\n}\n.progress-ring__stroke__arenda {\n  stroke: #d58576;\n}\n.progress-ring__stroke__integrations {\n  stroke: #797ca4;\n}\n.progress-ring__stroke__onec {\n  stroke: #e36052;\n}\n.progress-ring__stroke__mchd {\n  stroke: #626ab7;\n}\n.progress-ring__stroke__elk {\n  stroke: #577590;\n}";
styleInject(css_248z$u);

const ActivityRing = memo$1((props) => {
    const { progress, showProgressText, progressRingColor, progressTextColor, theme, product } = props;
    const progressRing = React__default.useRef(null);
    const progressCheck = React__default.useRef(null);
    useEffect(() => {
        const curPrRing = progressRing.current;
        const curPrCheck = progressCheck.current;
        if (progress && curPrRing && curPrCheck) {
            const progressRingDasharray = window.getComputedStyle(curPrRing).strokeDasharray;
            const strokeDashOffsetValue = progressRingDasharray && (parseInt(progressRingDasharray, 10) / 100) * (100 - progress);
            curPrRing.style.strokeDashoffset = String(strokeDashOffsetValue);
            if (progress >= 100) {
                curPrCheck === null || curPrCheck === void 0 ? void 0 : curPrCheck.classList.add('active');
                curPrCheck.style.strokeDashoffset = String(0);
            }
            else {
                curPrCheck === null || curPrCheck === void 0 ? void 0 : curPrCheck.classList.remove('active');
                curPrCheck.style.strokeDashoffset = String(100);
            }
        }
    }, [progress]);
    const strokeBgCls = `progress-ring__stroke__${theme || product}`;
    const strokeRingCls = progressRingColor
        ? `progress-ring__stroke__${progressRingColor}`
        : 'progress-ring__stroke__common';
    const textCls = progressTextColor
        ? `progress-ring__text-color__${progressTextColor}`
        : 'progress-ring__text-color__white';
    return (React__default.createElement("div", { className: "progress" }, progress > 0 && (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "progress-ring" },
            React__default.createElement("svg", { width: "16", height: "16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "7.25", className: `progress-ring__background ${strokeBgCls}` }),
                React__default.createElement("circle", { cx: "8", cy: "8", r: "7.25", className: `progress-ring__progress ${strokeRingCls}`, transform: "rotate(-90 8 8)", ref: progressRing }),
                React__default.createElement("polyline", { ref: progressCheck, points: "5.5,8 7.5,10.5 11,6", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", className: "progress-ring__check" }))),
        showProgressText && React__default.createElement("span", { className: `progress-percent ${textCls}` },
            progress,
            "%")))));
});
ActivityRing.displayName = 'ActivityRing';

var css_248z$t = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_Regular_400.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_SemiBold_600.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_Bold_700.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n/* Общий стиль для всех кнопок */\n.storybook-button {\n  position: relative;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-weight: normal;\n  border-radius: 0.2rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  line-height: 1;\n  outline: none;\n  transition: all 0.3s;\n  width: 100%;\n  justify-content: center;\n  padding: 0 3.2rem;\n}\n.storybook-button:hover {\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n.storybook-button:focus-visible {\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07), 0 0 0 0.3rem #5bc0de;\n}\n\n.storybook-button--text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.storybook-button--icon span {\n  margin-right: 0.8rem;\n  margin-left: 0.8rem;\n}\n\n.storybook-button--download {\n  text-decoration: none;\n}\n\n/* Анимация загрузки */\n.storybook-button--progress {\n  position: absolute;\n  top: 0.1rem;\n  left: 0.1rem;\n  width: 100%;\n  height: 100%;\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 4rem 4rem;\n  transition: width 0.6s ease;\n  animation: progress-bar-stripes 2s linear infinite;\n  transform: translate(-0.1rem, -0.1rem);\n  border-radius: 0.2rem;\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 4rem 0;\n  }\n}\n/* Размер кнопок */\n.storybook-button--medium {\n  font-size: 1.4rem;\n  height: 3.2rem;\n}\n.storybook-button--medium svg {\n  width: 1.4rem;\n  height: 1.4rem;\n}\n\n.storybook-button--large {\n  font-size: 1.6rem;\n  line-height: 2.4rem;\n  height: 4.8rem;\n  word-break: break-all;\n}\n.storybook-button--large svg {\n  width: 1.8rem;\n  height: 1.8rem;\n}\n\n/* Стиль задизейблиной кнопки */\n.storybook-button:disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n/* Кнопка только с иконкой */\n.storybook-button__without_label {\n  min-width: 4.8rem;\n  width: 4.8rem;\n  padding: 0;\n}\n.storybook-button__without_label svg {\n  margin: 0;\n}\n\n.storybook-button--medium.storybook-button__without_label {\n  min-width: 3.2rem;\n  width: 3.2rem;\n}\n\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n/* Стиль кнопки secondary */\n.storybook-button--secondary {\n  background-color: #ffffff;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border: 0.1rem solid;\n}\n\n.storybook-button--secondary:hover {\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n\n.storybook-button--secondary:active {\n  box-shadow: inset 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n\n.storybook-button--secondary .storybook-button--progress {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.4) 25%, rgb(255, 255, 255) 25%, rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.4) 75%, rgb(255, 255, 255) 75%, rgb(255, 255, 255));\n  box-shadow: inset 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n\n/* Тема кнопки ofd */\n.storybook-button--secondary.ofd {\n  border-color: #4ba1a5;\n  color: #4ba1a5;\n}\n.storybook-button--secondary.ofd .storybook-button--progress {\n  background-color: #e3eff0;\n}\n.storybook-button--secondary.ofd:focus-visible {\n  color: #40898c;\n}\n.storybook-button--secondary.ofd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #40898c;\n}\n\n.storybook-button--secondary.ofd:hover {\n  border-color: #40898c;\n  color: #40898c;\n}\n.storybook-button--secondary.ofd:hover svg {\n  transition: 0.3s;\n  stroke: #40898c;\n}\n\n.storybook-button--secondary.ofd:active {\n  background: #e3eff0;\n  color: #4ba1a5;\n}\n.storybook-button--secondary.ofd:active svg {\n  transition: 0.3s;\n  stroke: #4ba1a5;\n}\n\n/* Тема кнопки td */\n.storybook-button--secondary.td {\n  border-color: #ea8242;\n  color: #ea8242;\n}\n.storybook-button--secondary.td .storybook-button--progress {\n  background-color: #fcf3ed;\n}\n.storybook-button--secondary.td:focus-visible {\n  color: #e76e23;\n}\n.storybook-button--secondary.td:focus-visible svg {\n  transition: 0.3s;\n  stroke: #e76e23;\n}\n\n.storybook-button--secondary.td:hover {\n  border-color: #e76e23;\n  color: #e76e23;\n}\n.storybook-button--secondary.td:hover svg {\n  transition: 0.3s;\n  stroke: #e76e23;\n}\n\n.storybook-button--secondary.td:active {\n  background: #fcf3ed;\n  color: #ea8242;\n}\n.storybook-button--secondary.td:active svg {\n  transition: 0.3s;\n  stroke: #ea8242;\n}\n\n/* Тема кнопки edo */\n.storybook-button--secondary.edo {\n  color: #f5a91b;\n  border-color: #f5a91b;\n}\n.storybook-button--secondary.edo .storybook-button--progress {\n  background-color: #fcf6ea;\n}\n.storybook-button--secondary.edo:focus-visible {\n  color: #eb9d0c;\n}\n.storybook-button--secondary.edo:focus-visible svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--secondary.edo:hover {\n  border-color: #eb9d0c;\n  color: #eb9d0c;\n}\n.storybook-button--secondary.edo:hover svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--secondary.edo:active {\n  background: #fcf6ea;\n  color: #f5a91b;\n}\n.storybook-button--secondary.edo:active svg {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n\n/* Тема кнопки epd */\n.storybook-button--secondary.epd {\n  color: #f5a91b;\n  border-color: #f5a91b;\n}\n.storybook-button--secondary.epd .storybook-button--progress {\n  background-color: #fcf6ea;\n}\n.storybook-button--secondary.epd:focus-visible {\n  color: #eb9d0c;\n}\n.storybook-button--secondary.epd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--secondary.epd:hover {\n  border-color: #eb9d0c;\n  color: #eb9d0c;\n}\n.storybook-button--secondary.epd:hover svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--secondary.epd:active {\n  background: #fcf6ea;\n  color: #f5a91b;\n}\n.storybook-button--secondary.epd:active svg {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n\n/* Тема кнопки gosotchet */\n.storybook-button--secondary.gosotchet {\n  color: #488bca;\n  border-color: #488bca;\n}\n.storybook-button--secondary.gosotchet .storybook-button--progress {\n  background-color: #eaf1f8;\n}\n.storybook-button--secondary.gosotchet:focus-visible {\n  color: #367aba;\n}\n.storybook-button--secondary.gosotchet:focus-visible svg {\n  transition: 0.3s;\n  stroke: #367aba;\n}\n\n.storybook-button--secondary.gosotchet:hover {\n  color: #367aba;\n  border-color: #367aba;\n}\n.storybook-button--secondary.gosotchet:hover svg {\n  transition: 0.3s;\n  stroke: #367aba;\n}\n\n.storybook-button--secondary.gosotchet:active {\n  background: #eaf1f8;\n  color: #488bca;\n}\n.storybook-button--secondary.gosotchet:active svg {\n  transition: 0.3s;\n  stroke: #488bca;\n}\n\n/* Тема кнопки arenda */\n.storybook-button--secondary.arenda {\n  color: #d58576;\n  border-color: #d58576;\n}\n.storybook-button--secondary.arenda .storybook-button--progress {\n  background-color: #f9f2f1;\n}\n.storybook-button--secondary.arenda:focus-visible {\n  color: #cd6d5b;\n}\n.storybook-button--secondary.arenda:focus-visible svg {\n  transition: 0.3s;\n  stroke: #cd6d5b;\n}\n\n.storybook-button--secondary.arenda:hover {\n  color: #cd6d5b;\n  border-color: #cd6d5b;\n}\n.storybook-button--secondary.arenda:hover svg {\n  transition: 0.3s;\n  stroke: #cd6d5b;\n}\n\n.storybook-button--secondary.arenda:active {\n  background: #f9f2f1;\n  color: #d58576;\n}\n.storybook-button--secondary.arenda:active svg {\n  transition: 0.3s;\n  stroke: #d58576;\n}\n\n/* Тема кнопки marking */\n.storybook-button--secondary.marking {\n  color: #4bb9ba;\n  border-color: #4bb9ba;\n}\n.storybook-button--secondary.marking .storybook-button--progress {\n  background-color: #f1f9f9;\n}\n.storybook-button--secondary.marking:focus-visible {\n  color: #3ea1a2;\n}\n.storybook-button--secondary.marking:focus-visible svg {\n  transition: 0.3s;\n  stroke: #3ea1a2;\n}\n\n.storybook-button--secondary.marking:hover {\n  color: #3ea1a2;\n  border-color: #3ea1a2;\n}\n.storybook-button--secondary.marking:hover svg {\n  transition: 0.3s;\n  stroke: #3ea1a2;\n}\n\n.storybook-button--secondary.marking:active {\n  background: #f1f9f9;\n  color: #4bb9ba;\n}\n.storybook-button--secondary.marking:active svg {\n  transition: 0.3s;\n  stroke: #4bb9ba;\n}\n\n/* Тема кнопки big-data */\n.storybook-button--secondary.big-data {\n  color: #5ab8c5;\n  border-color: #5ab8c5;\n}\n.storybook-button--secondary.big-data .storybook-button--progress {\n  background-color: #e7f2f3;\n}\n.storybook-button--secondary.big-data:focus-visible {\n  color: #41aab9;\n}\n.storybook-button--secondary.big-data:focus-visible svg {\n  transition: 0.3s;\n  stroke: #41aab9;\n}\n\n.storybook-button--secondary.big-data:hover {\n  color: #41aab9;\n  border-color: #41aab9;\n}\n.storybook-button--secondary.big-data:hover svg {\n  transition: 0.3s;\n  stroke: #41aab9;\n}\n\n.storybook-button--secondary.big-data:active {\n  background: #e7f2f3;\n  color: #5ab8c5;\n}\n.storybook-button--secondary.big-data:active svg {\n  transition: 0.3s;\n  stroke: #5ab8c5;\n}\n\n/* Тема кнопки check-index */\n.storybook-button--secondary.check-index {\n  color: #5bc0de;\n  border-color: #5bc0de;\n}\n.storybook-button--secondary.check-index .storybook-button--progress {\n  background-color: #f3fafc;\n}\n.storybook-button--secondary.check-index:focus-visible {\n  color: #3cb4d8;\n}\n.storybook-button--secondary.check-index:focus-visible svg {\n  transition: 0.3s;\n  stroke: #3cb4d8;\n}\n\n.storybook-button--secondary.check-index:hover {\n  color: #3cb4d8;\n  border-color: #3cb4d8;\n}\n.storybook-button--secondary.check-index:hover svg {\n  transition: 0.3s;\n  stroke: #3cb4d8;\n}\n\n.storybook-button--secondary.check-index:active {\n  background: #f3fafc;\n  color: #5bc0de;\n}\n.storybook-button--secondary.check-index:active svg {\n  transition: 0.3s;\n  stroke: #5bc0de;\n}\n\n/* Тема кнопки МЧД */\n.storybook-button--secondary.mchd {\n  color: #626ab7;\n  border-color: #626ab7;\n}\n.storybook-button--secondary.mchd .storybook-button--progress {\n  background-color: #fbefee;\n}\n.storybook-button--secondary.mchd:focus-visible {\n  color: #4c55a9;\n}\n.storybook-button--secondary.mchd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #4c55a9;\n}\n\n.storybook-button--secondary.mchd:hover {\n  color: #4c55a9;\n  border-color: #4c55a9;\n}\n.storybook-button--secondary.mchd:hover svg {\n  transition: 0.3s;\n  stroke: #4c55a9;\n}\n\n.storybook-button--secondary.mchd:active {\n  background: #fbefee;\n  color: #626ab7;\n}\n.storybook-button--secondary.mchd:active svg {\n  transition: 0.3s;\n  stroke: #626ab7;\n}\n\n/* Тема кнопки ЕЛК */\n.storybook-button--secondary.elk {\n  border-color: #577590;\n  color: #577590;\n}\n.storybook-button--secondary.elk .storybook-button--progress {\n  background-color: #f0f2f5;\n}\n.storybook-button--secondary.elk:focus-visible {\n  color: #466077;\n}\n.storybook-button--secondary.elk:focus-visible svg {\n  transition: 0.3s;\n  stroke: #466077;\n}\n\n.storybook-button--secondary.elk:hover {\n  border-color: #466077;\n  color: #466077;\n}\n.storybook-button--secondary.elk:hover svg {\n  transition: 0.3s;\n  stroke: #466077;\n}\n\n.storybook-button--secondary.elk:active {\n  background: #f0f2f5;\n  color: #577590;\n}\n.storybook-button--secondary.elk:active svg {\n  transition: 0.3s;\n  stroke: #577590;\n}\n\n/* Тема кнопки success */\n.storybook-button--secondary.success {\n  color: #8bc34a;\n  border-color: #8bc34a;\n}\n.storybook-button--secondary.success .storybook-button--progress {\n  background-color: #f5f9f0;\n}\n.storybook-button--secondary.success:focus-visible {\n  color: #7ab03a;\n}\n.storybook-button--secondary.success:focus-visible svg {\n  transition: 0.3s;\n  stroke: #7ab03a;\n}\n\n.storybook-button--secondary.success:hover {\n  color: #7ab03a;\n  border-color: #7ab03a;\n}\n.storybook-button--secondary.success:hover svg {\n  transition: 0.3s;\n  stroke: #7ab03a;\n}\n\n.storybook-button--secondary.success:active {\n  background: #f5f9f0;\n  color: #8bc34a;\n}\n.storybook-button--secondary.success:active svg {\n  transition: 0.3s;\n  stroke: #8bc34a;\n}\n\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n/* Стиль кнопки primary */\n.storybook-button--primary {\n  color: #ffffff;\n  border: none;\n}\n\n.storybook-button--primary:active {\n  box-shadow: inset 0 0.3rem 0.4rem 0 rgba(0, 0, 0, 0.1);\n}\n\n.storybook-button--primary .storybook-button--progress {\n  box-shadow: inset 0 0.3rem 0.4rem 0 rgba(0, 0, 0, 0.1);\n}\n\n/* Тема кнопки ofd */\n.storybook-button--primary.ofd {\n  background-color: #4ba1a5;\n}\n\n.storybook-button--primary.ofd:is(:focus-visible, :hover) {\n  background: #40898c;\n}\n\n.storybook-button--primary.ofd:active {\n  background: #357d81;\n}\n\n.storybook-button--primary.ofd .storybook-button--progress {\n  background-color: #4ba1a5;\n}\n\n/* Тема кнопки td */\n.storybook-button--primary.td {\n  background-color: #ea8242;\n}\n\n.storybook-button--primary.td:is(:focus-visible, :hover) {\n  background: #e76e23;\n}\n\n.storybook-button--primary.td:active {\n  background: #e26212;\n}\n\n.storybook-button--primary.td .storybook-button--progress {\n  background-color: #ea8242;\n}\n\n/* Тема кнопки edo */\n.storybook-button--primary.edo {\n  background-color: #f5a91b;\n}\n\n.storybook-button--primary.edo:is(:focus-visible, :hover) {\n  background: #eb9d0c;\n}\n\n.storybook-button--primary.edo:active {\n  background: #e89700;\n}\n\n.storybook-button--primary.edo .storybook-button--progress {\n  background-color: #f5a91b;\n}\n\n/* Тема кнопки epd */\n.storybook-button--primary.epd {\n  background-color: #f5a91b;\n}\n\n.storybook-button--primary.epd:is(:focus-visible, :hover) {\n  background: #eb9d0c;\n}\n\n.storybook-button--primary.epd:active {\n  background: #e89700;\n}\n\n.storybook-button--primary.epd .storybook-button--progress {\n  background-color: #f5a91b;\n}\n\n/* Тема кнопки gosotchet */\n.storybook-button--primary.gosotchet {\n  background-color: #488bca;\n}\n\n.storybook-button--primary.gosotchet:is(:focus-visible, :hover) {\n  background: #367aba;\n}\n\n.storybook-button--primary.gosotchet:active {\n  background: #2c70af;\n}\n\n.storybook-button--primary.gosotchet .storybook-button--progress {\n  background-color: #488bca;\n}\n\n/* Тема кнопки arenda */\n.storybook-button--primary.arenda {\n  background-color: #d58576;\n}\n\n.storybook-button--primary.arenda:is(:focus-visible, :hover) {\n  background: #cd6d5b;\n}\n\n.storybook-button--primary.arenda:active {\n  background: #ce5a46;\n}\n\n.storybook-button--primary.arenda .storybook-button--progress {\n  background-color: #d58576;\n}\n\n/* Тема кнопки marking */\n.storybook-button--primary.marking {\n  background-color: #4bb9ba;\n}\n\n.storybook-button--primary.marking:is(:focus-visible, :hover) {\n  background: #3ea1a2;\n}\n\n.storybook-button--primary.marking:active {\n  background: #339799;\n}\n\n.storybook-button--primary.marking .storybook-button--progress {\n  background-color: #4bb9ba;\n}\n\n/* Тема кнопки big-data */\n.storybook-button--primary.big-data {\n  background-color: #5ab8c5;\n}\n\n.storybook-button--primary.big-data:is(:focus-visible, :hover) {\n  background: #41aab9;\n}\n\n.storybook-button--primary.big-data:active {\n  background: #36a1b0;\n}\n\n.storybook-button--primary.big-data .storybook-button--progress {\n  background-color: #5ab8c5;\n}\n\n/* Тема кнопки check-index */\n.storybook-button--primary.check-index {\n  background-color: #5bc0de;\n}\n\n.storybook-button--primary.check-index:is(:focus-visible, :hover) {\n  background: #3cb4d8;\n}\n\n.storybook-button--primary.check-index:active {\n  background: #2097bc;\n}\n\n.storybook-button--primary.check-index .storybook-button--progress {\n  background-color: #5bc0de;\n}\n\n/* Тема кнопки МЧД */\n.storybook-button--primary.mchd {\n  background-color: #626ab7;\n}\n\n.storybook-button--primary.mchd:is(:focus-visible, :hover) {\n  background: #4c55a9;\n}\n\n.storybook-button--primary.mchd:active {\n  background: #434ca3;\n}\n\n.storybook-button--primary.mchd .storybook-button--progress {\n  background-color: #626ab7;\n}\n\n/* Тема кнопки ЕЛК */\n.storybook-button--primary.elk {\n  background-color: #577590;\n}\n\n.storybook-button--primary.elk:is(:focus-visible, :hover) {\n  background: #466077;\n}\n\n.storybook-button--primary.elk:active {\n  background: #344b60;\n}\n\n.storybook-button--primary.elk .storybook-button--progress {\n  background-color: #577590;\n}\n\n/* Тема кнопки success */\n.storybook-button--primary.success {\n  background-color: #8bc34a;\n}\n\n.storybook-button--primary.success:focus-visible {\n  background: #7ab03a;\n}\n\n.storybook-button--primary.success:hover {\n  background: #7ab03a;\n}\n\n.storybook-button--primary.success:active {\n  background: #5d8a28;\n}\n\n.storybook-button--primary.success .storybook-button--progress {\n  background-color: #8bc34a;\n}\n\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n/* Стиль кнопки aside-secondary */\n.storybook-button--aside-secondary {\n  color: #ffffff;\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n  border: 0.1rem solid #ffffff;\n}\n.storybook-button--aside-secondary svg {\n  position: absolute;\n  left: 1.6rem;\n  width: 2rem;\n  height: 2rem;\n}\n\n.storybook-button--aside-secondary.storybook-button--icon span {\n  margin-right: 0;\n  margin-left: 1.6rem;\n}\n\n.storybook-button--aside-secondary.storybook-button--aside {\n  width: 4rem;\n  height: 4rem;\n  padding: 0;\n}\n@media (min-width: 1200px) {\n  .storybook-button--aside-secondary.storybook-button--aside {\n    width: 100%;\n    height: 4.8rem;\n  }\n}\n.storybook-button--aside-secondary.storybook-button--aside span {\n  margin-right: 0;\n  margin-left: 1.6rem;\n  display: none;\n}\n@media (min-width: 1200px) {\n  .storybook-button--aside-secondary.storybook-button--aside span {\n    display: block;\n  }\n}\n.storybook-button--aside-secondary.storybook-button--aside svg {\n  transition: 0.3s;\n  width: 1.6rem;\n  height: 1.6rem;\n  left: auto;\n}\n@media (min-width: 1200px) {\n  .storybook-button--aside-secondary.storybook-button--aside svg {\n    position: absolute;\n    left: 1.6rem;\n    width: 2rem;\n    height: 2rem;\n  }\n}\n\n.storybook-button--aside-secondary:active {\n  box-shadow: inset 0 0.3rem 0.4rem 0 rgba(0, 0, 0, 0.1);\n}\n\n/* Тема кнопки ofd */\n.storybook-button--aside-secondary.ofd {\n  background-color: #4ba1a5;\n}\n\n.storybook-button--aside-secondary.ofd:hover {\n  background: #40898c;\n}\n\n.storybook-button--aside-secondary.ofd:active {\n  background: #357d81;\n}\n\n.storybook-button--aside-secondary.ofd .storybook-button--progress {\n  background-color: #4ba1a5;\n}\n\n.storybook-button--aside-secondary.ofd:focus-visible {\n  background: #40898c;\n}\n\n/* Тема кнопки td */\n.storybook-button--aside-secondary.td {\n  background-color: #ea8242;\n}\n\n.storybook-button--aside-secondary.td:hover {\n  background: #e76e23;\n}\n\n.storybook-button--aside-secondary.td:active {\n  background: #e26212;\n}\n\n.storybook-button--aside-secondary.td:focus-visible {\n  background: #e76e23;\n}\n\n.storybook-button--aside-secondary.td .storybook-button--progress {\n  background-color: #ea8242;\n}\n\n/* Тема кнопки edo */\n.storybook-button--aside-secondary.edo {\n  background-color: #f5a91b;\n}\n\n.storybook-button--aside-secondary.edo:hover {\n  background: #eb9d0c;\n}\n\n.storybook-button--aside-secondary.edo:active {\n  background: #e89700;\n}\n\n.storybook-button--aside-secondary.edo:focus-visible {\n  background: #eb9d0c;\n}\n\n.storybook-button--aside-secondary.edo .storybook-button--progress {\n  background-color: #f5a91b;\n}\n\n/* Тема кнопки epd */\n.storybook-button--aside-secondary.epd {\n  background-color: #f5a91b;\n}\n\n.storybook-button--aside-secondary.epd:hover {\n  background: #eb9d0c;\n}\n\n.storybook-button--aside-secondary.epd:active {\n  background: #e89700;\n}\n\n.storybook-button--aside-secondary.epd:focus-visible {\n  background: #eb9d0c;\n}\n\n.storybook-button--aside-secondary.epd .storybook-button--progress {\n  background-color: #f5a91b;\n}\n\n/* Тема кнопки gosotchet */\n.storybook-button--aside-secondary.gosotchet {\n  background-color: #488bca;\n}\n\n.storybook-button--aside-secondary.gosotchet:hover {\n  background: #367aba;\n}\n\n.storybook-button--aside-secondary.gosotchet:active {\n  background: #2c70af;\n  box-shadow: inset 0 0.3rem 0.4rem 0 rgba(0, 0, 0, 0.1);\n}\n\n.storybook-button--aside-secondary.gosotchet:focus-visible {\n  background: #367aba;\n}\n\n.storybook-button--aside-secondary.gosotchet .storybook-button--progress {\n  background-color: #488bca;\n}\n\n/* Тема кнопки arenda */\n.storybook-button--aside-secondary.arenda {\n  background-color: #d58576;\n}\n\n.storybook-button--aside-secondary.arenda:hover {\n  background: #cd6d5b;\n}\n\n.storybook-button--aside-secondary.arenda:active {\n  background: #ce5a46;\n}\n\n.storybook-button--aside-secondary.arenda:focus-visible {\n  background: #cd6d5b;\n}\n\n.storybook-button--aside-secondary.arenda .storybook-button--progress {\n  background-color: #d58576;\n}\n\n/* Тема кнопки marking */\n.storybook-button--aside-secondary.marking {\n  background-color: #4bb9ba;\n}\n\n.storybook-button--aside-secondary.marking:hover {\n  background: #3ea1a2;\n}\n\n.storybook-button--aside-secondary.marking:active {\n  background: #339799;\n}\n\n.storybook-button--aside-secondary.marking:focus-visible {\n  background: #3ea1a2;\n}\n\n.storybook-button--aside-secondary.marking .storybook-button--progress {\n  background-color: #4bb9ba;\n}\n\n/* Тема кнопки big-data */\n.storybook-button--aside-secondary.big-data {\n  background-color: #5ab8c5;\n}\n\n.storybook-button--aside-secondary.big-data:hover {\n  background: #41aab9;\n}\n\n.storybook-button--aside-secondary.big-data:active {\n  background: #36a1b0;\n}\n\n.storybook-button--aside-secondary.big-data:focus-visible {\n  background: #41aab9;\n}\n\n.storybook-button--aside-secondary.big-data .storybook-button--progress {\n  background-color: #5ab8c5;\n}\n\n/* Тема кнопки check-index */\n.storybook-button--aside-secondary.check-index {\n  background-color: #5bc0de;\n}\n\n.storybook-button--aside-secondary.check-index:hover {\n  background: #3cb4d8;\n}\n\n.storybook-button--aside-secondary.check-index:active {\n  background: #2097bc;\n}\n\n.storybook-button--aside-secondary.check-index .storybook-button--progress {\n  background-color: #5bc0de;\n}\n\n/* Тема кнопки МЧД */\n.storybook-button--aside-secondary.mchd {\n  background-color: #626ab7;\n}\n\n.storybook-button--aside-secondary.mchd:hover {\n  background: #4c55a9;\n}\n\n.storybook-button--aside-secondary.mchd:active {\n  background: #434ca3;\n}\n\n.storybook-button--aside-secondary.mchd .storybook-button--progress {\n  background-color: #626ab7;\n}\n\n/* Тема кнопки ЕЛК */\n.storybook-button--aside-secondary.elk {\n  background-color: #577590;\n}\n\n.storybook-button--aside-secondary.elk:hover {\n  background: #466077;\n}\n\n.storybook-button--aside-secondary.elk:active {\n  background: #344b60;\n}\n\n.storybook-button--aside-secondary.elk:focus-visible {\n  background: #466077;\n}\n\n.storybook-button--aside-secondary.elk .storybook-button--progress {\n  background-color: #577590;\n}\n\n/* Тема кнопки success */\n.storybook-button--aside-secondary.success {\n  background-color: #8bc34a;\n}\n\n.storybook-button--aside-secondary.success:hover {\n  background: #7ab03a;\n}\n\n.storybook-button--aside-secondary.success:active {\n  background: #5d8a28;\n}\n\n.storybook-button--aside-secondary.success:focus-visible {\n  background: #7ab03a;\n}\n\n.storybook-button--aside-secondary.success .storybook-button--progress {\n  background-color: #8bc34a;\n}\n\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n/* Стиль кнопки aside-primary */\n.storybook-button--aside-primary {\n  background-color: #ffffff;\n  border: 0.1rem solid rgba(0, 0, 0, 0.05);\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.storybook-button--aside-primary svg {\n  position: absolute;\n  left: 1.6rem;\n  width: 2rem;\n  height: 2rem;\n}\n\n.storybook-button--aside-primary.storybook-button--icon span {\n  margin-right: 0;\n  margin-left: 1.6rem;\n}\n\n.storybook-button--aside-primary.storybook-button--aside {\n  width: 4rem;\n  height: 4rem;\n  padding: 0;\n}\n@media (min-width: 1200px) {\n  .storybook-button--aside-primary.storybook-button--aside {\n    width: 100%;\n    height: 4.8rem;\n  }\n}\n.storybook-button--aside-primary.storybook-button--aside span {\n  margin-right: 0;\n  margin-left: 1.6rem;\n  display: none;\n}\n@media (min-width: 1200px) {\n  .storybook-button--aside-primary.storybook-button--aside span {\n    display: block;\n  }\n}\n.storybook-button--aside-primary.storybook-button--aside svg {\n  transition: 0.3s;\n  width: 1.6rem;\n  height: 1.6rem;\n  left: auto;\n}\n@media (min-width: 1200px) {\n  .storybook-button--aside-primary.storybook-button--aside svg {\n    position: absolute;\n    left: 1.6rem;\n    width: 2rem;\n    height: 2rem;\n  }\n}\n\n.storybook-button--aside-primary:hover {\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.15);\n}\n\n.storybook-button--aside-primary:active {\n  box-shadow: inset 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n\n.storybook-button--aside-primary .storybook-button--progress {\n  background-color: #bcd3d4;\n}\n\n/* Тема кнопки ofd */\n.storybook-button--aside-primary.ofd {\n  color: #4ba1a5;\n}\n\n.storybook-button--aside-primary.ofd:hover {\n  color: #357d81;\n}\n.storybook-button--aside-primary.ofd:hover svg {\n  transition: 0.3s;\n  stroke: #357d81;\n}\n\n.storybook-button--aside-primary.ofd:active {\n  background: #e3eff0;\n  color: #357d81;\n}\n.storybook-button--aside-primary.ofd:active svg {\n  transition: 0.3s;\n  stroke: #357d81;\n}\n\n/* Тема кнопки td */\n.storybook-button--aside-primary.td {\n  color: #ea8242;\n}\n\n.storybook-button--aside-primary.td:hover {\n  color: #e26212;\n}\n.storybook-button--aside-primary.td:hover svg {\n  transition: 0.3s;\n  stroke: #e26212;\n}\n\n.storybook-button--aside-primary.td:active {\n  background: #fcf3ed;\n  color: #e26212;\n}\n.storybook-button--aside-primary.td:active svg {\n  transition: 0.3s;\n  stroke: #e26212;\n}\n\n.storybook-button--aside-primary.td:focus-visible {\n  color: #e26212;\n}\n.storybook-button--aside-primary.td:focus-visible svg {\n  transition: 0.3s;\n  stroke: #e26212;\n}\n\n/* Тема кнопки edo */\n.storybook-button--aside-primary.edo {\n  color: #f5a91b;\n}\n\n.storybook-button--aside-primary.edo:hover {\n  color: #e89700;\n}\n.storybook-button--aside-primary.edo:hover svg {\n  transition: 0.3s;\n  stroke: #e89700;\n}\n\n.storybook-button--aside-primary.edo:active {\n  background: #fcf6ea;\n  color: #e89700;\n}\n.storybook-button--aside-primary.edo:active svg {\n  transition: 0.3s;\n  stroke: #e89700;\n}\n\n.storybook-button--aside-primary.edo:focus-visible {\n  color: #e89700;\n}\n.storybook-button--aside-primary.edo:focus-visible svg {\n  transition: 0.3s;\n  stroke: #e89700;\n}\n\n/* Тема кнопки epd */\n.storybook-button--aside-primary.epd {\n  color: #f5a91b;\n}\n\n.storybook-button--aside-primary.epd:hover {\n  color: #e89700;\n}\n.storybook-button--aside-primary.epd:hover svg {\n  transition: 0.3s;\n  stroke: #e89700;\n}\n\n.storybook-button--aside-primary.epd:active {\n  background: #fcf6ea;\n  color: #e89700;\n}\n.storybook-button--aside-primary.epd:active svg {\n  transition: 0.3s;\n  stroke: #e89700;\n}\n\n.storybook-button--aside-primary.epd:focus-visible {\n  color: #e89700;\n}\n.storybook-button--aside-primary.epd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #e89700;\n}\n\n/* Тема кнопки gosotchet */\n.storybook-button--aside-primary.gosotchet {\n  color: #488bca;\n}\n\n.storybook-button--aside-primary.gosotchet:hover {\n  color: #2c70af;\n}\n.storybook-button--aside-primary.gosotchet:hover svg {\n  transition: 0.3s;\n  stroke: #2c70af;\n}\n\n.storybook-button--aside-primary.gosotchet:active {\n  background: #eaf1f8;\n  color: #2c70af;\n}\n.storybook-button--aside-primary.gosotchet:active svg {\n  transition: 0.3s;\n  stroke: #2c70af;\n}\n\n.storybook-button--aside-primary.gosotchet:focus-visible {\n  color: #2c70af;\n}\n.storybook-button--aside-primary.gosotchet:focus-visible svg {\n  transition: 0.3s;\n  stroke: #2c70af;\n}\n\n/* Тема кнопки arenda */\n.storybook-button--aside-primary.arenda {\n  color: #d58576;\n}\n\n.storybook-button--aside-primary.arenda:hover {\n  color: #ce5a46;\n}\n.storybook-button--aside-primary.arenda:hover svg {\n  transition: 0.3s;\n  stroke: #ce5a46;\n}\n\n.storybook-button--aside-primary.arenda:active {\n  background: #f9f2f1;\n  color: #ce5a46;\n}\n.storybook-button--aside-primary.arenda:active svg {\n  transition: 0.3s;\n  stroke: #ce5a46;\n}\n\n.storybook-button--aside-primary.arenda:focus-visible {\n  color: #ce5a46;\n}\n.storybook-button--aside-primary.arenda:focus-visible svg {\n  transition: 0.3s;\n  stroke: #ce5a46;\n}\n\n/* Тема кнопки marking */\n.storybook-button--aside-primary.marking {\n  color: #4bb9ba;\n}\n\n.storybook-button--aside-primary.marking:hover {\n  color: #339799;\n}\n.storybook-button--aside-primary.marking:hover svg {\n  transition: 0.3s;\n  stroke: #339799;\n}\n\n.storybook-button--aside-primary.marking:active {\n  background: #f1f9f9;\n  color: #339799;\n}\n.storybook-button--aside-primary.marking:active svg {\n  transition: 0.3s;\n  stroke: #339799;\n}\n\n.storybook-button--aside-primary.marking:focus-visible {\n  color: #339799;\n}\n.storybook-button--aside-primary.marking:focus-visible svg {\n  transition: 0.3s;\n  stroke: #339799;\n}\n\n/* Тема кнопки big-data */\n.storybook-button--aside-primary.big-data {\n  color: #5ab8c5;\n}\n\n.storybook-button--aside-primary.big-data:hover {\n  color: #36a1b0;\n}\n.storybook-button--aside-primary.big-data:hover svg {\n  transition: 0.3s;\n  stroke: #36a1b0;\n}\n\n.storybook-button--aside-primary.big-data:active {\n  background: #e7f2f3;\n  color: #36a1b0;\n}\n.storybook-button--aside-primary.big-data:active svg {\n  transition: 0.3s;\n  stroke: #36a1b0;\n}\n\n.storybook-button--aside-primary.big-data:focus-visible {\n  color: #36a1b0;\n}\n.storybook-button--aside-primary.big-data:focus-visible svg {\n  transition: 0.3s;\n  stroke: #36a1b0;\n}\n\n/* Тема кнопки check-index */\n.storybook-button--aside-primary.check-index {\n  color: #5bc0de;\n}\n\n.storybook-button--aside-primary.check-index:hover {\n  color: #23a5cd;\n}\n.storybook-button--aside-primary.check-index:hover svg {\n  transition: 0.3s;\n  stroke: #23a5cd;\n}\n\n.storybook-button--aside-primary.check-index:active {\n  background: #f3fafc;\n  color: #23a5cd;\n}\n.storybook-button--aside-primary.check-index:active svg {\n  transition: 0.3s;\n  stroke: #23a5cd;\n}\n\n.storybook-button--aside-primary.check-index:focus-visible {\n  color: #23a5cd;\n}\n.storybook-button--aside-primary.check-index:focus-visible svg {\n  transition: 0.3s;\n  stroke: #23a5cd;\n}\n\n/* Тема кнопки МЧД */\n.storybook-button--aside-primary.mchd {\n  color: #626ab7;\n}\n\n.storybook-button--aside-primary.mchd:hover {\n  color: #434ca3;\n}\n.storybook-button--aside-primary.mchd:hover svg {\n  transition: 0.3s;\n  stroke: #434ca3;\n}\n\n.storybook-button--aside-primary.mchd:active {\n  background: #fbefee;\n  color: #434ca3;\n}\n.storybook-button--aside-primary.mchd:active svg {\n  transition: 0.3s;\n  stroke: #434ca3;\n}\n\n.storybook-button--aside-primary.mchd:focus-visible {\n  color: #434ca3;\n}\n.storybook-button--aside-primary.mchd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #434ca3;\n}\n\n/* Тема кнопки ЕЛК */\n.storybook-button--aside-primary.elk {\n  color: #577590;\n}\n\n.storybook-button--aside-primary.elk:hover {\n  color: #344b60;\n}\n.storybook-button--aside-primary.elk:hover svg {\n  transition: 0.3s;\n  stroke: #344b60;\n}\n\n.storybook-button--aside-primary.elk:active {\n  background: #f0f2f5;\n  color: #344b60;\n}\n.storybook-button--aside-primary.elk:active svg {\n  transition: 0.3s;\n  stroke: #344b60;\n}\n\n.storybook-button--aside-primary.elk:focus-visible {\n  color: #344b60;\n}\n.storybook-button--aside-primary.elk:focus-visible svg {\n  transition: 0.3s;\n  stroke: #344b60;\n}\n\n/* Тема кнопки success */\n.storybook-button--aside-primary.success {\n  color: #8bc34a;\n}\n\n.storybook-button--aside-primary.success:hover {\n  color: #5d8a28;\n}\n.storybook-button--aside-primary.success:hover svg {\n  transition: 0.3s;\n  stroke: #5d8a28;\n}\n\n.storybook-button--aside-primary.success:active {\n  background: #f5f9f0;\n  color: #5d8a28;\n}\n.storybook-button--aside-primary.success:active svg {\n  transition: 0.3s;\n  stroke: #5d8a28;\n}\n\n.storybook-button--aside-primary.success:focus-visible {\n  color: #5d8a28;\n}\n.storybook-button--aside-primary.success:focus-visible svg {\n  transition: 0.3s;\n  stroke: #5d8a28;\n}\n\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n/* Стиль кнопки default */\n.storybook-button--default {\n  background-color: #ffffff;\n  border: 0.1rem solid #d6d6d6;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n.storybook-button--default:hover {\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n\n.storybook-button--default:active {\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n.storybook-button--default .storybook-button--progress {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.4) 25%, rgb(255, 255, 255) 25%, rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.4) 75%, rgb(255, 255, 255) 75%, rgb(255, 255, 255));\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n/* Тема кнопки ofd */\n.storybook-button--default.ofd {\n  color: #4ba1a5;\n}\n.storybook-button--default.ofd .storybook-button--progress {\n  background-color: #e3eff0;\n}\n.storybook-button--default.ofd:focus-visible {\n  color: #40898c;\n}\n.storybook-button--default.ofd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #40898c;\n}\n\n.storybook-button--default.ofd:hover {\n  color: #40898c;\n}\n.storybook-button--default.ofd:hover svg {\n  transition: 0.3s;\n  stroke: #40898c;\n}\n\n.storybook-button--default.ofd:active {\n  background: #e3eff0;\n  color: #4ba1a5;\n  border-color: #bcd3d4;\n}\n.storybook-button--default.ofd:active svg {\n  transition: 0.3s;\n  stroke: #4ba1a5;\n}\n\n/* Тема кнопки td */\n.storybook-button--default.td {\n  color: #ea8242;\n}\n.storybook-button--default.td .storybook-button--progress {\n  background-color: #fcf3ed;\n}\n.storybook-button--default.td:focus-visible {\n  color: #e76e23;\n}\n.storybook-button--default.td:focus-visible svg {\n  transition: 0.3s;\n  stroke: #e76e23;\n}\n\n.storybook-button--default.td:hover {\n  color: #e76e23;\n}\n.storybook-button--default.td:hover svg {\n  transition: 0.3s;\n  stroke: #e76e23;\n}\n\n.storybook-button--default.td:active {\n  background: #fcf3ed;\n  color: #ea8242;\n  border-color: #f6e2d5;\n}\n.storybook-button--default.td:active svg {\n  transition: 0.3s;\n  stroke: #ea8242;\n}\n\n/* Тема кнопки edo */\n.storybook-button--default.edo {\n  color: #f5a91b;\n}\n.storybook-button--default.edo .storybook-button--progress {\n  background-color: #fcf6ea;\n}\n.storybook-button--default.edo:focus-visible {\n  color: #eb9d0c;\n}\n.storybook-button--default.edo:focus-visible svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--default.edo:hover {\n  color: #eb9d0c;\n}\n.storybook-button--default.edo:hover svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--default.edo:active {\n  background: #fcf6ea;\n  color: #f5a91b;\n  border-color: #f7ebd4;\n}\n.storybook-button--default.edo:active svg {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n\n/* Тема кнопки epd */\n.storybook-button--default.epd {\n  color: #f5a91b;\n}\n.storybook-button--default.epd .storybook-button--progress {\n  background-color: #fcf6ea;\n}\n.storybook-button--default.epd:focus-visible {\n  color: #eb9d0c;\n}\n.storybook-button--default.epd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--default.epd:hover {\n  color: #eb9d0c;\n}\n.storybook-button--default.epd:hover svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--default.epd:active {\n  background: #fcf6ea;\n  color: #f5a91b;\n  border-color: #f7ebd4;\n}\n.storybook-button--default.epd:active svg {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n\n/* Тема кнопки gosotchet */\n.storybook-button--default.gosotchet {\n  color: #488bca;\n}\n.storybook-button--default.gosotchet .storybook-button--progress {\n  background-color: #eaf1f8;\n}\n.storybook-button--default.gosotchet:focus-visible {\n  color: #367aba;\n}\n.storybook-button--default.gosotchet:focus-visible svg {\n  transition: 0.3s;\n  stroke: #367aba;\n}\n\n.storybook-button--default.gosotchet:hover {\n  color: #367aba;\n}\n.storybook-button--default.gosotchet:hover svg {\n  transition: 0.3s;\n  stroke: #367aba;\n}\n\n.storybook-button--default.gosotchet:active {\n  color: #488bca;\n  background: #eaf1f8;\n  border-color: #ccd9e5;\n}\n.storybook-button--default.gosotchet:active svg {\n  transition: 0.3s;\n  stroke: #488bca;\n}\n\n/* Тема кнопки arenda */\n.storybook-button--default.arenda {\n  color: #d58576;\n}\n.storybook-button--default.arenda .storybook-button--progress {\n  background-color: #f9f2f1;\n}\n.storybook-button--default.arenda:focus-visible {\n  color: #cd6d5b;\n}\n.storybook-button--default.arenda:focus-visible svg {\n  transition: 0.3s;\n  stroke: #cd6d5b;\n}\n\n.storybook-button--default.arenda:hover {\n  color: #cd6d5b;\n}\n.storybook-button--default.arenda:hover svg {\n  transition: 0.3s;\n  stroke: #cd6d5b;\n}\n\n.storybook-button--default.arenda:active {\n  color: #d58576;\n  background: #f9f2f1;\n  border-color: #f2d8d3;\n}\n.storybook-button--default.arenda:active svg {\n  transition: 0.3s;\n  stroke: #d58576;\n}\n\n/* Тема кнопки marking */\n.storybook-button--default.marking {\n  color: #4bb9ba;\n}\n.storybook-button--default.marking .storybook-button--progress {\n  background-color: #f1f9f9;\n}\n.storybook-button--default.marking:focus-visible {\n  color: #3ea1a2;\n}\n.storybook-button--default.marking:focus-visible svg {\n  transition: 0.3s;\n  stroke: #3ea1a2;\n}\n\n.storybook-button--default.marking:hover {\n  color: #3ea1a2;\n}\n.storybook-button--default.marking:hover svg {\n  transition: 0.3s;\n  stroke: #3ea1a2;\n}\n\n.storybook-button--default.marking:active {\n  color: #4bb9ba;\n  background: #f1f9f9;\n  border-color: #c7e0e1;\n}\n.storybook-button--default.marking:active svg {\n  transition: 0.3s;\n  stroke: #4bb9ba;\n}\n\n/* Тема кнопки big-data */\n.storybook-button--default.big-data {\n  color: #5ab8c5;\n}\n.storybook-button--default.big-data .storybook-button--progress {\n  background-color: #e7f2f3;\n}\n.storybook-button--default.big-data:focus-visible {\n  color: #41aab9;\n}\n.storybook-button--default.big-data:focus-visible svg {\n  transition: 0.3s;\n  stroke: #41aab9;\n}\n\n.storybook-button--default.big-data:hover {\n  color: #41aab9;\n}\n.storybook-button--default.big-data:hover svg {\n  transition: 0.3s;\n  stroke: #41aab9;\n}\n\n.storybook-button--default.big-data:active {\n  color: #5ab8c5;\n  background: #e7f2f3;\n  border-color: #b3dfe5;\n}\n.storybook-button--default.big-data:active svg {\n  transition: 0.3s;\n  stroke: #5ab8c5;\n}\n\n/* Тема кнопки check-index */\n.storybook-button--default.check-index {\n  color: #5bc0de;\n}\n.storybook-button--default.check-index .storybook-button--progress {\n  background-color: #f3fafc;\n}\n.storybook-button--default.check-index:focus-visible {\n  color: #3cb4d8;\n}\n.storybook-button--default.check-index:focus-visible svg {\n  transition: 0.3s;\n  stroke: #3cb4d8;\n}\n\n.storybook-button--default.check-index:hover {\n  color: #3cb4d8;\n}\n.storybook-button--default.check-index:hover svg {\n  transition: 0.3s;\n  stroke: #3cb4d8;\n}\n\n.storybook-button--default.check-index:active {\n  color: #5bc0de;\n  background: #f3fafc;\n  border-color: #e0f0f5;\n}\n.storybook-button--default.check-index:active svg {\n  transition: 0.3s;\n  stroke: #5bc0de;\n}\n\n/* Тема кнопки МЧД */\n.storybook-button--default.mchd {\n  color: #626ab7;\n}\n.storybook-button--default.mchd .storybook-button--progress {\n  background-color: #fbefee;\n}\n.storybook-button--default.mchd:focus-visible {\n  color: #4c55a9;\n}\n.storybook-button--default.mchd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #4c55a9;\n}\n\n.storybook-button--default.mchd:hover {\n  color: #4c55a9;\n}\n.storybook-button--default.mchd:hover svg {\n  transition: 0.3s;\n  stroke: #4c55a9;\n}\n\n.storybook-button--default.mchd:active {\n  color: #626ab7;\n  background: #fbefee;\n  border-color: #cfd2e7;\n}\n.storybook-button--default.mchd:active svg {\n  transition: 0.3s;\n  stroke: #626ab7;\n}\n\n/* Тема кнопки ЕЛК */\n.storybook-button--default.elk {\n  color: #577590;\n}\n.storybook-button--default.elk .storybook-button--progress {\n  background-color: #f0f2f5;\n}\n.storybook-button--default.elk:focus-visible {\n  color: #466077;\n}\n.storybook-button--default.elk:focus-visible svg {\n  transition: 0.3s;\n  stroke: #466077;\n}\n\n.storybook-button--default.elk:hover {\n  color: #466077;\n}\n.storybook-button--default.elk:hover svg {\n  transition: 0.3s;\n  stroke: #466077;\n}\n\n.storybook-button--default.elk:active {\n  background: #f0f2f5;\n  color: #577590;\n  border-color: #b9c2ca;\n}\n.storybook-button--default.elk:active svg {\n  transition: 0.3s;\n  stroke: #577590;\n}\n\n/* Тема кнопки success */\n.storybook-button--default.success {\n  color: #8bc34a;\n}\n.storybook-button--default.success .storybook-button--progress {\n  background-color: #f5f9f0;\n}\n.storybook-button--default.success:focus-visible {\n  color: #7ab03a;\n}\n.storybook-button--default.success:focus-visible svg {\n  transition: 0.3s;\n  stroke: #7ab03a;\n}\n\n.storybook-button--default.success:hover {\n  color: #7ab03a;\n}\n.storybook-button--default.success:hover svg {\n  transition: 0.3s;\n  stroke: #7ab03a;\n}\n\n.storybook-button--default.success:active {\n  color: #8bc34a;\n  background: #f5f9f0;\n  border-color: #d7e4c8;\n}\n.storybook-button--default.success:active svg {\n  transition: 0.3s;\n  stroke: #8bc34a;\n}\n\n/* Тема кнопки error */\n.storybook-button--default.error {\n  color: #d12e34;\n}\n.storybook-button--default.error .storybook-button--progress {\n  background-color: #faebec;\n}\n.storybook-button--default.error:focus-visible {\n  color: #b4272c;\n}\n.storybook-button--default.error:focus-visible svg {\n  transition: 0.3s;\n  stroke: #b4272c;\n}\n\n.storybook-button--default.error:hover {\n  color: #b4272c;\n}\n.storybook-button--default.error:hover svg {\n  transition: 0.3s;\n  stroke: #b4272c;\n}\n\n.storybook-button--default.error:active {\n  color: #d12e34;\n  background: #faebec;\n  border-color: #e6b7b9;\n}\n.storybook-button--default.error:active svg {\n  transition: 0.3s;\n  stroke: #d12e34;\n}\n\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n/* Стиль кнопки borderless */\n.storybook-button--borderless {\n  background-color: #ffffff;\n  border: none;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n.storybook-button--borderless:hover {\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n\n.storybook-button--borderless:active {\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n.storybook-button--borderless .storybook-button--progress {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.4) 25%, rgb(255, 255, 255) 25%, rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.4) 75%, rgb(255, 255, 255) 75%, rgb(255, 255, 255));\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n/* Тема кнопки ofd */\n.storybook-button--borderless.ofd {\n  color: #4ba1a5;\n}\n.storybook-button--borderless.ofd .storybook-button--progress {\n  background-color: #e3eff0;\n}\n.storybook-button--borderless.ofd:focus-visible {\n  color: #40898c;\n}\n.storybook-button--borderless.ofd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #40898c;\n}\n\n.storybook-button--borderless.ofd:hover {\n  color: #40898c;\n}\n.storybook-button--borderless.ofd:hover svg {\n  transition: 0.3s;\n  stroke: #40898c;\n}\n\n.storybook-button--borderless.ofd:active {\n  background: #e3eff0;\n  color: #4ba1a5;\n}\n.storybook-button--borderless.ofd:active svg {\n  transition: 0.3s;\n  stroke: #4ba1a5;\n}\n\n/* Тема кнопки td */\n.storybook-button--borderless.td {\n  color: #ea8242;\n}\n.storybook-button--borderless.td .storybook-button--progress {\n  background-color: #fcf3ed;\n}\n.storybook-button--borderless.td:focus-visible {\n  color: #e76e23;\n}\n.storybook-button--borderless.td:focus-visible svg {\n  transition: 0.3s;\n  stroke: #e76e23;\n}\n\n.storybook-button--borderless.td:hover {\n  color: #e76e23;\n}\n.storybook-button--borderless.td:hover svg {\n  transition: 0.3s;\n  stroke: #e76e23;\n}\n\n.storybook-button--borderless.td:active {\n  background: #fcf3ed;\n  color: #ea8242;\n}\n.storybook-button--borderless.td:active svg {\n  transition: 0.3s;\n  stroke: #ea8242;\n}\n\n/* Тема кнопки edo */\n.storybook-button--borderless.edo {\n  color: #f5a91b;\n}\n.storybook-button--borderless.edo .storybook-button--progress {\n  background-color: #fcf6ea;\n}\n.storybook-button--borderless.edo:focus-visible {\n  color: #eb9d0c;\n}\n.storybook-button--borderless.edo:focus-visible svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--borderless.edo:hover {\n  color: #eb9d0c;\n}\n.storybook-button--borderless.edo:hover svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--borderless.edo:active {\n  background: #fcf6ea;\n  color: #f5a91b;\n}\n.storybook-button--borderless.edo:active svg {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n\n/* Тема кнопки epd */\n.storybook-button--borderless.epd {\n  color: #f5a91b;\n}\n.storybook-button--borderless.epd .storybook-button--progress {\n  background-color: #fcf6ea;\n}\n.storybook-button--borderless.epd:focus-visible {\n  color: #eb9d0c;\n}\n.storybook-button--borderless.epd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--borderless.epd:hover {\n  color: #eb9d0c;\n}\n.storybook-button--borderless.epd:hover svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--borderless.epd:active {\n  background: #fcf6ea;\n  color: #f5a91b;\n}\n.storybook-button--borderless.epd:active svg {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n\n/* Тема кнопки gosotchet */\n.storybook-button--borderless.gosotchet {\n  color: #488bca;\n}\n.storybook-button--borderless.gosotchet .storybook-button--progress {\n  background-color: #eaf1f8;\n}\n.storybook-button--borderless.gosotchet:focus-visible {\n  color: #367aba;\n}\n.storybook-button--borderless.gosotchet:focus-visible svg {\n  transition: 0.3s;\n  stroke: #367aba;\n}\n\n.storybook-button--borderless.gosotchet:hover {\n  color: #367aba;\n}\n.storybook-button--borderless.gosotchet:hover svg {\n  transition: 0.3s;\n  stroke: #367aba;\n}\n\n.storybook-button--borderless.gosotchet:active {\n  color: #488bca;\n  background: #eaf1f8;\n}\n.storybook-button--borderless.gosotchet:active svg {\n  transition: 0.3s;\n  stroke: #488bca;\n}\n\n/* Тема кнопки arenda */\n.storybook-button--borderless.arenda {\n  color: #d58576;\n}\n.storybook-button--borderless.arenda .storybook-button--progress {\n  background-color: #f9f2f1;\n}\n.storybook-button--borderless.arenda:focus-visible {\n  color: #cd6d5b;\n}\n.storybook-button--borderless.arenda:focus-visible svg {\n  transition: 0.3s;\n  stroke: #cd6d5b;\n}\n\n.storybook-button--borderless.arenda:hover {\n  color: #cd6d5b;\n}\n.storybook-button--borderless.arenda:hover svg {\n  transition: 0.3s;\n  stroke: #cd6d5b;\n}\n\n.storybook-button--borderless.arenda:active {\n  color: #d58576;\n  background: #f9f2f1;\n}\n.storybook-button--borderless.arenda:active svg {\n  transition: 0.3s;\n  stroke: #d58576;\n}\n\n/* Тема кнопки marking */\n.storybook-button--borderless.marking {\n  color: #4bb9ba;\n}\n.storybook-button--borderless.marking .storybook-button--progress {\n  background-color: #f1f9f9;\n}\n.storybook-button--borderless.marking:focus-visible {\n  color: #3ea1a2;\n}\n.storybook-button--borderless.marking:focus-visible svg {\n  transition: 0.3s;\n  stroke: #3ea1a2;\n}\n\n.storybook-button--borderless.marking:hover {\n  color: #3ea1a2;\n}\n.storybook-button--borderless.marking:hover svg {\n  transition: 0.3s;\n  stroke: #3ea1a2;\n}\n\n.storybook-button--borderless.marking:active {\n  color: #4bb9ba;\n  background: #f1f9f9;\n}\n.storybook-button--borderless.marking:active svg {\n  transition: 0.3s;\n  stroke: #4bb9ba;\n}\n\n/* Тема кнопки big-data */\n.storybook-button--borderless.big-data {\n  color: #5ab8c5;\n}\n.storybook-button--borderless.big-data .storybook-button--progress {\n  background-color: #e7f2f3;\n}\n.storybook-button--borderless.big-data:focus-visible {\n  color: #41aab9;\n}\n.storybook-button--borderless.big-data:focus-visible svg {\n  transition: 0.3s;\n  stroke: #41aab9;\n}\n\n.storybook-button--borderless.big-data:hover {\n  color: #41aab9;\n}\n.storybook-button--borderless.big-data:hover svg {\n  transition: 0.3s;\n  stroke: #41aab9;\n}\n\n.storybook-button--borderless.big-data:active {\n  color: #5ab8c5;\n  background: #e7f2f3;\n}\n.storybook-button--borderless.big-data:active svg {\n  transition: 0.3s;\n  stroke: #5ab8c5;\n}\n\n/* Тема кнопки check-index */\n.storybook-button--borderless.check-index {\n  color: #5bc0de;\n}\n.storybook-button--borderless.check-index .storybook-button--progress {\n  background-color: #f3fafc;\n}\n.storybook-button--borderless.check-index:focus-visible {\n  color: #3cb4d8;\n}\n.storybook-button--borderless.check-index:focus-visible svg {\n  transition: 0.3s;\n  stroke: #3cb4d8;\n}\n\n.storybook-button--borderless.check-index:hover {\n  color: #3cb4d8;\n}\n.storybook-button--borderless.check-index:hover svg {\n  transition: 0.3s;\n  stroke: #3cb4d8;\n}\n\n.storybook-button--borderless.check-index:active {\n  color: #5bc0de;\n  background: #f3fafc;\n}\n.storybook-button--borderless.check-index:active svg {\n  transition: 0.3s;\n  stroke: #5bc0de;\n}\n\n/* Тема кнопки МЧД */\n.storybook-button--borderless.mchd {\n  color: #626ab7;\n}\n.storybook-button--borderless.mchd .storybook-button--progress {\n  background-color: #fbefee;\n}\n.storybook-button--borderless.mchd:focus-visible {\n  color: #4c55a9;\n}\n.storybook-button--borderless.mchd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #4c55a9;\n}\n\n.storybook-button--borderless.mchd:hover {\n  color: #4c55a9;\n}\n.storybook-button--borderless.mchd:hover svg {\n  transition: 0.3s;\n  stroke: #4c55a9;\n}\n\n.storybook-button--borderless.mchd:active {\n  color: #5bc0de;\n  background: #fbefee;\n}\n.storybook-button--borderless.mchd:active svg {\n  transition: 0.3s;\n  stroke: #626ab7;\n}\n\n/* Тема кнопки ЕЛК */\n.storybook-button--borderless.elk {\n  color: #577590;\n}\n.storybook-button--borderless.elk .storybook-button--progress {\n  background-color: #f0f2f5;\n}\n.storybook-button--borderless.elk:focus-visible {\n  color: #466077;\n}\n.storybook-button--borderless.elk:focus-visible svg {\n  transition: 0.3s;\n  stroke: #466077;\n}\n\n.storybook-button--borderless.elk:hover {\n  color: #466077;\n}\n.storybook-button--borderless.elk:hover svg {\n  transition: 0.3s;\n  stroke: #466077;\n}\n\n.storybook-button--borderless.elk:active {\n  background: #f0f2f5;\n  color: #577590;\n}\n.storybook-button--borderless.elk:active svg {\n  transition: 0.3s;\n  stroke: #577590;\n}\n\n/* Тема кнопки success */\n.storybook-button--borderless.success {\n  color: #8bc34a;\n}\n.storybook-button--borderless.success .storybook-button--progress {\n  background-color: #f5f9f0;\n}\n.storybook-button--borderless.success:focus-visible {\n  color: #7ab03a;\n}\n.storybook-button--borderless.success:focus-visible svg {\n  transition: 0.3s;\n  stroke: #7ab03a;\n}\n\n.storybook-button--borderless.success:hover {\n  color: #7ab03a;\n}\n.storybook-button--borderless.success:hover svg {\n  transition: 0.3s;\n  stroke: #7ab03a;\n}\n\n.storybook-button--borderless.success:active {\n  color: #8bc34a;\n  background: #f5f9f0;\n}\n.storybook-button--borderless.success:active svg {\n  transition: 0.3s;\n  stroke: #8bc34a;\n}\n\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n/* Стиль кнопки invisible */\n.storybook-button--invisible {\n  background-color: transparent;\n  box-shadow: none;\n  border: none;\n}\n\n.storybook-button--invisible:is(:hover, :active) {\n  background-color: rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n\n.storybook-button--invisible .storybook-button--progress {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.4) 25%, rgb(255, 255, 255) 25%, rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.4) 75%, rgb(255, 255, 255) 75%, rgb(255, 255, 255));\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  background-color: rgb(242, 242, 242);\n}\n\n/* Тема кнопки ofd */\n.storybook-button--invisible.ofd {\n  color: #4ba1a5;\n}\n\n.storybook-button--invisible.ofd:hover {\n  color: #40898c;\n}\n.storybook-button--invisible.ofd:hover svg {\n  transition: 0.3s;\n  stroke: #40898c;\n}\n\n.storybook-button--invisible.ofd:focus-visible {\n  color: #40898c;\n}\n.storybook-button--invisible.ofd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #40898c;\n}\n\n.storybook-button--invisible.ofd:active {\n  color: #4ba1a5;\n}\n.storybook-button--invisible.ofd:active svg {\n  transition: 0.3s;\n  stroke: #4ba1a5;\n}\n\n/* Тема кнопки td */\n.storybook-button--invisible.td {\n  color: #ea8242;\n}\n\n.storybook-button--invisible.td:hover {\n  color: #e76e23;\n}\n.storybook-button--invisible.td:hover svg {\n  transition: 0.3s;\n  stroke: #e76e23;\n}\n\n.storybook-button--invisible.td:focus-visible {\n  color: #e76e23;\n}\n.storybook-button--invisible.td:focus-visible svg {\n  transition: 0.3s;\n  stroke: #e76e23;\n}\n\n.storybook-button--invisible.td:active {\n  color: #ea8242;\n}\n.storybook-button--invisible.td:active svg {\n  transition: 0.3s;\n  stroke: #ea8242;\n}\n\n/* Тема кнопки edo */\n.storybook-button--invisible.edo {\n  color: #f5a91b;\n}\n\n.storybook-button--invisible.edo:hover {\n  color: #eb9d0c;\n}\n.storybook-button--invisible.edo:hover svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--invisible.edo:focus-visible {\n  color: #eb9d0c;\n}\n.storybook-button--invisible.edo:focus-visible svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--invisible.edo:active {\n  color: #f5a91b;\n}\n.storybook-button--invisible.edo:active svg {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n\n/* Тема кнопки epd */\n.storybook-button--invisible.epd {\n  color: #f5a91b;\n}\n\n.storybook-button--invisible.epd:hover {\n  color: #eb9d0c;\n}\n.storybook-button--invisible.epd:hover svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--invisible.epd:focus-visible {\n  color: #eb9d0c;\n}\n.storybook-button--invisible.epd:focus-visible svg {\n  transition: 0.3s;\n  stroke: #eb9d0c;\n}\n\n.storybook-button--invisible.epd:active {\n  color: #f5a91b;\n}\n.storybook-button--invisible.epd:active svg {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n\n/* Тема кнопки gosotchet */\n.storybook-button--invisible.gosotchet {\n  color: #488bca;\n}\n\n.storybook-button--invisible.gosotchet:hover {\n  color: #367aba;\n}\n\n.storybook-button--invisible.gosotchet:active {\n  color: #488bca;\n}\n.storybook-button--invisible.gosotchet:active svg {\n  transition: 0.3s;\n  stroke: #488bca;\n}\n\n/* Тема кнопки arenda */\n.storybook-button--invisible.arenda {\n  color: #d58576;\n}\n\n.storybook-button--invisible.arenda:hover {\n  color: #cd6d5b;\n}\n\n.storybook-button--invisible.arenda:active {\n  color: #d58576;\n}\n.storybook-button--invisible.arenda:active svg {\n  transition: 0.3s;\n  stroke: #d58576;\n}\n\n/* Тема кнопки marking */\n.storybook-button--invisible.marking {\n  color: #4bb9ba;\n}\n\n.storybook-button--invisible.marking:hover {\n  color: #3ea1a2;\n}\n\n.storybook-button--invisible.marking:active {\n  color: #4bb9ba;\n}\n.storybook-button--invisible.marking:active svg {\n  transition: 0.3s;\n  stroke: #4bb9ba;\n}\n\n/* Тема кнопки big-data */\n.storybook-button--invisible.big-data {\n  color: #5ab8c5;\n}\n\n.storybook-button--invisible.big-data:hover {\n  color: #41aab9;\n}\n\n.storybook-button--invisible.big-data:active {\n  color: #5ab8c5;\n}\n.storybook-button--invisible.big-data:active svg {\n  transition: 0.3s;\n  stroke: #5ab8c5;\n}\n\n/* Тема кнопки check-index */\n.storybook-button--invisible.check-index {\n  color: #5bc0de;\n}\n\n.storybook-button--invisible.check-index:hover {\n  color: #3cb4d8;\n}\n\n.storybook-button--invisible.check-index:active {\n  color: #5bc0de;\n}\n.storybook-button--invisible.check-index:active svg {\n  transition: 0.3s;\n  stroke: #5bc0de;\n}\n\n/* Тема кнопки МЧД */\n.storybook-button--invisible.mchd {\n  color: #626ab7;\n}\n\n.storybook-button--invisible.mchd:hover {\n  color: #4c55a9;\n}\n\n.storybook-button--invisible.mchd:active {\n  color: #626ab7;\n}\n.storybook-button--invisible.mchd:active svg {\n  transition: 0.3s;\n  stroke: #626ab7;\n}\n\n/* Тема кнопки ЕЛК */\n.storybook-button--invisible.elk {\n  color: #577590;\n}\n\n.storybook-button--invisible.elk:hover {\n  color: #466077;\n}\n.storybook-button--invisible.elk:hover svg {\n  transition: 0.3s;\n  stroke: #466077;\n}\n\n.storybook-button--invisible.elk:focus-visible {\n  color: #466077;\n}\n.storybook-button--invisible.elk:focus-visible svg {\n  transition: 0.3s;\n  stroke: #466077;\n}\n\n.storybook-button--invisible.elk:active {\n  color: #577590;\n}\n.storybook-button--invisible.elk:active svg {\n  transition: 0.3s;\n  stroke: #577590;\n}\n\n/* Тема кнопки success */\n.storybook-button--invisible.success {\n  color: #8bc34a;\n}\n\n.storybook-button--invisible.success:hover {\n  color: #7ab03a;\n}\n\n.storybook-button--invisible.success:active {\n  color: #8bc34a;\n}\n.storybook-button--invisible.success:active svg {\n  transition: 0.3s;\n  stroke: #8bc34a;\n}";
styleInject(css_248z$t);

var css_248z$s = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n/* Стиль кнопки primary */\n.storybook-button--primary {\n  color: #ffffff;\n  border: none;\n}\n\n.storybook-button--primary:active {\n  box-shadow: inset 0 0.3rem 0.4rem 0 rgba(0, 0, 0, 0.1);\n}\n\n.storybook-button--primary .storybook-button--progress {\n  box-shadow: inset 0 0.3rem 0.4rem 0 rgba(0, 0, 0, 0.1);\n}\n\n/* Тема кнопки ofd */\n.storybook-button--primary.ofd {\n  background-color: #4ba1a5;\n}\n\n.storybook-button--primary.ofd:is(:focus-visible, :hover) {\n  background: #40898c;\n}\n\n.storybook-button--primary.ofd:active {\n  background: #357d81;\n}\n\n.storybook-button--primary.ofd .storybook-button--progress {\n  background-color: #4ba1a5;\n}\n\n/* Тема кнопки td */\n.storybook-button--primary.td {\n  background-color: #ea8242;\n}\n\n.storybook-button--primary.td:is(:focus-visible, :hover) {\n  background: #e76e23;\n}\n\n.storybook-button--primary.td:active {\n  background: #e26212;\n}\n\n.storybook-button--primary.td .storybook-button--progress {\n  background-color: #ea8242;\n}\n\n/* Тема кнопки edo */\n.storybook-button--primary.edo {\n  background-color: #f5a91b;\n}\n\n.storybook-button--primary.edo:is(:focus-visible, :hover) {\n  background: #eb9d0c;\n}\n\n.storybook-button--primary.edo:active {\n  background: #e89700;\n}\n\n.storybook-button--primary.edo .storybook-button--progress {\n  background-color: #f5a91b;\n}\n\n/* Тема кнопки epd */\n.storybook-button--primary.epd {\n  background-color: #f5a91b;\n}\n\n.storybook-button--primary.epd:is(:focus-visible, :hover) {\n  background: #eb9d0c;\n}\n\n.storybook-button--primary.epd:active {\n  background: #e89700;\n}\n\n.storybook-button--primary.epd .storybook-button--progress {\n  background-color: #f5a91b;\n}\n\n/* Тема кнопки gosotchet */\n.storybook-button--primary.gosotchet {\n  background-color: #488bca;\n}\n\n.storybook-button--primary.gosotchet:is(:focus-visible, :hover) {\n  background: #367aba;\n}\n\n.storybook-button--primary.gosotchet:active {\n  background: #2c70af;\n}\n\n.storybook-button--primary.gosotchet .storybook-button--progress {\n  background-color: #488bca;\n}\n\n/* Тема кнопки arenda */\n.storybook-button--primary.arenda {\n  background-color: #d58576;\n}\n\n.storybook-button--primary.arenda:is(:focus-visible, :hover) {\n  background: #cd6d5b;\n}\n\n.storybook-button--primary.arenda:active {\n  background: #ce5a46;\n}\n\n.storybook-button--primary.arenda .storybook-button--progress {\n  background-color: #d58576;\n}\n\n/* Тема кнопки marking */\n.storybook-button--primary.marking {\n  background-color: #4bb9ba;\n}\n\n.storybook-button--primary.marking:is(:focus-visible, :hover) {\n  background: #3ea1a2;\n}\n\n.storybook-button--primary.marking:active {\n  background: #339799;\n}\n\n.storybook-button--primary.marking .storybook-button--progress {\n  background-color: #4bb9ba;\n}\n\n/* Тема кнопки big-data */\n.storybook-button--primary.big-data {\n  background-color: #5ab8c5;\n}\n\n.storybook-button--primary.big-data:is(:focus-visible, :hover) {\n  background: #41aab9;\n}\n\n.storybook-button--primary.big-data:active {\n  background: #36a1b0;\n}\n\n.storybook-button--primary.big-data .storybook-button--progress {\n  background-color: #5ab8c5;\n}\n\n/* Тема кнопки check-index */\n.storybook-button--primary.check-index {\n  background-color: #5bc0de;\n}\n\n.storybook-button--primary.check-index:is(:focus-visible, :hover) {\n  background: #3cb4d8;\n}\n\n.storybook-button--primary.check-index:active {\n  background: #2097bc;\n}\n\n.storybook-button--primary.check-index .storybook-button--progress {\n  background-color: #5bc0de;\n}\n\n/* Тема кнопки МЧД */\n.storybook-button--primary.mchd {\n  background-color: #626ab7;\n}\n\n.storybook-button--primary.mchd:is(:focus-visible, :hover) {\n  background: #4c55a9;\n}\n\n.storybook-button--primary.mchd:active {\n  background: #434ca3;\n}\n\n.storybook-button--primary.mchd .storybook-button--progress {\n  background-color: #626ab7;\n}\n\n/* Тема кнопки ЕЛК */\n.storybook-button--primary.elk {\n  background-color: #577590;\n}\n\n.storybook-button--primary.elk:is(:focus-visible, :hover) {\n  background: #466077;\n}\n\n.storybook-button--primary.elk:active {\n  background: #344b60;\n}\n\n.storybook-button--primary.elk .storybook-button--progress {\n  background-color: #577590;\n}\n\n/* Тема кнопки success */\n.storybook-button--primary.success {\n  background-color: #8bc34a;\n}\n\n.storybook-button--primary.success:focus-visible {\n  background: #7ab03a;\n}\n\n.storybook-button--primary.success:hover {\n  background: #7ab03a;\n}\n\n.storybook-button--primary.success:active {\n  background: #5d8a28;\n}\n\n.storybook-button--primary.success .storybook-button--progress {\n  background-color: #8bc34a;\n}";
styleInject(css_248z$s);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var cn$i = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

var css_248z$r = ".Spinner-module_spinner__d2Lf2 {\n  animation: Spinner-module_rotate__pdJ1Z 2s linear infinite;\n  z-index: 2;\n}\n.Spinner-module_spinner__d2Lf2 .Spinner-module_path__1z2Ug {\n  stroke-linecap: round;\n  animation: Spinner-module_dash__4B4E- 1.5s ease-in-out infinite;\n}\n\n@keyframes Spinner-module_rotate__pdJ1Z {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes Spinner-module_dash__4B4E- {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}";
var styleSpinner = {"spinner":"Spinner-module_spinner__d2Lf2","rotate":"Spinner-module_rotate__pdJ1Z","path":"Spinner-module_path__1z2Ug","dash":"Spinner-module_dash__4B4E-"};
styleInject(css_248z$r);

/**
 * NB!
 * Для того, чтобы новая svg появилась для выбора,
 * нужно добавить тип в: /types.ts: TIconNames
 *
 * Иконки с внутренними заливками добавляются с суффиксом _fill, например, file_upload_fill.
 * Иконки с внешними границами добавляются без суффиксов, например, file_upload.
 * Суффикс _secondary больше не использовать.
 *
 * Добавляем из Фигмы сразу все состояния иконок.
 * Название иконки берём из блока в Фигме.
 */
const useIcons = ({ alt = '', height, iconFill, iconStroke, product, strokeSecond, strokeThird, theme, width, fillOpacity, fillColor, }) => {
    let clsName;
    const style = { width, height };
    clsName = iconStroke ? `sprite-stroke-primary-color__${theme !== null && theme !== void 0 ? theme : product} ` : '';
    clsName += iconFill ? `sprite-fill-primary-color__${theme !== null && theme !== void 0 ? theme : product} ` : clsName;
    return {
        planet: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M1.49756 7.99995H14.5105M11.25 7.97823C11.25 10.8192 9.60401 13.2774 8.65479 14.4588C8.30991 14.888 7.69002 14.888 7.34514 14.4588C6.39592 13.2774 4.74996 10.8192 4.74996 7.97823C4.74996 5.13727 6.39592 2.67911 7.34514 1.49771C7.69002 1.06847 8.30991 1.06847 8.65479 1.49771C9.60401 2.67911 11.25 5.13727 11.25 7.97823ZM15.25 8C15.25 12.0041 12.0041 15.25 8 15.25C3.99594 15.25 0.75 12.0041 0.75 8C0.75 3.99594 3.99594 0.75 8 0.75C12.0041 0.75 15.25 3.99594 15.25 8Z", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        print: (React__default.createElement("svg", { style: style, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', className: clsName, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_577_19767)" },
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.00002 11.3333H2.66669C2.48988 11.3333 2.32031 11.263 2.19528 11.138C2.07026 11.013 2.00002 10.8434 2.00002 10.6666V7.33325C2.00002 7.15644 2.07026 6.98687 2.19528 6.86185C2.32031 6.73682 2.48988 6.66659 2.66669 6.66659H13.3334C13.5102 6.66659 13.6797 6.73682 13.8048 6.86185C13.9298 6.98687 14 7.15644 14 7.33325V10.6666C14 10.8434 13.9298 11.013 13.8048 11.138C13.6797 11.263 13.5102 11.3333 13.3334 11.3333H12C11.8232 11.3333 11.6536 11.4035 11.5286 11.5285C11.4036 11.6535 11.3334 11.8231 11.3334 11.9999C11.3334 12.1767 11.4036 12.3463 11.5286 12.4713C11.6536 12.5963 11.8232 12.6666 12 12.6666H13.3334C13.8638 12.6666 14.3725 12.4559 14.7476 12.0808C15.1226 11.7057 15.3334 11.197 15.3334 10.6666V7.33325C15.3334 6.80282 15.1226 6.29411 14.7476 5.91904C14.3725 5.54397 13.8638 5.33325 13.3334 5.33325H2.66669C2.13625 5.33325 1.62755 5.54397 1.25247 5.91904C0.877401 6.29411 0.666687 6.80282 0.666687 7.33325V10.6666C0.666687 11.197 0.877401 11.7057 1.25247 12.0808C1.62755 12.4559 2.13625 12.6666 2.66669 12.6666H4.00002C4.17683 12.6666 4.3464 12.5963 4.47142 12.4713C4.59645 12.3463 4.66669 12.1767 4.66669 11.9999C4.66669 11.8231 4.59645 11.6535 4.47142 11.5285C4.3464 11.4035 4.17683 11.3333 4.00002 11.3333Z" }),
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.00004 15.3333C3.82323 15.3333 3.65366 15.2631 3.52864 15.138C3.40361 15.013 3.33337 14.8434 3.33337 14.6666V9.33329C3.33337 9.15648 3.40361 8.98691 3.52864 8.86189C3.65366 8.73686 3.82323 8.66663 4.00004 8.66663H12C12.1769 8.66663 12.3464 8.73686 12.4714 8.86189C12.5965 8.98691 12.6667 9.15648 12.6667 9.33329V14.6666C12.6667 14.8434 12.5965 15.013 12.4714 15.138C12.3464 15.2631 12.1769 15.3333 12 15.3333H4.00004ZM4.66671 14H11.3334V9.99996H4.66671V14ZM4.66671 5.33329H3.33337V1.33329C3.33337 1.15648 3.40361 0.986912 3.52864 0.861888C3.65366 0.736864 3.82323 0.666626 4.00004 0.666626H12C12.1769 0.666626 12.3464 0.736864 12.4714 0.861888C12.5965 0.986912 12.6667 1.15648 12.6667 1.33329V5.33329H11.3334V1.99996H4.66671V5.33329Z" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_577_19767" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        print_secondary: (React__default.createElement("svg", { style: style, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', className: clsName, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_2204_345)" },
                React__default.createElement("path", { d: "M12.25 3V1.45C12.25 1.0634 11.9366 0.75 11.55 0.75H4.45C4.0634 0.75 3.75 1.0634 3.75 1.45L3.75 3", stroke: "#254E5F", strokeWidth: "1.5", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M11.55 15.25H4.45C4.0634 15.25 3.75 14.9366 3.75 14.55V9.75H12.25V14.55C12.25 14.9366 11.9366 15.25 11.55 15.25Z", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M3 11.25H1.45C1.0634 11.25 0.75 10.9366 0.75 10.55V6.45C0.75 6.0634 1.0634 5.75 1.45 5.75H14.55C14.9366 5.75 15.25 6.0634 15.25 6.45V10.55C15.25 10.9366 14.9366 11.25 14.55 11.25H13", strokeWidth: "1.5", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_2204_345" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        exclamationTriangle: (React__default.createElement("svg", { style: style, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", className: `sprite-stroke-primary-color sprite-stroke-primary-color__${theme !== null && theme !== void 0 ? theme : product}`, xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1373_234)" },
                React__default.createElement("path", { d: "M7.13398 1.66665C7.51629 0.987003 8.49483 0.987003 8.87714 1.66665L15.1204 12.7658C15.4954 13.4324 15.0136 14.256 14.2488 14.256H1.76231C0.997482 14.256 0.515767 13.4324 0.890732 12.7658L7.13398 1.66665Z", fill: iconFill ? strokeSecond : '', stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '', strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M8 5.75391L8 9.2525", stroke: iconFill ? '#FFFFFF' : strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M8.00061 11.8672L8.00061 11.8772", stroke: iconFill ? '#FFFFFF' : strokeSecond, strokeWidth: "1.9", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1373_234" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        exclamation: (React__default.createElement("svg", { style: style, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', className: `sprite-stroke-primary-color sprite-stroke-primary-color__${theme !== null && theme !== void 0 ? theme : product}`, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M7.75061 14.74L7.75061 14.75", strokeWidth: "1.9", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M7.74609 1.1228L7.74609 11.7431", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        calendarWithCorner: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none" },
            React__default.createElement("path", { d: "M13.95 2.75C14.1157 2.75 14.25 2.88431 14.25 3.05L14.25 10.4984C14.25 10.5892 14.2088 10.6752 14.138 10.7322L9.84433 14.1838C9.79105 14.2266 9.72474 14.25 9.65637 14.25L2.05 14.25C1.88431 14.25 1.75 14.1157 1.75 13.95L1.75 3.05C1.75 2.88431 1.88431 2.75 2.05 2.75L13.95 2.75Z", stroke: strokeSecond, strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M4.74988 1C4.74988 0.585786 4.41409 0.25 3.99988 0.25C3.58566 0.25 3.24988 0.585786 3.24988 1H4.74988ZM3.24988 4.25C3.24988 4.66421 3.58566 5 3.99988 5C4.41409 5 4.74988 4.66421 4.74988 4.25H3.24988ZM12.7499 1C12.7499 0.585786 12.4141 0.25 11.9999 0.25C11.5857 0.25 11.2499 0.585786 11.2499 1H12.7499ZM11.2499 4.25C11.2499 4.66421 11.5857 5 11.9999 5C12.4141 5 12.7499 4.66421 12.7499 4.25H11.2499ZM2.50098 8H13.5064V6.5H2.50098V8ZM3.24988 1V4.25H4.74988V1H3.24988ZM11.2499 1V4.25H12.7499V1H11.2499Z", fill: strokeThird !== null && strokeThird !== void 0 ? strokeThird : '#254E5F' }),
            React__default.createElement("path", { d: "M10 11L14.8789 11L14.75 11.2031L10.2344 14.8281L10 14.9414L10 11Z", fill: strokeThird !== null && strokeThird !== void 0 ? strokeThird : '#254E5F' }))),
        animatedSpinner: (React__default.createElement("svg", { style: style, className: styleSpinner.spinner, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 50 50" },
            React__default.createElement("circle", { className: cn$i(styleSpinner.path, `sprite-stroke-primary-color__${theme !== null && theme !== void 0 ? theme : product} `), cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" }))),
        ask: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none" },
            React__default.createElement("path", { d: "M5.75 6.495C5.75 5.25235 6.75736 4.245 8 4.24499C9.24264 4.24499 10.25 5.25235 10.25 6.49499C10.25 7.73764 9.24264 8.74499 8 8.74499L8 9.49759", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("g", { filter: "url(#filter0_i_0_1)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "7.25", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("path", { d: "M8 11.745L8 11.755", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0_i_0_1", x: "0", y: "0", width: "16", height: "17", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React__default.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_0_1" }))))),
        smartphone: (React__default.createElement("svg", { style: style, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", className: clsName, xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_950_3822)" },
                React__default.createElement("path", { d: "M9.24609 1.50269L6.74999 1.50269L6.74999 1.95015C6.74999 2.11584 6.88431 2.25015 7.04999 2.25015L8.94609 2.25015C9.11178 2.25015 9.24609 2.11584 9.24609 1.95015L9.24609 1.50269Z", strokeWidth: "1.5" }),
                React__default.createElement("g", { filter: "url(#filter0_i_950_3822)" },
                    React__default.createElement("path", { d: "M12.25 1.04854C12.25 0.88285 12.1157 0.748535 11.95 0.748535L4.05177 0.748534C3.88609 0.748534 3.75177 0.882849 3.75178 1.04853L3.75179 14.9494C3.75179 15.1151 3.88611 15.2494 4.05179 15.2494L11.95 15.2494C12.1157 15.2494 12.25 15.1151 12.25 14.9494L12.25 1.04854Z", stroke: strokeSecond, strokeWidth: "1.5" })),
                React__default.createElement("path", { d: "M7.99939 12.8672L7.99939 12.8772", stroke: strokeThird, strokeWidth: "1.9", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0_i_950_3822", x: "3.00177", y: "-0.00146484", width: "9.99823", height: "17.001", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React__default.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_950_3822" })),
                React__default.createElement("clipPath", { id: "clip0_950_3822" },
                    React__default.createElement("rect", { width: "16", height: "16", transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 16 0)" }))))),
        plus: (React__default.createElement("svg", { style: style, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', className: `sprite-stroke-primary-color ${clsName}`, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1363_1938)" },
                React__default.createElement("path", { d: "M8.00239 0.754272L8.0024 15.2456M15.2481 7.99995L0.756714 7.99997", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M8.00239 0.754272V7.99996M15.2481 7.99995L0.756714 7.99997", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1363_1938" },
                    React__default.createElement("rect", { width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "white" }))))),
        odometer_reading: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("rect", { y: "2.65234", width: "15.9113", height: "10.6075", rx: "1" }),
            React__default.createElement("mask", { id: "mask0_1559_40297", style: { maskType: 'alpha' }, maskUnits: "userSpaceOnUse", x: "0", y: "2", width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%' },
                React__default.createElement("rect", { y: "2.65234", width: "15.9113", height: "10.6075", rx: "1" })),
            React__default.createElement("g", { mask: "url(#mask0_1559_40297)" },
                React__default.createElement("rect", { x: "2.38867", y: "6.24219", width: "2.47109", height: "3.54708", rx: "1.23554", stroke: "white" }),
                React__default.createElement("rect", { x: "6.7644", y: "6.24219", width: "2.47109", height: "3.54708", rx: "1.23554", stroke: "white" }),
                React__default.createElement("path", { d: "M11.1399 4.49379C11.1399 4.03613 11.5109 3.66512 11.9686 3.66512H12.3754C13.0577 3.66512 13.611 4.21843 13.611 4.90089C13.611 5.58334 13.0577 6.13666 12.3754 6.13666C11.6931 6.13666 11.1399 5.58334 11.1399 4.90089V4.49379Z", stroke: "white" }),
                React__default.createElement("path", { d: "M13.0523 1.64648L11.3731 4.14844", stroke: "white", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M11.2509 8.58594L13.2408 8.58594C13.4613 8.58594 13.6064 8.81578 13.5117 9.01485L11.7401 12.7374", stroke: "white", strokeLinecap: "round" })))),
        tech_condition: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M0.75 5.75488C0.75 4.98065 0.925973 4.24752 1.2401 3.59331L5.46747 7.79142L7.82049 5.43839L3.59479 1.24194C4.24739 0.929717 4.97828 0.754883 5.75 0.754883C8.51142 0.754883 10.75 2.99346 10.75 5.75488C10.75 6.39178 10.6309 7.00087 10.4138 7.56109L14.5663 11.431C15.4862 12.2884 15.5113 13.7379 14.6215 14.6266C13.7328 15.5141 12.2853 15.4885 11.4286 14.5699L7.55663 10.4185C6.99629 10.6357 6.38706 10.7549 5.75 10.7549C2.98858 10.7549 0.75 8.51631 0.75 5.75488Z", stroke: strokeSecond, strokeWidth: "0.4" }))),
        location: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8 6.00042C8 7.10499 7.10457 8.00042 6 8.00042C4.89543 8.00042 4 7.10499 4 6.00042C4 4.89585 4.89543 4.00042 6 4.00042C7.10457 4.00042 8 4.89585 8 6.00042Z", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M11.249 6.15022C11.249 8.75136 7.23173 13.8265 6.2261 15.0561C6.10863 15.1998 5.89137 15.1998 5.7739 15.0561C4.76827 13.8264 0.750977 8.75136 0.750977 6.15022C0.750977 3.17693 3.10104 0.766602 6 0.766602C8.89896 0.766602 11.249 3.17693 11.249 6.15022Z", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }))),
        dot: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 6 6" },
            React__default.createElement("circle", { cx: "3", cy: "3", r: "3", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : product }))),
        key: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_283_1956)" },
                React__default.createElement("path", { d: "M10.9996 9.74632C13.3466 9.74632 15.2492 7.84373 15.2492 5.49676C15.2492 3.14979 13.3466 1.24719 10.9996 1.24719C8.65262 1.24719 6.75003 3.14979 6.75003 5.49676C6.75003 6.0014 6.83799 6.4855 6.99942 6.93456L1.08001 12.502C0.52134 13.0274 0.737744 13.9603 1.47069 14.1861L3.51536 14.816C4.1345 15.0068 4.76151 14.5439 4.76151 13.896C4.76151 13.3643 5.19253 12.9333 5.72421 12.9333H6.02817C6.58045 12.9333 7.02817 12.4856 7.02817 11.9333V11.6666C7.02817 11.1144 7.47588 10.6666 8.02817 10.6666L8.29482 10.6666C8.84711 10.6666 9.29482 10.2189 9.29482 9.66665V9.39999C9.29482 9.39685 9.29484 9.39371 9.29487 9.39058C9.8167 9.61936 10.3933 9.74632 10.9996 9.74632Z", strokeWidth: "1.5" }),
                React__default.createElement("path", { d: "M12.5427 4.99101C12.5427 5.64849 12.0097 6.18148 11.3523 6.18148C10.6948 6.18148 10.1618 5.64849 10.1618 4.99101C10.1618 4.33353 10.6948 3.80054 11.3523 3.80054C12.0097 3.80054 12.5427 4.33353 12.5427 4.99101Z", strokeWidth: "1.5", stroke: strokeSecond })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_283_1956" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        // todo notworkin
        ok: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 12", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#clip)" },
                React__default.createElement("circle", { cx: "6", cy: "6", r: "5.5", stroke: strokeSecond }),
                React__default.createElement("path", { d: "M4.125 5.8125L5.625 7.6875L8.25 4.3125", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip" },
                    React__default.createElement("rect", { width: "12", height: "12", fill: "white" }))))),
        inbox: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none" },
            React__default.createElement("path", { d: "M3 1.5C3.41421 1.5 3.75 1.16421 3.75 0.75C3.75 0.335786 3.41421 0 3 0V1.5ZM13 0C12.5858 0 12.25 0.335786 12.25 0.75C12.25 1.16421 12.5858 1.5 13 1.5V0ZM11.5383 7.53033C11.8312 7.23744 11.8312 6.76256 11.5383 6.46967C11.2454 6.17678 10.7706 6.17678 10.4777 6.46967L11.5383 7.53033ZM8.00799 10L7.47766 10.5303C7.61831 10.671 7.80907 10.75 8.00799 10.75C8.2069 10.75 8.39766 10.671 8.53832 10.5303L8.00799 10ZM8.75399 0.999667C8.75381 0.585453 8.41787 0.249816 8.00366 0.25C7.58944 0.250184 7.25381 0.58612 7.25399 1.00033L8.75399 0.999667ZM5.53832 6.46967C5.24543 6.17678 4.77055 6.17678 4.47766 6.46967C4.18476 6.76256 4.18476 7.23744 4.47766 7.53033L5.53832 6.46967ZM3 0H1.75V1.5H3V0ZM0 1.75V14.25H1.5V1.75H0ZM1.75 16H14.25V14.5H1.75V16ZM16 14.25V1.75H14.5V14.25H16ZM14.25 0H13V1.5H14.25V0ZM16 1.75C16 0.783501 15.2165 0 14.25 0V1.5C14.3881 1.5 14.5 1.61193 14.5 1.75H16ZM14.25 16C15.2165 16 16 15.2165 16 14.25H14.5C14.5 14.3881 14.3881 14.5 14.25 14.5V16ZM0 14.25C0 15.2165 0.783502 16 1.75 16V14.5C1.61193 14.5 1.5 14.3881 1.5 14.25H0ZM1.75 0C0.783502 0 0 0.783502 0 1.75H1.5C1.5 1.61193 1.61193 1.5 1.75 1.5V0ZM10.4777 6.46967L7.47766 9.46967L8.53832 10.5303L11.5383 7.53033L10.4777 6.46967ZM7.25399 1.00033L7.25799 10.0003L8.75799 9.99967L8.75399 0.999667L7.25399 1.00033ZM8.53832 9.46967L5.53832 6.46967L4.47766 7.53033L7.47766 10.5303L8.53832 9.46967Z" }))),
        phone: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#clip0_743_429)" },
                React__default.createElement("path", { d: "M9.24609 1.50281L6.74999 1.50281L6.74999 1.95028C6.74999 2.11596 6.88431 2.25028 7.04999 2.25028L8.94609 2.25028C9.11178 2.25028 9.24609 2.11596 9.24609 1.95028L9.24609 1.50281Z", strokeWidth: "1.5" }),
                React__default.createElement("g", { filter: "url(#filter0_i_743_429)" },
                    React__default.createElement("path", { d: "M12.25 1.04847C12.25 0.882789 12.1157 0.748474 11.95 0.748474L4.05177 0.748473C3.88609 0.748473 3.75177 0.882788 3.75178 1.04847L3.75179 14.9494C3.75179 15.115 3.88611 15.2494 4.05179 15.2494L11.95 15.2494C12.1157 15.2494 12.25 15.115 12.25 14.9494L12.25 1.04847Z", stroke: strokeSecond, strokeWidth: "1.5" })),
                React__default.createElement("path", { d: "M7.99939 12.8671L7.99939 12.8771", strokeWidth: "1.9", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0_i_743_429", x: "3.00183", y: "-0.00152588", width: "9.99817", height: "17.0009", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React__default.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_743_429" })),
                React__default.createElement("clipPath", { id: "clip0_743_429" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white", transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 16 0)" }))))),
        email: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_950_3828)" },
                React__default.createElement("path", { d: "M15 3L9.30158 7.88436C8.5526 8.52634 7.4474 8.52634 6.69842 7.88436L1 3", strokeWidth: "1.5" }),
                React__default.createElement("g", { filter: "url(#filter0_i_950_3828)" },
                    React__default.createElement("rect", { x: "0.75", y: "0.75", width: "10.5", height: "14.5", rx: "1.25", transform: "matrix(-4.37114e-08 1 1 4.37114e-08 -3.27835e-08 2)", stroke: strokeSecond, strokeWidth: "1.5" }))),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0_i_950_3828", x: "0", y: "2", width: "16", height: "13", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React__default.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_950_3828" })),
                React__default.createElement("clipPath", { id: "clip0_950_3828" },
                    React__default.createElement("rect", { width: "16", height: "16", transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 16 0)" }))))),
        mail: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 12", fill: "none" },
            React__default.createElement("path", { d: "M15 1L9.30158 5.88436C8.5526 6.52634 7.4474 6.52634 6.69842 5.88436L1 0.999999", strokeWidth: "1.5" }),
            React__default.createElement("g", { filter: "url(#filter0)" },
                React__default.createElement("rect", { x: "0.75", y: "0.75", width: "10.5", height: "14.5", rx: "1.25", transform: "matrix(-4.37114e-08 1 1 4.37114e-08 -3.27835e-08 3.27835e-08)", stroke: strokeSecond, strokeWidth: "1.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0", x: "0", y: "0", width: "16", height: "13", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React__default.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_0_1" }))))),
        chat: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 15", fill: "none" },
            React__default.createElement("path", { d: "M4.99854 5.5L4.99954 5.5M7.99954 5.5L8.00054 5.5M11.0005 5.5L11.0015 5.5", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("g", { filter: "url(#filter0_i_0_1)" },
                React__default.createElement("path", { d: "M0.754618 8.99657L0.754619 13.9281C0.754619 13.9285 0.754882 13.9289 0.755277 13.929L0.755727 13.9292C0.756123 13.9293 0.756565 13.9292 0.756835 13.9289L3.54076 10.6069C3.73076 10.3801 4.0114 10.2492 4.30721 10.2492L13.95 10.2492C14.668 10.2492 15.25 9.66713 15.25 8.94916L15.25 2.04768C15.25 1.32971 14.668 0.747679 13.95 0.74768L2.05 0.747681C1.33203 0.747681 0.75 1.32971 0.75 2.04768L0.754618 8.99657Z", stroke: strokeSecond, strokeWidth: "1.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0_i_0_1", x: "0", y: "-0.00231934", width: "16", height: "15.6816", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React__default.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_0_1" }))))),
        check: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "m7 14 8-12", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2 8.5 7 14", strokeWidth: "1.5", strokeLinecap: "round" }))),
        check_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1934_20699)" },
                React__default.createElement("path", { d: "M7.5 14L15.5 2", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M2.5 8.5L7.5 14", stroke: "", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1934_20699" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white", transform: "translate(0.5)" }))))),
        loupe: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 14 14", fill: "none" },
            React__default.createElement("path", { d: "M10.4506 9.508L13.4713 12.528C13.5964 12.653 13.6667 12.8226 13.6668 12.9994C13.6668 13.1763 13.5966 13.3459 13.4716 13.471C13.3466 13.5961 13.177 13.6664 13.0002 13.6665C12.8233 13.6665 12.6537 13.5963 12.5286 13.4713L9.50795 10.4507C8.37301 11.3452 6.93918 11.7724 5.49973 11.6447C4.06028 11.5171 2.72397 10.8444 1.76411 9.76411C0.804251 8.68384 0.293371 7.27768 0.33596 5.83321C0.378549 4.38874 0.971388 3.01511 1.99323 1.99327C3.01507 0.971434 4.38869 0.378595 5.83316 0.336006C7.27763 0.293417 8.6838 0.804296 9.76407 1.76416C10.8443 2.72402 11.5171 4.06033 11.6447 5.49978C11.7723 6.93923 11.3452 8.37305 10.4506 9.508ZM9.10662 9.02133C9.90424 8.20118 10.3452 7.09889 10.3332 5.95491C10.3213 4.81093 9.85742 3.71809 9.04284 2.91478C8.22827 2.11147 7.12907 1.66288 5.98503 1.66686C4.841 1.67084 3.74495 2.12707 2.93599 2.93604C2.12703 3.745 1.6708 4.84104 1.66681 5.98508C1.66283 7.12912 2.11142 8.22831 2.91473 9.04289C3.71804 9.85746 4.81088 10.3213 5.95486 10.3333C7.09885 10.3452 8.20114 9.90428 9.02129 9.10666C9.04713 9.07573 9.07568 9.04717 9.10662 9.02133Z" }))),
        calendar: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 14 16", fill: "none" },
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.33337 2H11.6667C12.1971 2 12.7058 2.21071 13.0809 2.58579C13.456 2.96086 13.6667 3.46957 13.6667 4V13.3333C13.6667 13.8638 13.456 14.3725 13.0809 14.7475C12.7058 15.1226 12.1971 15.3333 11.6667 15.3333H2.33337C1.80294 15.3333 1.29423 15.1226 0.919161 14.7475C0.544088 14.3725 0.333374 13.8638 0.333374 13.3333V4C0.333374 3.46957 0.544088 2.96086 0.919161 2.58579C1.29423 2.21071 1.80294 2 2.33337 2ZM2.33337 3.33333C2.15656 3.33333 1.98699 3.40357 1.86197 3.5286C1.73695 3.65362 1.66671 3.82319 1.66671 4V13.3333C1.66671 13.5101 1.73695 13.6797 1.86197 13.8047C1.98699 13.9298 2.15656 14 2.33337 14H11.6667C11.8435 14 12.0131 13.9298 12.1381 13.8047C12.2631 13.6797 12.3334 13.5101 12.3334 13.3333V4C12.3334 3.82319 12.2631 3.65362 12.1381 3.5286C12.0131 3.40357 11.8435 3.33333 11.6667 3.33333H2.33337Z" }),
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.3334 7.33332H1.66675V5.99999H12.3334V7.33332ZM9.00008 3.99999V1.33332C9.00008 1.15651 9.07032 0.986943 9.19534 0.861919C9.32037 0.736894 9.48994 0.666656 9.66675 0.666656C9.84356 0.666656 10.0131 0.736894 10.1382 0.861919C10.2632 0.986943 10.3334 1.15651 10.3334 1.33332V3.99999C10.3334 4.1768 10.2632 4.34637 10.1382 4.47139C10.0131 4.59642 9.84356 4.66666 9.66675 4.66666C9.48994 4.66666 9.32037 4.59642 9.19534 4.47139C9.07032 4.34637 9.00008 4.1768 9.00008 3.99999ZM3.66675 3.99999V1.33332C3.66675 1.15651 3.73699 0.986943 3.86201 0.861919C3.98703 0.736894 4.1566 0.666656 4.33341 0.666656C4.51023 0.666656 4.67979 0.736894 4.80482 0.861919C4.92984 0.986943 5.00008 1.15651 5.00008 1.33332V3.99999C5.00008 4.1768 4.92984 4.34637 4.80482 4.47139C4.67979 4.59642 4.51023 4.66666 4.33341 4.66666C4.1566 4.66666 3.98703 4.59642 3.86201 4.47139C3.73699 4.34637 3.66675 4.1768 3.66675 3.99999Z" }))),
        services_ofd: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.20605 12.4664L18.9957 2.90564V22.0271L2.20605 12.4664Z", fill: "#4BA1A5" }),
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0673 14.0987V1.9729L21.794 8.03583L11.0673 14.0987Z", fill: "#254E5F" }))),
        services_edo: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { opacity: "0.6", d: "M4.41477 2.92261C4.31308 2.92261 4.23065 3.00504 4.23065 3.10672L4.23065 3.72726C4.23065 3.82894 4.31308 3.91137 4.41477 3.91137H12.3868C12.4885 3.91137 12.5709 3.9938 12.5709 4.09549V13.3579C12.5709 13.4596 12.6533 13.542 12.755 13.542H14.4019C14.5036 13.542 14.586 13.4596 14.586 13.3579V3.10672C14.586 3.00504 14.5036 2.92261 14.4019 2.92261H4.41477Z", fill: "#F5A91B" }),
            React__default.createElement("path", { d: "M11.3268 18.227C11.3268 18.4177 11.1722 18.5722 10.9816 18.5722H0.718382C0.527726 18.5722 0.373169 18.4177 0.373169 18.227V5.56555C0.373169 5.37489 0.527726 5.22034 0.718382 5.22034H10.9816C11.1722 5.22034 11.3268 5.37489 11.3268 5.56555V18.227Z", fill: "#F5A91B" }),
            React__default.createElement("path", { d: "M6.12774 10.6893C6.00344 10.7604 6.00435 10.94 6.12938 11.0098L19.3921 18.4193C19.5148 18.4879 19.666 18.3991 19.666 18.2586V3.26082C19.666 3.11941 19.5132 3.03079 19.3904 3.10101L6.12774 10.6893Z", fill: "#254E5F" }))),
        services_go: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M12.0619 4.07214C12.2113 4.07214 12.2987 4.24154 12.2159 4.36588C10.3847 7.11643 11.0137 8.71478 12.4177 11.7504C13.8464 14.8188 14.4726 16.6605 12.5208 19.5095C12.4575 19.6019 12.3511 19.6574 12.2391 19.6574H3.90845C3.75907 19.6574 3.67155 19.4881 3.75401 19.3635C5.58569 16.5968 4.95678 14.7661 3.55262 11.7504C2.12394 8.66155 1.49782 7.08093 3.44942 4.22114C3.5128 4.12827 3.61954 4.07214 3.73197 4.07214H12.0619Z", fill: "url(#paint0_linear_2776_1810)" }),
            React__default.createElement("path", { d: "M21.781 4.20221C21.781 4.06083 21.6283 3.9722 21.5055 4.04237L8.19463 11.6515C8.07041 11.7225 8.07112 11.9018 8.1959 11.9719L21.5068 19.4412C21.6295 19.51 21.781 19.4213 21.781 19.2806V4.20221Z", fill: "#254E5F" }),
            React__default.createElement("defs", null,
                React__default.createElement("linearGradient", { id: "paint0_linear_2776_1810", x1: "7.98517", y1: "4.07214", x2: "7.98517", y2: "19.6574", gradientUnits: "userSpaceOnUse" },
                    React__default.createElement("stop", { stopColor: "#488BCA", stopOpacity: "0.63" }),
                    React__default.createElement("stop", { offset: "0.265625", stopColor: "#488BCA", stopOpacity: "0.78" }),
                    React__default.createElement("stop", { offset: "0.78125", stopColor: "#488BCA" }))))),
        services_kudir: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { opacity: "0.6", fillRule: "evenodd", clipRule: "evenodd", d: "M13.462 17.3466L14.1754 17.2004C14.6734 17.0984 14.9945 16.6119 14.8924 16.1138L12.2004 2.97685C12.0983 2.47879 11.6118 2.15776 11.1137 2.25983L10.4004 2.40601C10.6082 2.63985 10.7592 2.92986 10.8265 3.25839L13.5185 16.3953C13.5858 16.7238 13.5611 17.0499 13.462 17.3466Z", fill: "#488BCA" }),
            React__default.createElement("path", { d: "M0.219578 4.68024C0.199165 4.58063 0.26337 4.48333 0.362983 4.46292L1.75944 4.17676L4.82107 19.1174L3.42461 19.4035C3.325 19.4239 3.2277 19.3597 3.20729 19.2601L0.219578 4.68024Z", fill: "#2C70AF" }),
            React__default.createElement("path", { d: "M1.72731 4.18335L8.83804 2.72621C9.33611 2.62415 9.82261 2.94517 9.92467 3.44324L12.6167 16.5802C12.7188 17.0782 12.3977 17.5647 11.8997 17.6668L4.78894 19.1239L1.72731 4.18335Z", fill: "#488BCA" }),
            React__default.createElement("path", { d: "M6.46355 10.6891C6.33925 10.7603 6.34017 10.9398 6.46519 11.0097L19.7279 18.4192C19.8506 18.4877 20.0018 18.399 20.0018 18.2584V3.2607C20.0018 3.11929 19.849 3.03067 19.7262 3.10089L6.46355 10.6891Z", fill: "#254E5F" }))),
        services_kep: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M12.2935 26.4089C12.089 26.5161 11.8363 26.4372 11.7292 26.2327L4.9674 13.331C4.86023 13.1265 4.93912 12.8738 5.14361 12.7666L21.0324 4.43942C21.2368 4.33224 21.4895 4.41114 21.5967 4.61563L28.3584 17.5174C28.4656 17.7219 28.3867 17.9745 28.1822 18.0817L12.2935 26.4089Z", fill: "#6470B9" }),
            React__default.createElement("path", { d: "M12.2935 26.4089C12.089 26.5161 11.8363 26.4372 11.7292 26.2327L4.9674 13.331C4.86023 13.1265 4.93912 12.8738 5.14361 12.7666L21.0324 4.43942C21.2368 4.33224 21.4895 4.41114 21.5967 4.61563L28.3584 17.5174C28.4656 17.7219 28.3867 17.9745 28.1822 18.0817L12.2935 26.4089Z", fill: "white", fillOpacity: "0.3" }),
            React__default.createElement("g", { clipPath: "url(#clip0_77_1581)" },
                React__default.createElement("path", { d: "M21.3689 9.59749L13.9235 7.22087C13.3386 7.03417 12.7131 7.35696 12.5264 7.94185L7.53201 23.5883C6.68903 26.2292 8.14652 29.0534 10.7874 29.8964C13.4283 30.7394 16.2525 29.2819 17.0955 26.641L22.0899 10.9946C22.2766 10.4097 21.9538 9.78418 21.3689 9.59749ZM10.3517 24.5993L10.6019 23.8156L14.4621 25.0478L14.2119 25.8315C13.8716 26.8974 12.7317 27.4857 11.6657 27.1455C10.5998 26.8052 10.0115 25.6653 10.3517 24.5993Z", fill: "#626AB7", stroke: "#F8F8F8", strokeWidth: "1.39345" }),
                React__default.createElement("path", { d: "M21.604 5.33902L16.8321 4.71411L16.0366 7.4978L20.0133 9.14529L21.604 5.33902Z", fill: "#F8F8F8" }),
                React__default.createElement("path", { d: "M13.6665 7.86987L13.4546 8.5336L14.1184 8.74547L20.3281 10.7276L20.9918 10.9395L21.2037 10.2758L22.7234 5.51482C22.9074 4.93821 22.5892 4.32157 22.0126 4.13751L16.5635 2.39814C15.9869 2.21409 15.3703 2.53231 15.1862 3.10892L15.85 3.32079L15.1862 3.10892L13.6665 7.86987Z", fill: "#626AB7" }),
                React__default.createElement("path", { d: "M13.6665 7.86987L13.4546 8.5336L14.1184 8.74547L20.3281 10.7276L20.9918 10.9395L21.2037 10.2758L22.7234 5.51482C22.9074 4.93821 22.5892 4.32157 22.0126 4.13751L16.5635 2.39814C15.9869 2.21409 15.3703 2.53231 15.1862 3.10892L15.85 3.32079L15.1862 3.10892L13.6665 7.86987Z", fill: "white", fillOpacity: "0.3" }),
                React__default.createElement("path", { d: "M13.6665 7.86987L13.4546 8.5336L14.1184 8.74547L20.3281 10.7276L20.9918 10.9395L21.2037 10.2758L22.7234 5.51482C22.9074 4.93821 22.5892 4.32157 22.0126 4.13751L16.5635 2.39814C15.9869 2.21409 15.3703 2.53231 15.1862 3.10892L15.85 3.32079L15.1862 3.10892L13.6665 7.86987Z", stroke: "#F8F8F8", strokeWidth: "1.39345" }),
                React__default.createElement("path", { d: "M14.8482 24.7479L10.4917 23.7607L9.97044 25.7699L13.0829 27.5352L14.8482 24.7479Z", fill: "#F8F8F8" })),
            React__default.createElement("path", { d: "M15.6058 15.9132C15.4553 15.9994 15.4564 16.2168 15.6078 16.3014L31.6682 25.2739C31.8169 25.357 31.9999 25.2495 31.9999 25.0793V6.91775C31.9999 6.74651 31.8149 6.6392 31.6663 6.72424L15.6058 15.9132Z", fill: "#254E5F" }),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_77_1581" },
                    React__default.createElement("rect", { width: "22.356", height: "22.356", fill: "white", transform: "translate(0.193604 11.2223) rotate(-27.4226)" }))))),
        services_epd: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.26339 7.10769C1.03404 6.97436 1.03454 6.64292 1.26428 6.51028L9.12201 1.97362C9.22882 1.91195 9.36041 1.91195 9.46722 1.97362L17.6779 6.71403C17.7847 6.7757 17.8505 6.88966 17.8505 7.01299V16.4938C17.8505 16.6171 17.7847 16.7311 17.6779 16.7928L9.82511 21.3266C9.59497 21.4594 9.30729 21.2933 9.30729 21.0276L9.30718 11.9826C9.30717 11.8597 9.24177 11.746 9.13547 11.6842L1.26339 7.10769Z", fill: "#F5A91B" }),
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.855225 16.7924V8.89392L5.23345 11.4352L7.68344 15.1555L7.68351 20.7873L0.855225 16.7924Z", fill: "url(#paint0_linear_2776_1565)", fillOpacity: "0.8" }),
            React__default.createElement("path", { d: "M9.47405 11.6789C9.34975 11.75 9.35067 11.9296 9.47569 11.9994L22.7384 19.4089C22.8611 19.4775 23.0123 19.3888 23.0123 19.2482V4.25044C23.0123 4.10903 22.8595 4.02041 22.7367 4.09064L9.47405 11.6789Z", fill: "#254E5F" }),
            React__default.createElement("path", { d: "M5.21559 14.2085L5.21545 11.4433C5.21545 11.4319 5.2303 11.4275 5.23658 11.437L7.6796 15.1505C7.68575 15.1599 7.67629 15.1716 7.66585 15.1676L5.23034 14.2299C5.22145 14.2265 5.21559 14.218 5.21559 14.2085Z", fill: "#F5A91B" }),
            React__default.createElement("defs", null,
                React__default.createElement("linearGradient", { id: "paint0_linear_2776_1565", x1: "3.14913", y1: "24.996", x2: "8.6714", y2: "9.89219", gradientUnits: "userSpaceOnUse" },
                    React__default.createElement("stop", { stopColor: "#F5A91B", stopOpacity: "0.6" }),
                    React__default.createElement("stop", { offset: "0.234375", stopColor: "#F5A91B", stopOpacity: "0.78" }),
                    React__default.createElement("stop", { offset: "0.703125", stopColor: "#F5A91B", stopOpacity: "0.5" }))))),
        services_mchd: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { opacity: "0.7", fillRule: "evenodd", clipRule: "evenodd", d: "M15.3153 19.0352C15.3153 19.2259 15.1607 19.3804 14.97 19.3804H11.9939L12.4241 19.2615C13.1632 19.0572 13.6983 18.4162 13.7672 17.6525L13.8801 16.4029L14.5916 15.3696C15.0265 14.738 15.0243 13.903 14.5863 13.2736L13.8695 12.2439L13.7503 10.9949C13.6775 10.2316 13.1391 9.5933 12.399 9.39277L11.188 9.06467L10.2939 8.18453C9.74741 7.64659 8.92474 7.50369 8.22886 7.82582L7.09031 8.35288L5.83963 8.25338C5.07522 8.19256 4.35316 8.6119 4.02715 9.30597L3.49376 10.4416L2.47173 11.1693C2.45672 11.1799 2.44192 11.1908 2.42731 11.2019V3.15539C2.42731 2.96474 2.58186 2.81018 2.77252 2.81018H11.8631L15.3153 6.03217V19.0352ZM2.42731 17.491V19.0352C2.42731 19.2259 2.58186 19.3804 2.77252 19.3804H4.04782L3.51364 18.258L2.48792 17.5355C2.46735 17.521 2.44714 17.5062 2.42731 17.491ZM9.79944 19.3804H7.815L7.48906 19.2315C7.38109 19.1822 7.26223 19.1616 7.14395 19.1716L5.77352 19.2876C5.48699 19.3119 5.21542 19.156 5.09184 18.8964L4.50081 17.6545C4.4498 17.5473 4.37201 17.4551 4.27497 17.3868L3.15057 16.5948C2.91547 16.4292 2.80763 16.1352 2.87987 15.8569L3.22536 14.5256C3.25517 14.4107 3.25487 14.2901 3.22446 14.1754L2.87221 12.8459C2.79855 12.5679 2.9049 12.2734 3.13915 12.1066L4.25951 11.3089C4.3562 11.2401 4.43351 11.1475 4.48398 11.04L5.06869 9.79519C5.19094 9.53491 5.46172 9.37766 5.74837 9.40046L7.11937 9.50954C7.2377 9.51895 7.35645 9.4977 7.46417 9.44784L8.71226 8.87007C8.97322 8.74927 9.28172 8.80286 9.48665 9.00459L10.4668 9.96941C10.5514 10.0527 10.656 10.1127 10.7706 10.1438L12.0981 10.5034C12.3756 10.5786 12.5775 10.818 12.6048 11.1042L12.7355 12.4734C12.7467 12.5915 12.7883 12.7048 12.8561 12.8022L13.6418 13.931C13.8061 14.167 13.8069 14.4801 13.6438 14.717L12.8638 15.8498C12.7965 15.9475 12.7556 16.061 12.7449 16.1792L12.6212 17.549C12.5953 17.8354 12.3947 18.0758 12.1175 18.1524L10.7919 18.5188C10.6775 18.5504 10.5731 18.611 10.489 18.6947L9.79944 19.3804Z", fill: "url(#paint0_linear_2775_38482)" }),
            React__default.createElement("path", { d: "M8.71231 8.87004C8.97327 8.74924 9.28177 8.80282 9.4867 9.00455L10.4668 9.96937C10.5514 10.0526 10.6561 10.1127 10.7706 10.1437L12.0981 10.5034C12.3757 10.5786 12.5775 10.818 12.6049 11.1042L12.7355 12.4733C12.7468 12.5915 12.7883 12.7047 12.8561 12.8022L13.6419 13.931C13.8061 14.167 13.8069 14.4801 13.6439 14.717L12.8639 15.8497C12.7966 15.9475 12.7556 16.061 12.7449 16.1792L12.6212 17.549C12.5954 17.8353 12.3947 18.0757 12.1176 18.1523L10.7919 18.5187C10.6775 18.5504 10.5732 18.611 10.489 18.6947L9.51382 19.6645C9.30992 19.8672 9.00169 19.9224 8.74013 19.8029L7.48911 19.2315C7.38114 19.1822 7.26228 19.1615 7.144 19.1716L5.77357 19.2876C5.48704 19.3119 5.21547 19.156 5.0919 18.8963L4.50086 17.6545C4.44985 17.5473 4.37206 17.4551 4.27502 17.3867L3.15062 16.5947C2.91552 16.4291 2.80768 16.1352 2.87992 15.8568L3.22541 14.5256C3.25522 14.4107 3.25492 14.2901 3.22452 14.1753L2.87226 12.8459C2.7986 12.5679 2.90495 12.2734 3.1392 12.1066L4.25956 11.3089C4.35625 11.2401 4.43356 11.1474 4.48403 11.04L5.06874 9.79515C5.191 9.53487 5.46177 9.37762 5.74842 9.40043L7.11942 9.5095C7.23775 9.51892 7.3565 9.49767 7.46422 9.4478L8.71231 8.87004Z", fill: "#626AB7" }),
            React__default.createElement("path", { d: "M8.12774 11.4974C8.00344 11.5685 8.00435 11.7481 8.12938 11.8179L21.3921 19.2274C21.5148 19.296 21.666 19.2072 21.666 19.0667V4.06893C21.666 3.92751 21.5132 3.83889 21.3904 3.90912L8.12774 11.4974Z", fill: "#254E5F" }),
            React__default.createElement("path", { d: "M11.8632 2.81018L15.3153 6.03217H11.8632V2.81018Z", fill: "#626AB7" }),
            React__default.createElement("defs", null,
                React__default.createElement("linearGradient", { id: "paint0_linear_2775_38482", x1: "8.87129", y1: "2.81018", x2: "5.22834", y2: "19.3384", gradientUnits: "userSpaceOnUse" },
                    React__default.createElement("stop", { stopColor: "#626AB7", stopOpacity: "0.6" }),
                    React__default.createElement("stop", { offset: "0.234375", stopColor: "#626AB7", stopOpacity: "0.78" }),
                    React__default.createElement("stop", { offset: "0.703125", stopColor: "#626AB7", stopOpacity: "0.5" }))))),
        eye_opened: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            alt && React__default.createElement("title", null, alt),
            React__default.createElement("g", { clipPath: "url(#clip0_110_2069)" },
                React__default.createElement("circle", { cx: "8.5498", cy: "8.5", r: "2.25", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M15.7996 8.5L14.4756 7.03902C11.301 3.53598 5.79726 3.5351 2.62151 7.03712L1.29492 8.5L2.62151 9.96288C5.79726 13.4649 11.301 13.464 14.4756 9.96098L15.7996 8.5Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_110_2069" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white", transform: "translate(0.549805 0.5)" }))))),
        eye_closed: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1353_1948)" },
                React__default.createElement("path", { d: "M8 15.25V12.7207M11.6545 14.4431L10.9999 12M15.2477 12.2923L13.4593 10.5038M0.75206 12.2923L2.54055 10.5038M4.34527 14.4431L4.9999 12", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M15.2477 8.0049L13.9288 9.45982C10.753 12.9631 5.24787 12.9623 2.07308 9.45809L0.75206 8", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1353_1948" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        help: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_950_3837)" },
                React__default.createElement("path", { d: "M5.75 6.49487C5.75 5.25223 6.75736 4.24487 8 4.24487C9.24264 4.24487 10.25 5.25223 10.25 6.49487C10.25 7.73751 9.24264 8.74487 8 8.74487L8 9.49747", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("g", { filter: "url(#filter0_i_950_3837)" },
                    React__default.createElement("circle", { cx: "8", cy: "8", r: "7.25", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
                React__default.createElement("path", { d: "M8 11.7449L8 11.7549", stroke: strokeThird, strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0_i_950_3837", x: "0", y: "0", width: "16", height: "17", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React__default.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_950_3837" })),
                React__default.createElement("clipPath", { id: "clip0_950_3837" },
                    React__default.createElement("rect", { width: "16", height: "16" }))))),
        download: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_175_522)" },
                React__default.createElement("path", { d: "M12.5049 6.75004L8.00488 11.25L3.50488 6.75005M8.00726 0.750021L8.00726 11.249", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", fill: "" }),
                React__default.createElement("path", { d: "M0.75 10.75L0.75 13.25C0.75 14.3546 1.64543 15.25 2.75 15.25L13.2549 15.25C14.3594 15.25 15.2549 14.3546 15.2549 13.25L15.2549 10.75", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", stroke: "", fill: "none" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_175_522" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        upload_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1198_35623)" },
                React__default.createElement("path", { d: "M13.2827 5.24998L8.78271 0.749984L4.28271 5.24997M8.7851 11.25L8.78509 0.750997", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("g", { filter: "url(#filter0_i_1198_35623)" },
                    React__default.createElement("path", { d: "M16.0327 10.75L16.0327 13.25C16.0327 14.3546 15.1373 15.25 14.0327 15.25L3.52783 15.25C2.42326 15.25 1.52783 14.3546 1.52783 13.25L1.52783 10.75", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0_i_1198_35623", x: "0.777832", y: "10", width: "16.0049", height: "7", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React__default.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_1198_35623" })),
                React__default.createElement("clipPath", { id: "clip0_1198_35623" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white", transform: "translate(0.777832)" }))))),
        arrowLeft: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M4.75 8L11.25 14.5", strokeWidth: "1.5", strokeLinecap: "round", stroke: strokeSecond }),
            React__default.createElement("path", { d: "M4.75 8L11.25 1.5", strokeWidth: "1.5", strokeLinecap: "round" }))),
        arrow_doubleLeft: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M14.25 14.5L7.75 8L14.25 1.5M8.25 1.5L1.75 8L8.25 14.5", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrow_doubleLeft_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M7.75 8L14.25 14.5", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M7.75 8L14.25 1.5M8.25 1.5L1.75 8L8.25 14.5", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrowRight: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M11.25 8L4.75 14.5", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M11.25 8L4.75 1.5", strokeWidth: "1.5", strokeLinecap: "round" }))),
        arrow_doubleRight: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M1.75 14.5L8.25 8L1.75 1.5M7.75 1.5L14.25 8L7.75 14.5", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrow_doubleRight_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8.25 8L1.75 14.5", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M8.25 8L1.75 1.5M7.75 1.5L14.25 8L7.75 14.5", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrow_doubleUp: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M1.5 14.25L8 7.75L14.5 14.25M14.5 8.25L8 1.75L1.5 8.25", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrow_doubleUp_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8 7.75L14.5 14.25", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M8 7.75L1.5 14.25M1.5 8.25L8 1.75L14.5 8.25", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrowUp: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8 4.75L14.5 11.25", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M8 4.75L1.5 11.25", strokeWidth: "1.5", strokeLinecap: "round" }))),
        arrowDown: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8 11.25L14.5 4.75", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M8 11.25L1.5 4.75", strokeWidth: "1.5", strokeLinecap: "round" }))),
        arrow_doubleDown: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M14.5 1.75L8 8.25L1.5 1.75M1.5 7.75L8 14.25L14.5 7.75", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrow_doubleDown_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8 14.25L14.5 7.75", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M14.5 1.74994L8 8.24994L1.5 1.74994M8 14.2499L1.5 7.74994", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrowLineDown: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "none", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { strokeLinecap: "round", strokeWidth: "1.5", clipPath: "url(#a)" },
                React__default.createElement("path", { stroke: strokeSecond, d: "m7.998 15.248 6.5-6.5" }),
                React__default.createElement("path", { d: "M8 .752v14.491m-.002.005-6.5-6.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "a" },
                    React__default.createElement("path", { fill: "#fff", d: "M0 0h16v16H0z" }))))),
        arrowLineUp: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16" },
            React__default.createElement("g", { strokeLinecap: "round", strokeWidth: "1.5", clipPath: "url(#a)" },
                React__default.createElement("path", { stroke: strokeSecond, d: "m7.998.752 6.5 6.5" }),
                React__default.createElement("path", { d: "M8 15.248V.756M7.998.752l-6.5 6.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "a" },
                    React__default.createElement("path", { fill: "#fff", d: "M0 0h16v16H0z" }))))),
        arrowLineLeft: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16" },
            React__default.createElement("g", { strokeLinecap: "round", strokeWidth: "1.5", clipPath: "url(#a)" },
                React__default.createElement("path", { stroke: strokeSecond, d: "m.75 8 6.5 6.5" }),
                React__default.createElement("path", { d: "M15.246 8.002H.754M.75 8l6.5-6.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "a" },
                    React__default.createElement("path", { fill: "#fff", d: "M0 0h16v16H0z" }))))),
        arrowLineRight: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16" },
            React__default.createElement("g", { strokeLinecap: "round", strokeWidth: "1.5", clipPath: "url(#a)" },
                React__default.createElement("path", { stroke: strokeSecond, d: "m15.246 8-6.5 6.5" }),
                React__default.createElement("path", { d: "M.75 8.002h14.491M15.246 8l-6.5-6.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "a" },
                    React__default.createElement("path", { fill: "#fff", d: "M0 0h16v16H0z" }))))),
        arrowUpAndleft: (React__default.createElement("svg", { style: style, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M1.75 5.25L6.25 9.5M1.75 5.25L10.25 5.25C11.9069 5.25 13.25 6.59315 13.25 8.25V15.25M1.75 5.25L6.25 1", stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : 'white', strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        canceled: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1038_29779)" },
                React__default.createElement("circle", { cx: "6", cy: "6", r: "6", fill: "" }),
                React__default.createElement("path", { d: "M9.18927 6.00186L2.81427 5.99829", stroke: "white", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1038_29779" },
                    React__default.createElement("rect", { className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "white" }))))),
        canceled_inverse: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_3222_34301)" },
                React__default.createElement("path", { d: "M4.752 8H11.248M15.25 8C15.25 12.0041 12.0041 15.25 8 15.25C3.99594 15.25 0.75 12.0041 0.75 8C0.75 3.99594 3.99594 0.75 8 0.75C12.0041 0.75 15.25 3.99594 15.25 8Z", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_3222_34301" },
                    React__default.createElement("rect", { width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "white" }))))),
        card: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M0.5625 2.5875C0.5625 2.29755 0.79755 2.0625 1.0875 2.0625H10.9125C11.2024 2.0625 11.4375 2.29755 11.4375 2.5875V9.4125C11.4375 9.70245 11.2024 9.9375 10.9125 9.9375H1.0875C0.79755 9.9375 0.5625 9.70245 0.5625 9.4125V2.5875Z", fill: "", stroke: "", strokeWidth: "1.125" }),
            React__default.createElement("path", { d: "M0.5625 4.3103H11.4375", stroke: "white", strokeLinecap: "square" }))),
        flowStatusOk: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_920_885)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "8", fill: "#8BC34A" }),
                React__default.createElement("path", { d: "M5.5 7.75L7.5 10.25L11 5.75", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_920_885" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        marking_success: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1699_61768)" },
                React__default.createElement("path", { d: "M4.12501 5.8125L5.62501 7.6875L8.25001 4.3125M9.18121 0.562528H11.0625C11.2696 0.562528 11.4375 0.730422 11.4375 0.937528V2.84048M11.4375 9.18757V11.0626C11.4375 11.2697 11.2696 11.4376 11.0625 11.4376H9.18751M2.81251 11.4375L0.937507 11.4375C0.7304 11.4375 0.562507 11.2696 0.562507 11.0625L0.562507 9.18753M0.5625 2.8125L0.593348 0.931375C0.596704 0.726695 0.763585 0.562526 0.968292 0.562524L2.8125 0.5625", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1699_61768" },
                    React__default.createElement("rect", { width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "white" }))))),
        marking_process: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M9.18118 1.375H11.0625C11.2696 1.375 11.4375 1.54289 11.4375 1.75V3.65295M11.4375 10V11.875C11.4375 12.0821 11.2696 12.25 11.0625 12.25H9.1875M2.8125 12.25H0.9375C0.730393 12.25 0.5625 12.0821 0.5625 11.875V10M0.5625 3.625L0.593348 1.74387C0.596704 1.53919 0.763585 1.37503 0.968292 1.37502L2.8125 1.375M9.1875 6.8125C9.1875 8.56912 7.75662 10 6 10C4.24338 10 2.8125 8.56912 2.8125 6.8125C2.8125 5.05588 4.24338 3.625 6 3.625", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        marking_error: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M9.18118 0.812744H11.0625C11.2696 0.812744 11.4375 0.980637 11.4375 1.18774V3.09069M11.4375 9.43774V11.3127C11.4375 11.5199 11.2696 11.6877 11.0625 11.6877H9.1875M2.8125 11.6877H0.9375C0.730393 11.6877 0.5625 11.5199 0.5625 11.3127V9.43774M0.5625 3.06274L0.593348 1.18162C0.596704 0.976939 0.763585 0.81277 0.968292 0.812768L2.8125 0.812744M6 3.61682V6.99273", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M6 9.05908L6 9.06658", stroke: "", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" }))),
        marking_wait: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M9.18118 0.5625H11.0625C11.2696 0.5625 11.4375 0.730393 11.4375 0.9375V2.84045M11.4375 9.1875V11.0625C11.4375 11.2696 11.2696 11.4375 11.0625 11.4375H9.1875M2.8125 11.4375H0.9375C0.730393 11.4375 0.5625 11.2696 0.5625 11.0625V9.1875M0.5625 2.8125L0.593348 0.931375C0.596704 0.726695 0.763585 0.562526 0.968292 0.562524L2.8125 0.5625M4.3125 4.87125C4.3125 3.93927 5.06802 3.18375 6 3.18375C6.93198 3.18375 7.6875 3.93927 7.6875 4.87125C7.6875 5.80323 6.93198 6.55875 6 6.55875V7.12319", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M6 8.80884L6 8.81634", stroke: "", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" }))),
        more_vert: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8 3L8 3.01", stroke: "#254E5F", strokeWidth: "2.3", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M8 8L8 8.01M8 13L8 13.01", strokeWidth: "2.3", strokeLinecap: "round", strokeLinejoin: "round" }))),
        flowStatusWait: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_920_736)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "7.25", fill: "#DCAE1D", stroke: "#DCAE1D", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M8.00018 3.75L8.00016 8.00011L10.2506 10.2505", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_920_736" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        flowStatusPrepare: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_920_736)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "7.25", fill: "#D6D6D6", stroke: "#D6D6D6", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M8.00018 3.75L8.00016 8.00011L10.2506 10.2505", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_920_736" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        flowStatusAlert: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1415_375)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "8", fill: theme ? '' : '#D12E34' }),
                React__default.createElement("path", { d: "M8 4.48877L8 8.98997", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M8 12L8 12.01", stroke: "white", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1415_375" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        flowStatusClosed: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1818_31377)" },
                React__default.createElement("circle", { cx: "6.5", cy: "6", r: "6", fill: "#ADADB8" }),
                React__default.createElement("path", { d: "M4.625 5.8125L6.125 7.6875L8.75 4.3125", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1818_31377" },
                    React__default.createElement("rect", { width: "12", height: "12", fill: "white", transform: "translate(0.5)" }))))),
        flowStatusStop: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("circle", { cx: "8", cy: "8", r: "8", fill: fillColor !== null && fillColor !== void 0 ? fillColor : '' }),
            React__default.createElement("path", { d: "M5.21003 8L10.9275 8", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        qr: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "none", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1087_50131)" },
                React__default.createElement("path", { d: "M15.302 0.9375H18.4375C18.7827 0.9375 19.0625 1.21732 19.0625 1.5625V4.73408M19.0625 15.3125V18.4375C19.0625 18.7827 18.7827 19.0625 18.4375 19.0625H15.3125M4.6875 19.0625H1.5625C1.21732 19.0625 0.9375 18.7827 0.9375 18.4375L0.9375 15.3125M0.9375 4.6875L0.988913 1.55229C0.994507 1.21116 1.27264 0.937544 1.61382 0.937539L4.6875 0.9375M5.14832 8.43744H7.81488C8.16006 8.43744 8.43988 8.15762 8.43988 7.81244V5.14587C8.43988 4.8007 8.16006 4.52087 7.81488 4.52087H5.14832C4.80314 4.52087 4.52332 4.8007 4.52332 5.14587V7.81244C4.52332 8.15762 4.80314 8.43744 5.14832 8.43744ZM5.14832 15.4791H7.81488C8.16006 15.4791 8.43988 15.1992 8.43988 14.8541V12.1875C8.43988 11.8423 8.16006 11.5625 7.81488 11.5625H5.14832C4.80314 11.5625 4.52332 11.8423 4.52332 12.1875V14.8541C4.52332 15.1992 4.80314 15.4791 5.14832 15.4791ZM12.1851 8.43744H14.8516C15.1968 8.43744 15.4766 8.15762 15.4766 7.81244V5.14587C15.4766 4.8007 15.1968 4.52087 14.8516 4.52087H12.1851C11.8399 4.52087 11.5601 4.8007 11.5601 5.14587V7.81244C11.5601 8.15762 11.8399 8.43744 12.1851 8.43744ZM11.6851 12.8125H12.6851C12.7541 12.8125 12.8101 12.7565 12.8101 12.6875V11.6875C12.8101 11.6185 12.7541 11.5625 12.6851 11.5625H11.6851C11.616 11.5625 11.5601 11.6185 11.5601 11.6875V12.6875C11.5601 12.7565 11.616 12.8125 11.6851 12.8125ZM14.3517 15.4791H15.3517C15.4207 15.4791 15.4767 15.4232 15.4767 15.3541V14.3541C15.4767 14.2851 15.4207 14.2291 15.3517 14.2291H14.3517C14.2826 14.2291 14.2267 14.2851 14.2267 14.3541V15.3541C14.2267 15.4232 14.2826 15.4791 14.3517 15.4791Z", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1087_50131" },
                    React__default.createElement("rect", { width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%' }))))),
        clock: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1946_41924)" },
                React__default.createElement("path", { d: "M8.00018 3.75L8.00016 8.00011L10.2506 10.2505M15.25 8C15.25 12.0041 12.0041 15.25 8 15.25C3.99594 15.25 0.75 12.0041 0.75 8C0.75 3.99594 3.99594 0.75 8 0.75C12.0041 0.75 15.25 3.99594 15.25 8Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1946_41924" },
                    React__default.createElement("rect", { width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "white" }))))),
        edit: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("mask", { id: "path-1-inside-1_1818_31285" },
                React__default.createElement("path", { d: "M2.62197 6.56107L8.14076 0.573248C8.25305 0.451416 8.44284 0.44368 8.56468 0.555968L11.2283 3.01096C11.3501 3.12325 11.3579 3.31304 11.2456 3.43487L5.61016 9.54925L2.62197 6.56107ZM1.81724 7.87766L1.05537 10.9885C0.999217 11.2178 1.21764 11.4191 1.4416 11.3444L4.32363 10.3841L1.81724 7.87766Z" })),
            React__default.createElement("path", { d: "M2.62197 6.56107L8.14076 0.573248C8.25305 0.451416 8.44284 0.44368 8.56468 0.555968L11.2283 3.01096C11.3501 3.12325 11.3579 3.31304 11.2456 3.43487L5.61016 9.54925L2.62197 6.56107ZM1.81724 7.87766L1.05537 10.9885C0.999217 11.2178 1.21764 11.4191 1.4416 11.3444L4.32363 10.3841L1.81724 7.87766Z" }),
            React__default.createElement("path", { d: "M8.14076 0.573248L7.03779 -0.443333V-0.443333L8.14076 0.573248ZM2.62197 6.56107L1.51899 5.54449L0.543007 6.60343L1.56131 7.62173L2.62197 6.56107ZM8.56468 0.555968L9.58126 -0.547011L9.58126 -0.547012L8.56468 0.555968ZM11.2283 3.01096L10.2117 4.11394L10.2117 4.11394L11.2283 3.01096ZM11.2456 3.43487L10.1426 2.41829V2.41829L11.2456 3.43487ZM5.61016 9.54925L4.54949 10.6099L5.65427 11.7147L6.71313 10.5658L5.61016 9.54925ZM1.81724 7.87766L2.8779 6.817L0.994047 4.93315L0.360296 7.52084L1.81724 7.87766ZM1.05537 10.9885L2.51231 11.3453L2.51232 11.3453L1.05537 10.9885ZM1.4416 11.3444L1.91582 12.7675L1.91582 12.7675L1.4416 11.3444ZM4.32363 10.3841L4.79784 11.8071L7.10065 11.0397L5.38429 9.32339L4.32363 10.3841ZM7.03779 -0.443333L1.51899 5.54449L3.72495 7.57765L9.24374 1.58983L7.03779 -0.443333ZM9.58126 -0.547012C8.85027 -1.22074 7.71152 -1.17432 7.03779 -0.443333L9.24374 1.58983C8.79459 2.07716 8.03542 2.1081 7.5481 1.65895L9.58126 -0.547012ZM12.2449 1.90798L9.58126 -0.547011L7.54809 1.65895L10.2117 4.11394L12.2449 1.90798ZM12.3486 4.45145C13.0223 3.72046 12.9759 2.58171 12.2449 1.90798L10.2117 4.11394C9.7244 3.66478 9.69346 2.90561 10.1426 2.41829L12.3486 4.45145ZM6.71313 10.5658L12.3486 4.45145L10.1426 2.41829L4.50718 8.53267L6.71313 10.5658ZM1.56131 7.62173L4.54949 10.6099L6.67082 8.48859L3.68263 5.50041L1.56131 7.62173ZM0.360296 7.52084L-0.401569 10.6316L2.51232 11.3453L3.27418 8.23448L0.360296 7.52084ZM-0.401569 10.6316C-0.738505 12.0074 0.572061 13.2153 1.91582 12.7675L0.967392 9.92137C1.86323 9.62285 2.73694 10.4281 2.51231 11.3453L-0.401569 10.6316ZM1.91582 12.7675L4.79784 11.8071L3.84942 8.96098L0.96739 9.92137L1.91582 12.7675ZM5.38429 9.32339L2.8779 6.817L0.756578 8.93832L3.26297 11.4447L5.38429 9.32339Z", mask: "url(#path-1-inside-1_1818_31285)" }))),
        edit_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_2321_1173)" },
                React__default.createElement("path", { d: "M2.63135 10.289L6.09188 13.4784M9.33887 3.09048L12.7994 6.27995", stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '#254E5F', strokeWidth: "1.5" }),
                React__default.createElement("path", { d: "M11.2618 1.00233L2.02128 10.9456C1.98128 10.9886 1.95481 11.0425 1.94513 11.1004L1.31234 14.8917C1.27625 15.1079 1.47668 15.2886 1.688 15.2303L5.33844 14.2237C5.39208 14.2089 5.44056 14.1794 5.47844 14.1387L14.7207 4.19361C14.8338 4.07189 14.8264 3.88141 14.7042 3.76879L11.6849 0.985961C11.5634 0.874 11.3743 0.881319 11.2618 1.00233Z", strokeWidth: "1.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_2321_1173" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        person: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M13.4546 14.6531V13.2979C13.4546 11.0888 11.6637 9.29791 9.45457 9.29791M2.74756 14.6531V13.2979C2.74756 11.0888 4.53842 9.2979 6.74756 9.2979H9.50644C10.5614 9.2979 11.5695 9.73364 12.2923 10.5021M10.75 3.54785C10.75 5.06663 9.51877 6.29785 7.99998 6.29785C6.4812 6.29785 5.24998 5.06663 5.24998 3.54785C5.24998 2.02907 6.4812 0.797852 7.99998 0.797852C9.51877 0.797852 10.75 2.02907 10.75 3.54785Z", strokeWidth: "1.5", strokeLinecap: "round" }))),
        circle_xCross: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1418_488)" },
                React__default.createElement("path", { d: "M5.70331 5.70331L10.2967 10.2967M10.2981 5.7019L5.70189 10.2981", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("circle", { cx: "8", cy: "8", r: "7.25", stroke: strokeThird, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1418_488" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        circle_xCross_fill: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1418_484)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "8", fill: strokeSecond }),
                React__default.createElement("path", { d: "M11.7158 10.6019L11.7158 5.29503L5.39715 11.6019L10.7158 11.6019C11.2681 11.6019 11.7158 11.1542 11.7158 10.6019Z", fill: strokeThird }),
                React__default.createElement("path", { d: "M11.0093 4.99648L4.99549 11.0035M11.0059 11.0069L4.99882 4.99316", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1418_484" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        circle_cross: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_495_66)" },
                React__default.createElement("circle", { cx: "10", cy: "10", r: "9.375", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '#D12E34', stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '#D12E34', strokeWidth: "1.25" }),
                React__default.createElement("path", { d: "M13.7617 6.24555L6.24444 13.7543M13.7574 13.7586L6.2486 6.24139", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_495_66" },
                    React__default.createElement("rect", { width: "20", height: "20", fill: "white" }))))),
        circle_crossOut: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1539_406)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "7.25", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M0.750242 0.750246L15.25 15.25", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1539_406" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        circle_crossOut_fill: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1539_402)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "8", fill: strokeSecond }),
                React__default.createElement("path", { d: "M1.75 3.74866L12.2452 14.25", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M0.750242 0.750246L15.25 15.25", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1539_402" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        cross: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M13.1259 2.87646L2.87893 13.1234M13.1259 13.1234L2.87891 2.87648", strokeWidth: "1.5", strokeLinecap: "round" }))),
        file_download: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8.00487 5C8.00487 7.34241 8.00487 11.7461 8.00487 11.7461M8.00487 11.7461L11 8.75M8.00487 11.7461L5 8.75", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }))),
        file_default: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M5.75 8.25H10.25M5.75 5H8.25M5.75 11.5H10.246", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843826L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }))
        // TODO уголок?
        ),
        file_check: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M5.5 8.75L7.5 11.25L11 6.75", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843826L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }))),
        file_send: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M1.5 2C1.5 0.895431 2.39543 0 3.5 0H7.01938C7.32316 0 7.61047 0.13809 7.80024 0.375305L10.2809 3.47609C10.4227 3.6534 10.5 3.87371 10.5 4.10078V10C10.5 11.1046 9.60457 12 8.5 12H3.5C2.39543 12 1.5 11.1046 1.5 10V2Z", fill: "" }),
            React__default.createElement("path", { d: "M6.00366 8.80957C6.00366 7.05276 6.00366 3.75001 6.00366 3.75001M6.00366 3.75001L8.25 5.99707M6.00366 3.75001L3.75 5.99707", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M7.5 3.75V0.0908203L7.51223 0.0985845C7.60501 0.157459 7.68744 0.23122 7.75622 0.316904L10.3 3.48564C10.3472 3.5445 10.3877 3.60853 10.4205 3.67649L10.4561 3.75H7.5Z", fill: "#eeeeee" }))),
        file_alert_inverse: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M1.5 1.5C1.5 0.671573 2.17157 0 3 0H7.13953C7.36737 0 7.58285 0.103567 7.72518 0.281479L10.3357 3.54456C10.442 3.67755 10.5 3.84278 10.5 4.01309V10.5C10.5 11.3284 9.82843 12 9 12H3C2.17157 12 1.5 11.3284 1.5 10.5V1.5Z", fill: "" }),
            React__default.createElement("path", { d: "M7.5 3.75V0.0908203L7.54726 0.120813C7.61684 0.164969 7.67867 0.22029 7.73025 0.284553L10.3178 3.50779C10.3532 3.55193 10.3835 3.59995 10.4082 3.65092L10.4561 3.75H7.5Z", fill: "white", fillOpacity: "0.5" }),
            React__default.createElement("path", { d: "M6 3.36658L6 6.74248", stroke: "white", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M6 8.80872L6 8.81622", stroke: "white", strokeWidth: "1.275", strokeLinecap: "round", strokeLinejoin: "round" }))),
        file_question: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M5.75 6.495C5.75 5.25235 6.75736 4.245 8 4.245C9.24264 4.245 10.25 5.25235 10.25 6.495C10.25 7.73764 9.24264 8.745 8 8.745V9.49759", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }),
            React__default.createElement("path", { d: "M8 11.745L8 11.755", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" }))),
        file_alert: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }),
            React__default.createElement("path", { d: "M8 4.48877L8 8.98997", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M8 11.745L8 11.755", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" }))),
        file_in: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", stroke: "", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }),
            React__default.createElement("path", { d: "M5.62695 8.74763C7.96937 8.74763 10.373 8.74763 10.373 8.74763M10.373 8.74763L8.00484 11.2505M10.373 8.74763L7.99694 6.25", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        file_out: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", stroke: "", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }),
            React__default.createElement("path", { d: "M10.373 8.74763C8.03063 8.74763 5.62697 8.74763 5.62697 8.74763M5.62697 8.74763L7.99516 11.2505M5.62697 8.74763L8.00306 6.25", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        file_info: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }),
            React__default.createElement("path", { d: "M8 11.755L8 7.2538", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M8 4.49878L8 4.48878", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" }))),
        file_plus: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M5.754 9H10.25M8.00201 6.75L8.00201 11.25", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }))),
        mark: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1516_21126)" },
                React__default.createElement("path", { d: "M9.18118 1.0625H11.0625C11.2696 1.0625 11.4375 1.23039 11.4375 1.4375V3.34045M11.4375 9.6875V11.5625C11.4375 11.7696 11.2696 11.9375 11.0625 11.9375H9.1875M2.8125 11.9375H0.9375C0.730393 11.9375 0.5625 11.7696 0.5625 11.5625V9.6875M0.5625 3.3125L0.593348 1.43137C0.596704 1.22669 0.763585 1.06253 0.968292 1.06252L2.8125 1.0625", stroke: "", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M6 6.5L6 6.5075", stroke: "", strokeWidth: "1.9", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1516_21126" },
                    React__default.createElement("rect", { width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "white", transform: "translate(0 0.5)" }))))),
        mark_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_3325_890)" },
                React__default.createElement("path", { d: "M18.9625 1.125H22.7251C23.1394 1.125 23.4751 1.46078 23.4751 1.875V5.68089M23.4751 18.3751V22.1251C23.4751 22.5393 23.1393 22.8751 22.7251 22.8751H18.9751M6.22511 22.875L2.47511 22.875C2.0609 22.875 1.72511 22.5392 1.72511 22.125L1.72511 18.375M1.7251 5.62494L1.78679 1.86269C1.79351 1.45333 2.12727 1.12499 2.53668 1.12499L6.2251 1.12494M6.77809 10.1249H9.97798C10.3922 10.1249 10.728 9.78914 10.728 9.37493V6.17504C10.728 5.76083 10.3922 5.42504 9.97798 5.42504H6.77809C6.36388 5.42504 6.02809 5.76083 6.02809 6.17504V9.37493C6.02809 9.78914 6.36388 10.1249 6.77809 10.1249ZM6.77809 18.5749H9.97798C10.3922 18.5749 10.728 18.2391 10.728 17.8249V14.625C10.728 14.2108 10.3922 13.875 9.97798 13.875H6.77809C6.36388 13.875 6.02809 14.2108 6.02809 14.625V17.8249C6.02809 18.2391 6.36388 18.5749 6.77809 18.5749ZM15.2222 10.1249H18.4221C18.8363 10.1249 19.1721 9.78914 19.1721 9.37493V6.17504C19.1721 5.76083 18.8363 5.42504 18.4221 5.42504H15.2222C14.808 5.42504 14.4722 5.76083 14.4722 6.17504V9.37493C14.4722 9.78914 14.808 10.1249 15.2222 10.1249Z", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M14.4722 14.025C14.4722 13.9422 14.5393 13.875 14.6222 13.875H15.8222C15.905 13.875 15.9722 13.9422 15.9722 14.025V15.225C15.9722 15.3078 15.905 15.375 15.8222 15.375H14.6222C14.5393 15.375 14.4722 15.3078 14.4722 15.225V14.025Z", stroke: "#254E5F", strokeWidth: "1.5" }),
                React__default.createElement("path", { d: "M17.6721 17.225C17.6721 17.1421 17.7393 17.075 17.8221 17.075H19.0221C19.105 17.075 19.1721 17.1421 19.1721 17.225V18.425C19.1721 18.5078 19.105 18.575 19.0221 18.575H17.8221C17.7393 18.575 17.6721 18.5078 17.6721 18.425V17.225Z", stroke: "#254E5F", strokeWidth: "1.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_3325_890" },
                    React__default.createElement("rect", { width: "24", height: "24", fill: "white", transform: "translate(0.600098)" }))))),
        menu: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_3062_36594)" },
                React__default.createElement("path", { d: "M0.75 1.45C0.75 1.0634 1.0634 0.75 1.45 0.75H5.55C5.9366 0.75 6.25 1.0634 6.25 1.45V5.55C6.25 5.9366 5.9366 6.25 5.55 6.25H1.45C1.0634 6.25 0.75 5.9366 0.75 5.55V1.45Z", stroke: "white", strokeWidth: "1.5", strokeMiterlimit: "10" }),
                React__default.createElement("path", { d: "M9.75 1.45C9.75 1.0634 10.0634 0.75 10.45 0.75H14.55C14.9366 0.75 15.25 1.0634 15.25 1.45V5.55C15.25 5.9366 14.9366 6.25 14.55 6.25H10.45C10.0634 6.25 9.75 5.9366 9.75 5.55V1.45Z", stroke: "white", strokeWidth: "1.5", strokeMiterlimit: "10" }),
                React__default.createElement("path", { d: "M0.75 10.45C0.75 10.0634 1.0634 9.75 1.45 9.75H5.55C5.9366 9.75 6.25 10.0634 6.25 10.45V14.55C6.25 14.9366 5.9366 15.25 5.55 15.25H1.45C1.0634 15.25 0.75 14.9366 0.75 14.55V10.45Z", stroke: "white", strokeWidth: "1.5", strokeMiterlimit: "10" }),
                React__default.createElement("path", { d: "M9.75 10.45C9.75 10.0634 10.0634 9.75 10.45 9.75H14.55C14.9366 9.75 15.25 10.0634 15.25 10.45V14.55C15.25 14.9366 14.9366 15.25 14.55 15.25H10.45C10.0634 15.25 9.75 14.9366 9.75 14.55V10.45Z", stroke: "white", strokeWidth: "1.5", strokeMiterlimit: "10" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_3062_36594" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        file_minus: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M5.754 9H10.25", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }))),
        file_x_cross: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M5.70535 6.70332L10.2987 11.2967M10.2987 6.70331L5.70532 11.2967", strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }))),
        file_crossout: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_2544_398)" },
                React__default.createElement("path", { d: "M0.750242 0.750246L15.25 15.25", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M5.75 0.75H9.45775C9.57926 0.75 9.69419 0.805236 9.7701 0.900122L13.1623 5.14043C13.2191 5.21136 13.25 5.29948 13.25 5.39031V8.24549M2.75 7.75V13.95C2.75 14.668 3.33203 15.25 4.05 15.25H10.25", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_2544_398" },
                    React__default.createElement("rect", { width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', fill: "white" }))))),
        file_pause: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M6.25003 6.75L6.25 11.25M9.75003 6.75L9.75 11.25", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }))),
        file_dot: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M8 9L8 9.01", strokeWidth: "1.9", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }))),
        briefcase: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M3.75452 4.35874V1.7353C3.75452 1.56962 3.88883 1.4353 4.05452 1.4353H11.9645C12.1302 1.4353 12.2645 1.56962 12.2645 1.7353V4.35874", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M6.75391 9.03528H9.25001V9.48275C9.25001 9.64843 9.11569 9.78275 8.95001 9.78275H7.05391C6.88822 9.78275 6.75391 9.64843 6.75391 9.48275V9.03528Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M14.7 4.01746C15.0038 4.01746 15.25 4.2637 15.25 4.56746V13.503C15.25 13.8067 15.0038 14.053 14.7 14.053L1.3 14.053C0.996244 14.053 0.75 13.8067 0.75 13.503L0.75 4.56746C0.75 4.2637 0.996243 4.01746 1.3 4.01746L14.7 4.01746Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M1 6.50586L7.60608 9.33704C7.85763 9.44484 8.14237 9.44484 8.39392 9.33704L15 6.50586M6.75391 9.03522H9.25001V9.48269C9.25001 9.64837 9.11569 9.78269 8.95001 9.78269H7.05391C6.88822 9.78269 6.75391 9.64837 6.75391 9.48269V9.03522Z", strokeWidth: "1.5" }))),
        briefcase_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { stroke: "#254E5F", strokeWidth: "1.5", d: "m.5 6.5 7.106 3.308a1 1 0 0 0 .788 0L15.5 6.5M6.754 9.755v.199a.3.3 0 0 0 .3.3H8.95a.3.3 0 0 0 .3-.3v-.2H6.754Z" }),
            React__default.createElement("path", { stroke: strokeSecond, strokeWidth: "1.5", d: "M3.755 3.82V1.496a.3.3 0 0 1 .3-.3h7.906a.3.3 0 0 1 .3.3v2.142M.75 4.45v9.1a.7.7 0 0 0 .7.7h13.1a.7.7 0 0 0 .7-.7v-9.1a.7.7 0 0 0-.7-.7H1.45a.7.7 0 0 0-.7.7Z" }))),
        body_check: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M5.03333 5.33333C5.19902 5.33333 5.33333 5.19902 5.33333 5.03333V0.300001C5.33333 0.134315 5.46765 0 5.63333 0H10.3667C10.5324 0 10.6667 0.134315 10.6667 0.3V5.03333C10.6667 5.19902 10.801 5.33333 10.9667 5.33333H15.7C15.8657 5.33333 16 5.46765 16 5.63333V10.3667C16 10.5324 15.8657 10.6667 15.7 10.6667H10.9667C10.801 10.6667 10.6667 10.801 10.6667 10.9667V15.7C10.6667 15.8657 10.5324 16 10.3667 16H5.63333C5.46765 16 5.33333 15.8657 5.33333 15.7V10.9667C5.33333 10.801 5.19902 10.6667 5.03333 10.6667H0.300001C0.134315 10.6667 0 10.5324 0 10.3667V5.63333C0 5.46765 0.134315 5.33333 0.3 5.33333H5.03333Z" }))),
        tooltip_tail: (React__default.createElement("svg", { width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M7.27613 14.0694C8.04943 15.384 9.95057 15.384 10.7239 14.0694L17.227 3.01404C18.0113 1.68077 17.05 0 15.5032 0H2.49683C0.950003 0 -0.01131 1.68077 0.772965 3.01404L7.27613 14.0694Z", fill: "" }))),
        triangle_alert: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8 5.75385V9.25244M8.00061 11.8671V11.8771M1.76231 14.256H14.2488C15.0136 14.256 15.4954 13.4323 15.1204 12.7657L8.87714 1.6666C8.49483 0.986947 7.51629 0.986947 7.13399 1.6666L0.890733 12.7657C0.515768 13.4323 0.997483 14.256 1.76231 14.256Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        triangle_alert_fill: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_5044_117871)" },
                React__default.createElement("path", { d: "M7.13426 1.66665C7.51656 0.987003 8.49511 0.987003 8.87741 1.66665L15.1207 12.7658C15.4956 13.4324 15.0139 14.256 14.2491 14.256H1.76258C0.997757 14.256 0.516042 13.4324 0.891006 12.7658L7.13426 1.66665Z", fill: "", stroke: "", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M8 5.75391L8 9.2525", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M8.00098 11.8672L8.00098 11.8772", stroke: "white", strokeWidth: "1.9", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_5044_117871" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        refresh: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#clip0_1446_695)" },
                React__default.createElement("path", { d: "M14.6015 8C14.6015 11.6739 11.6094 14.6521 7.91844 14.6521C5.70614 14.6521 3.7449 13.5822 2.52856 11.9337", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M1.34497 8.00006C1.34497 4.32618 4.33707 1.34791 8.02801 1.34791C10.2403 1.34791 12.2016 2.4179 13.4179 4.06634M2.52866 11.9339C3.745 13.5824 5.70623 14.6524 7.91854 14.6524C9.1711 14.6524 10.3432 14.3094 11.3452 13.7126M2.82862 15.2556L2.24762 11.8014L5.63821 11.4866M13.1179 0.744656L13.6989 4.19886L10.3083 4.51361", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1446_695" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        paint: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M12.5 9L7 14.5L2 9L12.5 9Z" }),
            React__default.createElement("path", { d: "M14.2517 8.00328L14.782 7.47295L14.7819 7.47281L14.2517 8.00328ZM7.52719 0.221226C7.23429 -0.0716676 6.75942 -0.0716676 6.46653 0.221226C6.17363 0.514119 6.17363 0.988993 6.46653 1.28189L7.52719 0.221226ZM13.9696 8.78189L14.5 9.31222L15.5606 8.25156L15.0303 7.72123L13.9696 8.78189ZM8.10005 14.1549L7.56972 13.6246L8.10005 14.1549ZM7.71822 2.53358L13.7215 8.53375L14.7819 7.47281L8.77861 1.47264L7.71822 2.53358ZM13.7214 7.47295L7.56972 13.6246L8.63038 14.6853L14.782 8.53361L13.7214 7.47295ZM6.93332 13.6246L2.63001 9.3213L1.56935 10.382L5.87266 14.6853L6.93332 13.6246ZM2.62994 8.68497L8.77886 2.53332L7.71797 1.4729L1.56905 7.62455L2.62994 8.68497ZM8.77874 1.47278L7.52719 0.221226L6.46653 1.28189L7.71808 2.53344L8.77874 1.47278ZM14.2517 8.00328C13.7214 8.53361 13.7214 8.53361 13.7214 8.53361C13.7214 8.53361 13.7214 8.53362 13.7214 8.53362C13.7214 8.53362 13.7214 8.53362 13.7214 8.53363C13.7214 8.53363 13.7214 8.53363 13.7214 8.53364C13.7214 8.53364 13.7214 8.53365 13.7214 8.53365C13.7214 8.53366 13.7214 8.53367 13.7214 8.53367C13.7214 8.53368 13.7214 8.53369 13.7214 8.53369C13.7215 8.5337 13.7215 8.53371 13.7215 8.53372C13.7215 8.53373 13.7215 8.53374 13.7215 8.53375C13.7215 8.53376 13.7215 8.53377 13.7215 8.53378C13.7215 8.53379 13.7216 8.53381 13.7216 8.53382C13.7216 8.53383 13.7216 8.53384 13.7216 8.53386C13.7216 8.53387 13.7216 8.53388 13.7217 8.5339C13.7217 8.53391 13.7217 8.53393 13.7217 8.53395C13.7217 8.53396 13.7217 8.53398 13.7217 8.53399C13.7218 8.53401 13.7218 8.53403 13.7218 8.53405C13.7218 8.53407 13.7218 8.53408 13.7219 8.5341C13.7219 8.53412 13.7219 8.53414 13.7219 8.53416C13.7219 8.53418 13.722 8.5342 13.722 8.53422C13.722 8.53425 13.722 8.53427 13.722 8.53429C13.7221 8.53431 13.7221 8.53434 13.7221 8.53436C13.7221 8.53438 13.7222 8.53441 13.7222 8.53443C13.7222 8.53446 13.7222 8.53448 13.7223 8.53451C13.7223 8.53453 13.7223 8.53456 13.7223 8.53459C13.7224 8.53461 13.7224 8.53464 13.7224 8.53467C13.7224 8.5347 13.7225 8.53473 13.7225 8.53475C13.7225 8.53478 13.7226 8.53481 13.7226 8.53484C13.7226 8.53487 13.7227 8.5349 13.7227 8.53493C13.7227 8.53497 13.7227 8.535 13.7228 8.53503C13.7228 8.53506 13.7228 8.53509 13.7229 8.53513C13.7229 8.53516 13.7229 8.53519 13.723 8.53523C13.723 8.53526 13.7231 8.5353 13.7231 8.53533C13.7231 8.53537 13.7232 8.5354 13.7232 8.53544C13.7232 8.53548 13.7233 8.53551 13.7233 8.53555C13.7233 8.53559 13.7234 8.53563 13.7234 8.53567C13.7235 8.5357 13.7235 8.53574 13.7235 8.53578C13.7236 8.53582 13.7236 8.53586 13.7237 8.5359C13.7237 8.53594 13.7237 8.53599 13.7238 8.53603C13.7238 8.53607 13.7239 8.53611 13.7239 8.53615C13.7239 8.5362 13.724 8.53624 13.724 8.53628C13.7241 8.53633 13.7241 8.53637 13.7242 8.53642C13.7242 8.53646 13.7243 8.53651 13.7243 8.53655C13.7244 8.5366 13.7244 8.53664 13.7244 8.53669C13.7245 8.53674 13.7245 8.53678 13.7246 8.53683C13.7246 8.53688 13.7247 8.53693 13.7247 8.53698C13.7248 8.53703 13.7248 8.53708 13.7249 8.53713C13.7249 8.53718 13.725 8.53723 13.725 8.53728C13.7251 8.53733 13.7251 8.53738 13.7252 8.53743C13.7252 8.53748 13.7253 8.53754 13.7253 8.53759C13.7254 8.53764 13.7254 8.53769 13.7255 8.53775C13.7256 8.5378 13.7256 8.53786 13.7257 8.53791C13.7257 8.53797 13.7258 8.53802 13.7258 8.53808C13.7259 8.53813 13.7259 8.53819 13.726 8.53825C13.7261 8.5383 13.7261 8.53836 13.7262 8.53842C13.7262 8.53848 13.7263 8.53854 13.7263 8.53859C13.7264 8.53865 13.7265 8.53871 13.7265 8.53877C13.7266 8.53883 13.7266 8.53889 13.7267 8.53895C13.7268 8.53901 13.7268 8.53908 13.7269 8.53914C13.727 8.5392 13.727 8.53926 13.7271 8.53932C13.7271 8.53939 13.7272 8.53945 13.7273 8.53951C13.7273 8.53958 13.7274 8.53964 13.7275 8.53971C13.7275 8.53977 13.7276 8.53984 13.7277 8.5399C13.7277 8.53997 13.7278 8.54003 13.7279 8.5401C13.7279 8.54017 13.728 8.54023 13.7281 8.5403C13.7281 8.54037 13.7282 8.54044 13.7283 8.54051C13.7283 8.54057 13.7284 8.54064 13.7285 8.54071C13.7285 8.54078 13.7286 8.54085 13.7287 8.54092C13.7287 8.54099 13.7288 8.54106 13.7289 8.54114C13.729 8.54121 13.729 8.54128 13.7291 8.54135C13.7292 8.54142 13.7292 8.5415 13.7293 8.54157C13.7294 8.54164 13.7295 8.54172 13.7295 8.54179C13.7296 8.54187 13.7297 8.54194 13.7298 8.54202C13.7298 8.54209 13.7299 8.54217 13.73 8.54224C13.7301 8.54232 13.7301 8.5424 13.7302 8.54247C13.7303 8.54255 13.7304 8.54263 13.7305 8.5427C13.7305 8.54278 13.7306 8.54286 13.7307 8.54294C13.7308 8.54302 13.7309 8.5431 13.7309 8.54318C13.731 8.54326 13.7311 8.54334 13.7312 8.54342C13.7313 8.5435 13.7313 8.54358 13.7314 8.54366C13.7315 8.54374 13.7316 8.54383 13.7317 8.54391C13.7317 8.54399 13.7318 8.54407 13.7319 8.54416C13.732 8.54424 13.7321 8.54433 13.7322 8.54441C13.7322 8.54449 13.7323 8.54458 13.7324 8.54466C13.7325 8.54475 13.7326 8.54483 13.7327 8.54492C13.7328 8.54501 13.7328 8.54509 13.7329 8.54518C13.733 8.54527 13.7331 8.54536 13.7332 8.54544C13.7333 8.54553 13.7334 8.54562 13.7335 8.54571C13.7336 8.5458 13.7336 8.54589 13.7337 8.54598C13.7338 8.54607 13.7339 8.54616 13.734 8.54625C13.7341 8.54634 13.7342 8.54643 13.7343 8.54652C13.7344 8.54661 13.7345 8.5467 13.7345 8.5468C13.7346 8.54689 13.7347 8.54698 13.7348 8.54707C13.7349 8.54717 13.735 8.54726 13.7351 8.54735C13.7352 8.54745 13.7353 8.54754 13.7354 8.54764C13.7355 8.54773 13.7356 8.54783 13.7357 8.54792C13.7358 8.54802 13.7359 8.54812 13.736 8.54821C13.7361 8.54831 13.7362 8.54841 13.7363 8.54851C13.7364 8.5486 13.7365 8.5487 13.7366 8.5488C13.7367 8.5489 13.7367 8.549 13.7368 8.5491C13.7369 8.5492 13.737 8.5493 13.7371 8.54939C13.7372 8.5495 13.7373 8.5496 13.7374 8.5497C13.7376 8.5498 13.7377 8.5499 13.7378 8.55C13.7379 8.5501 13.738 8.5502 13.7381 8.55031C13.7382 8.55041 13.7383 8.55051 13.7384 8.55062C13.7385 8.55072 13.7386 8.55082 13.7387 8.55093C13.7388 8.55103 13.7389 8.55114 13.739 8.55124C13.7391 8.55135 13.7392 8.55145 13.7393 8.55156C13.7394 8.55167 13.7395 8.55177 13.7396 8.55188C13.7397 8.55199 13.7398 8.55209 13.74 8.5522C13.7401 8.55231 13.7402 8.55242 13.7403 8.55252C13.7404 8.55263 13.7405 8.55274 13.7406 8.55285C13.7407 8.55296 13.7408 8.55307 13.7409 8.55318C13.741 8.55329 13.7412 8.5534 13.7413 8.55351C13.7414 8.55362 13.7415 8.55373 13.7416 8.55384C13.7417 8.55396 13.7418 8.55407 13.7419 8.55418C13.742 8.55429 13.7422 8.55441 13.7423 8.55452C13.7424 8.55463 13.7425 8.55475 13.7426 8.55486C13.7427 8.55498 13.7428 8.55509 13.743 8.5552C13.7431 8.55532 13.7432 8.55544 13.7433 8.55555C13.7434 8.55567 13.7435 8.55578 13.7437 8.5559C13.7438 8.55601 13.7439 8.55613 13.744 8.55625C13.7441 8.55637 13.7442 8.55648 13.7444 8.5566C13.7445 8.55672 13.7446 8.55684 13.7447 8.55696C13.7448 8.55708 13.7449 8.5572 13.7451 8.55732C13.7452 8.55744 13.7453 8.55755 13.7454 8.55768C13.7455 8.5578 13.7457 8.55792 13.7458 8.55804C13.7459 8.55816 13.746 8.55828 13.7462 8.5584C13.7463 8.55852 13.7464 8.55865 13.7465 8.55877C13.7466 8.55889 13.7468 8.55901 13.7469 8.55914C13.747 8.55926 13.7471 8.55939 13.7473 8.55951C13.7474 8.55963 13.7475 8.55976 13.7476 8.55988C13.7478 8.56001 13.7479 8.56013 13.748 8.56026C13.7481 8.56038 13.7483 8.56051 13.7484 8.56064C13.7485 8.56076 13.7486 8.56089 13.7488 8.56102C13.7489 8.56114 13.749 8.56127 13.7492 8.5614C13.7493 8.56153 13.7494 8.56166 13.7495 8.56179C13.7497 8.56191 13.7498 8.56204 13.7499 8.56217C13.7501 8.5623 13.7502 8.56243 13.7503 8.56256C13.7504 8.56269 13.7506 8.56282 13.7507 8.56295C13.7508 8.56308 13.751 8.56322 13.7511 8.56335C13.7512 8.56348 13.7514 8.56361 13.7515 8.56374C13.7516 8.56388 13.7518 8.56401 13.7519 8.56414C13.752 8.56427 13.7522 8.56441 13.7523 8.56454C13.7524 8.56467 13.7526 8.56481 13.7527 8.56494C13.7528 8.56508 13.753 8.56521 13.7531 8.56535C13.7532 8.56548 13.7534 8.56562 13.7535 8.56575C13.7536 8.56589 13.7538 8.56603 13.7539 8.56616C13.7541 8.5663 13.7542 8.56644 13.7543 8.56657C13.7545 8.56671 13.7546 8.56685 13.7547 8.56699C13.7549 8.56712 13.755 8.56726 13.7552 8.5674C13.7553 8.56754 13.7554 8.56768 13.7556 8.56782C13.7557 8.56796 13.7559 8.5681 13.756 8.56824C13.7561 8.56838 13.7563 8.56852 13.7564 8.56866C13.7566 8.5688 13.7567 8.56894 13.7568 8.56908C13.757 8.56922 13.7571 8.56937 13.7573 8.56951C13.7574 8.56965 13.7575 8.56979 13.7577 8.56994C13.7578 8.57008 13.758 8.57022 13.7581 8.57036C13.7583 8.57051 13.7584 8.57065 13.7585 8.5708C13.7587 8.57094 13.7588 8.57108 13.759 8.57123C13.7591 8.57137 13.7593 8.57152 13.7594 8.57167C13.7596 8.57181 13.7597 8.57196 13.7599 8.5721C13.76 8.57225 13.7601 8.57239 13.7603 8.57254C13.7604 8.57269 13.7606 8.57284 13.7607 8.57298C13.7609 8.57313 13.761 8.57328 13.7612 8.57343C13.7613 8.57358 13.7615 8.57372 13.7616 8.57387C13.7618 8.57402 13.7619 8.57417 13.7621 8.57432C13.7622 8.57447 13.7624 8.57462 13.7625 8.57477C13.7627 8.57492 13.7628 8.57507 13.763 8.57522C13.7631 8.57537 13.7633 8.57552 13.7634 8.57567C13.7636 8.57582 13.7637 8.57598 13.7639 8.57613C13.764 8.57628 13.7642 8.57643 13.7643 8.57658C13.7645 8.57674 13.7646 8.57689 13.7648 8.57704C13.7649 8.5772 13.7651 8.57735 13.7653 8.5775C13.7654 8.57766 13.7656 8.57781 13.7657 8.57797C13.7659 8.57812 13.766 8.57828 13.7662 8.57843C13.7663 8.57859 13.7665 8.57874 13.7666 8.5789C13.7668 8.57905 13.767 8.57921 13.7671 8.57937C13.7673 8.57952 13.7674 8.57968 13.7676 8.57984C13.7677 8.57999 13.7679 8.58015 13.7681 8.58031C13.7682 8.58046 13.7684 8.58062 13.7685 8.58078C13.7687 8.58094 13.7688 8.5811 13.769 8.58126C13.7692 8.58141 13.7693 8.58157 13.7695 8.58173C13.7696 8.58189 13.7698 8.58205 13.77 8.58221C13.7701 8.58237 13.7703 8.58253 13.7704 8.58269C13.7706 8.58285 13.7708 8.58301 13.7709 8.58318C13.7711 8.58334 13.7713 8.5835 13.7714 8.58366C13.7716 8.58382 13.7717 8.58398 13.7719 8.58415C13.7721 8.58431 13.7722 8.58447 13.7724 8.58463C13.7725 8.5848 13.7727 8.58496 13.7729 8.58512C13.773 8.58529 13.7732 8.58545 13.7734 8.58561C13.7735 8.58578 13.7737 8.58594 13.7739 8.58611C13.774 8.58627 13.7742 8.58644 13.7744 8.5866C13.7745 8.58677 13.7747 8.58693 13.7749 8.5871C13.775 8.58726 13.7752 8.58743 13.7753 8.5876C13.7755 8.58776 13.7757 8.58793 13.7758 8.5881C13.776 8.58826 13.7762 8.58843 13.7763 8.5886C13.7765 8.58876 13.7767 8.58893 13.7769 8.5891C13.777 8.58927 13.7772 8.58944 13.7774 8.5896C13.7775 8.58977 13.7777 8.58994 13.7779 8.59011C13.778 8.59028 13.7782 8.59045 13.7784 8.59062C13.7785 8.59079 13.7787 8.59096 13.7789 8.59113C13.7791 8.5913 13.7792 8.59147 13.7794 8.59164C13.7796 8.59181 13.7797 8.59198 13.7799 8.59215C13.7801 8.59232 13.7802 8.5925 13.7804 8.59267C13.7806 8.59284 13.7808 8.59301 13.7809 8.59318C13.7811 8.59336 13.7813 8.59353 13.7815 8.5937C13.7816 8.59387 13.7818 8.59405 13.782 8.59422C13.7821 8.59439 13.7823 8.59457 13.7825 8.59474C13.7827 8.59491 13.7828 8.59509 13.783 8.59526C13.7832 8.59544 13.7834 8.59561 13.7835 8.59579C13.7837 8.59596 13.7839 8.59614 13.7841 8.59631C13.7842 8.59649 13.7844 8.59666 13.7846 8.59684C13.7848 8.59701 13.7849 8.59719 13.7851 8.59737C13.7853 8.59754 13.7855 8.59772 13.7856 8.5979C13.7858 8.59807 13.786 8.59825 13.7862 8.59843C13.7864 8.59861 13.7865 8.59878 13.7867 8.59896C13.7869 8.59914 13.7871 8.59932 13.7872 8.5995C13.7874 8.59967 13.7876 8.59985 13.7878 8.60003C13.788 8.60021 13.7881 8.60039 13.7883 8.60057C13.7885 8.60075 13.7887 8.60093 13.7889 8.60111C13.789 8.60129 13.7892 8.60147 13.7894 8.60165C13.7896 8.60183 13.7898 8.60201 13.7899 8.60219C13.7901 8.60237 13.7903 8.60255 13.7905 8.60273C13.7907 8.60291 13.7908 8.60309 13.791 8.60328C13.7912 8.60346 13.7914 8.60364 13.7916 8.60382C13.7918 8.604 13.7919 8.60419 13.7921 8.60437C13.7923 8.60455 13.7925 8.60474 13.7927 8.60492C13.7929 8.6051 13.793 8.60528 13.7932 8.60547C13.7934 8.60565 13.7936 8.60584 13.7938 8.60602C13.794 8.6062 13.7941 8.60639 13.7943 8.60657C13.7945 8.60676 13.7947 8.60694 13.7949 8.60713C13.7951 8.60731 13.7952 8.6075 13.7954 8.60768C13.7956 8.60787 13.7958 8.60805 13.796 8.60824C13.7962 8.60842 13.7964 8.60861 13.7965 8.6088C13.7967 8.60898 13.7969 8.60917 13.7971 8.60936C13.7973 8.60954 13.7975 8.60973 13.7977 8.60992C13.7979 8.6101 13.798 8.61029 13.7982 8.61048C13.7984 8.61067 13.7986 8.61085 13.7988 8.61104C13.799 8.61123 13.7992 8.61142 13.7994 8.61161C13.7995 8.61179 13.7997 8.61198 13.7999 8.61217C13.8001 8.61236 13.8003 8.61255 13.8005 8.61274C13.8007 8.61293 13.8009 8.61312 13.8011 8.61331C13.8013 8.6135 13.8014 8.61369 13.8016 8.61388C13.8018 8.61407 13.802 8.61426 13.8022 8.61445C13.8024 8.61464 13.8026 8.61483 13.8028 8.61502C13.803 8.61521 13.8032 8.6154 13.8033 8.61559C13.8035 8.61578 13.8037 8.61598 13.8039 8.61617C13.8041 8.61636 13.8043 8.61655 13.8045 8.61674C13.8047 8.61694 13.8049 8.61713 13.8051 8.61732C13.8053 8.61751 13.8055 8.6177 13.8057 8.6179C13.8058 8.61809 13.806 8.61828 13.8062 8.61848C13.8064 8.61867 13.8066 8.61886 13.8068 8.61906C13.807 8.61925 13.8072 8.61944 13.8074 8.61964C13.8076 8.61983 13.8078 8.62003 13.808 8.62022C13.8082 8.62042 13.8084 8.62061 13.8086 8.6208C13.8088 8.621 13.8089 8.62119 13.8091 8.62139C13.8093 8.62158 13.8095 8.62178 13.8097 8.62198C13.8099 8.62217 13.8101 8.62237 13.8103 8.62256C13.8105 8.62276 13.8107 8.62295 13.8109 8.62315C13.8111 8.62335 13.8113 8.62354 13.8115 8.62374C13.8117 8.62394 13.8119 8.62413 13.8121 8.62433C13.8123 8.62453 13.8125 8.62472 13.8127 8.62492C13.8129 8.62512 13.8131 8.62532 13.8133 8.62551C13.8135 8.62571 13.8137 8.62591 13.8139 8.62611C13.8141 8.6263 13.8143 8.6265 13.8145 8.6267C13.8147 8.6269 13.8149 8.6271 13.815 8.6273C13.8152 8.6275 13.8154 8.62769 13.8156 8.62789C13.8158 8.62809 13.816 8.62829 13.8162 8.62849C13.8164 8.62869 13.8166 8.62889 13.8168 8.62909C13.817 8.62929 13.8172 8.62949 13.8174 8.62969C13.8176 8.62989 13.8178 8.63009 13.818 8.63029C13.8182 8.63049 13.8184 8.63069 13.8186 8.63089C13.8188 8.63109 13.819 8.63129 13.8192 8.63149C13.8194 8.63169 13.8196 8.63189 13.8198 8.6321C13.8201 8.6323 13.8203 8.6325 13.8205 8.6327C13.8207 8.6329 13.8209 8.6331 13.8211 8.63331C13.8213 8.63351 13.8215 8.63371 13.8217 8.63391C13.8219 8.63411 13.8221 8.63432 13.8223 8.63452C13.8225 8.63472 13.8227 8.63492 13.8229 8.63513C13.8231 8.63533 13.8233 8.63553 13.8235 8.63574C13.8237 8.63594 13.8239 8.63614 13.8241 8.63635C13.8243 8.63655 13.8245 8.63675 13.8247 8.63696C13.8249 8.63716 13.8251 8.63736 13.8253 8.63757C13.8255 8.63777 13.8257 8.63798 13.8259 8.63818C13.8261 8.63838 13.8263 8.63859 13.8265 8.63879C13.8268 8.639 13.827 8.6392 13.8272 8.63941C13.8274 8.63961 13.8276 8.63982 13.8278 8.64002C13.828 8.64023 13.8282 8.64043 13.8284 8.64064C13.8286 8.64084 13.8288 8.64105 13.829 8.64125C13.8292 8.64146 13.8294 8.64167 13.8296 8.64187C13.8298 8.64208 13.83 8.64228 13.8302 8.64249C13.8304 8.6427 13.8307 8.6429 13.8309 8.64311C13.8311 8.64332 13.8313 8.64352 13.8315 8.64373C13.8317 8.64394 13.8319 8.64414 13.8321 8.64435C13.8323 8.64456 13.8325 8.64476 13.8327 8.64497C13.8329 8.64518 13.8331 8.64539 13.8333 8.64559C13.8336 8.6458 13.8338 8.64601 13.834 8.64622C13.8342 8.64642 13.8344 8.64663 13.8346 8.64684C13.8348 8.64705 13.835 8.64725 13.8352 8.64746C13.8354 8.64767 13.8356 8.64788 13.8358 8.64809C13.836 8.6483 13.8363 8.6485 13.8365 8.64871C13.8367 8.64892 13.8369 8.64913 13.8371 8.64934C13.8373 8.64955 13.8375 8.64976 13.8377 8.64997C13.8379 8.65018 13.8381 8.65038 13.8383 8.65059C13.8386 8.6508 13.8388 8.65101 13.839 8.65122C13.8392 8.65143 13.8394 8.65164 13.8396 8.65185C13.8398 8.65206 13.84 8.65227 13.8402 8.65248C13.8404 8.65269 13.8407 8.6529 13.8409 8.65311C13.8411 8.65332 13.8413 8.65353 13.8415 8.65374C13.8417 8.65395 13.8419 8.65416 13.8421 8.65437C13.8423 8.65458 13.8425 8.6548 13.8428 8.65501C13.843 8.65522 13.8432 8.65543 13.8434 8.65564C13.8436 8.65585 13.8438 8.65606 13.844 8.65627C13.8442 8.65648 13.8444 8.65669 13.8447 8.65691C13.8449 8.65712 13.8451 8.65733 13.8453 8.65754C13.8455 8.65775 13.8457 8.65796 13.8459 8.65818C13.8461 8.65839 13.8464 8.6586 13.8466 8.65881C13.8468 8.65902 13.847 8.65924 13.8472 8.65945C13.8474 8.65966 13.8476 8.65987 13.8478 8.66008C13.8481 8.6603 13.8483 8.66051 13.8485 8.66072C13.8487 8.66093 13.8489 8.66115 13.8491 8.66136C13.8493 8.66157 13.8495 8.66179 13.8498 8.662C13.85 8.66221 13.8502 8.66242 13.8504 8.66264C13.8506 8.66285 13.8508 8.66306 13.851 8.66328C13.8512 8.66349 13.8515 8.6637 13.8517 8.66392C13.8519 8.66413 13.8521 8.66434 13.8523 8.66456C13.8525 8.66477 13.8527 8.66498 13.8529 8.6652C13.8532 8.66541 13.8534 8.66562 13.8536 8.66584C13.8538 8.66605 13.854 8.66627 13.8542 8.66648C13.8544 8.66669 13.8547 8.66691 13.8549 8.66712C13.8551 8.66734 13.8553 8.66755 13.8555 8.66776C13.8557 8.66798 13.8559 8.66819 13.8562 8.66841C13.8564 8.66862 13.8566 8.66884 13.8568 8.66905C13.857 8.66926 13.8572 8.66948 13.8574 8.66969C13.8577 8.66991 13.8579 8.67012 13.8581 8.67034C13.8583 8.67055 13.8585 8.67077 13.8587 8.67098C13.859 8.6712 13.8592 8.67141 13.8594 8.67163C13.8596 8.67184 13.8598 8.67206 13.86 8.67227C13.8602 8.67249 13.8605 8.6727 13.8607 8.67292C13.8609 8.67313 13.8611 8.67335 13.8613 8.67356C13.8615 8.67378 13.8617 8.674 13.862 8.67421C13.8622 8.67443 13.8624 8.67464 13.8626 8.67486C13.8628 8.67507 13.863 8.67529 13.8633 8.6755C13.8635 8.67572 13.8637 8.67594 13.8639 8.67615C13.8641 8.67637 13.8643 8.67658 13.8646 8.6768C13.8648 8.67701 13.865 8.67723 13.8652 8.67745C13.8654 8.67766 13.8656 8.67788 13.8658 8.6781C13.8661 8.67831 13.8663 8.67853 13.8665 8.67874C13.8667 8.67896 13.8669 8.67918 13.8671 8.67939C13.8674 8.67961 13.8676 8.67982 13.8678 8.68004C13.868 8.68026 13.8682 8.68047 13.8684 8.68069C13.8687 8.68091 13.8689 8.68112 13.8691 8.68134C13.8693 8.68156 13.8695 8.68177 13.8697 8.68199C13.87 8.68221 13.8702 8.68242 13.8704 8.68264C13.8706 8.68286 13.8708 8.68307 13.871 8.68329C13.8713 8.68351 13.8715 8.68372 13.8717 8.68394C13.8719 8.68416 13.8721 8.68437 13.8723 8.68459C13.8726 8.68481 13.8728 8.68502 13.873 8.68524C13.8732 8.68546 13.8734 8.68567 13.8736 8.68589C13.8739 8.68611 13.8741 8.68632 13.8743 8.68654C13.8745 8.68676 13.8747 8.68698 13.8749 8.68719C13.8752 8.68741 13.8754 8.68763 13.8756 8.68784C13.8758 8.68806 13.876 8.68828 13.8762 8.6885C13.8765 8.68871 13.8767 8.68893 13.8769 8.68915C13.8771 8.68936 13.8773 8.68958 13.8776 8.6898C13.8778 8.69002 13.878 8.69023 13.8782 8.69045C13.8784 8.69067 13.8786 8.69088 13.8789 8.6911C13.8791 8.69132 13.8793 8.69154 13.8795 8.69175C13.8797 8.69197 13.8799 8.69219 13.8802 8.69241C13.8804 8.69262 13.8806 8.69284 13.8808 8.69306C13.881 8.69328 13.8812 8.69349 13.8815 8.69371C13.8817 8.69393 13.8819 8.69414 13.8821 8.69436C13.8823 8.69458 13.8826 8.6948 13.8828 8.69501C13.883 8.69523 13.8832 8.69545 13.8834 8.69567C13.8836 8.69588 13.8839 8.6961 13.8841 8.69632C13.8843 8.69654 13.8845 8.69675 13.8847 8.69697C13.8849 8.69719 13.8852 8.69741 13.8854 8.69762C13.8856 8.69784 13.8858 8.69806 13.886 8.69828C13.8862 8.69849 13.8865 8.69871 13.8867 8.69893C13.8869 8.69915 13.8871 8.69936 13.8873 8.69958C13.8876 8.6998 13.8878 8.70002 13.888 8.70023C13.8882 8.70045 13.8884 8.70067 13.8886 8.70088C13.8889 8.7011 13.8891 8.70132 13.8893 8.70154C13.8895 8.70175 13.8897 8.70197 13.8899 8.70219C13.8902 8.70241 13.8904 8.70262 13.8906 8.70284C13.8908 8.70306 13.891 8.70328 13.8912 8.70349C13.8915 8.70371 13.8917 8.70393 13.8919 8.70414C13.8921 8.70436 13.8923 8.70458 13.8925 8.7048C13.8928 8.70501 13.893 8.70523 13.8932 8.70545C13.8934 8.70567 13.8936 8.70588 13.8939 8.7061C13.8941 8.70632 13.8943 8.70653 13.8945 8.70675C13.8947 8.70697 13.8949 8.70719 13.8952 8.7074C13.8954 8.70762 13.8956 8.70784 13.8958 8.70805C13.896 8.70827 13.8962 8.70849 13.8965 8.7087C13.8967 8.70892 13.8969 8.70914 13.8971 8.70936C13.8973 8.70957 13.8975 8.70979 13.8978 8.71001C13.898 8.71022 13.8982 8.71044 13.8984 8.71066C13.8986 8.71087 13.8988 8.71109 13.8991 8.71131C13.8993 8.71152 13.8995 8.71174 13.8997 8.71196C13.8999 8.71217 13.9001 8.71239 13.9004 8.71261C13.9006 8.71282 13.9008 8.71304 13.901 8.71326C13.9012 8.71347 13.9014 8.71369 13.9017 8.71391C13.9019 8.71412 13.9021 8.71434 13.9023 8.71456C13.9025 8.71477 13.9027 8.71499 13.903 8.7152C13.9032 8.71542 13.9034 8.71564 13.9036 8.71585C13.9038 8.71607 13.904 8.71629 13.9043 8.7165C13.9045 8.71672 13.9047 8.71693 13.9049 8.71715C13.9051 8.71737 13.9053 8.71758 13.9056 8.7178C13.9058 8.71801 13.906 8.71823 13.9062 8.71845C13.9064 8.71866 13.9066 8.71888 13.9068 8.71909C13.9071 8.71931 13.9073 8.71952 13.9075 8.71974C13.9077 8.71996 13.9079 8.72017 13.9081 8.72039C13.9084 8.7206 13.9086 8.72082 13.9088 8.72103C13.909 8.72125 13.9092 8.72146 13.9094 8.72168C13.9096 8.72189 13.9099 8.72211 13.9101 8.72232C13.9103 8.72254 13.9105 8.72276 13.9107 8.72297C13.9109 8.72318 13.9112 8.7234 13.9114 8.72362C13.9116 8.72383 13.9118 8.72404 13.912 8.72426C13.9122 8.72447 13.9124 8.72469 13.9127 8.7249C13.9129 8.72512 13.9131 8.72533 13.9133 8.72555C13.9135 8.72576 13.9137 8.72598 13.9139 8.72619C13.9142 8.72641 13.9144 8.72662 13.9146 8.72683C13.9148 8.72705 13.915 8.72726 13.9152 8.72748C13.9154 8.72769 13.9157 8.72791 13.9159 8.72812C13.9161 8.72833 13.9163 8.72855 13.9165 8.72876C13.9167 8.72897 13.9169 8.72919 13.9172 8.7294C13.9174 8.72962 13.9176 8.72983 13.9178 8.73004C13.918 8.73026 13.9182 8.73047 13.9184 8.73068C13.9186 8.7309 13.9189 8.73111 13.9191 8.73132C13.9193 8.73154 13.9195 8.73175 13.9197 8.73196C13.9199 8.73218 13.9201 8.73239 13.9204 8.7326C13.9206 8.73282 13.9208 8.73303 13.921 8.73324C13.9212 8.73345 13.9214 8.73367 13.9216 8.73388C13.9218 8.73409 13.9221 8.7343 13.9223 8.73452C13.9225 8.73473 13.9227 8.73494 13.9229 8.73515C13.9231 8.73536 13.9233 8.73558 13.9235 8.73579C13.9238 8.736 13.924 8.73621 13.9242 8.73643C13.9244 8.73664 13.9246 8.73685 13.9248 8.73706C13.925 8.73727 13.9252 8.73748 13.9254 8.73769C13.9257 8.73791 13.9259 8.73812 13.9261 8.73833C13.9263 8.73854 13.9265 8.73875 13.9267 8.73896C13.9269 8.73917 13.9271 8.73938 13.9273 8.7396C13.9276 8.73981 13.9278 8.74002 13.928 8.74023C13.9282 8.74044 13.9284 8.74065 13.9286 8.74086C13.9288 8.74107 13.929 8.74128 13.9292 8.74149C13.9295 8.7417 13.9297 8.74191 13.9299 8.74212C13.9301 8.74233 13.9303 8.74254 13.9305 8.74275C13.9307 8.74296 13.9309 8.74317 13.9311 8.74338C13.9313 8.74359 13.9316 8.7438 13.9318 8.74401C13.932 8.74422 13.9322 8.74443 13.9324 8.74464C13.9326 8.74485 13.9328 8.74506 13.933 8.74526C13.9332 8.74547 13.9334 8.74568 13.9336 8.74589C13.9339 8.7461 13.9341 8.74631 13.9343 8.74652C13.9345 8.74673 13.9347 8.74693 13.9349 8.74714C13.9351 8.74735 13.9353 8.74756 13.9355 8.74777C13.9357 8.74797 13.9359 8.74818 13.9361 8.74839C13.9364 8.7486 13.9366 8.74881 13.9368 8.74901C13.937 8.74922 13.9372 8.74943 13.9374 8.74964C13.9376 8.74984 13.9378 8.75005 13.938 8.75026C13.9382 8.75046 13.9384 8.75067 13.9386 8.75088C13.9388 8.75108 13.939 8.75129 13.9393 8.7515C13.9395 8.7517 13.9397 8.75191 13.9399 8.75212C13.9401 8.75232 13.9403 8.75253 13.9405 8.75274C13.9407 8.75294 13.9409 8.75315 13.9411 8.75335C13.9413 8.75356 13.9415 8.75376 13.9417 8.75397C13.9419 8.75418 13.9421 8.75438 13.9423 8.75459C13.9425 8.75479 13.9427 8.755 13.943 8.7552C13.9432 8.75541 13.9434 8.75561 13.9436 8.75582C13.9438 8.75602 13.944 8.75622 13.9442 8.75643C13.9444 8.75663 13.9446 8.75684 13.9448 8.75704C13.945 8.75725 13.9452 8.75745 13.9454 8.75765C13.9456 8.75786 13.9458 8.75806 13.946 8.75826C13.9462 8.75847 13.9464 8.75867 13.9466 8.75887C13.9468 8.75908 13.947 8.75928 13.9472 8.75948C13.9474 8.75969 13.9476 8.75989 13.9478 8.76009C13.948 8.7603 13.9483 8.7605 13.9485 8.7607C13.9487 8.7609 13.9489 8.7611 13.9491 8.76131C13.9493 8.76151 13.9495 8.76171 13.9497 8.76191C13.9499 8.76211 13.9501 8.76231 13.9503 8.76252C13.9505 8.76272 13.9507 8.76292 13.9509 8.76312C13.9511 8.76332 13.9513 8.76352 13.9515 8.76372C13.9517 8.76392 13.9519 8.76412 13.9521 8.76432C13.9523 8.76453 13.9525 8.76473 13.9527 8.76493C13.9529 8.76513 13.9531 8.76533 13.9533 8.76553C13.9535 8.76572 13.9537 8.76592 13.9539 8.76612C13.9541 8.76632 13.9543 8.76652 13.9545 8.76672C13.9547 8.76692 13.9549 8.76712 13.9551 8.76732C13.9553 8.76752 13.9555 8.76772 13.9557 8.76791C13.9559 8.76811 13.9561 8.76831 13.9563 8.76851C13.9565 8.76871 13.9567 8.76891 13.9569 8.7691C13.9571 8.7693 13.9573 8.7695 13.9574 8.7697C13.9576 8.76989 13.9578 8.77009 13.958 8.77029C13.9582 8.77048 13.9584 8.77068 13.9586 8.77088C13.9588 8.77108 13.959 8.77127 13.9592 8.77147C13.9594 8.77166 13.9596 8.77186 13.9598 8.77206C13.96 8.77225 13.9602 8.77245 13.9604 8.77264C13.9606 8.77284 13.9608 8.77303 13.961 8.77323C13.9612 8.77343 13.9614 8.77362 13.9616 8.77382C13.9618 8.77401 13.962 8.7742 13.9622 8.7744C13.9623 8.77459 13.9625 8.77479 13.9627 8.77498C13.9629 8.77518 13.9631 8.77537 13.9633 8.77556C13.9635 8.77576 13.9637 8.77595 13.9639 8.77614C13.9641 8.77634 13.9643 8.77653 13.9645 8.77672C13.9647 8.77692 13.9649 8.77711 13.9651 8.7773C13.9652 8.77749 13.9654 8.77769 13.9656 8.77788C13.9658 8.77807 13.966 8.77826 13.9662 8.77846C13.9664 8.77865 13.9666 8.77884 13.9668 8.77903C13.967 8.77922 13.9672 8.77941 13.9674 8.7796C13.9675 8.7798 13.9677 8.77999 13.9679 8.78018C13.9681 8.78037 13.9683 8.78056 13.9685 8.78075C13.9687 8.78094 13.9689 8.78113 13.9691 8.78132C13.9693 8.78151 13.9694 8.7817 13.9696 8.78189L15.0303 7.72123C15.0301 7.72104 15.0299 7.72085 15.0297 7.72066C15.0295 7.72047 15.0294 7.72028 15.0292 7.72009C15.029 7.7199 15.0288 7.71971 15.0286 7.71952C15.0284 7.71933 15.0282 7.71914 15.028 7.71894C15.0278 7.71875 15.0276 7.71856 15.0274 7.71837C15.0273 7.71818 15.0271 7.71799 15.0269 7.7178C15.0267 7.7176 15.0265 7.71741 15.0263 7.71722C15.0261 7.71703 15.0259 7.71683 15.0257 7.71664C15.0255 7.71645 15.0253 7.71626 15.0251 7.71606C15.0249 7.71587 15.0248 7.71568 15.0246 7.71548C15.0244 7.71529 15.0242 7.7151 15.024 7.7149C15.0238 7.71471 15.0236 7.71452 15.0234 7.71432C15.0232 7.71413 15.023 7.71393 15.0228 7.71374C15.0226 7.71354 15.0224 7.71335 15.0222 7.71315C15.022 7.71296 15.0218 7.71277 15.0216 7.71257C15.0214 7.71237 15.0213 7.71218 15.0211 7.71198C15.0209 7.71179 15.0207 7.71159 15.0205 7.7114C15.0203 7.7112 15.0201 7.711 15.0199 7.71081C15.0197 7.71061 15.0195 7.71042 15.0193 7.71022C15.0191 7.71002 15.0189 7.70982 15.0187 7.70963C15.0185 7.70943 15.0183 7.70923 15.0181 7.70904C15.0179 7.70884 15.0177 7.70864 15.0175 7.70844C15.0173 7.70824 15.0171 7.70805 15.0169 7.70785C15.0167 7.70765 15.0165 7.70745 15.0163 7.70725C15.0161 7.70706 15.0159 7.70686 15.0157 7.70666C15.0155 7.70646 15.0153 7.70626 15.0151 7.70606C15.0149 7.70586 15.0147 7.70566 15.0145 7.70546C15.0143 7.70526 15.0141 7.70506 15.0139 7.70487C15.0137 7.70467 15.0135 7.70447 15.0133 7.70426C15.0131 7.70407 15.0129 7.70387 15.0127 7.70366C15.0125 7.70346 15.0123 7.70326 15.0121 7.70306C15.0119 7.70286 15.0117 7.70266 15.0115 7.70246C15.0113 7.70226 15.0111 7.70206 15.0109 7.70186C15.0107 7.70165 15.0105 7.70145 15.0103 7.70125C15.0101 7.70105 15.0099 7.70085 15.0097 7.70065C15.0095 7.70044 15.0093 7.70024 15.0091 7.70004C15.0089 7.69984 15.0087 7.69963 15.0085 7.69943C15.0083 7.69923 15.0081 7.69903 15.0079 7.69882C15.0077 7.69862 15.0075 7.69842 15.0073 7.69821C15.0071 7.69801 15.0069 7.69781 15.0067 7.6976C15.0065 7.6974 15.0063 7.6972 15.0061 7.69699C15.0059 7.69679 15.0057 7.69659 15.0055 7.69638C15.0053 7.69618 15.005 7.69597 15.0048 7.69577C15.0046 7.69556 15.0044 7.69536 15.0042 7.69516C15.004 7.69495 15.0038 7.69475 15.0036 7.69454C15.0034 7.69434 15.0032 7.69413 15.003 7.69393C15.0028 7.69372 15.0026 7.69352 15.0024 7.69331C15.0022 7.6931 15.002 7.6929 15.0018 7.69269C15.0016 7.69249 15.0014 7.69228 15.0011 7.69208C15.0009 7.69187 15.0007 7.69166 15.0005 7.69146C15.0003 7.69125 15.0001 7.69104 14.9999 7.69084C14.9997 7.69063 14.9995 7.69042 14.9993 7.69022C14.9991 7.69001 14.9989 7.6898 14.9987 7.6896C14.9985 7.68939 14.9983 7.68918 14.998 7.68898C14.9978 7.68877 14.9976 7.68856 14.9974 7.68835C14.9972 7.68815 14.997 7.68794 14.9968 7.68773C14.9966 7.68752 14.9964 7.68731 14.9962 7.68711C14.996 7.6869 14.9958 7.68669 14.9956 7.68648C14.9953 7.68627 14.9951 7.68606 14.9949 7.68586C14.9947 7.68565 14.9945 7.68544 14.9943 7.68523C14.9941 7.68502 14.9939 7.68481 14.9937 7.6846C14.9935 7.6844 14.9933 7.68419 14.9931 7.68398C14.9928 7.68377 14.9926 7.68356 14.9924 7.68335C14.9922 7.68314 14.992 7.68293 14.9918 7.68272C14.9916 7.68251 14.9914 7.6823 14.9912 7.68209C14.991 7.68188 14.9907 7.68167 14.9905 7.68146C14.9903 7.68125 14.9901 7.68104 14.9899 7.68083C14.9897 7.68062 14.9895 7.68041 14.9893 7.6802C14.9891 7.67999 14.9889 7.67978 14.9886 7.67957C14.9884 7.67936 14.9882 7.67915 14.988 7.67894C14.9878 7.67872 14.9876 7.67851 14.9874 7.6783C14.9872 7.67809 14.987 7.67788 14.9867 7.67767C14.9865 7.67746 14.9863 7.67725 14.9861 7.67703C14.9859 7.67682 14.9857 7.67661 14.9855 7.6764C14.9853 7.67619 14.985 7.67598 14.9848 7.67576C14.9846 7.67555 14.9844 7.67534 14.9842 7.67513C14.984 7.67492 14.9838 7.6747 14.9836 7.67449C14.9834 7.67428 14.9831 7.67407 14.9829 7.67386C14.9827 7.67364 14.9825 7.67343 14.9823 7.67322C14.9821 7.67301 14.9819 7.67279 14.9817 7.67258C14.9814 7.67237 14.9812 7.67216 14.981 7.67194C14.9808 7.67173 14.9806 7.67152 14.9804 7.6713C14.9802 7.67109 14.9799 7.67088 14.9797 7.67066C14.9795 7.67045 14.9793 7.67024 14.9791 7.67002C14.9789 7.66981 14.9787 7.6696 14.9785 7.66938C14.9782 7.66917 14.978 7.66896 14.9778 7.66874C14.9776 7.66853 14.9774 7.66831 14.9772 7.6681C14.977 7.66789 14.9767 7.66767 14.9765 7.66746C14.9763 7.66725 14.9761 7.66703 14.9759 7.66682C14.9757 7.6666 14.9755 7.66639 14.9752 7.66617C14.975 7.66596 14.9748 7.66575 14.9746 7.66553C14.9744 7.66532 14.9742 7.6651 14.974 7.66489C14.9737 7.66467 14.9735 7.66446 14.9733 7.66424C14.9731 7.66403 14.9729 7.66381 14.9727 7.6636C14.9725 7.66338 14.9722 7.66317 14.972 7.66295C14.9718 7.66274 14.9716 7.66252 14.9714 7.66231C14.9712 7.6621 14.971 7.66188 14.9707 7.66166C14.9705 7.66145 14.9703 7.66123 14.9701 7.66102C14.9699 7.6608 14.9697 7.66059 14.9694 7.66037C14.9692 7.66016 14.969 7.65994 14.9688 7.65973C14.9686 7.65951 14.9684 7.6593 14.9682 7.65908C14.9679 7.65886 14.9677 7.65865 14.9675 7.65843C14.9673 7.65822 14.9671 7.658 14.9669 7.65779C14.9666 7.65757 14.9664 7.65735 14.9662 7.65714C14.966 7.65692 14.9658 7.65671 14.9656 7.65649C14.9653 7.65627 14.9651 7.65606 14.9649 7.65584C14.9647 7.65563 14.9645 7.65541 14.9643 7.65519C14.964 7.65498 14.9638 7.65476 14.9636 7.65454C14.9634 7.65433 14.9632 7.65411 14.963 7.6539C14.9628 7.65368 14.9625 7.65346 14.9623 7.65325C14.9621 7.65303 14.9619 7.65281 14.9617 7.6526C14.9615 7.65238 14.9612 7.65216 14.961 7.65195C14.9608 7.65173 14.9606 7.65151 14.9604 7.6513C14.9602 7.65108 14.9599 7.65086 14.9597 7.65065C14.9595 7.65043 14.9593 7.65021 14.9591 7.65C14.9589 7.64978 14.9586 7.64956 14.9584 7.64935C14.9582 7.64913 14.958 7.64891 14.9578 7.6487C14.9576 7.64848 14.9573 7.64826 14.9571 7.64804C14.9569 7.64783 14.9567 7.64761 14.9565 7.64739C14.9562 7.64718 14.956 7.64696 14.9558 7.64674C14.9556 7.64653 14.9554 7.64631 14.9552 7.64609C14.9549 7.64587 14.9547 7.64566 14.9545 7.64544C14.9543 7.64522 14.9541 7.64501 14.9539 7.64479C14.9536 7.64457 14.9534 7.64435 14.9532 7.64414C14.953 7.64392 14.9528 7.6437 14.9526 7.64348C14.9523 7.64327 14.9521 7.64305 14.9519 7.64283C14.9517 7.64262 14.9515 7.6424 14.9513 7.64218C14.951 7.64196 14.9508 7.64175 14.9506 7.64153C14.9504 7.64131 14.9502 7.64109 14.95 7.64088C14.9497 7.64066 14.9495 7.64044 14.9493 7.64022C14.9491 7.64001 14.9489 7.63979 14.9486 7.63957C14.9484 7.63936 14.9482 7.63914 14.948 7.63892C14.9478 7.6387 14.9476 7.63849 14.9473 7.63827C14.9471 7.63805 14.9469 7.63783 14.9467 7.63762C14.9465 7.6374 14.9463 7.63718 14.946 7.63696C14.9458 7.63675 14.9456 7.63653 14.9454 7.63631C14.9452 7.63609 14.9449 7.63588 14.9447 7.63566C14.9445 7.63544 14.9443 7.63522 14.9441 7.63501C14.9439 7.63479 14.9436 7.63457 14.9434 7.63435C14.9432 7.63414 14.943 7.63392 14.9428 7.6337C14.9426 7.63348 14.9423 7.63327 14.9421 7.63305C14.9419 7.63283 14.9417 7.63262 14.9415 7.6324C14.9413 7.63218 14.941 7.63196 14.9408 7.63175C14.9406 7.63153 14.9404 7.63131 14.9402 7.63109C14.94 7.63088 14.9397 7.63066 14.9395 7.63044C14.9393 7.63022 14.9391 7.63001 14.9389 7.62979C14.9386 7.62957 14.9384 7.62936 14.9382 7.62914C14.938 7.62892 14.9378 7.6287 14.9376 7.62849C14.9373 7.62827 14.9371 7.62805 14.9369 7.62784C14.9367 7.62762 14.9365 7.6274 14.9363 7.62718C14.936 7.62697 14.9358 7.62675 14.9356 7.62653C14.9354 7.62632 14.9352 7.6261 14.935 7.62588C14.9347 7.62566 14.9345 7.62545 14.9343 7.62523C14.9341 7.62501 14.9339 7.6248 14.9337 7.62458C14.9334 7.62436 14.9332 7.62415 14.933 7.62393C14.9328 7.62371 14.9326 7.6235 14.9324 7.62328C14.9321 7.62306 14.9319 7.62285 14.9317 7.62263C14.9315 7.62241 14.9313 7.6222 14.9311 7.62198C14.9308 7.62176 14.9306 7.62155 14.9304 7.62133C14.9302 7.62111 14.93 7.6209 14.9298 7.62068C14.9295 7.62046 14.9293 7.62025 14.9291 7.62003C14.9289 7.61981 14.9287 7.6196 14.9285 7.61938C14.9282 7.61916 14.928 7.61895 14.9278 7.61873C14.9276 7.61852 14.9274 7.6183 14.9272 7.61808C14.9269 7.61787 14.9267 7.61765 14.9265 7.61744C14.9263 7.61722 14.9261 7.617 14.9259 7.61679C14.9256 7.61657 14.9254 7.61635 14.9252 7.61614C14.925 7.61592 14.9248 7.61571 14.9246 7.61549C14.9243 7.61528 14.9241 7.61506 14.9239 7.61484C14.9237 7.61463 14.9235 7.61441 14.9233 7.6142C14.9231 7.61398 14.9228 7.61377 14.9226 7.61355C14.9224 7.61333 14.9222 7.61312 14.922 7.6129C14.9218 7.61269 14.9215 7.61247 14.9213 7.61226C14.9211 7.61204 14.9209 7.61183 14.9207 7.61161C14.9205 7.6114 14.9203 7.61118 14.92 7.61097C14.9198 7.61075 14.9196 7.61054 14.9194 7.61032C14.9192 7.61011 14.919 7.60989 14.9188 7.60968C14.9185 7.60946 14.9183 7.60925 14.9181 7.60903C14.9179 7.60882 14.9177 7.6086 14.9175 7.60839C14.9172 7.60818 14.917 7.60796 14.9168 7.60775C14.9166 7.60753 14.9164 7.60732 14.9162 7.6071C14.916 7.60689 14.9157 7.60668 14.9155 7.60646C14.9153 7.60625 14.9151 7.60603 14.9149 7.60582C14.9147 7.60561 14.9145 7.60539 14.9143 7.60518C14.914 7.60496 14.9138 7.60475 14.9136 7.60454C14.9134 7.60432 14.9132 7.60411 14.913 7.6039C14.9128 7.60368 14.9125 7.60347 14.9123 7.60326C14.9121 7.60304 14.9119 7.60283 14.9117 7.60262C14.9115 7.6024 14.9113 7.60219 14.9111 7.60198C14.9108 7.60176 14.9106 7.60155 14.9104 7.60134C14.9102 7.60113 14.91 7.60091 14.9098 7.6007C14.9096 7.60049 14.9093 7.60027 14.9091 7.60006C14.9089 7.59985 14.9087 7.59964 14.9085 7.59942C14.9083 7.59921 14.9081 7.599 14.9079 7.59879C14.9076 7.59858 14.9074 7.59836 14.9072 7.59815C14.907 7.59794 14.9068 7.59773 14.9066 7.59752C14.9064 7.5973 14.9062 7.59709 14.906 7.59688C14.9057 7.59667 14.9055 7.59646 14.9053 7.59625C14.9051 7.59603 14.9049 7.59582 14.9047 7.59561C14.9045 7.5954 14.9043 7.59519 14.9041 7.59498C14.9038 7.59477 14.9036 7.59456 14.9034 7.59435C14.9032 7.59414 14.903 7.59392 14.9028 7.59371C14.9026 7.5935 14.9024 7.59329 14.9022 7.59308C14.9019 7.59287 14.9017 7.59266 14.9015 7.59245C14.9013 7.59224 14.9011 7.59203 14.9009 7.59182C14.9007 7.59161 14.9005 7.5914 14.9003 7.59119C14.9001 7.59098 14.8998 7.59077 14.8996 7.59056C14.8994 7.59035 14.8992 7.59014 14.899 7.58993C14.8988 7.58972 14.8986 7.58952 14.8984 7.58931C14.8982 7.5891 14.898 7.58889 14.8978 7.58868C14.8975 7.58847 14.8973 7.58826 14.8971 7.58805C14.8969 7.58784 14.8967 7.58764 14.8965 7.58743C14.8963 7.58722 14.8961 7.58701 14.8959 7.5868C14.8957 7.58659 14.8955 7.58639 14.8953 7.58618C14.895 7.58597 14.8948 7.58576 14.8946 7.58556C14.8944 7.58535 14.8942 7.58514 14.894 7.58493C14.8938 7.58473 14.8936 7.58452 14.8934 7.58431C14.8932 7.5841 14.893 7.5839 14.8928 7.58369C14.8926 7.58348 14.8923 7.58328 14.8921 7.58307C14.8919 7.58286 14.8917 7.58266 14.8915 7.58245C14.8913 7.58224 14.8911 7.58204 14.8909 7.58183C14.8907 7.58162 14.8905 7.58142 14.8903 7.58121C14.8901 7.58101 14.8899 7.5808 14.8897 7.58059C14.8895 7.58039 14.8893 7.58018 14.8891 7.57998C14.8888 7.57977 14.8886 7.57957 14.8884 7.57936C14.8882 7.57916 14.888 7.57895 14.8878 7.57875C14.8876 7.57854 14.8874 7.57834 14.8872 7.57813C14.887 7.57793 14.8868 7.57772 14.8866 7.57752C14.8864 7.57732 14.8862 7.57711 14.886 7.57691C14.8858 7.5767 14.8856 7.5765 14.8854 7.5763C14.8852 7.57609 14.885 7.57589 14.8848 7.57569C14.8846 7.57548 14.8844 7.57528 14.8841 7.57508C14.8839 7.57487 14.8837 7.57467 14.8835 7.57447C14.8833 7.57426 14.8831 7.57406 14.8829 7.57386C14.8827 7.57366 14.8825 7.57345 14.8823 7.57325C14.8821 7.57305 14.8819 7.57285 14.8817 7.57265C14.8815 7.57244 14.8813 7.57224 14.8811 7.57204C14.8809 7.57184 14.8807 7.57164 14.8805 7.57144C14.8803 7.57123 14.8801 7.57103 14.8799 7.57083C14.8797 7.57063 14.8795 7.57043 14.8793 7.57023C14.8791 7.57003 14.8789 7.56983 14.8787 7.56963C14.8785 7.56943 14.8783 7.56923 14.8781 7.56903C14.8779 7.56883 14.8777 7.56863 14.8775 7.56843C14.8773 7.56823 14.8771 7.56803 14.8769 7.56783C14.8767 7.56763 14.8765 7.56743 14.8763 7.56723C14.8761 7.56703 14.8759 7.56684 14.8757 7.56664C14.8755 7.56644 14.8753 7.56624 14.8751 7.56604C14.8749 7.56584 14.8747 7.56564 14.8745 7.56545C14.8743 7.56525 14.8741 7.56505 14.8739 7.56485C14.8737 7.56466 14.8735 7.56446 14.8733 7.56426C14.8731 7.56406 14.8729 7.56387 14.8727 7.56367C14.8725 7.56347 14.8723 7.56328 14.8722 7.56308C14.872 7.56288 14.8718 7.56269 14.8716 7.56249C14.8714 7.56229 14.8712 7.5621 14.871 7.5619C14.8708 7.56171 14.8706 7.56151 14.8704 7.56131C14.8702 7.56112 14.87 7.56092 14.8698 7.56073C14.8696 7.56053 14.8694 7.56034 14.8692 7.56014C14.869 7.55995 14.8688 7.55976 14.8686 7.55956C14.8684 7.55937 14.8682 7.55917 14.8681 7.55898C14.8679 7.55878 14.8677 7.55859 14.8675 7.5584C14.8673 7.5582 14.8671 7.55801 14.8669 7.55782C14.8667 7.55762 14.8665 7.55743 14.8663 7.55724C14.8661 7.55704 14.8659 7.55685 14.8657 7.55666C14.8655 7.55647 14.8653 7.55627 14.8652 7.55608C14.865 7.55589 14.8648 7.5557 14.8646 7.55551C14.8644 7.55532 14.8642 7.55512 14.864 7.55493C14.8638 7.55474 14.8636 7.55455 14.8634 7.55436C14.8632 7.55417 14.8631 7.55398 14.8629 7.55379C14.8627 7.5536 14.8625 7.55341 14.8623 7.55322C14.8621 7.55303 14.8619 7.55284 14.8617 7.55265C14.8615 7.55246 14.8613 7.55227 14.8612 7.55208C14.861 7.55189 14.8608 7.5517 14.8606 7.55151C14.8604 7.55132 14.8602 7.55113 14.86 7.55095C14.8598 7.55076 14.8596 7.55057 14.8595 7.55038C14.8593 7.55019 14.8591 7.55001 14.8589 7.54982C14.8587 7.54963 14.8585 7.54944 14.8583 7.54926C14.8581 7.54907 14.858 7.54888 14.8578 7.5487C14.8576 7.54851 14.8574 7.54832 14.8572 7.54814C14.857 7.54795 14.8568 7.54776 14.8567 7.54758C14.8565 7.54739 14.8563 7.54721 14.8561 7.54702C14.8559 7.54684 14.8557 7.54665 14.8555 7.54647C14.8554 7.54628 14.8552 7.5461 14.855 7.54591C14.8548 7.54573 14.8546 7.54554 14.8544 7.54536C14.8542 7.54518 14.8541 7.54499 14.8539 7.54481C14.8537 7.54462 14.8535 7.54444 14.8533 7.54426C14.8531 7.54408 14.853 7.54389 14.8528 7.54371C14.8526 7.54353 14.8524 7.54334 14.8522 7.54316C14.8521 7.54298 14.8519 7.5428 14.8517 7.54262C14.8515 7.54243 14.8513 7.54225 14.8511 7.54207C14.851 7.54189 14.8508 7.54171 14.8506 7.54153C14.8504 7.54135 14.8502 7.54117 14.8501 7.54099C14.8499 7.54081 14.8497 7.54063 14.8495 7.54045C14.8493 7.54027 14.8492 7.54009 14.849 7.53991C14.8488 7.53973 14.8486 7.53955 14.8484 7.53937C14.8483 7.53919 14.8481 7.53901 14.8479 7.53884C14.8477 7.53866 14.8476 7.53848 14.8474 7.5383C14.8472 7.53812 14.847 7.53795 14.8468 7.53777C14.8467 7.53759 14.8465 7.53741 14.8463 7.53724C14.8461 7.53706 14.846 7.53688 14.8458 7.53671C14.8456 7.53653 14.8454 7.53635 14.8453 7.53618C14.8451 7.536 14.8449 7.53583 14.8447 7.53565C14.8445 7.53548 14.8444 7.5353 14.8442 7.53513C14.844 7.53495 14.8438 7.53478 14.8437 7.5346C14.8435 7.53443 14.8433 7.53425 14.8432 7.53408C14.843 7.53391 14.8428 7.53373 14.8426 7.53356C14.8425 7.53339 14.8423 7.53321 14.8421 7.53304C14.8419 7.53287 14.8418 7.53269 14.8416 7.53252C14.8414 7.53235 14.8413 7.53218 14.8411 7.53201C14.8409 7.53184 14.8407 7.53166 14.8406 7.53149C14.8404 7.53132 14.8402 7.53115 14.8401 7.53098C14.8399 7.53081 14.8397 7.53064 14.8395 7.53047C14.8394 7.5303 14.8392 7.53013 14.839 7.52996C14.8389 7.52979 14.8387 7.52962 14.8385 7.52945C14.8384 7.52928 14.8382 7.52911 14.838 7.52894C14.8378 7.52878 14.8377 7.52861 14.8375 7.52844C14.8373 7.52827 14.8372 7.5281 14.837 7.52794C14.8368 7.52777 14.8367 7.5276 14.8365 7.52744C14.8363 7.52727 14.8362 7.5271 14.836 7.52694C14.8358 7.52677 14.8357 7.5266 14.8355 7.52644C14.8353 7.52627 14.8352 7.52611 14.835 7.52594C14.8348 7.52578 14.8347 7.52561 14.8345 7.52545C14.8344 7.52528 14.8342 7.52512 14.834 7.52495C14.8339 7.52479 14.8337 7.52463 14.8335 7.52446C14.8334 7.5243 14.8332 7.52414 14.833 7.52397C14.8329 7.52381 14.8327 7.52365 14.8326 7.52349C14.8324 7.52332 14.8322 7.52316 14.8321 7.523C14.8319 7.52284 14.8317 7.52268 14.8316 7.52251C14.8314 7.52235 14.8313 7.52219 14.8311 7.52203C14.8309 7.52187 14.8308 7.52171 14.8306 7.52155C14.8305 7.52139 14.8303 7.52123 14.8301 7.52107C14.83 7.52091 14.8298 7.52075 14.8297 7.5206C14.8295 7.52044 14.8294 7.52028 14.8292 7.52012C14.829 7.51996 14.8289 7.5198 14.8287 7.51965C14.8286 7.51949 14.8284 7.51933 14.8282 7.51917C14.8281 7.51902 14.8279 7.51886 14.8278 7.5187C14.8276 7.51855 14.8275 7.51839 14.8273 7.51824C14.8272 7.51808 14.827 7.51793 14.8268 7.51777C14.8267 7.51762 14.8265 7.51746 14.8264 7.51731C14.8262 7.51715 14.8261 7.517 14.8259 7.51684C14.8258 7.51669 14.8256 7.51654 14.8255 7.51638C14.8253 7.51623 14.8252 7.51608 14.825 7.51592C14.8248 7.51577 14.8247 7.51562 14.8245 7.51547C14.8244 7.51532 14.8242 7.51516 14.8241 7.51501C14.8239 7.51486 14.8238 7.51471 14.8236 7.51456C14.8235 7.51441 14.8233 7.51426 14.8232 7.51411C14.823 7.51396 14.8229 7.51381 14.8227 7.51366C14.8226 7.51351 14.8224 7.51336 14.8223 7.51321C14.8221 7.51306 14.822 7.51291 14.8218 7.51277C14.8217 7.51262 14.8215 7.51247 14.8214 7.51232C14.8212 7.51218 14.8211 7.51203 14.821 7.51188C14.8208 7.51173 14.8207 7.51159 14.8205 7.51144C14.8204 7.5113 14.8202 7.51115 14.8201 7.51101C14.8199 7.51086 14.8198 7.51071 14.8196 7.51057C14.8195 7.51042 14.8194 7.51028 14.8192 7.51014C14.8191 7.50999 14.8189 7.50985 14.8188 7.5097C14.8186 7.50956 14.8185 7.50942 14.8183 7.50928C14.8182 7.50913 14.8181 7.50899 14.8179 7.50885C14.8178 7.50871 14.8176 7.50856 14.8175 7.50842C14.8174 7.50828 14.8172 7.50814 14.8171 7.508C14.8169 7.50786 14.8168 7.50772 14.8167 7.50758C14.8165 7.50744 14.8164 7.5073 14.8162 7.50716C14.8161 7.50702 14.816 7.50688 14.8158 7.50674C14.8157 7.5066 14.8155 7.50646 14.8154 7.50633C14.8153 7.50619 14.8151 7.50605 14.815 7.50591C14.8148 7.50578 14.8147 7.50564 14.8146 7.5055C14.8144 7.50537 14.8143 7.50523 14.8142 7.50509C14.814 7.50496 14.8139 7.50482 14.8138 7.50469C14.8136 7.50455 14.8135 7.50442 14.8134 7.50428C14.8132 7.50415 14.8131 7.50401 14.813 7.50388C14.8128 7.50375 14.8127 7.50361 14.8126 7.50348C14.8124 7.50335 14.8123 7.50322 14.8122 7.50308C14.812 7.50295 14.8119 7.50282 14.8118 7.50269C14.8116 7.50255 14.8115 7.50242 14.8114 7.50229C14.8112 7.50216 14.8111 7.50203 14.811 7.5019C14.8108 7.50177 14.8107 7.50164 14.8106 7.50151C14.8105 7.50138 14.8103 7.50125 14.8102 7.50113C14.8101 7.501 14.8099 7.50087 14.8098 7.50074C14.8097 7.50061 14.8096 7.50048 14.8094 7.50036C14.8093 7.50023 14.8092 7.5001 14.8091 7.49998C14.8089 7.49985 14.8088 7.49972 14.8087 7.4996C14.8085 7.49947 14.8084 7.49935 14.8083 7.49922C14.8082 7.4991 14.808 7.49897 14.8079 7.49885C14.8078 7.49873 14.8077 7.4986 14.8076 7.49848C14.8074 7.49835 14.8073 7.49823 14.8072 7.49811C14.8071 7.49799 14.8069 7.49786 14.8068 7.49774C14.8067 7.49762 14.8066 7.4975 14.8065 7.49738C14.8063 7.49726 14.8062 7.49714 14.8061 7.49702C14.806 7.49689 14.8058 7.49678 14.8057 7.49665C14.8056 7.49654 14.8055 7.49642 14.8054 7.4963C14.8053 7.49618 14.8051 7.49606 14.805 7.49594C14.8049 7.49582 14.8048 7.49571 14.8047 7.49559C14.8045 7.49547 14.8044 7.49535 14.8043 7.49524C14.8042 7.49512 14.8041 7.49501 14.804 7.49489C14.8038 7.49477 14.8037 7.49466 14.8036 7.49454C14.8035 7.49443 14.8034 7.49431 14.8033 7.4942C14.8032 7.49409 14.803 7.49397 14.8029 7.49386C14.8028 7.49375 14.8027 7.49363 14.8026 7.49352C14.8025 7.49341 14.8024 7.4933 14.8023 7.49318C14.8021 7.49307 14.802 7.49296 14.8019 7.49285C14.8018 7.49274 14.8017 7.49263 14.8016 7.49252C14.8015 7.49241 14.8014 7.4923 14.8013 7.49219C14.8012 7.49208 14.801 7.49197 14.8009 7.49186C14.8008 7.49176 14.8007 7.49165 14.8006 7.49154C14.8005 7.49143 14.8004 7.49132 14.8003 7.49122C14.8002 7.49111 14.8001 7.49101 14.8 7.4909C14.7999 7.49079 14.7998 7.49069 14.7997 7.49058C14.7996 7.49048 14.7994 7.49037 14.7993 7.49027C14.7992 7.49016 14.7991 7.49006 14.799 7.48996C14.7989 7.48985 14.7988 7.48975 14.7987 7.48965C14.7986 7.48954 14.7985 7.48944 14.7984 7.48934C14.7983 7.48924 14.7982 7.48914 14.7981 7.48904C14.798 7.48894 14.7979 7.48884 14.7978 7.48873C14.7977 7.48863 14.7976 7.48854 14.7975 7.48844C14.7974 7.48834 14.7973 7.48824 14.7972 7.48814C14.7971 7.48804 14.797 7.48794 14.7969 7.48785C14.7968 7.48775 14.7967 7.48765 14.7966 7.48755C14.7965 7.48746 14.7964 7.48736 14.7963 7.48726C14.7962 7.48717 14.7961 7.48707 14.7961 7.48698C14.796 7.48688 14.7959 7.48679 14.7958 7.48669C14.7957 7.4866 14.7956 7.48651 14.7955 7.48641C14.7954 7.48632 14.7953 7.48623 14.7952 7.48614C14.7951 7.48604 14.795 7.48595 14.7949 7.48586C14.7948 7.48577 14.7948 7.48568 14.7947 7.48559C14.7946 7.4855 14.7945 7.48541 14.7944 7.48532C14.7943 7.48523 14.7942 7.48514 14.7941 7.48505C14.794 7.48496 14.7939 7.48487 14.7939 7.48478C14.7938 7.4847 14.7937 7.48461 14.7936 7.48452C14.7935 7.48443 14.7934 7.48435 14.7933 7.48426C14.7932 7.48417 14.7932 7.48409 14.7931 7.484C14.793 7.48392 14.7929 7.48383 14.7928 7.48375C14.7927 7.48366 14.7927 7.48358 14.7926 7.4835C14.7925 7.48341 14.7924 7.48333 14.7923 7.48325C14.7922 7.48317 14.7922 7.48308 14.7921 7.483C14.792 7.48292 14.7919 7.48284 14.7918 7.48276C14.7918 7.48268 14.7917 7.4826 14.7916 7.48252C14.7915 7.48244 14.7914 7.48236 14.7914 7.48228C14.7913 7.4822 14.7912 7.48212 14.7911 7.48204C14.791 7.48197 14.791 7.48189 14.7909 7.48181C14.7908 7.48173 14.7907 7.48166 14.7907 7.48158C14.7906 7.48151 14.7905 7.48143 14.7904 7.48136C14.7904 7.48128 14.7903 7.48121 14.7902 7.48113C14.7901 7.48106 14.7901 7.48098 14.79 7.48091C14.7899 7.48084 14.7898 7.48076 14.7898 7.48069C14.7897 7.48062 14.7896 7.48055 14.7895 7.48048C14.7895 7.4804 14.7894 7.48033 14.7893 7.48026C14.7893 7.48019 14.7892 7.48012 14.7891 7.48005C14.7891 7.47998 14.789 7.47991 14.7889 7.47985C14.7889 7.47978 14.7888 7.47971 14.7887 7.47964C14.7886 7.47957 14.7886 7.47951 14.7885 7.47944C14.7884 7.47937 14.7884 7.47931 14.7883 7.47924C14.7882 7.47918 14.7882 7.47911 14.7881 7.47905C14.7881 7.47898 14.788 7.47892 14.7879 7.47885C14.7879 7.47879 14.7878 7.47873 14.7877 7.47866C14.7877 7.4786 14.7876 7.47854 14.7875 7.47848C14.7875 7.47842 14.7874 7.47835 14.7874 7.47829C14.7873 7.47823 14.7872 7.47817 14.7872 7.47811C14.7871 7.47805 14.7871 7.47799 14.787 7.47793C14.7869 7.47788 14.7869 7.47782 14.7868 7.47776C14.7868 7.4777 14.7867 7.47764 14.7867 7.47759C14.7866 7.47753 14.7865 7.47747 14.7865 7.47742C14.7864 7.47736 14.7864 7.47731 14.7863 7.47725C14.7863 7.4772 14.7862 7.47714 14.7862 7.47709C14.7861 7.47703 14.7861 7.47698 14.786 7.47693C14.7859 7.47687 14.7859 7.47682 14.7858 7.47677C14.7858 7.47672 14.7857 7.47667 14.7857 7.47662C14.7856 7.47657 14.7856 7.47652 14.7855 7.47647C14.7855 7.47642 14.7854 7.47637 14.7854 7.47632C14.7853 7.47627 14.7853 7.47622 14.7852 7.47617C14.7852 7.47612 14.7852 7.47608 14.7851 7.47603C14.7851 7.47598 14.785 7.47594 14.785 7.47589C14.7849 7.47585 14.7849 7.4758 14.7848 7.47576C14.7848 7.47571 14.7847 7.47567 14.7847 7.47562C14.7847 7.47558 14.7846 7.47554 14.7846 7.47549C14.7845 7.47545 14.7845 7.47541 14.7844 7.47537C14.7844 7.47533 14.7844 7.47528 14.7843 7.47524C14.7843 7.4752 14.7842 7.47516 14.7842 7.47512C14.7842 7.47508 14.7841 7.47504 14.7841 7.47501C14.784 7.47497 14.784 7.47493 14.784 7.47489C14.7839 7.47485 14.7839 7.47482 14.7839 7.47478C14.7838 7.47474 14.7838 7.47471 14.7837 7.47467C14.7837 7.47464 14.7837 7.4746 14.7836 7.47457C14.7836 7.47453 14.7836 7.4745 14.7835 7.47447C14.7835 7.47443 14.7835 7.4744 14.7834 7.47437C14.7834 7.47434 14.7834 7.47431 14.7833 7.47427C14.7833 7.47424 14.7833 7.47421 14.7833 7.47418C14.7832 7.47415 14.7832 7.47412 14.7832 7.47409C14.7831 7.47406 14.7831 7.47404 14.7831 7.47401C14.7831 7.47398 14.783 7.47395 14.783 7.47393C14.783 7.4739 14.7829 7.47387 14.7829 7.47385C14.7829 7.47382 14.7829 7.4738 14.7828 7.47377C14.7828 7.47375 14.7828 7.47372 14.7828 7.4737C14.7827 7.47368 14.7827 7.47365 14.7827 7.47363C14.7827 7.47361 14.7827 7.47359 14.7826 7.47356C14.7826 7.47354 14.7826 7.47352 14.7826 7.4735C14.7826 7.47348 14.7825 7.47346 14.7825 7.47344C14.7825 7.47342 14.7825 7.47341 14.7825 7.47339C14.7824 7.47337 14.7824 7.47335 14.7824 7.47333C14.7824 7.47332 14.7824 7.4733 14.7824 7.47329C14.7823 7.47327 14.7823 7.47325 14.7823 7.47324C14.7823 7.47322 14.7823 7.47321 14.7823 7.4732C14.7823 7.47318 14.7822 7.47317 14.7822 7.47316C14.7822 7.47315 14.7822 7.47313 14.7822 7.47312C14.7822 7.47311 14.7822 7.4731 14.7822 7.47309C14.7822 7.47308 14.7821 7.47307 14.7821 7.47306C14.7821 7.47305 14.7821 7.47304 14.7821 7.47303C14.7821 7.47303 14.7821 7.47302 14.7821 7.47301C14.7821 7.47301 14.7821 7.473 14.7821 7.47299C14.7821 7.47299 14.7821 7.47298 14.7821 7.47298C14.782 7.47297 14.782 7.47297 14.782 7.47297C14.782 7.47296 14.782 7.47296 14.782 7.47296C14.782 7.47295 14.782 7.47295 14.782 7.47295C14.782 7.47295 14.782 7.47295 14.2517 8.00328ZM2.63001 9.3213C2.45431 9.14559 2.45427 8.86072 2.62994 8.68497L1.56905 7.62455C0.807815 8.38612 0.80795 9.62055 1.56935 10.382L2.63001 9.3213ZM7.56972 13.6246C7.39398 13.8003 7.10906 13.8003 6.93332 13.6246L5.87266 14.6853C6.63418 15.4468 7.86885 15.4468 8.63038 14.6853L7.56972 13.6246Z" }),
            React__default.createElement("path", { d: "M13.4212 13.6839L15 10L16.5788 13.6839C16.8367 14.2856 16.7302 14.9815 16.3042 15.4784C15.6187 16.2782 14.3813 16.2782 13.6958 15.4784C13.2698 14.9815 13.1633 14.2856 13.4212 13.6839Z" }))),
        position: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_2763_46009)" },
                React__default.createElement("path", { d: "M1.78284 6.04191L8.66697 7.05953C8.79506 7.07847 8.89278 7.18261 8.90354 7.31164L9.48164 14.2465", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M1.76332 6.02604L14.4544 1.51971C14.6684 1.44371 14.8704 1.65896 14.7809 1.86773C14.6915 2.07651 9.47724 14.2468 9.47724 14.2468", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_2763_46009" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        pfr: (React__default.createElement("svg", { style: style, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1083_34788)" },
                React__default.createElement("path", { d: "M6.71937 5.94162C6.71937 8.13458 8.62767 9.02035 10.3195 9.02035M6.71937 5.94162C6.71937 3.74866 8.62767 2.84711 10.3195 2.84711C12.0113 2.84711 14.0612 3.72317 14.0612 5.93373M6.71937 5.94162H5.95718M5.95718 15.0508V5.94162M3.75 11.5625C1.80758 11.5625 0.9375 10.3587 0.9375 8.74997C0.9375 7.1412 2.24167 5.94162 3.85044 5.94162H5.95718M10.3195 9.02035C12.0113 9.02035 14.0612 8.1443 14.0612 5.93373M10.3195 9.02035L10.3155 13.7919C10.3155 10.6921 10.3155 8.37605 10.3155 5.94162C10.3155 4.90116 10.3155 3.83908 10.3155 2.68493M14.0612 5.93373L16.1496 5.93749C17.7583 5.93749 19.0625 7.14121 19.0625 8.74999C19.0625 10.3588 17.7583 11.5625 16.1496 11.5625C16.1496 11.5625 16.1496 11.5625 16.1496 11.5625C16.1496 11.5625 14.6726 11.5625 13.75 11.5625M10.3155 2.68493C10.3155 1.8474 10.3155 0.961398 10.3155 0V2.68493Z", stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : 'white', strokeWidth: "1.5" }),
                React__default.createElement("path", { d: "M2.4707 18.4451L15.4407 15.683M14.0612 17.8298L19.8096 16.6211", stroke: strokeThird !== null && strokeThird !== void 0 ? strokeThird : 'white', strokeWidth: "1.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1083_34788" },
                    React__default.createElement("rect", { width: "20", height: "20", fill: "white" }))))),
        fns: (React__default.createElement("svg", { style: style, width: iconStroke ? '16' : '40', height: iconStroke ? '16' : '41', viewBox: iconStroke ? '0 0 16 16' : '0 0 40 41', fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_301_19663)" }, iconStroke ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.10377 1.62539C5.27033 1.51871 5.53203 1.47675 5.79377 1.52217C5.89334 1.53944 5.96968 1.56582 6.01943 1.58915C6.03747 1.65451 6.05814 1.73447 6.0808 1.82549H7.62393C7.54702 1.49947 7.4699 1.18881 7.41263 1.01234C7.29689 0.655733 7.0208 0.435052 6.81022 0.311809C6.58172 0.178071 6.31613 0.0903862 6.05019 0.0442452C5.52956 -0.0460851 4.8604 -2.64472e-05 4.29474 0.362277L5.10377 1.62539ZM7.83159 3.32549H6.43184C6.47162 3.49241 6.50653 3.63167 6.53167 3.71547L7.83159 3.32549ZM3.9491 2.38795L2.58171 1.16829C1.96756 0.620494 1.0019 0.805752 0.633088 1.53918L0.140936 2.48026L0.13668 2.48839L0.132624 2.49663C0.0679996 2.62794 0.0396678 2.76522 0.0268215 2.83702C0.0117538 2.92123 1.03011e-05 3.02198 1.03011e-05 3.11632V5.8787C1.03011e-05 6.07788 0.0476061 6.27417 0.138832 6.45122L0.80317 6.10893L0.138832 6.45123C0.551032 7.25124 0.902802 7.85253 1.3808 8.3641C1.86211 8.8792 2.43368 9.26379 3.22273 9.70127L3.22966 9.70575L3.23678 9.71041L3.24588 9.71634C3.55897 9.91996 3.94556 9.97206 4.29909 9.86186L4.2788 9.84519C3.94832 9.57377 3.7432 9.16941 3.7432 8.72742V8.27279C3.13177 7.92186 2.76805 7.6517 2.47681 7.34001C2.1562 6.99688 1.88713 6.56522 1.50001 5.81794V3.12522L1.5001 3.12433L1.50104 3.11631L1.82269 2.50127L3.7432 4.2143V3.07549C3.7432 2.8215 3.81896 2.5852 3.9491 2.38795ZM5.2432 5.22762V3.54224L6.08041 4.289L5.2432 5.22762ZM4.72183 10.2091L3.09922 11.8387L1.3432 9.54411C1.09147 9.21517 0.620736 9.15258 0.291794 9.40431C-0.0371487 9.65604 -0.0997393 10.1268 0.151994 10.4557L2.42958 13.4319L3.40444 14.7057C3.65617 15.0347 4.1269 15.0972 4.45584 14.8455C4.78478 14.5938 4.84737 14.1231 4.59564 13.7941L4.01912 13.0408L5.88632 11.1654L4.72183 10.2091ZM6.94953 10.0976L5.78505 9.14121L6.26992 8.65423C6.56218 8.3607 7.03705 8.35967 7.33058 8.65193C7.62411 8.94418 7.62514 9.41906 7.33288 9.71259L6.94953 10.0976ZM6.19186 11.4164L5.85985 11.8603C5.85174 11.8711 5.84393 11.8822 5.83641 11.8934C5.36932 12.5941 5.4674 13.528 6.06986 14.1163L7.47623 15.4896L8.00023 16.0012L8.52421 15.4895L9.93049 14.1162C10.5329 13.528 10.631 12.5941 10.1639 11.8935C10.1565 11.8823 10.1487 11.8713 10.1407 11.8606L9.8091 11.4169L8.64872 12.3699L8.92301 12.7369C8.9814 12.8356 8.96531 12.9622 8.88248 13.0431L8.00019 13.9047L7.11782 13.0431C7.03501 12.9622 7.01891 12.8356 7.07724 12.737L7.35222 12.3694L6.19186 11.4164ZM7.81289 10.8067L7.58177 10.6169C7.61551 10.6348 7.64831 10.6555 7.67986 10.6791C7.73039 10.7169 7.7748 10.7599 7.81289 10.8067ZM8.18712 10.8079L8.42066 10.6161C8.38652 10.6342 8.35333 10.6551 8.32143 10.6789C8.27034 10.7171 8.22551 10.7605 8.18712 10.8079ZM10.1392 11.1457L11.0643 12.2143C11.0224 12.386 11.0001 12.5654 11.0001 12.7499C11.0001 13.9926 12.0075 14.9999 13.2501 14.9999C14.4928 14.9999 15.5001 13.9926 15.5001 12.7499C15.5001 11.5073 14.4928 10.4999 13.2501 10.4999C12.7581 10.4999 12.3031 10.6578 11.9327 10.9257L11.2988 10.1934L10.1392 11.1457ZM10.3167 9.05889L9.15718 10.0112L8.76449 9.55758C8.4934 9.24441 8.52751 8.77076 8.84069 8.49966C9.15386 8.22857 9.62751 8.26268 9.89861 8.57586L10.3167 9.05889ZM12.2583 8.27069C12.8676 7.92078 13.2304 7.65108 13.5211 7.34001C13.8417 6.99688 14.1107 6.56522 14.4979 5.81794V3.17451L14.1692 2.50665L12.2583 4.21102V3.07549C12.2583 2.82061 12.1821 2.58355 12.0511 2.3859L13.4162 1.16829C14.0331 0.618023 15.0047 0.807441 15.3697 1.54915L15.8694 2.56434C15.9539 2.73606 15.9979 2.92491 15.9979 3.11632V5.8787C15.9979 6.07789 15.9503 6.27418 15.859 6.45123C15.4468 7.25124 15.0951 7.85253 14.6171 8.3641C14.1358 8.87921 13.5642 9.26379 12.7751 9.70127L12.7682 9.70575L12.7611 9.71041L12.752 9.71634C12.4397 9.91945 12.0542 9.9718 11.7014 9.86269L11.7227 9.84519C12.0532 9.57377 12.2583 9.16941 12.2583 8.72742V8.27069ZM10.7583 3.53897V5.23174L9.91745 4.289L10.7583 3.53897ZM9.56825 3.32549C9.52846 3.49242 9.49355 3.63168 9.46841 3.71547L8.16848 3.32549H9.56825ZM9.91936 1.82549H8.37621C8.45313 1.49948 8.53026 1.18883 8.58753 1.01237C8.70326 0.655765 8.97935 0.435084 9.18993 0.311841C9.41844 0.178103 9.68402 0.0904183 9.94996 0.0442773C10.4706 -0.0460529 11.1398 5.73928e-06 11.7054 0.362309L10.8964 1.62543C10.7298 1.51875 10.4681 1.47678 10.2064 1.5222C10.1068 1.53947 10.0305 1.56585 9.98072 1.58918C9.96268 1.65454 9.94201 1.73448 9.91936 1.82549ZM6.07526 1.62173C6.07503 1.6218 6.07243 1.62002 6.06815 1.61617C6.07335 1.61973 6.07549 1.62165 6.07526 1.62173ZM9.9249 1.62176C9.92467 1.62169 9.92681 1.61976 9.932 1.6162C9.92772 1.62005 9.92513 1.62183 9.9249 1.62176ZM12.5001 12.7499C12.5001 12.3357 12.8359 11.9999 13.2501 11.9999C13.6643 11.9999 14.0001 12.3357 14.0001 12.7499C14.0001 13.1642 13.6643 13.4999 13.2501 13.4999C12.8359 13.4999 12.5001 13.1642 12.5001 12.7499Z", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : 'white' }),
                React__default.createElement("path", { d: "M5.75146 4.25439C5.75146 3.97825 5.97532 3.75439 6.25146 3.75439H9.75C10.0261 3.75439 10.25 3.97825 10.25 4.25439V8.02546C10.25 8.16825 10.189 8.30422 10.0822 8.39911L8.00073 10.2499L5.91922 8.39911C5.81252 8.30422 5.75146 8.16825 5.75146 8.02546V4.25439Z", stroke: strokeThird !== null && strokeThird !== void 0 ? strokeThird : 'white', strokeWidth: "1.5", strokeLinecap: "round" }))) : (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.6327 3.44226C13.8274 3.30253 12.9354 3.40982 12.2862 3.82564L11.2075 2.14148C12.3889 1.38484 13.8241 1.27208 14.9746 1.4717C15.5574 1.57282 16.1181 1.76195 16.5823 2.03366C17.0227 2.29138 17.5034 2.70018 17.698 3.29992C17.8869 3.88175 18.181 5.14119 18.446 6.29244C18.4832 6.45406 18.5199 6.61364 18.5557 6.76971C18.7874 7.77837 18.9854 8.64071 19.0817 8.96149L17.166 9.53619C17.0489 9.1459 16.8324 8.20212 16.6063 7.21686C16.57 7.05863 16.5334 6.89932 16.497 6.74108C16.2253 5.56093 15.9586 4.42879 15.8029 3.93965C15.794 3.92886 15.7415 3.85892 15.5721 3.75977C15.3525 3.63122 15.0279 3.51083 14.6327 3.44226ZM25.0232 1.47178C26.1738 1.27216 27.609 1.38492 28.7903 2.14156L27.7116 3.82572C27.0624 3.4099 26.1705 3.30261 25.3651 3.44234C24.9699 3.51091 24.6454 3.6313 24.4258 3.75985C24.2563 3.859 24.2039 3.92894 24.195 3.93973C24.0393 4.4289 23.7725 5.56105 23.5008 6.74116C23.4643 6.8995 23.4277 7.0589 23.3914 7.21722C23.1653 8.20237 22.9487 9.14596 22.8317 9.53619L20.916 8.96149C21.0122 8.64068 21.2103 7.77833 21.442 6.76969C21.4779 6.61362 21.5145 6.45405 21.5517 6.29244C21.8168 5.14119 22.111 3.8818 22.2998 3.3C22.4945 2.70026 22.9752 2.29146 23.4155 2.03374C23.8798 1.76203 24.4404 1.5729 25.0232 1.47178ZM4.53928 5.56522C4.4159 5.45517 4.22157 5.49305 4.14856 5.64139L4.14316 5.65238L2.91923 7.99272C2.91893 7.99376 2.91862 7.99487 2.91829 7.99603C2.91166 8.01976 2.90358 8.05464 2.89584 8.09789C2.88824 8.14038 2.88232 8.18338 2.87845 8.22143C2.87438 8.26154 2.87376 8.28473 2.87376 8.28975V15.1957C2.87376 15.2355 2.88328 15.2748 2.90152 15.3102C3.91274 17.2728 4.64351 18.4747 5.55142 19.4463C6.45314 20.4114 7.57927 21.2016 9.46526 22.2463L9.4682 22.248C9.4809 22.2501 9.49622 22.2526 9.51442 22.2553C9.58784 22.266 9.68509 22.2775 9.80682 22.2889C10.0501 22.3119 10.3637 22.3325 10.7291 22.3502C11.4583 22.3856 12.362 22.4078 13.2563 22.4162C14.1508 22.4246 15.0255 22.419 15.6969 22.3996C16.034 22.3899 16.3095 22.377 16.5066 22.3617C16.6063 22.3539 16.673 22.3466 16.7118 22.3409C16.7172 22.3401 16.7218 22.3394 16.7258 22.3387C16.6973 22.3454 16.6379 22.3621 16.5689 22.3953L16.6327 22.5279C16.9917 22.3854 17.4167 22.4589 17.7078 22.7488C18.0992 23.1385 18.1006 23.7716 17.7109 24.163L8.88694 33.0253L10.793 35.5159C11.1286 35.9545 11.0452 36.5822 10.6066 36.9178C10.168 37.2535 9.54034 37.17 9.20469 36.7314L1.07359 26.1064C0.737945 25.6678 0.821399 25.0402 1.25999 24.7046C1.69858 24.3689 2.32622 24.4524 2.66186 24.891L7.66041 31.4226L14.6349 24.4178C14.1897 24.4212 13.715 24.4206 13.2376 24.4161C12.3264 24.4076 11.3953 24.3849 10.6322 24.3479C10.2514 24.3294 9.90447 24.307 9.61914 24.2801C9.36125 24.2558 9.07423 24.2215 8.86253 24.16C8.74355 24.1254 8.65021 24.0799 8.5928 24.0497C8.56422 24.0346 8.53929 24.0204 8.52451 24.012L8.49611 23.9959C6.5439 22.9144 5.2039 22.0038 4.09008 20.8118C2.98245 19.6264 2.14827 18.2149 1.12364 16.2262C0.959433 15.9075 0.87376 15.5542 0.87376 15.1957V8.28975C0.87376 8.1193 0.895753 7.92086 0.927109 7.74562C0.955503 7.58693 1.00947 7.34207 1.11536 7.12693L1.12077 7.11594L2.36032 4.74574C3.02214 3.42103 4.76358 3.08529 5.87057 4.07268L14.6173 11.8744L13.286 13.367L4.53928 5.56522ZM16.7437 22.3352C16.7441 22.3354 16.7385 22.3366 16.7258 22.3387C16.7369 22.3362 16.7432 22.3351 16.7437 22.3352ZM34.1216 4.07269C35.232 3.0822 36.9809 3.42315 37.638 4.75823L38.8871 7.29619C39.0393 7.6053 39.1184 7.94522 39.1184 8.28975V15.1957C39.1184 15.5542 39.0327 15.9075 38.8685 16.2262C37.8439 18.2149 37.0097 19.6264 35.9021 20.8118C34.7882 22.0038 33.4482 22.9144 31.496 23.9959L31.469 24.0113C31.4547 24.0194 31.4302 24.0334 31.4023 24.0483C31.3462 24.0781 31.2543 24.1235 31.137 24.1585C30.9282 24.2209 30.6507 24.2557 30.405 24.2801C30.1328 24.3071 29.8038 24.3295 29.4443 24.348C28.7237 24.385 27.8473 24.4076 26.9903 24.4161C26.5623 24.4204 26.1364 24.4211 25.7345 24.4182L29.7377 29.0428C30.5994 28.1669 31.7983 27.6238 33.1241 27.6238C35.7474 27.6238 37.8741 29.7504 37.8741 32.3738C37.8741 34.9971 35.7474 37.1237 33.1241 37.1237C30.5007 37.1237 28.3741 34.9971 28.3741 32.3738C28.3741 31.8228 28.4678 31.2938 28.6404 30.8017C28.5894 30.7621 28.5416 30.7169 28.4978 30.6663L22.5715 23.8202C22.2101 23.4026 22.2556 22.7711 22.6731 22.4096C23.0341 22.0972 23.555 22.0888 23.923 22.362C24.1073 22.3771 24.3649 22.3899 24.6811 22.3996C25.3112 22.4189 26.1313 22.4245 26.9705 22.4162C27.8096 22.4079 28.6569 22.3858 29.3417 22.3506C29.6849 22.333 29.9791 22.3125 30.2073 22.2899C30.3215 22.2785 30.4123 22.2673 30.4805 22.2568C30.4957 22.2545 30.5087 22.2523 30.5197 22.2504L30.5269 22.2464C32.4129 21.2016 33.539 20.4114 34.4407 19.4463C35.3486 18.4747 36.0794 17.2728 37.0906 15.3102C37.1089 15.2748 37.1184 15.2355 37.1184 15.1957V8.28975C37.1184 8.25148 37.1096 8.21371 37.0927 8.17936L35.8436 5.6414C35.7706 5.49306 35.5762 5.45517 35.4529 5.56523L26.7061 13.367L25.3748 11.8744L34.1216 4.07269ZM23.7052 22.3367C23.7056 22.3366 23.7116 22.3376 23.722 22.3401C23.71 22.3381 23.7048 22.3368 23.7052 22.3367ZM33.1241 29.6238C31.6053 29.6238 30.3741 30.855 30.3741 32.3738C30.3741 33.8925 31.6053 35.1237 33.1241 35.1237C34.6428 35.1237 35.8741 33.8925 35.8741 32.3738C35.8741 30.855 34.6428 29.6238 33.1241 29.6238ZM18.6743 27.8974C19.1166 28.2282 19.2069 28.8549 18.8762 29.2971L16.9689 31.8471C16.5834 32.4454 16.6712 33.2339 17.182 33.7326L19.9992 36.4836L22.8163 33.7326C23.327 33.2338 23.4148 32.4453 23.0292 31.847L21.1236 29.2968C20.793 28.8544 20.8836 28.2278 21.3261 27.8972C21.7685 27.5666 22.3951 27.6572 22.7257 28.0996L24.6495 30.6741C24.6602 30.6885 24.6705 30.7031 24.6805 30.718C25.6146 32.1192 25.4184 33.9869 24.2136 35.1635L19.9993 39.279L15.7847 35.1635C14.5798 33.987 14.3836 32.1191 15.3178 30.7179C15.3278 30.7029 15.3382 30.6881 15.3491 30.6737L17.2746 28.0992C17.6054 27.657 18.232 27.5666 18.6743 27.8974Z", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : 'white' }),
                React__default.createElement("path", { d: "M14.3828 11.1367C14.3828 10.4464 14.9425 9.88672 15.6328 9.88672H24.3791C25.0695 9.88672 25.6291 10.4464 25.6291 11.1367V20.5644C25.6291 20.9213 25.4765 21.2613 25.2098 21.4985L20.006 26.1256L14.8022 21.4985C14.5354 21.2613 14.3828 20.9213 14.3828 20.5644V11.1367Z", stroke: fillOpacity !== null && fillOpacity !== void 0 ? fillOpacity : '#EAF1F8', strokeWidth: "5", strokeLinecap: "round" }),
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.3823 11.1367C13.3823 9.89408 14.3897 8.88672 15.6323 8.88672H24.3787C25.6213 8.88672 26.6287 9.89408 26.6287 11.1367V20.5644C26.6287 21.2069 26.3539 21.8188 25.8738 22.2458L20.0055 27.4637L14.1372 22.2458C13.6571 21.8188 13.3823 21.2069 13.3823 20.5644V11.1367ZM15.6323 10.8867C15.4943 10.8867 15.3823 10.9986 15.3823 11.1367V20.5644C15.3823 20.6358 15.4128 20.7038 15.4662 20.7512L20.0055 24.7874L24.5448 20.7512C24.5981 20.7038 24.6287 20.6358 24.6287 20.5644V11.1367C24.6287 10.9986 24.5167 10.8867 24.3787 10.8867H15.6323Z", fill: strokeThird !== null && strokeThird !== void 0 ? strokeThird : 'white' })))))),
        fss: (React__default.createElement("svg", { style: style, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1156_1612)" },
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.75053 0.0772705C3.81739 0.692156 0 4.90026 0 9.99997C0 15.0997 3.81739 19.3078 8.75053 19.9227V18.4088C4.64848 17.8045 1.5 14.2699 1.5 9.99997C1.5 5.73002 4.64848 2.19545 8.75053 1.59116V0.0772705Z", fill: strokeThird !== null && strokeThird !== void 0 ? strokeThird : 'white' }),
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.75065 6.44943C6.98545 6.66946 5.61951 8.17522 5.61951 10C5.61951 11.8248 6.98545 13.3306 8.75065 13.5506V12.0301C7.81775 11.8255 7.11951 10.9943 7.11951 10C7.11951 9.00573 7.81775 8.17451 8.75065 7.96998V6.44943ZM12.776 10.0117C12.776 10.0078 12.776 10.0039 12.776 10C12.776 9.99613 12.776 9.99225 12.776 9.98836V10.0117Z", fill: strokeThird !== null && strokeThird !== void 0 ? strokeThird : 'white' }),
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.267 16.0789C14.2892 15.7022 16.6278 13.1242 16.6278 10C16.6278 6.87576 14.2892 4.29775 11.267 3.92104L11.267 5.43672C13.4577 5.8015 15.1278 7.70572 15.1278 10C15.1278 12.2943 13.4577 14.1985 11.267 14.5633L11.267 16.0789ZM4.3752 9.98493C4.37519 9.98995 4.37519 9.99497 4.37519 10C4.37519 10.005 4.37519 10.01 4.3752 10.0151L4.3752 9.98493Z", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : 'white' }),
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.2523 19.9223C11.7714 19.8575 12.2782 19.7528 12.7695 19.6115L12.5622 18.8907L12.3549 18.17C11.9969 18.2729 11.6288 18.3531 11.2523 18.4086L11.2523 19.9223ZM11.2523 1.59139C11.6288 1.6469 11.9969 1.72704 12.3549 1.83L12.5622 1.10922L12.7695 0.388445C12.2782 0.247149 11.7714 0.142497 11.2523 0.077639L11.2523 1.59139ZM6.59043e-06 9.98917C2.77542e-06 9.99277 8.67754e-07 9.99638 8.67439e-07 9.99998C8.67124e-07 10.0036 2.77416e-06 10.0072 6.58854e-06 10.0108L6.59043e-06 9.98917ZM14.4746 18.0978L14.838 18.7539C16.4824 17.8431 17.8431 16.4824 18.7539 14.838L18.0978 14.4746L17.4417 14.1112C16.6673 15.5095 15.5095 16.6673 14.1112 17.4417L14.4746 18.0978ZM20 9.99999C20 10.9608 19.8645 11.89 19.6115 12.7695L18.8908 12.5622L18.17 12.3548C18.3846 11.6088 18.5 10.8192 18.5 9.99999C18.5 9.18082 18.3846 8.39116 18.17 7.64513L18.8908 7.43782L19.6115 7.23051C19.8645 8.10997 20 9.03915 20 9.99999ZM18.0978 5.52537L18.7539 5.16199C17.8431 3.51755 16.4824 2.15687 14.838 1.2461L14.4746 1.90219L14.1112 2.55828C15.5095 3.3327 16.6673 4.4905 17.4417 5.88874L18.0978 5.52537Z", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : 'white' })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1156_1612" },
                    React__default.createElement("rect", { width: "20", height: "20", fill: "white" }))))),
        rosstat: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#clip0_477_41247)" },
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5454 2.75285L11.6298 4.65364C12.4981 3.92016 13.4642 3.54995 14 3.54995C14.0782 3.54995 14.211 3.59482 14.3422 3.70985C14.3943 3.75554 14.4301 3.79891 14.4508 3.82982V7.54881V9.99685C14.3088 9.96714 14.1582 9.94995 14 9.94995C13.154 9.94995 12.4623 10.2797 11.8979 10.6959L11.9904 12.7805C12.204 12.5509 12.4154 12.337 12.6491 12.1404C13.1087 11.7539 13.533 11.55 14 11.55C14.1269 11.55 14.2576 11.5934 14.38 11.6688C14.4399 11.7058 14.4907 11.7462 14.5294 11.7826C14.5633 11.8146 14.5798 11.8358 14.583 11.8399L14.583 11.8399C14.5836 11.8407 14.5837 11.8408 14.5832 11.8401L16.0508 11.3992V7.54881V3.74995C16.0508 3.45912 15.942 3.2059 15.8342 3.02494C15.7198 2.83294 15.5677 2.65648 15.3969 2.50673C15.0655 2.2162 14.5729 1.94995 14 1.94995C13.2543 1.94995 12.3692 2.25749 11.5454 2.75285ZM4.01011 12.7811L4.1048 10.6979C3.5399 10.2807 2.84738 9.94996 2.00001 9.94996C1.84181 9.94996 1.69115 9.96715 1.54922 9.99686V7.54882V3.82982C1.56991 3.79892 1.6057 3.75554 1.65781 3.70986C1.78901 3.59483 1.92178 3.54996 2.00001 3.54996C2.53765 3.54996 3.50862 3.92274 4.37922 4.66129L4.46567 2.75957C3.63874 2.26028 2.74901 1.94996 2.00001 1.94996C1.42708 1.94996 0.934456 2.21621 0.603056 2.50674C0.432253 2.65648 0.280145 2.83294 0.165779 3.02494C0.0579892 3.2059 -0.0507812 3.45912 -0.0507812 3.74995V7.54882V11.3992L1.41678 11.8401C1.41629 11.8408 1.41636 11.8407 1.41703 11.8399C1.42018 11.8358 1.43664 11.8147 1.47062 11.7827C1.50927 11.7463 1.56011 11.7058 1.62003 11.6689C1.74238 11.5934 1.8731 11.55 2.00001 11.55C2.467 11.55 2.89125 11.7539 3.35084 12.1404C3.58478 12.3371 3.79631 12.5513 4.01011 12.7811ZM14.4688 3.86133C14.4687 3.86132 14.4677 3.85948 14.4663 3.85584C14.4682 3.85952 14.4689 3.86134 14.4688 3.86133ZM1.5312 3.86133C1.53108 3.86134 1.53177 3.85952 1.53364 3.85584C1.53226 3.85948 1.53132 3.86132 1.5312 3.86133Z", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : 'white' }),
                React__default.createElement("path", { d: "M10.2502 11.9999L10.7795 12.5314C11.0124 12.2994 11.0671 11.9427 10.9144 11.6516L10.2502 11.9999ZM9.1994 5.74994L9.94932 5.73886C9.94327 5.32901 9.6093 4.99994 9.1994 4.99994V5.74994ZM6.80024 5.74994V4.99994C6.39035 4.99994 6.05638 5.32901 6.05033 5.73886L6.80024 5.74994ZM5.75293 11.9999L5.08873 11.6516C4.93065 11.953 4.99537 12.3231 5.24636 12.553L5.75293 11.9999ZM7.99861 15.8936L7.2673 16.06L8.72918 16.0633L7.99861 15.8936ZM6.25034 -2.65747V-3.40747C5.83613 -3.40747 5.50034 -3.07168 5.50034 -2.65747H6.25034ZM9.75034 -2.65747H10.5003C10.5003 -3.07168 10.1646 -3.40747 9.75034 -3.40747V-2.65747ZM9.00034 5.24994V5.99994H10.5003V5.24994H9.00034ZM5.50034 5.24994V5.99994H7.00034V5.24994H5.50034ZM10.9144 11.6516C10.6384 11.1253 10.396 10.1509 10.2227 8.99611C10.0534 7.86829 9.96297 6.66272 9.94932 5.73886L8.44948 5.76102C8.46411 6.7509 8.55987 8.02348 8.7393 9.21879C8.91469 10.3871 9.1836 11.5809 9.58604 12.3483L10.9144 11.6516ZM9.1994 4.99994H6.80024V6.49994H9.1994V4.99994ZM6.05033 5.73886C6.03667 6.66311 5.94709 7.86886 5.77864 8.99666C5.60615 10.1516 5.36459 11.1256 5.08873 11.6516L6.41713 12.3483C6.81975 11.5806 7.08771 10.3864 7.26219 9.21824C7.44072 8.02291 7.53555 6.75051 7.55016 5.76102L6.05033 5.73886ZM5.24636 12.553C6.00294 13.246 6.5125 14.1199 6.83503 14.8425C6.99475 15.2003 7.10466 15.5121 7.17398 15.732C7.20857 15.8417 7.23286 15.9279 7.24804 15.9846C7.25562 16.013 7.26092 16.034 7.26408 16.0468C7.26567 16.0532 7.26671 16.0576 7.26724 16.0598C7.26751 16.0609 7.26764 16.0615 7.26765 16.0616C7.26766 16.0616 7.26763 16.0615 7.26757 16.0612C7.26754 16.0611 7.26751 16.0609 7.26746 16.0607C7.26744 16.0606 7.2674 16.0605 7.26739 16.0604C7.26735 16.0602 7.2673 16.06 7.99861 15.8936C8.72992 15.7272 8.72987 15.727 8.72982 15.7268C8.7298 15.7267 8.72975 15.7265 8.72971 15.7263C8.72964 15.726 8.72955 15.7256 8.72946 15.7252C8.72927 15.7244 8.72905 15.7234 8.72879 15.7223C8.72828 15.7201 8.72763 15.7174 8.72685 15.7141C8.72528 15.7074 8.72315 15.6986 8.72044 15.6876C8.71503 15.6657 8.70731 15.6352 8.6971 15.5971C8.6767 15.5208 8.64631 15.4134 8.60456 15.281C8.52121 15.0166 8.39177 14.65 8.20478 14.2311C7.83389 13.4001 7.22061 12.3272 6.2595 11.4469L5.24636 12.553ZM7.99861 15.8936C8.72918 16.0633 8.72913 16.0635 8.72908 16.0637C8.72907 16.0637 8.72903 16.0639 8.729 16.064C8.72895 16.0642 8.72891 16.0644 8.72887 16.0646C8.7288 16.0649 8.72875 16.0651 8.72874 16.0651C8.72871 16.0652 8.72881 16.0649 8.72902 16.064C8.72946 16.0622 8.73038 16.0584 8.73181 16.0527C8.73467 16.0414 8.73958 16.0224 8.74671 15.9965C8.76096 15.9446 8.78405 15.8648 8.81736 15.7621C8.88409 15.5563 8.99125 15.2602 9.14971 14.9121C9.4681 14.2127 9.98478 13.3228 10.7795 12.5314L9.72102 11.4685C8.76286 12.4227 8.15373 13.4796 7.78451 14.2906C7.59917 14.6978 7.47208 15.0478 7.39051 15.2994C7.34967 15.4253 7.3201 15.527 7.30023 15.5994C7.29029 15.6356 7.28277 15.6645 7.27747 15.6854C7.27483 15.6959 7.27273 15.7044 7.27117 15.7109C7.27039 15.7141 7.26974 15.7168 7.26922 15.719C7.26896 15.7201 7.26873 15.7211 7.26854 15.7219C7.26844 15.7223 7.26835 15.7227 7.26827 15.7231C7.26823 15.7232 7.26817 15.7235 7.26815 15.7236C7.2681 15.7238 7.26805 15.724 7.99861 15.8936ZM6.25034 -1.90747H9.75034V-3.40747H6.25034V-1.90747ZM9.00034 -2.65747V5.24994H10.5003V-2.65747H9.00034ZM7.00034 5.24994V-2.65747H5.50034V5.24994H7.00034Z", fill: strokeThird !== null && strokeThird !== void 0 ? strokeThird : 'white' })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_477_41247" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        drafts: (React__default.createElement("svg", { style: style, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M5.75391 9H10.2499M8.00192 6.75L8.00192 11.25", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", stroke: "white", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "white" }))),
        sfr: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: iconStroke ? '0 0 17 17' : '0 0 40 41', fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_477_41237)" }, iconStroke ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8113 3.62022L11.7617 4.27946L11.3342 4.89573L6.55645 11.7839L6.34103 12.0945L5.96325 12.1061L5.10149 12.1326C2.61912 12.209 0.610263 10.1313 0.770159 7.65293C0.907925 5.51756 2.66264 3.84604 4.80218 3.81208L6.52502 3.78473L9.49479 -0.867554H11.2743L7.57236 4.93179L7.35535 5.27174L6.95209 5.27814L4.82599 5.31189C3.46812 5.33344 2.35448 6.39428 2.26705 7.7495C2.16411 9.34497 3.45732 10.6825 5.05535 10.6333L5.53934 10.6184L10.1017 4.04082L10.3934 3.62022H10.8113Z", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : 'white', stroke: "none" }),
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.93151 18.7313L10.5659 11.9645L12.4603 11.9062C14.6933 11.8375 16.4678 10.0075 16.4678 7.77352C16.4678 5.49004 14.6167 3.63892 12.3332 3.63892H10.3776L9.32908 5.13892H10.0379H12.3332C13.7882 5.13892 14.9678 6.31847 14.9678 7.77352C14.9678 9.19702 13.837 10.3631 12.4142 10.4069L10.1392 10.4769L9.75859 10.4886L9.54345 10.8027L4.50439 18.1605L5.93151 18.7313Z", fill: strokeThird !== null && strokeThird !== void 0 ? strokeThird : 'white', stroke: "none" }))) : (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.6742 9.28574L26.9485 10.1696L26.3785 10.9913L14.4341 28.2117L14.1469 28.6258L13.6431 28.6413L11.4887 28.7075C5.79868 28.8826 1.19399 24.1202 1.5605 18.4393C1.87556 13.556 5.88838 9.7334 10.7813 9.65574L15.5588 9.57991L23.5368 -2.91797H25.9095L16.9553 11.1093L16.6659 11.5626L16.1283 11.5711L10.813 11.6555C6.96235 11.7166 3.8043 14.7249 3.55635 18.5681C3.26579 23.0718 6.91628 26.8473 11.4272 26.7085L13.0779 26.6577L24.7351 9.85139L25.0361 9.41752L25.6742 9.28574Z", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : 'white', stroke: "none" }),
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.7568 45.7453L24.7047 28.2996L29.8849 28.1402C34.9946 27.983 39.0554 23.7953 39.0554 18.6832C39.0554 13.4577 34.8193 9.22168 29.5939 9.22168H25.1681L23.7764 11.2217H23.8556H29.5939C33.7148 11.2217 37.0554 14.5623 37.0554 18.6832C37.0554 22.7147 33.853 26.0172 29.8234 26.1412L24.1358 26.3162L23.6283 26.3318L23.3415 26.7506L10.854 44.9842L12.7568 45.7453Z", fill: strokeThird !== null && strokeThird !== void 0 ? strokeThird : 'white', stroke: "none" })))))),
        urn: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M9 12.25C9 12.6642 9.33579 13 9.75 13C10.1642 13 10.5 12.6642 10.5 12.25H9ZM10.5 6.75C10.5 6.33579 10.1642 6 9.75 6C9.33579 6 9 6.33579 9 6.75H10.5ZM5.50403 12.25C5.50403 12.6642 5.83981 13 6.25403 13C6.66824 13 7.00403 12.6642 7.00403 12.25H5.50403ZM7.00403 6.75C7.00403 6.33579 6.66824 6 6.25403 6C5.83981 6 5.50403 6.33579 5.50403 6.75H7.00403ZM0.75 3.00002C0.335786 3.00002 0 3.33581 0 3.75002C0 4.16424 0.335786 4.50002 0.75 4.50002V3.00002ZM15.25 4.50002C15.6642 4.50002 16 4.16424 16 3.75002C16 3.33581 15.6642 3.00002 15.25 3.00002V4.50002ZM14 4.19989C14 3.78568 13.6642 3.44989 13.25 3.44989C12.8358 3.44989 12.5 3.78568 12.5 4.19989H14ZM3.75006 0C3.33584 0 3.00006 0.335786 3.00006 0.75C3.00006 1.16421 3.33584 1.5 3.75006 1.5V0ZM12.2501 1.5C12.6643 1.5 13.0001 1.16421 13.0001 0.75C13.0001 0.335786 12.6643 0 12.2501 0V1.5ZM10.5 12.25V6.75H9V12.25H10.5ZM7.00403 12.25V6.75H5.50403V12.25H7.00403ZM0.75 4.50002H15.25V3.00002H0.75V4.50002ZM2 4.19989V14.55H3.5V4.19989H2ZM3.45 16H12.55V14.5H3.45V16ZM14 14.55V4.19989H12.5V14.55H14ZM12.55 16C13.3508 16 14 15.3508 14 14.55H12.5C12.5 14.5224 12.5224 14.5 12.55 14.5V16ZM2 14.55C2 15.3508 2.64919 16 3.45 16V14.5C3.47761 14.5 3.5 14.5224 3.5 14.55H2ZM3.75006 1.5H12.2501V0H3.75006V1.5Z", fill: "#D12E34" }))),
        urn_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#clip0_2594_1251)" },
                React__default.createElement("path", { d: "M9.75 12.25L9.75 6.75M6.25403 12.25L6.25403 6.75", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M0.75 3.00002C0.335786 3.00002 0 3.33581 0 3.75002C0 4.16424 0.335786 4.50002 0.75 4.50002V3.00002ZM15.25 4.50002C15.6642 4.50002 16 4.16424 16 3.75002C16 3.33581 15.6642 3.00002 15.25 3.00002V4.50002ZM14 4.19989C14 3.78568 13.6642 3.44989 13.25 3.44989C12.8358 3.44989 12.5 3.78568 12.5 4.19989H14ZM3.75006 0C3.33584 0 3.00006 0.335786 3.00006 0.75C3.00006 1.16421 3.33584 1.5 3.75006 1.5V0ZM12.2501 1.5C12.6643 1.5 13.0001 1.16421 13.0001 0.75C13.0001 0.335786 12.6643 0 12.2501 0V1.5ZM0.75 4.50002H15.25V3.00002H0.75V4.50002ZM2 4.19989V14.55H3.5V4.19989H2ZM3.45 16H12.55V14.5H3.45V16ZM14 14.55V4.19989H12.5V14.55H14ZM12.55 16C13.3508 16 14 15.3508 14 14.55H12.5C12.5 14.5224 12.5224 14.5 12.55 14.5V16ZM2 14.55C2 15.3508 2.64919 16 3.45 16V14.5C3.47761 14.5 3.5 14.5224 3.5 14.55H2ZM3.75006 1.5H12.2501V0H3.75006V1.5Z" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_2594_1251" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        file_check_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("path", { d: "M6.25 9.25L7.75 11.25L10.25 7.25", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("g", { filter: "url(#filter0_i_1427_439)" },
                React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("path", { d: "M10 5V0.121094L10.2031 0.25L13.8281 4.76562L13.9414 5H10Z", fill: "#254E5F", stroke: "#254E5F", strokeWidth: "0", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0_i_1427_439", x: "2", y: "0", width: "12", height: "17", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React__default.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_1427_439" })),
                React__default.createElement("linearGradient", { id: "paint0_linear_1427_439", x1: "2", y1: "16", x2: "17.36", y2: "4.48", gradientUnits: "userSpaceOnUse" },
                    React__default.createElement("stop", { stopColor: "#3C9F83" }),
                    React__default.createElement("stop", { offset: "1", stopColor: "#4BA1A5" }))))),
        file_unformalized_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M5.75 6.75V9.25M5.75 12.25V9.25M5.75 9.25H10.2544V6.75V12.25", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", stroke: "", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "#254E5F", stroke: "#254E5F", strokeWidth: "0", strokeLinecap: "round", strokeLinejoin: "round" }))),
        file_default_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("path", { d: "M5.75 8.25H10.25M5.75 5H8.25M5.75 11.5H10.246", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: "#254E5F", stroke: "#254E5F", strokeWidth: "0", strokeLinecap: "round", strokeLinejoin: "round" }))),
        catalog_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("path", { fill: "#254E5F", stroke: "none", d: "M3.502 6.25a.75.75 0 0 0-1.5 0h1.5Zm-1.5 0v7h1.5v-7h-1.5ZM4.752 16h7.996v-1.5H4.752V16Zm9.245-1.25v-8.5h-1.5v8.5h1.5ZM12.748 16c.69 0 1.25-.56 1.25-1.25h-1.5a.25.25 0 0 1 .25-.25V16ZM2.003 13.25A2.75 2.75 0 0 0 4.752 16v-1.5c-.69 0-1.25-.56-1.25-1.25h-1.5Z" }),
            React__default.createElement("path", { strokeWidth: "1.5", d: "M2.75 2.75a2 2 0 0 1 2-2h8a.5.5 0 0 1 .5.5v10.5a.5.5 0 0 1-.5.5h-8a2 2 0 0 1-2-2v-7.5Z" }))),
        user_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("path", { stroke: "#254E5F", strokeLinecap: "round", strokeWidth: "1.5", d: "M9.455 9.298a4 4 0 0 1 4 4v1.355" }),
            React__default.createElement("path", { stroke: strokeSecond, strokeLinecap: "round", strokeWidth: "1.5", d: "M2.748 14.653v-1.355a4 4 0 0 1 4-4h2.758c1.055 0 2.063.436 2.786 1.204M10.75 3.548a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z" }))),
        users_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("g", { strokeLinecap: "round", strokeWidth: "1.5", clipPath: "url(#a)" },
                React__default.createElement("path", { stroke: "#254E5F", d: "M11.49 14.653v-1.355a4 4 0 0 0-4-4m7.763 5.355v-1.355A3.996 3.996 0 0 0 13.517 10M11 6.162A2.751 2.751 0 0 0 11 1" }),
                React__default.createElement("path", { d: "M.796 14.653v-1.355a4 4 0 0 1 4-4h2.76c1.054 0 2.062.436 2.785 1.204M8.799 3.548a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "a" },
                    React__default.createElement("path", { fill: "#fff", d: "M0 0h16v16H0z" }))))),
        logout: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("path", { stroke: "#254E5F", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "M5.25 12.5.75 8l4.5-4.5m5 4.502H.751" }),
            React__default.createElement("path", { stroke: "#D12E34", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "M11.75 1.75h1.5a2 2 0 0 1 2 2v8.5a2 2 0 0 1-2 2h-1.5" }))),
        controls: (React__default.createElement("svg", { style: style, className: `sprite-stroke-primary-color sprite-stroke-primary-color__${theme !== null && theme !== void 0 ? theme : product} sprite-fill-primary-color__${theme !== null && theme !== void 0 ? theme : product} `, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("path", { fillRule: "evenodd", d: "M.938 4.344a.75.75 0 0 1 .75-.75h1.937a.75.75 0 0 1 0 1.5H1.687a.75.75 0 0 1-.75-.75Zm6 0a.75.75 0 0 1 .75-.75h7.062a.75.75 0 0 1 0 1.5H7.687a.75.75 0 0 1-.75-.75ZM9.5 11.64a.75.75 0 0 1-.75.75H1.687a.75.75 0 0 1 0-1.5H8.75a.75.75 0 0 1 .75.75Zm6 0a.75.75 0 0 1-.75.75h-1.938a.75.75 0 0 1 0-1.5h1.938a.75.75 0 0 1 .75.75Z", clipRule: "evenodd", stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '', fill: iconFill ? strokeSecond : `` }),
            React__default.createElement("path", { fillRule: "evenodd", d: "M4.438 4.344a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm1.25-2.75a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM12 11.64a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-1.25 2.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z", clipRule: "evenodd", stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '', fill: iconFill ? strokeSecond : `` }))),
        controls_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("path", { fillRule: "evenodd", d: "M.938 4.344a.75.75 0 0 1 .75-.75h1.937a.75.75 0 0 1 0 1.5H1.687a.75.75 0 0 1-.75-.75Zm6 0a.75.75 0 0 1 .75-.75h7.062a.75.75 0 0 1 0 1.5H7.687a.75.75 0 0 1-.75-.75ZM9.5 11.64a.75.75 0 0 1-.75.75H1.687a.75.75 0 0 1 0-1.5H8.75a.75.75 0 0 1 .75.75Zm6 0a.75.75 0 0 1-.75.75h-1.938a.75.75 0 0 1 0-1.5h1.938a.75.75 0 0 1 .75.75Z", clipRule: "evenodd" }),
            React__default.createElement("path", { fill: "#254E5F", fillRule: "evenodd", d: "M4.438 4.344a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm1.25-2.75a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM12 11.64a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-1.25 2.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z", clipRule: "evenodd" }))),
        bell_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("path", { stroke: "#254E5F", strokeWidth: "1.5", d: "M4.75 14s-.008 1.25 1.246 1.25M7.25 14s0 1.25-1.254 1.25m0 0V14" }),
            React__default.createElement("path", { strokeLinejoin: "round", strokeWidth: "1.5", d: "M7.273 1.184c0 .172.727.156.727.156s.726.016.726-.156c0-.077-.214-.434-.726-.434s-.727.353-.727.434ZM11.967 8.262c.61.92 1.726 1.634 1.555 2.725a41.842 41.842 0 0 1-.218 1.263H2.803s-.106-.57-.212-1.262c-.166-1.092.962-1.817 1.536-2.76 1.14-1.871-1.3-6.488 3.926-6.488 5.26 0 2.687 4.676 3.914 6.522Z" }))),
        question_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("path", { stroke: "#254E5F", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.9", d: "M8 14.867v.01" }),
            React__default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "M3.82 5.298a4.175 4.175 0 1 1 4.176 4.176v2.396" }))),
        list_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#clip0_2994_1092)" },
                React__default.createElement("path", { d: "M1.18091 3.74H1.19091", stroke: "#254E5F", strokeWidth: "2", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M4.93091 3.75H15.4309", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M1.18091 8H1.19091M1.18091 12.25H1.19091", strokeWidth: "2", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M4.93091 8H15.4309M4.93091 12.25H15.4309", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_2994_1092" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white", transform: "translate(0.180908)" }))))),
        x_cross_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M9.20758 7.46967L8.67725 6.93934L7.61659 8L8.14692 8.53033L9.20758 7.46967ZM13.2734 13.6569C13.5663 13.9497 14.0412 13.9497 14.3341 13.6569C14.627 13.364 14.627 12.8891 14.3341 12.5962L13.2734 13.6569ZM8.14692 8.53033L13.2734 13.6569L14.3341 12.5962L9.20758 7.46967L8.14692 8.53033Z", stroke: "#254E5F", fill: "#254E5F", strokeWidth: "0.1" }),
            React__default.createElement("path", { d: "M13.6268 2.88L3.3799 13.127M3.37988 2.88002L8.33581 7.83594", stroke: "", strokeWidth: "1.5", strokeLinecap: "round" }))),
        circle_question_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_175_591)" },
                React__default.createElement("path", { d: "M5.75 6.495C5.75 5.25235 6.75736 4.245 8 4.24499C9.24264 4.24499 10.25 5.25235 10.25 6.49499C10.25 7.73764 9.24264 8.74499 8 8.74499L8 9.49759", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("circle", { cx: "8", cy: "8", r: "7.25", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M8 11.745L8 11.755", stroke: "#254E5F", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_175_591" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        mail_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_175_584)" },
                React__default.createElement("path", { d: "M15 3L9.30158 7.88436C8.5526 8.52634 7.4474 8.52634 6.69842 7.88436L1 3", stroke: "#254E5F", strokeWidth: "1.5" }),
                React__default.createElement("rect", { x: "0.75", y: "0.75", width: "10.5", height: "14.5", rx: "1.25", transform: "matrix(-4.37114e-08 1 1 4.37114e-08 -3.27835e-08 2)", strokeWidth: "1.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_175_584" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white", transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 16 0)" }))))),
        download_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_175_522)" },
                React__default.createElement("path", { d: "M12.5049 6.75004L8.00488 11.25L3.50488 6.75005M8.00726 0.750021L8.00726 11.249", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", fill: "" }),
                React__default.createElement("path", { d: "M0.75 10.75L0.75 13.25C0.75 14.3546 1.64543 15.25 2.75 15.25L13.2549 15.25C14.3594 15.25 15.2549 14.3546 15.2549 13.25L15.2549 10.75", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '', fill: "" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_175_522" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        download_high: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_175_18319)" },
                React__default.createElement("path", { d: "M3.75 0.9375H2.1875C1.49714 0.9375 0.9375 1.49714 0.9375 2.1875V17.8125C0.9375 18.5029 1.49714 19.0625 2.1875 19.0625H17.8125C18.5029 19.0625 19.0625 18.5029 19.0625 17.8125V2.1875C19.0625 1.49714 18.5029 0.9375 17.8125 0.9375H16.25M13.76 8.75L10.01 12.5M10.01 12.5L10.005 1.25M10.01 12.5L6.25998 8.75", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_175_18319" },
                    React__default.createElement("rect", { width: "20", height: "20", fill: "white" }))))),
        download_full_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_4598_72754)" },
                React__default.createElement("path", { d: "M13.76 8.75L10.01 12.5M10.01 12.5L10.005 1.25M10.01 12.5L6.26001 8.75", stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '', strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M3.75 0.9375H1.9375C1.38522 0.9375 0.9375 1.38522 0.9375 1.9375V18.0625C0.9375 18.6148 1.38522 19.0625 1.9375 19.0625H18.0625C18.6148 19.0625 19.0625 18.6148 19.0625 18.0625V1.9375C19.0625 1.38522 18.6148 0.9375 18.0625 0.9375H16.25", stroke: strokeThird !== null && strokeThird !== void 0 ? strokeThird : '', strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_4598_72754" },
                    React__default.createElement("rect", { width: "20", height: "20", fill: "white" }))))),
        star: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M26.2454 11.0236L25.835 11.3093L26.2454 11.0236C26.1302 10.8581 26.0595 10.6656 26.0404 10.4648L25.5426 10.5123L26.0404 10.4648L25.7237 7.14654C25.6377 6.24545 25.0023 5.49201 24.1286 5.25529L20.9112 4.3836C20.7165 4.33084 20.5387 4.22878 20.395 4.08727L18.0195 1.7489C17.3744 1.11389 16.4033 0.945206 15.5818 1.32547L12.5569 2.72576C12.3738 2.8105 12.172 2.84662 11.9709 2.83062L8.64812 2.56626C7.74579 2.49447 6.89344 2.98947 6.50861 3.80878L5.09147 6.82585C5.00571 7.00844 4.87433 7.16583 4.71 7.28283L1.99465 9.21618C1.25728 9.7412 0.922518 10.6683 1.15436 11.5433L2.00811 14.7654C2.05977 14.9604 2.0603 15.1654 2.00962 15.3607L1.17228 18.5871C0.944892 19.4633 1.28436 20.3886 2.0244 20.9099L4.74955 22.8294C4.91447 22.9455 5.04665 23.1023 5.13334 23.2844L6.56581 26.2942C6.95481 27.1116 7.80966 27.6022 8.71162 27.5258L12.033 27.2446C12.2341 27.2276 12.4361 27.2627 12.6195 27.3465L15.6515 28.7313C16.4749 29.1074 17.4452 28.9338 18.087 28.2955L20.4506 25.9451C20.5936 25.8028 20.7709 25.6999 20.9653 25.6461L24.1782 24.7581C25.0506 24.5169 25.6823 23.7603 25.7637 22.8587L26.0635 19.5389C26.0816 19.338 26.1512 19.1452 26.2656 18.979L28.156 16.2336C28.6693 15.488 28.6668 14.5024 28.1497 13.7594L26.2454 11.0236Z", fill: "", stroke: "white" }),
            React__default.createElement("path", { d: "M5.86446 19.078L6.15239 18.6692L5.86446 19.078L7.73225 20.3936C7.82317 20.4576 7.89605 20.5441 7.94384 20.6445L8.92564 22.7074C9.22041 23.3267 9.86819 23.6985 10.5517 23.6407L12.8281 23.4479C12.9389 23.4385 13.0503 23.4578 13.1515 23.504L15.2296 24.4532C15.8535 24.7382 16.5887 24.6066 17.0751 24.123L18.695 22.512C18.7739 22.4336 18.8717 22.3768 18.9788 22.3472L21.1809 21.7385C21.842 21.5558 22.3207 20.9824 22.3823 20.2993L22.5878 18.0239C22.5978 17.9132 22.6362 17.8068 22.6993 17.7152L23.9949 15.8335C24.3839 15.2686 24.382 14.5217 23.9901 13.9587L22.6849 12.0836C22.6214 11.9923 22.5825 11.8862 22.5719 11.7755L22.0742 11.823L22.5719 11.7755L22.3549 9.50123C22.2897 8.81842 21.8082 8.24748 21.1461 8.06811L18.941 7.47066C18.8337 7.44157 18.7356 7.3853 18.6564 7.30728L17.0282 5.70459C16.5394 5.22341 15.8035 5.09558 15.1811 5.38373L13.1078 6.34347C13.0069 6.39019 12.8956 6.41011 12.7848 6.40129L10.5073 6.2201C9.82359 6.1657 9.1777 6.54079 8.88609 7.16164L7.91481 9.2295C7.86752 9.33016 7.79509 9.41694 7.70449 9.48144L5.84342 10.8065C5.28466 11.2044 5.031 11.9069 5.20668 12.5699L5.79183 14.7783C5.82031 14.8858 5.8206 14.9989 5.79266 15.1065L5.21876 17.3179C5.04645 17.9818 5.30369 18.683 5.86446 19.078Z", fill: "", stroke: "white" }))),
        star_2: (React__default.createElement("svg", { style: style, className: `sprite-stroke-primary-color__${theme !== null && theme !== void 0 ? theme : product}`, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: '', xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_2763_1369)" },
                React__default.createElement("path", { d: "M7.72791 1.25288C7.83543 1.02136 8.16457 1.02136 8.27209 1.25288L10.1962 5.39604C10.2399 5.49017 10.3292 5.55502 10.4322 5.5675L14.9672 6.11713C15.2206 6.14785 15.3223 6.46088 15.1353 6.63468L11.7895 9.74492C11.7135 9.81558 11.6794 9.92051 11.6994 10.0224L12.578 14.5052C12.6271 14.7557 12.3608 14.9492 12.1378 14.8251L8.14585 12.6041C8.05516 12.5537 7.94484 12.5537 7.85415 12.6041L3.86222 14.8251C3.63915 14.9492 3.37287 14.7557 3.42197 14.5052L4.30062 10.0224C4.32058 9.92051 4.28649 9.81558 4.21048 9.74492L0.864681 6.63468C0.677718 6.46088 0.779428 6.14785 1.03284 6.11713L5.56781 5.5675C5.67083 5.55502 5.76009 5.49017 5.8038 5.39604L7.72791 1.25288Z", fill: strokeThird !== null && strokeThird !== void 0 ? strokeThird : ``, fillOpacity: fillOpacity !== null && fillOpacity !== void 0 ? fillOpacity : '0.05', stroke: "" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_2763_1369" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "" }))))),
        copy_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M9.25 12.75V13.25C9.25 13.8023 8.80228 14.25 8.25 14.25H2.75C2.19772 14.25 1.75 13.8023 1.75 13.25V7.75C1.75 7.19772 2.1977 6.75 2.74998 6.75C2.9005 6.75 3.06733 6.75 3.25 6.75", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "square" }),
            React__default.createElement("path", { d: "M6.75 2.75C6.75 2.19772 7.19772 1.75 7.75 1.75H13.25C13.8023 1.75 14.25 2.19772 14.25 2.75V8.25C14.25 8.80228 13.8023 9.25 13.25 9.25H7.75C7.19772 9.25 6.75 8.80228 6.75 8.25V2.75Z", strokeWidth: "1.5", strokeLinecap: "round" }))),
        company: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M10.8021 14.2398V10.0352C10.8021 9.90262 10.6946 9.79517 10.5621 9.79517H5.48707C5.35452 9.79517 5.24707 9.90262 5.24707 10.0352V14.2398", stroke: strokeSecond, strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M13.7714 6.48065V13.9397C13.7714 14.1054 13.637 14.2397 13.4714 14.2397H2.57747C2.41178 14.2397 2.27747 14.1054 2.27747 13.9397V6.57681M2.7476 6.44016C3.24099 6.43641 3.71409 6.07783 4.06892 5.72145C4.42178 6.08107 4.89624 6.44022 5.3904 6.44022C5.88457 6.44022 6.35903 6.08107 6.71189 5.72145C7.04654 6.08901 7.51179 6.44016 8.01426 6.44016C8.50765 6.43641 8.98075 6.07783 9.33558 5.72145C9.68844 6.08107 10.1629 6.44022 10.6571 6.44022C11.1512 6.44022 11.6257 6.08107 11.9786 5.72145C12.3334 6.07783 12.8065 6.43641 13.2999 6.44016C13.914 6.44016 14.5467 6.12926 14.919 5.62768C15.1981 5.24078 15.2912 4.79585 15.1795 4.37026L13.917 1.49176C13.8692 1.3827 13.7614 1.31226 13.6423 1.31226H2.61632C2.50366 1.31226 2.4005 1.37538 2.34921 1.47569L0.869306 4.37026C0.757646 4.79585 0.850696 5.24078 1.12985 5.62768C1.50072 6.13064 2.13214 6.44016 2.7476 6.44016Z", strokeWidth: "1.5", strokeMiterlimit: "10" }))),
        plus_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_175_19604)" },
                React__default.createElement("path", { d: "M10.003 0.942871L10.003 19.0571M19.0601 9.99997L0.945862 10", stroke: "#254E5F", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M10.003 0.942871V9.99999M19.0601 9.99997L0.945862 10", strokeWidth: "1.5", strokeLinecap: "round" })))),
        headphones_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_175_579)" },
                React__default.createElement("path", { d: "M14 7C14 3.68629 11.3137 1 8 0.999999C4.68629 0.999999 2 3.68629 2 7M14 10C14 16 11 15 7 15", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M15.5 7C15.5 6.17157 14.8284 5.5 14 5.5C13.7239 5.5 13.5 5.72386 13.5 6L13.5 11C13.5 11.2761 13.7239 11.5 14 11.5C14.8284 11.5 15.5 10.8284 15.5 10L15.5 7ZM7 14.5C6.72386 14.5 6.5 14.7239 6.5 15C6.5 15.2761 6.72386 15.5 7 15.5L9 15.5C9.27614 15.5 9.5 15.2761 9.5 15C9.5 14.7239 9.27614 14.5 9 14.5L7 14.5ZM2 5.5C1.17157 5.5 0.5 6.17157 0.5 7L0.5 10C0.499999 10.8284 1.17157 11.5 2 11.5C2.27614 11.5 2.5 11.2761 2.5 11L2.5 6C2.5 5.72386 2.27614 5.5 2 5.5Z", fill: "#254E5F", stroke: "#254E5F" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_175_579" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white", transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 16 0)" }))))),
        chat_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_175_599)" },
                React__default.createElement("path", { d: "M4.99854 5.5L4.99954 5.5M7.99954 5.5L8.00054 5.5M11.0005 5.5L11.0015 5.5", stroke: "#254E5F", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M0.754618 8.99657L0.754619 13.9281C0.754619 13.9285 0.754882 13.9289 0.755277 13.929L0.755727 13.9292C0.756123 13.9293 0.756565 13.9292 0.756835 13.9289L3.54076 10.6069C3.73076 10.3801 4.0114 10.2492 4.30721 10.2492L13.95 10.2492C14.668 10.2492 15.25 9.66713 15.25 8.94916L15.25 2.04768C15.25 1.32971 14.668 0.747679 13.95 0.74768L2.05 0.747681C1.33203 0.747681 0.75 1.32971 0.75 2.04768L0.754618 8.99657Z", strokeWidth: "1.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_175_599" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        archive_secondary: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M12.25 7.75H6.75", stroke: "#254E5F", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M15.25 13.55V5.45C15.25 5.0634 14.9366 4.75 14.55 4.75H6.25L5.44348 3.13695C5.3249 2.8998 5.08252 2.75 4.81738 2.75H1.45C1.0634 2.75 0.75 3.0634 0.75 3.45V13.55C0.75 13.9366 1.0634 14.25 1.45 14.25H14.55C14.9366 14.25 15.25 13.9366 15.25 13.55Z", strokeWidth: "1.5", strokeLinejoin: "round" }))),
        cash: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 16", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#clip0_1659_457)" },
                React__default.createElement("path", { d: "M14.6137 5.40925C15.028 5.40925 15.3637 5.07346 15.3637 4.65925C15.3637 4.24504 15.028 3.90925 14.6137 3.90925V5.40925ZM4.02789 3.90925C3.61368 3.90925 3.27789 4.24504 3.27789 4.65925C3.27789 5.07346 3.61368 5.40925 4.02789 5.40925V3.90925ZM2.67695 3.13232H13.352V1.63232H2.67695V3.13232ZM13.352 12.8678H2.67695V14.3678H13.352V12.8678ZM2.12695 12.3178V3.68232H0.626953V12.3178H2.12695ZM13.902 9.70312V12.3178H15.402V9.70312H13.902ZM13.902 3.68232V7.70312H15.402V3.68232H13.902ZM2.67695 12.8678C2.3732 12.8678 2.12695 12.6216 2.12695 12.3178H0.626953C0.626953 13.45 1.54477 14.3678 2.67695 14.3678V12.8678ZM13.352 14.3678C14.4842 14.3678 15.402 13.45 15.402 12.3178H13.902C13.902 12.6216 13.6558 12.8678 13.352 12.8678V14.3678ZM13.352 3.13232C13.6558 3.13232 13.902 3.37857 13.902 3.68232H15.402C15.402 2.55014 14.4842 1.63232 13.352 1.63232V3.13232ZM2.67695 1.63232C1.54477 1.63232 0.626953 2.55014 0.626953 3.68232H2.12695C2.12695 3.37857 2.3732 3.13232 2.67695 3.13232V1.63232ZM14.6137 3.90925H4.02789V5.40925H14.6137V3.90925Z" }),
                React__default.createElement("path", { d: "M11.9341 7.75398C11.9341 7.58829 12.0684 7.45398 12.2341 7.45398H15.5264C15.6921 7.45398 15.8264 7.58829 15.8264 7.75398V9.65398C15.8264 9.81966 15.6921 9.95398 15.5264 9.95398H12.2341C12.0684 9.95398 11.9341 9.81966 11.9341 9.65398V7.75398Z", stroke: strokeSecond, strokeWidth: "1.5" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1659_457" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white", transform: "translate(0.595703)" }))))),
        cash_filled: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 16", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#clip0_1659_456)" },
                React__default.createElement("path", { d: "M13.352 2.38232H2.67695C1.95898 2.38232 1.37695 2.96435 1.37695 3.68232V12.3178C1.37695 13.0358 1.95898 13.6178 2.67695 13.6178H13.352C14.07 13.6178 14.652 13.0358 14.652 12.3178V6.70312V3.68232C14.652 2.96435 14.07 2.38232 13.352 2.38232Z", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M15.4003 4H4.02783", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { d: "M11.9341 7.75398C11.9341 7.58829 12.0684 7.45398 12.2341 7.45398H15.5264C15.6921 7.45398 15.8264 7.58829 15.8264 7.75398V9.65398C15.8264 9.81966 15.6921 9.95398 15.5264 9.95398H12.2341C12.0684 9.95398 11.9341 9.81966 11.9341 9.65398V7.75398Z", fill: "#254E5F", stroke: "#254E5F" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1659_456" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white", transform: "translate(0.595703)" }))))),
        doc_check: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", fill: "none" },
            React__default.createElement("path", { d: "M4 2.66667C4 1.19391 5.19391 0 6.66667 0H19.3592C19.7642 0 20.1473 0.18412 20.4003 0.500407L27.7078 9.63478C27.897 9.8712 28 10.1649 28 10.4677V29.3333C28 30.8061 26.8061 32 25.3333 32H6.66667C5.19391 32 4 30.8061 4 29.3333V2.66667Z" }),
            React__default.createElement("path", { d: "M11 17.5L15 22.5L22 13.5", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M20 9.33333V0.242188L20.2194 0.381446C20.3431 0.459945 20.453 0.558294 20.5448 0.672538L27.5614 9.41315C27.6244 9.49163 27.6784 9.57699 27.7222 9.66761L27.8828 10H20.6667C20.2985 10 20 9.70152 20 9.33333Z", fill: "#254E5F" }))),
        doc_location: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 33 32", fill: "none" },
            React__default.createElement("path", { d: "M4.33301 2.66667C4.33301 1.19391 5.52692 0 6.99967 0H19.6922C20.0972 0 20.4803 0.18412 20.7333 0.500407L28.0408 9.63478C28.23 9.8712 28.333 10.1649 28.333 10.4677V29.3333C28.333 30.8061 27.1391 32 25.6663 32H6.99967C5.52691 32 4.33301 30.8061 4.33301 29.3333V2.66667Z" }),
            React__default.createElement("path", { d: "M20.333 9.33333V0.242188L20.5524 0.381446C20.6761 0.459945 20.7861 0.558294 20.8778 0.672538L27.8945 9.41315C27.9575 9.49163 28.0114 9.57699 28.0552 9.66761L28.2158 10H20.9997C20.6315 10 20.333 9.70152 20.333 9.33333Z", fill: "#254E5F" }),
            React__default.createElement("path", { d: "M21.6667 17.2788C21.6667 19.8443 17.752 24.7993 16.6304 26.1665C16.4743 26.3567 16.1923 26.3567 16.0363 26.1665C14.9146 24.7993 11 19.8443 11 17.2788C11 14.2842 13.3878 11.8567 16.3333 11.8567C19.2789 11.8567 21.6667 14.2842 21.6667 17.2788Z", stroke: "white", strokeWidth: "2", strokeLinecap: "round" }),
            React__default.createElement("circle", { cx: "16.3327", cy: "17.1901", r: "0.666667", fill: "white", stroke: "white", strokeWidth: "1.86667" }))),
        doc_lines: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 33 32", fill: "none" },
            React__default.createElement("path", { d: "M4.66699 2.66667C4.66699 1.19391 5.8609 0 7.33366 0H20.0262C20.4312 0 20.8143 0.18412 21.0673 0.500407L28.3748 9.63478C28.564 9.8712 28.667 10.1649 28.667 10.4677V29.3333C28.667 30.8061 27.4731 32 26.0003 32H7.33366C5.8609 32 4.66699 30.8061 4.66699 29.3333V2.66667Z" }),
            React__default.createElement("path", { d: "M20.667 9.33333V0.242188L20.8864 0.381446C21.0101 0.459945 21.12 0.558294 21.2118 0.672538L28.2284 9.41315C28.2914 9.49163 28.3454 9.57699 28.3891 9.66761L28.5498 10H21.3337C20.9655 10 20.667 9.70152 20.667 9.33333Z", fill: "#254E5F" }),
            React__default.createElement("path", { d: "M12.167 16.5H21.167M12.167 10H17.167M12.167 23H21.1589", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        doc_rudder: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", fill: "none" },
            React__default.createElement("path", { d: "M4 2.66667C4 1.19391 5.19391 0 6.66667 0H19.3592C19.7642 0 20.1473 0.18412 20.4003 0.500407L27.7078 9.63478C27.897 9.8712 28 10.1649 28 10.4677V29.3333C28 30.8061 26.8061 32 25.3333 32H6.66667C5.19391 32 4 30.8061 4 29.3333V2.66667Z" }),
            React__default.createElement("path", { d: "M20 9.33333V0.242188L20.2194 0.381446C20.3431 0.459945 20.453 0.558294 20.5448 0.672538L27.5614 9.41315C27.6244 9.49163 27.6784 9.57699 27.7222 9.66761L27.8828 10H20.6667C20.2985 10 20 9.70152 20 9.33333Z", fill: "#254E5F" }),
            React__default.createElement("rect", { x: "8.33301", y: "12.0066", width: "15.3333", height: "15.3333", rx: "7.66667", stroke: "white", strokeWidth: "2" }),
            React__default.createElement("path", { d: "M16 12.3398L16 17.0065", stroke: "white", strokeWidth: "2" }),
            React__default.createElement("path", { d: "M16 21.6731L16 26.3398", stroke: "white", strokeWidth: "2" }),
            React__default.createElement("path", { d: "M8.33301 19.6731L12.9997 19.6731", stroke: "white", strokeWidth: "2" }),
            React__default.createElement("path", { d: "M19 19.6731L23.6667 19.6731", stroke: "white", strokeWidth: "2" }),
            React__default.createElement("rect", { x: "13.667", y: "17.3398", width: "4.66667", height: "4.66667", rx: "2.33333", stroke: "white", strokeWidth: "2" }))),
        doc_packet: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_3546_1093)" },
                React__default.createElement("path", { d: "M3.75 8.25H8.25M3.75 5H6.25M3.75 11.5H8.24596", stroke: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '', fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M11.1623 5.14043L7.7701 0.900122C7.69419 0.805236 7.57926 0.75 7.45775 0.75H2C1.30964 0.75 0.75 1.30964 0.75 2V14C0.75 14.6904 1.30964 15.25 2 15.25H10C10.6904 15.25 11.25 14.6904 11.25 14V5.39031C11.25 5.29948 11.2191 5.21136 11.1623 5.14043Z", stroke: "", fill: "none", strokeWidth: "1.5", strokeLinecap: "round" }),
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1136 0.0198517H10.5527C10.5582 0.0269468 10.5637 0.0341269 10.569 0.0413911L14.3227 5.16142C14.3775 5.23609 14.4212 5.31752 14.4532 5.40321C14.4836 5.44567 14.5 5.49661 14.5 5.54889V5.57327C14.5108 5.63217 14.5163 5.6922 14.5163 5.75269V14.2228C14.5163 14.9672 14.1095 15.6166 13.5062 15.961C14.9049 15.8318 16 14.6552 16 13.2228V5.54889C16 5.17802 15.8822 4.81674 15.6636 4.51718L12.9053 0.73814C12.5759 0.286749 12.0506 0.0198517 11.4918 0.0198517H11.1136ZM8 0.121094V5H11.9414L11.8776 4.86789C11.8447 4.79993 11.8043 4.73591 11.757 4.67705L8.30701 0.379404C8.23822 0.29372 8.15579 0.219959 8.06302 0.161085L8 0.121094Z", fill: strokeSecond !== null && strokeSecond !== void 0 ? strokeSecond : '', stroke: "none" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_3546_1093" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        doc_plus: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 33 32", fill: "none" },
            React__default.createElement("path", { d: "M4.33301 2.66667C4.33301 1.19391 5.52692 0 6.99967 0H19.6922C20.0972 0 20.4803 0.18412 20.7333 0.500407L28.0408 9.63478C28.23 9.8712 28.333 10.1649 28.333 10.4677V29.3333C28.333 30.8061 27.1391 32 25.6663 32H6.99967C5.52691 32 4.33301 30.8061 4.33301 29.3333V2.66667Z" }),
            React__default.createElement("path", { d: "M20.333 9.33333V0.242188L20.5524 0.381446C20.6761 0.459945 20.7861 0.558294 20.8778 0.672538L27.8945 9.41315C27.9575 9.49163 28.0114 9.57699 28.0552 9.66761L28.2158 10H20.9997C20.6315 10 20.333 9.70152 20.333 9.33333Z", fill: "#254E5F" }),
            React__default.createElement("path", { d: "M9.84082 18H22.8328M16.3369 11.5L16.3369 24.5", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        doc_cargo: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 33 32" },
            React__default.createElement("path", { d: "M4.667 2.667A2.667 2.667 0 0 1 7.334 0h12.692c.405 0 .788.184 1.041.5l7.308 9.135c.189.236.292.53.292.833v18.865A2.667 2.667 0 0 1 26 32H7.334a2.667 2.667 0 0 1-2.667-2.667V2.667Z" }),
            React__default.createElement("path", { fill: "#254E5F", d: "M20.667 9.333V.243l.22.138c.123.079.233.177.325.292l7.016 8.74c.063.079.117.164.161.255l.16.332h-7.215a.667.667 0 0 1-.667-.667Z" }),
            React__default.createElement("mask", { id: "a", fill: "#fff" },
                React__default.createElement("rect", { width: "13.714", height: "13.714", x: "9.811", y: "12.572", rx: "1.143" })),
            React__default.createElement("rect", { width: "13.714", height: "13.714", x: "9.811", y: "12.572", stroke: "#fff", strokeWidth: "4", mask: "url(#a)", rx: "1.143" }),
            React__default.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M14.662 25.353V14.075M18.662 25.353V14.075" }))),
        load: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#clip0_1383_113)" },
                React__default.createElement("path", { d: "M8 15C11.866 15 15 11.866 15 8.00001C15 7.30504 14.8987 6.63372 14.7101 6.00001", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M8 15C4.13401 15 1 11.866 1 7.99998C1 4.13398 4.13401 0.999977 8 0.999977C9.48725 0.999977 10.8662 1.46379 12 2.25467", strokeWidth: "1.5", strokeLinecap: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1383_113" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        integration_edo_onec: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 86 86", fill: "none" },
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.32 58.5281C14.8682 58.7967 14.7117 59.3674 14.8694 59.8688C15.2733 61.1522 15.2033 62.547 14.5132 63.7422L12.1122 67.901C11.7394 68.5467 11.9606 69.3723 12.6063 69.7451L20.0108 74.0201C20.6565 74.3929 21.4822 74.1717 21.855 73.526L24.2544 69.37C25.2909 67.5748 27.4166 66.766 29.4708 67.0445C31.547 67.326 33.6671 67.3333 35.7738 67.051C37.8293 66.7755 39.9564 67.5837 40.9933 69.3797L43.3872 73.5259C43.76 74.1716 44.5856 74.3928 45.2313 74.02L52.6358 69.745C53.2815 69.3723 53.5027 68.5466 53.1299 67.9009L50.7363 63.7549C50.2694 62.9463 50.0865 62.0465 50.142 61.1516C50.1684 60.7265 49.9886 60.3016 49.6215 60.0855L37.5791 52.9939C37.2882 52.8226 36.9316 52.8131 36.6215 52.9466C33.4793 54.2997 29.9417 53.9389 27.177 52.1773C26.8385 51.9617 26.4068 51.9367 26.0619 52.1418L15.32 58.5281Z", fill: "#797CA4" }),
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.1121 19.356C11.7393 18.7103 11.9606 17.8847 12.6063 17.5119L20.0108 13.2369C20.6565 12.8641 21.4821 13.0853 21.8549 13.731L24.2607 17.8979C25.2976 19.694 27.4248 20.5021 29.4803 20.2266C31.581 19.945 33.6951 19.9514 35.7657 20.2305C37.8186 20.5072 39.9421 19.6982 40.9778 17.9043L43.3872 13.7311C43.76 13.0854 44.5856 12.8641 45.2313 13.2369L52.6358 17.5119C53.2815 17.8847 53.5028 18.7104 53.13 19.3561L50.7275 23.5172C50.3664 24.1426 50.1751 24.8226 50.1327 25.5127C50.1096 25.8871 49.9305 26.2438 49.6081 26.4355L36.8752 34.0056C36.6061 34.1656 36.2786 34.1873 35.9832 34.0837C33.294 33.1406 30.225 33.3319 27.5635 34.8685C23.249 37.3595 21.4608 42.5457 23.0977 47.0725C23.2724 47.5555 23.107 48.1084 22.6655 48.3709L12.7207 54.2834C12.2315 54.5742 11.5967 54.3996 11.3492 53.8871C11.1446 53.4634 10.9537 53.0361 10.7765 52.6059C9.98725 50.6895 8.22425 49.2534 6.15172 49.2534H1.34614C0.600556 49.2534 -0.0038597 48.649 -0.00386047 47.9034L-0.00385931 39.3534C-0.0038596 38.6079 0.600556 38.0034 1.34614 38.0034H6.16535C8.23682 38.0034 9.99922 36.569 10.786 34.6528C11.5795 32.7201 12.6309 30.8862 13.925 29.2077C15.1913 27.5654 15.555 25.3192 14.5181 23.5232L12.1121 19.356Z", fill: "#EEAF41" }),
            React__default.createElement("path", { d: "M31 43.3339L86 75.5V10.5L31 43.3339Z", fill: "#254E5F" }))),
        repeat: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none" },
            React__default.createElement("path", { d: "M14 3.674H3.915a2 2 0 0 0-2 2V6.8M2 12.237h10.085a2 2 0 0 0 2-2V9.11", strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M14.085 3.674 11.33 6.429m-9.415 5.808 2.755 2.756", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "M1.915 12.237 4.67 9.482m9.415-5.808L11.33.918", strokeWidth: "1.5", strokeLinecap: "round" }))),
        circle_right: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none" },
            React__default.createElement("g", { clipPath: "url(#a)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "8" }),
                React__default.createElement("path", { d: "m7.301 4.442 4.625 3.23L7.301 10.9V4.442Z", fill: strokeSecond }),
                React__default.createElement("path", { d: "m8.05 4.462 3.221 3.22-3.22 3.22m-3.962-3.22h7.18", stroke: "#fff", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "a" },
                    React__default.createElement("path", { fill: "#fff", d: "M0 0h16v16H0z" }))))),
        search: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none" },
            React__default.createElement("path", { d: "M5.078 10.922 1.75 14.25", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("circle", { cx: "8.998", cy: "7.002", r: "5.252", strokeWidth: "1.5" }))),
        govkey: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 17" },
            React__default.createElement("path", { fill: "#0A2896", d: "M15.924 8.69c-.07.81-.104 1.726-.25 2.632-.165.993-.708 1.804-1.528 2.391-1.321.95-2.71 1.795-4.213 2.443-1.061.466-2.132.457-3.193-.017-1.381-.622-2.676-1.39-3.92-2.245-1.182-.811-1.794-1.933-1.898-3.357C.818 9.034.792 7.54.974 6.048c.146-1.2.69-2.192 1.709-2.84A65.75 65.75 0 0 1 6.602.947C7.715.35 8.88.368 10.028.895a24.189 24.189 0 0 1 4.049 2.34c.95.681 1.519 1.613 1.648 2.779.095.845.13 1.709.199 2.675ZM1.768 8.5c.052.776.069 1.553.155 2.321.095.88.51 1.606 1.217 2.124 1.278.923 2.624 1.726 4.074 2.356.795.345 1.597.32 2.383-.034 1.39-.622 2.684-1.407 3.927-2.28.717-.5 1.148-1.19 1.269-2.053.207-1.545.164-3.1.017-4.644-.103-1.062-.587-1.89-1.484-2.434A69.722 69.722 0 0 0 9.744 1.81c-.855-.458-1.753-.449-2.642-.043-1.346.613-2.598 1.38-3.832 2.2-.803.519-1.243 1.278-1.355 2.21-.087.769-.104 1.546-.147 2.322Z" }),
            React__default.createElement("path", { fill: "#0A2896", d: "M6.878 10.113c0 .242-.009.423 0 .604.026.302-.138.432-.415.45-.19.016-.38.042-.587.068-.026.216-.06.432-.086.639-.043.31-.242.5-.561.5-.88 0-.725.061-.751-.733-.009-.32.095-.544.32-.76.664-.63 1.303-1.286 1.967-1.95-.241-.242-.077-.397.104-.579.57-.552.561-.56 1.113-.008.19.19.372.388.57.57.138.129.147.241 0 .37-.25.234-.492.484-.75.708a.571.571 0 0 1-.32.112c-.181.018-.371.01-.604.01Z" }),
            React__default.createElement("path", { fill: "#0A2896", fillRule: "evenodd", d: "M10.683 8.534c.417-.411.834-.822 1.244-1.242.381-.382.452-.845.069-1.252a30.995 30.995 0 0 0-1.502-1.51c-.354-.337-.846-.311-1.191.034-.46.449-.909.9-1.359 1.355l-.678.682c-.207.207-.207.406 0 .613l.683.681c.457.456.916.913 1.371 1.373.199.207.406.216.613.009.25-.25.5-.496.75-.743Zm-.567-1.354a.592.592 0 0 0 .448-.563.582.582 0 0 0-.579-.57.585.585 0 0 0-.562.591.578.578 0 0 0 .562.559.529.529 0 0 0 .13-.017Z", clipRule: "evenodd" }))),
        settings: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16" },
            React__default.createElement("g", { strokeWidth: "1.5", clipPath: "url(#a)" },
                React__default.createElement("circle", { cx: "8", cy: "8", r: "2.251", stroke: strokeSecond }),
                React__default.createElement("path", { d: "M7.05.747a.3.3 0 0 0-.3.3v1.07c0 .46-.32.852-.746 1.028-.435.179-.841.415-1.209.699-.364.281-.863.361-1.261.131l-.928-.535a.3.3 0 0 0-.41.11l-.95 1.645a.3.3 0 0 0 .11.41l.925.534c.399.23.579.702.518 1.159a5.296 5.296 0 0 0-.001 1.4c.06.456-.12.928-.518 1.158l-.924.534a.3.3 0 0 0-.11.41l.95 1.645a.3.3 0 0 0 .41.11l.924-.533c.399-.23.898-.15 1.262.132.368.285.775.521 1.212.701.426.176.746.567.746 1.028v1.064a.3.3 0 0 0 .3.3h1.9a.3.3 0 0 0 .3-.3v-1.063c0-.461.32-.853.746-1.029.437-.18.844-.416 1.212-.701.365-.282.864-.363 1.262-.132l.924.533a.3.3 0 0 0 .41-.11l.95-1.645a.3.3 0 0 0-.11-.41l-.924-.534c-.399-.23-.578-.702-.518-1.158a5.29 5.29 0 0 0 0-1.4c-.061-.457.118-.929.517-1.16l.925-.533a.3.3 0 0 0 .11-.41l-.95-1.645a.3.3 0 0 0-.41-.11l-.928.535c-.398.23-.897.15-1.261-.131a5.243 5.243 0 0 0-1.21-.7c-.425-.175-.745-.567-.745-1.027v-1.07a.3.3 0 0 0-.3-.3h-1.9Z" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "a" },
                    React__default.createElement("path", { fill: "#fff", d: "M0 0h16v16H0z" }))))),
        arrowDownMini: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16" },
            React__default.createElement("path", { d: "m8 10.25 4.25-4.5", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "m8 10.25-4.25-4.5", strokeWidth: "1.5", strokeLinecap: "round" }))),
        arrowUpMini: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16" },
            React__default.createElement("path", { d: "m8 6.75 4.25 4.5", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "m8 6.75-4.25 4.5", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrowLeftMini: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16" },
            React__default.createElement("path", { d: "m5.75 8 3.5 4.25", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "m5.75 8 3.5-4.25", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        arrowRightMini: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16" },
            React__default.createElement("path", { d: "m10.25 8-3.5 4.25", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round" }),
            React__default.createElement("path", { d: "m10.25 8-3.5-4.25", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        message_fill: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_1403_449)" },
                React__default.createElement("path", { d: "M0 6C0 11.346 1.87252 14.0578 3.0552 15.2375C3.37167 15.5531 3.84823 15.2426 3.85047 14.7956C3.85792 13.3161 4.57606 11 9 11C15.5 11 0 -1.81343 0 6Z", fill: strokeSecond }),
                React__default.createElement("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V9C16 10.1046 15.1046 11 14 11H4C1.79086 11 0 9.20914 0 7V2Z" }),
                React__default.createElement("path", { d: "M5.49854 5.5H5.49954M8.49954 5.5H8.50054M11.5005 5.5H11.5015", stroke: "white", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_1403_449" },
                    React__default.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
        file_upload_fill: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M2 2C2 0.895431 2.89543 0 4 0H9.51938C9.82316 0 10.1105 0.13809 10.3002 0.375305L13.7809 4.72609C13.9227 4.9034 14 5.12371 14 5.35078V14C14 15.1046 13.1046 16 12 16H4C2.89543 16 2 15.1046 2 14V2Z", stroke: "" }),
            React__default.createElement("path", { d: "M8.00487 11.7461C8.00487 9.40368 8.00487 5.00001 8.00487 5.00001M8.00487 5.00001L11 7.99609M8.00487 5.00001L5 7.99609", stroke: "#FFFFFF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: strokeSecond }))),
        file_upload: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 12 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8.00487 11.7461C8.00487 9.40368 8.00487 5.00001 8.00487 5.00001M8.00487 5.00001L11 7.99609M8.00487 5.00001L5 7.99609", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5", fill: "none" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: strokeSecond, strokeWidth: "0" }))),
        function_fill: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M3.3 16C3.13431 16 3 15.8657 3 15.7V14.8648C3 14.6991 3.13431 14.5648 3.3 14.5648H3.92137C4.39387 14.5648 4.78368 14.4348 5.09081 14.175C5.39793 13.9151 5.61646 13.4662 5.7464 12.8283L7.35219 5.28812C7.36399 5.2327 7.42739 5.20599 7.47529 5.23624C7.54428 5.27981 7.51341 5.38649 7.43182 5.38649H5.58571C5.42003 5.38649 5.28571 5.25217 5.28571 5.08649V4.30443C5.28571 4.13874 5.42003 4.00443 5.58571 4.00443H7.69668C7.77265 4.00443 7.80621 4.1001 7.74689 4.14756C7.68795 4.19472 7.60239 4.14196 7.61805 4.06812L7.81949 3.11849C8.03212 2.12625 8.42783 1.35843 9.00664 0.815061C9.59727 0.271687 10.3769 0 11.3455 0H12.0023C12.168 0 12.3023 0.134315 12.3023 0.3V1.15293C12.3023 1.31862 12.168 1.45293 12.0023 1.45293H11.505C10.9734 1.45293 10.5541 1.58287 10.247 1.84275C9.93983 2.09081 9.71539 2.53968 9.57364 3.18937L9.37953 4.11517C9.36427 4.18793 9.27342 4.21339 9.22257 4.15915C9.16756 4.10047 9.20917 4.00443 9.2896 4.00443H11.2227C11.3884 4.00443 11.5227 4.13874 11.5227 4.30443V5.08649C11.5227 5.25217 11.3884 5.38649 11.2227 5.38649H9.05768C8.9851 5.38649 8.9571 5.29201 9.01794 5.25246C9.07249 5.217 9.14263 5.26532 9.12895 5.32892L7.50055 12.8992C7.28793 13.8915 6.89221 14.6534 6.3134 15.1849C5.7464 15.7283 4.9845 16 4.02769 16H3.3Z" }))),
        function: (React__default.createElement("svg", { style: style, className: clsName, width: width !== null && width !== void 0 ? width : '100%', height: height !== null && height !== void 0 ? height : '100%', viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M3.3 16C3.13431 16 3 15.8657 3 15.7V14.8648C3 14.6991 3.13431 14.5648 3.3 14.5648H3.92137C4.39387 14.5648 4.78368 14.4348 5.09081 14.175C5.39793 13.9151 5.61646 13.4662 5.7464 12.8283L7.35219 5.28812C7.36399 5.2327 7.42739 5.20599 7.47529 5.23624C7.54428 5.27981 7.51341 5.38649 7.43182 5.38649H5.58571C5.42003 5.38649 5.28571 5.25217 5.28571 5.08649V4.30443C5.28571 4.13874 5.42003 4.00443 5.58571 4.00443H7.69668C7.77265 4.00443 7.80621 4.1001 7.74689 4.14756C7.68795 4.19472 7.60239 4.14196 7.61805 4.06812L7.81949 3.11849C8.03212 2.12625 8.42783 1.35843 9.00664 0.815061C9.59727 0.271687 10.3769 0 11.3455 0H12.0023C12.168 0 12.3023 0.134315 12.3023 0.3V1.15293C12.3023 1.31862 12.168 1.45293 12.0023 1.45293H11.505C10.9734 1.45293 10.5541 1.58287 10.247 1.84275C9.93983 2.09081 9.71539 2.53968 9.57364 3.18937L9.37953 4.11517C9.36427 4.18793 9.27342 4.21339 9.22257 4.15915C9.16756 4.10047 9.20917 4.00443 9.2896 4.00443H11.2227C11.3884 4.00443 11.5227 4.13874 11.5227 4.30443V5.08649C11.5227 5.25217 11.3884 5.38649 11.2227 5.38649H9.05768C8.9851 5.38649 8.9571 5.29201 9.01794 5.25246C9.07249 5.217 9.14263 5.26532 9.12895 5.32892L7.50055 12.8992C7.28793 13.8915 6.89221 14.6534 6.3134 15.1849C5.7464 15.7283 4.9845 16 4.02769 16H3.3Z" }),
            React__default.createElement("path", { d: "M5.58564 5.38649H7.71311H8.81167H11.2226C11.3883 5.38649 11.5226 5.25217 11.5226 5.08649V4.30443C11.5226 4.13874 11.3883 4.00443 11.2226 4.00443H9.07745H7.92573H5.58564C5.41996 4.00443 5.28564 4.13874 5.28564 4.30443V5.08649C5.28564 5.25217 5.41996 5.38649 5.58564 5.38649Z", fill: strokeSecond }),
            React__default.createElement("path", { d: "M8.00487 11.7461C8.00487 9.40368 8.00487 5.00001 8.00487 5.00001M8.00487 5.00001L11 7.99609M8.00487 5.00001L5 7.99609", stroke: strokeSecond, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 2C2.75 1.30964 3.30964 0.75 4 0.75H9.51938C9.59532 0.75 9.66715 0.784522 9.71459 0.843827L13.1952 5.19461C13.2307 5.23894 13.25 5.29401 13.25 5.35078V14C13.25 14.6904 12.6904 15.25 12 15.25H4C3.30964 15.25 2.75 14.6904 2.75 14V2Z", strokeWidth: "1.5", fill: "none" }),
            React__default.createElement("path", { d: "M10 5V0.121094L10.063 0.161085C10.1558 0.219959 10.2382 0.29372 10.307 0.379404L13.757 4.67705C13.8043 4.73591 13.8447 4.79993 13.8776 4.86789L13.9414 5H10Z", fill: strokeSecond, strokeWidth: "0" }))),
    };
};

var css_248z$q = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.sprite-stroke-primary-color {\n  transition: 0.3s;\n  /* Продуктовые цвета */\n  /* ofd */\n  /* gosotchet */\n  /* td */\n  /* edo */\n  /* epd */\n  /* arenda */\n  /* marking */\n  /* check-index */\n  /* big-data */\n  /* МЧД */\n  /* ЕЛК */\n  /* ------------- ТЕМЫ -----------*/\n  /* success */\n  /* info */\n  /* warn */\n  /* error */\n  /* grey */\n  /* common */\n  /* white */\n  /* primary */\n}\n.sprite-stroke-primary-color__default {\n  stroke: #ffffff;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__ofd {\n  stroke: #4ba1a5;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__gosotchet {\n  stroke: #488bca;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__td {\n  stroke: #ea8242;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__edo {\n  stroke: #f5a91b;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__epd {\n  stroke: #f5a91b;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__arenda {\n  stroke: #d58576;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__marking {\n  stroke: #4bb9ba;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__check-index {\n  stroke: #5bc0de;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__big-data {\n  stroke: #5ab8c5;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__mchd {\n  stroke: #626ab7;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__elk {\n  stroke: #577590;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__success {\n  stroke: #8bc34a;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__info {\n  stroke: #5bc0de;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__warning {\n  stroke: #dcae1d;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__error {\n  stroke: #d12e34;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__grey {\n  stroke: #d6d6d6;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__common {\n  stroke: #254e5f;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__white {\n  stroke: #ffffff;\n  fill: transparent;\n}\n.sprite-stroke-primary-color__primary {\n  stroke: #4ba1a5;\n  fill: transparent;\n}\n\n/* --------------------- Копия stroke для fill'ов ---------------------- */\n.sprite-fill-primary-color {\n  fill: #ffffff;\n  /* ofd */\n  /* gosotchet */\n  /* td */\n  /* edo */\n  /* epd */\n  /* arenda */\n  /* marking */\n  /* check-index */\n  /* big-data */\n  /* МЧД */\n  /* ЕЛК */\n  /* ------------- ТЕМЫ -----------*/\n  /* success */\n  /* info */\n  /* warn */\n  /* primary */\n  /* error */\n  /* grey */\n  /* common */\n}\n.sprite-fill-primary-color__default {\n  fill: #c7c7cc;\n}\n.sprite-fill-primary-color__ofd {\n  fill: #4ba1a5;\n}\n.sprite-fill-primary-color__gosotchet {\n  fill: #488bca;\n}\n.sprite-fill-primary-color__td {\n  fill: #ea8242;\n}\n.sprite-fill-primary-color__edo {\n  fill: #f5a91b;\n}\n.sprite-fill-primary-color__epd {\n  fill: #f5a91b;\n}\n.sprite-fill-primary-color__arenda {\n  fill: #d58576;\n}\n.sprite-fill-primary-color__marking {\n  fill: #4bb9ba;\n}\n.sprite-fill-primary-color__check-index {\n  fill: #5bc0de;\n}\n.sprite-fill-primary-color__big-data {\n  fill: #5ab8c5;\n}\n.sprite-fill-primary-color__mchd {\n  fill: #626ab7;\n}\n.sprite-fill-primary-color__elk {\n  fill: #577590;\n}\n.sprite-fill-primary-color__success {\n  fill: #8bc34a;\n}\n.sprite-fill-primary-color__info {\n  fill: #5bc0de;\n}\n.sprite-fill-primary-color__warning {\n  fill: #dcae1d;\n}\n.sprite-fill-primary-color__primary {\n  fill: #4ba1a5;\n}\n.sprite-fill-primary-color__error {\n  fill: #d12e34;\n}\n.sprite-fill-primary-color__grey {\n  fill: #d6d6d6;\n}\n.sprite-fill-primary-color__common {\n  fill: #254e5f;\n}\n.sprite-fill-primary-color__white {\n  fill: #ffffff;\n}";
styleInject(css_248z$q);

const Icon = memo$1((props) => {
    const { name } = props;
    const icons = useIcons(props);
    return name && icons[name];
});
Icon.displayName = 'Icon';

/**
 * Primary UI component for user interaction
 */
const Button = ({ styleType, size = 'medium', label = '', title, type = 'button', product, theme, isIconTheme = false, disabled = false, onClick, leftIcon, loading, rightIcon, aside, iconStroke, strokeSecond = '', iconFill, iconWidth, iconHeight, testId, className, buttonStyles, }) => (React__default.createElement("button", { type: type, disabled: disabled, onClick: onClick, "data-testid": testId, title: title !== null && title !== void 0 ? title : (typeof label === 'string' ? label : ''), style: buttonStyles, className: [
        className,
        'storybook-button',
        `storybook-button--${size}`,
        `${aside && leftIcon ? 'storybook-button--aside' : ''}`,
        `${leftIcon || rightIcon ? 'storybook-button--icon' : ''}`,
        `storybook-button--${styleType}`,
        !label && leftIcon !== null ? 'storybook-button__without_label' : '',
        `${product}`,
        `${theme || ''}`,
    ].join(' ') },
    leftIcon && (React__default.createElement(Icon, { name: leftIcon, product: styleType !== 'primary' && styleType !== 'aside-secondary' ? product : 'default', theme: !isIconTheme ? theme : undefined, iconFill: iconFill, strokeSecond: strokeSecond, iconStroke: iconStroke, width: iconWidth, height: iconHeight })),
    label ? React__default.createElement("span", { className: "storybook-button--text" }, label) : null,
    rightIcon && (React__default.createElement(Icon, { name: rightIcon, product: styleType !== 'primary' && styleType !== 'aside-secondary' ? product : 'default', theme: !isIconTheme ? theme : undefined, iconFill: iconFill, iconStroke: iconStroke, strokeSecond: strokeSecond, width: iconWidth, height: iconHeight })),
    loading ? React__default.createElement("div", { className: ['storybook-button--progress', `${product}`].join(' ') }) : null));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var css_248z$p = ".CopyToClipboard-module_button__x9Ojv {\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  padding: 0;\n}\n\n.CopyToClipboard-module_animate__RHk8A {\n  animation-name: CopyToClipboard-module_tap__JLXWJ;\n  animation-duration: 3s;\n}\n\n.CopyToClipboard-module_icon__Njqud {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@keyframes CopyToClipboard-module_tap__JLXWJ {\n  0% {\n    scale: 1;\n  }\n  5% {\n    scale: 0.5;\n  }\n  10% {\n    scale: 1;\n  }\n  90% {\n    scale: 1;\n  }\n  95% {\n    scale: 0.5;\n  }\n  100% {\n    scale: 1;\n  }\n}";
var s$f = {"button":"CopyToClipboard-module_button__x9Ojv","animate":"CopyToClipboard-module_animate__RHk8A","tap":"CopyToClipboard-module_tap__JLXWJ","icon":"CopyToClipboard-module_icon__Njqud"};
styleInject(css_248z$p);

const COPIED_TIME = 3000;
const CopyToClipboard = ({ value, className, product, iconHeight = '16', iconWidth = '16', }) => {
    const [copied, setCopied] = useState(false);
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, COPIED_TIME);
        }
        catch (err) {
            console.error('Failed to copy:', err);
        }
    });
    return (React__default.createElement("button", { className: cn$i(s$f.button, className, { [s$f.animate]: copied }), onClick: handleClick, disabled: copied },
        React__default.createElement("div", { className: s$f.icon },
            React__default.createElement(Icon, { name: copied ? 'flowStatusOk' : 'copy_secondary', product: product, width: iconWidth, height: iconHeight, iconStroke: !copied }))));
};
var CopyToClipboard$1 = memo$1(CopyToClipboard);

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var moment$1 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
	    module.exports = factory() ;
	}(commonjsGlobal, (function () {
	    var hookCallback;

	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }

	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }

	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }

	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }

	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }

	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }

	    function isUndefined(input) {
	        return input === void 0;
	    }

	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }

	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }

	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }

	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }

	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }

	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }

	        return a;
	    }

	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }

	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }

	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }

	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;

	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }

	            return false;
	        };
	    }

	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }

	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }

	        return m;
	    }

	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;

	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;

	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }

	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }

	        return to;
	    }

	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }

	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }

	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }

	    function deprecate(msg, fn) {
	        var firstTime = true;

	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }

	    var deprecations = {};

	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }

	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;

	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }

	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }

	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }

	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }

	    var keys;

	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }

	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };

	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }

	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }

	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};

	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }

	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }

	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;

	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }

	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }

	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }

	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);

	        return formatFunctions[format](m);
	    }

	    function expandFormat(format, locale) {
	        var i = 5;

	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }

	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }

	        return format;
	    }

	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };

	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];

	        if (format || !formatUpper) {
	            return format;
	        }

	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');

	        return this._longDateFormat[key];
	    }

	    var defaultInvalidDate = 'Invalid date';

	    function invalidDate() {
	        return this._invalidDate;
	    }

	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }

	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };

	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }

	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }

	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };

	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }

	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;

	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }

	        return normalizedInput;
	    }

	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };

	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }

	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;

	    regexes = {};

	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }

	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }

	        return regexes[token](config._strict, config._locale);
	    }

	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }

	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }

	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }

	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;

	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }

	        return value;
	    }

	    var tokens = {};

	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }

	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }

	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }

	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }

	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;

	    // FORMATTING

	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });

	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });

	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

	    // PARSING

	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);

	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });

	    // HELPERS

	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }

	    // HOOKS

	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };

	    // MOMENTS

	    var getSetYear = makeGetSet('FullYear', true);

	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }

	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }

	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }

	        var d = mom._d,
	            isUTC = mom._isUTC;

	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }

	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;

	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }

	        d = mom._d;
	        isUTC = mom._isUTC;

	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }

	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }

	    // MOMENTS

	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }

	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }

	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }

	    var indexOf;

	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }

	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }

	    // FORMATTING

	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });

	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });

	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });

	    // PARSING

	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });

	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });

	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });

	    // LOCALES

	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;

	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }

	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }

	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;

	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }

	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }

	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }

	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }

	        var month = value,
	            date = mom.date();

	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }

	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }

	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }

	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }

	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }

	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);

	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }

	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }

	        return date;
	    }

	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }

	        return date;
	    }

	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

	        return -fwdlw + fwd - 1;
	    }

	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;

	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }

	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }

	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;

	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }

	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }

	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }

	    // FORMATTING

	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

	    // PARSING

	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);

	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );

	    // HELPERS

	    // LOCALES

	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }

	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };

	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }

	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }

	    // MOMENTS

	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    // FORMATTING

	    addFormatToken('d', 0, 'do', 'day');

	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });

	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });

	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });

	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');

	    // PARSING

	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });

	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });

	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });

	    // HELPERS

	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }

	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }

	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }

	        return null;
	    }

	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }

	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }

	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;

	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }

	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }

	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }

	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];

	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;

	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }

	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }

	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already

	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }

	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }

	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }

	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }

	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.

	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }

	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }

	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }

	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }

	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);

	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;

	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }

	    // FORMATTING

	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }

	    function kFormat() {
	        return this.hours() || 24;
	    }

	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);

	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });

	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });

	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }

	    meridiem('a', true);
	    meridiem('A', false);

	    // PARSING

	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }

	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);

	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);

	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });

	    // LOCALES

	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }

	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);

	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }

	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,

	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,

	        week: defaultLocaleWeek,

	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,

	        meridiemParse: defaultLocaleMeridiemParse,
	    };

	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;

	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }

	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }

	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;

	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }

	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }

	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            'object' !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = commonjsRequire;
	                aliasedRequire('./locale/' + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }

	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }

	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }

	        return globalLocale._abbr;
	    }

	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));

	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }

	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);

	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }

	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;

	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }

	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }

	    // returns locale data
	    function getLocale(key) {
	        var locale;

	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }

	        if (!key) {
	            return globalLocale;
	        }

	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }

	        return chooseLocale(key);
	    }

	    function listLocales() {
	        return keys(locales);
	    }

	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;

	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;

	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }

	            getParsingFlags(m).overflow = overflow;
	        }

	        return m;
	    }

	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };

	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;

	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }

	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];

	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }

	        return result;
	    }

	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }

	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }

	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }

	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }

	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }

	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);

	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }

	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }

	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }

	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }

	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }

	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );

	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }

	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }

	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;

	        if (config._d) {
	            return;
	        }

	        currentDate = currentDateArray(config);

	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }

	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }

	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }

	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }

	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }

	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }

	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();

	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }

	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }

	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }

	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;

	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;

	            curWeek = weekOfYear(createLocal(), dow, doy);

	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

	            // Default to current week.
	            week = defaults(w.w, curWeek.week);

	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }

	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};

	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};

	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;

	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;

	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }

	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }

	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }

	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );

	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }

	        configFromArray(config);
	        checkOverflow(config);
	    }

	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;

	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }

	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;

	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }

	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);

	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }

	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;

	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

	            getParsingFlags(tempConfig).score = currentScore;

	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }

	        extend(config, bestMoment || tempConfig);
	    }

	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }

	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );

	        configFromArray(config);
	    }

	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }

	        return res;
	    }

	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;

	        config._locale = config._locale || getLocale(config._l);

	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }

	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }

	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }

	        if (!isValid(config)) {
	            config._d = null;
	        }

	        return config;
	    }

	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }

	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};

	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }

	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }

	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;

	        return createFromConfig(c);
	    }

	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }

	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );

	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }

	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isBefore', args);
	    }

	    function max() {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isAfter', args);
	    }

	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };

	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];

	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }

	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }

	        return true;
	    }

	    function isValid$1() {
	        return this._isValid;
	    }

	    function createInvalid$1() {
	        return createDuration(NaN);
	    }

	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;

	        this._isValid = isDurationValid(normalizedInput);

	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;

	        this._data = {};

	        this._locale = getLocale();

	        this._bubble();
	    }

	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }

	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }

	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }

	    // FORMATTING

	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }

	    offset('Z', ':');
	    offset('ZZ', '');

	    // PARSING

	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });

	    // HELPERS

	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;

	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;

	        if (matches === null) {
	            return null;
	        }

	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);

	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }

	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }

	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }

	    // HOOKS

	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};

	    // MOMENTS

	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }

	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }

	            this.utcOffset(input, keepLocalTime);

	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }

	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }

	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;

	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }

	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }

	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;

	        return (this.utcOffset() - input) % 60 === 0;
	    }

	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }

	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }

	        var c = {},
	            other;

	        copyConfig(c, this);
	        c = prepareConfig(c);

	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }

	        return this._isDSTShifted;
	    }

	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }

	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }

	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }

	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;

	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );

	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }

	        ret = new Duration(duration);

	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }

	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }

	        return ret;
	    }

	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;

	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }

	    function positiveMomentsDifference(base, other) {
	        var res = {};

	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }

	        res.milliseconds = +other - +base.clone().add(res.months, 'M');

	        return res;
	    }

	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }

	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }

	        return res;
	    }

	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }

	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }

	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);

	        if (!mom.isValid()) {
	            // No op
	            return;
	        }

	        updateOffset = updateOffset == null ? true : updateOffset;

	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }

	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');

	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }

	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }

	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;

	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }

	        return objectTest && propertyTest;
	    }

	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }

	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;

	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }

	        return objectTest && propertyTest;
	    }

	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }

	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);

	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }

	    function clone() {
	        return new Moment(this);
	    }

	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }

	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }

	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }

	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }

	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }

	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }

	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;

	        if (!this.isValid()) {
	            return NaN;
	        }

	        that = cloneWithOffset(input, this);

	        if (!that.isValid()) {
	            return NaN;
	        }

	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

	        units = normalizeUnits(units);

	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }

	        return asFloat ? output : absFloor(output);
	    }

	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;

	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }

	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }

	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }

	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }

	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';

	        return this.format(prefix + year + datetime + suffix);
	    }

	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }

	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }

	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }

	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;

	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }

	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );

	    function localeData() {
	        return this._locale;
	    }

	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }

	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }

	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }

	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }

	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }

	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }

	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }

	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }

	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }

	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }

	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }

	    function toDate() {
	        return new Date(this.valueOf());
	    }

	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }

	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }

	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }

	    function isValid$2() {
	        return isValid(this);
	    }

	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }

	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }

	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }

	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);

	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );

	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);

	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }

	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });

	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }

	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }

	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();

	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();

	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;

	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;

	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }

	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }

	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }

	        return '';
	    }

	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }

	        return '';
	    }

	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }

	        return '';
	    }

	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;

	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }

	        return this.year();
	    }

	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }

	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }

	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }

	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }

	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }

	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }

	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }

	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();

	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);

	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }

	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }

	    // FORMATTING

	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });

	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });

	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }

	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

	    // ALIASES

	    // PARSING

	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);

	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );

	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });

	    // MOMENTS

	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }

	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }

	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }

	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }

	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }

	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }

	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }

	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }

	    // FORMATTING

	    addFormatToken('Q', 0, 'Qo', 'quarter');

	    // PARSING

	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });

	    // MOMENTS

	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }

	    // FORMATTING

	    addFormatToken('D', ['DD', 2], 'Do', 'date');

	    // PARSING

	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });

	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });

	    // MOMENTS

	    var getSetDayOfMonth = makeGetSet('Date', true);

	    // FORMATTING

	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

	    // PARSING

	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });

	    // HELPERS

	    // MOMENTS

	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }

	    // FORMATTING

	    addFormatToken('m', ['mm', 2], 0, 'minute');

	    // PARSING

	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);

	    // MOMENTS

	    var getSetMinute = makeGetSet('Minutes', false);

	    // FORMATTING

	    addFormatToken('s', ['ss', 2], 0, 'second');

	    // PARSING

	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);

	    // MOMENTS

	    var getSetSecond = makeGetSet('Seconds', false);

	    // FORMATTING

	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });

	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });

	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });

	    // PARSING

	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);

	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }

	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }

	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }

	    getSetMillisecond = makeGetSet('Milliseconds', false);

	    // FORMATTING

	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');

	    // MOMENTS

	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }

	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }

	    var proto = Moment.prototype;

	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );

	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }

	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }

	    function preParsePostFormat(string) {
	        return string;
	    }

	    var proto$1 = Locale.prototype;

	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;

	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;

	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;

	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;

	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }

	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }

	        format = format || '';

	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }

	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }

	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;

	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        }

	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];

	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }

	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }

	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }

	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }

	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }

	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }

	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }

	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });

	    // Side effect imports

	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );

	    var mathAbs = Math.abs;

	    function abs() {
	        var data = this._data;

	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);

	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);

	        return this;
	    }

	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);

	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;

	        return duration._bubble();
	    }

	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }

	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }

	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }

	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;

	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }

	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;

	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;

	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;

	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;

	        days += absFloor(hours / 24);

	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));

	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;

	        data.days = days;
	        data.months = months;
	        data.years = years;

	        return this;
	    }

	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }

	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }

	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;

	        units = normalizeUnits(units);

	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }

	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }

	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;

	    function clone$1() {
	        return createDuration(this);
	    }

	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }

	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }

	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');

	    function weeks() {
	        return absFloor(this.days() / 7);
	    }

	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };

	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }

	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);

	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];

	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }

	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }

	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }

	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }

	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;

	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }

	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);

	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }

	        return locale.postformat(output);
	    }

	    var abs$1 = Math.abs;

	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }

	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }

	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;

	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }

	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;

	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;

	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }

	    var proto$2 = Duration.prototype;

	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;

	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;

	    // FORMATTING

	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');

	    // PARSING

	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });

	    //! moment.js

	    hooks.version = '2.30.1';

	    setHookCallback(createLocal);

	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;

	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };

	    return hooks;

	}))); 
} (moment$1));

var momentExports = moment$1.exports;
var moment = /*@__PURE__*/getDefaultExportFromCjs(momentExports);

const getPureStreet = (string) => {
    const breakWords = [
        'огрн=',
        'ogrn=',
        'снилс=',
        'snils=',
        'inn=',
        'инн=',
        'инн организации=',
        'e=',
        'o=',
        'ou=',
        't=',
        'cn=',
        'sn=',
        'c=',
        'l=',
        's=',
        'g=',
        'cn=',
        'ogrnip=',
        'огрнип=',
    ];
    let result = breakWords.reduce((res, item) => {
        const index = String(string).toLowerCase().indexOf(item);
        if (index > -1) {
            res = res.substring(0, index);
        }
        return res;
    }, string);
    result = result.replace(/['"«»]/g, '');
    return result;
};
const getValueFromCertificateDescription = (source, name, exclusion) => {
    var _a;
    if (!source || source.length === 0) {
        return null;
    }
    if (exclusion) {
        source = source.replace(exclusion, '#');
    }
    const index = source.indexOf(name);
    if (index >= 0) {
        let value = source.slice(index + name.length);
        if (name === 'INNLE=' ||
            name === 'INN=' ||
            name === 'ИНН=' ||
            name === 'KPP=' ||
            name === 'КПП=' ||
            name === 'OGRNIP=' ||
            name === 'ОГРНИП=' ||
            name === 'ОГРН=' ||
            name === 'OGRN=') {
            value = ((_a = value.match(/\d+/)) === null || _a === void 0 ? void 0 : _a[0]) || '';
        }
        let next;
        if (name === 'STREET=') {
            next = 10000;
            value = value.substring(0, next);
            value = getPureStreet(value);
        }
        else {
            next = value.indexOf(',');
            if (next > 0) {
                value = value.substring(0, next);
            }
        }
        return value;
    }
};
const makeReadableCertificate = (loadedCertificate) => {
    try {
        const fields = {};
        fields.company = getValueFromCertificateDescription(loadedCertificate.subjectName, 'CN=');
        if (!fields.company) {
            fields.company = 'Без названия';
        }
        fields.inn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'INNLE=');
        if (!fields.inn) {
            fields.inn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'ИНН ЮЛ=');
        }
        if (!fields.inn) {
            fields.inn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'OID.1.2.643.100.4=');
        }
        if (!fields.inn) {
            fields.inn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'ИНН=');
        }
        if (!fields.inn) {
            fields.inn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'INN=');
        }
        if (!fields.inn) {
            fields.inn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'ИНН организации=');
        }
        if (!fields.inn) {
            fields.inn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'OID.1.2.643.3.131.1.1=');
        }
        fields.email = getValueFromCertificateDescription(loadedCertificate.subjectName, 'E=');
        fields.city = getValueFromCertificateDescription(loadedCertificate.subjectName, 'L=');
        fields.street = getValueFromCertificateDescription(loadedCertificate.subjectName, 'STREET=');
        fields.surname = getValueFromCertificateDescription(loadedCertificate.subjectName, 'SN=');
        fields.givenName = getValueFromCertificateDescription(loadedCertificate.subjectName, 'G=');
        if (!fields.givenName) {
            fields.givenName = fields.company;
        }
        fields.fio = fields.surname && fields.givenName ? fields.surname + ' ' + fields.givenName : null;
        fields.position = getValueFromCertificateDescription(loadedCertificate.subjectName, 'T=', 'STREET');
        fields.displayDate = loadedCertificate.validTo
            ? moment(loadedCertificate.validTo).format('DD.MM.YYYY | HH:mm') || loadedCertificate.validTo
            : 'не удалось получить дату';
        fields.startDate = loadedCertificate.validFrom
            ? moment(loadedCertificate.validFrom).format('DD.MM.YYYY HH:mm') || loadedCertificate.validFrom
            : 'не удалось получить дату';
        fields.snils = getValueFromCertificateDescription(loadedCertificate.subjectName, 'СНИЛС=');
        if (!fields.snils) {
            fields.snils = getValueFromCertificateDescription(loadedCertificate.subjectName, 'SNILS=');
        }
        if (!fields.snils) {
            fields.snils = getValueFromCertificateDescription(loadedCertificate.subjectName, 'OID.1.2.643.100.3=');
        }
        fields.ogrn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'ОГРН=');
        if (!fields.ogrn) {
            fields.ogrn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'OGRN=');
        }
        if (!fields.ogrn) {
            fields.ogrn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'ОГРНИП=');
        }
        if (!fields.ogrn) {
            fields.ogrn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'OGRNIP=');
        }
        if (!fields.ogrn) {
            fields.ogrn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'OID.1.2.643.100.1=');
        }
        if (!fields.ogrn) {
            fields.ogrn = getValueFromCertificateDescription(loadedCertificate.subjectName, 'OID.1.2.643.100.5=');
        }
        fields.kpp = getValueFromCertificateDescription(loadedCertificate.subjectName, 'КПП=');
        if (!fields.kpp) {
            fields.kpp = getValueFromCertificateDescription(loadedCertificate.subjectName, 'OID.1.2.643.100.4=');
        }
        if (fields.inn && fields.inn.length === 12 && fields.inn.substring(0, 2) === '00') {
            fields.inn = fields.inn.substring(2);
        }
        fields.thumbprint = loadedCertificate.thumbprint;
        fields.issuer = getValueFromCertificateDescription(loadedCertificate.issuerName, 'O=');
        if (!fields.issuer) {
            fields.issuer = 'Без названия';
        }
        return fields;
    }
    catch (_a) {
        console.error('Ошибка в сертификате');
    }
};

var css_248z$o = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.CertificateCard-module_container__xlX2D {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  color: #333333;\n  background-color: #ffffff;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  border: 0.1rem solid #d6d6d6;\n  border-radius: 0.2rem;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n.CertificateCard-module_title__eJJDV {\n  padding: 1.4rem 2.4rem 1.4rem 1.6rem;\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  border-bottom: 0.1rem solid #eeeeee;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.CertificateCard-module_title-icon__vLpG6 {\n  width: 3.6rem;\n  height: 3.6rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f8f8;\n  border-radius: 200rem;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.CertificateCard-module_title-wrapper__gJJnc {\n  display: flex;\n  flex-direction: column;\n}\n.CertificateCard-module_title-text__KeiNi {\n  color: #858594;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n  font-weight: 600;\n}\n.CertificateCard-module_title-name__hdzjF {\n  font-weight: 700;\n}\n.CertificateCard-module_title-right-icon__70k7J {\n  margin-left: auto;\n}\n\n.CertificateCard-module_info__AbyVQ {\n  padding: 0.8rem 2.4rem 1.6rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n.CertificateCard-module_info-field__3XWMo {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n.CertificateCard-module_info-field-value__atDWm {\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.CertificateCard-module_copy__-INAh {\n  padding-bottom: 0.4rem;\n}";
var s$e = {"container":"CertificateCard-module_container__xlX2D","title":"CertificateCard-module_title__eJJDV","title-icon":"CertificateCard-module_title-icon__vLpG6","title-wrapper":"CertificateCard-module_title-wrapper__gJJnc","title-text":"CertificateCard-module_title-text__KeiNi","title-name":"CertificateCard-module_title-name__hdzjF","title-right-icon":"CertificateCard-module_title-right-icon__70k7J","info":"CertificateCard-module_info__AbyVQ","info-field":"CertificateCard-module_info-field__3XWMo","info-field-value":"CertificateCard-module_info-field-value__atDWm","copy":"CertificateCard-module_copy__-INAh"};
styleInject(css_248z$o);

const CertificateCard = ({ product, certificate, className, rightIcon, hideIssuer, customContentBackgroundColor }) => {
    var _a, _b;
    const readableCertificate = makeReadableCertificate(certificate);
    const isLE = ((_a = readableCertificate === null || readableCertificate === void 0 ? void 0 : readableCertificate.inn) === null || _a === void 0 ? void 0 : _a.length) === 10;
    return (React__default.createElement("div", { className: cn$i(s$e.container, className) },
        React__default.createElement("div", { className: s$e.title },
            React__default.createElement("div", { className: s$e['title-icon'], "data-testid": "title-icon" },
                React__default.createElement(Icon, { product: product, name: isLE ? 'briefcase_secondary' : 'user_secondary', width: "16", height: "16", iconStroke: true })),
            React__default.createElement("div", { className: s$e['title-wrapper'] },
                React__default.createElement("span", { className: s$e['title-text'], "data-testid": "title-text" }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0434\u043F\u0438\u0441\u0438"),
                React__default.createElement("span", { className: s$e['title-name'], "data-testid": 'title-name' }, isLE ? readableCertificate === null || readableCertificate === void 0 ? void 0 : readableCertificate.company : (_b = readableCertificate === null || readableCertificate === void 0 ? void 0 : readableCertificate.fio) === null || _b === void 0 ? void 0 : _b.toUpperCase())),
            (rightIcon === null || rightIcon === void 0 ? void 0 : rightIcon.name) && (React__default.createElement("div", { className: s$e['title-right-icon'], "data-testid": 'right-icon' },
                React__default.createElement(Icon, { height: "16", width: "16", iconStroke: true, strokeThird: rightIcon.strokeThird, name: rightIcon.name, product: product, theme: "grey" })))),
        React__default.createElement("div", { className: s$e.info, style: {
                backgroundColor: customContentBackgroundColor
            }, "data-testid": 'info-container' },
            isLE && (React__default.createElement("div", { className: s$e['info-field'] },
                React__default.createElement("span", { className: s$e['info-field-title'], "data-testid": 'info-field-title' }, "\u0424\u0418\u041E:"),
                React__default.createElement("span", { className: s$e['info-field-value'], "data-testid": 'info-field-value' }, readableCertificate === null || readableCertificate === void 0 ? void 0 : readableCertificate.fio))),
            !hideIssuer && (React__default.createElement("div", { className: s$e['info-field'] },
                React__default.createElement("span", { className: s$e['info-field-title'], "data-testid": "issuer-field-title" }, "\u0423\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u044E\u0449\u0438\u0439 \u0446\u0435\u043D\u0442\u0440:"),
                React__default.createElement("span", { className: s$e['info-field-value'], "data-testid": "issuer-field-value" }, readableCertificate === null || readableCertificate === void 0 ? void 0 : readableCertificate.issuer))),
            !isLE && (React__default.createElement("div", { className: s$e['info-field'] },
                React__default.createElement("span", { className: s$e['info-field-title'], "data-testid": "cert-number-title" }, "\u041D\u043E\u043C\u0435\u0440 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430:"),
                React__default.createElement("div", { className: s$e['info-field-value'] },
                    React__default.createElement("span", { "data-testid": "cert-number-value" }, readableCertificate === null || readableCertificate === void 0 ? void 0 : readableCertificate.thumbprint),
                    React__default.createElement(CopyToClipboard$1, { product: product, value: (readableCertificate === null || readableCertificate === void 0 ? void 0 : readableCertificate.thumbprint) || '', className: s$e.copy })))),
            React__default.createElement("div", { className: s$e['info-field'] },
                React__default.createElement("span", { className: s$e['info-field-title'], "data-testid": "date-to-field-title" }, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0434\u043E:"),
                React__default.createElement("span", { className: s$e['info-field-value'], "data-testid": "date-to-field-value" }, readableCertificate === null || readableCertificate === void 0 ? void 0 : readableCertificate.displayDate)))));
};
var CertificateCard$1 = memo$1(CertificateCard);

var css_248z$n = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.storybook-check {\n  position: relative;\n  border: 1px solid #eeeeee;\n  border-radius: 0.2rem;\n  background: #ffffff;\n  padding: 1rem 1rem 1rem 3.6rem;\n  color: #254e5f;\n  box-sizing: border-box;\n  font-weight: 400;\n  font-size: 14px;\n  cursor: pointer;\n  transition: 0.3s;\n  display: flex;\n  align-items: center;\n}\n\n.storybook-check--simple,\n.storybook-check--simple.storybook-check--checked {\n  border: none;\n  box-shadow: none;\n  background: none;\n  display: inline-flex;\n  position: static;\n  padding: 0.8rem;\n}\n\n.storybook-check--disabled {\n  opacity: 0.3;\n  cursor: context-menu;\n}\n\n.storybook-check:hover {\n  transition: 0.3s;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n.storybook-check__input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  outline: none;\n}\n\n.storybook-check__box {\n  position: absolute;\n  width: 1.6rem;\n  height: 1.6rem;\n  border-radius: 0.2rem;\n  left: 1rem;\n  box-sizing: border-box;\n  transition: border 0.3s;\n}\n\n.storybook-check .storybook-check__box {\n  border: 1px solid #eeeeee;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n.storybook-check--checked {\n  background: #f8f8f8;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n\n.storybook-check__input:checked + .storybook-check__box {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.35378 4.14654C1.30766 4.09879 1.25249 4.06069 1.19149 4.03449C1.13048 4.00828 1.06488 3.99449 0.998485 3.99391C0.932096 3.99334 0.866256 4.00599 0.804808 4.03113C0.74336 4.05627 0.687534 4.0934 0.640587 4.14034C0.593641 4.18729 0.556514 4.24312 0.531374 4.30456C0.506233 4.36601 0.493583 4.43185 0.49416 4.49824C0.494736 4.56463 0.50853 4.63024 0.534734 4.69124C0.560939 4.75224 0.59903 4.80742 0.646785 4.85354L3.14678 7.35354C3.24055 7.44728 3.3677 7.49993 3.50028 7.49993C3.63287 7.49993 3.76002 7.44728 3.85378 7.35354L9.35379 1.85354C9.40154 1.80742 9.43963 1.75224 9.46584 1.69124C9.49204 1.63024 9.50583 1.56463 9.50641 1.49824C9.50699 1.43185 9.49434 1.36601 9.4692 1.30456C9.44406 1.24312 9.40693 1.18729 9.35998 1.14034C9.31304 1.0934 9.25721 1.05627 9.19576 1.03113C9.13431 1.00599 9.06847 0.993338 9.00208 0.993915C8.9357 0.994492 8.87008 1.00829 8.80908 1.03449C8.74808 1.06069 8.69291 1.09879 8.64678 1.14654L3.50028 6.29304L1.35378 4.14654Z' fill='white'/%3E%3C/svg%3E%0A\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.storybook-check__box.partiallyChecked {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDExIDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNMC45Njg3NSAwLjk5ODA0OEwxMC4wMzEzIDAuOTk4MDQ3IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg==);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: #4ba1a5;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #4ba1a5, inset 0 -1px 4px #357d81;\n}\n\n.storybook-check__input--ofd:checked + .storybook-check__box {\n  background-color: #4ba1a5;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #4ba1a5, inset 0 -1px 4px #357d81;\n}\n\n.storybook-check--ofd:hover,\n.storybook-check--ofd:hover .storybook-check__box {\n  border-color: #4ba1a5;\n}\n\n.storybook-check__input--edo:checked + .storybook-check__box {\n  background-color: #f5a91b;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #f5a91b, inset 0 -1px 4px #e89700;\n}\n\n.storybook-check--edo:hover,\n.storybook-check--edo:hover .storybook-check__box {\n  border-color: #f5a91b;\n}\n\n.storybook-check__input--epd:checked + .storybook-check__box {\n  background-color: #f5a91b;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #f5a91b, inset 0 -1px 4px #e89700;\n}\n\n.storybook-check--epd:hover,\n.storybook-check--epd:hover .storybook-check__box {\n  border-color: #f5a91b;\n}\n\n.storybook-check__input--gosotchet:checked + .storybook-check__box {\n  background-color: #488bca;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #488bca, inset 0 -1px 4px #2c70af;\n}\n\n.storybook-check--gosotchet:hover,\n.storybook-check--gosotchet:hover .storybook-check__box {\n  border-color: #488bca;\n}\n\n.storybook-check__input--td:checked + .storybook-check__box {\n  background-color: #ea8242;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #ea8242, inset 0 -1px 4px #e26212;\n}\n\n.storybook-check--td:hover,\n.storybook-check--td:hover .storybook-check__box {\n  border-color: #ea8242;\n}\n\n.storybook-check__input--marking:checked + .storybook-check__box {\n  background-color: #4bb9ba;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #4bb9ba, inset 0 -1px 4px #339799;\n}\n\n.storybook-check--marking:hover,\n.storybook-check--marking:hover .storybook-check__box {\n  border-color: #4bb9ba;\n}\n\n.storybook-check__input--check-index:checked + .storybook-check__box {\n  background-color: #5bc0de;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #5bc0de, inset 0 -1px 4px #23a5cd;\n}\n\n.storybook-check--check-index:hover,\n.storybook-check--check-index:hover .storybook-check__box {\n  border-color: #5bc0de;\n}\n\n.storybook-check__input--big-data:checked + .storybook-check__box {\n  background-color: #5ab8c5;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #5ab8c5, inset 0 -1px 4px #36a1b0;\n}\n\n.storybook-check--big-data:hover,\n.storybook-check--big-data:hover .storybook-check__box {\n  border-color: #5ab8c5;\n}\n\n.storybook-check__input--arenda:checked + .storybook-check__box {\n  background-color: #d58576;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #d58576, inset 0 -1px 4px #ce5a46;\n}\n\n.storybook-check--arenda:hover,\n.storybook-check--arenda:hover .storybook-check__box {\n  border-color: #d58576;\n}\n\n.storybook-check__input--mchd:checked + .storybook-check__box {\n  background-color: #626ab7;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #626ab7, inset 0 -1px 4px #434ca3;\n}\n\n.storybook-check--mchd:hover,\n.storybook-check--mchd:hover .storybook-check__box {\n  border-color: #626ab7;\n}\n\n.storybook-check__input--elk:checked + .storybook-check__box {\n  background-color: #577590;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), inset 0 1px 4px #577590, inset 0 -1px 4px #434ca3;\n}\n\n.storybook-check--elk:hover,\n.storybook-check--elk:hover .storybook-check__box {\n  border-color: #577590;\n}\n\n.storybook-check__help-block {\n  position: absolute;\n  bottom: -1.25rem;\n  left: 1rem;\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 0.875rem;\n}\n\n.storybook-check--error {\n  border-color: #d12e34;\n}\n\n.storybook-check--error .storybook-check__help-block {\n  color: #d12e34;\n}\n\n.storybook-check--warning {\n  border-color: #dcae1d;\n}\n\n.storybook-check--warning .storybook-check__help-block {\n  color: #dcae1d;\n}\n\n.storybook-check--focus {\n  box-shadow: 0 0 0 2px #5bc0de;\n  border-color: transparent;\n}\n\n.storybook-check--focus:hover {\n  box-shadow: 0 0 0 2px #5bc0de;\n  border-color: transparent;\n}\n\n.storybook-check__item-number {\n  margin-left: 0.5rem;\n  color: #c7c7cc;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1rem;\n}\n\n.storybook-check__item-number span:first-child {\n  color: #254e5f;\n}";
styleInject(css_248z$n);

const Checkbox = ({ simple = false, label, value, checked, partiallyChecked = false, onClick, onKeyDown, product, helpBlockText, error, warning, disabled, currentIndex, totalElements, testId, labelClassName = '', inputClassName = '', checkBoxClassName = '', helpBlockClassName = '', inputTabIndex = 0, }) => {
    const [checkedFlag, setCheckedFlag] = useState(checked);
    const [focusFlag, setFocusFlag] = useState(false);
    const [partially, setPartially] = useState(partiallyChecked);
    const rootEl = useRef(null);
    const errorClass = error ? 'storybook-check--error' : null;
    const warningClass = warning ? 'storybook-check--warning' : null;
    const disabledClass = disabled ? 'storybook-check--disabled' : null;
    const handleChange = (e) => {
        setPartially(false);
        if (e.target.checked) {
            setCheckedFlag(true);
            onClick(e);
        }
        else {
            setCheckedFlag(false);
            onClick(e);
        }
    };
    useEffect(() => {
        const onAwayRootElClick = (e) => {
            if (!rootEl.current.contains(e.target)) {
                setFocusFlag(false);
            }
        };
        document.addEventListener('click', onAwayRootElClick);
        return () => document.removeEventListener('click', onAwayRootElClick);
    }, []);
    useEffect(() => {
        setCheckedFlag(checked);
    }, [checked]);
    useEffect(() => {
        setPartially(partiallyChecked);
    }, [partiallyChecked]);
    const onFocus = () => {
        setFocusFlag(true);
    };
    const onBlur = () => {
        setFocusFlag(false);
    };
    const handleCheckboxOutlineChange = (e) => {
        if (e.key === 'Enter' && focusFlag) {
            if (!checkedFlag) {
                setCheckedFlag(true);
                onKeyDown(e);
                e.currentTarget.checked = true;
            }
            else {
                setCheckedFlag(false);
                onKeyDown(e);
                e.currentTarget.checked = false;
            }
        }
    };
    return (React__default.createElement("label", { htmlFor: `checkbox-${value}`, "data-testid": "testLabel", className: [
            `storybook-check ${simple ? 'storybook-check--simple' : ''}`,
            `storybook-check--${product}`,
            checkedFlag ? 'storybook-check--checked' : null,
            focusFlag ? 'storybook-check--focus' : null,
            errorClass,
            warningClass,
            disabledClass,
            labelClassName,
        ].join(' ') },
        React__default.createElement("input", { checked: checkedFlag, "data-testid": testId, type: "checkbox", id: `checkbox-${value}`, ref: rootEl, onFocus: onFocus, onBlur: onBlur, onKeyDown: handleCheckboxOutlineChange, onChange: handleChange, value: value, disabled: disabled, className: ['storybook-check__input', `storybook-check__input--${product}`, inputClassName].join(' '), name: `checkbox-${value}`, tabIndex: inputTabIndex }),
        !simple && label,
        React__default.createElement("span", { className: `storybook-check__box ${checkBoxClassName} ${partially && 'partiallyChecked'}` }),
        !simple && currentIndex ? (React__default.createElement("span", { className: "storybook-check__item-number" },
            React__default.createElement("span", null, currentIndex),
            " /",
            React__default.createElement("span", null, totalElements))) : null,
        error || warning ? (React__default.createElement("span", { className: `storybook-check__help-block ${helpBlockClassName}` }, helpBlockText)) : null));
};

var lib = {};

var flattenNames$1 = {};

/** Detect free variable `global` from Node.js. */

var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$2;

var freeGlobal$1 = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$9 = freeGlobal$1 || freeSelf$1 || Function('return this')();

var _root = root$9;

var root$8 = _root;

/** Built-in value references. */
var Symbol$7 = root$8.Symbol;

var _Symbol = Symbol$7;

var Symbol$6 = _Symbol;

/** Used for built-in method references. */
var objectProto$u = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$o = objectProto$u.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$3 = objectProto$u.toString;

/** Built-in value references. */
var symToStringTag$3 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$o.call(value, symToStringTag$3),
      tag = value[symToStringTag$3];

  try {
    value[symToStringTag$3] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}

var _getRawTag = getRawTag$2;

/** Used for built-in method references. */

var objectProto$t = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$t.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$2(value) {
  return nativeObjectToString$2.call(value);
}

var _objectToString = objectToString$2;

var Symbol$5 = _Symbol,
    getRawTag$1 = _getRawTag,
    objectToString$1 = _objectToString;

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$8(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return (symToStringTag$2 && symToStringTag$2 in Object(value))
    ? getRawTag$1(value)
    : objectToString$1(value);
}

var _baseGetTag = baseGetTag$8;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$d = Array.isArray;

var isArray_1 = isArray$d;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$a(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$a;

var baseGetTag$7 = _baseGetTag,
    isArray$c = isArray_1,
    isObjectLike$9 = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag$6 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray$c(value) && isObjectLike$9(value) && baseGetTag$7(value) == stringTag$6);
}

var isString_1 = isString;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$2(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$2;

var createBaseFor$1 = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$2 = createBaseFor$1();

var _baseFor = baseFor$2;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$2(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$2;

var baseGetTag$6 = _baseGetTag,
    isObjectLike$8 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$6 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$2(value) {
  return isObjectLike$8(value) && baseGetTag$6(value) == argsTag$6;
}

var _baseIsArguments = baseIsArguments$2;

var baseIsArguments$1 = _baseIsArguments,
    isObjectLike$7 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$s = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$n = objectProto$s.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$3 = objectProto$s.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$3 = baseIsArguments$1(function() { return arguments; }()) ? baseIsArguments$1 : function(value) {
  return isObjectLike$7(value) && hasOwnProperty$n.call(value, 'callee') &&
    !propertyIsEnumerable$3.call(value, 'callee');
};

var isArguments_1 = isArguments$3;

var isBuffer$4 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse$1() {
  return false;
}

var stubFalse_1 = stubFalse$1;

isBuffer$4.exports;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer; 
} (isBuffer$4, isBuffer$4.exports));

var isBufferExports = isBuffer$4.exports;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$3 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$3 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint$1.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$4(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

var isLength_1 = isLength$4;

var baseGetTag$5 = _baseGetTag,
    isLength$3 = isLength_1,
    isObjectLike$6 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$5 = '[object Arguments]',
    arrayTag$4 = '[object Array]',
    boolTag$5 = '[object Boolean]',
    dateTag$5 = '[object Date]',
    errorTag$4 = '[object Error]',
    funcTag$4 = '[object Function]',
    mapTag$8 = '[object Map]',
    numberTag$5 = '[object Number]',
    objectTag$8 = '[object Object]',
    regexpTag$5 = '[object RegExp]',
    setTag$8 = '[object Set]',
    stringTag$5 = '[object String]',
    weakMapTag$4 = '[object WeakMap]';

var arrayBufferTag$5 = '[object ArrayBuffer]',
    dataViewTag$7 = '[object DataView]',
    float32Tag$3 = '[object Float32Array]',
    float64Tag$3 = '[object Float64Array]',
    int8Tag$3 = '[object Int8Array]',
    int16Tag$3 = '[object Int16Array]',
    int32Tag$3 = '[object Int32Array]',
    uint8Tag$3 = '[object Uint8Array]',
    uint8ClampedTag$3 = '[object Uint8ClampedArray]',
    uint16Tag$3 = '[object Uint16Array]',
    uint32Tag$3 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] =
typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] =
typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] =
typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] =
typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$4] =
typedArrayTags$1[arrayBufferTag$5] = typedArrayTags$1[boolTag$5] =
typedArrayTags$1[dataViewTag$7] = typedArrayTags$1[dateTag$5] =
typedArrayTags$1[errorTag$4] = typedArrayTags$1[funcTag$4] =
typedArrayTags$1[mapTag$8] = typedArrayTags$1[numberTag$5] =
typedArrayTags$1[objectTag$8] = typedArrayTags$1[regexpTag$5] =
typedArrayTags$1[setTag$8] = typedArrayTags$1[stringTag$5] =
typedArrayTags$1[weakMapTag$4] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$2(value) {
  return isObjectLike$6(value) &&
    isLength$3(value.length) && !!typedArrayTags$1[baseGetTag$5(value)];
}

var _baseIsTypedArray = baseIsTypedArray$2;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$4(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$4;

var _nodeUtil = {exports: {}};

_nodeUtil.exports;

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil; 
} (_nodeUtil, _nodeUtil.exports));

var _nodeUtilExports = _nodeUtil.exports;

var baseIsTypedArray$1 = _baseIsTypedArray,
    baseUnary$3 = _baseUnary,
    nodeUtil$3 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray$1 = nodeUtil$3 && nodeUtil$3.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$3 = nodeIsTypedArray$1 ? baseUnary$3(nodeIsTypedArray$1) : baseIsTypedArray$1;

var isTypedArray_1 = isTypedArray$3;

var baseTimes$1 = _baseTimes,
    isArguments$2 = isArguments_1,
    isArray$b = isArray_1,
    isBuffer$3 = isBufferExports,
    isIndex$2 = _isIndex,
    isTypedArray$2 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$r = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$m = objectProto$r.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$3(value, inherited) {
  var isArr = isArray$b(value),
      isArg = !isArr && isArguments$2(value),
      isBuff = !isArr && !isArg && isBuffer$3(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$2(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes$1(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$m.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$2(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$3;

/** Used for built-in method references. */

var objectProto$q = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$4(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$q;

  return value === proto;
}

var _isPrototype = isPrototype$4;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$3(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$3;

var overArg$2 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$2 = overArg$2(Object.keys, Object);

var _nativeKeys = nativeKeys$2;

var isPrototype$3 = _isPrototype,
    nativeKeys$1 = _nativeKeys;

/** Used for built-in method references. */
var objectProto$p = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$l = objectProto$p.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$2(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$l.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$2;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$7(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$7;

var baseGetTag$4 = _baseGetTag,
    isObject$6 = isObject_1;

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
    funcTag$3 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$4(value) {
  if (!isObject$6(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$4(value);
  return tag == funcTag$3 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
}

var isFunction_1 = isFunction$4;

var isFunction$3 = isFunction_1,
    isLength$2 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$5(value) {
  return value != null && isLength$2(value.length) && !isFunction$3(value);
}

var isArrayLike_1 = isArrayLike$5;

var arrayLikeKeys$2 = _arrayLikeKeys,
    baseKeys$1 = _baseKeys,
    isArrayLike$4 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$6(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$2(object) : baseKeys$1(object);
}

var keys_1 = keys$6;

var baseFor$1 = _baseFor,
    keys$5 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$3(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys$5);
}

var _baseForOwn = baseForOwn$3;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$3(value) {
  return value;
}

var identity_1 = identity$3;

var identity$2 = identity_1;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction$2(value) {
  return typeof value == 'function' ? value : identity$2;
}

var _castFunction = castFunction$2;

var baseForOwn$2 = _baseForOwn,
    castFunction$1 = _castFunction;

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn$2(object, castFunction$1(iteratee));
}

var forOwn_1 = forOwn;

var overArg$1 = _overArg;

/** Built-in value references. */
var getPrototype$4 = overArg$1(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$4;

var baseGetTag$3 = _baseGetTag,
    getPrototype$3 = _getPrototype,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag$7 = '[object Object]';

/** Used for built-in method references. */
var funcProto$5 = Function.prototype,
    objectProto$o = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$5 = funcProto$5.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$k = objectProto$o.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString$1 = funcToString$5.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$1(value) {
  if (!isObjectLike$5(value) || baseGetTag$3(value) != objectTag$7) {
    return false;
  }
  var proto = getPrototype$3(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$k.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$5.call(Ctor) == objectCtorString$1;
}

var isPlainObject_1 = isPlainObject$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$3(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$3;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$2;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$4(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$4;

var eq$3 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$5(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$3(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$5;

var assocIndexOf$4 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$2(key) {
  var data = this.__data__,
      index = assocIndexOf$4(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$2;

var assocIndexOf$3 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$2(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$2;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$2(key) {
  return assocIndexOf$2(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$2;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$2(key, value) {
  var data = this.__data__,
      index = assocIndexOf$1(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$2;

var listCacheClear$1 = _listCacheClear,
    listCacheDelete$1 = _listCacheDelete,
    listCacheGet$1 = _listCacheGet,
    listCacheHas$1 = _listCacheHas,
    listCacheSet$1 = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$5(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$5.prototype.clear = listCacheClear$1;
ListCache$5.prototype['delete'] = listCacheDelete$1;
ListCache$5.prototype.get = listCacheGet$1;
ListCache$5.prototype.has = listCacheHas$1;
ListCache$5.prototype.set = listCacheSet$1;

var _ListCache = ListCache$5;

var ListCache$4 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$2() {
  this.__data__ = new ListCache$4;
  this.size = 0;
}

var _stackClear = stackClear$2;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$2(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$2;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$2(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$2;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$2(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$2;

var root$7 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$2 = root$7['__core-js_shared__'];

var _coreJsData = coreJsData$2;

var coreJsData$1 = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = (function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$2(func) {
  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
}

var _isMasked = isMasked$2;

/** Used for built-in method references. */

var funcProto$4 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$4 = funcProto$4.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$3(func) {
  if (func != null) {
    try {
      return funcToString$4.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$3;

var isFunction$2 = isFunction_1,
    isMasked$1 = _isMasked,
    isObject$5 = isObject_1,
    toSource$2 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$3 = Function.prototype,
    objectProto$n = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$3 = funcProto$3.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$j = objectProto$n.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' +
  funcToString$3.call(hasOwnProperty$j).replace(reRegExpChar$1, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$2(value) {
  if (!isObject$5(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$2(value));
}

var _baseIsNative = baseIsNative$2;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$2;

var baseIsNative$1 = _baseIsNative,
    getValue$1 = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$8(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative$1(value) ? value : undefined;
}

var _getNative = getNative$8;

var getNative$7 = _getNative,
    root$6 = _root;

/* Built-in method references that are verified to be native. */
var Map$5 = getNative$7(root$6, 'Map');

var _Map = Map$5;

var getNative$6 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$5 = getNative$6(Object, 'create');

var _nativeCreate = nativeCreate$5;

var nativeCreate$4 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$2() {
  this.__data__ = nativeCreate$4 ? nativeCreate$4(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$2;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$2;

var nativeCreate$3 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$5 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$m = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$i = objectProto$m.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$2(key) {
  var data = this.__data__;
  if (nativeCreate$3) {
    var result = data[key];
    return result === HASH_UNDEFINED$5 ? undefined : result;
  }
  return hasOwnProperty$i.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$2;

var nativeCreate$2 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$l = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$h = objectProto$l.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$2 ? (data[key] !== undefined) : hasOwnProperty$h.call(data, key);
}

var _hashHas = hashHas$2;

var nativeCreate$1 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$2(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED$4 : value;
  return this;
}

var _hashSet = hashSet$2;

var hashClear$1 = _hashClear,
    hashDelete$1 = _hashDelete,
    hashGet$1 = _hashGet,
    hashHas$1 = _hashHas,
    hashSet$1 = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$2(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$2.prototype.clear = hashClear$1;
Hash$2.prototype['delete'] = hashDelete$1;
Hash$2.prototype.get = hashGet$1;
Hash$2.prototype.has = hashHas$1;
Hash$2.prototype.set = hashSet$1;

var _Hash = Hash$2;

var Hash$1 = _Hash,
    ListCache$3 = _ListCache,
    Map$4 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1,
    'map': new (Map$4 || ListCache$3),
    'string': new Hash$1
  };
}

var _mapCacheClear = mapCacheClear$2;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$2(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$2;

var isKeyable$1 = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$5(map, key) {
  var data = map.__data__;
  return isKeyable$1(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$5;

var getMapData$4 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$2(key) {
  var result = getMapData$4(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$2;

var getMapData$3 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$2(key) {
  return getMapData$3(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$2;

var getMapData$2 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$2(key) {
  return getMapData$2(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$2;

var getMapData$1 = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$2(key, value) {
  var data = getMapData$1(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$2;

var mapCacheClear$1 = _mapCacheClear,
    mapCacheDelete$1 = _mapCacheDelete,
    mapCacheGet$1 = _mapCacheGet,
    mapCacheHas$1 = _mapCacheHas,
    mapCacheSet$1 = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$4.prototype.clear = mapCacheClear$1;
MapCache$4.prototype['delete'] = mapCacheDelete$1;
MapCache$4.prototype.get = mapCacheGet$1;
MapCache$4.prototype.has = mapCacheHas$1;
MapCache$4.prototype.set = mapCacheSet$1;

var _MapCache = MapCache$4;

var ListCache$2 = _ListCache,
    Map$3 = _Map,
    MapCache$3 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$2(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$2) {
    var pairs = data.__data__;
    if (!Map$3 || (pairs.length < LARGE_ARRAY_SIZE$1 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$3(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$2;

var ListCache$1 = _ListCache,
    stackClear$1 = _stackClear,
    stackDelete$1 = _stackDelete,
    stackGet$1 = _stackGet,
    stackHas$1 = _stackHas,
    stackSet$1 = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$4(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$4.prototype.clear = stackClear$1;
Stack$4.prototype['delete'] = stackDelete$1;
Stack$4.prototype.get = stackGet$1;
Stack$4.prototype.has = stackHas$1;
Stack$4.prototype.set = stackSet$1;

var _Stack = Stack$4;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$2(value) {
  this.__data__.set(value, HASH_UNDEFINED$3);
  return this;
}

var _setCacheAdd = setCacheAdd$2;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$2(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$2;

var MapCache$2 = _MapCache,
    setCacheAdd$1 = _setCacheAdd,
    setCacheHas$1 = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$2(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$2;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd$1;
SetCache$2.prototype.has = setCacheHas$1;

var _SetCache = SetCache$2;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$2;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$2(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$2;

var SetCache$1 = _SetCache,
    arraySome$1 = _arraySome,
    cacheHas$1 = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$b = 1,
    COMPARE_UNORDERED_FLAG$7 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$3(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$b,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$7) ? new SetCache$1 : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome$1(other, function(othValue, othIndex) {
            if (!cacheHas$1(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$3;

var root$5 = _root;

/** Built-in value references. */
var Uint8Array$4 = root$5.Uint8Array;

var _Uint8Array = Uint8Array$4;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$2(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$2;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$2(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$2;

var Symbol$4 = _Symbol,
    Uint8Array$3 = _Uint8Array,
    eq$2 = eq_1,
    equalArrays$2 = _equalArrays,
    mapToArray$1 = _mapToArray,
    setToArray$1 = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$a = 1,
    COMPARE_UNORDERED_FLAG$6 = 2;

/** `Object#toString` result references. */
var boolTag$4 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    errorTag$3 = '[object Error]',
    mapTag$7 = '[object Map]',
    numberTag$4 = '[object Number]',
    regexpTag$4 = '[object RegExp]',
    setTag$7 = '[object Set]',
    stringTag$4 = '[object String]',
    symbolTag$5 = '[object Symbol]';

var arrayBufferTag$4 = '[object ArrayBuffer]',
    dataViewTag$6 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$4 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolValueOf$2 = symbolProto$4 ? symbolProto$4.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$2(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$6:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$4:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$3(object), new Uint8Array$3(other))) {
        return false;
      }
      return true;

    case boolTag$4:
    case dateTag$4:
    case numberTag$4:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$2(+object, +other);

    case errorTag$3:
      return object.name == other.name && object.message == other.message;

    case regexpTag$4:
    case stringTag$4:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$7:
      var convert = mapToArray$1;

    case setTag$7:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$a;
      convert || (convert = setToArray$1);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$6;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$2(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$5:
      if (symbolValueOf$2) {
        return symbolValueOf$2.call(object) == symbolValueOf$2.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$2;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$3;

var arrayPush$2 = _arrayPush,
    isArray$a = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$3(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$a(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$3;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$2;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$3() {
  return [];
}

var stubArray_1 = stubArray$3;

var arrayFilter$1 = _arrayFilter,
    stubArray$2 = stubArray_1;

/** Used for built-in method references. */
var objectProto$k = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$2 = objectProto$k.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$4 = !nativeGetSymbols$2 ? stubArray$2 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$2(object), function(symbol) {
    return propertyIsEnumerable$2.call(object, symbol);
  });
};

var _getSymbols = getSymbols$4;

var baseGetAllKeys$2 = _baseGetAllKeys,
    getSymbols$3 = _getSymbols,
    keys$4 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$3(object) {
  return baseGetAllKeys$2(object, keys$4, getSymbols$3);
}

var _getAllKeys = getAllKeys$3;

var getAllKeys$2 = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$9 = 1;

/** Used for built-in method references. */
var objectProto$j = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$j.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$2(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$9,
      objProps = getAllKeys$2(object),
      objLength = objProps.length,
      othProps = getAllKeys$2(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$g.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$2;

var getNative$5 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$5(root$4, 'DataView');

var _DataView = DataView$2;

var getNative$4 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Promise$3 = getNative$4(root$3, 'Promise');

var _Promise = Promise$3;

var getNative$3 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$3(root$2, 'Set');

var _Set = Set$3;

var getNative$2 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$3 = getNative$2(root$1, 'WeakMap');

var _WeakMap = WeakMap$3;

var DataView$1 = _DataView,
    Map$2 = _Map,
    Promise$2 = _Promise,
    Set$2 = _Set,
    WeakMap$2 = _WeakMap,
    baseGetTag$2 = _baseGetTag,
    toSource$1 = _toSource;

/** `Object#toString` result references. */
var mapTag$6 = '[object Map]',
    objectTag$6 = '[object Object]',
    promiseTag$1 = '[object Promise]',
    setTag$6 = '[object Set]',
    weakMapTag$3 = '[object WeakMap]';

var dataViewTag$5 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString$1 = toSource$1(DataView$1),
    mapCtorString$1 = toSource$1(Map$2),
    promiseCtorString$1 = toSource$1(Promise$2),
    setCtorString$1 = toSource$1(Set$2),
    weakMapCtorString$1 = toSource$1(WeakMap$2);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$5 = baseGetTag$2;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag$5(new DataView$1(new ArrayBuffer(1))) != dataViewTag$5) ||
    (Map$2 && getTag$5(new Map$2) != mapTag$6) ||
    (Promise$2 && getTag$5(Promise$2.resolve()) != promiseTag$1) ||
    (Set$2 && getTag$5(new Set$2) != setTag$6) ||
    (WeakMap$2 && getTag$5(new WeakMap$2) != weakMapTag$3)) {
  getTag$5 = function(value) {
    var result = baseGetTag$2(value),
        Ctor = result == objectTag$6 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$1(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1: return dataViewTag$5;
        case mapCtorString$1: return mapTag$6;
        case promiseCtorString$1: return promiseTag$1;
        case setCtorString$1: return setTag$6;
        case weakMapCtorString$1: return weakMapTag$3;
      }
    }
    return result;
  };
}

var _getTag = getTag$5;

var Stack$3 = _Stack,
    equalArrays$1 = _equalArrays,
    equalByTag$1 = _equalByTag,
    equalObjects$1 = _equalObjects,
    getTag$4 = _getTag,
    isArray$9 = isArray_1,
    isBuffer$2 = isBufferExports,
    isTypedArray$1 = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$8 = 1;

/** `Object#toString` result references. */
var argsTag$4 = '[object Arguments]',
    arrayTag$3 = '[object Array]',
    objectTag$5 = '[object Object]';

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$i.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$2(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$9(object),
      othIsArr = isArray$9(other),
      objTag = objIsArr ? arrayTag$3 : getTag$4(object),
      othTag = othIsArr ? arrayTag$3 : getTag$4(other);

  objTag = objTag == argsTag$4 ? objectTag$5 : objTag;
  othTag = othTag == argsTag$4 ? objectTag$5 : othTag;

  var objIsObj = objTag == objectTag$5,
      othIsObj = othTag == objectTag$5,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$2(object)) {
    if (!isBuffer$2(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$3);
    return (objIsArr || isTypedArray$1(object))
      ? equalArrays$1(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag$1(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$8)) {
    var objIsWrapped = objIsObj && hasOwnProperty$f.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$f.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$3);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$3);
  return equalObjects$1(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$2;

var baseIsEqualDeep$1 = _baseIsEqualDeep,
    isObjectLike$4 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$4(value) && !isObjectLike$4(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep$1(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;

var Stack$2 = _Stack,
    baseIsEqual$2 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$7 = 1,
    COMPARE_UNORDERED_FLAG$5 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$2(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$2;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$7 | COMPARE_UNORDERED_FLAG$5, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$2;

var isObject$4 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$3(value) {
  return value === value && !isObject$4(value);
}

var _isStrictComparable = isStrictComparable$3;

var isStrictComparable$2 = _isStrictComparable,
    keys$3 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$2(object) {
  var result = keys$3(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$2(value)];
  }
  return result;
}

var _getMatchData = getMatchData$2;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$3(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$3;

var baseIsMatch$1 = _baseIsMatch,
    getMatchData$1 = _getMatchData,
    matchesStrictComparable$2 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$2(source) {
  var matchData = getMatchData$1(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$2(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch$1(object, source, matchData);
  };
}

var _baseMatches = baseMatches$2;

var baseGetTag$1 = _baseGetTag,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$4 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$4(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$3(value) && baseGetTag$1(value) == symbolTag$4);
}

var isSymbol_1 = isSymbol$4;

var isArray$8 = isArray_1,
    isSymbol$3 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp$1 = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$4(value, object) {
  if (isArray$8(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$4;

var MapCache$1 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache$1);
  return memoized;
}

// Expose `MapCache`.
memoize$2.Cache = MapCache$1;

var memoize_1 = memoize$2;

var memoize$1 = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE$1 = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$2(func) {
  var result = memoize$1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$2;

var memoizeCapped$1 = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped$1(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$2;

var Symbol$3 = _Symbol,
    arrayMap$2 = _arrayMap,
    isArray$7 = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$7(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$2(value, baseToString$2) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

var _baseToString = baseToString$2;

var baseToString$1 = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString$1(value);
}

var toString_1 = toString$2;

var isArray$6 = isArray_1,
    isKey$3 = _isKey,
    stringToPath$1 = _stringToPath,
    toString$1 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$3(value, object) {
  if (isArray$6(value)) {
    return value;
  }
  return isKey$3(value, object) ? [value] : stringToPath$1(toString$1(value));
}

var _castPath = castPath$3;

var isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$2 = _castPath,
    toKey$4 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$3(object, path) {
  path = castPath$2(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$4(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$3;

var baseGet$2 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$3(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$2(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$3;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$2(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$2;

var castPath$1 = _castPath,
    isArguments$1 = isArguments_1,
    isArray$5 = isArray_1,
    isIndex$1 = _isIndex,
    isLength$1 = isLength_1,
    toKey$3 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$2(object, path, hasFunc) {
  path = castPath$1(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$1(length) && isIndex$1(key, length) &&
    (isArray$5(object) || isArguments$1(object));
}

var _hasPath = hasPath$2;

var baseHasIn$1 = _baseHasIn,
    hasPath$1 = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$2(object, path) {
  return object != null && hasPath$1(object, path, baseHasIn$1);
}

var hasIn_1 = hasIn$2;

var baseIsEqual$1 = _baseIsEqual,
    get$2 = get_1,
    hasIn$1 = hasIn_1,
    isKey$2 = _isKey,
    isStrictComparable$1 = _isStrictComparable,
    matchesStrictComparable$1 = _matchesStrictComparable,
    toKey$2 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$6 = 1,
    COMPARE_UNORDERED_FLAG$4 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$2(path, srcValue) {
  if (isKey$2(path) && isStrictComparable$1(srcValue)) {
    return matchesStrictComparable$1(toKey$2(path), srcValue);
  }
  return function(object) {
    var objValue = get$2(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn$1(object, path)
      : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$6 | COMPARE_UNORDERED_FLAG$4);
  };
}

var _baseMatchesProperty = baseMatchesProperty$2;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$2(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$2;

var baseGet$1 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$2(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$2;

var baseProperty$1 = _baseProperty,
    basePropertyDeep$1 = _basePropertyDeep,
    isKey$1 = _isKey,
    toKey$1 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$2(path) {
  return isKey$1(path) ? baseProperty$1(toKey$1(path)) : basePropertyDeep$1(path);
}

var property_1 = property$2;

var baseMatches$1 = _baseMatches,
    baseMatchesProperty$1 = _baseMatchesProperty,
    identity$1 = identity_1,
    isArray$4 = isArray_1,
    property$1 = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$2(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (typeof value == 'object') {
    return isArray$4(value)
      ? baseMatchesProperty$1(value[0], value[1])
      : baseMatches$1(value);
  }
  return property$1(value);
}

var _baseIteratee = baseIteratee$2;

var isArrayLike$3 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$2(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$3(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$2;

var baseForOwn$1 = _baseForOwn,
    createBaseEach$1 = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$2 = createBaseEach$1(baseForOwn$1);

var _baseEach = baseEach$2;

var baseEach$1 = _baseEach,
    isArrayLike$2 = isArrayLike_1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$2(collection, iteratee) {
  var index = -1,
      result = isArrayLike$2(collection) ? Array(collection.length) : [];

  baseEach$1(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$2;

var arrayMap$1 = _arrayMap,
    baseIteratee$1 = _baseIteratee,
    baseMap$1 = _baseMap,
    isArray$3 = isArray_1;

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map$1(collection, iteratee) {
  var func = isArray$3(collection) ? arrayMap$1 : baseMap$1;
  return func(collection, baseIteratee$1(iteratee));
}

var map_1 = map$1;

Object.defineProperty(flattenNames$1, "__esModule", {
  value: true
});
flattenNames$1.flattenNames = undefined;

var _isString2 = isString_1;

var _isString3 = _interopRequireDefault$8(_isString2);

var _forOwn2$2 = forOwn_1;

var _forOwn3$2 = _interopRequireDefault$8(_forOwn2$2);

var _isPlainObject2 = isPlainObject_1;

var _isPlainObject3 = _interopRequireDefault$8(_isPlainObject2);

var _map2 = map_1;

var _map3 = _interopRequireDefault$8(_map2);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = flattenNames$1.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3$2.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

flattenNames$1.default = flattenNames;

var mergeClasses$1 = {};

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$2;

var getNative$1 = _getNative;

var defineProperty$2 = (function() {
  try {
    var func = getNative$1(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$3 = defineProperty$2;

var defineProperty$1 = _defineProperty$3;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$3;

var baseAssignValue$2 = _baseAssignValue,
    eq$1 = eq_1;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$h.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$3(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$e.call(object, key) && eq$1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$2(object, key, value);
  }
}

var _assignValue = assignValue$3;

var assignValue$2 = _assignValue,
    baseAssignValue$1 = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$5(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$1(object, key, newValue);
    } else {
      assignValue$2(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$5;

var copyObject$4 = _copyObject,
    keys$2 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$4(source, keys$2(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$2(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$2;

var isObject$3 = isObject_1,
    isPrototype$2 = _isPrototype,
    nativeKeysIn$1 = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$g.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$2(object) {
  if (!isObject$3(object)) {
    return nativeKeysIn$1(object);
  }
  var isProto = isPrototype$2(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$d.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeysIn$1 = _baseKeysIn,
    isArrayLike$1 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$4(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object, true) : baseKeysIn$1(object);
}

var keysIn_1 = keysIn$4;

var copyObject$3 = _copyObject,
    keysIn$3 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$3(source, keysIn$3(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

_cloneBuffer.exports;

(function (module, exports) {
	var root = _root;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	module.exports = cloneBuffer; 
} (_cloneBuffer, _cloneBuffer.exports));

var _cloneBufferExports = _cloneBuffer.exports;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$2(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$2;

var copyObject$2 = _copyObject,
    getSymbols$2 = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$2(source, getSymbols$2(source), object);
}

var _copySymbols = copySymbols$1;

var arrayPush$1 = _arrayPush,
    getPrototype$2 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray$1 = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols$1(object));
    object = getPrototype$2(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

var copyObject$1 = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject$1(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$2 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$1(object) {
  return baseGetAllKeys$1(object, keysIn$2, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

/** Used for built-in method references. */

var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$f.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$c.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var Uint8Array$2 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$4(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$4;

var cloneArrayBuffer$3 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$3(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$2 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$2(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$2;

var cloneArrayBuffer$1 = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray$1 = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$3 = '[object Symbol]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$3:
      return cloneArrayBuffer$1(object);

    case boolTag$3:
    case dateTag$3:
      return new Ctor(+object);

    case dataViewTag$4:
      return cloneDataView(object, isDeep);

    case float32Tag$2: case float64Tag$2:
    case int8Tag$2: case int16Tag$2: case int32Tag$2:
    case uint8Tag$2: case uint8ClampedTag$2: case uint16Tag$2: case uint32Tag$2:
      return cloneTypedArray$1(object, isDeep);

    case mapTag$5:
      return new Ctor;

    case numberTag$3:
    case stringTag$3:
      return new Ctor(object);

    case regexpTag$3:
      return cloneRegExp(object);

    case setTag$5:
      return new Ctor;

    case symbolTag$3:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$2 = isObject_1;

/** Built-in value references. */
var objectCreate$1 = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$2 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$2(proto)) {
      return {};
    }
    if (objectCreate$1) {
      return objectCreate$1(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$2;

var baseCreate$1 = _baseCreate,
    getPrototype$1 = _getPrototype,
    isPrototype$1 = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$2(object) {
  return (typeof object.constructor == 'function' && !isPrototype$1(object))
    ? baseCreate$1(getPrototype$1(object))
    : {};
}

var _initCloneObject = initCloneObject$2;

var getTag$3 = _getTag,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$2(value) && getTag$3(value) == mapTag$4;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$2 = _baseUnary,
    nodeUtil$2 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$2 && nodeUtil$2.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$2 = _getTag,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$4 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike$1(value) && getTag$2(value) == setTag$4;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary$1 = _baseUnary,
    nodeUtil$1 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack$1 = _Stack,
    arrayEach$1 = _arrayEach,
    assignValue$1 = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer$1 = _cloneBufferExports,
    copyArray$1 = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys$1 = _getAllKeys,
    getAllKeysIn = _getAllKeysIn,
    getTag$1 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject$1 = _initCloneObject,
    isArray$2 = isArray_1,
    isBuffer$1 = isBufferExports,
    isMap = isMap_1,
    isObject$1 = isObject_1,
    isSet = isSet_1,
    keys$1 = keys_1,
    keysIn$1 = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] =
cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] =
cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] =
cloneableTags[int32Tag$1] = cloneableTags[mapTag$3] =
cloneableTags[numberTag$2] = cloneableTags[objectTag$4] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$3] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] =
cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] =
cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray$2(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray$1(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer$1(value)) {
      return cloneBuffer$1(value, isDeep);
    }
    if (tag == objectTag$4 || tag == argsTag$3 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject$1(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$1);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys$1)
    : (isFlat ? keysIn$1 : keys$1);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach$1(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue$1(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

var baseClone = _baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

Object.defineProperty(mergeClasses$1, "__esModule", {
  value: true
});
mergeClasses$1.mergeClasses = undefined;

var _forOwn2$1 = forOwn_1;

var _forOwn3$1 = _interopRequireDefault$7(_forOwn2$1);

var _cloneDeep2 = cloneDeep_1;

var _cloneDeep3 = _interopRequireDefault$7(_cloneDeep2);

var _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = mergeClasses$1.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3$1.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends$g({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

mergeClasses$1.default = mergeClasses;

var autoprefix$1 = {};

Object.defineProperty(autoprefix$1, "__esModule", {
  value: true
});
autoprefix$1.autoprefix = undefined;

var _forOwn2 = forOwn_1;

var _forOwn3 = _interopRequireDefault$6(_forOwn2);

var _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = autoprefix$1.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends$f({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

autoprefix$1.default = autoprefix;

var hover$1 = {};

Object.defineProperty(hover$1, "__esModule", {
  value: true
});
hover$1.hover = undefined;

var _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$3 = React__default;

var _react2$3 = _interopRequireDefault$5(_react$3);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$a(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = hover$1.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits$a(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$a(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$a(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2$3.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2$3.default.createElement(Component, _extends$e({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn$a(_this, _ret);
    }

    return Hover;
  }(_react2$3.default.Component);
};

hover$1.default = hover;

var active$1 = {};

Object.defineProperty(active$1, "__esModule", {
  value: true
});
active$1.active = undefined;

var _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$2 = React__default;

var _react2$2 = _interopRequireDefault$4(_react$2);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$9(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = active$1.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits$9(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$9(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$9(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2$2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2$2.default.createElement(Component, _extends$d({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn$9(_this, _ret);
    }

    return Active;
  }(_react2$2.default.Component);
};

active$1.default = active;

var loop = {};

Object.defineProperty(loop, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

loop.default = loopable;

Object.defineProperty(lib, "__esModule", {
  value: true
});
lib.ReactCSS = lib.loop = lib.handleActive = handleHover = lib.handleHover = lib.hover = undefined;

var _flattenNames = flattenNames$1;

var _flattenNames2 = _interopRequireDefault$3(_flattenNames);

var _mergeClasses = mergeClasses$1;

var _mergeClasses2 = _interopRequireDefault$3(_mergeClasses);

var _autoprefix = autoprefix$1;

var _autoprefix2 = _interopRequireDefault$3(_autoprefix);

var _hover2 = hover$1;

var _hover3 = _interopRequireDefault$3(_hover2);

var _active = active$1;

var _active2 = _interopRequireDefault$3(_active);

var _loop2 = loop;

var _loop3 = _interopRequireDefault$3(_loop2);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

lib.hover = _hover3.default;
var handleHover = lib.handleHover = _hover3.default;
lib.handleActive = _active2.default;
lib.loop = _loop3.default;
var ReactCSS = lib.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

var _default$2 = lib.default = ReactCSS;

var calculateChange$2 = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};

var checkboardCache = {};

var render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get$1 = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};

var _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;

  var styles = _default$2({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + get$1(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return isValidElement(children) ? React__default.cloneElement(children, _extends$c({}, children.props, { style: _extends$c({}, children.props.style, styles.grid) })) : React__default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

var _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$8 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$8(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = function (_ref) {
  _inherits$8(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$8(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$8(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = calculateChange$2(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn$8(_this, _ret);
  }

  _createClass$8(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = _default$2({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends$b({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return React__default.createElement(
        'div',
        { style: styles.alpha },
        React__default.createElement(
          'div',
          { style: styles.checkboard },
          React__default.createElement(Checkboard, { renderers: this.props.renderers })
        ),
        React__default.createElement('div', { style: styles.gradient }),
        React__default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(PureComponent || Component);

var _createClass$7 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$7(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter = 1;

var EditableInput = function (_ref) {
  _inherits$7(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck$7(this, EditableInput);

    var _this = _possibleConstructorReturn$7(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };

    _this.inputId = 'rc-editable-input-' + idCounter++;
    return _this;
  }

  _createClass$7(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty$2({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = _default$2({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return React__default.createElement(
        'div',
        { style: styles.wrap },
        React__default.createElement('input', {
          id: this.inputId,
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? React__default.createElement(
          'label',
          {
            htmlFor: this.inputId,
            style: styles.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(PureComponent || Component);

var calculateChange$1 = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }
  return null;
};

var _createClass$6 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$6(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = function (_ref) {
  _inherits$6(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$6(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$6(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = calculateChange$1(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn$6(_this, _ret);
  }

  _createClass$6(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = _default$2({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return React__default.createElement(
        'div',
        { style: styles.hue },
        React__default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          React__default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(PureComponent || Component);

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$e.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$d.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$c = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$a).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root, 'Map');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$9.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty$8.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/** Detect free variable `exports`. */
var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root.Buffer : undefined;
    Buffer$1 ? Buffer$1.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  {
    return buffer.slice();
  }
}

/** Built-in value references. */
var Uint8Array$1 = root.Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = cloneArrayBuffer(typedArray.buffer) ;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$9;

  return value === proto;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$7.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Built-in value references. */
var Buffer = moduleExports$1 ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$6.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag] =
typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] =
typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray$1(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$1(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction$1(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$1(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

var Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = _default$2(merge({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return React__default.createElement(
    'div',
    { style: styles.wrap },
    React__default.createElement('div', { style: styles.bg }),
    React__default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: PropTypes.string,
  zDepth: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  radius: PropTypes.number,
  styles: PropTypes.object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root.Date.now();
};

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag$1);
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};

var _createClass$5 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = function (_ref) {
  _inherits$5(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck$5(this, Saturation);

    var _this = _possibleConstructorReturn$5(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = throttle(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass$5(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;

      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = _default$2({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return React__default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        React__default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        React__default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          React__default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          React__default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(PureComponent || Component);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = -1,
        iterable = Object(collection);

    while ((++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray$1(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

// This file is autogenerated. It's used to publish ESM to npm.
function _typeof$2(obj) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$2(obj);
}

// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

var trimLeft = /^\s+/;
var trimRight = /\s+$/;
function tinycolor(color, opts) {
  color = color ? color : "";
  opts = opts || {};

  // If input is already a tinycolor, return itself
  if (color instanceof tinycolor) {
    return color;
  }
  // If we are called as a function, call using new instead
  if (!(this instanceof tinycolor)) {
    return new tinycolor(color, opts);
  }
  var rgb = inputToRGB(color);
  this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
  this._gradientType = opts.gradientType;

  // Don't let the range of [0,255] come back in [0,1].
  // Potentially lose a little bit of precision here, but will fix issues where
  // .5 gets interpreted as half of the total, instead of half of 1
  // If it was supposed to be 128, this was already taken care of by `inputToRgb`
  if (this._r < 1) this._r = Math.round(this._r);
  if (this._g < 1) this._g = Math.round(this._g);
  if (this._b < 1) this._b = Math.round(this._b);
  this._ok = rgb.ok;
}
tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    //http://www.w3.org/TR/AERT#color-contrast
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  },
  getLuminance: function getLuminance() {
    //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    var rgb = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B;
    RsRGB = rgb.r / 255;
    GsRGB = rgb.g / 255;
    BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  },
  setAlpha: function setAlpha(value) {
    this._a = boundAlpha(value);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360),
      s = Math.round(hsv.s * 100),
      v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl.h * 360,
      s: hsl.s,
      l: hsl.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl.h * 360),
      s = Math.round(hsl.s * 100),
      l = Math.round(hsl.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex$1(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }
    if (this._a < 1) {
      return false;
    }
    return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";
    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString(format) {
    var formatSet = !!format;
    format = format || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
    if (needsAlphaFormat) {
      // Special case for "transparent", all other non-alpha formats
      // will return rgba when there is transparency.
      if (format === "name" && this._a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }
    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format === "name") {
      formattedString = this.toName();
    }
    if (format === "hsl") {
      formattedString = this.toHslString();
    }
    if (format === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  },
  clone: function clone() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color._r;
    this._g = color._g;
    this._b = color._b;
    this.setAlpha(color._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function (color, opts) {
  if (_typeof$2(color) == "object") {
    var newColor = {};
    for (var i in color) {
      if (color.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color[i];
        } else {
          newColor[i] = convertToPercentage(color[i]);
        }
      }
    }
    color = newColor;
  }
  return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;
  if (typeof color == "string") {
    color = stringInputToObject(color);
  }
  if (_typeof$2(color) == "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = "hsl";
    }
    if (color.hasOwnProperty("a")) {
      a = color.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok: ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a
  };
}

// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h: h,
    s: s,
    l: l
  };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
  var r, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);
  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    v = max;
  var d = max - min;
  s = max === 0 ? 0 : d / max;
  if (max == min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h: h,
    s: s,
    v: v
  };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h),
    f = h - i,
    p = v * (1 - s),
    q = v * (1 - f * s),
    t = v * (1 - (1 - f) * s),
    mod = i % 6,
    r = [v, q, p, p, t, v][mod],
    g = [t, v, v, q, p, p][mod],
    b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

  // Return a 3 character hex if possible
  if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }
  return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex$1(r, g, b, a, allow4Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

  // Return a 4 character hex if possible
  if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }
  return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {
  var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
  if (!color1 || !color2) return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};
tinycolor.random = function () {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};

// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function _desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _greyscale(color) {
  return tinycolor(color).desaturate(100);
}
function _lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = tinycolor(color).toRgb();
  rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
  rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
  rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb);
}
function _darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function _spin(color, amount) {
  var hsl = tinycolor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function _complement(color) {
  var hsl = tinycolor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return tinycolor(hsl);
}
function polyad(color, number) {
  if (isNaN(number) || number <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }
  var hsl = tinycolor(color).toHsl();
  var result = [tinycolor(color)];
  var step = 360 / number;
  for (var i = 1; i < number; i++) {
    result.push(tinycolor({
      h: (hsl.h + i * step) % 360,
      s: hsl.s,
      l: hsl.l
    }));
  }
  return result;
}
function _splitcomplement(color) {
  var hsl = tinycolor(color).toHsl();
  var h = hsl.h;
  return [tinycolor(color), tinycolor({
    h: (h + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}
function _analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = tinycolor(color).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color)];
  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(tinycolor(hsl));
  }
  return ret;
}
function _monochromatic(color, results) {
  results = results || 6;
  var hsv = tinycolor(color).toHsv();
  var h = hsv.h,
    s = hsv.s,
    v = hsv.v;
  var ret = [];
  var modification = 1 / results;
  while (results--) {
    ret.push(tinycolor({
      h: h,
      s: s,
      v: v
    }));
    v = (v + modification) % 1;
  }
  return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function (color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba);
};

// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function (color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function (color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);
  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;
    case "AAlarge":
      out = readability >= 3;
      break;
    case "AAAsmall":
      out = readability >= 7;
      break;
  }
  return out;
};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function (baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;
  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);
    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }
  if (tinycolor.isReadable(baseColor, bestColor, {
    level: level,
    size: size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
};

// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip$3(names);

// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip$3(o) {
  var flipped = {};
  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }
  return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
  if (isOnePointZero(n)) n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max, Math.max(0, parseFloat(n)));

  // Automatically convert percentage into number
  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  }

  // Handle floating point rounding errors
  if (Math.abs(n - max) < 0.000001) {
    return 1;
  }

  // Convert into [0, 1] range if it isn't already
  return n % max / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
  return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
  return c.length == 1 ? "0" + c : "" + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }
  return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
var matchers = function () {
  // <http://www.w3.org/TR/css3-values/#integers>
  var CSS_INTEGER = "[-\\+]?\\d+%?";

  // <http://www.w3.org/TR/css3-values/#number-value>
  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

  // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

  // Actual matching.
  // Parentheses and commas are optional, but not required.
  // Whitespace can take the place of commas or opening paren
  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
  return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {
  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  }

  // Try to match string input using regular expressions.
  // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
  // Just return an object and let the conversion functions handle that.
  // This way the result will be the same whether the tinycolor is initialized with string or object.
  var match;
  if (match = matchers.rgb.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }
  if (match = matchers.rgba.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsl.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }
  if (match = matchers.hsla.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsv.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }
  if (match = matchers.hsva.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hex8.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex6.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? "name" : "hex"
    };
  }
  if (match = matchers.hex4.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex3.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function validateWCAG2Parms(parms) {
  // return valid WCAG2 parms for isReadable.
  // If input parms are invalid, return {"level":"AA", "size":"small"}
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();
  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }
  if (size !== "small" && size !== "large") {
    size = "small";
  }
  return {
    level: level,
    size: size
  };
}

var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  forEach(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = function toState(data, oldHue) {
  var color = data.hex ? tinycolor(data.hex) : tinycolor(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

var isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  }
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && tinycolor(hex).isValid();
};

var getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

var isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return tinycolor(type + ' (' + stringWithoutDegree + ')')._ok;
};

var _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits$4(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck$4(this, ColorPicker);

      var _this = _possibleConstructorReturn$4(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends$a({}, toState(props.color, 0));

      _this.debounce = debounce(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass$4(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return React__default.createElement(Picker, _extends$a({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends$a({}, toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(PureComponent || Component);

  ColorPicker.propTypes = _extends$a({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends$a({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

var _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits$3(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$3(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$3(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn$3(_this, _ret);
    }

    _createClass$3(Focus, [{
      key: 'render',
      value: function render() {
        return React__default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          React__default.createElement(Component, _extends$9({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(React__default.Component);
};

var _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ENTER = 13;

var Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = _default$2({
    default: {
      swatch: _extends$8({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return React__default.createElement(
    'div',
    _extends$8({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && React__default.createElement(Checkboard, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

var Swatch$1 = handleFocus(Swatch);

var AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = _default$2({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return React__default.createElement('div', { style: styles.picker });
};

var _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return React__default.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    React__default.createElement(Alpha, _extends$7({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: AlphaPointer
};

ColorWrap(AlphaPicker);

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root, 'Promise');

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root, 'Set');

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root, 'WeakMap');

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map$1 && getTag(new Map$1) != mapTag) ||
    (Promise$1 && getTag(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag(new Set$1) != setTag) ||
    (WeakMap$1 && getTag(new WeakMap$1) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object),
      othIsArr = isArray$1(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      var result; 
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray$1(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray$1(object) || isArguments(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$1(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray$1(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}

var BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = _default$2({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return React__default.createElement(
    'div',
    { style: styles.swatches },
    map(colors, function (c) {
      return React__default.createElement(Swatch$1, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    React__default.createElement('div', { style: styles.clear })
  );
};

var Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = _default$2(merge({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), { 'hide-triangle': triangle === 'hide' });

  return React__default.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    React__default.createElement('div', { style: styles.triangle }),
    React__default.createElement(
      'div',
      { style: styles.head },
      transparent && React__default.createElement(Checkboard, { borderRadius: '6px 6px 0 0' }),
      React__default.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    React__default.createElement(
      'div',
      { style: styles.body },
      React__default.createElement(BlockSwatches, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      React__default.createElement(EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(['top', 'hide']),
  styles: PropTypes.object
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};

ColorWrap(Block);

var red = {"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"};
var pink = {"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"};
var purple = {"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"};
var deepPurple = {"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"};
var indigo = {"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"};
var blue = {"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"};
var lightBlue = {"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"};
var cyan = {"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"};
var teal = {"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"};
var green = {"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"};
var lightGreen = {"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"};
var lime = {"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"};
var yellow = {"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"};
var amber = {"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"};
var orange = {"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"};
var deepOrange = {"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"};
var brown = {"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"};
var blueGrey = {"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"};

var CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = _default$2({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return React__default.createElement(
    'div',
    { style: styles.swatch },
    React__default.createElement(Swatch$1, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

var CircleSwatch$1 = handleHover(CircleSwatch);

var Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return React__default.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    map(colors, function (c) {
      return React__default.createElement(CircleSwatch$1, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  circleSize: PropTypes.number,
  circleSpacing: PropTypes.number,
  styles: PropTypes.object
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red['500'], pink['500'], purple['500'], deepPurple['500'], indigo['500'], blue['500'], lightBlue['500'], cyan['500'], teal['500'], green['500'], lightGreen['500'], lime['500'], yellow['500'], amber['500'], orange['500'], deepOrange['500'], brown['500'], blueGrey['500']],
  styles: {}
};

ColorWrap(Circle);

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

var UnfoldMoreHorizontalIcon = {};

Object.defineProperty(UnfoldMoreHorizontalIcon, "__esModule", {
  value: true
});

var _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1 = React__default;

var _react2$1 = _interopRequireDefault$2(_react$1);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE$1 = 24;

var _default$1 = UnfoldMoreHorizontalIcon.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE$1 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE$1 : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties$1(_ref, ['fill', 'width', 'height', 'style']);

  return _react2$1.default.createElement(
    'svg',
    _extends$6({
      viewBox: '0 0 ' + DEFAULT_SIZE$1 + ' ' + DEFAULT_SIZE$1,
      style: _extends$6({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2$1.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
  );
};

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChromeFields = function (_React$Component) {
  _inherits$2(ChromeFields, _React$Component);

  function ChromeFields(props) {
    _classCallCheck$2(this, ChromeFields);

    var _this = _possibleConstructorReturn$2(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }
        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        }

        // We store HSL as a unit interval so we need to override the 1 input to 0.01
        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!isUndefined(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!isUndefined(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }

  _createClass$2(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = _default$2({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = React__default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          React__default.createElement(
            'div',
            { style: styles.field },
            React__default.createElement(EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = React__default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          React__default.createElement(
            'div',
            { style: styles.field },
            React__default.createElement(EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            'div',
            { style: styles.field },
            React__default.createElement(EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            'div',
            { style: styles.field },
            React__default.createElement(EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            'div',
            { style: styles.alpha },
            React__default.createElement(EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = React__default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          React__default.createElement(
            'div',
            { style: styles.field },
            React__default.createElement(EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            'div',
            { style: styles.field },
            React__default.createElement(EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            'div',
            { style: styles.field },
            React__default.createElement(EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            'div',
            { style: styles.alpha },
            React__default.createElement(EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return React__default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        React__default.createElement(
          'div',
          { style: styles.toggle },
          React__default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            React__default.createElement(_default$1, {
              style: styles.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return { view: 'rgb' };
      }
      return null;
    }
  }]);

  return ChromeFields;
}(React__default.Component);

ChromeFields.defaultProps = {
  view: "hex"
};

var ChromePointer = function ChromePointer() {
  var styles = _default$2({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return React__default.createElement('div', { style: styles.picker });
};

var ChromePointerCircle = function ChromePointerCircle() {
  var styles = _default$2({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return React__default.createElement('div', { style: styles.picker });
};

var Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;

  var styles = _default$2(merge({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return React__default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    React__default.createElement(
      'div',
      { style: styles.saturation },
      React__default.createElement(Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: ChromePointerCircle,
        onChange: onChange
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.body },
      React__default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        React__default.createElement(
          'div',
          { style: styles.color },
          React__default.createElement(
            'div',
            { style: styles.swatch },
            React__default.createElement('div', { style: styles.active }),
            React__default.createElement(Checkboard, { renderers: renderers })
          )
        ),
        React__default.createElement(
          'div',
          { style: styles.toggles },
          React__default.createElement(
            'div',
            { style: styles.hue },
            React__default.createElement(Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: ChromePointer,
              onChange: onChange
            })
          ),
          React__default.createElement(
            'div',
            { style: styles.alpha },
            React__default.createElement(Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: ChromePointer,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      React__default.createElement(ChromeFields, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disableAlpha: PropTypes.bool,
  styles: PropTypes.object,
  defaultView: PropTypes.oneOf(["hex", "rgb", "hsl"])
};

Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};

var ChromePicker = ColorWrap(Chrome);

var CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = _default$2({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return React__default.createElement(
    Swatch$1,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    React__default.createElement('div', { style: styles.dot })
  );
};

var CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = _default$2({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return React__default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    React__default.createElement('div', { style: styles.active }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

var Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return React__default.createElement(
    Raised,
    { style: styles.Compact, styles: passedStyles },
    React__default.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      React__default.createElement(
        'div',
        null,
        map(colors, function (c) {
          return React__default.createElement(CompactColor, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        React__default.createElement('div', { style: styles.clear })
      ),
      React__default.createElement(CompactFields, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};

ColorWrap(Compact);

var GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = _default$2({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return React__default.createElement(
    'div',
    { style: styles.swatch },
    React__default.createElement(Swatch$1, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

var GithubSwatch$1 = handleHover(GithubSwatch);

var Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return React__default.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    React__default.createElement('div', { style: styles.triangleShadow }),
    React__default.createElement('div', { style: styles.triangle }),
    map(colors, function (c) {
      return React__default.createElement(GithubSwatch$1, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: PropTypes.object
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};

ColorWrap(Github);

var SliderPointer$1 = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = _default$2({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return React__default.createElement('div', { style: styles.picker });
};

var _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return React__default.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    React__default.createElement(Hue, _extends$5({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.propTypes = {
  styles: PropTypes.object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: SliderPointer$1,
  styles: {}
};

ColorWrap(HuePicker);

var Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return React__default.createElement(
    Raised,
    { styles: passedStyles },
    React__default.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      React__default.createElement(EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      React__default.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        React__default.createElement(
          'div',
          { style: styles.third },
          React__default.createElement(EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        React__default.createElement(
          'div',
          { style: styles.third },
          React__default.createElement(EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        React__default.createElement(
          'div',
          { style: styles.third },
          React__default.createElement(EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

ColorWrap(Material);

var PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = _default$2({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        top: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return React__default.createElement(
    'div',
    { style: styles.fields },
    React__default.createElement(EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    React__default.createElement('div', { style: styles.divider }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    React__default.createElement('div', { style: styles.divider }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    React__default.createElement(
      'div',
      { style: styles.fieldSymbols },
      React__default.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      React__default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      React__default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

var PhotoshopPointerCircle$1 = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = _default$2({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return React__default.createElement('div', { style: styles.picker });
};

var PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = _default$2({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return React__default.createElement(
    'div',
    { style: styles.pointer },
    React__default.createElement(
      'div',
      { style: styles.left },
      React__default.createElement('div', { style: styles.leftInside })
    ),
    React__default.createElement(
      'div',
      { style: styles.right },
      React__default.createElement('div', { style: styles.rightInside })
    )
  );
};

var PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = _default$2({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return React__default.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = _default$2({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return React__default.createElement(
    'div',
    null,
    React__default.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    React__default.createElement(
      'div',
      { style: styles.swatches },
      React__default.createElement('div', { style: styles.new }),
      React__default.createElement('div', { style: styles.current })
    ),
    React__default.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photoshop = function (_React$Component) {
  _inherits$1(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck$1(this, Photoshop);

    var _this = _possibleConstructorReturn$1(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass$1(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = _default$2(merge({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));

      return React__default.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        React__default.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        React__default.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          React__default.createElement(
            'div',
            { style: styles.saturation },
            React__default.createElement(Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: PhotoshopPointerCircle$1,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            'div',
            { style: styles.hue },
            React__default.createElement(Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: PhotoshopPointerCircle,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            'div',
            { style: styles.controls },
            React__default.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              React__default.createElement(
                'div',
                { style: styles.previews },
                React__default.createElement(PhotoshopPreviews, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              React__default.createElement(
                'div',
                { style: styles.actions },
                React__default.createElement(PhotoshopButton, { label: 'OK', onClick: this.props.onAccept, active: true }),
                React__default.createElement(PhotoshopButton, { label: 'Cancel', onClick: this.props.onCancel }),
                React__default.createElement(PhotoshopPicker, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(React__default.Component);

Photoshop.propTypes = {
  header: PropTypes.string,
  styles: PropTypes.object
};

Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};

ColorWrap(Photoshop);

/* eslint-disable no-param-reassign */


var SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = _default$2({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return React__default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    React__default.createElement(
      'div',
      { style: styles.double },
      React__default.createElement(EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.single },
      React__default.createElement(EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.single },
      React__default.createElement(EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.single },
      React__default.createElement(EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.alpha },
      React__default.createElement(EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

var _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = _default$2({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return React__default.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return React__default.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        React__default.createElement(Swatch$1, _extends$4({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    color: PropTypes.string,
    title: PropTypes.string
  })])).isRequired
};

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': _extends$3({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return React__default.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    React__default.createElement(
      'div',
      { style: styles.saturation },
      React__default.createElement(Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      React__default.createElement(
        'div',
        { style: styles.sliders },
        React__default.createElement(
          'div',
          { style: styles.hue },
          React__default.createElement(Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        React__default.createElement(
          'div',
          { style: styles.alpha },
          React__default.createElement(Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      React__default.createElement(
        'div',
        { style: styles.color },
        React__default.createElement(Checkboard, null),
        React__default.createElement('div', { style: styles.activeColor })
      )
    ),
    React__default.createElement(SketchFields, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    React__default.createElement(SketchPresetColors, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

ColorWrap(Sketch);

var SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = _default$2({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return React__default.createElement('div', { style: styles.swatch, onClick: handleClick });
};

var SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = _default$2({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  // Acceptible difference in floating point equality
  var epsilon = 0.1;

  return React__default.createElement(
    'div',
    { style: styles.swatches },
    React__default.createElement(
      'div',
      { style: styles.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
      })
    ),
    React__default.createElement('div', { style: styles.clear })
  );
};

var SliderPointer = function SliderPointer() {
  var styles = _default$2({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return React__default.createElement('div', { style: styles.picker });
};

var Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  return React__default.createElement(
    'div',
    { style: styles.wrap || {}, className: 'slider-picker ' + className },
    React__default.createElement(
      'div',
      { style: styles.hue },
      React__default.createElement(Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.swatches },
      React__default.createElement(SliderSwatches, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.propTypes = {
  styles: PropTypes.object
};
Slider.defaultProps = {
  pointer: SliderPointer,
  styles: {}
};

ColorWrap(Slider);

var CheckIcon = {};

Object.defineProperty(CheckIcon, "__esModule", {
  value: true
});

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = React__default;

var _react2 = _interopRequireDefault$1(_react);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

var _default = CheckIcon.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends$2({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends$2({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
  );
};

var SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = _default$2({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return React__default.createElement(
    Swatch$1,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    React__default.createElement(
      'div',
      { style: styles.check },
      React__default.createElement(_default, null)
    )
  );
};

var SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = _default$2({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return React__default.createElement(
    'div',
    { style: styles.group },
    map(group, function (color, i) {
      return React__default.createElement(SwatchesColor, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

var Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    return onChange({ hex: data, source: 'hex' }, e);
  };

  return React__default.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    React__default.createElement(
      Raised,
      null,
      React__default.createElement(
        'div',
        { style: styles.overflow },
        React__default.createElement(
          'div',
          { style: styles.body },
          map(colors, function (group) {
            return React__default.createElement(SwatchesGroup, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          React__default.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  styles: PropTypes.object

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red['900'], red['700'], red['500'], red['300'], red['100']], [pink['900'], pink['700'], pink['500'], pink['300'], pink['100']], [purple['900'], purple['700'], purple['500'], purple['300'], purple['100']], [deepPurple['900'], deepPurple['700'], deepPurple['500'], deepPurple['300'], deepPurple['100']], [indigo['900'], indigo['700'], indigo['500'], indigo['300'], indigo['100']], [blue['900'], blue['700'], blue['500'], blue['300'], blue['100']], [lightBlue['900'], lightBlue['700'], lightBlue['500'], lightBlue['300'], lightBlue['100']], [cyan['900'], cyan['700'], cyan['500'], cyan['300'], cyan['100']], [teal['900'], teal['700'], teal['500'], teal['300'], teal['100']], ['#194D33', green['700'], green['500'], green['300'], green['100']], [lightGreen['900'], lightGreen['700'], lightGreen['500'], lightGreen['300'], lightGreen['100']], [lime['900'], lime['700'], lime['500'], lime['300'], lime['100']], [yellow['900'], yellow['700'], yellow['500'], yellow['300'], yellow['100']], [amber['900'], amber['700'], amber['500'], amber['300'], amber['100']], [orange['900'], orange['700'], orange['500'], orange['300'], orange['100']], [deepOrange['900'], deepOrange['700'], deepOrange['500'], deepOrange['300'], deepOrange['100']], [brown['900'], brown['700'], brown['500'], brown['300'], brown['100']], [blueGrey['900'], blueGrey['700'], blueGrey['500'], blueGrey['300'], blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};

ColorWrap(Swatches);

var Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return React__default.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    React__default.createElement('div', { style: styles.triangleShadow }),
    React__default.createElement('div', { style: styles.triangle }),
    React__default.createElement(
      'div',
      { style: styles.body },
      map(colors, function (c, i) {
        return React__default.createElement(Swatch$1, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      React__default.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      React__default.createElement(EditableInput, {
        label: null,
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      React__default.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  triangle: PropTypes.oneOf(['hide', 'top-left', 'top-right']),
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};

ColorWrap(Twitter);

var GooglePointerCircle = function GooglePointerCircle(props) {
  var styles = _default$2({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        border: '2px #fff solid',
        transform: 'translate(-12px, -13px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
      }
    }
  });

  return React__default.createElement('div', { style: styles.picker });
};

GooglePointerCircle.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};

GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

var GooglePointer = function GooglePointer(props) {
  var styles = _default$2({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        transform: 'translate(-10px, -7px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
        border: '2px white solid'
      }
    }
  });

  return React__default.createElement('div', { style: styles.picker });
};

GooglePointer.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};

GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

var GoogleFields = function GoogleFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      hsv = _ref.hsv;


  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.rgb) {
      var values = data.rgb.split(',');
      isvalidColorString(data.rgb, 'rgb') && onChange({
        r: values[0],
        g: values[1],
        b: values[2],
        a: 1,
        source: 'rgb'
      }, e);
    } else if (data.hsv) {
      var _values = data.hsv.split(',');
      if (isvalidColorString(data.hsv, 'hsv')) {
        _values[2] = _values[2].replace('%', '');
        _values[1] = _values[1].replace('%', '');
        _values[0] = _values[0].replace('°', '');
        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }
        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: 'hsv'
        }, e);
      }
    } else if (data.hsl) {
      var _values2 = data.hsl.split(',');
      if (isvalidColorString(data.hsl, 'hsl')) {
        _values2[2] = _values2[2].replace('%', '');
        _values2[1] = _values2[1].replace('%', '');
        _values2[0] = _values2[0].replace('°', '');
        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }
        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: 'hsl'
        }, e);
      }
    }
  };

  var styles = _default$2({
    'default': {
      wrap: {
        display: 'flex',
        height: '100px',
        marginTop: '4px'
      },
      fields: {
        width: '100%'
      },
      column: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      double: {
        padding: '0px 4.4px',
        boxSizing: 'border-box'
      },
      input: {
        width: '100%',
        height: '38px',
        boxSizing: 'border-box',
        padding: '4px 10% 3px',
        textAlign: 'center',
        border: '1px solid #dadce0',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      input2: {
        height: '38px',
        width: '100%',
        border: '1px solid #dadce0',
        boxSizing: 'border-box',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        paddingLeft: '10px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label: {
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '35px',
        top: '-6px',
        left: '0',
        right: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label2: {
        left: '10px',
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '32px',
        top: '-6px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      single: {
        flexGrow: '1',
        margin: '0px 4.4px'
      }
    }
  });

  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';

  return React__default.createElement(
    'div',
    { style: styles.wrap, className: 'flexbox-fix' },
    React__default.createElement(
      'div',
      { style: styles.fields },
      React__default.createElement(
        'div',
        { style: styles.double },
        React__default.createElement(EditableInput, {
          style: { input: styles.input, label: styles.label },
          label: 'hex',
          value: hex,
          onChange: handleChange
        })
      ),
      React__default.createElement(
        'div',
        { style: styles.column },
        React__default.createElement(
          'div',
          { style: styles.single },
          React__default.createElement(EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'rgb',
            value: rgbValue,
            onChange: handleChange
          })
        ),
        React__default.createElement(
          'div',
          { style: styles.single },
          React__default.createElement(EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsv',
            value: hsvValue,
            onChange: handleChange
          })
        ),
        React__default.createElement(
          'div',
          { style: styles.single },
          React__default.createElement(EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsl',
            value: hslValue,
            onChange: handleChange
          })
        )
      )
    )
  );
};

var Google = function Google(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      header = _ref.header,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = _default$2(merge({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        border: '1px solid #dfe1e5',
        boxSizing: 'initial',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '8px 8px 0px 0px'
      },
      head: {
        height: '57px',
        width: '100%',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        fontSize: '20px',
        boxSizing: 'border-box',
        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
      },
      saturation: {
        width: '70%',
        padding: '0px',
        position: 'relative',
        overflow: 'hidden'
      },
      swatch: {
        width: '30%',
        height: '228px',
        padding: '0px',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
        position: 'relative',
        overflow: 'hidden'
      },
      body: {
        margin: 'auto',
        width: '95%'
      },
      controls: {
        display: 'flex',
        boxSizing: 'border-box',
        height: '52px',
        paddingTop: '22px'
      },
      color: {
        width: '32px'
      },
      hue: {
        height: '8px',
        position: 'relative',
        margin: '0px 16px 0px 16px',
        width: '100%'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return React__default.createElement(
    'div',
    { style: styles.picker, className: 'google-picker ' + className },
    React__default.createElement(
      'div',
      { style: styles.head },
      header
    ),
    React__default.createElement('div', { style: styles.swatch }),
    React__default.createElement(
      'div',
      { style: styles.saturation },
      React__default.createElement(Saturation, {
        hsl: hsl,
        hsv: hsv,
        pointer: GooglePointerCircle,
        onChange: onChange
      })
    ),
    React__default.createElement(
      'div',
      { style: styles.body },
      React__default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        React__default.createElement(
          'div',
          { style: styles.hue },
          React__default.createElement(Hue, {
            style: styles.Hue,
            hsl: hsl,
            radius: '4px',
            pointer: GooglePointer,
            onChange: onChange
          })
        )
      ),
      React__default.createElement(GoogleFields, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
      })
    )
  );
};

Google.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object,
  header: PropTypes.string

};

Google.defaultProps = {
  width: 652,
  styles: {},
  header: 'Color picker'
};

ColorWrap(Google);

var bind = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue.call(this, arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return this && this[arg] || arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(this, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, this && this[key] || key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (bind));

var bindExports = bind.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(bindExports);

var reactTextMask = {exports: {}};

(function (module, exports) {
	!function(e,t){module.exports=t(React__default);}(commonjsGlobal,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e;}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0, y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t);}},{key:"componentDidMount",value:function(){this.initTextMask();}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0, m.isNil)(n)&&!(0, m.isNil)(e.pipe)||!(0, m.isNil)(n)&&(0, m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask();}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e);}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e);}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}};},function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return "string"==typeof e||e instanceof String}function a(e){return "number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return "undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return {maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0, i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0, i.processCaretTraps)(t).maskWithoutCaretTraps;}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0, i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g);}for(var M=e.split(s).map(function(e,t){return {char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1);}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--;}else V+=F;continue e}N=!0;}b===!1&&(V+=v.substr(A,C));break}V+=B;}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s;}return {conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s="";},function(e,t){function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else {var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o="";},function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return {state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0, d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0, d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0, d.convertMaskToPlaceholder)(x,g);}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0, p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0, d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0, f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D));}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y));}function a(e){if((0, d.isString)(e))return e;if((0, d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout;},function(e,t){function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n;},function(e,t,r){function n(e,t,r,n,i,a,u,s){if(!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation";}throw l.framesToPop=1,l}}e.exports=n;},function(e,t,r){var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r};},function(e,t,r){e.exports=r(8)();},function(e,t){var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r;},function(t,r){t.exports=e;}])}); 
} (reactTextMask));

var reactTextMaskExports = reactTextMask.exports;
var MaskedInputPackage = /*@__PURE__*/getDefaultExportFromCjs(reactTextMaskExports);

const convertRGBAToText = (color) => `rgba(${color.r},${color.g},${color.b},${color.a})`;
const convertTextToRGBA = (text) => {
    var _a;
    const matched = (_a = text.match(/^rgba\((.*)\)/)) === null || _a === void 0 ? void 0 : _a[1];
    if (!matched)
        return null;
    const [r, g, b, a] = matched.split(',');
    return {
        r: Number(r),
        g: Number(g),
        b: Number(b),
        a: Number(a),
    };
};
const hexToRGBA = (hex, alpha = 100) => {
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
const rgbaToHex = (color) => {
    const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
    return `${((1 << 24) + (parseInt(rgba[0], 10) << 16) + (parseInt(rgba[1], 10) << 8) + parseInt(rgba[2], 10))
        .toString(16)
        .slice(1)}`;
};
const addHashColor = (color) => `#${color}`;

const defaultColor = {
    r: 100,
    g: 100,
    b: 100,
    a: 100,
};

const TIME_MASK$1 = [/\d/, /\d/, ':', /\d/, /\d/];
const COLORS_MASK = {
    hex: [
        /[0-9A-Fa-f]/,
        /[0-9A-Fa-f]/,
        /[0-9A-Fa-f]/,
        /[0-9A-Fa-f]/,
        /[0-9A-Fa-f]/,
        /[0-9A-Fa-f]/,
    ],
    rgba: [
        'r',
        'g',
        'b',
        'a',
        '(',
        /\d/,
        /\d/,
        /\d/,
        ',',
        /\d/,
        /\d/,
        /\d/,
        ',',
        /\d/,
        /\d/,
        /\d/,
        ',',
        /\d/,
        ')',
    ],
};

var css_248z$m = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.ColorPicker-module_colorPicker__g0CjT {\n  width: 100%;\n  height: 4.8rem;\n  position: relative;\n  display: inline-flex;\n  background: #ffffff;\n  border: 1px solid #d6d6d6;\n  border-radius: 0.2rem;\n  box-sizing: border-box;\n  transition: border 0.3s;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--default__wHhF1 {\n  border: 1px solid #858594;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--ofd__hARK2 {\n  border: 1px solid #4ba1a5;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--edo__AWhU9 {\n  border: 1px solid #f5a91b;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--epd__uuzNq {\n  border: 1px solid #f5a91b;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--gosotchet__uTO-b {\n  border: 1px solid #488bca;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--td__-l66S {\n  border: 1px solid #ea8242;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--marking__JMDn6 {\n  border: 1px solid #4bb9ba;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--check-index__xgFc7 {\n  border: 1px solid #5bc0de;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--big-data__GKDw5 {\n  border: 1px solid #5ab8c5;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--arenda__YgDA2 {\n  border: 1px solid #d58576;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--integrations__TSH62 {\n  border: 1px solid #797ca4;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--onec__2FP2q {\n  border: 1px solid #e36052;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--mchd__TpgfB {\n  border: 1px solid #626ab7;\n}\n.ColorPicker-module_colorPicker__g0CjT:hover.ColorPicker-module_colorPicker--elk__LvmSP {\n  border: 1px solid #577590;\n}\n.ColorPicker-module_colorPicker--withText__1D5CZ .ColorPicker-module_inputTitle__s6Ixi {\n  color: #858594;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--default__wHhF1 .ColorPicker-module_inputTitle__s6Ixi {\n  color: #858594;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--ofd__hARK2 .ColorPicker-module_inputTitle__s6Ixi {\n  color: #4ba1a5;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--edo__AWhU9 .ColorPicker-module_inputTitle__s6Ixi {\n  color: #f5a91b;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--epd__uuzNq .ColorPicker-module_inputTitle__s6Ixi {\n  color: #f5a91b;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--gosotchet__uTO-b .ColorPicker-module_inputTitle__s6Ixi {\n  color: #488bca;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--td__-l66S .ColorPicker-module_inputTitle__s6Ixi {\n  color: #ea8242;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--marking__JMDn6 .ColorPicker-module_inputTitle__s6Ixi {\n  color: #4bb9ba;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--check-index__xgFc7 .ColorPicker-module_inputTitle__s6Ixi {\n  color: #5bc0de;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--big-data__GKDw5 .ColorPicker-module_inputTitle__s6Ixi {\n  color: #5ab8c5;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--arenda__YgDA2 .ColorPicker-module_inputTitle__s6Ixi {\n  color: #d58576;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--integrations__TSH62 .ColorPicker-module_inputTitle__s6Ixi {\n  color: #797ca4;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--onec__2FP2q .ColorPicker-module_inputTitle__s6Ixi {\n  color: #e36052;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--mchd__TpgfB .ColorPicker-module_inputTitle__s6Ixi {\n  color: #626ab7;\n}\n.ColorPicker-module_colorPicker--active__ZwB7r.ColorPicker-module_colorPicker--elk__LvmSP .ColorPicker-module_inputTitle__s6Ixi {\n  color: #577590;\n}\n\n.ColorPicker-module_indicator__3tgVs {\n  width: 3rem;\n  height: 3rem;\n  border: 1px solid #d6d6d6;\n  border-radius: 0.2rem;\n  cursor: pointer;\n  transition: 0.3s;\n  margin: 0.7rem;\n}\n.ColorPicker-module_indicator__3tgVs:focus-visible {\n  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.07), 0 0 0 0.3rem #5bc0de;\n  outline: 1px solid #5bc0de;\n  border-radius: 0.2rem;\n}\n\n.ColorPicker-module_inputContainer__HcJWd {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.ColorPicker-module_inputTitle__s6Ixi {\n  margin-top: 0.8rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n  letter-spacing: 0.01em;\n  color: #254e5f;\n}\n\n.ColorPicker-module_inputText__62mcF {\n  color: #c7c7cc;\n  font-size: 1.6rem;\n  margin-left: 0.1rem;\n}\n\n.ColorPicker-module_input__dYLZp {\n  display: inline-block;\n  width: calc(100% - 2.2rem);\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n  color: #254e5f;\n  border: none;\n  outline: none;\n  box-shadow: none;\n}\n.ColorPicker-module_input__dYLZp:disabled {\n  background: #ffffff;\n}\n\n.ColorPicker-module_icon__uCg80 {\n  padding: 0.7rem;\n}\n\n.ColorPicker-module_iconButton__1Blvd {\n  border: none;\n  box-shadow: none;\n  min-width: auto;\n  width: 3.2rem;\n  height: 100%;\n}\n.ColorPicker-module_iconButton__1Blvd:hover {\n  border: none;\n  box-shadow: none;\n  background: #eeeeee;\n}\n.ColorPicker-module_iconButton__1Blvd:hover svg path {\n  stroke: none;\n}\n\n.ColorPicker-module_pallet__-uWt4 {\n  position: absolute;\n  top: 5rem;\n  z-index: 500;\n}\n.ColorPicker-module_pallet__-uWt4.ColorPicker-module_right__imcTa {\n  right: 0;\n}\n.ColorPicker-module_pallet__-uWt4.ColorPicker-module_left__QsKBv {\n  left: 0;\n}";
var s$d = {"colorPicker":"ColorPicker-module_colorPicker__g0CjT","colorPicker--default":"ColorPicker-module_colorPicker--default__wHhF1","colorPicker--ofd":"ColorPicker-module_colorPicker--ofd__hARK2","colorPicker--edo":"ColorPicker-module_colorPicker--edo__AWhU9","colorPicker--epd":"ColorPicker-module_colorPicker--epd__uuzNq","colorPicker--gosotchet":"ColorPicker-module_colorPicker--gosotchet__uTO-b","colorPicker--td":"ColorPicker-module_colorPicker--td__-l66S","colorPicker--marking":"ColorPicker-module_colorPicker--marking__JMDn6","colorPicker--check-index":"ColorPicker-module_colorPicker--check-index__xgFc7","colorPicker--big-data":"ColorPicker-module_colorPicker--big-data__GKDw5","colorPicker--arenda":"ColorPicker-module_colorPicker--arenda__YgDA2","colorPicker--integrations":"ColorPicker-module_colorPicker--integrations__TSH62","colorPicker--onec":"ColorPicker-module_colorPicker--onec__2FP2q","colorPicker--mchd":"ColorPicker-module_colorPicker--mchd__TpgfB","colorPicker--elk":"ColorPicker-module_colorPicker--elk__LvmSP","colorPicker--withText":"ColorPicker-module_colorPicker--withText__1D5CZ","inputTitle":"ColorPicker-module_inputTitle__s6Ixi","colorPicker--active":"ColorPicker-module_colorPicker--active__ZwB7r","indicator":"ColorPicker-module_indicator__3tgVs","inputContainer":"ColorPicker-module_inputContainer__HcJWd","inputText":"ColorPicker-module_inputText__62mcF","input":"ColorPicker-module_input__dYLZp","icon":"ColorPicker-module_icon__uCg80","iconButton":"ColorPicker-module_iconButton__1Blvd","pallet":"ColorPicker-module_pallet__-uWt4","right":"ColorPicker-module_right__imcTa","left":"ColorPicker-module_left__QsKBv"};
styleInject(css_248z$m);

var background_chess = "<svg width=\"47\" height=\"46\" viewBox=\"0 0 47 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <g filter=\"url(#filter0_i_120_7818)\">\n        <path d=\"M0 1C0 0.447715 0.447715 0 1 0H47V46H1C0.447715 46 0 45.5523 0 45V1Z\" fill=\"#F8F8F8\"/>\n        <path d=\"M0 1C0 0.447715 0.447715 0 1 0H47V46H1C0.447715 46 0 45.5523 0 45V1Z\" fill=\"url(#pattern0)\"/>\n    </g>\n    <defs>\n        <filter id=\"filter0_i_120_7818\" x=\"0\" y=\"0\" width=\"47\" height=\"48\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n            <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n            <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>\n            <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n            <feOffset dy=\"2\"/>\n            <feGaussianBlur stdDeviation=\"2\"/>\n            <feComposite in2=\"hardAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\"/>\n            <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0\"/>\n            <feBlend mode=\"normal\" in2=\"shape\" result=\"effect1_innerShadow_120_7818\"/>\n        </filter>\n        <pattern id=\"pattern0\" patternContentUnits=\"objectBoundingBox\" width=\"0.510638\" height=\"0.521739\">\n            <use xlink:href=\"#image0_120_7818\" transform=\"scale(0.0106383 0.0108696)\"/>\n        </pattern>\n        <image id=\"image0_120_7818\" width=\"48\" height=\"48\" xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABFUlEQVRoBe3WQYrDQBQD0dz/XL5XwuzM21QbJouADIEW6q/QJdv4dV3X+8nv/fB6kv239+n1+vYffDt/B6jK10AQ2i0UgB694fYWOnngirj+SeZ9j/Ol9wwUoTvdk3Xl6f9+A56o9AnF+57K07/PnqxfBpQ+Cb3vqTz9++zJegcoShIuXXn6a0Ai6iKu73zpNVCEJFy68vTXgETURVzf+dJroAhJuHTl6f/+x5wnKl0E9StP3/nSa6AISbh05emvAYmoi7i+86XXQBGScOnK018DElEXcX3nS6+BIiTh0pWnv6/R/yZaefprQCJq79nSzpdeA0WoiOtXnv4akIhawqWdL70GilAR1688/TUgEbWESztf+gND5sFhTb5NpwAAAABJRU5ErkJggg==\"/>\n    </defs>\n</svg>";

const cn$h = classNames.bind(s$d);
const ColorPicker = memo$1((props) => {
    const { onChange = () => null, onChangeComplete = () => null, inputText = 'Цвет фона', initColor = defaultColor, colorType = 'rgba', isInputDisabled = false, product = 'default', } = props;
    const [state, setState] = useState({
        background: '',
        backgroundText: '',
        backgroundHex: '',
        displayColorPicker: false,
        palletPosition: 'right',
        isActive: false,
    });
    const ref = useRef(null);
    const refMask = useRef(null);
    const refInput = useRef(null);
    const handleMaskRef = useCallback(() => {
        var _a;
        (_a = refMask.current) === null || _a === void 0 ? void 0 : _a.inputElement.focus();
    }, [refMask]);
    const handleInputRef = useCallback(() => {
        var _a;
        (_a = refInput.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [refInput]);
    const handleContainerClick = () => {
        colorType === 'hex' ? handleMaskRef() : handleInputRef();
    };
    const inputValue = useMemo(() => {
        if (colorType === 'rgba')
            return state.backgroundText;
        return state.backgroundHex;
    }, [colorType, state.backgroundHex, state.backgroundText]);
    const { indicatorStyles } = useMemo(() => {
        var _a;
        if (state.background && ((_a = state.background) === null || _a === void 0 ? void 0 : _a.a) === 0) {
            return {
                indicatorStyles: {
                    backgroundColor: 'transparent',
                    backgroundImage: `url(${background_chess})`,
                },
            };
        }
        return {
            indicatorStyles: {
                backgroundColor: `${state.backgroundText}`,
            },
        };
    }, [state.background, state.backgroundText]);
    const handleChangePicker = useCallback((color) => {
        const newColors = {
            background: color.rgb,
            backgroundHex: color.hex.replace(/#/, ''),
            backgroundText: convertRGBAToText(color.rgb),
        };
        onChange({
            rgb: newColors.background,
            text: newColors.backgroundText,
            hex: addHashColor(newColors.backgroundHex),
        });
        setState((prev) => (Object.assign(Object.assign({}, prev), newColors)));
    }, [onChange]);
    const handleChangePickerComplete = useCallback(() => {
        onChangeComplete({
            rgb: state.background,
            text: state.backgroundText,
            hex: addHashColor(state.backgroundHex),
        });
    }, [onChangeComplete, state.background, state.backgroundHex, state.backgroundText]);
    const handleChangeInput = useCallback((e) => {
        let newColors = {
            backgroundText: hexToRGBA(e.target.value),
            backgroundHex: e.target.value,
            background: convertTextToRGBA(hexToRGBA(e.target.value)) || defaultColor,
        };
        if (props.colorType === 'rgba') {
            newColors = {
                backgroundText: e.target.value,
                backgroundHex: rgbaToHex(e.target.value),
                background: convertTextToRGBA(e.target.value) || defaultColor,
            };
        }
        onChange({
            rgb: newColors.background,
            text: newColors.backgroundText,
            hex: addHashColor(newColors.backgroundHex),
        });
        setState((prev) => (Object.assign(Object.assign({}, prev), newColors)));
    }, [onChange, props.colorType]);
    const handleClickIcon = useCallback(() => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { palletPosition: 'right', displayColorPicker: true })));
    }, []);
    const handleClickPallet = useCallback((e) => {
        e.stopPropagation();
        setState((prev) => (Object.assign(Object.assign({}, prev), { palletPosition: 'left', displayColorPicker: true })));
    }, []);
    const handleClickOutside = useCallback((e) => {
        var _a;
        if (!state.displayColorPicker)
            return;
        if (e.target instanceof HTMLElement && !((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            setState((prev) => (Object.assign(Object.assign({}, prev), { displayColorPicker: false })));
        }
    }, [state.displayColorPicker]);
    const handleFocus = useCallback(() => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { isActive: true })));
    }, []);
    const handleBlur = useCallback(() => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { isActive: false })));
    }, []);
    useEffect(() => {
        let colorObj;
        let colorTextRgb;
        let colorTextHex;
        if (typeof initColor === 'string') {
            colorTextHex = initColor;
            colorTextRgb = hexToRGBA(colorTextHex);
            colorObj = convertTextToRGBA(colorTextRgb) || '';
        }
        else {
            colorObj = initColor;
            colorTextRgb = convertRGBAToText(colorObj);
            colorTextHex = rgbaToHex(colorTextRgb);
        }
        setState((prev) => (Object.assign(Object.assign({}, prev), { background: colorObj, backgroundText: colorTextRgb, backgroundHex: colorTextHex })));
    }, [initColor]);
    useEffect(() => {
        window.addEventListener('mousedown', handleClickOutside);
        return () => window.removeEventListener('mousedown', handleClickOutside);
    }, [handleClickOutside]);
    return (React__default.createElement("div", { className: cn$h('colorPicker', {
            'colorPicker--withText': !!state.backgroundHex.length,
            'colorPicker--active': state.isActive,
            ['colorPicker--' + product]: product,
        }) },
        React__default.createElement("div", { style: indicatorStyles, className: cn$h('indicator'), role: "button", tabIndex: 0, onKeyDown: () => null, onClick: handleClickPallet, "aria-label": "handleClickPallet" }),
        React__default.createElement("div", { className: cn$h('inputContainer'), role: "button", tabIndex: 0, onKeyDown: () => null, onClick: handleContainerClick, "aria-label": "handleClickPallet" },
            React__default.createElement("span", { className: cn$h('inputTitle') }, inputText),
            React__default.createElement("div", { className: cn$h('inputText'), role: "button", tabIndex: 0, onKeyDown: () => null, onClick: (e) => e.stopPropagation(), "aria-label": "handleClickPallet" }, colorType === 'hex' ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("span", null, "#"),
                React__default.createElement(MaskedInputPackage, { className: cn$h('input'), mask: COLORS_MASK.hex, type: "text", value: inputValue, onChange: handleChangeInput, onFocus: handleFocus, onBlur: handleBlur, disabled: isInputDisabled, ref: refMask }))) : (React__default.createElement("input", { type: "text", className: cn$h('input'), value: inputValue, onChange: handleChangeInput, disabled: isInputDisabled, ref: refInput })))),
        React__default.createElement("div", { className: cn$h('icon') },
            React__default.createElement(Button, { iconFill: true, label: "", leftIcon: "paint", onClick: handleClickIcon, product: "ofd", size: "large", styleType: "borderless", theme: "primary", type: "button", className: cn$h('iconButton') })),
        state.displayColorPicker && (React__default.createElement("div", { ref: ref, className: cn$h('pallet', {
                left: state.palletPosition === 'left',
                right: state.palletPosition === 'right',
            }) },
            React__default.createElement(ChromePicker, { color: state.background, onChange: handleChangePicker, onChangeComplete: handleChangePickerComplete })))));
});
ColorPicker.displayName = 'ColorPicker';

function r$1(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r$1(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx$1(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r$1(e))&&(n&&(n+=" "),n+=t);return n}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === "object" && argStr === "[object Date]")
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (
    typeof argument === "number" ||
    argStr === "[object Number]" ||
    typeof argument === "string" ||
    argStr === "[object String]"
  ) {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid$1(date) {
  if (!isDate(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}

const formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance$1 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

const dateFormats$1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

const formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full",
  }),

  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full",
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full",
  }),
};

const formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative$1 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$1[token];

/* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

const eraValues$1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues$1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber$1 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

const localize$1 = {
  ordinalNumber: ordinalNumber$1,

  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: "wide",
  }),

  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide",
  }),

  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide",
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide",
  }),
};

function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

const matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$1 = /\d+/i;

const matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns$1 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

const match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any",
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any",
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any",
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any",
  }),
};

/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const enUS = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};

let defaultOptions = {};

function getDefaultOptions$1() {
  return defaultOptions;
}

/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */


/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
const millisecondsInWeek = 604800000;

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
const millisecondsInDay = 86400000;

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
const millisecondsInMinute = 60000;

/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */
const millisecondsInHour = 3600000;

/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */
const millisecondsInSecond = 1000;

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);

  const timestampLeft =
    +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight =
    +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}

/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}

/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = getDefaultOptions$1();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);

  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = toDate(date);
  const year = _date.getFullYear();

  const defaultOptions = getDefaultOptions$1();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);

  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = getDefaultOptions$1();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}

/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek$1(date, options) {
  const _date = toDate(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / millisecondsInWeek) + 1;
}

function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

const lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },

  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  },
};

const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

const formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = getWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = getISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = getWeek$1(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return addLeadingZeros(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = getISOWeek(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return addLeadingZeros(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = getDayOfYear(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return addLeadingZeros(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  },
};

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
};

const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp$1 =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp$2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp$1 = /^'([^]*?)'?$/;
const doubleQuoteRegExp$1 = /''/g;
const unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;

/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(date, formatStr, options) {
  const defaultOptions = getDefaultOptions$1();
  const locale = options?.locale ?? defaultOptions.locale ?? enUS;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = toDate(date);

  if (!isValid$1(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp$2)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp$1)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString$1(substring) };
      }

      if (formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (!options?.useAdditionalWeekYearTokens &&
          isProtectedWeekYearToken(token)) ||
        (!options?.useAdditionalDayOfYearTokens &&
          isProtectedDayOfYearToken(token))
      ) {
        warnOrThrowProtectedError(token, formatStr, String(date));
      }

      const formatter = formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString$1(input) {
  const matched = input.match(escapedStringRegExp$1);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp$1, "'");
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(date, amount) {
  const timestamp = +toDate(date);
  return constructFrom(date, timestamp + amount);
}

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(date, amount) {
  return addMilliseconds(date, amount * millisecondsInMinute);
}

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours(date, amount) {
  return addMilliseconds(date, amount * millisecondsInHour);
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(date, amount) {
  const days = amount * 7;
  return addDays(date, days);
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */
function addMonths(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  const dayOfMonth = _date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  const endOfDesiredMonth = constructFrom(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters(date, amount) {
  const months = amount * 3;
  return addMonths(date, months);
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(date, amount) {
  return addMonths(date, amount * 12);
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(date, amount) {
  return addDays(date, -amount);
}

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(date, amount) {
  return addWeeks(date, -amount);
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(date, amount) {
  return addMonths(date, -amount);
}

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters(date, amount) {
  return addQuarters(date, -amount);
}

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(date, amount) {
  return addYears(date, -amount);
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(date) {
  const _date = toDate(date);
  const seconds = _date.getSeconds();
  return seconds;
}

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(date) {
  const _date = toDate(date);
  const minutes = _date.getMinutes();
  return minutes;
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(date) {
  const _date = toDate(date);
  const hours = _date.getHours();
  return hours;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(date) {
  const _date = toDate(date);
  const day = _date.getDay();
  return day;
}

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(date) {
  const _date = toDate(date);
  const dayOfMonth = _date.getDate();
  return dayOfMonth;
}

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  return month;
}

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(date) {
  const _date = toDate(date);
  const quarter = Math.trunc(_date.getMonth() / 3) + 1;
  return quarter;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(date) {
  return toDate(date).getFullYear();
}

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(date) {
  const _date = toDate(date);
  const timestamp = _date.getTime();
  return timestamp;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(date, seconds) {
  const _date = toDate(date);
  _date.setSeconds(seconds);
  return _date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(date, minutes) {
  const _date = toDate(date);
  _date.setMinutes(minutes);
  return _date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(date, hours) {
  const _date = toDate(date);
  _date.setHours(hours);
  return _date;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(date, month) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const day = _date.getDate();

  const dateWithDesiredMonth = constructFrom(date, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(date, quarter) {
  const _date = toDate(date);
  const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
  const diff = quarter - oldQuarter;
  return setMonth(_date, _date.getMonth() + diff * 3);
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(date, year) {
  const _date = toDate(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }

  _date.setFullYear(year);
  return _date;
}

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min$1(dates) {
  let result;

  dates.forEach((dirtyDate) => {
    const date = toDate(dirtyDate);
    if (!result || result > date || isNaN(+date)) {
      result = date;
    }
  });

  return result || new Date(NaN);
}

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max$1(dates) {
  let result;
  dates.forEach(function (dirtyDate) {
    const currentDate = toDate(dirtyDate);

    if (
      result === undefined ||
      result < currentDate ||
      isNaN(Number(currentDate))
    ) {
      result = currentDate;
    }
  });

  return result || new Date(NaN);
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);

  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();

  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);

  return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);

  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const quarterDiff = getQuarter(_dateLeft) - getQuarter(_dateRight);

  return yearDiff * 4 + quarterDiff;
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(date) {
  const _date = toDate(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(date) {
  const _date = toDate(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - (currentMonth % 3);
  _date.setMonth(month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(date) {
  const _date = toDate(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

/**
 * The {@link endOfWeek} function options.
 */

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(date, options) {
  const defaultOptions = getDefaultOptions$1();
  const weekStartsOn =
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual$1(leftDate, rightDate) {
  const _dateLeft = toDate(leftDate);
  const _dateRight = toDate(rightDate);
  return +_dateLeft === +_dateRight;
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay$1(dateLeft, dateRight) {
  const dateLeftStartOfDay = startOfDay(dateLeft);
  const dateRightStartOfDay = startOfDay(dateRight);

  return +dateLeftStartOfDay === +dateRightStartOfDay;
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth$1(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return (
    _dateLeft.getFullYear() === _dateRight.getFullYear() &&
    _dateLeft.getMonth() === _dateRight.getMonth()
  );
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear$1(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameQuarter$1(dateLeft, dateRight) {
  const dateLeftStartOfQuarter = startOfQuarter(dateLeft);
  const dateRightStartOfQuarter = startOfQuarter(dateRight);

  return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return +_date < +_dateToCompare;
}

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */
function isWithinInterval(date, interval) {
  const time = +toDate(date);
  const [startTime, endTime] = [
    +toDate(interval.start),
    +toDate(interval.end),
  ].sort((a, b) => a - b);

  return time >= startTime && time <= endTime;
}

/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */
function getDefaultOptions() {
  return Object.assign({}, getDefaultOptions$1());
}

/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */
function transpose(fromDate, constructor) {
  const date =
    constructor instanceof Date
      ? constructFrom(constructor, 0)
      : new constructor(0);
  date.setFullYear(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate(),
  );
  date.setHours(
    fromDate.getHours(),
    fromDate.getMinutes(),
    fromDate.getSeconds(),
    fromDate.getMilliseconds(),
  );
  return date;
}

const TIMEZONE_UNIT_PRIORITY = 10;

class Setter {
  subPriority = 0;

  validate(_utcDate, _options) {
    return true;
  }
}

class ValueSetter extends Setter {
  constructor(
    value,

    validateValue,

    setValue,

    priority,
    subPriority,
  ) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }

  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }

  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
}

class DateToSystemTimezoneSetter extends Setter {
  priority = TIMEZONE_UNIT_PRIORITY;
  subPriority = -1;
  set(date, flags) {
    if (flags.timestampIsSet) return date;
    return constructFrom(date, transpose(date, Date));
  }
}

class Parser {
  run(dateString, token, match, options) {
    const result = this.parse(dateString, token, match, options);
    if (!result) {
      return null;
    }

    return {
      setter: new ValueSetter(
        result.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority,
      ),
      rest: result.rest,
    };
  }

  validate(_utcDate, _value, _options) {
    return true;
  }
}

class EraParser extends Parser {
  priority = 140;

  parse(dateString, token, match) {
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return (
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );

      // A, B
      case "GGGGG":
        return match.era(dateString, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return (
          match.era(dateString, { width: "wide" }) ||
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );
    }
  }

  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["R", "u", "t", "T"];
}

const numericPatterns = {
  month: /^(1[0-2]|0?\d)/, // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/, // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/, // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/, // 0 to 12
  minute: /^[0-5]?\d/, // 0 to 59
  second: /^[0-5]?\d/, // 0 to 59

  singleDigit: /^\d/, // 0 to 9
  twoDigits: /^\d{1,2}/, // 0 to 99
  threeDigits: /^\d{1,3}/, // 0 to 999
  fourDigits: /^\d{1,4}/, // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/, // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/, // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/, // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/, // 0 to 9999, -0 to -9999
};

const timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/,
};

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest,
  };
}

function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1),
    };
  }

  const sign = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;

  return {
    value:
      sign *
      (hours * millisecondsInHour +
        minutes * millisecondsInMinute +
        seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}

function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}

function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}

function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;

  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

function isLeapYearIndex$1(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class YearParser extends Parser {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "yy",
    });

    switch (token) {
      case "y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "yo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value) {
    const currentYear = date.getFullYear();

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear,
      );
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

// Local week-numbering year
class LocalWeekYearParser extends Parser {
  priority = 130;

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "YY",
    });

    switch (token) {
      case "Y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "Yo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value, options) {
    const currentYear = getWeekYear(date, options);

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear,
      );
      date.setFullYear(
        normalizedTwoDigitYear,
        0,
        options.firstWeekContainsDate,
      );
      date.setHours(0, 0, 0, 0);
      return startOfWeek(date, options);
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return startOfWeek(date, options);
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}

// ISO week-numbering year
class ISOWeekYearParser extends Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "R") {
      return parseNDigitsSigned(4, dateString);
    }

    return parseNDigitsSigned(token.length, dateString);
  }

  set(date, _flags, value) {
    const firstWeekOfYear = constructFrom(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return startOfISOWeek(firstWeekOfYear);
  }

  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}

class ExtendedYearParser extends Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "u") {
      return parseNDigitsSigned(4, dateString);
    }

    return parseNDigitsSigned(token.length, dateString);
  }

  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}

class QuarterParser extends Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ": // 01, 02, 03, 04
        return parseNDigits(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return match.quarter(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

class StandAloneQuarterParser extends Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "q":
      case "qq": // 01, 02, 03, 04
        return parseNDigits(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return match.quarter(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

class MonthParser extends Parser {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];

  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "M":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "MM":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );

      // J, F, ..., D
      case "MMMMM":
        return match.month(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return (
          match.month(dateString, { width: "wide", context: "formatting" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}

class StandAloneMonthParser extends Parser {
  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "LL":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );

      // J, F, ..., D
      case "LLLLL":
        return match.month(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return (
          match.month(dateString, { width: "wide", context: "standalone" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

/**
 * The {@link setWeek} function options.
 */

/**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */
function setWeek(date, week, options) {
  const _date = toDate(date);
  const diff = getWeek$1(_date, options) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}

// Local week of year
class LocalWeekParser extends Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "w":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "wo":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value, options) {
    return startOfWeek(setWeek(date, value, options), options);
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}

/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek(date, week) {
  const _date = toDate(date);
  const diff = getISOWeek(_date) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}

// ISO week of year
class ISOWeekParser extends Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "I":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "Io":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value) {
    return startOfISOWeek(setISOWeek(date, value));
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}

const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR = [
  31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
];

// Day of the month
class DateParser extends Parser {
  priority = 90;
  subPriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "d":
        return parseNumericPattern(numericPatterns.date, dateString);
      case "do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = isLeapYearIndex$1(year);
    const month = date.getMonth();
    if (isLeapYear) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }

  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

class DayOfYearParser extends Parser {
  priority = 90;

  subpriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);
      case "Do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = isLeapYearIndex$1(year);
    if (isLeapYear) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }

  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}

/**
 * The {@link setDay} function options.
 */

/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay(date, day, options) {
  const defaultOptions = getDefaultOptions$1();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = toDate(date);
  const currentDay = _date.getDay();

  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;

  const delta = 7 - weekStartsOn;
  const diff =
    day < 0 || day > 6
      ? day - ((currentDay + delta) % 7)
      : ((dayIndex + delta) % 7) - ((currentDay + delta) % 7);
  return addDays(_date, diff);
}

// Day of week
class DayParser extends Parser {
  priority = 90;

  parse(dateString, token, match) {
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "EEEEE":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "EEEE":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}

// Local day of week
class LocalDayParser extends Parser {
  priority = 90;
  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "e":
      case "ee": // 03
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      // 3rd
      case "eo":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "eee":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "eeeee":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "eeee":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T",
  ];
}

// Stand-alone local day of week
class StandAloneLocalDayParser extends Parser {
  priority = 90;

  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "c":
      case "cc": // 03
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      // 3rd
      case "co":
        return mapValue(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "ccc":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // T
      case "ccccc":
        return match.day(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return (
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // Tuesday
      case "cccc":
      default:
        return (
          match.day(dateString, { width: "wide", context: "standalone" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T",
  ];
}

/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay(date) {
  const _date = toDate(date);
  let day = _date.getDay();

  if (day === 0) {
    day = 7;
  }

  return day;
}

/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay(date, day) {
  const _date = toDate(date);
  const currentDay = getISODay(_date);
  const diff = day - currentDay;
  return addDays(_date, diff);
}

// ISO day of week
class ISODayParser extends Parser {
  priority = 90;

  parse(dateString, token, match) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };

    switch (token) {
      // 2
      case "i":
      case "ii": // 02
        return parseNDigits(token.length, dateString);
      // 2nd
      case "io":
        return match.ordinalNumber(dateString, { unit: "day" });
      // Tue
      case "iii":
        return mapValue(
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // T
      case "iiiii":
        return mapValue(
          match.day(dateString, {
            width: "narrow",
            context: "formatting",
          }),
          valueCallback,
        );
      // Tu
      case "iiiiii":
        return mapValue(
          match.day(dateString, {
            width: "short",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // Tuesday
      case "iiii":
      default:
        return mapValue(
          match.day(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "abbreviated",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 7;
  }

  set(date, _flags, value) {
    date = setISODay(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T",
  ];
}

class AMPMParser extends Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "aaaaa":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}

class AMPMMidnightParser extends Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "bbbbb":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}

// in the morning, in the afternoon, in the evening, at night
class DayPeriodParser extends Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "BBBBB":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "t", "T"];
}

class Hour1to12Parser extends Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, dateString);
      case "ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 12;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["H", "K", "k", "t", "T"];
}

class Hour0to23Parser extends Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, dateString);
      case "Ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 23;
  }

  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}

class Hour0To11Parser extends Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, dateString);
      case "Ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["h", "H", "k", "t", "T"];
}

class Hour1To24Parser extends Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, dateString);
      case "ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 24;
  }

  set(date, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date.setHours(hours, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}

class MinuteParser extends Parser {
  priority = 60;

  parse(dateString, token, match) {
    switch (token) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, dateString);
      case "mo":
        return match.ordinalNumber(dateString, { unit: "minute" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}

class SecondParser extends Parser {
  priority = 50;

  parse(dateString, token, match) {
    switch (token) {
      case "s":
        return parseNumericPattern(numericPatterns.second, dateString);
      case "so":
        return match.ordinalNumber(dateString, { unit: "second" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}

class FractionOfSecondParser extends Parser {
  priority = 30;

  parse(dateString, token) {
    const valueCallback = (value) =>
      Math.trunc(value * Math.pow(10, -token.length + 3));
    return mapValue(parseNDigits(token.length, dateString), valueCallback);
  }

  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}

// Timezone (ISO-8601. +00:00 is `'Z'`)
class ISOTimezoneWithZParser extends Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "X":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "XXXX":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "XXXXX":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds(date) - value,
    );
  }

  incompatibleTokens = ["t", "T", "x"];
}

// Timezone (ISO-8601)
class ISOTimezoneParser extends Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "x":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "xxxx":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "xxxxx":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds(date) - value,
    );
  }

  incompatibleTokens = ["t", "T", "X"];
}

class TimestampSecondsParser extends Parser {
  priority = 40;

  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }

  set(date, _flags, value) {
    return [constructFrom(date, value * 1000), { timestampIsSet: true }];
  }

  incompatibleTokens = "*";
}

class TimestampMillisecondsParser extends Parser {
  priority = 20;

  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }

  set(date, _flags, value) {
    return [constructFrom(date, value), { timestampIsSet: true }];
  }

  incompatibleTokens = "*";
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser(),
};

/**
 * The {@link parse} function options.
 */

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;

const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dateStr, formatStr, referenceDate, options) {
  const defaultOptions = getDefaultOptions();
  const locale = options?.locale ?? defaultOptions.locale ?? enUS;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  if (formatStr === "") {
    if (dateStr === "") {
      return toDate(referenceDate);
    } else {
      return constructFrom(referenceDate, NaN);
    }
  }

  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  // If timezone isn't specified, it will be set to the system timezone
  const setters = [new DateToSystemTimezoneSetter()];

  const tokens = formatStr
    .match(longFormattingTokensRegExp$1)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter in longFormatters) {
        const longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp);

  const usedTokens = [];

  for (let token of tokens) {
    if (
      !options?.useAdditionalWeekYearTokens &&
      isProtectedWeekYearToken(token)
    ) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    if (
      !options?.useAdditionalDayOfYearTokens &&
      isProtectedDayOfYearToken(token)
    ) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }

    const firstCharacter = token[0];
    const parser = parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find(
          (usedToken) =>
            incompatibleTokens.includes(usedToken.token) ||
            usedToken.token === firstCharacter,
        );
        if (incompatibleToken) {
          throw new RangeError(
            `The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`,
          );
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(
          `The format string mustn't contain \`${token}\` and any other token at the same time`,
        );
      }

      usedTokens.push({ token: firstCharacter, fullToken: token });

      const parseResult = parser.run(
        dateStr,
        token,
        locale.match,
        subFnOptions,
      );

      if (!parseResult) {
        return constructFrom(referenceDate, NaN);
      }

      setters.push(parseResult.setter);

      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      // Replace two single quote characters with one single quote character
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      }

      // Cut token from string, or, if string doesn't match the token, return Invalid Date
      if (dateStr.indexOf(token) === 0) {
        dateStr = dateStr.slice(token.length);
      } else {
        return constructFrom(referenceDate, NaN);
      }
    }
  }

  // Check if the remaining input contains something other than whitespace
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return constructFrom(referenceDate, NaN);
  }

  const uniquePrioritySetters = setters
    .map((setter) => setter.priority)
    .sort((a, b) => b - a)
    .filter((priority, index, array) => array.indexOf(priority) === index)
    .map((priority) =>
      setters
        .filter((setter) => setter.priority === priority)
        .sort((a, b) => b.subPriority - a.subPriority),
    )
    .map((setterArray) => setterArray[0]);

  let date = toDate(referenceDate);

  if (isNaN(date.getTime())) {
    return constructFrom(referenceDate, NaN);
  }

  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return constructFrom(referenceDate, NaN);
    }

    const result = setter.set(date, flags, subFnOptions);
    // Result is tuple (date, flags)
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
      // Result is date
    } else {
      date = result;
    }
  }

  return constructFrom(referenceDate, date);
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * The {@link parseISO} function options.
 */

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  const additionalDigits = 2;
  const dateStrings = splitDateString(argument);

  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate$1(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  const timestamp = date.getTime();
  let time = 0;
  let offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    // JS parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    const result = new Date(0);
    result.setFullYear(
      dirtyDate.getUTCFullYear(),
      dirtyDate.getUTCMonth(),
      dirtyDate.getUTCDate(),
    );
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds(),
    );
    return result;
  }

  return new Date(timestamp + time + offset);
}

const patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/,
};

const dateRegex =
  /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex =
  /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length,
      );
    }
  }

  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  const regex = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" +
      (4 + additionalDigits) +
      "})|(\\d{2}|[+-]\\d{" +
      (2 + additionalDigits) +
      "})$)",
  );

  const captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return { year: NaN, restDateString: "" };

  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length),
  };
}

function parseDate$1(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);

  const captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);

  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = new Date(0);
    if (
      !validateDate(year, month, day) ||
      !validateDayOfYearDate(year, dayOfYear)
    ) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return (
    hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000
  );
}

function parseTimeUnit(value) {
  return (value && parseFloat(value.replace(",", "."))) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;

  const captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;

  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = (captures[3] && parseInt(captures[3])) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
const daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

function validateDate(year, month, date) {
  return (
    month >= 0 &&
    month <= 11 &&
    date >= 1 &&
    date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28))
  );
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return (
    seconds >= 0 &&
    seconds < 60 &&
    minutes >= 0 &&
    minutes < 60 &&
    hours >= 0 &&
    hours < 25
  );
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds(date, amount) {
  return addMilliseconds(date, amount * 1000);
}

/**
 * The {@link isSameWeek} function options.
 */

/**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameWeek(dateLeft, dateRight, options) {
  const dateLeftStartOfWeek = startOfWeek(dateLeft, options);
  const dateRightStartOfWeek = startOfWeek(dateRight, options);

  return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */

function set(date, values) {
  let _date = toDate(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }

  if (values.year != null) {
    _date.setFullYear(values.year);
  }

  if (values.month != null) {
    _date = setMonth(_date, values.month);
  }

  if (values.date != null) {
    _date.setDate(values.date);
  }

  if (values.hours != null) {
    _date.setHours(values.hours);
  }

  if (values.minutes != null) {
    _date.setMinutes(values.minutes);
  }

  if (values.seconds != null) {
    _date.setSeconds(values.seconds);
  }

  if (values.milliseconds != null) {
    _date.setMilliseconds(values.milliseconds);
  }

  return _date;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf$1(subClass, superClass);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return findDOMNode$1(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;
          if (_this.initTimeStamp > event.timeStamp) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized$1(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized$1(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      _this.initTimeStamp = performance.now();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      this.getInstance();

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement(WrappedComponent, props);
    };

    return onClickOutside;
  }(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [':popover-open', ':modal'].some(selector => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle$2(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$2(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp$1(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$3 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp$1(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$2 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset$2 = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

function getCssDimensions(element) {
  const css = getComputedStyle$2(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}

function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 :
  // RTL <body> scrollbar.
  getWindowScrollBarX(documentElement, htmlRect));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$2(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$2(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$2(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
      // Firefox with layout.scrollbar.side = 3 in about:config to test this.
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return getComputedStyle$2(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$2(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};

function isRTL(element) {
  return getComputedStyle$2(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset$1 = offset$2;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$1 = flip$2;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$2 = arrow$3;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

var index$1 = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = React$1.useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React$1.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React$1.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React$1.useState(null);
  const [_floating, _setFloating] = React$1.useState(null);
  const setReference = React$1.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React$1.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React$1.useRef(null);
  const floatingRef = React$1.useRef(null);
  const dataRef = React$1.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const openRef = useLatestRef(open);
  const update = React$1.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index$1(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React$1.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$1(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React$1.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React$1.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React$1.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React$1.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$2({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow$2({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = (options, deps) => ({
  ...offset$1(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = (options, deps) => ({
  ...flip$1(options),
  options: [options, deps]
});

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = (options, deps) => ({
  ...arrow$1(options),
  options: [options, deps]
});

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const SafeReact = {
  ...React$1
};

const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = React$1.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error('Cannot call an event handler while rendering.');
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React$1.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

var index = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

let serverHandoffComplete = false;
let count = 0;
const genId = () => // Ensure the id is unique with multiple independent versions of Floating UI
// on <React 18
"floating-ui-" + Math.random().toString(36).slice(2, 6) + count++;
function useFloatingId() {
  const [id, setId] = React$1.useState(() => serverHandoffComplete ? genId() : undefined);
  index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React$1.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = SafeReact.useId;

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */
const useId = useReactId || useFloatingId;

let devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /*#__PURE__*/new Set();
}
function warn() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
    console.warn(message);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
    console.error(message);
  }
}

/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */
const FloatingArrow = /*#__PURE__*/React$1.forwardRef(function FloatingArrow(props, ref) {
  const {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow,
        shift
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = props;
  if (process.env.NODE_ENV !== "production") {
    if (!ref) {
      warn('The `ref` prop is required for `FloatingArrow`.');
    }
  }
  const clipPathId = useId();
  const [isRTL, setIsRTL] = React$1.useState(false);

  // https://github.com/floating-ui/floating-ui/issues/2932
  index(() => {
    if (!floating) return;
    const isRTL = getComputedStyle$2(floating).direction === 'rtl';
    if (isRTL) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }
  const [side, alignment] = placement.split('-');
  const isVerticalSide = side === 'top' || side === 'bottom';
  let computedStaticOffset = staticOffset;
  if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) {
    computedStaticOffset = null;
  }

  // Strokes must be double the border width, this ensures the stroke's width
  // works as you'd expect.
  const computedStrokeWidth = strokeWidth * 2;
  const halfStrokeWidth = computedStrokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const isCustomShape = !!d;
  const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
  let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
  if (computedStaticOffset && isRTL) {
    xOffsetProp = alignment === 'end' ? 'left' : 'right';
  }
  const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
  const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
  const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
  const rotation = {
    top: isCustomShape ? 'rotate(180deg)' : '',
    left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
    bottom: isCustomShape ? '' : 'rotate(180deg)',
    right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
  }[side];
  return /*#__PURE__*/React$1.createElement("svg", _extends$1({}, rest, {
    "aria-hidden": true,
    ref: ref,
    width: isCustomShape ? width : width + computedStrokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
      transform: [rotation, transform].filter(t => !!t).join(' '),
      ...restStyle
    }
  }), computedStrokeWidth > 0 && /*#__PURE__*/React$1.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke: stroke
    // Account for the stroke on the fill path rendered below.
    ,
    strokeWidth: computedStrokeWidth + (d ? 0 : 1),
    d: dValue
  }), /*#__PURE__*/React$1.createElement("path", {
    stroke: computedStrokeWidth && !d ? rest.fill : 'none',
    d: dValue
  }), /*#__PURE__*/React$1.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React$1.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width + computedStrokeWidth,
    height: width
  })));
});

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(l => l !== listener)) || []);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/React$1.createContext(null);
const FloatingTreeContext = /*#__PURE__*/React$1.createContext(null);

/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React$1.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};

/**
 * Returns the nearest floating tree context, if available.
 */
const useFloatingTree = () => React$1.useContext(FloatingTreeContext);

function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = React$1.useRef({});
  const [events] = React$1.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const optionDomReference = elementsProp.reference;
    if (optionDomReference && !isElement(optionDomReference)) {
      error('Cannot pass a virtual element to the `elements.reference` option,', 'as it must be a real DOM element. Use `refs.setPositionReference()`', 'instead.');
    }
  }
  const [positionReference, setPositionReference] = React$1.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open, event, reason) => {
    dataRef.current.openEvent = open ? event : undefined;
    events.emit('openchange', {
      open,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
  });
  const refs = React$1.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = React$1.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return React$1.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = React$1.useState(null);
  const [positionReference, _setPositionReference] = React$1.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = React$1.useRef(null);
  const tree = useFloatingTree();
  index(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position = useFloating$1({
    ...options,
    elements: {
      ...computedElements,
      ...(positionReference && {
        reference: positionReference
      })
    }
  });
  const setPositionReference = React$1.useCallback(node => {
    const computedPositionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    // Store the positionReference in state if the DOM reference is specified externally via the
    // `elements.reference` option. This ensures that it won't be overridden on future renders.
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  const setReference = React$1.useCallback(node => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React$1.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React$1.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = React$1.useMemo(() => ({
    ...position,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position, refs, elements, nodeId, rootContext]);
  index(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React$1.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

/*!
  react-datepicker v6.9.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive$1(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey$1(t) {
  var i = _toPrimitive$1(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DEFAULT_YEAR_ITEM_NUMBER = 12;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

// ** Date Constructors **

function newDate(value) {
  var d = value ? typeof value === "string" || value instanceof String ? parseISO(value) : toDate(value) : new Date();
  return isValid(d) ? d : null;
}
function parseDate(value, dateFormat, locale, strictParsing, minDate) {
  var parsedDate = null;
  var localeObject = getLocaleObject(locale) || getLocaleObject(getDefaultLocale());
  var strictParsingValueMatch = true;
  if (Array.isArray(dateFormat)) {
    dateFormat.forEach(function (df) {
      var tryParseDate = parse(value, df, new Date(), {
        locale: localeObject,
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
      });
      if (strictParsing) {
        strictParsingValueMatch = isValid(tryParseDate, minDate) && value === formatDate(tryParseDate, df, locale);
      }
      if (isValid(tryParseDate, minDate) && strictParsingValueMatch) {
        parsedDate = tryParseDate;
      }
    });
    return parsedDate;
  }
  parsedDate = parse(value, dateFormat, new Date(), {
    locale: localeObject,
    useAdditionalWeekYearTokens: true,
    useAdditionalDayOfYearTokens: true
  });
  if (strictParsing) {
    strictParsingValueMatch = isValid(parsedDate) && value === formatDate(parsedDate, dateFormat, locale);
  } else if (!isValid(parsedDate)) {
    dateFormat = dateFormat.match(longFormattingTokensRegExp).map(function (substring) {
      var firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        var longFormatter = longFormatters[firstCharacter];
        return localeObject ? longFormatter(substring, localeObject.formatLong) : firstCharacter;
      }
      return substring;
    }).join("");
    if (value.length > 0) {
      parsedDate = parse(value, dateFormat.slice(0, value.length), new Date(), {
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
      });
    }
    if (!isValid(parsedDate)) {
      parsedDate = new Date(value);
    }
  }
  return isValid(parsedDate) && strictParsingValueMatch ? parsedDate : null;
}
function isValid(date, minDate) {
  minDate = minDate ? minDate : new Date("1/1/1000");
  return isValid$1(date) && !isBefore(date, minDate);
}

// ** Date Formatting **

function formatDate(date, formatStr, locale) {
  if (locale === "en") {
    return format(date, formatStr, {
      useAdditionalWeekYearTokens: true,
      useAdditionalDayOfYearTokens: true
    });
  }
  var localeObj = getLocaleObject(locale);
  if (locale && !localeObj) {
    console.warn("A locale object was not found for the provided string [\"".concat(locale, "\"]."));
  }
  if (!localeObj && !!getDefaultLocale() && !!getLocaleObject(getDefaultLocale())) {
    localeObj = getLocaleObject(getDefaultLocale());
  }
  return format(date, formatStr, {
    locale: localeObj ? localeObj : null,
    useAdditionalWeekYearTokens: true,
    useAdditionalDayOfYearTokens: true
  });
}
function safeDateFormat(date, _ref) {
  var dateFormat = _ref.dateFormat,
    locale = _ref.locale;
  return date && formatDate(date, Array.isArray(dateFormat) ? dateFormat[0] : dateFormat, locale) || "";
}
function safeDateRangeFormat(startDate, endDate, props) {
  if (!startDate) {
    return "";
  }
  var formattedStartDate = safeDateFormat(startDate, props);
  var formattedEndDate = endDate ? safeDateFormat(endDate, props) : "";
  return "".concat(formattedStartDate, " - ").concat(formattedEndDate);
}
function safeMultipleDatesFormat(dates, props) {
  if (!(dates !== null && dates !== void 0 && dates.length)) {
    return "";
  }
  var formattedFirstDate = safeDateFormat(dates[0], props);
  if (dates.length === 1) {
    return formattedFirstDate;
  }
  if (dates.length === 2) {
    var formattedSecondDate = safeDateFormat(dates[1], props);
    return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
  }
  var extraDatesCount = dates.length - 1;
  return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}

// ** Date Setters **

function setTime(date, _ref2) {
  var _ref2$hour = _ref2.hour,
    hour = _ref2$hour === void 0 ? 0 : _ref2$hour,
    _ref2$minute = _ref2.minute,
    minute = _ref2$minute === void 0 ? 0 : _ref2$minute,
    _ref2$second = _ref2.second,
    second = _ref2$second === void 0 ? 0 : _ref2$second;
  return setHours(setMinutes(setSeconds(date, second), minute), hour);
}
function getWeek(date, locale) {
  getDefaultLocale() && getLocaleObject(getDefaultLocale());
  return getISOWeek(date);
}
function getDayOfWeekCode(day, locale) {
  return formatDate(day, "ddd", locale);
}

// *** Start of ***

function getStartOfDay(date) {
  return startOfDay(date);
}
function getStartOfWeek(date, locale, calendarStartDay) {
  var localeObj = locale ? getLocaleObject(locale) : getLocaleObject(getDefaultLocale());
  return startOfWeek(date, {
    locale: localeObj,
    weekStartsOn: calendarStartDay
  });
}
function getStartOfMonth(date) {
  return startOfMonth(date);
}
function getStartOfYear(date) {
  return startOfYear(date);
}
function getStartOfQuarter(date) {
  return startOfQuarter(date);
}
function getStartOfToday() {
  return startOfDay(newDate());
}

// *** End of ***

function getEndOfWeek(date) {
  return endOfWeek(date);
}
function isSameYear(date1, date2) {
  if (date1 && date2) {
    return isSameYear$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return isSameMonth$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isSameQuarter(date1, date2) {
  if (date1 && date2) {
    return isSameQuarter$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isSameDay(date1, date2) {
  if (date1 && date2) {
    return isSameDay$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isEqual(date1, date2) {
  if (date1 && date2) {
    return isEqual$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isDayInRange(day, startDate, endDate) {
  var valid;
  var start = startOfDay(startDate);
  var end = endOfDay(endDate);
  try {
    valid = isWithinInterval(day, {
      start: start,
      end: end
    });
  } catch (err) {
    valid = false;
  }
  return valid;
}

// ** Date Localization **

function registerLocale(localeName, localeData) {
  var scope = typeof window !== "undefined" ? window : globalThis;
  if (!scope.__localeData__) {
    scope.__localeData__ = {};
  }
  scope.__localeData__[localeName] = localeData;
}
function getDefaultLocale() {
  var scope = typeof window !== "undefined" ? window : globalThis;
  return scope.__localeId__;
}
function getLocaleObject(localeSpec) {
  if (typeof localeSpec === "string") {
    // Treat it as a locale name registered by registerLocale
    var scope = typeof window !== "undefined" ? window : globalThis;
    return scope.__localeData__ ? scope.__localeData__[localeSpec] : null;
  } else {
    // Treat it as a raw date-fns locale object
    return localeSpec;
  }
}
function getFormattedWeekdayInLocale(date, formatFunc, locale) {
  return formatFunc(formatDate(date, "EEEE", locale));
}
function getWeekdayMinInLocale(date, locale) {
  return formatDate(date, "EEEEEE", locale);
}
function getWeekdayShortInLocale(date, locale) {
  return formatDate(date, "EEE", locale);
}
function getMonthInLocale(month, locale) {
  return formatDate(setMonth(newDate(), month), "LLLL", locale);
}
function getMonthShortInLocale(month, locale) {
  return formatDate(setMonth(newDate(), month), "LLL", locale);
}
function getQuarterShortInLocale(quarter, locale) {
  return formatDate(setQuarter(newDate(), quarter), "QQQ", locale);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    minDate = _ref3.minDate,
    maxDate = _ref3.maxDate,
    excludeDates = _ref3.excludeDates,
    excludeDateIntervals = _ref3.excludeDateIntervals,
    includeDates = _ref3.includeDates,
    includeDateIntervals = _ref3.includeDateIntervals,
    filterDate = _ref3.filterDate;
  return isOutOfBounds(day, {
    minDate: minDate,
    maxDate: maxDate
  }) || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate.date ? excludeDate.date : excludeDate);
  }) || excludeDateIntervals && excludeDateIntervals.some(function (_ref4) {
    var start = _ref4.start,
      end = _ref4.end;
    return isWithinInterval(day, {
      start: start,
      end: end
    });
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || includeDateIntervals && !includeDateIntervals.some(function (_ref5) {
    var start = _ref5.start,
      end = _ref5.end;
    return isWithinInterval(day, {
      start: start,
      end: end
    });
  }) || filterDate && !filterDate(newDate(day)) || false;
}
function isDayExcluded(day) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    excludeDates = _ref6.excludeDates,
    excludeDateIntervals = _ref6.excludeDateIntervals;
  if (excludeDateIntervals && excludeDateIntervals.length > 0) {
    return excludeDateIntervals.some(function (_ref7) {
      var start = _ref7.start,
        end = _ref7.end;
      return isWithinInterval(day, {
        start: start,
        end: end
      });
    });
  }
  return excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate.date ? excludeDate.date : excludeDate);
  }) || false;
}
function isMonthDisabled(month) {
  var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    minDate = _ref8.minDate,
    maxDate = _ref8.maxDate,
    excludeDates = _ref8.excludeDates,
    includeDates = _ref8.includeDates,
    filterDate = _ref8.filterDate;
  return isOutOfBounds(month, {
    minDate: startOfMonth(minDate),
    maxDate: endOfMonth(maxDate)
  }) || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameMonth(month, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameMonth(month, includeDate);
  }) || filterDate && !filterDate(newDate(month)) || false;
}
function isMonthInRange(startDate, endDate, m, day) {
  var startDateYear = getYear(startDate);
  var startDateMonth = getMonth(startDate);
  var endDateYear = getYear(endDate);
  var endDateMonth = getMonth(endDate);
  var dayYear = getYear(day);
  if (startDateYear === endDateYear && startDateYear === dayYear) {
    return startDateMonth <= m && m <= endDateMonth;
  } else if (startDateYear < endDateYear) {
    return dayYear === startDateYear && startDateMonth <= m || dayYear === endDateYear && endDateMonth >= m || dayYear < endDateYear && dayYear > startDateYear;
  }
}
function isQuarterDisabled(quarter) {
  var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    minDate = _ref9.minDate,
    maxDate = _ref9.maxDate,
    excludeDates = _ref9.excludeDates,
    includeDates = _ref9.includeDates,
    filterDate = _ref9.filterDate;
  return isOutOfBounds(quarter, {
    minDate: minDate,
    maxDate: maxDate
  }) || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameQuarter(quarter, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameQuarter(quarter, includeDate);
  }) || filterDate && !filterDate(newDate(quarter)) || false;
}

/**
 * @param {number} year
 * @param {Date} start
 * @param {Date} end
 * @returns {boolean}
 */
function isYearInRange(year, start, end) {
  if (!isValid$1(start) || !isValid$1(end)) return false;
  var startYear = getYear(start);
  var endYear = getYear(end);
  return startYear <= year && endYear >= year;
}
function isYearDisabled(year) {
  var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    minDate = _ref10.minDate,
    maxDate = _ref10.maxDate,
    excludeDates = _ref10.excludeDates,
    includeDates = _ref10.includeDates,
    filterDate = _ref10.filterDate;
  var date = new Date(year, 0, 1);
  return isOutOfBounds(date, {
    minDate: startOfYear(minDate),
    maxDate: endOfYear(maxDate)
  }) || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameYear(date, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameYear(date, includeDate);
  }) || filterDate && !filterDate(newDate(date)) || false;
}
function isQuarterInRange(startDate, endDate, q, day) {
  var startDateYear = getYear(startDate);
  var startDateQuarter = getQuarter(startDate);
  var endDateYear = getYear(endDate);
  var endDateQuarter = getQuarter(endDate);
  var dayYear = getYear(day);
  if (startDateYear === endDateYear && startDateYear === dayYear) {
    return startDateQuarter <= q && q <= endDateQuarter;
  } else if (startDateYear < endDateYear) {
    return dayYear === startDateYear && startDateQuarter <= q || dayYear === endDateYear && endDateQuarter >= q || dayYear < endDateYear && dayYear > startDateYear;
  }
}
function isOutOfBounds(day) {
  var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    minDate = _ref11.minDate,
    maxDate = _ref11.maxDate;
  return minDate && differenceInCalendarDays(day, minDate) < 0 || maxDate && differenceInCalendarDays(day, maxDate) > 0;
}
function isTimeInList(time, times) {
  return times.some(function (listTime) {
    return getHours(listTime) === getHours(time) && getMinutes(listTime) === getMinutes(time) && getSeconds(listTime) === getSeconds(time);
  });
}
function isTimeDisabled(time) {
  var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    excludeTimes = _ref12.excludeTimes,
    includeTimes = _ref12.includeTimes,
    filterTime = _ref12.filterTime;
  return excludeTimes && isTimeInList(time, excludeTimes) || includeTimes && !isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function isTimeInDisabledRange(time, _ref13) {
  var minTime = _ref13.minTime,
    maxTime = _ref13.maxTime;
  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }
  var baseTime = newDate();
  baseTime = setHours(baseTime, getHours(time));
  baseTime = setMinutes(baseTime, getMinutes(time));
  baseTime = setSeconds(baseTime, getSeconds(time));
  var min = newDate();
  min = setHours(min, getHours(minTime));
  min = setMinutes(min, getMinutes(minTime));
  min = setSeconds(min, getSeconds(minTime));
  var max = newDate();
  max = setHours(max, getHours(maxTime));
  max = setMinutes(max, getMinutes(maxTime));
  max = setSeconds(max, getSeconds(maxTime));
  var valid;
  try {
    valid = !isWithinInterval(baseTime, {
      start: min,
      end: max
    });
  } catch (err) {
    valid = false;
  }
  return valid;
}
function monthDisabledBefore(day) {
  var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    minDate = _ref14.minDate,
    includeDates = _ref14.includeDates;
  var previousMonth = subMonths(day, 1);
  return minDate && differenceInCalendarMonths(minDate, previousMonth) > 0 || includeDates && includeDates.every(function (includeDate) {
    return differenceInCalendarMonths(includeDate, previousMonth) > 0;
  }) || false;
}
function monthDisabledAfter(day) {
  var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    maxDate = _ref15.maxDate,
    includeDates = _ref15.includeDates;
  var nextMonth = addMonths(day, 1);
  return maxDate && differenceInCalendarMonths(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function (includeDate) {
    return differenceInCalendarMonths(nextMonth, includeDate) > 0;
  }) || false;
}
function quarterDisabledBefore(date) {
  var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    minDate = _ref16.minDate,
    includeDates = _ref16.includeDates;
  var firstDateOfYear = startOfYear(date);
  var previousQuarter = subQuarters(firstDateOfYear, 1);
  return minDate && differenceInCalendarQuarters(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function (includeDate) {
    return differenceInCalendarQuarters(includeDate, previousQuarter) > 0;
  }) || false;
}
function quarterDisabledAfter(date) {
  var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    maxDate = _ref17.maxDate,
    includeDates = _ref17.includeDates;
  var lastDateOfYear = endOfYear(date);
  var nextQuarter = addQuarters(lastDateOfYear, 1);
  return maxDate && differenceInCalendarQuarters(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function (includeDate) {
    return differenceInCalendarQuarters(nextQuarter, includeDate) > 0;
  }) || false;
}
function yearDisabledBefore(day) {
  var _ref18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    minDate = _ref18.minDate,
    includeDates = _ref18.includeDates;
  var previousYear = subYears(day, 1);
  return minDate && differenceInCalendarYears(minDate, previousYear) > 0 || includeDates && includeDates.every(function (includeDate) {
    return differenceInCalendarYears(includeDate, previousYear) > 0;
  }) || false;
}
function yearsDisabledBefore(day) {
  var _ref19 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    minDate = _ref19.minDate,
    _ref19$yearItemNumber = _ref19.yearItemNumber,
    yearItemNumber = _ref19$yearItemNumber === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _ref19$yearItemNumber;
  var previousYear = getStartOfYear(subYears(day, yearItemNumber));
  var _getYearsPeriod = getYearsPeriod(previousYear, yearItemNumber),
    endPeriod = _getYearsPeriod.endPeriod;
  var minDateYear = minDate && getYear(minDate);
  return minDateYear && minDateYear > endPeriod || false;
}
function yearDisabledAfter(day) {
  var _ref20 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    maxDate = _ref20.maxDate,
    includeDates = _ref20.includeDates;
  var nextYear = addYears(day, 1);
  return maxDate && differenceInCalendarYears(nextYear, maxDate) > 0 || includeDates && includeDates.every(function (includeDate) {
    return differenceInCalendarYears(nextYear, includeDate) > 0;
  }) || false;
}
function yearsDisabledAfter(day) {
  var _ref21 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    maxDate = _ref21.maxDate,
    _ref21$yearItemNumber = _ref21.yearItemNumber,
    yearItemNumber = _ref21$yearItemNumber === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _ref21$yearItemNumber;
  var nextYear = addYears(day, yearItemNumber);
  var _getYearsPeriod2 = getYearsPeriod(nextYear, yearItemNumber),
    startPeriod = _getYearsPeriod2.startPeriod;
  var maxDateYear = maxDate && getYear(maxDate);
  return maxDateYear && maxDateYear < startPeriod || false;
}
function getEffectiveMinDate(_ref22) {
  var minDate = _ref22.minDate,
    includeDates = _ref22.includeDates;
  if (includeDates && minDate) {
    var minDates = includeDates.filter(function (includeDate) {
      return differenceInCalendarDays(includeDate, minDate) >= 0;
    });
    return min$1(minDates);
  } else if (includeDates) {
    return min$1(includeDates);
  } else {
    return minDate;
  }
}
function getEffectiveMaxDate(_ref23) {
  var maxDate = _ref23.maxDate,
    includeDates = _ref23.includeDates;
  if (includeDates && maxDate) {
    var maxDates = includeDates.filter(function (includeDate) {
      return differenceInCalendarDays(includeDate, maxDate) <= 0;
    });
    return max$1(maxDates);
  } else if (includeDates) {
    return max$1(includeDates);
  } else {
    return maxDate;
  }
}
function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";
  var dateClasses = new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isDate(obj)) {
      var key = formatDate(obj, "MM.dd.yyyy");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if (_typeof$1(obj) === "object") {
      var keys = Object.keys(obj);
      var className = keys[0];
      var arrOfDates = obj[keys[0]];
      if (typeof className === "string" && arrOfDates.constructor === Array) {
        for (var k = 0, _len = arrOfDates.length; k < _len; k++) {
          var _key = formatDate(arrOfDates[k], "MM.dd.yyyy");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }
  return dateClasses;
}

/**
 * Compare the two arrays
 * @param {Array} array1
 * @param {Array} array2
 * @returns {Boolean} true, if the passed array are equal, false otherwise
 */
function arraysAreEqual(array1, array2) {
  if (array1.length !== array2.length) {
    return false;
  }
  return array1.every(function (value, index) {
    return value === array2[index];
  });
}

/**
 * Assign the custom class to each date
 * @param {Array} holidayDates array of object containing date and name of the holiday
 * @param {string} classname to be added.
 * @returns {Map} Map containing date as key and array of classname and holiday name as value
 */
function getHolidaysMap() {
  var holidayDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--holidays";
  var dateClasses = new Map();
  holidayDates.forEach(function (holiday) {
    var dateObj = holiday.date,
      holidayName = holiday.holidayName;
    if (!isDate(dateObj)) {
      return;
    }
    var key = formatDate(dateObj, "MM.dd.yyyy");
    var classNamesObj = dateClasses.get(key) || {};
    if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && arraysAreEqual(classNamesObj["holidayNames"], [holidayName])) {
      return;
    }
    classNamesObj["className"] = defaultClassName;
    var holidayNameArr = classNamesObj["holidayNames"];
    classNamesObj["holidayNames"] = holidayNameArr ? [].concat(_toConsumableArray(holidayNameArr), [holidayName]) : [holidayName];
    dateClasses.set(key, classNamesObj);
  });
  return dateClasses;
}
function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l; i++) {
    var injectedTime = startOfDay;
    injectedTime = addHours(injectedTime, getHours(injectedTimes[i]));
    injectedTime = addMinutes(injectedTime, getMinutes(injectedTimes[i]));
    injectedTime = addSeconds(injectedTime, getSeconds(injectedTimes[i]));
    var nextTime = addMinutes(startOfDay, (currentMultiplier + 1) * intervals);
    if (isAfter(injectedTime, currentTime) && isBefore(injectedTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }
  return times;
}
function addZero(i) {
  return i < 10 ? "0".concat(i) : "".concat(i);
}
function getYearsPeriod(date) {
  var yearItemNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_YEAR_ITEM_NUMBER;
  var endPeriod = Math.ceil(getYear(date) / yearItemNumber) * yearItemNumber;
  var startPeriod = endPeriod - (yearItemNumber - 1);
  return {
    startPeriod: startPeriod,
    endPeriod: endPeriod
  };
}
function getHoursInDay(d) {
  var startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  var startOfTheNextDay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 24);
  return Math.round((+startOfTheNextDay - +startOfDay) / 3600000);
}

/**
 * Returns the start of the minute for the given date
 *
 * NOTE: this function is a DST and timezone-safe analog of `date-fns/startOfMinute`
 * do not make changes unless you know what you're doing
 *
 * See comments on https://github.com/Hacker0x01/react-datepicker/pull/4244
 * for more details
 *
 * @param {Date} d date
 * @returns {Date} start of the minute
 */
function startOfMinute(d) {
  var seconds = d.getSeconds();
  var milliseconds = d.getMilliseconds();
  return toDate(d.getTime() - seconds * 1000 - milliseconds);
}

/**
 * Returns whether the given dates are in the same minute
 *
 * This function is a DST and timezone-safe analog of `date-fns/isSameMinute`
 *
 * @param {Date} d1
 * @param {Date} d2
 * @returns {boolean}
 */
function isSameMinute(d1, d2) {
  return startOfMinute(d1).getTime() === startOfMinute(d2).getTime();
}

/**
 * Returns a cloned date with midnight time (00:00:00)
 *
 * @param {Date} date The date for which midnight time is required
 * @param {Date} dateToCompare the date to compare with
 * @returns {Date} A new datetime object representing the input date with midnight time
 */
function getMidnightDate(date) {
  if (!isDate(date)) {
    throw new Error("Invalid date");
  }
  var dateWithoutTime = new Date(date);
  dateWithoutTime.setHours(0, 0, 0, 0);
  return dateWithoutTime;
}

/**
 * Is the first date before the second one?
 *
 * @param {Date} date The date that should be before the other one to return true
 * @param {Date} dateToCompare The date to compare with
 * @returns {boolean} The first date is before the second date
 *
 * Note:
 *  This function considers the mid-night of the given dates for comparison.
 *  It evaluates whether date is before dateToCompare based on their mid-night timestamps.
 */
function isDateBefore(date, dateToCompare) {
  if (!isDate(date) || !isDate(dateToCompare)) {
    throw new Error("Invalid date received");
  }
  var midnightDate = getMidnightDate(date);
  var midnightDateToCompare = getMidnightDate(dateToCompare);
  return isBefore(midnightDate, midnightDateToCompare);
}
function isSpaceKeyDown(event) {
  var SPACE_KEY = " ";
  return event.key === SPACE_KEY;
}

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;
    if (minDate) {
      isInRange = getYear(minDate) <= newYear;
    }
    if (maxDate && isInRange) {
      isInRange = getYear(maxDate) >= newYear;
    }
    if (isInRange) {
      list.push(newYear);
    }
  }
  return list;
}
var YearDropdownOptions = /*#__PURE__*/function (_React$Component) {
  function YearDropdownOptions(props) {
    var _this;
    _classCallCheck(this, YearDropdownOptions);
    _this = _callSuper(this, YearDropdownOptions, [props]);
    _defineProperty$1(_this, "renderOptions", function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
          key: year,
          onClick: _this.onChange.bind(_this, year),
          "aria-selected": selectedYear === year ? "true" : undefined
        }, selectedYear === year ? /*#__PURE__*/React__default.createElement("span", {
          className: "react-datepicker__year-option--selected"
        }, "\u2713") : "", year);
      });
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : null;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : null;
      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift( /*#__PURE__*/React__default.createElement("div", {
          className: "react-datepicker__year-option",
          key: "upcoming",
          onClick: _this.incrementYears
        }, /*#__PURE__*/React__default.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
        })));
      }
      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push( /*#__PURE__*/React__default.createElement("div", {
          className: "react-datepicker__year-option",
          key: "previous",
          onClick: _this.decrementYears
        }, /*#__PURE__*/React__default.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
        })));
      }
      return options;
    });
    _defineProperty$1(_this, "onChange", function (year) {
      _this.props.onChange(year);
    });
    _defineProperty$1(_this, "handleClickOutside", function () {
      _this.props.onCancel();
    });
    _defineProperty$1(_this, "shiftYears", function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });
      _this.setState({
        yearsList: years
      });
    });
    _defineProperty$1(_this, "incrementYears", function () {
      return _this.shiftYears(1);
    });
    _defineProperty$1(_this, "decrementYears", function () {
      return _this.shiftYears(-1);
    });
    var yearDropdownItemNumber = props.yearDropdownItemNumber,
      scrollableYearDropdown = props.scrollableYearDropdown;
    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    _this.dropdownRef = /*#__PURE__*/createRef();
    return _this;
  }
  _inherits(YearDropdownOptions, _React$Component);
  return _createClass(YearDropdownOptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var dropdownCurrent = this.dropdownRef.current;
      if (dropdownCurrent) {
        // Get array from HTMLCollection
        var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
        var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function (childEl) {
          return childEl.ariaSelected;
        }) : null;
        dropdownCurrent.scrollTop = selectedYearOptionEl ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var dropdownClass = clsx$1({
        "react-datepicker__year-dropdown": true,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: dropdownClass,
        ref: this.dropdownRef
      }, this.renderOptions());
    }
  }]);
}(React__default.Component);

var WrappedYearDropdownOptions = onClickOutsideHOC(YearDropdownOptions);
var YearDropdown = /*#__PURE__*/function (_React$Component) {
  function YearDropdown() {
    var _this;
    _classCallCheck(this, YearDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, YearDropdown, [].concat(args));
    _defineProperty$1(_this, "state", {
      dropdownVisible: false
    });
    _defineProperty$1(_this, "renderSelectOptions", function () {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push( /*#__PURE__*/React__default.createElement("option", {
          key: i,
          value: i
        }, i));
      }
      return options;
    });
    _defineProperty$1(_this, "onSelectChange", function (e) {
      _this.onChange(e.target.value);
    });
    _defineProperty$1(_this, "renderSelectMode", function () {
      return /*#__PURE__*/React__default.createElement("select", {
        value: _this.props.year,
        className: "react-datepicker__year-select",
        onChange: _this.onSelectChange
      }, _this.renderSelectOptions());
    });
    _defineProperty$1(_this, "renderReadView", function (visible) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: "read",
        style: {
          visibility: visible ? "visible" : "hidden"
        },
        className: "react-datepicker__year-read-view",
        onClick: function onClick(event) {
          return _this.toggleDropdown(event);
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "react-datepicker__year-read-view--down-arrow"
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "react-datepicker__year-read-view--selected-year"
      }, _this.props.year));
    });
    _defineProperty$1(_this, "renderDropdown", function () {
      return /*#__PURE__*/React__default.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    });
    _defineProperty$1(_this, "renderScrollMode", function () {
      var dropdownVisible = _this.state.dropdownVisible;
      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    });
    _defineProperty$1(_this, "onChange", function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    });
    _defineProperty$1(_this, "toggleDropdown", function (event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function () {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    });
    _defineProperty$1(_this, "handleYearChange", function (date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    });
    _defineProperty$1(_this, "onSelect", function (date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    });
    _defineProperty$1(_this, "setOpen", function () {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    });
    return _this;
  }
  _inherits(YearDropdown, _React$Component);
  return _createClass(YearDropdown, [{
    key: "render",
    value: function render() {
      var renderedDropdown;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode();
          break;
        case "select":
          renderedDropdown = this.renderSelectMode();
          break;
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
      }, renderedDropdown);
    }
  }]);
}(React__default.Component);

var MonthDropdownOptions = /*#__PURE__*/function (_React$Component) {
  function MonthDropdownOptions() {
    var _this;
    _classCallCheck(this, MonthDropdownOptions);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MonthDropdownOptions, [].concat(args));
    _defineProperty$1(_this, "isSelectedMonth", function (i) {
      return _this.props.month === i;
    });
    _defineProperty$1(_this, "renderOptions", function () {
      return _this.props.monthNames.map(function (month, i) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
          key: month,
          onClick: _this.onChange.bind(_this, i),
          "aria-selected": _this.isSelectedMonth(i) ? "true" : undefined
        }, _this.isSelectedMonth(i) ? /*#__PURE__*/React__default.createElement("span", {
          className: "react-datepicker__month-option--selected"
        }, "\u2713") : "", month);
      });
    });
    _defineProperty$1(_this, "onChange", function (month) {
      return _this.props.onChange(month);
    });
    _defineProperty$1(_this, "handleClickOutside", function () {
      return _this.props.onCancel();
    });
    return _this;
  }
  _inherits(MonthDropdownOptions, _React$Component);
  return _createClass(MonthDropdownOptions, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__month-dropdown"
      }, this.renderOptions());
    }
  }]);
}(React__default.Component);

var WrappedMonthDropdownOptions = onClickOutsideHOC(MonthDropdownOptions);
var MonthDropdown = /*#__PURE__*/function (_React$Component) {
  function MonthDropdown() {
    var _this;
    _classCallCheck(this, MonthDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MonthDropdown, [].concat(args));
    _defineProperty$1(_this, "state", {
      dropdownVisible: false
    });
    _defineProperty$1(_this, "renderSelectOptions", function (monthNames) {
      return monthNames.map(function (M, i) {
        return /*#__PURE__*/React__default.createElement("option", {
          key: i,
          value: i
        }, M);
      });
    });
    _defineProperty$1(_this, "renderSelectMode", function (monthNames) {
      return /*#__PURE__*/React__default.createElement("select", {
        value: _this.props.month,
        className: "react-datepicker__month-select",
        onChange: function onChange(e) {
          return _this.onChange(e.target.value);
        }
      }, _this.renderSelectOptions(monthNames));
    });
    _defineProperty$1(_this, "renderReadView", function (visible, monthNames) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: "read",
        style: {
          visibility: visible ? "visible" : "hidden"
        },
        className: "react-datepicker__month-read-view",
        onClick: _this.toggleDropdown
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "react-datepicker__month-read-view--down-arrow"
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "react-datepicker__month-read-view--selected-month"
      }, monthNames[_this.props.month]));
    });
    _defineProperty$1(_this, "renderDropdown", function (monthNames) {
      return /*#__PURE__*/React__default.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    });
    _defineProperty$1(_this, "renderScrollMode", function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;
      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    });
    _defineProperty$1(_this, "onChange", function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    });
    _defineProperty$1(_this, "toggleDropdown", function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    });
    return _this;
  }
  _inherits(MonthDropdown, _React$Component);
  return _createClass(MonthDropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
        return getMonthShortInLocale(M, _this2.props.locale);
      } : function (M) {
        return getMonthInLocale(M, _this2.props.locale);
      });
      var renderedDropdown;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode(monthNames);
          break;
        case "select":
          renderedDropdown = this.renderSelectMode(monthNames);
          break;
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
      }, renderedDropdown);
    }
  }]);
}(React__default.Component);

function generateMonthYears(minDate, maxDate) {
  var list = [];
  var currDate = getStartOfMonth(minDate);
  var lastDate = getStartOfMonth(maxDate);
  while (!isAfter(currDate, lastDate)) {
    list.push(newDate(currDate));
    currDate = addMonths(currDate, 1);
  }
  return list;
}
var MonthYearDropdownOptions = /*#__PURE__*/function (_React$Component) {
  function MonthYearDropdownOptions(props) {
    var _this;
    _classCallCheck(this, MonthYearDropdownOptions);
    _this = _callSuper(this, MonthYearDropdownOptions, [props]);
    _defineProperty$1(_this, "renderOptions", function () {
      return _this.state.monthYearsList.map(function (monthYear) {
        var monthYearPoint = getTime(monthYear);
        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
        return /*#__PURE__*/React__default.createElement("div", {
          className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
          key: monthYearPoint,
          onClick: _this.onChange.bind(_this, monthYearPoint),
          "aria-selected": isSameMonthYear ? "true" : undefined
        }, isSameMonthYear ? /*#__PURE__*/React__default.createElement("span", {
          className: "react-datepicker__month-year-option--selected"
        }, "\u2713") : "", formatDate(monthYear, _this.props.dateFormat, _this.props.locale));
      });
    });
    _defineProperty$1(_this, "onChange", function (monthYear) {
      return _this.props.onChange(monthYear);
    });
    _defineProperty$1(_this, "handleClickOutside", function () {
      _this.props.onCancel();
    });
    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }
  _inherits(MonthYearDropdownOptions, _React$Component);
  return _createClass(MonthYearDropdownOptions, [{
    key: "render",
    value: function render() {
      var dropdownClass = clsx$1({
        "react-datepicker__month-year-dropdown": true,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: dropdownClass
      }, this.renderOptions());
    }
  }]);
}(React__default.Component);

var WrappedMonthYearDropdownOptions = onClickOutsideHOC(MonthYearDropdownOptions);
var MonthYearDropdown = /*#__PURE__*/function (_React$Component) {
  function MonthYearDropdown() {
    var _this;
    _classCallCheck(this, MonthYearDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MonthYearDropdown, [].concat(args));
    _defineProperty$1(_this, "state", {
      dropdownVisible: false
    });
    _defineProperty$1(_this, "renderSelectOptions", function () {
      var currDate = getStartOfMonth(_this.props.minDate);
      var lastDate = getStartOfMonth(_this.props.maxDate);
      var options = [];
      while (!isAfter(currDate, lastDate)) {
        var timePoint = getTime(currDate);
        options.push( /*#__PURE__*/React__default.createElement("option", {
          key: timePoint,
          value: timePoint
        }, formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
        currDate = addMonths(currDate, 1);
      }
      return options;
    });
    _defineProperty$1(_this, "onSelectChange", function (e) {
      _this.onChange(e.target.value);
    });
    _defineProperty$1(_this, "renderSelectMode", function () {
      return /*#__PURE__*/React__default.createElement("select", {
        value: getTime(getStartOfMonth(_this.props.date)),
        className: "react-datepicker__month-year-select",
        onChange: _this.onSelectChange
      }, _this.renderSelectOptions());
    });
    _defineProperty$1(_this, "renderReadView", function (visible) {
      var yearMonth = formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
      return /*#__PURE__*/React__default.createElement("div", {
        key: "read",
        style: {
          visibility: visible ? "visible" : "hidden"
        },
        className: "react-datepicker__month-year-read-view",
        onClick: function onClick(event) {
          return _this.toggleDropdown(event);
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "react-datepicker__month-year-read-view--down-arrow"
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "react-datepicker__month-year-read-view--selected-month-year"
      }, yearMonth));
    });
    _defineProperty$1(_this, "renderDropdown", function () {
      return /*#__PURE__*/React__default.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
        locale: _this.props.locale
      });
    });
    _defineProperty$1(_this, "renderScrollMode", function () {
      var dropdownVisible = _this.state.dropdownVisible;
      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    });
    _defineProperty$1(_this, "onChange", function (monthYearPoint) {
      _this.toggleDropdown();
      var changedDate = newDate(parseInt(monthYearPoint));
      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }
      _this.props.onChange(changedDate);
    });
    _defineProperty$1(_this, "toggleDropdown", function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    });
    return _this;
  }
  _inherits(MonthYearDropdown, _React$Component);
  return _createClass(MonthYearDropdown, [{
    key: "render",
    value: function render() {
      var renderedDropdown;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode();
          break;
        case "select":
          renderedDropdown = this.renderSelectMode();
          break;
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
      }, renderedDropdown);
    }
  }]);
}(React__default.Component);

var Day = /*#__PURE__*/function (_React$Component) {
  function Day() {
    var _this;
    _classCallCheck(this, Day);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Day, [].concat(args));
    _defineProperty$1(_this, "dayEl", /*#__PURE__*/React__default.createRef());
    _defineProperty$1(_this, "handleClick", function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    });
    _defineProperty$1(_this, "handleMouseEnter", function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    });
    _defineProperty$1(_this, "handleOnKeyDown", function (event) {
      var eventKey = event.key;
      if (eventKey === " ") {
        event.preventDefault();
        event.key = "Enter";
      }
      _this.props.handleOnKeyDown(event);
    });
    _defineProperty$1(_this, "isSameDay", function (other) {
      return isSameDay(_this.props.day, other);
    });
    _defineProperty$1(_this, "isKeyboardSelected", function () {
      var _this$props$selectedD;
      if (_this.props.disabledKeyboardNavigation) {
        return false;
      }
      var isSelectedDate = _this.props.selectsMultiple ? (_this$props$selectedD = _this.props.selectedDates) === null || _this$props$selectedD === void 0 ? void 0 : _this$props$selectedD.some(function (date) {
        return _this.isSameDayOrWeek(date);
      }) : _this.isSameDayOrWeek(_this.props.selected);
      return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection);
    });
    _defineProperty$1(_this, "isDisabled", function () {
      return isDayDisabled(_this.props.day, _this.props);
    });
    _defineProperty$1(_this, "isExcluded", function () {
      return isDayExcluded(_this.props.day, _this.props);
    });
    _defineProperty$1(_this, "isStartOfWeek", function () {
      return isSameDay(_this.props.day, getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
    });
    _defineProperty$1(_this, "isSameWeek", function (other) {
      return _this.props.showWeekPicker && isSameDay(other, getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
    });
    _defineProperty$1(_this, "isSameDayOrWeek", function (other) {
      return _this.isSameDay(other) || _this.isSameWeek(other);
    });
    _defineProperty$1(_this, "getHighLightedClass", function () {
      var _this$props = _this.props,
        day = _this$props.day,
        highlightDates = _this$props.highlightDates;
      if (!highlightDates) {
        return false;
      }

      // Looking for className in the Map of {'day string, 'className'}
      var dayStr = formatDate(day, "MM.dd.yyyy");
      return highlightDates.get(dayStr);
    });
    // Function to return the array containing classname associated to the date
    _defineProperty$1(_this, "getHolidaysClass", function () {
      var _this$props2 = _this.props,
        day = _this$props2.day,
        holidays = _this$props2.holidays;
      if (!holidays) {
        return false;
      }
      var dayStr = formatDate(day, "MM.dd.yyyy");
      // Looking for className in the Map of {day string: {className, holidayName}}
      if (holidays.has(dayStr)) {
        return [holidays.get(dayStr).className];
      }
    });
    _defineProperty$1(_this, "isInRange", function () {
      var _this$props3 = _this.props,
        day = _this$props3.day,
        startDate = _this$props3.startDate,
        endDate = _this$props3.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    });
    _defineProperty$1(_this, "isInSelectingRange", function () {
      var _this$props$selecting;
      var _this$props4 = _this.props,
        day = _this$props4.day,
        selectsStart = _this$props4.selectsStart,
        selectsEnd = _this$props4.selectsEnd,
        selectsRange = _this$props4.selectsRange,
        selectsDisabledDaysInRange = _this$props4.selectsDisabledDaysInRange,
        startDate = _this$props4.startDate,
        endDate = _this$props4.endDate;
      var selectingDate = (_this$props$selecting = _this.props.selectingDate) !== null && _this$props$selecting !== void 0 ? _this$props$selecting : _this.props.preSelection;
      if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) {
        return false;
      }
      if (selectsStart && endDate && (isBefore(selectingDate, endDate) || isEqual(selectingDate, endDate))) {
        return isDayInRange(day, selectingDate, endDate);
      }
      if (selectsEnd && startDate && (isAfter(selectingDate, startDate) || isEqual(selectingDate, startDate))) {
        return isDayInRange(day, startDate, selectingDate);
      }
      if (selectsRange && startDate && !endDate && (isAfter(selectingDate, startDate) || isEqual(selectingDate, startDate))) {
        return isDayInRange(day, startDate, selectingDate);
      }
      return false;
    });
    _defineProperty$1(_this, "isSelectingRangeStart", function () {
      var _this$props$selecting2;
      if (!_this.isInSelectingRange()) {
        return false;
      }
      var _this$props5 = _this.props,
        day = _this$props5.day,
        startDate = _this$props5.startDate,
        selectsStart = _this$props5.selectsStart;
      var selectingDate = (_this$props$selecting2 = _this.props.selectingDate) !== null && _this$props$selecting2 !== void 0 ? _this$props$selecting2 : _this.props.preSelection;
      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    });
    _defineProperty$1(_this, "isSelectingRangeEnd", function () {
      var _this$props$selecting3;
      if (!_this.isInSelectingRange()) {
        return false;
      }
      var _this$props6 = _this.props,
        day = _this$props6.day,
        endDate = _this$props6.endDate,
        selectsEnd = _this$props6.selectsEnd,
        selectsRange = _this$props6.selectsRange;
      var selectingDate = (_this$props$selecting3 = _this.props.selectingDate) !== null && _this$props$selecting3 !== void 0 ? _this$props$selecting3 : _this.props.preSelection;
      if (selectsEnd || selectsRange) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    });
    _defineProperty$1(_this, "isRangeStart", function () {
      var _this$props7 = _this.props,
        day = _this$props7.day,
        startDate = _this$props7.startDate,
        endDate = _this$props7.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    });
    _defineProperty$1(_this, "isRangeEnd", function () {
      var _this$props8 = _this.props,
        day = _this$props8.day,
        startDate = _this$props8.startDate,
        endDate = _this$props8.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    });
    _defineProperty$1(_this, "isWeekend", function () {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    });
    _defineProperty$1(_this, "isAfterMonth", function () {
      return _this.props.month !== undefined && (_this.props.month + 1) % 12 === getMonth(_this.props.day);
    });
    _defineProperty$1(_this, "isBeforeMonth", function () {
      return _this.props.month !== undefined && (getMonth(_this.props.day) + 1) % 12 === _this.props.month;
    });
    _defineProperty$1(_this, "isCurrentDay", function () {
      return _this.isSameDay(newDate());
    });
    _defineProperty$1(_this, "isSelected", function () {
      if (_this.props.selectsMultiple) {
        var _this$props$selectedD2;
        return (_this$props$selectedD2 = _this.props.selectedDates) === null || _this$props$selectedD2 === void 0 ? void 0 : _this$props$selectedD2.some(function (date) {
          return _this.isSameDayOrWeek(date);
        });
      }
      return _this.isSameDayOrWeek(_this.props.selected);
    });
    _defineProperty$1(_this, "getClassNames", function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return clsx$1("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--excluded": _this.isExcluded(),
        "react-datepicker__day--selected": _this.isSelected(),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isCurrentDay(),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"), _this.getHolidaysClass());
    });
    _defineProperty$1(_this, "getAriaLabel", function () {
      var _this$props9 = _this.props,
        day = _this$props9.day,
        _this$props9$ariaLabe = _this$props9.ariaLabelPrefixWhenEnabled,
        ariaLabelPrefixWhenEnabled = _this$props9$ariaLabe === void 0 ? "Choose" : _this$props9$ariaLabe,
        _this$props9$ariaLabe2 = _this$props9.ariaLabelPrefixWhenDisabled,
        ariaLabelPrefixWhenDisabled = _this$props9$ariaLabe2 === void 0 ? "Not available" : _this$props9$ariaLabe2;
      var prefix = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
      return "".concat(prefix, " ").concat(formatDate(day, "PPPP", _this.props.locale));
    });
    // A function to return the holiday's name as title's content
    _defineProperty$1(_this, "getTitle", function () {
      var _this$props10 = _this.props,
        day = _this$props10.day,
        _this$props10$holiday = _this$props10.holidays,
        holidays = _this$props10$holiday === void 0 ? new Map() : _this$props10$holiday,
        excludeDates = _this$props10.excludeDates;
      var compareDt = formatDate(day, "MM.dd.yyyy");
      var titles = [];
      if (holidays.has(compareDt)) {
        titles.push.apply(titles, _toConsumableArray(holidays.get(compareDt).holidayNames));
      }
      if (_this.isExcluded()) {
        titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function (excludeDate) {
          return isSameDay(excludeDate.date ? excludeDate.date : excludeDate, day);
        }).map(function (excludeDate) {
          return excludeDate.message;
        }));
      }
      return titles.join(", ");
    });
    _defineProperty$1(_this, "getTabIndex", function (selected, preSelection) {
      var selectedDay = selected || _this.props.selected;
      var preSelectionDay = preSelection || _this.props.preSelection;
      var tabIndex = !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && isSameDay(preSelectionDay, selectedDay)) ? 0 : -1;
      return tabIndex;
    });
    // various cases when we need to apply focus to the preselected day
    // focus the day on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
    // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
    _defineProperty$1(_this, "handleFocusDay", function () {
      var _this$dayEl$current;
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var shouldFocusDay = false;
      // only do this while the input isn't focused
      // otherwise, typing/backspacing the date manually may steal focus away from the input
      if (_this.getTabIndex() === 0 && !prevProps.isInputFocused && _this.isSameDay(_this.props.preSelection)) {
        // there is currently no activeElement and not inline
        if (!document.activeElement || document.activeElement === document.body) {
          shouldFocusDay = true;
        }
        // inline version:
        // do not focus on initial render to prevent autoFocus issue
        // focus after month has changed via keyboard
        if (_this.props.inline && !_this.props.shouldFocusDayInline) {
          shouldFocusDay = false;
        }
        // the activeElement is in the container, and it is another instance of Day
        if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day")) {
          shouldFocusDay = true;
        }
        //day is one of the non rendered duplicate days
        if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) {
          shouldFocusDay = false;
        }
        if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) {
          shouldFocusDay = false;
        }
      }
      shouldFocusDay && ((_this$dayEl$current = _this.dayEl.current) === null || _this$dayEl$current === void 0 ? void 0 : _this$dayEl$current.focus({
        preventScroll: true
      }));
    });
    _defineProperty$1(_this, "renderDayContents", function () {
      if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) return null;
      if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) return null;
      return _this.props.renderDayContents ? _this.props.renderDayContents(getDate(_this.props.day), _this.props.day) : getDate(_this.props.day);
    });
    _defineProperty$1(_this, "render", function () {
      return /*#__PURE__*/React__default.createElement("div", {
        ref: _this.dayEl,
        className: _this.getClassNames(_this.props.day),
        onKeyDown: _this.handleOnKeyDown,
        onClick: _this.handleClick,
        onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
        onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
        tabIndex: _this.getTabIndex(),
        "aria-label": _this.getAriaLabel(),
        role: "option",
        title: _this.getTitle(),
        "aria-disabled": _this.isDisabled(),
        "aria-current": _this.isCurrentDay() ? "date" : undefined,
        "aria-selected": _this.isSelected() || _this.isInRange()
      }, _this.renderDayContents(), _this.getTitle() !== "" && /*#__PURE__*/React__default.createElement("span", {
        className: "overlay"
      }, _this.getTitle()));
    });
    return _this;
  }
  _inherits(Day, _React$Component);
  return _createClass(Day, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFocusDay();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.handleFocusDay(prevProps);
    }
  }]);
}(React__default.Component);

var WeekNumber = /*#__PURE__*/function (_React$Component) {
  function WeekNumber() {
    var _this;
    _classCallCheck(this, WeekNumber);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WeekNumber, [].concat(args));
    _defineProperty$1(_this, "weekNumberEl", /*#__PURE__*/React__default.createRef());
    _defineProperty$1(_this, "handleClick", function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    });
    _defineProperty$1(_this, "handleOnKeyDown", function (event) {
      var eventKey = event.key;
      if (eventKey === " ") {
        event.preventDefault();
        event.key = "Enter";
      }
      _this.props.handleOnKeyDown(event);
    });
    _defineProperty$1(_this, "isKeyboardSelected", function () {
      return !_this.props.disabledKeyboardNavigation && !isSameDay(_this.props.date, _this.props.selected) && isSameDay(_this.props.date, _this.props.preSelection);
    });
    _defineProperty$1(_this, "getTabIndex", function () {
      return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || isSameDay(_this.props.date, _this.props.selected) && isSameDay(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
    });
    // various cases when we need to apply focus to the preselected week-number
    // focus the week-number on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
    // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
    _defineProperty$1(_this, "handleFocusWeekNumber", function () {
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var shouldFocusWeekNumber = false;
      // only do this while the input isn't focused
      // otherwise, typing/backspacing the date manually may steal focus away from the input
      if (_this.getTabIndex() === 0 && !prevProps.isInputFocused && isSameDay(_this.props.date, _this.props.preSelection)) {
        // there is currently no activeElement and not inline
        if (!document.activeElement || document.activeElement === document.body) {
          shouldFocusWeekNumber = true;
        }
        // inline version:
        // do not focus on initial render to prevent autoFocus issue
        // focus after month has changed via keyboard
        if (_this.props.inline && !_this.props.shouldFocusDayInline) {
          shouldFocusWeekNumber = false;
        }
        // the activeElement is in the container, and it is another instance of WeekNumber
        if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) {
          shouldFocusWeekNumber = true;
        }
      }
      shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({
        preventScroll: true
      });
    });
    return _this;
  }
  _inherits(WeekNumber, _React$Component);
  return _createClass(WeekNumber, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFocusWeekNumber();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.handleFocusWeekNumber(prevProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        weekNumber = _this$props.weekNumber,
        _this$props$ariaLabel = _this$props.ariaLabelPrefix,
        ariaLabelPrefix = _this$props$ariaLabel === void 0 ? "week " : _this$props$ariaLabel,
        onClick = _this$props.onClick;
      var weekNumberClasses = {
        "react-datepicker__week-number": true,
        "react-datepicker__week-number--clickable": !!onClick,
        "react-datepicker__week-number--selected": !!onClick && isSameDay(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return /*#__PURE__*/React__default.createElement("div", {
        ref: this.weekNumberEl,
        className: clsx$1(weekNumberClasses),
        "aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber),
        onClick: this.handleClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: this.getTabIndex()
      }, weekNumber);
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        ariaLabelPrefix: "week "
      };
    }
  }]);
}(React__default.Component);

var Week = /*#__PURE__*/function (_React$Component) {
  function Week() {
    var _this;
    _classCallCheck(this, Week);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Week, [].concat(args));
    _defineProperty$1(_this, "handleDayClick", function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    });
    _defineProperty$1(_this, "handleDayMouseEnter", function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    });
    _defineProperty$1(_this, "handleWeekClick", function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
      if (_this.props.showWeekPicker) {
        _this.handleDayClick(day, event);
      }
      if (_this.props.shouldCloseOnSelect) {
        _this.props.setOpen(false);
      }
    });
    _defineProperty$1(_this, "formatWeekNumber", function (date) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(date);
      }
      return getWeek(date);
    });
    _defineProperty$1(_this, "renderDays", function () {
      var startOfWeek = _this.startOfWeek();
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push( /*#__PURE__*/React__default.createElement(WeekNumber, {
          key: "W",
          weekNumber: weekNumber,
          date: startOfWeek,
          onClick: onClickAction,
          selected: _this.props.selected,
          preSelection: _this.props.preSelection,
          ariaLabelPrefix: _this.props.ariaLabelPrefix,
          showWeekPicker: _this.props.showWeekPicker,
          showWeekNumber: _this.props.showWeekNumber,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          handleOnKeyDown: _this.props.handleOnKeyDown,
          isInputFocused: _this.props.isInputFocused,
          containerRef: _this.props.containerRef
        }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(startOfWeek, offset);
        return /*#__PURE__*/React__default.createElement(Day, {
          ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix,
          ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix,
          key: day.valueOf(),
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          usePointerEvent: _this.props.usePointerEvent,
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          calendarStartDay: _this.props.calendarStartDay,
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals,
          includeDates: _this.props.includeDates,
          includeDateIntervals: _this.props.includeDateIntervals,
          highlightDates: _this.props.highlightDates,
          holidays: _this.props.holidays,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          selectsRange: _this.props.selectsRange,
          showWeekPicker: _this.props.showWeekPicker,
          showWeekNumber: _this.props.showWeekNumber,
          selectsDisabledDaysInRange: _this.props.selectsDisabledDaysInRange,
          selectsMultiple: _this.props.selectsMultiple,
          selectedDates: _this.props.selectedDates,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          renderDayContents: _this.props.renderDayContents,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          handleOnKeyDown: _this.props.handleOnKeyDown,
          isInputFocused: _this.props.isInputFocused,
          containerRef: _this.props.containerRef,
          inline: _this.props.inline,
          shouldFocusDayInline: _this.props.shouldFocusDayInline,
          monthShowsDuplicateDaysEnd: _this.props.monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart: _this.props.monthShowsDuplicateDaysStart,
          locale: _this.props.locale
        });
      }));
    });
    _defineProperty$1(_this, "startOfWeek", function () {
      return getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
    });
    _defineProperty$1(_this, "isKeyboardSelected", function () {
      return !_this.props.disabledKeyboardNavigation && !isSameDay(_this.startOfWeek(), _this.props.selected) && isSameDay(_this.startOfWeek(), _this.props.preSelection);
    });
    return _this;
  }
  _inherits(Week, _React$Component);
  return _createClass(Week, [{
    key: "render",
    value: function render() {
      var weekNumberClasses = {
        "react-datepicker__week": true,
        "react-datepicker__week--selected": isSameDay(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return /*#__PURE__*/React__default.createElement("div", {
        className: clsx$1(weekNumberClasses)
      }, this.renderDays());
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        shouldCloseOnSelect: true
      };
    }
  }]);
}(React__default.Component);

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var MONTH_COLUMNS_LAYOUT = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
};
var MONTH_COLUMNS = _defineProperty$1(_defineProperty$1(_defineProperty$1({}, MONTH_COLUMNS_LAYOUT.TWO_COLUMNS, {
  grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]],
  verticalNavigationOffset: 2
}), MONTH_COLUMNS_LAYOUT.THREE_COLUMNS, {
  grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]],
  verticalNavigationOffset: 3
}), MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS, {
  grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]],
  verticalNavigationOffset: 4
});
var MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
  if (showFourColumnMonthYearPicker) return MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
  if (showTwoColumnMonthYearPicker) return MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
  return MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
var Month = /*#__PURE__*/function (_React$Component) {
  function Month() {
    var _this;
    _classCallCheck(this, Month);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Month, [].concat(args));
    _defineProperty$1(_this, "MONTH_REFS", _toConsumableArray(Array(12)).map(function () {
      return /*#__PURE__*/React__default.createRef();
    }));
    _defineProperty$1(_this, "QUARTER_REFS", _toConsumableArray(Array(4)).map(function () {
      return /*#__PURE__*/React__default.createRef();
    }));
    _defineProperty$1(_this, "isDisabled", function (date) {
      return isDayDisabled(date, _this.props);
    });
    _defineProperty$1(_this, "isExcluded", function (date) {
      return isDayExcluded(date, _this.props);
    });
    _defineProperty$1(_this, "handleDayClick", function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event, _this.props.orderInDisplay);
      }
    });
    _defineProperty$1(_this, "handleDayMouseEnter", function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    });
    _defineProperty$1(_this, "handleMouseLeave", function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    });
    _defineProperty$1(_this, "isRangeStartMonth", function (m) {
      var _this$props = _this.props,
        day = _this$props.day,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameMonth(setMonth(day, m), startDate);
    });
    _defineProperty$1(_this, "isRangeStartQuarter", function (q) {
      var _this$props2 = _this.props,
        day = _this$props2.day,
        startDate = _this$props2.startDate,
        endDate = _this$props2.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameQuarter(setQuarter(day, q), startDate);
    });
    _defineProperty$1(_this, "isRangeEndMonth", function (m) {
      var _this$props3 = _this.props,
        day = _this$props3.day,
        startDate = _this$props3.startDate,
        endDate = _this$props3.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameMonth(setMonth(day, m), endDate);
    });
    _defineProperty$1(_this, "isRangeEndQuarter", function (q) {
      var _this$props4 = _this.props,
        day = _this$props4.day,
        startDate = _this$props4.startDate,
        endDate = _this$props4.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameQuarter(setQuarter(day, q), endDate);
    });
    _defineProperty$1(_this, "isInSelectingRangeMonth", function (m) {
      var _this$props$selecting;
      var _this$props5 = _this.props,
        day = _this$props5.day,
        selectsStart = _this$props5.selectsStart,
        selectsEnd = _this$props5.selectsEnd,
        selectsRange = _this$props5.selectsRange,
        startDate = _this$props5.startDate,
        endDate = _this$props5.endDate;
      var selectingDate = (_this$props$selecting = _this.props.selectingDate) !== null && _this$props$selecting !== void 0 ? _this$props$selecting : _this.props.preSelection;
      if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) {
        return false;
      }
      if (selectsStart && endDate) {
        return isMonthInRange(selectingDate, endDate, m, day);
      }
      if (selectsEnd && startDate) {
        return isMonthInRange(startDate, selectingDate, m, day);
      }
      if (selectsRange && startDate && !endDate) {
        return isMonthInRange(startDate, selectingDate, m, day);
      }
      return false;
    });
    _defineProperty$1(_this, "isSelectingMonthRangeStart", function (m) {
      var _this$props$selecting2;
      if (!_this.isInSelectingRangeMonth(m)) {
        return false;
      }
      var _this$props6 = _this.props,
        day = _this$props6.day,
        startDate = _this$props6.startDate,
        selectsStart = _this$props6.selectsStart;
      var _month = setMonth(day, m);
      var selectingDate = (_this$props$selecting2 = _this.props.selectingDate) !== null && _this$props$selecting2 !== void 0 ? _this$props$selecting2 : _this.props.preSelection;
      if (selectsStart) {
        return isSameMonth(_month, selectingDate);
      } else {
        return isSameMonth(_month, startDate);
      }
    });
    _defineProperty$1(_this, "isSelectingMonthRangeEnd", function (m) {
      var _this$props$selecting3;
      if (!_this.isInSelectingRangeMonth(m)) {
        return false;
      }
      var _this$props7 = _this.props,
        day = _this$props7.day,
        endDate = _this$props7.endDate,
        selectsEnd = _this$props7.selectsEnd,
        selectsRange = _this$props7.selectsRange;
      var _month = setMonth(day, m);
      var selectingDate = (_this$props$selecting3 = _this.props.selectingDate) !== null && _this$props$selecting3 !== void 0 ? _this$props$selecting3 : _this.props.preSelection;
      if (selectsEnd || selectsRange) {
        return isSameMonth(_month, selectingDate);
      } else {
        return isSameMonth(_month, endDate);
      }
    });
    _defineProperty$1(_this, "isInSelectingRangeQuarter", function (q) {
      var _this$props$selecting4;
      var _this$props8 = _this.props,
        day = _this$props8.day,
        selectsStart = _this$props8.selectsStart,
        selectsEnd = _this$props8.selectsEnd,
        selectsRange = _this$props8.selectsRange,
        startDate = _this$props8.startDate,
        endDate = _this$props8.endDate;
      var selectingDate = (_this$props$selecting4 = _this.props.selectingDate) !== null && _this$props$selecting4 !== void 0 ? _this$props$selecting4 : _this.props.preSelection;
      if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) {
        return false;
      }
      if (selectsStart && endDate) {
        return isQuarterInRange(selectingDate, endDate, q, day);
      }
      if (selectsEnd && startDate) {
        return isQuarterInRange(startDate, selectingDate, q, day);
      }
      if (selectsRange && startDate && !endDate) {
        return isQuarterInRange(startDate, selectingDate, q, day);
      }
      return false;
    });
    _defineProperty$1(_this, "isWeekInMonth", function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = addDays(startOfWeek, 6);
      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
    });
    _defineProperty$1(_this, "isCurrentMonth", function (day, m) {
      return getYear(day) === getYear(newDate()) && m === getMonth(newDate());
    });
    _defineProperty$1(_this, "isCurrentQuarter", function (day, q) {
      return getYear(day) === getYear(newDate()) && q === getQuarter(newDate());
    });
    _defineProperty$1(_this, "isSelectedMonth", function (day, m, selected) {
      return getMonth(selected) === m && getYear(day) === getYear(selected);
    });
    _defineProperty$1(_this, "isSelectedQuarter", function (day, q, selected) {
      return getQuarter(day) === q && getYear(day) === getYear(selected);
    });
    _defineProperty$1(_this, "renderWeeks", function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var i = 0;
      var breakAfterNextPush = false;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
      var selected = _this.props.showWeekPicker ? getStartOfWeek(_this.props.selected, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
      var preSelection = _this.props.showWeekPicker ? getStartOfWeek(_this.props.preSelection, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
      while (true) {
        weeks.push( /*#__PURE__*/React__default.createElement(Week, {
          ariaLabelPrefix: _this.props.weekAriaLabelPrefix,
          chooseDayAriaLabelPrefix: _this.props.chooseDayAriaLabelPrefix,
          disabledDayAriaLabelPrefix: _this.props.disabledDayAriaLabelPrefix,
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          usePointerEvent: _this.props.usePointerEvent,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          locale: _this.props.locale,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals,
          includeDates: _this.props.includeDates,
          includeDateIntervals: _this.props.includeDateIntervals,
          inline: _this.props.inline,
          shouldFocusDayInline: _this.props.shouldFocusDayInline,
          highlightDates: _this.props.highlightDates,
          holidays: _this.props.holidays,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: preSelection,
          selected: selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          selectsRange: _this.props.selectsRange,
          selectsDisabledDaysInRange: _this.props.selectsDisabledDaysInRange,
          selectsMultiple: _this.props.selectsMultiple,
          selectedDates: _this.props.selectedDates,
          showWeekNumber: _this.props.showWeekNumbers,
          showWeekPicker: _this.props.showWeekPicker,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          setOpen: _this.props.setOpen,
          shouldCloseOnSelect: _this.props.shouldCloseOnSelect,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderDayContents: _this.props.renderDayContents,
          handleOnKeyDown: _this.props.handleOnKeyDown,
          isInputFocused: _this.props.isInputFocused,
          containerRef: _this.props.containerRef,
          calendarStartDay: _this.props.calendarStartDay,
          monthShowsDuplicateDaysEnd: _this.props.monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart: _this.props.monthShowsDuplicateDaysStart
        }));
        if (breakAfterNextPush) break;
        i++;
        currentWeekStart = addWeeks(currentWeekStart, 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }
      return weeks;
    });
    _defineProperty$1(_this, "onMonthClick", function (e, m) {
      var labelDate = setMonth(_this.props.day, m);
      if (isMonthDisabled(labelDate, _this.props)) {
        return;
      }
      _this.handleDayClick(getStartOfMonth(labelDate), e);
    });
    _defineProperty$1(_this, "onMonthMouseEnter", function (m) {
      var labelDate = setMonth(_this.props.day, m);
      if (isMonthDisabled(labelDate, _this.props)) {
        return;
      }
      _this.handleDayMouseEnter(getStartOfMonth(labelDate));
    });
    _defineProperty$1(_this, "handleMonthNavigation", function (newMonth, newDate) {
      if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
      _this.props.setPreSelection(newDate);
      _this.MONTH_REFS[newMonth].current && _this.MONTH_REFS[newMonth].current.focus();
    });
    _defineProperty$1(_this, "onMonthKeyDown", function (event, month) {
      var _this$props9 = _this.props,
        selected = _this$props9.selected,
        preSelection = _this$props9.preSelection,
        disabledKeyboardNavigation = _this$props9.disabledKeyboardNavigation,
        showTwoColumnMonthYearPicker = _this$props9.showTwoColumnMonthYearPicker,
        showFourColumnMonthYearPicker = _this$props9.showFourColumnMonthYearPicker,
        setPreSelection = _this$props9.setPreSelection,
        handleOnMonthKeyDown = _this$props9.handleOnMonthKeyDown;
      var eventKey = event.key;
      if (eventKey !== "Tab") {
        // preventDefault on tab event blocks focus change
        event.preventDefault();
      }
      if (!disabledKeyboardNavigation) {
        var monthColumnsLayout = getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
        var verticalOffset = MONTH_COLUMNS[monthColumnsLayout].verticalNavigationOffset;
        var monthsGrid = MONTH_COLUMNS[monthColumnsLayout].grid;
        switch (eventKey) {
          case "Enter":
            _this.onMonthClick(event, month);
            setPreSelection(selected);
            break;
          case "ArrowRight":
            _this.handleMonthNavigation(month === 11 ? 0 : month + MONTH_NAVIGATION_HORIZONTAL_OFFSET, addMonths(preSelection, MONTH_NAVIGATION_HORIZONTAL_OFFSET));
            break;
          case "ArrowLeft":
            _this.handleMonthNavigation(month === 0 ? 11 : month - MONTH_NAVIGATION_HORIZONTAL_OFFSET, subMonths(preSelection, MONTH_NAVIGATION_HORIZONTAL_OFFSET));
            break;
          case "ArrowUp":
            _this.handleMonthNavigation(
            // Check if month on the first row
            monthsGrid[0].includes(month) ? month + 12 - verticalOffset : month - verticalOffset, subMonths(preSelection, verticalOffset));
            break;
          case "ArrowDown":
            _this.handleMonthNavigation(
            // Check if month on the last row
            monthsGrid[monthsGrid.length - 1].includes(month) ? month - 12 + verticalOffset : month + verticalOffset, addMonths(preSelection, verticalOffset));
            break;
        }
      }
      handleOnMonthKeyDown && handleOnMonthKeyDown(event);
    });
    _defineProperty$1(_this, "onQuarterClick", function (e, q) {
      var labelDate = setQuarter(_this.props.day, q);
      if (isQuarterDisabled(labelDate, _this.props)) {
        return;
      }
      _this.handleDayClick(getStartOfQuarter(labelDate), e);
    });
    _defineProperty$1(_this, "onQuarterMouseEnter", function (q) {
      var labelDate = setQuarter(_this.props.day, q);
      if (isQuarterDisabled(labelDate, _this.props)) {
        return;
      }
      _this.handleDayMouseEnter(getStartOfQuarter(labelDate));
    });
    _defineProperty$1(_this, "handleQuarterNavigation", function (newQuarter, newDate) {
      if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
      _this.props.setPreSelection(newDate);
      _this.QUARTER_REFS[newQuarter - 1].current && _this.QUARTER_REFS[newQuarter - 1].current.focus();
    });
    _defineProperty$1(_this, "onQuarterKeyDown", function (event, quarter) {
      var eventKey = event.key;
      if (!_this.props.disabledKeyboardNavigation) {
        switch (eventKey) {
          case "Enter":
            _this.onQuarterClick(event, quarter);
            _this.props.setPreSelection(_this.props.selected);
            break;
          case "ArrowRight":
            _this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, addQuarters(_this.props.preSelection, 1));
            break;
          case "ArrowLeft":
            _this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, subQuarters(_this.props.preSelection, 1));
            break;
        }
      }
    });
    _defineProperty$1(_this, "isMonthDisabled", function (month) {
      var _this$props10 = _this.props,
        day = _this$props10.day,
        minDate = _this$props10.minDate,
        maxDate = _this$props10.maxDate,
        excludeDates = _this$props10.excludeDates,
        includeDates = _this$props10.includeDates;
      var labelDate = setMonth(day, month);
      return (minDate || maxDate || excludeDates || includeDates) && isMonthDisabled(labelDate, _this.props);
    });
    _defineProperty$1(_this, "getMonthClassNames", function (m) {
      var _this$props11 = _this.props,
        day = _this$props11.day,
        startDate = _this$props11.startDate,
        endDate = _this$props11.endDate,
        selected = _this$props11.selected,
        preSelection = _this$props11.preSelection,
        monthClassName = _this$props11.monthClassName;
      var _monthClassName = monthClassName ? monthClassName(setMonth(day, m)) : undefined;
      return clsx$1("react-datepicker__month-text", "react-datepicker__month-".concat(m), _monthClassName, {
        "react-datepicker__month-text--disabled": _this.isMonthDisabled(m),
        "react-datepicker__month-text--selected": _this.isSelectedMonth(day, m, selected),
        "react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && _this.isSelectedMonth(day, m, preSelection),
        "react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m),
        "react-datepicker__month-text--in-range": isMonthInRange(startDate, endDate, m, day),
        "react-datepicker__month-text--range-start": _this.isRangeStartMonth(m),
        "react-datepicker__month-text--range-end": _this.isRangeEndMonth(m),
        "react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m),
        "react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m),
        "react-datepicker__month-text--today": _this.isCurrentMonth(day, m)
      });
    });
    _defineProperty$1(_this, "getTabIndex", function (m) {
      var preSelectedMonth = getMonth(_this.props.preSelection);
      var tabIndex = !_this.props.disabledKeyboardNavigation && m === preSelectedMonth ? "0" : "-1";
      return tabIndex;
    });
    _defineProperty$1(_this, "getQuarterTabIndex", function (q) {
      var preSelectedQuarter = getQuarter(_this.props.preSelection);
      var tabIndex = !_this.props.disabledKeyboardNavigation && q === preSelectedQuarter ? "0" : "-1";
      return tabIndex;
    });
    _defineProperty$1(_this, "getAriaLabel", function (month) {
      var _this$props12 = _this.props,
        _this$props12$chooseD = _this$props12.chooseDayAriaLabelPrefix,
        chooseDayAriaLabelPrefix = _this$props12$chooseD === void 0 ? "Choose" : _this$props12$chooseD,
        _this$props12$disable = _this$props12.disabledDayAriaLabelPrefix,
        disabledDayAriaLabelPrefix = _this$props12$disable === void 0 ? "Not available" : _this$props12$disable,
        day = _this$props12.day,
        locale = _this$props12.locale;
      var labelDate = setMonth(day, month);
      var prefix = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
      return "".concat(prefix, " ").concat(formatDate(labelDate, "MMMM yyyy", locale));
    });
    _defineProperty$1(_this, "getQuarterClassNames", function (q) {
      var _this$props13 = _this.props,
        day = _this$props13.day,
        startDate = _this$props13.startDate,
        endDate = _this$props13.endDate,
        selected = _this$props13.selected,
        minDate = _this$props13.minDate,
        maxDate = _this$props13.maxDate,
        preSelection = _this$props13.preSelection,
        disabledKeyboardNavigation = _this$props13.disabledKeyboardNavigation;
      return clsx$1("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q), {
        "react-datepicker__quarter-text--disabled": (minDate || maxDate) && isQuarterDisabled(setQuarter(day, q), _this.props),
        "react-datepicker__quarter-text--selected": _this.isSelectedQuarter(day, q, selected),
        "react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && _this.isSelectedQuarter(day, q, preSelection),
        "react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q),
        "react-datepicker__quarter-text--in-range": isQuarterInRange(startDate, endDate, q, day),
        "react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q),
        "react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q)
      });
    });
    _defineProperty$1(_this, "getMonthContent", function (m) {
      var _this$props14 = _this.props,
        showFullMonthYearPicker = _this$props14.showFullMonthYearPicker,
        renderMonthContent = _this$props14.renderMonthContent,
        locale = _this$props14.locale,
        day = _this$props14.day;
      var shortMonthText = getMonthShortInLocale(m, locale);
      var fullMonthText = getMonthInLocale(m, locale);
      if (renderMonthContent) {
        return renderMonthContent(m, shortMonthText, fullMonthText, day);
      }
      return showFullMonthYearPicker ? fullMonthText : shortMonthText;
    });
    _defineProperty$1(_this, "getQuarterContent", function (q) {
      var _this$props15 = _this.props,
        renderQuarterContent = _this$props15.renderQuarterContent,
        locale = _this$props15.locale;
      var shortQuarter = getQuarterShortInLocale(q, locale);
      return renderQuarterContent ? renderQuarterContent(q, shortQuarter) : shortQuarter;
    });
    _defineProperty$1(_this, "renderMonths", function () {
      var _this$props16 = _this.props,
        showTwoColumnMonthYearPicker = _this$props16.showTwoColumnMonthYearPicker,
        showFourColumnMonthYearPicker = _this$props16.showFourColumnMonthYearPicker,
        day = _this$props16.day,
        selected = _this$props16.selected;
      var monthColumns = MONTH_COLUMNS[getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)].grid;
      return monthColumns.map(function (month, i) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "react-datepicker__month-wrapper",
          key: i
        }, month.map(function (m, j) {
          return /*#__PURE__*/React__default.createElement("div", {
            ref: _this.MONTH_REFS[m],
            key: j,
            onClick: function onClick(ev) {
              _this.onMonthClick(ev, m);
            },
            onKeyDown: function onKeyDown(ev) {
              if (isSpaceKeyDown(ev)) {
                ev.preventDefault();
                ev.key = "Enter";
              }
              _this.onMonthKeyDown(ev, m);
            },
            onMouseEnter: !_this.props.usePointerEvent ? function () {
              return _this.onMonthMouseEnter(m);
            } : undefined,
            onPointerEnter: _this.props.usePointerEvent ? function () {
              return _this.onMonthMouseEnter(m);
            } : undefined,
            tabIndex: _this.getTabIndex(m),
            className: _this.getMonthClassNames(m),
            "aria-disabled": _this.isMonthDisabled(m),
            role: "option",
            "aria-label": _this.getAriaLabel(m),
            "aria-current": _this.isCurrentMonth(day, m) ? "date" : undefined,
            "aria-selected": _this.isSelectedMonth(day, m, selected)
          }, _this.getMonthContent(m));
        }));
      });
    });
    _defineProperty$1(_this, "renderQuarters", function () {
      var _this$props17 = _this.props,
        day = _this$props17.day,
        selected = _this$props17.selected;
      var quarters = [1, 2, 3, 4];
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__quarter-wrapper"
      }, quarters.map(function (q, j) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: j,
          ref: _this.QUARTER_REFS[j],
          role: "option",
          onClick: function onClick(ev) {
            _this.onQuarterClick(ev, q);
          },
          onKeyDown: function onKeyDown(ev) {
            _this.onQuarterKeyDown(ev, q);
          },
          onMouseEnter: !_this.props.usePointerEvent ? function () {
            return _this.onQuarterMouseEnter(q);
          } : undefined,
          onPointerEnter: _this.props.usePointerEvent ? function () {
            return _this.onQuarterMouseEnter(q);
          } : undefined,
          className: _this.getQuarterClassNames(q),
          "aria-selected": _this.isSelectedQuarter(day, q, selected),
          tabIndex: _this.getQuarterTabIndex(q),
          "aria-current": _this.isCurrentQuarter(day, q) ? "date" : undefined
        }, _this.getQuarterContent(q));
      }));
    });
    _defineProperty$1(_this, "getClassNames", function () {
      var _this$props18 = _this.props,
        selectingDate = _this$props18.selectingDate,
        selectsStart = _this$props18.selectsStart,
        selectsEnd = _this$props18.selectsEnd,
        showMonthYearPicker = _this$props18.showMonthYearPicker,
        showQuarterYearPicker = _this$props18.showQuarterYearPicker,
        showWeekPicker = _this$props18.showWeekPicker;
      return clsx$1("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      }, {
        "react-datepicker__monthPicker": showMonthYearPicker
      }, {
        "react-datepicker__quarterPicker": showQuarterYearPicker
      }, {
        "react-datepicker__weekPicker": showWeekPicker
      });
    });
    return _this;
  }
  _inherits(Month, _React$Component);
  return _createClass(Month, [{
    key: "render",
    value: function render() {
      var _this$props19 = this.props,
        showMonthYearPicker = _this$props19.showMonthYearPicker,
        showQuarterYearPicker = _this$props19.showQuarterYearPicker,
        day = _this$props19.day,
        _this$props19$ariaLab = _this$props19.ariaLabelPrefix,
        ariaLabelPrefix = _this$props19$ariaLab === void 0 ? "Month " : _this$props19$ariaLab;
      var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
      return /*#__PURE__*/React__default.createElement("div", {
        className: this.getClassNames(),
        onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
        onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
        "aria-label": "".concat(formattedAriaLabelPrefix).concat(formatDate(day, "MMMM, yyyy", this.props.locale)),
        role: "listbox"
      }, showMonthYearPicker ? this.renderMonths() : showQuarterYearPicker ? this.renderQuarters() : this.renderWeeks());
    }
  }]);
}(React__default.Component);

var Time = /*#__PURE__*/function (_React$Component) {
  function Time() {
    var _this;
    _classCallCheck(this, Time);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Time, [].concat(args));
    _defineProperty$1(_this, "state", {
      height: null
    });
    _defineProperty$1(_this, "scrollToTheSelectedTime", function () {
      requestAnimationFrame(function () {
        if (!_this.list) return;
        _this.list.scrollTop = _this.centerLi && Time.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - _this.header.clientHeight : _this.list.clientHeight, _this.centerLi);
      });
    });
    _defineProperty$1(_this, "handleClick", function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && isTimeDisabled(time, _this.props)) {
        return;
      }
      _this.props.onChange(time);
    });
    _defineProperty$1(_this, "isSelectedTime", function (time) {
      return _this.props.selected && isSameMinute(_this.props.selected, time);
    });
    _defineProperty$1(_this, "isDisabledTime", function (time) {
      return (_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && isTimeDisabled(time, _this.props);
    });
    _defineProperty$1(_this, "liClasses", function (time) {
      var classes = ["react-datepicker__time-list-item", _this.props.timeClassName ? _this.props.timeClassName(time) : undefined];
      if (_this.isSelectedTime(time)) {
        classes.push("react-datepicker__time-list-item--selected");
      }
      if (_this.isDisabledTime(time)) {
        classes.push("react-datepicker__time-list-item--disabled");
      }

      //convert this.props.intervals and the relevant time to seconds and check if it it's a clean multiple of the interval
      if (_this.props.injectTimes && (getHours(time) * 3600 + getMinutes(time) * 60 + getSeconds(time)) % (_this.props.intervals * 60) !== 0) {
        classes.push("react-datepicker__time-list-item--injected");
      }
      return classes.join(" ");
    });
    _defineProperty$1(_this, "handleOnKeyDown", function (event, time) {
      if (event.key === " ") {
        event.preventDefault();
        event.key = "Enter";
      }
      if ((event.key === "ArrowUp" || event.key === "ArrowLeft") && event.target.previousSibling) {
        event.preventDefault();
        event.target.previousSibling.focus();
      }
      if ((event.key === "ArrowDown" || event.key === "ArrowRight") && event.target.nextSibling) {
        event.preventDefault();
        event.target.nextSibling.focus();
      }
      if (event.key === "Enter") {
        _this.handleClick(time);
      }
      _this.props.handleOnKeyDown(event);
    });
    _defineProperty$1(_this, "renderTimes", function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : "p";
      var intervals = _this.props.intervals;
      var activeDate = _this.props.selected || _this.props.openToDate || newDate();
      var base = getStartOfDay(activeDate);
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
        return a - b;
      });
      var minutesInDay = 60 * getHoursInDay(activeDate);
      var multiplier = minutesInDay / intervals;
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(base, i * intervals);
        times.push(currentTime);
        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }

      // Determine which time to focus and scroll into view when component mounts
      var timeToFocus = times.reduce(function (prev, time) {
        if (time.getTime() <= activeDate.getTime()) {
          return time;
        }
        return prev;
      }, times[0]);
      return times.map(function (time, i) {
        return /*#__PURE__*/React__default.createElement("li", {
          key: i,
          onClick: _this.handleClick.bind(_this, time),
          className: _this.liClasses(time),
          ref: function ref(li) {
            if (time === timeToFocus) {
              _this.centerLi = li;
            }
          },
          onKeyDown: function onKeyDown(ev) {
            _this.handleOnKeyDown(ev, time);
          },
          tabIndex: time === timeToFocus ? 0 : -1,
          role: "option",
          "aria-selected": _this.isSelectedTime(time) ? "true" : undefined,
          "aria-disabled": _this.isDisabledTime(time) ? "true" : undefined
        }, formatDate(time, format, _this.props.locale));
      });
    });
    return _this;
  }
  _inherits(Time, _React$Component);
  return _createClass(Time, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // code to ensure selected time will always be in focus within time window when it first appears
      this.scrollToTheSelectedTime();
      if (this.props.monthRef && this.header) {
        this.setState({
          height: this.props.monthRef.clientHeight - this.header.clientHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var height = this.state.height;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
        ref: function ref(header) {
          _this2.header = header;
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker-time__header"
      }, this.props.timeCaption)), /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__time"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__time-box"
      }, /*#__PURE__*/React__default.createElement("ul", {
        className: "react-datepicker__time-list",
        ref: function ref(list) {
          _this2.list = list;
        },
        style: height ? {
          height: height
        } : {},
        role: "listbox",
        "aria-label": this.props.timeCaption
      }, this.renderTimes()))));
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
}(React__default.Component);
_defineProperty$1(Time, "calcCenterPosition", function (listHeight, centerLiRef) {
  return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
});

var VERTICAL_NAVIGATION_OFFSET = 3;
var Year = /*#__PURE__*/function (_React$Component) {
  function Year(props) {
    var _this;
    _classCallCheck(this, Year);
    _this = _callSuper(this, Year, [props]);
    _defineProperty$1(_this, "YEAR_REFS", _toConsumableArray(Array(_this.props.yearItemNumber)).map(function () {
      return /*#__PURE__*/React__default.createRef();
    }));
    _defineProperty$1(_this, "isDisabled", function (date) {
      return isDayDisabled(date, _this.props);
    });
    _defineProperty$1(_this, "isExcluded", function (date) {
      return isDayExcluded(date, _this.props);
    });
    _defineProperty$1(_this, "selectingDate", function () {
      var _this$props$selecting;
      return (_this$props$selecting = _this.props.selectingDate) !== null && _this$props$selecting !== void 0 ? _this$props$selecting : _this.props.preSelection;
    });
    _defineProperty$1(_this, "updateFocusOnPaginate", function (refIndex) {
      var waitForReRender = function () {
        this.YEAR_REFS[refIndex].current.focus();
      }.bind(_this);
      window.requestAnimationFrame(waitForReRender);
    });
    _defineProperty$1(_this, "handleYearClick", function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    });
    _defineProperty$1(_this, "handleYearNavigation", function (newYear, newDate) {
      var _this$props = _this.props,
        date = _this$props.date,
        yearItemNumber = _this$props.yearItemNumber;
      var _utils$getYearsPeriod = getYearsPeriod(date, yearItemNumber),
        startPeriod = _utils$getYearsPeriod.startPeriod;
      if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
      _this.props.setPreSelection(newDate);
      if (newYear - startPeriod < 0) {
        _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
      } else if (newYear - startPeriod >= yearItemNumber) {
        _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
      } else _this.YEAR_REFS[newYear - startPeriod].current.focus();
    });
    _defineProperty$1(_this, "isSameDay", function (y, other) {
      return isSameDay(y, other);
    });
    _defineProperty$1(_this, "isCurrentYear", function (y) {
      return y === getYear(newDate());
    });
    _defineProperty$1(_this, "isRangeStart", function (y) {
      return _this.props.startDate && _this.props.endDate && isSameYear(setYear(newDate(), y), _this.props.startDate);
    });
    _defineProperty$1(_this, "isRangeEnd", function (y) {
      return _this.props.startDate && _this.props.endDate && isSameYear(setYear(newDate(), y), _this.props.endDate);
    });
    _defineProperty$1(_this, "isInRange", function (y) {
      return isYearInRange(y, _this.props.startDate, _this.props.endDate);
    });
    _defineProperty$1(_this, "isInSelectingRange", function (y) {
      var _this$props2 = _this.props,
        selectsStart = _this$props2.selectsStart,
        selectsEnd = _this$props2.selectsEnd,
        selectsRange = _this$props2.selectsRange,
        startDate = _this$props2.startDate,
        endDate = _this$props2.endDate;
      if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) {
        return false;
      }
      if (selectsStart && endDate) {
        return isYearInRange(y, _this.selectingDate(), endDate);
      }
      if (selectsEnd && startDate) {
        return isYearInRange(y, startDate, _this.selectingDate());
      }
      if (selectsRange && startDate && !endDate) {
        return isYearInRange(y, startDate, _this.selectingDate());
      }
      return false;
    });
    _defineProperty$1(_this, "isSelectingRangeStart", function (y) {
      if (!_this.isInSelectingRange(y)) {
        return false;
      }
      var _this$props3 = _this.props,
        startDate = _this$props3.startDate,
        selectsStart = _this$props3.selectsStart;
      var _year = setYear(newDate(), y);
      if (selectsStart) {
        return isSameYear(_year, _this.selectingDate());
      }
      return isSameYear(_year, startDate);
    });
    _defineProperty$1(_this, "isSelectingRangeEnd", function (y) {
      if (!_this.isInSelectingRange(y)) {
        return false;
      }
      var _this$props4 = _this.props,
        endDate = _this$props4.endDate,
        selectsEnd = _this$props4.selectsEnd,
        selectsRange = _this$props4.selectsRange;
      var _year = setYear(newDate(), y);
      if (selectsEnd || selectsRange) {
        return isSameYear(_year, _this.selectingDate());
      }
      return isSameYear(_year, endDate);
    });
    _defineProperty$1(_this, "isKeyboardSelected", function (y) {
      var date = getStartOfYear(setYear(_this.props.date, y));
      return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !isSameDay(date, getStartOfYear(_this.props.selected)) && isSameDay(date, getStartOfYear(_this.props.preSelection));
    });
    _defineProperty$1(_this, "onYearClick", function (e, y) {
      var date = _this.props.date;
      _this.handleYearClick(getStartOfYear(setYear(date, y)), e);
    });
    _defineProperty$1(_this, "onYearKeyDown", function (e, y) {
      var key = e.key;
      var _this$props5 = _this.props,
        date = _this$props5.date,
        yearItemNumber = _this$props5.yearItemNumber,
        handleOnKeyDown = _this$props5.handleOnKeyDown;
      if (key !== "Tab") {
        // preventDefault on tab event blocks focus change
        e.preventDefault();
      }
      if (!_this.props.disabledKeyboardNavigation) {
        switch (key) {
          case "Enter":
            _this.onYearClick(e, y);
            _this.props.setPreSelection(_this.props.selected);
            break;
          case "ArrowRight":
            _this.handleYearNavigation(y + 1, addYears(_this.props.preSelection, 1));
            break;
          case "ArrowLeft":
            _this.handleYearNavigation(y - 1, subYears(_this.props.preSelection, 1));
            break;
          case "ArrowUp":
            {
              var _utils$getYearsPeriod2 = getYearsPeriod(date, yearItemNumber),
                startPeriod = _utils$getYearsPeriod2.startPeriod;
              var offset = VERTICAL_NAVIGATION_OFFSET;
              var newYear = y - offset;
              if (newYear < startPeriod) {
                var leftOverOffset = yearItemNumber % offset;
                if (y >= startPeriod && y < startPeriod + leftOverOffset) {
                  offset = leftOverOffset;
                } else {
                  offset += leftOverOffset;
                }
                newYear = y - offset;
              }
              _this.handleYearNavigation(newYear, subYears(_this.props.preSelection, offset));
              break;
            }
          case "ArrowDown":
            {
              var _utils$getYearsPeriod3 = getYearsPeriod(date, yearItemNumber),
                endPeriod = _utils$getYearsPeriod3.endPeriod;
              var _offset = VERTICAL_NAVIGATION_OFFSET;
              var _newYear = y + _offset;
              if (_newYear > endPeriod) {
                var _leftOverOffset = yearItemNumber % _offset;
                if (y <= endPeriod && y > endPeriod - _leftOverOffset) {
                  _offset = _leftOverOffset;
                } else {
                  _offset += _leftOverOffset;
                }
                _newYear = y + _offset;
              }
              _this.handleYearNavigation(_newYear, addYears(_this.props.preSelection, _offset));
              break;
            }
        }
      }
      handleOnKeyDown && handleOnKeyDown(e);
    });
    _defineProperty$1(_this, "getYearClassNames", function (y) {
      var _this$props6 = _this.props,
        date = _this$props6.date,
        minDate = _this$props6.minDate,
        maxDate = _this$props6.maxDate,
        selected = _this$props6.selected,
        excludeDates = _this$props6.excludeDates,
        includeDates = _this$props6.includeDates,
        filterDate = _this$props6.filterDate,
        yearClassName = _this$props6.yearClassName;
      return clsx$1("react-datepicker__year-text", "react-datepicker__year-".concat(y), yearClassName ? yearClassName(setYear(date, y)) : undefined, {
        "react-datepicker__year-text--selected": y === getYear(selected),
        "react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate) && isYearDisabled(y, _this.props),
        "react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y),
        "react-datepicker__year-text--range-start": _this.isRangeStart(y),
        "react-datepicker__year-text--range-end": _this.isRangeEnd(y),
        "react-datepicker__year-text--in-range": _this.isInRange(y),
        "react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y),
        "react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y),
        "react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y),
        "react-datepicker__year-text--today": _this.isCurrentYear(y)
      });
    });
    _defineProperty$1(_this, "getYearTabIndex", function (y) {
      if (_this.props.disabledKeyboardNavigation) return "-1";
      var preSelected = getYear(_this.props.preSelection);
      return y === preSelected ? "0" : "-1";
    });
    _defineProperty$1(_this, "getYearContainerClassNames", function () {
      var _this$props7 = _this.props,
        selectingDate = _this$props7.selectingDate,
        selectsStart = _this$props7.selectsStart,
        selectsEnd = _this$props7.selectsEnd,
        selectsRange = _this$props7.selectsRange;
      return clsx$1("react-datepicker__year", {
        "react-datepicker__year--selecting-range": selectingDate && (selectsStart || selectsEnd || selectsRange)
      });
    });
    _defineProperty$1(_this, "getYearContent", function (y) {
      return _this.props.renderYearContent ? _this.props.renderYearContent(y) : y;
    });
    return _this;
  }
  _inherits(Year, _React$Component);
  return _createClass(Year, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var yearsList = [];
      var _this$props8 = this.props,
        date = _this$props8.date,
        yearItemNumber = _this$props8.yearItemNumber,
        onYearMouseEnter = _this$props8.onYearMouseEnter,
        onYearMouseLeave = _this$props8.onYearMouseLeave;
      var _utils$getYearsPeriod4 = getYearsPeriod(date, yearItemNumber),
        startPeriod = _utils$getYearsPeriod4.startPeriod,
        endPeriod = _utils$getYearsPeriod4.endPeriod;
      var _loop = function _loop(y) {
        yearsList.push( /*#__PURE__*/React__default.createElement("div", {
          ref: _this2.YEAR_REFS[y - startPeriod],
          onClick: function onClick(ev) {
            _this2.onYearClick(ev, y);
          },
          onKeyDown: function onKeyDown(ev) {
            if (isSpaceKeyDown(ev)) {
              ev.preventDefault();
              ev.key = "Enter";
            }
            _this2.onYearKeyDown(ev, y);
          },
          tabIndex: _this2.getYearTabIndex(y),
          className: _this2.getYearClassNames(y),
          onMouseEnter: !_this2.props.usePointerEvent ? function (ev) {
            return onYearMouseEnter(ev, y);
          } : undefined,
          onPointerEnter: _this2.props.usePointerEvent ? function (ev) {
            return onYearMouseEnter(ev, y);
          } : undefined,
          onMouseLeave: !_this2.props.usePointerEvent ? function (ev) {
            return onYearMouseLeave(ev, y);
          } : undefined,
          onPointerLeave: _this2.props.usePointerEvent ? function (ev) {
            return onYearMouseLeave(ev, y);
          } : undefined,
          key: y,
          "aria-current": _this2.isCurrentYear(y) ? "date" : undefined
        }, _this2.getYearContent(y)));
      };
      for (var y = startPeriod; y <= endPeriod; y++) {
        _loop(y);
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: this.getYearContainerClassNames()
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__year-wrapper",
        onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : undefined,
        onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : undefined
      }, yearsList));
    }
  }]);
}(React__default.Component);

var inputTime = /*#__PURE__*/function (_React$Component) {
  function inputTime(props) {
    var _this;
    _classCallCheck(this, inputTime);
    _this = _callSuper(this, inputTime, [props]);
    _defineProperty$1(_this, "onTimeChange", function (time) {
      _this.setState({
        time: time
      });
      var propDate = _this.props.date;
      var isPropDateValid = propDate instanceof Date && !isNaN(propDate);
      var date = isPropDateValid ? propDate : new Date();
      date.setHours(time.split(":")[0]);
      date.setMinutes(time.split(":")[1]);
      _this.props.onChange(date);
    });
    _defineProperty$1(_this, "renderTimeInput", function () {
      var time = _this.state.time;
      var _this$props = _this.props,
        date = _this$props.date,
        timeString = _this$props.timeString,
        customTimeInput = _this$props.customTimeInput;
      if (customTimeInput) {
        return /*#__PURE__*/React__default.cloneElement(customTimeInput, {
          date: date,
          value: time,
          onChange: _this.onTimeChange
        });
      }
      return /*#__PURE__*/React__default.createElement("input", {
        type: "time",
        className: "react-datepicker-time__input",
        placeholder: "Time",
        name: "time-input",
        required: true,
        value: time,
        onChange: function onChange(ev) {
          _this.onTimeChange(ev.target.value || timeString);
        }
      });
    });
    _this.state = {
      time: _this.props.timeString
    };
    return _this;
  }
  _inherits(inputTime, _React$Component);
  return _createClass(inputTime, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__input-time-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker-time__caption"
      }, this.props.timeInputLabel), /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker-time__input-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker-time__input"
      }, this.renderTimeInput())));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.timeString !== state.time) {
        return {
          time: props.timeString
        };
      }

      // Return null to indicate no change to state.
      return null;
    }
  }]);
}(React__default.Component);

function CalendarContainer(_ref) {
  var _ref$showTimeSelectOn = _ref.showTimeSelectOnly,
    showTimeSelectOnly = _ref$showTimeSelectOn === void 0 ? false : _ref$showTimeSelectOn,
    _ref$showTime = _ref.showTime,
    showTime = _ref$showTime === void 0 ? false : _ref$showTime,
    className = _ref.className,
    children = _ref.children;
  var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    role: "dialog",
    "aria-label": ariaLabel,
    "aria-modal": "true"
  }, children);
}

var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];
var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var classNames = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};
var Calendar = /*#__PURE__*/function (_React$Component) {
  function Calendar(props) {
    var _this;
    _classCallCheck(this, Calendar);
    _this = _callSuper(this, Calendar, [props]);
    _defineProperty$1(_this, "handleClickOutside", function (event) {
      _this.props.onClickOutside(event);
    });
    _defineProperty$1(_this, "setClickOutsideRef", function () {
      return _this.containerRef.current;
    });
    _defineProperty$1(_this, "handleDropdownFocus", function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    });
    _defineProperty$1(_this, "getDateInView", function () {
      var _this$props = _this.props,
        preSelection = _this$props.preSelection,
        selected = _this$props.selected,
        openToDate = _this$props.openToDate;
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = newDate();
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    });
    _defineProperty$1(_this, "increaseMonth", function () {
      _this.setState(function (_ref) {
        var date = _ref.date;
        return {
          date: addMonths(date, 1)
        };
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    });
    _defineProperty$1(_this, "decreaseMonth", function () {
      _this.setState(function (_ref2) {
        var date = _ref2.date;
        return {
          date: subMonths(date, 1)
        };
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    });
    _defineProperty$1(_this, "handleDayClick", function (day, event, monthSelectedIn) {
      _this.props.onSelect(day, event, monthSelectedIn);
      _this.props.setPreSelection && _this.props.setPreSelection(day);
    });
    _defineProperty$1(_this, "handleDayMouseEnter", function (day) {
      _this.setState({
        selectingDate: day
      });
      _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
    });
    _defineProperty$1(_this, "handleMonthMouseLeave", function () {
      _this.setState({
        selectingDate: null
      });
      _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
    });
    _defineProperty$1(_this, "handleYearMouseEnter", function (event, year) {
      _this.setState({
        selectingDate: setYear(newDate(), year)
      });
      !!_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
    });
    _defineProperty$1(_this, "handleYearMouseLeave", function (event, year) {
      !!_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
    });
    _defineProperty$1(_this, "handleYearChange", function (date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
        _this.setState({
          isRenderAriaLiveMessage: true
        });
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
      _this.props.setPreSelection && _this.props.setPreSelection(date);
    });
    _defineProperty$1(_this, "handleMonthChange", function (date) {
      _this.handleCustomMonthChange(date);
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
      _this.props.setPreSelection && _this.props.setPreSelection(date);
    });
    _defineProperty$1(_this, "handleCustomMonthChange", function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
        _this.setState({
          isRenderAriaLiveMessage: true
        });
      }
    });
    _defineProperty$1(_this, "handleMonthYearChange", function (date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    });
    _defineProperty$1(_this, "changeYear", function (year) {
      _this.setState(function (_ref3) {
        var date = _ref3.date;
        return {
          date: setYear(date, year)
        };
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    });
    _defineProperty$1(_this, "changeMonth", function (month) {
      _this.setState(function (_ref4) {
        var date = _ref4.date;
        return {
          date: setMonth(date, month)
        };
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    });
    _defineProperty$1(_this, "changeMonthYear", function (monthYear) {
      _this.setState(function (_ref5) {
        var date = _ref5.date;
        return {
          date: setYear(setMonth(date, getMonth(monthYear)), getYear(monthYear))
        };
      }, function () {
        return _this.handleMonthYearChange(_this.state.date);
      });
    });
    _defineProperty$1(_this, "header", function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
      var startOfWeek = getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push( /*#__PURE__*/React__default.createElement("div", {
          key: "W",
          className: "react-datepicker__day-name"
        }, _this.props.weekLabel || "#"));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(startOfWeek, offset);
        var weekDayName = _this.formatWeekday(day, _this.props.locale);
        var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : undefined;
        return /*#__PURE__*/React__default.createElement("div", {
          key: offset,
          "aria-label": formatDate(day, "EEEE", _this.props.locale),
          className: clsx$1("react-datepicker__day-name", weekDayClassName)
        }, weekDayName);
      }));
    });
    _defineProperty$1(_this, "formatWeekday", function (day, locale) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(day, locale) : getWeekdayMinInLocale(day, locale);
    });
    _defineProperty$1(_this, "decreaseYear", function () {
      _this.setState(function (_ref6) {
        var date = _ref6.date;
        return {
          date: subYears(date, _this.props.showYearPicker ? _this.props.yearItemNumber : 1)
        };
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    });
    _defineProperty$1(_this, "clearSelectingDate", function () {
      _this.setState({
        selectingDate: null
      });
    });
    _defineProperty$1(_this, "renderPreviousButton", function () {
      if (_this.props.renderCustomHeader) {
        return;
      }
      var allPrevDaysDisabled;
      switch (true) {
        case _this.props.showMonthYearPicker:
          allPrevDaysDisabled = yearDisabledBefore(_this.state.date, _this.props);
          break;
        case _this.props.showYearPicker:
          allPrevDaysDisabled = yearsDisabledBefore(_this.state.date, _this.props);
          break;
        case _this.props.showQuarterYearPicker:
          allPrevDaysDisabled = quarterDisabledBefore(_this.state.date, _this.props);
          break;
        default:
          allPrevDaysDisabled = monthDisabledBefore(_this.state.date, _this.props);
          break;
      }
      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }
      var iconClasses = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"];
      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
      var clickHandler = _this.decreaseMonth;
      if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) {
        clickHandler = _this.decreaseYear;
      }
      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--previous--disabled");
        clickHandler = null;
      }
      var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
      var _this$props2 = _this.props,
        previousMonthButtonLabel = _this$props2.previousMonthButtonLabel,
        previousYearButtonLabel = _this$props2.previousYearButtonLabel;
      var _this$props3 = _this.props,
        _this$props3$previous = _this$props3.previousMonthAriaLabel,
        previousMonthAriaLabel = _this$props3$previous === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _this$props3$previous,
        _this$props3$previous2 = _this$props3.previousYearAriaLabel,
        previousYearAriaLabel = _this$props3$previous2 === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _this$props3$previous2;
      return /*#__PURE__*/React__default.createElement("button", {
        type: "button",
        className: classes.join(" "),
        onClick: clickHandler,
        onKeyDown: _this.props.handleOnKeyDown,
        "aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel
      }, /*#__PURE__*/React__default.createElement("span", {
        className: iconClasses.join(" ")
      }, isForYear ? _this.props.previousYearButtonLabel : _this.props.previousMonthButtonLabel));
    });
    _defineProperty$1(_this, "increaseYear", function () {
      _this.setState(function (_ref7) {
        var date = _ref7.date;
        return {
          date: addYears(date, _this.props.showYearPicker ? _this.props.yearItemNumber : 1)
        };
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    });
    _defineProperty$1(_this, "renderNextButton", function () {
      if (_this.props.renderCustomHeader) {
        return;
      }
      var allNextDaysDisabled;
      switch (true) {
        case _this.props.showMonthYearPicker:
          allNextDaysDisabled = yearDisabledAfter(_this.state.date, _this.props);
          break;
        case _this.props.showYearPicker:
          allNextDaysDisabled = yearsDisabledAfter(_this.state.date, _this.props);
          break;
        case _this.props.showQuarterYearPicker:
          allNextDaysDisabled = quarterDisabledAfter(_this.state.date, _this.props);
          break;
        default:
          allNextDaysDisabled = monthDisabledAfter(_this.state.date, _this.props);
          break;
      }
      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }
      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      var iconClasses = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"];
      if (_this.props.showTimeSelect) {
        classes.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes.push("react-datepicker__navigation--next--with-today-button");
      }
      var clickHandler = _this.increaseMonth;
      if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) {
        clickHandler = _this.increaseYear;
      }
      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--next--disabled");
        clickHandler = null;
      }
      var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
      var _this$props4 = _this.props,
        nextMonthButtonLabel = _this$props4.nextMonthButtonLabel,
        nextYearButtonLabel = _this$props4.nextYearButtonLabel;
      var _this$props5 = _this.props,
        _this$props5$nextMont = _this$props5.nextMonthAriaLabel,
        nextMonthAriaLabel = _this$props5$nextMont === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _this$props5$nextMont,
        _this$props5$nextYear = _this$props5.nextYearAriaLabel,
        nextYearAriaLabel = _this$props5$nextYear === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _this$props5$nextYear;
      return /*#__PURE__*/React__default.createElement("button", {
        type: "button",
        className: classes.join(" "),
        onClick: clickHandler,
        onKeyDown: _this.props.handleOnKeyDown,
        "aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel
      }, /*#__PURE__*/React__default.createElement("span", {
        className: iconClasses.join(" ")
      }, isForYear ? _this.props.nextYearButtonLabel : _this.props.nextMonthButtonLabel));
    });
    _defineProperty$1(_this, "renderCurrentMonth", function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
      var classes = ["react-datepicker__current-month"];
      if (_this.props.showYearDropdown) {
        classes.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: classes.join(" ")
      }, formatDate(date, _this.props.dateFormat, _this.props.locale));
    });
    _defineProperty$1(_this, "renderYearDropdown", function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return /*#__PURE__*/React__default.createElement(YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    });
    _defineProperty$1(_this, "renderMonthDropdown", function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return /*#__PURE__*/React__default.createElement(MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    });
    _defineProperty$1(_this, "renderMonthYearDropdown", function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return /*#__PURE__*/React__default.createElement(MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    });
    _defineProperty$1(_this, "handleTodayButtonClick", function (e) {
      _this.props.onSelect(getStartOfToday(), e);
      _this.props.setPreSelection && _this.props.setPreSelection(getStartOfToday());
    });
    _defineProperty$1(_this, "renderTodayButton", function () {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__today-button",
        onClick: function onClick(e) {
          return _this.handleTodayButtonClick(e);
        }
      }, _this.props.todayButton);
    });
    _defineProperty$1(_this, "renderDefaultHeader", function (_ref8) {
      var monthDate = _ref8.monthDate,
        i = _ref8.i;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__header ".concat(_this.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
      }, _this.renderCurrentMonth(monthDate), /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode),
        onFocus: _this.handleDropdownFocus
      }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)), /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__day-names"
      }, _this.header(monthDate)));
    });
    _defineProperty$1(_this, "renderCustomHeader", function () {
      var headerArgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var monthDate = headerArgs.monthDate,
        i = headerArgs.i;
      if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) {
        return null;
      }
      var prevMonthButtonDisabled = monthDisabledBefore(_this.state.date, _this.props);
      var nextMonthButtonDisabled = monthDisabledAfter(_this.state.date, _this.props);
      var prevYearButtonDisabled = yearDisabledBefore(_this.state.date, _this.props);
      var nextYearButtonDisabled = yearDisabledAfter(_this.state.date, _this.props);
      var showDayNames = !_this.props.showMonthYearPicker && !_this.props.showQuarterYearPicker && !_this.props.showYearPicker;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__header react-datepicker__header--custom",
        onFocus: _this.props.onDropdownFocus
      }, _this.props.renderCustomHeader(_objectSpread2(_objectSpread2({}, _this.state), {}, {
        customHeaderCount: i,
        monthDate: monthDate,
        changeMonth: _this.changeMonth,
        changeYear: _this.changeYear,
        decreaseMonth: _this.decreaseMonth,
        increaseMonth: _this.increaseMonth,
        decreaseYear: _this.decreaseYear,
        increaseYear: _this.increaseYear,
        prevMonthButtonDisabled: prevMonthButtonDisabled,
        nextMonthButtonDisabled: nextMonthButtonDisabled,
        prevYearButtonDisabled: prevYearButtonDisabled,
        nextYearButtonDisabled: nextYearButtonDisabled
      })), showDayNames && /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__day-names"
      }, _this.header(monthDate)));
    });
    _defineProperty$1(_this, "renderYearHeader", function (_ref9) {
      var monthDate = _ref9.monthDate;
      var _this$props6 = _this.props,
        showYearPicker = _this$props6.showYearPicker,
        yearItemNumber = _this$props6.yearItemNumber;
      var _getYearsPeriod = getYearsPeriod(monthDate, yearItemNumber),
        startPeriod = _getYearsPeriod.startPeriod,
        endPeriod = _getYearsPeriod.endPeriod;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__header react-datepicker-year-header"
      }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : getYear(monthDate));
    });
    _defineProperty$1(_this, "renderHeader", function (headerArgs) {
      switch (true) {
        case _this.props.renderCustomHeader !== undefined:
          return _this.renderCustomHeader(headerArgs);
        case _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker:
          return _this.renderYearHeader(headerArgs);
        default:
          return _this.renderDefaultHeader(headerArgs);
      }
    });
    _defineProperty$1(_this, "renderMonths", function () {
      var _this$props$monthSele;
      if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) {
        return;
      }
      var monthList = [];
      var monthsToSubtract = _this.props.showPreviousMonths ? _this.props.monthsShown - 1 : 0;
      var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? addYears(_this.state.date, monthsToSubtract) : subMonths(_this.state.date, monthsToSubtract);
      var monthSelectedIn = (_this$props$monthSele = _this.props.monthSelectedIn) !== null && _this$props$monthSele !== void 0 ? _this$props$monthSele : monthsToSubtract;
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
        var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? addYears(fromMonthDate, monthsToAdd) : addMonths(fromMonthDate, monthsToAdd);
        var monthKey = "month-".concat(i);
        var monthShowsDuplicateDaysEnd = i < _this.props.monthsShown - 1;
        var monthShowsDuplicateDaysStart = i > 0;
        monthList.push( /*#__PURE__*/React__default.createElement("div", {
          key: monthKey,
          ref: function ref(div) {
            _this.monthContainer = div;
          },
          className: "react-datepicker__month-container"
        }, _this.renderHeader({
          monthDate: monthDate,
          i: i
        }), /*#__PURE__*/React__default.createElement(Month, {
          chooseDayAriaLabelPrefix: _this.props.chooseDayAriaLabelPrefix,
          disabledDayAriaLabelPrefix: _this.props.disabledDayAriaLabelPrefix,
          weekAriaLabelPrefix: _this.props.weekAriaLabelPrefix,
          ariaLabelPrefix: _this.props.monthAriaLabelPrefix,
          onChange: _this.changeMonthYear,
          day: monthDate,
          dayClassName: _this.props.dayClassName,
          calendarStartDay: _this.props.calendarStartDay,
          monthClassName: _this.props.monthClassName,
          onDayClick: _this.handleDayClick,
          handleOnKeyDown: _this.props.handleOnDayKeyDown,
          handleOnMonthKeyDown: _this.props.handleOnKeyDown,
          usePointerEvent: _this.props.usePointerEvent,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onMouseLeave: _this.handleMonthMouseLeave,
          onWeekSelect: _this.props.onWeekSelect,
          orderInDisplay: i,
          formatWeekNumber: _this.props.formatWeekNumber,
          locale: _this.props.locale,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals,
          highlightDates: _this.props.highlightDates,
          holidays: _this.props.holidays,
          selectingDate: _this.state.selectingDate,
          includeDates: _this.props.includeDates,
          includeDateIntervals: _this.props.includeDateIntervals,
          inline: _this.props.inline,
          shouldFocusDayInline: _this.props.shouldFocusDayInline,
          fixedHeight: _this.props.fixedHeight,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          setPreSelection: _this.props.setPreSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          selectsRange: _this.props.selectsRange,
          selectsDisabledDaysInRange: _this.props.selectsDisabledDaysInRange,
          selectsMultiple: _this.props.selectsMultiple,
          selectedDates: _this.props.selectedDates,
          showWeekNumbers: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          peekNextMonth: _this.props.peekNextMonth,
          setOpen: _this.props.setOpen,
          shouldCloseOnSelect: _this.props.shouldCloseOnSelect,
          renderDayContents: _this.props.renderDayContents,
          renderMonthContent: _this.props.renderMonthContent,
          renderQuarterContent: _this.props.renderQuarterContent,
          renderYearContent: _this.props.renderYearContent,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          showMonthYearPicker: _this.props.showMonthYearPicker,
          showFullMonthYearPicker: _this.props.showFullMonthYearPicker,
          showTwoColumnMonthYearPicker: _this.props.showTwoColumnMonthYearPicker,
          showFourColumnMonthYearPicker: _this.props.showFourColumnMonthYearPicker,
          showYearPicker: _this.props.showYearPicker,
          showQuarterYearPicker: _this.props.showQuarterYearPicker,
          showWeekPicker: _this.props.showWeekPicker,
          isInputFocused: _this.props.isInputFocused,
          containerRef: _this.containerRef,
          monthShowsDuplicateDaysEnd: monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart: monthShowsDuplicateDaysStart
        })));
      }
      return monthList;
    });
    _defineProperty$1(_this, "renderYears", function () {
      if (_this.props.showTimeSelectOnly) {
        return;
      }
      if (_this.props.showYearPicker) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "react-datepicker__year--container"
        }, _this.renderHeader({
          monthDate: _this.state.date
        }), /*#__PURE__*/React__default.createElement(Year, _extends({
          onDayClick: _this.handleDayClick,
          selectingDate: _this.state.selectingDate,
          clearSelectingDate: _this.clearSelectingDate,
          date: _this.state.date
        }, _this.props, {
          onYearMouseEnter: _this.handleYearMouseEnter,
          onYearMouseLeave: _this.handleYearMouseLeave
        })));
      }
    });
    _defineProperty$1(_this, "renderTimeSection", function () {
      if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
        return /*#__PURE__*/React__default.createElement(Time, {
          selected: _this.props.selected,
          openToDate: _this.props.openToDate,
          onChange: _this.props.onTimeChange,
          timeClassName: _this.props.timeClassName,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          filterTime: _this.props.filterTime,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes,
          locale: _this.props.locale,
          handleOnKeyDown: _this.props.handleOnKeyDown,
          showTimeSelectOnly: _this.props.showTimeSelectOnly
        });
      }
    });
    _defineProperty$1(_this, "renderInputTimeSection", function () {
      var time = new Date(_this.props.selected);
      var timeValid = isValid(time) && Boolean(_this.props.selected);
      var timeString = timeValid ? "".concat(addZero(time.getHours()), ":").concat(addZero(time.getMinutes())) : "";
      if (_this.props.showTimeInput) {
        return /*#__PURE__*/React__default.createElement(inputTime, {
          date: time,
          timeString: timeString,
          timeInputLabel: _this.props.timeInputLabel,
          onChange: _this.props.onTimeChange,
          customTimeInput: _this.props.customTimeInput
        });
      }
    });
    _defineProperty$1(_this, "renderAriaLiveRegion", function () {
      var _getYearsPeriod2 = getYearsPeriod(_this.state.date, _this.props.yearItemNumber),
        startPeriod = _getYearsPeriod2.startPeriod,
        endPeriod = _getYearsPeriod2.endPeriod;
      var ariaLiveMessage;
      if (_this.props.showYearPicker) {
        ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
      } else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) {
        ariaLiveMessage = getYear(_this.state.date);
      } else {
        ariaLiveMessage = "".concat(getMonthInLocale(getMonth(_this.state.date), _this.props.locale), " ").concat(getYear(_this.state.date));
      }
      return /*#__PURE__*/React__default.createElement("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live"
      }, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
    });
    _defineProperty$1(_this, "renderChildren", function () {
      if (_this.props.children) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "react-datepicker__children-container"
        }, _this.props.children);
      }
    });
    _this.containerRef = /*#__PURE__*/React__default.createRef();
    _this.state = {
      date: _this.getDateInView(),
      selectingDate: null,
      monthContainer: null,
      isRenderAriaLiveMessage: false
    };
    return _this;
  }
  _inherits(Calendar, _React$Component);
  return _createClass(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // monthContainer height is needed in time component
      // to determine the height for the ul in the time component
      // setState here so height is given after final component
      // layout is rendered
      if (this.props.showTimeSelect) {
        this.assignMonthContainer = function () {
          _this2.setState({
            monthContainer: _this2.monthContainer
          });
        }();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      if (this.props.preSelection && (!isSameDay(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
        var hasMonthChanged = !isSameMonth(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function () {
          return hasMonthChanged && _this3.handleCustomMonthChange(_this3.state.date);
        });
      } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
        this.setState({
          date: this.props.openToDate
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Container = this.props.container || CalendarContainer;
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "contents"
        },
        ref: this.containerRef
      }, /*#__PURE__*/React__default.createElement(Container, {
        className: clsx$1("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        }),
        showTime: this.props.showTimeSelect || this.props.showTimeInput,
        showTimeSelectOnly: this.props.showTimeSelectOnly
      }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time",
        previousYearButtonLabel: "Previous Year",
        nextYearButtonLabel: "Next Year",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next Month",
        customTimeInput: null,
        yearItemNumber: DEFAULT_YEAR_ITEM_NUMBER
      };
    }
  }]);
}(React__default.Component);

var CalendarIcon = function CalendarIcon(_ref) {
  var icon = _ref.icon,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _onClick = _ref.onClick;
  var defaultClass = "react-datepicker__calendar-icon";
  if ( /*#__PURE__*/React__default.isValidElement(icon)) {
    return /*#__PURE__*/React__default.cloneElement(icon, {
      className: "".concat(icon.props.className || "", " ").concat(defaultClass, " ").concat(className),
      onClick: function onClick(e) {
        if (typeof icon.props.onClick === "function") {
          icon.props.onClick(e);
        }
        if (typeof _onClick === "function") {
          _onClick(e);
        }
      }
    });
  }
  if (typeof icon === "string") {
    return /*#__PURE__*/React__default.createElement("i", {
      className: "".concat(defaultClass, " ").concat(icon, " ").concat(className),
      "aria-hidden": "true",
      onClick: _onClick
    });
  }

  // Default SVG Icon
  return /*#__PURE__*/React__default.createElement("svg", {
    className: "".concat(defaultClass, " ").concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    onClick: _onClick
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
  }));
};
var CalendarIcon$1 = CalendarIcon;

var Portal = /*#__PURE__*/function (_React$Component) {
  function Portal(props) {
    var _this;
    _classCallCheck(this, Portal);
    _this = _callSuper(this, Portal, [props]);
    _this.el = document.createElement("div");
    return _this;
  }
  _inherits(Portal, _React$Component);
  return _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
      if (!this.portalRoot) {
        this.portalRoot = document.createElement("div");
        this.portalRoot.setAttribute("id", this.props.portalId);
        (this.props.portalHost || document.body).appendChild(this.portalRoot);
      }
      this.portalRoot.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.portalRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/ReactDOM__default.createPortal(this.props.children, this.el);
    }
  }]);
}(React__default.Component);

// TabLoop prevents the user from tabbing outside of the popper
// It creates a tabindex loop so that "Tab" on the last element will focus the first element
// and "Shift Tab" on the first element will focus the last element

var focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var focusableFilter = function focusableFilter(node) {
  return !node.disabled && node.tabIndex !== -1;
};
var TabLoop = /*#__PURE__*/function (_React$Component) {
  function TabLoop(props) {
    var _this;
    _classCallCheck(this, TabLoop);
    _this = _callSuper(this, TabLoop, [props]);
    // query all focusable elements
    // trim first and last because they are the focus guards
    _defineProperty$1(_this, "getTabChildren", function () {
      return Array.prototype.slice.call(_this.tabLoopRef.current.querySelectorAll(focusableElementsSelector), 1, -1).filter(focusableFilter);
    });
    _defineProperty$1(_this, "handleFocusStart", function () {
      var tabChildren = _this.getTabChildren();
      tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
    });
    _defineProperty$1(_this, "handleFocusEnd", function () {
      var tabChildren = _this.getTabChildren();
      tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
    });
    _this.tabLoopRef = /*#__PURE__*/React__default.createRef();
    return _this;
  }
  _inherits(TabLoop, _React$Component);
  return _createClass(TabLoop, [{
    key: "render",
    value: function render() {
      if (!this.props.enableTabLoop) {
        return this.props.children;
      }
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__tab-loop",
        ref: this.tabLoopRef
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__tab-loop__start",
        tabIndex: "0",
        onFocus: this.handleFocusStart
      }), this.props.children, /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__tab-loop__end",
        tabIndex: "0",
        onFocus: this.handleFocusEnd
      }));
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        enableTabLoop: true
      };
    }
  }]);
}(React__default.Component);

function withFloating(Component) {
  var WithFloating = function WithFloating(props) {
    var alt_props = _objectSpread2(_objectSpread2({}, props), {}, {
      popperModifiers: props.popperModifiers || [],
      popperProps: props.popperProps || {},
      hidePopper: typeof props.hidePopper === "boolean" ? props.hidePopper : true
    });
    var arrowRef = React__default.useRef();
    var floatingProps = useFloating(_objectSpread2({
      open: !alt_props.hidePopper,
      whileElementsMounted: autoUpdate,
      placement: alt_props.popperPlacement,
      middleware: [flip({
        padding: 15
      }), offset(10), arrow({
        element: arrowRef
      })].concat(_toConsumableArray(alt_props.popperModifiers))
    }, alt_props.popperProps));
    return /*#__PURE__*/React__default.createElement(Component, _extends({}, alt_props, {
      popperProps: _objectSpread2(_objectSpread2({}, floatingProps), {}, {
        arrowRef: arrowRef
      })
    }));
  };
  return WithFloating;
}

// Exported for testing purposes
var PopperComponent = /*#__PURE__*/function (_React$Component) {
  function PopperComponent() {
    _classCallCheck(this, PopperComponent);
    return _callSuper(this, PopperComponent, arguments);
  }
  _inherits(PopperComponent, _React$Component);
  return _createClass(PopperComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        wrapperClassName = _this$props.wrapperClassName,
        hidePopper = _this$props.hidePopper,
        popperComponent = _this$props.popperComponent,
        targetComponent = _this$props.targetComponent,
        enableTabLoop = _this$props.enableTabLoop,
        popperOnKeyDown = _this$props.popperOnKeyDown,
        portalId = _this$props.portalId,
        portalHost = _this$props.portalHost,
        popperProps = _this$props.popperProps,
        showArrow = _this$props.showArrow;
      var popper;
      if (!hidePopper) {
        var classes = clsx$1("react-datepicker-popper", className);
        popper = /*#__PURE__*/React__default.createElement(TabLoop, {
          enableTabLoop: enableTabLoop
        }, /*#__PURE__*/React__default.createElement("div", {
          ref: popperProps.refs.setFloating,
          style: popperProps.floatingStyles,
          className: classes,
          "data-placement": popperProps.placement,
          onKeyDown: popperOnKeyDown
        }, popperComponent, showArrow && /*#__PURE__*/React__default.createElement(FloatingArrow, {
          ref: popperProps.arrowRef,
          context: popperProps.context,
          fill: "currentColor",
          strokeWidth: 1,
          height: 8,
          width: 16,
          style: {
            transform: "translateY(-1px)"
          },
          className: "react-datepicker__triangle"
        })));
      }
      if (this.props.popperContainer) {
        popper = /*#__PURE__*/React__default.createElement(this.props.popperContainer, {}, popper);
      }
      if (portalId && !hidePopper) {
        popper = /*#__PURE__*/React__default.createElement(Portal, {
          portalId: portalId,
          portalHost: portalHost
        }, popper);
      }
      var wrapperClasses = clsx$1("react-datepicker-wrapper", wrapperClassName);
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        ref: popperProps.refs.setReference,
        className: wrapperClasses
      }, targetComponent), popper);
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        hidePopper: true
      };
    }
  }]);
}(React__default.Component);
var PopperComponent$1 = withFloating(PopperComponent);

var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = onClickOutsideHOC(Calendar);

// Compares dates year+month combinations
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }
  return date1 !== date2;
}

/**
 * General datepicker component.
 */
var INPUT_ERR_1 = "Date input not valid.";
var DatePicker$1 = /*#__PURE__*/function (_React$Component) {
  function DatePicker(props) {
    var _this;
    _classCallCheck(this, DatePicker);
    _this = _callSuper(this, DatePicker, [props]);
    _defineProperty$1(_this, "getPreSelection", function () {
      return _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : newDate();
    });
    // Convert the date from string format to standard Date format
    _defineProperty$1(_this, "modifyHolidays", function () {
      var _this$props$holidays;
      return (_this$props$holidays = _this.props.holidays) === null || _this$props$holidays === void 0 ? void 0 : _this$props$holidays.reduce(function (accumulator, holiday) {
        var date = new Date(holiday.date);
        if (!isValid$1(date)) {
          return accumulator;
        }
        return [].concat(_toConsumableArray(accumulator), [_objectSpread2(_objectSpread2({}, holiday), {}, {
          date: date
        })]);
      }, []);
    });
    _defineProperty$1(_this, "calcInitialState", function () {
      var _ref;
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore(defaultPreSelection, startOfDay(minDate)) ? minDate : maxDate && isAfter(defaultPreSelection, endOfDay(maxDate)) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: (_ref = _this.props.selectsRange ? _this.props.startDate : _this.props.selected) !== null && _ref !== void 0 ? _ref : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false,
        // used to focus day in inline version after month has changed, but not on
        // initial render
        shouldFocusDayInline: false,
        isRenderAriaLiveMessage: false
      };
    });
    _defineProperty$1(_this, "clearPreventFocusTimeout", function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    });
    _defineProperty$1(_this, "setFocus", function () {
      if (_this.input && _this.input.focus) {
        _this.input.focus({
          preventScroll: true
        });
      }
    });
    _defineProperty$1(_this, "setBlur", function () {
      if (_this.input && _this.input.blur) {
        _this.input.blur();
      }
      _this.cancelFocusInput();
    });
    _defineProperty$1(_this, "setOpen", function (open) {
      var skipSetBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
      }, function () {
        if (!open) {
          _this.setState(function (prev) {
            return {
              focused: skipSetBlur ? prev.focused : false
            };
          }, function () {
            !skipSetBlur && _this.setBlur();
            _this.setState({
              inputValue: null
            });
          });
        }
      });
    });
    _defineProperty$1(_this, "inputOk", function () {
      return isDate(_this.state.preSelection);
    });
    _defineProperty$1(_this, "isCalendarOpen", function () {
      return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
    });
    _defineProperty$1(_this, "handleFocus", function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
          _this.setOpen(true);
        }
      }
      _this.setState({
        focused: true
      });
    });
    _defineProperty$1(_this, "sendFocusBackToInput", function () {
      // Clear previous timeout if it exists
      if (_this.preventFocusTimeout) {
        _this.clearPreventFocusTimeout();
      }

      // close the popper and refocus the input
      // stop the input from auto opening onFocus
      // setFocus to the input
      _this.setState({
        preventFocus: true
      }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          _this.setFocus();
          _this.setState({
            preventFocus: false
          });
        });
      });
    });
    _defineProperty$1(_this, "cancelFocusInput", function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    });
    _defineProperty$1(_this, "deferFocusInput", function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    });
    _defineProperty$1(_this, "handleDropdownFocus", function () {
      _this.cancelFocusInput();
    });
    _defineProperty$1(_this, "handleBlur", function (event) {
      if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) {
        _this.props.onBlur(event);
      }
      _this.setState({
        focused: false
      });
    });
    _defineProperty$1(_this, "handleCalendarClickOutside", function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    });
    _defineProperty$1(_this, "handleChange", function () {
      for (var _len = arguments.length, allArgs = new Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }
      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({
        inputValue: event.target.value,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
      });
      var date = parseDate(event.target.value, _this.props.dateFormat, _this.props.locale, _this.props.strictParsing, _this.props.minDate);
      // Use date from `selected` prop when manipulating only time for input value
      if (_this.props.showTimeSelectOnly && _this.props.selected && date && !isSameDay(date, _this.props.selected)) {
        date = set(_this.props.selected, {
          hours: getHours(date),
          minutes: getMinutes(date),
          seconds: getSeconds(date)
        });
      }
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    });
    _defineProperty$1(_this, "handleSelect", function (date, event, monthSelectedIn) {
      if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect) {
        // Preventing onFocus event to fix issue
        // https://github.com/Hacker0x01/react-datepicker/issues/628
        _this.sendFocusBackToInput();
      }
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw(event);
      }
      _this.setSelected(date, event, false, monthSelectedIn);
      if (_this.props.showDateSelect) {
        _this.setState({
          isRenderAriaLiveMessage: true
        });
      }
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        if (!_this.props.selectsRange) {
          _this.setOpen(false);
        }
        var _this$props = _this.props,
          startDate = _this$props.startDate,
          endDate = _this$props.endDate;
        if (startDate && !endDate && (_this.props.swapRange || !isDateBefore(date, startDate))) {
          _this.setOpen(false);
        }
      }
    });
    _defineProperty$1(_this, "setSelected", function (date, event, keepInput, monthSelectedIn) {
      var changedDate = date;
      if (_this.props.showYearPicker) {
        if (changedDate !== null && isYearDisabled(getYear(changedDate), _this.props)) {
          return;
        }
      } else if (_this.props.showMonthYearPicker) {
        if (changedDate !== null && isMonthDisabled(changedDate, _this.props)) {
          return;
        }
      } else {
        if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
          return;
        }
      }
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        selectsRange = _this$props2.selectsRange,
        startDate = _this$props2.startDate,
        endDate = _this$props2.endDate,
        selectsMultiple = _this$props2.selectsMultiple,
        selectedDates = _this$props2.selectedDates,
        minTime = _this$props2.minTime,
        swapRange = _this$props2.swapRange;
      if (!isEqual(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
        if (changedDate !== null) {
          if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) {
            changedDate = setTime(changedDate, {
              hour: getHours(_this.props.selected),
              minute: getMinutes(_this.props.selected),
              second: getSeconds(_this.props.selected)
            });
          }

          // If minTime is present then set the time to minTime
          if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
            if (minTime) {
              changedDate = setTime(changedDate, {
                hour: minTime.getHours(),
                minute: minTime.getMinutes(),
                second: minTime.getSeconds()
              });
            }
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
          if (!_this.props.focusSelectedMonth) {
            _this.setState({
              monthSelectedIn: monthSelectedIn
            });
          }
        }
        if (selectsRange) {
          var noRanges = !startDate && !endDate;
          var hasStartRange = startDate && !endDate;
          var isRangeFilled = startDate && endDate;
          if (noRanges) {
            onChange([changedDate, null], event);
          } else if (hasStartRange) {
            if (changedDate === null) {
              onChange([null, null], event);
            } else if (isDateBefore(changedDate, startDate)) {
              if (swapRange) {
                onChange([changedDate, startDate], event);
              } else {
                onChange([changedDate, null], event);
              }
            } else {
              onChange([startDate, changedDate], event);
            }
          }
          if (isRangeFilled) {
            onChange([changedDate, null], event);
          }
        } else if (selectsMultiple) {
          if (!(selectedDates !== null && selectedDates !== void 0 && selectedDates.length)) {
            onChange([changedDate], event);
          } else {
            var isChangedDateAlreadySelected = selectedDates.some(function (selectedDate) {
              return isSameDay(selectedDate, changedDate);
            });
            if (isChangedDateAlreadySelected) {
              var nextDates = selectedDates.filter(function (selectedDate) {
                return !isSameDay(selectedDate, changedDate);
              });
              onChange(nextDates, event);
            } else {
              onChange([].concat(_toConsumableArray(selectedDates), [changedDate]), event);
            }
          }
        } else {
          onChange(changedDate, event);
        }
      }
      if (!keepInput) {
        _this.props.onSelect(changedDate, event);
        _this.setState({
          inputValue: null
        });
      }
    });
    // When checking preSelection via min/maxDate, times need to be manipulated via startOfDay/endOfDay
    _defineProperty$1(_this, "setPreSelection", function (date) {
      var hasMinDate = typeof _this.props.minDate !== "undefined";
      var hasMaxDate = typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = true;
      if (date) {
        var dateStartOfDay = startOfDay(date);
        if (hasMinDate && hasMaxDate) {
          // isDayInRange uses startOfDay internally, so not necessary to manipulate times here
          isValidDateSelection = isDayInRange(date, _this.props.minDate, _this.props.maxDate);
        } else if (hasMinDate) {
          var minDateStartOfDay = startOfDay(_this.props.minDate);
          isValidDateSelection = isAfter(date, minDateStartOfDay) || isEqual(dateStartOfDay, minDateStartOfDay);
        } else if (hasMaxDate) {
          var maxDateEndOfDay = endOfDay(_this.props.maxDate);
          isValidDateSelection = isBefore(date, maxDateEndOfDay) || isEqual(dateStartOfDay, maxDateEndOfDay);
        }
      }
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    });
    _defineProperty$1(_this, "toggleCalendar", function () {
      _this.setOpen(!_this.state.open);
    });
    _defineProperty$1(_this, "handleTimeChange", function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = _this.props.selected ? time : setTime(selected, {
        hour: getHours(time),
        minute: getMinutes(time)
      });
      _this.setState({
        preSelection: changedDate
      });
      _this.props.onChange(changedDate);
      if (_this.props.shouldCloseOnSelect) {
        _this.sendFocusBackToInput();
        _this.setOpen(false);
      }
      if (_this.props.showTimeInput) {
        _this.setOpen(true);
      }
      if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) {
        _this.setState({
          isRenderAriaLiveMessage: true
        });
      }
      _this.setState({
        inputValue: null
      });
    });
    _defineProperty$1(_this, "onInputClick", function () {
      if (!_this.props.disabled && !_this.props.readOnly) {
        _this.setOpen(true);
      }
      _this.props.onInputClick();
    });
    _defineProperty$1(_this, "onInputKeyDown", function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp" || eventKey === "Enter") {
          _this.onInputClick();
        }
        return;
      }

      // if calendar is open, these keys will focus the selected item
      if (_this.state.open) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          event.preventDefault();
          var selectorString = _this.props.showWeekPicker && _this.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]';
          var selectedItem = _this.calendar.componentNode && _this.calendar.componentNode.querySelector(selectorString);
          selectedItem && selectedItem.focus({
            preventScroll: true
          });
          return;
        }
        var copy = newDate(_this.state.preSelection);
        if (eventKey === "Enter") {
          event.preventDefault();
          if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
            _this.handleSelect(copy, event);
            !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
          } else {
            _this.setOpen(false);
          }
        } else if (eventKey === "Escape") {
          event.preventDefault();
          _this.sendFocusBackToInput();
          _this.setOpen(false);
        } else if (eventKey === "Tab") {
          _this.setOpen(false);
        }
        if (!_this.inputOk()) {
          _this.props.onInputError({
            code: 1,
            msg: INPUT_ERR_1
          });
        }
      }
    });
    _defineProperty$1(_this, "onPortalKeyDown", function (event) {
      var eventKey = event.key;
      if (eventKey === "Escape") {
        event.preventDefault();
        _this.setState({
          preventFocus: true
        }, function () {
          _this.setOpen(false);
          setTimeout(function () {
            _this.setFocus();
            _this.setState({
              preventFocus: false
            });
          });
        });
      }
    });
    // keyDown events passed down to day.jsx
    _defineProperty$1(_this, "onDayKeyDown", function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      var isShiftKeyActive = event.shiftKey;
      var copy = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        _this.handleSelect(copy, event);
        !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
      } else if (eventKey === "Escape") {
        event.preventDefault();
        _this.setOpen(false);
        if (!_this.inputOk()) {
          _this.props.onInputError({
            code: 1,
            msg: INPUT_ERR_1
          });
        }
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection;
        switch (eventKey) {
          case "ArrowLeft":
            if (_this.props.showWeekPicker) {
              newSelection = subWeeks(copy, 1);
            } else {
              newSelection = subDays(copy, 1);
            }
            break;
          case "ArrowRight":
            if (_this.props.showWeekPicker) {
              newSelection = addWeeks(copy, 1);
            } else {
              newSelection = addDays(copy, 1);
            }
            break;
          case "ArrowUp":
            newSelection = subWeeks(copy, 1);
            break;
          case "ArrowDown":
            newSelection = addWeeks(copy, 1);
            break;
          case "PageUp":
            newSelection = isShiftKeyActive ? subYears(copy, 1) : subMonths(copy, 1);
            break;
          case "PageDown":
            newSelection = isShiftKeyActive ? addYears(copy, 1) : addMonths(copy, 1);
            break;
          case "Home":
            newSelection = getStartOfWeek(copy, _this.props.locale, _this.props.calendarStartDay);
            break;
          case "End":
            newSelection = getEndOfWeek(copy);
            break;
          default:
            newSelection = null;
            break;
        }
        if (!newSelection) {
          if (_this.props.onInputError) {
            _this.props.onInputError({
              code: 1,
              msg: INPUT_ERR_1
            });
          }
          return;
        }
        event.preventDefault();
        _this.setState({
          lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
        });
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
        // need to figure out whether month has changed to focus day in inline version
        if (_this.props.inline) {
          var prevMonth = getMonth(copy);
          var newMonth = getMonth(newSelection);
          var prevYear = getYear(copy);
          var newYear = getYear(newSelection);
          if (prevMonth !== newMonth || prevYear !== newYear) {
            // month has changed
            _this.setState({
              shouldFocusDayInline: true
            });
          } else {
            // month hasn't changed
            _this.setState({
              shouldFocusDayInline: false
            });
          }
        }
      }
    });
    // handle generic key down events in the popper that do not adjust or select dates
    // ex: while focusing prev and next month buttons
    _defineProperty$1(_this, "onPopperKeyDown", function (event) {
      var eventKey = event.key;
      if (eventKey === "Escape") {
        event.preventDefault();
        _this.sendFocusBackToInput();
      }
    });
    _defineProperty$1(_this, "onClearClick", function (event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.sendFocusBackToInput();
      if (_this.props.selectsRange) {
        _this.props.onChange([null, null], event);
      } else {
        _this.props.onChange(null, event);
      }
      _this.setState({
        inputValue: null
      });
    });
    _defineProperty$1(_this, "clear", function () {
      _this.onClearClick();
    });
    _defineProperty$1(_this, "onScroll", function (event) {
      if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
        if (event.target === document || event.target === document.documentElement || event.target === document.body) {
          _this.setOpen(false);
        }
      } else if (typeof _this.props.closeOnScroll === "function") {
        if (_this.props.closeOnScroll(event)) {
          _this.setOpen(false);
        }
      }
    });
    _defineProperty$1(_this, "renderCalendar", function () {
      if (!_this.props.inline && !_this.isCalendarOpen()) {
        return null;
      }
      return /*#__PURE__*/React__default.createElement(WrappedCalendar, {
        ref: function ref(elem) {
          _this.calendar = elem;
        },
        locale: _this.props.locale,
        calendarStartDay: _this.props.calendarStartDay,
        chooseDayAriaLabelPrefix: _this.props.chooseDayAriaLabelPrefix,
        disabledDayAriaLabelPrefix: _this.props.disabledDayAriaLabelPrefix,
        weekAriaLabelPrefix: _this.props.weekAriaLabelPrefix,
        monthAriaLabelPrefix: _this.props.monthAriaLabelPrefix,
        adjustDateOnChange: _this.props.adjustDateOnChange,
        setOpen: _this.setOpen,
        shouldCloseOnSelect: _this.props.shouldCloseOnSelect,
        dateFormat: _this.props.dateFormatCalendar,
        useWeekdaysShort: _this.props.useWeekdaysShort,
        formatWeekDay: _this.props.formatWeekDay,
        dropdownMode: _this.props.dropdownMode,
        selected: _this.props.selected,
        preSelection: _this.state.preSelection,
        onSelect: _this.handleSelect,
        onWeekSelect: _this.props.onWeekSelect,
        openToDate: _this.props.openToDate,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        selectsStart: _this.props.selectsStart,
        selectsEnd: _this.props.selectsEnd,
        selectsRange: _this.props.selectsRange,
        selectsMultiple: _this.props.selectsMultiple,
        selectedDates: _this.props.selectedDates,
        startDate: _this.props.startDate,
        endDate: _this.props.endDate,
        excludeDates: _this.props.excludeDates,
        excludeDateIntervals: _this.props.excludeDateIntervals,
        filterDate: _this.props.filterDate,
        onClickOutside: _this.handleCalendarClickOutside,
        formatWeekNumber: _this.props.formatWeekNumber,
        highlightDates: _this.state.highlightDates,
        holidays: getHolidaysMap(_this.modifyHolidays()),
        includeDates: _this.props.includeDates,
        includeDateIntervals: _this.props.includeDateIntervals,
        includeTimes: _this.props.includeTimes,
        injectTimes: _this.props.injectTimes,
        inline: _this.props.inline,
        shouldFocusDayInline: _this.state.shouldFocusDayInline,
        peekNextMonth: _this.props.peekNextMonth,
        showMonthDropdown: _this.props.showMonthDropdown,
        showPreviousMonths: _this.props.showPreviousMonths,
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
        showMonthYearDropdown: _this.props.showMonthYearDropdown,
        showWeekNumbers: _this.props.showWeekNumbers,
        showYearDropdown: _this.props.showYearDropdown,
        withPortal: _this.props.withPortal,
        forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
        showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
        todayButton: _this.props.todayButton,
        weekLabel: _this.props.weekLabel,
        outsideClickIgnoreClass: outsideClickIgnoreClass,
        fixedHeight: _this.props.fixedHeight,
        monthsShown: _this.props.monthsShown,
        monthSelectedIn: _this.state.monthSelectedIn,
        onDropdownFocus: _this.handleDropdownFocus,
        onMonthChange: _this.props.onMonthChange,
        onYearChange: _this.props.onYearChange,
        dayClassName: _this.props.dayClassName,
        weekDayClassName: _this.props.weekDayClassName,
        monthClassName: _this.props.monthClassName,
        timeClassName: _this.props.timeClassName,
        showDateSelect: _this.props.showDateSelect,
        showTimeSelect: _this.props.showTimeSelect,
        showTimeSelectOnly: _this.props.showTimeSelectOnly,
        onTimeChange: _this.handleTimeChange,
        timeFormat: _this.props.timeFormat,
        timeIntervals: _this.props.timeIntervals,
        minTime: _this.props.minTime,
        maxTime: _this.props.maxTime,
        excludeTimes: _this.props.excludeTimes,
        filterTime: _this.props.filterTime,
        timeCaption: _this.props.timeCaption,
        className: _this.props.calendarClassName,
        container: _this.props.calendarContainer,
        yearItemNumber: _this.props.yearItemNumber,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
        previousMonthAriaLabel: _this.props.previousMonthAriaLabel,
        previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
        nextMonthAriaLabel: _this.props.nextMonthAriaLabel,
        nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
        previousYearAriaLabel: _this.props.previousYearAriaLabel,
        previousYearButtonLabel: _this.props.previousYearButtonLabel,
        nextYearAriaLabel: _this.props.nextYearAriaLabel,
        nextYearButtonLabel: _this.props.nextYearButtonLabel,
        timeInputLabel: _this.props.timeInputLabel,
        disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
        renderCustomHeader: _this.props.renderCustomHeader,
        popperProps: _this.props.popperProps,
        renderDayContents: _this.props.renderDayContents,
        renderMonthContent: _this.props.renderMonthContent,
        renderQuarterContent: _this.props.renderQuarterContent,
        renderYearContent: _this.props.renderYearContent,
        onDayMouseEnter: _this.props.onDayMouseEnter,
        onMonthMouseLeave: _this.props.onMonthMouseLeave,
        onYearMouseEnter: _this.props.onYearMouseEnter,
        onYearMouseLeave: _this.props.onYearMouseLeave,
        selectsDisabledDaysInRange: _this.props.selectsDisabledDaysInRange,
        showTimeInput: _this.props.showTimeInput,
        showMonthYearPicker: _this.props.showMonthYearPicker,
        showFullMonthYearPicker: _this.props.showFullMonthYearPicker,
        showTwoColumnMonthYearPicker: _this.props.showTwoColumnMonthYearPicker,
        showFourColumnMonthYearPicker: _this.props.showFourColumnMonthYearPicker,
        showYearPicker: _this.props.showYearPicker,
        showQuarterYearPicker: _this.props.showQuarterYearPicker,
        showWeekPicker: _this.props.showWeekPicker,
        excludeScrollbar: _this.props.excludeScrollbar,
        handleOnKeyDown: _this.props.onKeyDown,
        handleOnDayKeyDown: _this.onDayKeyDown,
        isInputFocused: _this.state.focused,
        customTimeInput: _this.props.customTimeInput,
        setPreSelection: _this.setPreSelection,
        usePointerEvent: _this.props.usePointerEvent,
        yearClassName: _this.props.yearClassName
      }, _this.props.children);
    });
    _defineProperty$1(_this, "renderAriaLiveRegion", function () {
      var _this$props3 = _this.props,
        dateFormat = _this$props3.dateFormat,
        locale = _this$props3.locale;
      var isContainsTime = _this.props.showTimeInput || _this.props.showTimeSelect;
      var longDateFormat = isContainsTime ? "PPPPp" : "PPPP";
      var ariaLiveMessage;
      if (_this.props.selectsRange) {
        ariaLiveMessage = "Selected start date: ".concat(safeDateFormat(_this.props.startDate, {
          dateFormat: longDateFormat,
          locale: locale
        }), ". ").concat(_this.props.endDate ? "End date: " + safeDateFormat(_this.props.endDate, {
          dateFormat: longDateFormat,
          locale: locale
        }) : "");
      } else {
        if (_this.props.showTimeSelectOnly) {
          ariaLiveMessage = "Selected time: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat: dateFormat,
            locale: locale
          }));
        } else if (_this.props.showYearPicker) {
          ariaLiveMessage = "Selected year: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat: "yyyy",
            locale: locale
          }));
        } else if (_this.props.showMonthYearPicker) {
          ariaLiveMessage = "Selected month: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat: "MMMM yyyy",
            locale: locale
          }));
        } else if (_this.props.showQuarterYearPicker) {
          ariaLiveMessage = "Selected quarter: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat: "yyyy, QQQ",
            locale: locale
          }));
        } else {
          ariaLiveMessage = "Selected date: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat: longDateFormat,
            locale: locale
          }));
        }
      }
      return /*#__PURE__*/React__default.createElement("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live"
      }, ariaLiveMessage);
    });
    _defineProperty$1(_this, "renderDateInput", function () {
      var _React$cloneElement;
      var className = clsx$1(_this.props.className, _defineProperty$1({}, outsideClickIgnoreClass, _this.state.open));
      var customInput = _this.props.customInput || /*#__PURE__*/React__default.createElement("input", {
        type: "text"
      });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : _this.props.selectsRange ? safeDateRangeFormat(_this.props.startDate, _this.props.endDate, _this.props) : _this.props.selectsMultiple ? safeMultipleDatesFormat(_this.props.selectedDates, _this.props) : safeDateFormat(_this.props.selected, _this.props);
      return /*#__PURE__*/React__default.cloneElement(customInput, (_React$cloneElement = {}, _defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_React$cloneElement, customInputRef, function (input) {
        _this.input = input;
      }), "value", inputValue), "onBlur", _this.handleBlur), "onChange", _this.handleChange), "onClick", _this.onInputClick), "onFocus", _this.handleFocus), "onKeyDown", _this.onInputKeyDown), "id", _this.props.id), "name", _this.props.name), "form", _this.props.form), _defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_defineProperty$1(_React$cloneElement, "autoFocus", _this.props.autoFocus), "placeholder", _this.props.placeholderText), "disabled", _this.props.disabled), "autoComplete", _this.props.autoComplete), "className", clsx$1(customInput.props.className, className)), "title", _this.props.title), "readOnly", _this.props.readOnly), "required", _this.props.required), "tabIndex", _this.props.tabIndex), "aria-describedby", _this.props.ariaDescribedBy), _defineProperty$1(_defineProperty$1(_defineProperty$1(_React$cloneElement, "aria-invalid", _this.props.ariaInvalid), "aria-labelledby", _this.props.ariaLabelledBy), "aria-required", _this.props.ariaRequired)));
    });
    _defineProperty$1(_this, "renderClearButton", function () {
      var _this$props4 = _this.props,
        isClearable = _this$props4.isClearable,
        disabled = _this$props4.disabled,
        selected = _this$props4.selected,
        startDate = _this$props4.startDate,
        endDate = _this$props4.endDate,
        clearButtonTitle = _this$props4.clearButtonTitle,
        _this$props4$clearBut = _this$props4.clearButtonClassName,
        clearButtonClassName = _this$props4$clearBut === void 0 ? "" : _this$props4$clearBut,
        _this$props4$ariaLabe = _this$props4.ariaLabelClose,
        ariaLabelClose = _this$props4$ariaLabe === void 0 ? "Close" : _this$props4$ariaLabe,
        selectedDates = _this$props4.selectedDates;
      if (isClearable && (selected != null || startDate != null || endDate != null || selectedDates !== null && selectedDates !== void 0 && selectedDates.length)) {
        return /*#__PURE__*/React__default.createElement("button", {
          type: "button",
          className: clsx$1("react-datepicker__close-icon", clearButtonClassName, {
            "react-datepicker__close-icon--disabled": disabled
          }),
          disabled: disabled,
          "aria-label": ariaLabelClose,
          onClick: _this.onClearClick,
          title: clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    });
    _this.state = _this.calcInitialState();
    _this.preventFocusTimeout = null;
    return _this;
  }
  _inherits(DatePicker, _React$Component);
  return _createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
        this.setPreSelection(this.props.selected);
      }
      if (this.state.monthSelectedIn !== undefined && prevProps.monthsShown !== this.props.monthsShown) {
        this.setState({
          monthSelectedIn: 0
        });
      }
      if (prevProps.highlightDates !== this.props.highlightDates) {
        this.setState({
          highlightDates: getHightLightDaysMap(this.props.highlightDates)
        });
      }
      if (!prevState.focused && !isEqual(prevProps.selected, this.props.selected)) {
        this.setState({
          inputValue: null
        });
      }
      if (prevState.open !== this.state.open) {
        if (prevState.open === false && this.state.open === true) {
          this.props.onCalendarOpen();
        }
        if (prevState.open === true && this.state.open === false) {
          this.props.onCalendarClose();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearPreventFocusTimeout();
      window.removeEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "renderInputContainer",
    value: function renderInputContainer() {
      var _this$props5 = this.props,
        showIcon = _this$props5.showIcon,
        icon = _this$props5.icon,
        calendarIconClassname = _this$props5.calendarIconClassname,
        toggleCalendarOnIconClick = _this$props5.toggleCalendarOnIconClick;
      var open = this.state.open;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "")
      }, showIcon && /*#__PURE__*/React__default.createElement(CalendarIcon$1, _extends({
        icon: icon,
        className: "".concat(calendarIconClassname, " ").concat(open && "react-datepicker-ignore-onclickoutside")
      }, toggleCalendarOnIconClick ? {
        onClick: this.toggleCalendar
      } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    }
  }, {
    key: "render",
    value: function render() {
      var calendar = this.renderCalendar();
      if (this.props.inline) return calendar;
      if (this.props.withPortal) {
        var portalContainer = this.state.open ? /*#__PURE__*/React__default.createElement(TabLoop, {
          enableTabLoop: this.props.enableTabLoop
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "react-datepicker__portal",
          tabIndex: -1,
          onKeyDown: this.onPortalKeyDown
        }, calendar)) : null;
        if (this.state.open && this.props.portalId) {
          portalContainer = /*#__PURE__*/React__default.createElement(Portal, {
            portalId: this.props.portalId,
            portalHost: this.props.portalHost
          }, portalContainer);
        }
        return /*#__PURE__*/React__default.createElement("div", null, this.renderInputContainer(), portalContainer);
      }
      return /*#__PURE__*/React__default.createElement(PopperComponent$1, {
        className: this.props.popperClassName,
        wrapperClassName: this.props.wrapperClassName,
        hidePopper: !this.isCalendarOpen(),
        portalId: this.props.portalId,
        portalHost: this.props.portalHost,
        popperModifiers: this.props.popperModifiers,
        targetComponent: this.renderInputContainer(),
        popperContainer: this.props.popperContainer,
        popperComponent: calendar,
        popperPlacement: this.props.popperPlacement,
        popperProps: this.props.popperProps,
        popperOnKeyDown: this.onPopperKeyDown,
        enableTabLoop: this.props.enableTabLoop,
        showArrow: this.props.showPopperArrow
      });
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        allowSameDay: false,
        dateFormat: "MM/dd/yyyy",
        dateFormatCalendar: "LLLL yyyy",
        onChange: function onChange() {},
        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onInputClick: function onInputClick() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside() {},
        onMonthChange: function onMonthChange() {},
        onCalendarOpen: function onCalendarOpen() {},
        onCalendarClose: function onCalendarClose() {},
        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {},
        onInputError: function onInputError() {},
        monthsShown: 1,
        readOnly: false,
        withPortal: false,
        selectsDisabledDaysInRange: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        showTimeInput: false,
        showPreviousMonths: false,
        showMonthYearPicker: false,
        showFullMonthYearPicker: false,
        showTwoColumnMonthYearPicker: false,
        showFourColumnMonthYearPicker: false,
        showYearPicker: false,
        showQuarterYearPicker: false,
        showWeekPicker: false,
        strictParsing: false,
        swapRange: false,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthAriaLabel: "Previous Month",
        previousMonthButtonLabel: "Previous Month",
        nextMonthAriaLabel: "Next Month",
        nextMonthButtonLabel: "Next Month",
        previousYearAriaLabel: "Previous Year",
        previousYearButtonLabel: "Previous Year",
        nextYearAriaLabel: "Next Year",
        nextYearButtonLabel: "Next Year",
        timeInputLabel: "Time",
        enableTabLoop: true,
        yearItemNumber: DEFAULT_YEAR_ITEM_NUMBER,
        focusSelectedMonth: false,
        showPopperArrow: true,
        excludeScrollbar: true,
        customTimeInput: null,
        calendarStartDay: undefined,
        toggleCalendarOnIconClick: false,
        usePointerEvent: false
      };
    }
  }]);
}(React__default.Component);
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";

function declension(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  const rem10 = count % 10;
  const rem100 = count % 100;

  // 1, 21, 31, ...
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));

    // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));

    // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}

function buildLocalizeTokenFn(scheme) {
  return (count, options) => {
    if (options?.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension(scheme.future, count);
        } else {
          return "через " + declension(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension(scheme.past, count);
        } else {
          return declension(scheme.regular, count) + " назад";
        }
      }
    } else {
      return declension(scheme.regular, count);
    }
  };
}

const formatDistanceLocale = {
  lessThanXSeconds: buildLocalizeTokenFn({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд",
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд",
    },
  }),

  xSeconds: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд",
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад",
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд",
    },
  }),

  halfAMinute: (_count, options) => {
    if (options?.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return "через полминуты";
      } else {
        return "полминуты назад";
      }
    }

    return "полминуты";
  },

  lessThanXMinutes: buildLocalizeTokenFn({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут",
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут",
    },
  }),

  xMinutes: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут",
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад",
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут",
    },
  }),

  aboutXHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов",
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов",
    },
  }),

  xHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов",
    },
  }),

  xDays: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней",
    },
  }),

  aboutXWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель",
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель",
    },
  }),

  xWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель",
    },
  }),

  aboutXMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев",
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев",
    },
  }),

  xMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев",
    },
  }),

  aboutXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет",
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет",
    },
  }),

  xYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет",
    },
  }),

  overXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет",
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет",
    },
  }),

  almostXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет",
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет",
    },
  }),
};

const formatDistance = (token, count, options) => {
  return formatDistanceLocale[token](count, options);
};

const dateFormats = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y",
};

const timeFormats = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats = {
  any: "{{date}}, {{time}}",
};

const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "any",
  }),
};

const accusativeWeekdays = [
  "воскресенье",
  "понедельник",
  "вторник",
  "среду",
  "четверг",
  "пятницу",
  "субботу",
];

function lastWeek(day) {
  const weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
      return "'в прошлое " + weekday + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + weekday + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + weekday + " в' p";
  }
}

function thisWeek(day) {
  const weekday = accusativeWeekdays[day];

  if (day === 2 /* Tue */) {
    return "'во " + weekday + " в' p";
  } else {
    return "'в " + weekday + " в' p";
  }
}

function nextWeek(day) {
  const weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
      return "'в следующее " + weekday + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + weekday + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + weekday + " в' p";
  }
}

const formatRelativeLocale = {
  lastWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if (isSameWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return lastWeek(day);
    }
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if (isSameWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return nextWeek(day);
    }
  },
  other: "P",
};

const formatRelative = (token, date, baseDate, options) => {
  const format = formatRelativeLocale[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};

const eraValues = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"],
};

const monthValues = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек.",
  ],

  wide: [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь",
  ],
};

const formattingMonthValues = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек.",
  ],

  wide: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ],
};

const dayValues = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
  ],
};

const dayPeriodValues = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи",
  },
};

const ordinalNumber = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = options?.unit;

  let suffix;
  if (unit === "date") {
    suffix = "-е";
  } else if (unit === "week" || unit === "minute" || unit === "second") {
    suffix = "-я";
  } else {
    suffix = "-й";
  }

  return number + suffix;
};

const localize = {
  ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: "wide",
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "any",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
};

const matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i,
};
const parseEraPatterns = {
  any: [/^д/i, /^н/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i,
};

const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns = {
  narrow: /^[яфмаисонд]/i,
  abbreviated:
    /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i,
};

const parseMonthPatterns = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^я/i,
  ],

  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i,
};

const parseDayPatterns = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i],
};

const matchDayPeriodPatterns = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i,
};

const parseDayPeriodPatterns = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
};

/**
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
const ru = {
  code: "ru",
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
};

const DATE_MASK = [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
const TIME_MASK = [/\d/, /\d/, ':', /\d/, /\d/];
const DATE_TIME_MASK = [
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    '|',
    ' ',
    /\d/,
    /\d/,
    ':',
    /\d/,
    /\d/,
];

var css_248z$l = ".MaskedInput-module_masked__mu4bd {\n  width: 100%;\n  outline: none;\n  background-color: transparent;\n  padding: 0;\n  border: none;\n}";
var s$c = {"masked":"MaskedInput-module_masked__mu4bd"};
styleInject(css_248z$l);

const MaskedInput = forwardRef((props, ref) => {
    const { onClick, placeholder, value, onChange, onKeyDown, disabled, mask = DATE_MASK } = props;
    return (React__default.createElement("div", { ref: ref, onClick: onClick, role: "button", tabIndex: 0, onKeyDown: () => null, className: s$c.masked, "aria-label": "onClick" },
        React__default.createElement(MaskedInputPackage, { mask: mask, type: "text", placeholder: placeholder, value: value, onChange: onChange, onKeyDown: onKeyDown, disabled: disabled })));
});
MaskedInput.displayName = 'MaskedInput';

const MONTHS$1 = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];

var css_248z$k = "@charset \"UTF-8\";\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {\n  border-color: #ccc;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: \"\";\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 6px;\n  width: 9px;\n}\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n}\n\n.react-datepicker {\n  font-family: \"Helvetica Neue\", helvetica, arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n  line-height: initial;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time,\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n  line-height: 0;\n}\n.react-datepicker-popper .react-datepicker__triangle {\n  stroke: #aeaeae;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  fill: #f0f0f0;\n  color: #f0f0f0;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  fill: #fff;\n  color: #fff;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  padding: 8px 0;\n  position: relative;\n}\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n  border-top-left-radius: 0;\n}\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 15px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  align-items: center;\n  background: none;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 2px;\n  padding: 0;\n  border: none;\n  z-index: 1;\n  height: 32px;\n  width: 32px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n.react-datepicker__navigation--previous {\n  left: 2px;\n}\n.react-datepicker__navigation--next {\n  right: 2px;\n}\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 85px;\n}\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n}\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n}\n.react-datepicker__navigation:hover *::before {\n  border-color: #a6a6a6;\n}\n\n.react-datepicker__navigation-icon {\n  position: relative;\n  top: -1px;\n  font-size: 20px;\n  width: 0;\n}\n.react-datepicker__navigation-icon--next {\n  left: -2px;\n}\n.react-datepicker__navigation-icon--next::before {\n  transform: rotate(45deg);\n  left: -7px;\n}\n.react-datepicker__navigation-icon--previous {\n  right: -2px;\n}\n.react-datepicker__navigation-icon--previous::before {\n  transform: rotate(225deg);\n  right: -7px;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__year {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__year-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 180px;\n}\n.react-datepicker__year .react-datepicker__year-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: auto;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {\n  -moz-appearance: textfield;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -87px;\n  top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 85px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + 1.7rem / 2);\n  overflow-y: scroll;\n  padding-right: 0;\n  padding-left: 0;\n  width: 100%;\n  box-sizing: content-box;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:not(.react-datepicker__week-number--selected,\n.react-datepicker__week-number--keyboard-selected):hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n.react-datepicker__week-number--selected {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n.react-datepicker__week-number--selected:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__week-number--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #2a87d0;\n  color: #fff;\n}\n.react-datepicker__week-number--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day-names {\n  white-space: nowrap;\n  margin-bottom: -8px;\n}\n\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n  cursor: pointer;\n}\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n  font-weight: bold;\n}\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover {\n  background-color: #32be3f;\n}\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n  color: magenta;\n}\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n  color: green;\n}\n.react-datepicker__day--holidays,\n.react-datepicker__month-text--holidays,\n.react-datepicker__quarter-text--holidays,\n.react-datepicker__year-text--holidays {\n  position: relative;\n  border-radius: 0.3rem;\n  background-color: #ff6803;\n  color: #fff;\n}\n.react-datepicker__day--holidays .overlay,\n.react-datepicker__month-text--holidays .overlay,\n.react-datepicker__quarter-text--holidays .overlay,\n.react-datepicker__year-text--holidays .overlay {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 4px;\n  border-radius: 4px;\n  white-space: nowrap;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.3s ease-in-out;\n}\n.react-datepicker__day--holidays:hover,\n.react-datepicker__month-text--holidays:hover,\n.react-datepicker__quarter-text--holidays:hover,\n.react-datepicker__year-text--holidays:hover {\n  background-color: #cf5300;\n}\n.react-datepicker__day--holidays:hover .overlay,\n.react-datepicker__month-text--holidays:hover .overlay,\n.react-datepicker__quarter-text--holidays:hover .overlay,\n.react-datepicker__year-text--holidays:hover .overlay {\n  visibility: visible;\n  opacity: 1;\n}\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #bad9f1;\n  color: rgb(0, 0, 0);\n}\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range) {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range), .react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range) {\n  background-color: #f0f0f0;\n  color: #000;\n}\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover {\n  background-color: transparent;\n}\n.react-datepicker__day--disabled .overlay,\n.react-datepicker__month-text--disabled .overlay,\n.react-datepicker__quarter-text--disabled .overlay,\n.react-datepicker__year-text--disabled .overlay {\n  position: absolute;\n  bottom: 70%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 4px;\n  border-radius: 4px;\n  white-space: nowrap;\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s, opacity 0.3s ease-in-out;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n.react-datepicker__input-container .react-datepicker__calendar-icon {\n  position: absolute;\n  padding: 0.5rem;\n  box-sizing: content-box;\n}\n\n.react-datepicker__view-calendar-icon input {\n  padding: 6px 10px 5px 25px;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n  position: relative;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  transform: rotate(135deg);\n  right: -16px;\n  top: 0;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0 6px 0 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: \"×\";\n}\n.react-datepicker__close-icon--disabled {\n  cursor: default;\n}\n.react-datepicker__close-icon--disabled::after {\n  cursor: default;\n  background-color: #ccc;\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__children-container {\n  width: 13.8rem;\n  margin: 0.4rem;\n  padding-right: 0.2rem;\n  padding-left: 0.2rem;\n  height: auto;\n}\n\n.react-datepicker__aria-live {\n  position: absolute;\n  clip-path: circle(0);\n  border: 0;\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  width: 1px;\n  white-space: nowrap;\n}\n\n.react-datepicker__calendar-icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.125em;\n}\n";
styleInject(css_248z$k);

var css_248z$j = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.datepicker {\n  position: relative;\n}\n.datepicker__customHeader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.6rem 1.6rem 2.2rem 1.6rem;\n  border-bottom: 0.1rem solid #eeeeee;\n}\n.datepicker__customHeaderLeft, .datepicker__customHeaderRight {\n  width: 2rem;\n  background: transparent;\n  border: none;\n}\n.datepicker__customHeaderLeft:focus, .datepicker__customHeaderLeft:focus-within, .datepicker__customHeaderLeft:focus-visible, .datepicker__customHeaderRight:focus, .datepicker__customHeaderRight:focus-within, .datepicker__customHeaderRight:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker__customHeaderLeft svg, .datepicker__customHeaderRight svg {\n  display: block;\n  width: 100%;\n}\n.datepicker__customHeaderRight {\n  margin: 0 0 0 1.6rem;\n  cursor: pointer;\n}\n.datepicker__customHeaderLeft {\n  margin: 0 1.6rem 0 0;\n  cursor: pointer;\n}\n.datepicker__customHeaderCenter {\n  display: flex;\n}\n.datepicker__customHeaderMonth, .datepicker__customHeaderYear {\n  width: 11.2rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 400;\n  font-size: 1.6rem;\n  line-height: 2rem;\n  text-align: center;\n  padding: 1.4rem 0;\n  margin: 0 0.8rem;\n  background: #ffffff;\n  border: 0.1rem solid #eeeeee;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n  cursor: pointer;\n}\n.datepicker__customHeaderMonth:focus, .datepicker__customHeaderMonth:focus-within, .datepicker__customHeaderMonth:focus-visible, .datepicker__customHeaderYear:focus, .datepicker__customHeaderYear:focus-within, .datepicker__customHeaderYear:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker .react-datepicker {\n  border: 0.1rem solid #bcd3d4;\n  border-radius: 0.2rem;\n}\n.datepicker .react-datepicker__header {\n  background-color: #ffffff;\n  border: none;\n}\n.datepicker .react-datepicker-popper {\n  z-index: 100;\n}\n.datepicker .react-datepicker__year-wrapper {\n  max-width: 100%;\n  min-width: 36rem;\n  justify-content: flex-start;\n}\n.datepicker .react-datepicker__year {\n  margin: 0 2.4rem 2.4rem 2.4rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  text-align: center;\n}\n.datepicker .react-datepicker__year-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 5.6rem;\n  height: 4.8rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  text-align: center;\n  color: #254e5f;\n}\n.datepicker .react-datepicker__year-text--today {\n  font-weight: 600;\n}\n.datepicker .react-datepicker__year-text--today:focus, .datepicker .react-datepicker__year-text--today:focus-within, .datepicker .react-datepicker__year-text--today:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker .react-datepicker__year-text--selected {\n  color: #ffffff;\n}\n.datepicker .react-datepicker__year-text--keyboard-selected {\n  color: #ffffff;\n}\n.datepicker .react-datepicker__month-wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n.datepicker .react-datepicker__month {\n  margin: 0 1.3rem 2.1rem 1.3rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  text-align: center;\n  color: #254e5f;\n}\n.datepicker .react-datepicker__month-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 11.2rem;\n  height: 4.8rem;\n  text-transform: capitalize;\n}\n.datepicker .react-datepicker__month-text:focus, .datepicker .react-datepicker__month-text:focus-within, .datepicker .react-datepicker__month-text:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker .react-datepicker__month-text--keyboard-selected {\n  color: #ffffff;\n}\n.datepicker .react-datepicker__current-month {\n  display: none;\n}\n.datepicker .react-datepicker__week {\n  display: flex;\n  justify-content: space-between;\n}\n.datepicker .react-datepicker__day {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 4.8rem;\n  height: 4.8rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  text-align: center;\n}\n.datepicker .react-datepicker__day:focus, .datepicker .react-datepicker__day:focus-within, .datepicker .react-datepicker__day:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker .react-datepicker__day-names {\n  display: flex;\n  justify-content: space-between;\n  margin: 1.6rem 1.6rem 0.4rem;\n}\n.datepicker .react-datepicker__day-name {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 4rem;\n  height: 4rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #254e5f;\n  text-transform: uppercase;\n}\n.datepicker .react-datepicker__day--outside-month {\n  background: #f8f8f8;\n  color: #c7c7cc;\n}\n.datepicker .react-datepicker__navigation-icon::before {\n  top: 1.2rem;\n}\n.datepicker .react-datepicker__today-button {\n  margin: 0 2.4rem 2rem auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 9rem;\n  height: 3.2rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #ffffff;\n  border: 0.1rem solid #2c70af;\n  box-shadow: 0 0.2rem 0.4rem rgba(52, 123, 126, 0.15), inset 0 0.1rem 0.2rem rgba(255, 255, 255, 0.4);\n  border-radius: 0.2rem;\n}\n.datepicker .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  border-bottom-color: #bcd3d4;\n}\n.datepicker .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  border-bottom-color: #ffffff;\n}\n\n.datepicker[class~=ofd] .datepicker__customHeaderMonth, .datepicker[class~=ofd] .datepicker__customHeaderYear {\n  color: #4ba1a5;\n}\n.datepicker[class~=ofd] .react-datepicker__day--selected,\n.datepicker[class~=ofd] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=ofd] .react-datepicker__today-button,\n.datepicker[class~=ofd] .react-datepicker__year-text--selected,\n.datepicker[class~=ofd] .react-datepicker__month-text--keyboard-selected {\n  background-color: #4ba1a5;\n}\n.datepicker[class~=ofd] .react-datepicker__day--selected:hover,\n.datepicker[class~=ofd] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=ofd] .react-datepicker__today-button:hover,\n.datepicker[class~=ofd] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=ofd] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #357d81;\n}\n\n.datepicker[class~=td] .datepicker__customHeaderMonth, .datepicker[class~=td] .datepicker__customHeaderYear {\n  color: #ea8242;\n}\n.datepicker[class~=td] .react-datepicker__day--selected,\n.datepicker[class~=td] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=td] .react-datepicker__today-button,\n.datepicker[class~=td] .react-datepicker__year-text--selected,\n.datepicker[class~=td] .react-datepicker__month-text--keyboard-selected {\n  background-color: #ea8242;\n}\n.datepicker[class~=td] .react-datepicker__day--selected:hover,\n.datepicker[class~=td] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=td] .react-datepicker__today-button:hover,\n.datepicker[class~=td] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=td] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #e26212;\n}\n\n.datepicker[class~=gosotchet] .datepicker__customHeaderMonth, .datepicker[class~=gosotchet] .datepicker__customHeaderYear {\n  color: #488bca;\n}\n.datepicker[class~=gosotchet] .react-datepicker__day--selected,\n.datepicker[class~=gosotchet] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=gosotchet] .react-datepicker__today-button,\n.datepicker[class~=gosotchet] .react-datepicker__year-text--selected,\n.datepicker[class~=gosotchet] .react-datepicker__month-text--keyboard-selected {\n  background-color: #488bca;\n}\n.datepicker[class~=gosotchet] .react-datepicker__day--selected:hover,\n.datepicker[class~=gosotchet] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=gosotchet] .react-datepicker__today-button:hover,\n.datepicker[class~=gosotchet] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=gosotchet] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #2c70af;\n}\n\n.datepicker[class~=edo] .datepicker__customHeaderMonth, .datepicker[class~=edo] .datepicker__customHeaderYear,\n.datepicker[class~=epd] .datepicker__customHeaderMonth,\n.datepicker[class~=epd] .datepicker__customHeaderYear {\n  color: #f5a91b;\n}\n.datepicker[class~=edo] .react-datepicker__day--selected,\n.datepicker[class~=edo] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=edo] .react-datepicker__today-button,\n.datepicker[class~=edo] .react-datepicker__year-text--selected,\n.datepicker[class~=edo] .react-datepicker__month-text--keyboard-selected,\n.datepicker[class~=epd] .react-datepicker__day--selected,\n.datepicker[class~=epd] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=epd] .react-datepicker__today-button,\n.datepicker[class~=epd] .react-datepicker__year-text--selected,\n.datepicker[class~=epd] .react-datepicker__month-text--keyboard-selected {\n  background-color: #f5a91b;\n}\n.datepicker[class~=edo] .react-datepicker__day--selected:hover,\n.datepicker[class~=edo] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=edo] .react-datepicker__today-button:hover,\n.datepicker[class~=edo] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=edo] .react-datepicker__month-text--keyboard-selected:hover,\n.datepicker[class~=epd] .react-datepicker__day--selected:hover,\n.datepicker[class~=epd] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=epd] .react-datepicker__today-button:hover,\n.datepicker[class~=epd] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=epd] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #e89700;\n}\n\n.datepicker[class~=arenda] .datepicker__customHeaderMonth, .datepicker[class~=arenda] .datepicker__customHeaderYear {\n  color: #d58576;\n}\n.datepicker[class~=arenda] .react-datepicker__day--selected,\n.datepicker[class~=arenda] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=arenda] .react-datepicker__today-button,\n.datepicker[class~=arenda] .react-datepicker__year-text--selected,\n.datepicker[class~=arenda] .react-datepicker__month-text--keyboard-selected {\n  background-color: #d58576;\n}\n.datepicker[class~=arenda] .react-datepicker__day--selected:hover,\n.datepicker[class~=arenda] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=arenda] .react-datepicker__today-button:hover,\n.datepicker[class~=arenda] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=arenda] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #ce5a46;\n}\n\n.datepicker[class~=marking] .datepicker__customHeaderMonth, .datepicker[class~=marking] .datepicker__customHeaderYear {\n  color: #4bb9ba;\n}\n.datepicker[class~=marking] .react-datepicker__day--selected,\n.datepicker[class~=marking] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=marking] .react-datepicker__today-button,\n.datepicker[class~=marking] .react-datepicker__year-text--selected,\n.datepicker[class~=marking] .react-datepicker__month-text--keyboard-selected {\n  background-color: #4bb9ba;\n}\n.datepicker[class~=marking] .react-datepicker__day--selected:hover,\n.datepicker[class~=marking] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=marking] .react-datepicker__today-button:hover,\n.datepicker[class~=marking] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=marking] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #339799;\n}\n\n.datepicker[class~=check-index] .datepicker__customHeaderMonth, .datepicker[class~=check-index] .datepicker__customHeaderYear {\n  color: #5bc0de;\n}\n.datepicker[class~=check-index] .react-datepicker__day--selected,\n.datepicker[class~=check-index] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=check-index] .react-datepicker__today-button,\n.datepicker[class~=check-index] .react-datepicker__year-text--selected,\n.datepicker[class~=check-index] .react-datepicker__month-text--keyboard-selected {\n  background-color: #5bc0de;\n}\n.datepicker[class~=check-index] .react-datepicker__day--selected:hover,\n.datepicker[class~=check-index] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=check-index] .react-datepicker__today-button:hover,\n.datepicker[class~=check-index] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=check-index] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #23a5cd;\n}\n\n.datepicker[class~=big-data] .datepicker__customHeaderMonth, .datepicker[class~=big-data] .datepicker__customHeaderYear {\n  color: #5ab8c5;\n}\n.datepicker[class~=big-data] .react-datepicker__day--selected,\n.datepicker[class~=big-data] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=big-data] .react-datepicker__today-button,\n.datepicker[class~=big-data] .react-datepicker__year-text--selected,\n.datepicker[class~=big-data] .react-datepicker__month-text--keyboard-selected {\n  background-color: #5ab8c5;\n}\n.datepicker[class~=big-data] .react-datepicker__day--selected:hover,\n.datepicker[class~=big-data] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=big-data] .react-datepicker__today-button:hover,\n.datepicker[class~=big-data] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=big-data] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #36a1b0;\n}\n\n.datepicker[class~=mchd] .datepicker__customHeaderMonth, .datepicker[class~=mchd] .datepicker__customHeaderYear {\n  color: #626ab7;\n}\n.datepicker[class~=mchd] .react-datepicker__day--selected,\n.datepicker[class~=mchd] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=mchd] .react-datepicker__today-button,\n.datepicker[class~=mchd] .react-datepicker__year-text--selected,\n.datepicker[class~=mchd] .react-datepicker__month-text--keyboard-selected {\n  background-color: #626ab7;\n}\n.datepicker[class~=mchd] .react-datepicker__day--selected:hover,\n.datepicker[class~=mchd] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=mchd] .react-datepicker__today-button:hover,\n.datepicker[class~=mchd] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=mchd] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #434ca3;\n}\n\n.datepicker[class~=elk] .datepicker__customHeaderMonth, .datepicker[class~=elk] .datepicker__customHeaderYear {\n  color: #577590;\n}\n.datepicker[class~=elk] .react-datepicker__day--selected,\n.datepicker[class~=elk] .react-datepicker__day--keyboard-selected,\n.datepicker[class~=elk] .react-datepicker__today-button,\n.datepicker[class~=elk] .react-datepicker__year-text--selected,\n.datepicker[class~=elk] .react-datepicker__month-text--keyboard-selected {\n  background-color: #577590;\n}\n.datepicker[class~=elk] .react-datepicker__day--selected:hover,\n.datepicker[class~=elk] .react-datepicker__day--keyboard-selected:hover,\n.datepicker[class~=elk] .react-datepicker__today-button:hover,\n.datepicker[class~=elk] .react-datepicker__year-text--selected:hover,\n.datepicker[class~=elk] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #344b60;\n}\n\n@media (max-width: 1500px) {\n  .datepicker__customHeader {\n    padding: 1.4rem 1.4rem 2rem 1.4rem;\n  }\n  .datepicker__customHeaderMonth, .datepicker__customHeaderYear {\n    width: 8rem;\n    font-size: 1.4rem;\n    line-height: 1;\n    padding: 1rem 0;\n    margin: 0 0.8rem;\n  }\n  .datepicker .react-datepicker__day {\n    width: 3.5rem;\n    height: 2.5rem;\n    font-size: 1.3rem;\n  }\n  .datepicker .react-datepicker__day-name {\n    width: 2.5rem;\n    height: 2.5rem;\n    font-size: 1.3rem;\n  }\n  .datepicker .react-datepicker__month-text {\n    width: 9rem;\n    height: 4rem;\n  }\n  .datepicker .react-datepicker__year-text {\n    width: 5rem;\n    height: 4.5rem;\n    font-size: 1.4rem;\n  }\n  .datepicker .react-datepicker__year-wrapper {\n    min-width: 25rem;\n    justify-content: space-between;\n  }\n}";
styleInject(css_248z$j);

registerLocale('ru', ru);
const DatePicker = memo$1((props) => {
    const { product = '', selected, placeholder, name, setupDate, minDate = null, maxDate = new Date(), setupRawChange = () => null, popperPlacement = 'bottom-start', disabled = false, } = props;
    const [isMonthsPickerVisible, setIsMonthsPickerVisible] = useState(false);
    const [isYearsPickerVisible, setIsYearsPickerVisible] = useState(false);
    const toggleMonthsPicker = useCallback(() => {
        setIsYearsPickerVisible(false);
        setIsMonthsPickerVisible((prev) => !prev);
    }, []);
    const toggleYearsPicker = useCallback(() => {
        setIsMonthsPickerVisible(false);
        setIsYearsPickerVisible((prev) => !prev);
    }, []);
    const handleRawChange = useCallback((event) => {
        setupRawChange(event);
    }, [setupRawChange]);
    const handleCalendarClose = useCallback(() => {
        setIsMonthsPickerVisible(false);
        setIsYearsPickerVisible(false);
    }, []);
    const renderCustomHeader = ({ date, decreaseMonth, increaseMonth, increaseYear, decreaseYear, prevYearButtonDisabled, nextYearButtonDisabled, prevMonthButtonDisabled, nextMonthButtonDisabled, }) => (React__default.createElement("div", { className: `datepicker__customHeader ${product}` },
        React__default.createElement("button", { type: "button", onClick: decreaseYear, disabled: prevYearButtonDisabled, className: "datepicker__customHeaderLeft", "aria-label": "decreaseYear" },
            React__default.createElement(Icon, { name: "arrow_doubleLeft", product: product || 'default', iconStroke: true, iconFill: false })),
        React__default.createElement("button", { type: "button", onClick: decreaseMonth, disabled: prevMonthButtonDisabled, className: "datepicker__customHeaderLeft", "aria-label": "decreaseMonth" },
            React__default.createElement(Icon, { name: "arrowLeft", product: product || 'default', iconStroke: true, iconFill: false })),
        React__default.createElement("div", { className: "datepicker__customHeaderCenter" },
            React__default.createElement("button", { type: "button", onClick: toggleMonthsPicker, className: "datepicker__customHeaderMonth", "data-testid": "MonthBtn" }, MONTHS$1[date.getMonth()]),
            React__default.createElement("button", { type: "button", onClick: toggleYearsPicker, className: "datepicker__customHeaderYear", "data-testid": "YearBtn" }, date.getFullYear())),
        React__default.createElement("button", { type: "button", onClick: increaseMonth, disabled: nextMonthButtonDisabled, className: "datepicker__customHeaderRight", "aria-label": "increaseMonth" },
            React__default.createElement(Icon, { name: "arrowRight", product: product || 'default', iconStroke: true, iconFill: false })),
        React__default.createElement("button", { type: "button", onClick: increaseYear, disabled: nextYearButtonDisabled, className: "datepicker__customHeaderRight", "aria-label": "increaseYear" },
            React__default.createElement(Icon, { name: "arrow_doubleRight", product: product || 'default', iconStroke: true, iconFill: false }))));
    return (React__default.createElement("div", { className: `datepicker ${product}` },
        React__default.createElement(DatePicker$1, { locale: "ru", dateFormat: "dd.MM.yyyy", popperPlacement: popperPlacement, selected: selected, onChange: setupDate, onChangeRaw: handleRawChange, placeholderText: placeholder, todayButton: isMonthsPickerVisible || isYearsPickerVisible ? undefined : 'Сегодня', showMonthYearPicker: isMonthsPickerVisible, showFullMonthYearPicker: isMonthsPickerVisible, showYearPicker: isYearsPickerVisible, shouldCloseOnSelect: false, customInput: React__default.createElement(MaskedInput, null), renderCustomHeader: renderCustomHeader, name: name, minDate: minDate, maxDate: maxDate, onCalendarClose: handleCalendarClose, disabled: disabled, "test-id": "testInput" })));
});
DatePicker.displayName = 'DatePicker';

const FIRST_DAY_OF_YEAR$1 = `01.01.${new Date().getFullYear()}`;
const LAST_DAY_OF_YEAR$1 = `31.12.${new Date().getFullYear()}`;
const INPUT_LENGTH$1 = 8;

const stringToNewDate = (strDate) => {
    const [day, month, year] = strDate.split('.');
    const newDate = new Date(+year, +month - 1, +day);
    return new Date(newDate);
};

var css_248z$i = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.DateInput-module_dateInput__1NlSz {\n  position: relative;\n}\n.DateInput-module_dateInput__1NlSz .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #d6d6d6;\n}\n.DateInput-module_dateInput__1NlSz .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #d6d6d6;\n}\n.DateInput-module_dateInput__1NlSz:focus:not(.DateInput-module_disabled__EJkl7), .DateInput-module_dateInput__1NlSz:focus-within:not(.DateInput-module_disabled__EJkl7) {\n  outline: none;\n}\n.DateInput-module_dateInput__1NlSz:focus:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX, .DateInput-module_dateInput__1NlSz:focus-within:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz.DateInput-module_warning__0Mv3w .DateInput-module_title__J4sRs {\n  font-size: 1.4rem;\n}\n.DateInput-module_dateInput__1NlSz.DateInput-module_warning__0Mv3w .DateInput-module_inputs__9n2mX {\n  outline: 0.1rem solid #dcae1d;\n}\n.DateInput-module_dateInput__1NlSz.DateInput-module_error__zDUTa .DateInput-module_title__J4sRs {\n  font-size: 1.4rem;\n}\n.DateInput-module_dateInput__1NlSz.DateInput-module_error__zDUTa .DateInput-module_inputs__9n2mX {\n  outline: 0.1rem solid #d12e34;\n}\n.DateInput-module_dateInput__1NlSz.DateInput-module_disabled__EJkl7 {\n  outline: none;\n}\n.DateInput-module_dateInput__1NlSz.DateInput-module_disabled__EJkl7 .DateInput-module_title__J4sRs {\n  opacity: 0.3;\n}\n.DateInput-module_dateInput__1NlSz.DateInput-module_disabled__EJkl7 .DateInput-module_inputs__9n2mX {\n  outline: 0.1rem solid rgba(214, 214, 214, 0.3);\n  background: rgba(255, 255, 255, 0.3);\n  opacity: 1;\n}\n.DateInput-module_dateInput__1NlSz.DateInput-module_disabled__EJkl7 .DateInput-module_left__MOC8q svg {\n  opacity: 0.3;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=ofd]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=ofd]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #4ba1a5;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=ofd]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #4ba1a5;\n}\n.DateInput-module_dateInput__1NlSz[class~=ofd]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=ofd]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #4ba1a5;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=ofd] .DateInput-module_title__J4sRs {\n  color: #4ba1a5;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=gosotchet]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=gosotchet]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #488bca;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=gosotchet]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #488bca;\n}\n.DateInput-module_dateInput__1NlSz[class~=gosotchet]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=gosotchet]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #488bca;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=gosotchet] .DateInput-module_title__J4sRs {\n  color: #488bca;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=td]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=td]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #ea8242;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=td]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #ea8242;\n}\n.DateInput-module_dateInput__1NlSz[class~=td]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=td]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #ea8242;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=td] .DateInput-module_title__J4sRs {\n  color: #ea8242;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=edo]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=edo]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #f5a91b;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=edo]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n.DateInput-module_dateInput__1NlSz[class~=edo]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=edo]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #f5a91b;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=edo] .DateInput-module_title__J4sRs {\n  color: #f5a91b;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=check-index]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=check-index]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=check-index]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #5bc0de;\n}\n.DateInput-module_dateInput__1NlSz[class~=check-index]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=check-index]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #5bc0de;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=check-index] .DateInput-module_title__J4sRs {\n  color: #5bc0de;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=marking]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=marking]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #4bb9ba;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=marking]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #4bb9ba;\n}\n.DateInput-module_dateInput__1NlSz[class~=marking]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=marking]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #4bb9ba;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=marking] .DateInput-module_title__J4sRs {\n  color: #4bb9ba;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=big-data]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=big-data]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #5ab8c5;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=big-data]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #5ab8c5;\n}\n.DateInput-module_dateInput__1NlSz[class~=big-data]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=big-data]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #5ab8c5;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=big-data] .DateInput-module_title__J4sRs {\n  color: #5ab8c5;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=arenda]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=arenda]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #d58576;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=arenda]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #d58576;\n}\n.DateInput-module_dateInput__1NlSz[class~=arenda]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=arenda]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #d58576;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=arenda] .DateInput-module_title__J4sRs {\n  color: #d58576;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=mchd]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=mchd]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #626ab7;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=mchd]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #626ab7;\n}\n.DateInput-module_dateInput__1NlSz[class~=mchd]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=mchd]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #626ab7;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=mchd] .DateInput-module_title__J4sRs {\n  color: #626ab7;\n}\n\n.DateInput-module_dateInput__1NlSz[class~=elk]:hover:not(.DateInput-module_disabled__EJkl7) {\n  cursor: pointer;\n}\n.DateInput-module_dateInput__1NlSz[class~=elk]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  outline: 0.1rem solid #577590;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInput-module_dateInput__1NlSz[class~=elk]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #577590;\n}\n.DateInput-module_dateInput__1NlSz[class~=elk]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(2), .DateInput-module_dateInput__1NlSz[class~=elk]:hover:not(.DateInput-module_disabled__EJkl7) .DateInput-module_left__MOC8q svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #577590;\n}\n\n.DateInput-module_typingStatus__typing__CavK-[class~=elk] .DateInput-module_title__J4sRs {\n  color: #577590;\n}\n\n.DateInput-module_typingStatus__default__Em6kP .DateInput-module_title__J4sRs {\n  color: #254e5f;\n}\n.DateInput-module_typingStatus__typing__CavK- {\n  color: #488bca;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n.DateInput-module_typingStatus__typing__CavK- .DateInput-module_title__J4sRs {\n  color: #488bca;\n}\n.DateInput-module_typingStatus__complete__tFNKy .DateInput-module_title__J4sRs {\n  color: #c7c7cc;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n\n.DateInput-module_inputs__9n2mX {\n  transition: 0.3s;\n  height: 4.8rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  outline: 0.1rem solid #d6d6d6;\n  border-radius: 0.2rem;\n  padding: 0.8rem 1rem 0.8rem 1.8rem;\n  background-color: #ffffff;\n  box-sizing: border-box;\n}\n\n.DateInput-module_left__MOC8q {\n  display: flex;\n  margin: 0 0.9rem 0 0;\n}\n.DateInput-module_left_icon__L2hnb path:nth-child(1) {\n  stroke: #c7c7cc;\n}\n.DateInput-module_left_icon__L2hnb path:nth-child(2), .DateInput-module_left_icon__L2hnb path:nth-child(3) {\n  fill: #c7c7cc;\n}\n.DateInput-module_left__MOC8q svg {\n  display: inline-block;\n  width: 1.6rem;\n}\n\n.DateInput-module_center__sSk-w {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.DateInput-module_title__J4sRs {\n  transition: all 0.3s;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n  color: #254e5f;\n}\n\n.DateInput-module_inactive__I4NQS .DateInput-module_title__J4sRs {\n  font-size: 1.4rem;\n}\n\n.DateInput-module_dates__8TACf {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.DateInput-module_dates__8TACf input {\n  border: none;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #254e5f;\n  width: 7.1rem;\n  padding: 0;\n  background-color: transparent;\n}\n.DateInput-module_dates__8TACf input:focus {\n  outline: none;\n}\n.DateInput-module_dates__8TACf input::placeholder {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #c7c7cc;\n}\n\n.DateInput-module_delimiter__m5p8p {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  margin: 0 0.5rem;\n  color: #c7c7cc;\n}\n.DateInput-module_delimiter__cpomplete__SHaHa {\n  color: #254e5f;\n}\n\n.DateInput-module_right__SDVHs svg {\n  display: block;\n  width: 1.6rem;\n}\n\n.DateInput-module_clear__LxhmC {\n  outline: none;\n  border: none;\n  box-shadow: none;\n  background: transparent;\n  transform: rotate(45deg);\n  width: 1rem;\n  margin-left: auto;\n  cursor: pointer;\n}\n.DateInput-module_clear__LxhmC svg {\n  display: block;\n  width: 1.3rem;\n  stroke: #858594;\n}\n\n.DateInput-module_messages__MI72M {\n  padding: 0 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n.DateInput-module_messages_warning__-k1yS {\n  color: #dcae1d;\n}\n.DateInput-module_messages_error__OiusM {\n  color: #d12e34;\n}\n\n.DateInput-module_iconRequired__zyQIZ {\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 50%;\n  background-color: #d12e34;\n  position: absolute;\n  top: 0.6rem;\n  left: 0.6rem;\n}";
var s$b = {"dateInput":"DateInput-module_dateInput__1NlSz","left":"DateInput-module_left__MOC8q","disabled":"DateInput-module_disabled__EJkl7","inputs":"DateInput-module_inputs__9n2mX","warning":"DateInput-module_warning__0Mv3w","title":"DateInput-module_title__J4sRs","error":"DateInput-module_error__zDUTa","typingStatus__typing":"DateInput-module_typingStatus__typing__CavK-","typingStatus__default":"DateInput-module_typingStatus__default__Em6kP","typingStatus__complete":"DateInput-module_typingStatus__complete__tFNKy","left_icon":"DateInput-module_left_icon__L2hnb","center":"DateInput-module_center__sSk-w","inactive":"DateInput-module_inactive__I4NQS","dates":"DateInput-module_dates__8TACf","delimiter":"DateInput-module_delimiter__m5p8p","delimiter__cpomplete":"DateInput-module_delimiter__cpomplete__SHaHa","right":"DateInput-module_right__SDVHs","clear":"DateInput-module_clear__LxhmC","messages":"DateInput-module_messages__MI72M","messages_warning":"DateInput-module_messages_warning__-k1yS","messages_error":"DateInput-module_messages_error__OiusM","iconRequired":"DateInput-module_iconRequired__zyQIZ"};
styleInject(css_248z$i);

const isValidInputDate = (date) => {
    const [d, m, y] = date.split('.');
    return !isNaN(Number(d)) && !isNaN(Number(m)) && !isNaN(Number(y));
};
const DateInput = memo$1((props) => {
    const { valueFrom, valueTo, product = 'default', label = 'Период', nameFrom = '', nameTo = '', placeholderFrom = FIRST_DAY_OF_YEAR$1, placeholderTo = LAST_DAY_OF_YEAR$1, isRange = false, warningMsg = '', errorMsg = '', isDisabled = false, minDate = null, maxDate = null, onChange = () => null, onClear = () => null, onDateFromChange = () => null, onDateToChange = () => null, popperPlacement = 'bottom-start', required, } = props;
    const [dateFrom, setDateFrom] = useState(valueFrom || '');
    const [dateTo, setDateTo] = useState(valueTo || '');
    const [isInputsVisible, setIsInputsVisible] = useState(false);
    const ref = useRef(null);
    const typingStatus = useMemo(() => {
        var _a, _b, _c, _d;
        const dateFromLength = (_b = (_a = dateFrom.match(/\d/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        const dateToLength = (_d = (_c = dateTo.match(/\d/g)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
        const allLength = isRange ? dateFromLength + dateToLength : dateFromLength;
        const maxLength = INPUT_LENGTH$1 * (isRange ? 2 : 1);
        if (allLength > 0 && allLength < maxLength) {
            return 'typing';
        }
        if (allLength === maxLength) {
            return 'complete';
        }
        return 'default';
    }, [dateFrom, dateTo, isRange]);
    const handleClick = useCallback(() => {
        if (!isDisabled)
            setIsInputsVisible(true);
    }, [isDisabled]);
    const handleChangeFrom = useCallback((date) => {
        setDateFrom(date ? new Date(date).toLocaleDateString() : '');
    }, []);
    const handleChangeTo = useCallback((date) => {
        setDateTo(date ? new Date(date).toLocaleDateString() : '');
    }, []);
    const handleTypingFrom = useCallback((event) => {
        if (!event.target.value || !isValidInputDate(event.target.value))
            return;
        setDateFrom(event.target.value);
    }, []);
    const handleTypingTo = useCallback((event) => {
        if (!event.target.value || !isValidInputDate(event.target.value))
            return;
        setDateTo(event.target.value);
    }, []);
    const handleClear = useCallback((e) => {
        e.stopPropagation();
        setDateFrom('');
        setDateTo('');
        onClear();
    }, [onClear]);
    useEffect(() => {
        if (dateFrom || dateTo) {
            setIsInputsVisible(true);
        }
        if (!dateFrom && !dateTo) {
            setIsInputsVisible(false);
        }
    }, [dateFrom, dateTo]);
    useEffect(() => {
        onChange({ from: dateFrom, to: dateTo });
    }, 
    /* eslint-disable-next-line */
    [dateFrom, dateTo]);
    useEffect(() => {
        if (dateFrom === valueFrom)
            return;
        onDateFromChange({ from: dateFrom, to: dateTo });
    }, 
    /* eslint-disable-next-line */
    [dateFrom, valueFrom]);
    useEffect(() => {
        if (dateTo === valueTo)
            return;
        onDateToChange({ from: dateFrom, to: dateTo });
    }, 
    /* eslint-disable-next-line */
    [dateTo]);
    useEffect(() => {
        if (valueFrom !== undefined)
            setDateFrom(valueFrom);
    }, [valueFrom]);
    useEffect(() => {
        if (valueTo !== undefined)
            setDateTo(valueTo);
    }, [valueTo]);
    return (React__default.createElement("div", { className: cn$i(s$b.dateInput, {
            [s$b.range]: isRange,
            [s$b.error]: errorMsg,
            [s$b.warning]: warningMsg,
            [s$b.disabled]: isDisabled,
            [product]: product,
            [s$b.typingStatus__default]: typingStatus === 'default',
            [s$b.typingStatus__typing]: typingStatus === 'typing' && isInputsVisible,
            [s$b.typingStatus__cpomplete]: typingStatus === 'complete',
            [s$b.inactive]: !isInputsVisible,
        }) },
        React__default.createElement("div", { ref: ref, className: s$b.inputs, onClick: handleClick, role: "button", onKeyDown: () => null, tabIndex: 0 },
            React__default.createElement("div", { className: s$b.left },
                React__default.createElement(Icon, { name: "calendarWithCorner", product: product })),
            React__default.createElement("div", { className: s$b.center },
                required && React__default.createElement("div", { className: s$b.iconRequired }),
                React__default.createElement("div", { className: s$b.title }, label),
                isInputsVisible && (React__default.createElement("div", { className: s$b.dates },
                    React__default.createElement(DatePicker, { product: product, selected: dateFrom === '' ? null : stringToNewDate(dateFrom), placeholder: placeholderFrom, name: nameFrom, setupDate: handleChangeFrom, setupRawChange: handleTypingFrom, minDate: minDate || null, maxDate: maxDate || (dateTo ? stringToNewDate(dateTo) : new Date()), popperPlacement: popperPlacement, disabled: isDisabled }),
                    isRange && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("div", { className: cn$i(s$b.delimiter, {
                                [s$b.delimiter__complete]: typingStatus === 'complete',
                            }) }, "\u2014"),
                        React__default.createElement(DatePicker, { product: product, selected: dateTo === '' ? null : stringToNewDate(dateTo), name: nameTo, placeholder: placeholderTo, setupDate: handleChangeTo, setupRawChange: handleTypingTo, minDate: dateFrom ? stringToNewDate(dateFrom) : null, maxDate: maxDate || (dateTo ? stringToNewDate(dateTo) : new Date()), disabled: isDisabled })))))),
            (warningMsg || errorMsg) && (React__default.createElement("div", { className: s$b.right },
                errorMsg && React__default.createElement(Icon, { name: "exclamation", product: "gosotchet", theme: "error" }),
                warningMsg && React__default.createElement(Icon, { name: "exclamationTriangle", product: "gosotchet", theme: "warning" }))),
            (!!dateFrom || !!dateTo) && (React__default.createElement("button", { type: "button", className: cn$i(s$b.clear), onClick: handleClear, "aria-label": "handleClear" },
                React__default.createElement(Icon, { name: "plus", product: "gosotchet" })))),
        (warningMsg || errorMsg) && (React__default.createElement("div", { className: s$b.messages },
            warningMsg && React__default.createElement("div", { className: s$b.messages_warning }, warningMsg),
            errorMsg && React__default.createElement("div", { className: s$b.messages_error }, errorMsg)))));
});
DateInput.displayName = 'DateInput';

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  return unsafeStringify(rnds);
}

const MONTHS = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];

var css_248z$h = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.datepicker-isolate-wrapper .only-show-time-picker .react-datepicker__triangle {\n  display: none;\n}\n.datepicker-isolate-wrapper .custom-range-time-wrapper .react-datepicker-popper {\n  min-width: 42rem !important;\n}\n.datepicker-isolate-wrapper .datepicker-lite {\n  position: relative;\n}\n.datepicker-isolate-wrapper .datepicker-lite__customHeader {\n  display: flex;\n  gap: 0.8rem;\n  justify-content: center;\n  padding: 1.4rem;\n  border-bottom: 0.1rem solid #eeeeee;\n}\n.datepicker-isolate-wrapper .datepicker-lite__customHeaderWrapper {\n  display: flex;\n  gap: 0.8rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite__customHeaderButton {\n  padding: 0 0.8rem;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n.datepicker-isolate-wrapper .datepicker-lite__customHeaderButton:focus, .datepicker-isolate-wrapper .datepicker-lite__customHeaderButton:focus-within, .datepicker-isolate-wrapper .datepicker-lite__customHeaderButton:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite__customHeaderCenter {\n  display: flex;\n  gap: 1.6rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite__customHeaderYear {\n  width: 8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 1;\n  text-align: center;\n  padding: 0.8rem 0;\n  background: #ffffff;\n  border: 0.1rem solid #eeeeee;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n  cursor: pointer;\n}\n.datepicker-isolate-wrapper .datepicker-lite__customHeaderMonth:focus, .datepicker-isolate-wrapper .datepicker-lite__customHeaderMonth:focus-within, .datepicker-isolate-wrapper .datepicker-lite__customHeaderMonth:focus-visible, .datepicker-isolate-wrapper .datepicker-lite__customHeaderYear:focus, .datepicker-isolate-wrapper .datepicker-lite__customHeaderYear:focus-within, .datepicker-isolate-wrapper .datepicker-lite__customHeaderYear:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker {\n  border: 0.1rem solid #bcd3d4;\n  border-radius: 0.4rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker ul.react-datepicker__time-list {\n  height: 23rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: auto;\n  font-weight: 500;\n  font-size: 1.2rem;\n  color: #333333;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar {\n  width: 0.4rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  border-radius: 0.2rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker-wrapper {\n  display: block;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__header {\n  background-color: #ffffff;\n  border: none;\n  padding: 0;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year {\n  margin: 0 0 1rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year-wrapper {\n  margin: 0 auto;\n  min-width: 25rem;\n  max-width: 26rem;\n  justify-content: space-between;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 5rem;\n  height: 3.5rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  text-align: center;\n  color: #254e5f;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year-text--today {\n  font-weight: 600;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year-text--today:focus, .datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year-text--today:focus-within, .datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year-text--today:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year-text--selected {\n  color: #ffffff;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year-text--keyboard-selected {\n  color: #ffffff;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__year--container {\n  max-width: 300rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__month-wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__month {\n  margin: 0 1.3rem 1.3rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  text-align: center;\n  color: #254e5f;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__month-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 8rem;\n  height: 3.5rem;\n  text-transform: capitalize;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__month-text:focus, .datepicker-isolate-wrapper .datepicker-lite .react-datepicker__month-text:focus-within, .datepicker-isolate-wrapper .datepicker-lite .react-datepicker__month-text:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__month-text--keyboard-selected {\n  color: #ffffff;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__current-month {\n  display: none;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__week {\n  display: flex;\n  justify-content: space-between;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__day {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 3.5rem;\n  height: 2.5rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.3rem;\n  line-height: 2rem;\n  text-align: center;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__day:focus, .datepicker-isolate-wrapper .datepicker-lite .react-datepicker__day:focus-within, .datepicker-isolate-wrapper .datepicker-lite .react-datepicker__day:focus-visible {\n  outline: 0.1rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__day-names {\n  display: flex;\n  justify-content: space-between;\n  margin: 1.6rem 1.6rem 0.4rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__day-name {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n  font-size: 1.3rem;\n  line-height: 2rem;\n  color: #254e5f;\n  text-transform: uppercase;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__day--in-selecting-range {\n  background-color: #4ba1a5;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__day--outside-month {\n  background: #f8f8f8;\n  color: #c7c7cc;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker-time__header {\n  font-weight: 500;\n  font-size: 1.2rem;\n  font-family: \"Nunito Sans\", sans-serif;\n  padding: 0.8rem 0;\n  border-bottom: 0.1rem solid #eeeeee;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__navigation-icon::before {\n  top: 1.2rem;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__today-button {\n  margin: 0 1.3rem 1.3rem auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 9rem;\n  height: 3.2rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #ffffff;\n  border: none;\n  box-shadow: 0 0.2rem 0.4rem rgba(52, 123, 126, 0.15), inset 0 0.1rem 0.2rem rgba(255, 255, 255, 0.4);\n  border-radius: 0.2rem;\n  transition: all 0.3s;\n}\n.datepicker-isolate-wrapper .datepicker-lite .react-datepicker__triangle {\n  fill: #ffffff;\n  color: #ffffff;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .datepicker-lite__customHeaderYear {\n  color: #4ba1a5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker {\n  border-color: #bcd3d4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #bcd3d4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #4ba1a5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__triangle {\n  stroke: #bcd3d4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__day--in-selecting-range {\n  background-color: #bcd3d4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__year-text--in-selecting-range {\n  background-color: #bcd3d4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__month-text--in-selecting-range {\n  background-color: #bcd3d4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker-time__header {\n  color: #4ba1a5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__time-container {\n  border-color: #bcd3d4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__month-text--keyboard-selected {\n  background-color: #4ba1a5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=ofd] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #357d81;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=td] .datepicker-lite__customHeaderYear {\n  color: #ea8242;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker {\n  border-color: #f6e2d5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #f6e2d5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #ea8242;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__triangle {\n  stroke: #f6e2d5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__day--in-selecting-range {\n  background-color: #f6e2d5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__year-text--in-selecting-range {\n  background-color: #f6e2d5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__month-text--in-selecting-range {\n  background-color: #f6e2d5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker-time__header {\n  color: #ea8242;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__time-container {\n  border-color: #f6e2d5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__month-text--keyboard-selected {\n  background-color: #ea8242;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=td] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #e26212;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .datepicker-lite__customHeaderYear {\n  color: #488bca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker {\n  border-color: #ccd9e5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #ccd9e5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #488bca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__triangle {\n  stroke: #ccd9e5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__day--in-selecting-range {\n  background-color: #ccd9e5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__year-text--in-selecting-range {\n  background-color: #ccd9e5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__month-text--in-selecting-range {\n  background-color: #ccd9e5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker-time__header {\n  color: #488bca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__time-container {\n  border-color: #ccd9e5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__month-text--keyboard-selected {\n  background-color: #488bca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=gosotchet] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #2c70af;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=edo] .datepicker-lite__customHeaderYear {\n  color: #f5a91b;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker {\n  border-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #f5a91b;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__triangle {\n  stroke: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__day--in-selecting-range {\n  background-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__year-text--in-selecting-range {\n  background-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__month-text--in-selecting-range {\n  background-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker-time__header {\n  color: #f5a91b;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__time-container {\n  border-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__month-text--keyboard-selected {\n  background-color: #f5a91b;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=edo] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #e89700;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=epd] .datepicker-lite__customHeaderYear {\n  color: #f5a91b;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker {\n  border-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #f5a91b;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__triangle {\n  stroke: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__day--in-selecting-range {\n  background-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__year-text--in-selecting-range {\n  background-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__month-text--in-selecting-range {\n  background-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker-time__header {\n  color: #f5a91b;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__time-container {\n  border-color: #f7ebd4;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__month-text--keyboard-selected {\n  background-color: #f5a91b;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=epd] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #e89700;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .datepicker-lite__customHeaderYear {\n  color: #d58576;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker {\n  border-color: #f2d8d3;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #f2d8d3;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #d58576;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__triangle {\n  stroke: #f2d8d3;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__day--in-selecting-range {\n  background-color: #f2d8d3;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__year-text--in-selecting-range {\n  background-color: #f2d8d3;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__month-text--in-selecting-range {\n  background-color: #f2d8d3;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker-time__header {\n  color: #d58576;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__time-container {\n  border-color: #f2d8d3;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__month-text--keyboard-selected {\n  background-color: #d58576;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=arenda] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #ce5a46;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=marking] .datepicker-lite__customHeaderYear {\n  color: #4bb9ba;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker {\n  border-color: #c7e0e1;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #c7e0e1;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #4bb9ba;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__triangle {\n  stroke: #c7e0e1;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__day--in-selecting-range {\n  background-color: #c7e0e1;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__year-text--in-selecting-range {\n  background-color: #c7e0e1;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__month-text--in-selecting-range {\n  background-color: #c7e0e1;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker-time__header {\n  color: #4bb9ba;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__time-container {\n  border-color: #c7e0e1;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__month-text--keyboard-selected {\n  background-color: #4bb9ba;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=marking] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #339799;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .datepicker-lite__customHeaderYear {\n  color: #5bc0de;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker {\n  border-color: #e0f0f5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #e0f0f5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #5bc0de;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__triangle {\n  stroke: #e0f0f5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__day--in-selecting-range {\n  background-color: #e0f0f5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__year-text--in-selecting-range {\n  background-color: #e0f0f5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__month-text--in-selecting-range {\n  background-color: #e0f0f5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker-time__header {\n  color: #5bc0de;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__time-container {\n  border-color: #e0f0f5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__month-text--keyboard-selected {\n  background-color: #5bc0de;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=check-index] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #23a5cd;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .datepicker-lite__customHeaderYear {\n  color: #5ab8c5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker {\n  border-color: #b3dfe5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #b3dfe5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #5ab8c5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__triangle {\n  stroke: #b3dfe5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__day--in-selecting-range {\n  background-color: #b3dfe5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__year-text--in-selecting-range {\n  background-color: #b3dfe5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__month-text--in-selecting-range {\n  background-color: #b3dfe5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker-time__header {\n  color: #5ab8c5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__time-container {\n  border-color: #b3dfe5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__month-text--keyboard-selected {\n  background-color: #5ab8c5;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=big-data] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #36a1b0;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .datepicker-lite__customHeaderYear {\n  color: #626ab7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker {\n  border-color: #cfd2e7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #cfd2e7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #626ab7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__triangle {\n  stroke: #cfd2e7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__day--in-selecting-range {\n  background-color: #cfd2e7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__year-text--in-selecting-range {\n  background-color: #cfd2e7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__month-text--in-selecting-range {\n  background-color: #cfd2e7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker-time__header {\n  color: #626ab7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__time-container {\n  border-color: #cfd2e7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__month-text--keyboard-selected {\n  background-color: #626ab7;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=mchd] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #434ca3;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .datepicker-lite__customHeaderMonth, .datepicker-isolate-wrapper .datepicker-lite[class~=elk] .datepicker-lite__customHeaderYear {\n  color: #577590;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker {\n  border-color: #b9c2ca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker ul.react-datepicker__time-list::-webkit-scrollbar-thumb {\n  background-color: #b9c2ca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #577590;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__triangle {\n  stroke: #b9c2ca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__year-text--in-selecting-range {\n  background-color: #b9c2ca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__month-text--in-selecting-range {\n  background-color: #b9c2ca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker-time__header {\n  color: #577590;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__time-container {\n  border-color: #b9c2ca;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__day--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__day--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__today-button,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__year-text--selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__year-text--keyboard-selected,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__month-text--keyboard-selected {\n  background-color: #577590;\n}\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__day--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__day--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__today-button:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__year-text--selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__year-text--keyboard-selected:hover,\n.datepicker-isolate-wrapper .datepicker-lite[class~=elk] .react-datepicker__month-text--keyboard-selected:hover {\n  background-color: #344b60;\n}";
styleInject(css_248z$h);

registerLocale('ru', ru);
const DatePickerLite = memo$1((props) => {
    const { product, todayButton, showTimeSelect, isRange, showTimeSelectOnly } = props, rest = __rest$1(props, ["product", "todayButton", "showTimeSelect", "isRange", "showTimeSelectOnly"]);
    const [isMonthsPickerVisible, setIsMonthsPickerVisible] = useState(false);
    const [isYearsPickerVisible, setIsYearsPickerVisible] = useState(false);
    const togglePicker = useCallback((type) => {
        if (type === 'months') {
            setIsYearsPickerVisible(false);
            setIsMonthsPickerVisible((prev) => !prev);
        }
        else {
            setIsMonthsPickerVisible(false);
            setIsYearsPickerVisible((prev) => !prev);
        }
    }, []);
    const handleSelect = useCallback(() => {
        setIsYearsPickerVisible(false);
        setIsMonthsPickerVisible((prev) => !prev && isYearsPickerVisible);
    }, [isYearsPickerVisible]);
    const renderCustomHeader = ({ date, decreaseMonth, increaseMonth, decreaseYear, increaseYear, prevMonthButtonDisabled, nextMonthButtonDisabled, prevYearButtonDisabled, nextYearButtonDisabled, }) => (React__default.createElement("div", { className: `datepicker-lite__customHeader ${product}` },
        React__default.createElement("div", { className: "datepicker-lite__customHeaderWrapper" },
            React__default.createElement("button", { type: "button", onClick: decreaseYear, disabled: prevYearButtonDisabled, className: "datepicker-lite__customHeaderButton", "aria-label": "decreaseYear", "data-testid": "decreaseYearBtn" },
                React__default.createElement(Icon, { name: "arrow_doubleLeft", product: product, iconStroke: true, width: "8", height: "8" })),
            React__default.createElement("button", { type: "button", onClick: decreaseMonth, disabled: prevMonthButtonDisabled, className: "datepicker-lite__customHeaderButton", "aria-label": "decreaseMonth", "data-testid": "decreaseMonthBtn" },
                React__default.createElement(Icon, { name: "arrowLeft", product: product, iconStroke: true, width: "8", height: "8" }))),
        React__default.createElement("div", { className: "datepicker-lite__customHeaderCenter" },
            React__default.createElement("button", { type: "button", onClick: () => togglePicker('months'), className: "datepicker-lite__customHeaderMonth", "data-testid": "MonthBtn" }, MONTHS[date.getMonth()]),
            React__default.createElement("button", { type: "button", onClick: () => togglePicker('years'), className: "datepicker-lite__customHeaderYear", "data-testid": "YearBtn" }, date.getFullYear())),
        React__default.createElement("div", { className: "datepicker-lite__customHeaderWrapper" },
            React__default.createElement("button", { type: "button", onClick: increaseMonth, disabled: nextMonthButtonDisabled, className: "datepicker-lite__customHeaderButton", "aria-label": "increaseMonth", "data-testid": "increaseMonthBtn" },
                React__default.createElement(Icon, { name: "arrowRight", product: product, iconStroke: true, width: "8", height: "8" })),
            React__default.createElement("button", { type: "button", onClick: increaseYear, disabled: nextYearButtonDisabled, className: "datepicker-lite__customHeaderButton", "aria-label": "increaseYear", "data-testid": "increaseYearBtn" },
                React__default.createElement(Icon, { name: "arrow_doubleRight", product: product, iconStroke: true, width: "8", height: "8" })))));
    const dateFormat = useMemo(() => {
        if (showTimeSelectOnly) {
            return 'HH:mm';
        }
        if (showTimeSelect) {
            return 'dd.MM.yyyy | HH:mm';
        }
        return 'dd.MM.yyyy';
    }, [showTimeSelectOnly, showTimeSelect]);
    const mask = useMemo(() => {
        if (showTimeSelectOnly) {
            return TIME_MASK;
        }
        if (showTimeSelect) {
            return DATE_TIME_MASK;
        }
        return DATE_MASK;
    }, [showTimeSelectOnly, showTimeSelect]);
    const shouldShowTodayButton = useMemo(() => {
        if (!isMonthsPickerVisible && !isYearsPickerVisible && todayButton) {
            return 'Сегодня';
        }
    }, [isMonthsPickerVisible, isYearsPickerVisible, todayButton]);
    const shouldShowTimeSelect = useMemo(() => showTimeSelect && !isMonthsPickerVisible && !isYearsPickerVisible, [isMonthsPickerVisible, isYearsPickerVisible, showTimeSelect]);
    const shouldCloseOnSelect = useMemo(() => !(isMonthsPickerVisible || isYearsPickerVisible), [isMonthsPickerVisible, isYearsPickerVisible]);
    return (React__default.createElement("div", { className: "datepicker-isolate-wrapper" },
        React__default.createElement("div", { className: cn$i('datepicker-lite', [product], {
                'custom-range-time-wrapper': showTimeSelect && isRange,
                'only-show-time-picker': showTimeSelectOnly,
            }) },
            React__default.createElement(DatePicker$1, Object.assign({}, rest, { todayButton: shouldShowTodayButton, onSelect: handleSelect, locale: "ru", dateFormat: dateFormat, showMonthYearPicker: isMonthsPickerVisible, showFullMonthYearPicker: isMonthsPickerVisible, showYearPicker: isYearsPickerVisible, customInput: React__default.createElement(MaskedInput, { mask: mask }), renderCustomHeader: renderCustomHeader, timeCaption: "\u0412\u0440\u0435\u043C\u044F", showTimeSelect: shouldShowTimeSelect, showTimeSelectOnly: showTimeSelectOnly, shouldCloseOnSelect: shouldCloseOnSelect })))));
});
DatePickerLite.displayName = 'DatePickerLite';

const FIRST_DAY_OF_YEAR = `01.01.${new Date().getFullYear()}`;
const LAST_DAY_OF_YEAR = `31.12.${new Date().getFullYear()}`;

var css_248z$g = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.DateInputLite-module_dateInputLite__CmaF9 {\n  position: relative;\n}\n.DateInputLite-module_dateInputLite__CmaF9 * {\n  box-sizing: border-box;\n}\n.DateInputLite-module_dateInputLite__CmaF9 .DateInputLite-module_wrapper__sw0R5 {\n  text-decoration: none;\n  outline-color: transparent;\n}\n.DateInputLite-module_dateInputLite__CmaF9 .DateInputLite-module_left__gCAuP {\n  position: absolute;\n  left: 1.6rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9 .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #858594;\n}\n.DateInputLite-module_dateInputLite__CmaF9 .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9 .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #858594;\n}\n.DateInputLite-module_dateInputLite__CmaF9:focus:not(.DateInputLite-module_disabled__NzHTy), .DateInputLite-module_dateInputLite__CmaF9:focus-within:not(.DateInputLite-module_disabled__NzHTy) {\n  outline: none;\n}\n.DateInputLite-module_dateInputLite__CmaF9:focus:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9, .DateInputLite-module_dateInputLite__CmaF9:focus-within:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  position: relative;\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9.DateInputLite-module_warning__G-Ho4 .DateInputLite-module_inputs__8vmn9 {\n  outline: 0.1rem solid #dcae1d;\n}\n.DateInputLite-module_dateInputLite__CmaF9.DateInputLite-module_error__mVaWP .DateInputLite-module_inputs__8vmn9 {\n  outline: 0.1rem solid #d12e34;\n}\n.DateInputLite-module_dateInputLite__CmaF9.DateInputLite-module_disabled__NzHTy {\n  outline: none;\n}\n.DateInputLite-module_dateInputLite__CmaF9.DateInputLite-module_disabled__NzHTy .DateInputLite-module_label__xIp1x {\n  opacity: 0.3;\n}\n.DateInputLite-module_dateInputLite__CmaF9.DateInputLite-module_disabled__NzHTy .DateInputLite-module_inputs__8vmn9 {\n  outline: 0.1rem solid rgba(214, 214, 214, 0.3);\n  background: rgba(255, 255, 255, 0.3);\n  opacity: 1;\n}\n.DateInputLite-module_dateInputLite__CmaF9.DateInputLite-module_disabled__NzHTy .DateInputLite-module_left__gCAuP svg {\n  opacity: 0.3;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=ofd] .DateInputLite-module_label__focus__4OR01 {\n  color: #4ba1a5;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=ofd]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=ofd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #4ba1a5;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=ofd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #4ba1a5;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=ofd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=ofd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #4ba1a5;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=gosotchet] .DateInputLite-module_label__focus__4OR01 {\n  color: #488bca;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=gosotchet]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=gosotchet]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #488bca;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=gosotchet]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #488bca;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=gosotchet]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=gosotchet]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #488bca;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=td] .DateInputLite-module_label__focus__4OR01 {\n  color: #ea8242;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=td]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=td]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #ea8242;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=td]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #ea8242;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=td]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=td]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #ea8242;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=edo] .DateInputLite-module_label__focus__4OR01 {\n  color: #f5a91b;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=edo]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=edo]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #f5a91b;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=edo]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #f5a91b;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=edo]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=edo]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #f5a91b;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=epd] .DateInputLite-module_label__focus__4OR01 {\n  color: #f5a91b;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=epd]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=epd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #f5a91b;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=epd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #f5a91b;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=epd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=epd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #f5a91b;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=check-index] .DateInputLite-module_label__focus__4OR01 {\n  color: #5bc0de;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=check-index]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=check-index]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_label__focus__4OR01 {\n  color: #5bc0de;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=check-index]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=check-index]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #5bc0de;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=check-index]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=check-index]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #5bc0de;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=marking] .DateInputLite-module_label__focus__4OR01 {\n  color: #4bb9ba;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=marking]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=marking]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #4bb9ba;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=marking]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #4bb9ba;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=marking]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=marking]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #4bb9ba;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=big-data] .DateInputLite-module_label__focus__4OR01 {\n  color: #5ab8c5;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=big-data]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=big-data]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #5ab8c5;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=big-data]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #5ab8c5;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=big-data]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=big-data]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #5ab8c5;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=arenda] .DateInputLite-module_label__focus__4OR01 {\n  color: #d58576;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=arenda]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=arenda]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #d58576;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=arenda]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #d58576;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=arenda]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=arenda]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #d58576;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=mchd] .DateInputLite-module_label__focus__4OR01 {\n  color: #626ab7;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=mchd]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=mchd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #626ab7;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=mchd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #626ab7;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=mchd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=mchd]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #626ab7;\n}\n\n.DateInputLite-module_dateInputLite__CmaF9[class~=elk] .DateInputLite-module_label__focus__4OR01 {\n  color: #577590;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=elk]:hover:not(.DateInputLite-module_disabled__NzHTy) {\n  cursor: pointer;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=elk]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  outline: 0.1rem solid #577590;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=elk]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(1) {\n  transition: all 0.3s;\n  stroke: #577590;\n}\n.DateInputLite-module_dateInputLite__CmaF9[class~=elk]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(2), .DateInputLite-module_dateInputLite__CmaF9[class~=elk]:hover:not(.DateInputLite-module_disabled__NzHTy) .DateInputLite-module_left__gCAuP svg path:nth-child(3) {\n  transition: all 0.3s;\n  fill: #577590;\n}\n\n.DateInputLite-module_inputs__8vmn9 {\n  transition: 0.3s;\n  height: 4.8rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  outline: 0.1rem solid #d6d6d6;\n  border-radius: 0.2rem;\n  padding: 0.8rem 0;\n  background-color: #ffffff;\n}\n\n.DateInputLite-module_left__gCAuP {\n  display: flex;\n  pointer-events: none;\n}\n.DateInputLite-module_left_icon__YMRLY path:nth-child(1) {\n  stroke: #c7c7cc;\n}\n.DateInputLite-module_left_icon__YMRLY path:nth-child(2), .DateInputLite-module_left_icon__YMRLY path:nth-child(3) {\n  fill: #c7c7cc;\n}\n.DateInputLite-module_left__gCAuP svg {\n  display: inline-block;\n  width: 1.6rem;\n}\n\n.DateInputLite-module_center__jmo0J {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.DateInputLite-module_label__xIp1x {\n  position: absolute;\n  padding-left: 4rem;\n  transition: all 0.3s;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.6rem;\n  color: #254e5f;\n  font-size: 1.4rem;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.DateInputLite-module_label__active__0dNPr {\n  font-weight: 400;\n  font-size: 1.2rem;\n  top: 1rem;\n}\n.DateInputLite-module_label__complete__Mv0PS {\n  color: #858594;\n}\n\n.DateInputLite-module_dates__6SStm {\n  width: 100%;\n  transition: all 0.3s;\n  opacity: 0;\n}\n.DateInputLite-module_dates__6SStm input {\n  display: inline-block;\n  border: none;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #254e5f;\n  width: 100%;\n  padding-top: 2rem;\n  padding-left: 4rem;\n  background-color: transparent;\n  flex-grow: 1;\n  cursor: pointer;\n}\n.DateInputLite-module_dates__6SStm input:focus {\n  outline: none;\n}\n.DateInputLite-module_dates__6SStm input::placeholder {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #c7c7cc;\n}\n.DateInputLite-module_dates__range__yzxkR {\n  display: flex;\n}\n.DateInputLite-module_dates__range__yzxkR div:nth-child(3) input {\n  padding-left: 0.2rem;\n}\n.DateInputLite-module_dates__range__yzxkR input {\n  width: 11.5rem;\n}\n.DateInputLite-module_dates__range_time__sBnTE input {\n  width: 16rem;\n}\n.DateInputLite-module_dates__range_time_only__yW8fW input {\n  width: 8rem;\n}\n.DateInputLite-module_dates__active__cqsoM {\n  opacity: 1;\n}\n.DateInputLite-module_dates__active__cqsoM input {\n  cursor: text;\n}\n.DateInputLite-module_dates__second__Cou1g input {\n  width: 100%;\n}\n\n.DateInputLite-module_divider__cvBGE {\n  padding-top: 2rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  margin: 0 0.2rem;\n  color: #c7c7cc;\n}\n.DateInputLite-module_divider__complete__UKnHp {\n  color: #254e5f;\n}\n\n.DateInputLite-module_right__7-NXA {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 2.4rem;\n}\n.DateInputLite-module_right__7-NXA svg {\n  display: block;\n  width: 1.4rem;\n}\n\n.DateInputLite-module_clear__6i2gv {\n  position: absolute;\n  outline: none;\n  border: none;\n  box-shadow: none;\n  background: transparent;\n  margin-left: auto;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  width: 2.4rem;\n  height: 2.4rem;\n  right: 0;\n}\n.DateInputLite-module_clear_cross__6F4cC {\n  position: relative;\n  transition: all 0.3s;\n  width: 100%;\n  height: 100%;\n}\n.DateInputLite-module_clear_cross__6F4cC:hover::after, .DateInputLite-module_clear_cross__6F4cC:hover::before {\n  background-color: #d12e34;\n}\n.DateInputLite-module_clear_cross__6F4cC::after, .DateInputLite-module_clear_cross__6F4cC::before {\n  content: \"\";\n  transition: all 0.3s;\n  padding: 0;\n  position: absolute;\n  cursor: pointer;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  background-color: #d6d6d6;\n  color: #d6d6d6;\n  height: 0.2rem;\n  width: 1.4rem;\n  border-radius: 0.1rem;\n}\n.DateInputLite-module_clear_cross__6F4cC::after {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) rotate(45deg);\n}\n.DateInputLite-module_clear_cross__6F4cC::before {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) rotate(135deg);\n}\n\n.DateInputLite-module_messages__UD860 {\n  position: absolute;\n  padding-left: 1.6rem;\n  font: 400 1.2rem/1.6rem Roboto, sans-serif;\n}\n.DateInputLite-module_messages_warning__-4udH {\n  color: #dcae1d;\n}\n.DateInputLite-module_messages_error__-Mvnb {\n  color: #d12e34;\n}";
var s$a = {"dateInputLite":"DateInputLite-module_dateInputLite__CmaF9","wrapper":"DateInputLite-module_wrapper__sw0R5","left":"DateInputLite-module_left__gCAuP","disabled":"DateInputLite-module_disabled__NzHTy","inputs":"DateInputLite-module_inputs__8vmn9","warning":"DateInputLite-module_warning__G-Ho4","error":"DateInputLite-module_error__mVaWP","label":"DateInputLite-module_label__xIp1x","label__focus":"DateInputLite-module_label__focus__4OR01","left_icon":"DateInputLite-module_left_icon__YMRLY","center":"DateInputLite-module_center__jmo0J","label__active":"DateInputLite-module_label__active__0dNPr","label__complete":"DateInputLite-module_label__complete__Mv0PS","dates":"DateInputLite-module_dates__6SStm","dates__range":"DateInputLite-module_dates__range__yzxkR","dates__range_time":"DateInputLite-module_dates__range_time__sBnTE","dates__range_time_only":"DateInputLite-module_dates__range_time_only__yW8fW","dates__active":"DateInputLite-module_dates__active__cqsoM","dates__second":"DateInputLite-module_dates__second__Cou1g","divider":"DateInputLite-module_divider__cvBGE","divider__complete":"DateInputLite-module_divider__complete__UKnHp","right":"DateInputLite-module_right__7-NXA","clear":"DateInputLite-module_clear__6i2gv","clear_cross":"DateInputLite-module_clear_cross__6F4cC","messages":"DateInputLite-module_messages__UD860","messages_warning":"DateInputLite-module_messages_warning__-4udH","messages_error":"DateInputLite-module_messages_error__-Mvnb"};
styleInject(css_248z$g);

const DateInputLite = memo$1((props) => {
    const { id, valueFrom, valueTo, product = 'default', label = 'Период', nameFrom, nameTo, placeholderFrom = FIRST_DAY_OF_YEAR, placeholderTo = LAST_DAY_OF_YEAR, isRange, warning, error, isDisabled, minDate, maxDate, onChangeFrom = () => null, onChangeTo = () => null, popperPlacement, isTodayButton, isTimePicker, isOnlyTimePicker, timeIntervals = 15, isStaticLabel, zIndex, } = props;
    const [state, setState] = useState({ isActive: false, isFocus: false });
    const uniqueId = v4();
    const handleChange = useCallback((onChange) => (date) => {
        if (date)
            setState((prev) => (Object.assign(Object.assign({}, prev), { isFocus: false })));
        onChange(date);
    }, []);
    const handleClear = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        setState({ isActive: false, isFocus: false });
        onChangeFrom(null);
        onChangeTo(null);
    }, [onChangeFrom, onChangeTo]);
    const handleClickOutside = useCallback(() => {
        setState({ isActive: false, isFocus: false });
    }, []);
    const handleClickWrapper = useCallback((e) => {
        e.preventDefault();
        if (!isDisabled)
            setState((prev) => (Object.assign(Object.assign({}, prev), { isActive: true })));
    }, [isDisabled]);
    const handleInputClick = useCallback(() => {
        setState({ isActive: true, isFocus: true });
    }, []);
    const renderDatePicker = (type) => (React__default.createElement(DatePickerLite, { id: `${id !== null && id !== void 0 ? id : uniqueId}-${type}`, product: product, selected: type === 'from' ? valueFrom : valueTo, placeholderText: type === 'from' ? placeholderFrom : placeholderTo, name: type === 'from' ? nameFrom : nameTo, onChange: handleChange(type === 'from' ? onChangeFrom : onChangeTo), minDate: type === 'from' ? minDate : valueFrom, maxDate: maxDate, popperPlacement: popperPlacement, disabled: isDisabled, startDate: valueFrom, endDate: valueTo, onInputClick: handleInputClick, onClickOutside: handleClickOutside, todayButton: isTodayButton, showTimeSelect: isOnlyTimePicker || isTimePicker, isRange: isRange, timeIntervals: timeIntervals, selectsStart: type === 'from', selectsEnd: type === 'to', showTimeSelectOnly: isOnlyTimePicker }));
    return (React__default.createElement("div", { style: { zIndex }, className: cn$i(s$a.dateInputLite, {
            [s$a.range]: isRange,
            [s$a.error]: error,
            [s$a.warning]: warning,
            [s$a.disabled]: isDisabled,
            [product]: product,
        }) },
        React__default.createElement("a", { href: "/", onClick: handleClickWrapper, className: s$a.wrapper },
            React__default.createElement("div", { className: s$a.inputs },
                React__default.createElement("div", { className: s$a.left },
                    React__default.createElement(Icon, { name: "calendarWithCorner", product: product })),
                React__default.createElement("div", { className: s$a.center },
                    React__default.createElement("div", { className: cn$i(s$a.label, {
                            [s$a.label__active]: isStaticLabel || state.isActive || valueFrom || valueTo,
                            [s$a.label__complete]: valueFrom,
                            [s$a.label__focus]: state.isFocus,
                        }) }, label),
                    React__default.createElement("div", { className: cn$i(s$a.dates, {
                            [s$a.dates__range]: isRange,
                            [s$a.dates__range_time]: isRange && isTimePicker,
                            [s$a.dates__range_time_only]: isRange && isOnlyTimePicker,
                            [s$a.dates__active]: isStaticLabel || state.isActive || valueFrom || valueTo,
                        }) },
                        renderDatePicker('from'),
                        isRange && (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement("div", { className: cn$i(s$a.divider, { [s$a.divider__complete]: valueFrom && valueTo }) }, "\u2014"),
                            React__default.createElement("div", { className: s$a.dates__second }, renderDatePicker('to')))))),
                React__default.createElement("div", { className: s$a.right },
                    React__default.createElement("div", { className: s$a.icons },
                        error && React__default.createElement(Icon, { name: "exclamation", product: "default", theme: "error" }),
                        warning && React__default.createElement(Icon, { name: "exclamationTriangle", product: "default", theme: "warning" })),
                    (valueFrom || valueTo) && (React__default.createElement("button", { type: "button", className: s$a.clear, onClick: handleClear, "aria-label": "handleClear" },
                        React__default.createElement("div", { className: s$a.clear_cross })))))),
        (warning || error) && (React__default.createElement("div", { className: s$a.messages },
            warning && React__default.createElement("div", { className: s$a.messages_warning }, warning),
            error && React__default.createElement("div", { className: s$a.messages_error }, error)))));
});
DateInputLite.displayName = 'DateInputLite';

const getFileName = (file) => file.name;
const getFileType = (file) => getFileName(file).split('.').pop() || '';
const isAccept = (accepts, file) => accepts.includes(getFileType(file));
const isValidSize = (maxSize, file) => file.size / 1024 <= maxSize;
const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
});
const getFileData = (file) => {
    const fileName = file.name;
    const fileType = fileName.split('.').pop() || '';
    return { fileName, fileType };
};
const checkValidation = ({ file, accepts, maxSize }) => {
    const accept = accepts ? isAccept(accepts, file) : true;
    const size = maxSize ? isValidSize(maxSize, file) : true;
    return accept && size;
};
const getOutputFormat = (format, file) => __awaiter(void 0, void 0, void 0, function* () {
    let output = file;
    switch (format) {
        case 'base64':
            output = yield toBase64(file);
            break;
    }
    return output;
});

var css_248z$f = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_Regular_400.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_SemiBold_600.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_Bold_700.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n.FileLoader-module_disabled__c7fXS {\n  opacity: 0.3;\n}\n.FileLoader-module_disabled__c7fXS button,\n.FileLoader-module_disabled__c7fXS .FileLoader-module_fileButtonText__ETxeI {\n  cursor: auto;\n}\n\n.FileLoader-module_description__LlVNt {\n  font-family: Roboto, sans-serif;\n  font-size: 1.2rem;\n  font-style: normal;\n  line-height: 1.4rem;\n  padding: 0.4rem 1.6rem;\n  color: #c7c7cc;\n}\n\n.FileLoader-module_warning__VimEN {\n  font-family: Roboto, sans-serif;\n  font-size: 1.2rem;\n  font-style: normal;\n  line-height: 1.4rem;\n  padding: 0.4rem 1.6rem;\n  color: #dcae1d;\n}\n\n.FileLoader-module_error__od-dT {\n  font-family: Roboto, sans-serif;\n  font-size: 1.2rem;\n  font-style: normal;\n  line-height: 1.4rem;\n  padding: 0.4rem 1.6rem;\n  color: #d12e34;\n}\n\n.FileLoader-module_file__7lVgF {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 1.5rem 0 0 0;\n}\n\n.FileLoader-module_fileName__UwkOS {\n  display: flex;\n  align-items: center;\n}\n\n.FileLoader-module_fileIcon__qUvkW {\n  width: 1.2rem;\n}\n\n.FileLoader-module_fileText__-1ER5 {\n  color: #254e5f;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  margin: 0 0 0 1rem;\n}\n\n.FileLoader-module_fileButton__KyZnK {\n  display: flex;\n  align-items: center;\n  border: none;\n  background: transparent;\n  outline: none;\n}\n\n.FileLoader-module_fileButtonIcon__AyxJq {\n  width: 0.9rem;\n  height: 0.9rem;\n  transform: rotate(45deg);\n}\n.FileLoader-module_fileButtonIcon__AyxJq svg {\n  display: block;\n}\n\n.FileLoader-module_fileButtonText__ETxeI {\n  color: #d12e34;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.2rem;\n  margin: 0 0 0 1rem;\n  cursor: pointer;\n}";
var s$9 = {"disabled":"FileLoader-module_disabled__c7fXS","fileButtonText":"FileLoader-module_fileButtonText__ETxeI","description":"FileLoader-module_description__LlVNt","warning":"FileLoader-module_warning__VimEN","error":"FileLoader-module_error__od-dT","file":"FileLoader-module_file__7lVgF","fileName":"FileLoader-module_fileName__UwkOS","fileIcon":"FileLoader-module_fileIcon__qUvkW","fileText":"FileLoader-module_fileText__-1ER5","fileButton":"FileLoader-module_fileButton__KyZnK","fileButtonIcon":"FileLoader-module_fileButtonIcon__AyxJq"};
styleInject(css_248z$f);

const FileLoader = memo$1((props) => {
    const { onChange, filename, description, accepts, maxSize, warningMsg, errorMsg, isDisabled = false, customValidationFn, label = 'Загрузить изображение', outputFormat = 'base64', product = 'ofd', styleType = 'default', theme = 'common', multiple = false, className, buttonClassName, hasLeftIcon = true, customIconName, strokeSecond, } = props;
    const hiddenFileInput = React__default.useRef(null);
    const leftIconName = useMemo(() => {
        const name = strokeSecond ? 'download_secondary' : 'download';
        return hasLeftIcon ? name : undefined;
    }, [hasLeftIcon, strokeSecond]);
    const clearInput = useCallback(() => {
        var _a;
        if (!((_a = hiddenFileInput.current) === null || _a === void 0 ? void 0 : _a.value) || isDisabled)
            return;
        hiddenFileInput.current.value = '';
    }, [isDisabled]);
    const handleButtonClick = useCallback(() => {
        if (!hiddenFileInput.current || isDisabled)
            return;
        hiddenFileInput.current.click();
    }, [isDisabled]);
    const handleDeleteFile = useCallback(() => {
        if (isDisabled)
            return;
        onChange({
            fileName: '',
            fileType: '',
            source: '',
            isValid: true,
        }, []);
        clearInput();
    }, [isDisabled, clearInput, onChange]);
    const fileChange = useCallback((file) => __awaiter(void 0, void 0, void 0, function* () {
        return (Object.assign(Object.assign({}, getFileData(file)), { source: yield getOutputFormat(outputFormat, file), tmpURL: URL.createObjectURL(file), isValid: customValidationFn ? customValidationFn(file) : checkValidation({ file, maxSize, accepts }) }));
    }), [outputFormat, customValidationFn, maxSize, accepts]);
    const handleInputChange = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!((_a = event.target.files) === null || _a === void 0 ? void 0 : _a.length))
            return;
        if (multiple) {
            const promFiles = [];
            const files = Array.from(event.target.files);
            files.forEach((file) => {
                promFiles.push(fileChange(file));
            });
            const promFilesUpdate = Promise.all(promFiles);
            const filesUpdate = yield promFilesUpdate;
            onChange({}, filesUpdate, event);
            handleDeleteFile();
        }
        if (!multiple) {
            const files = Array.from(event.target.files);
            files.forEach((file) => __awaiter(void 0, void 0, void 0, function* () {
                const result = yield fileChange(file);
                onChange(result, [], event);
            }));
        }
    }), [onChange, multiple, handleDeleteFile, fileChange]);
    useEffect(() => {
        if (!filename)
            clearInput();
    }, [filename, clearInput]);
    return (React__default.createElement("div", { className: cn$i(s$9.fileLoader, className, {
            [s$9.disabled]: isDisabled,
        }) },
        React__default.createElement("input", { type: "file", multiple: multiple, ref: hiddenFileInput, style: { display: 'none' }, onChange: handleInputChange, accept: accepts === null || accepts === void 0 ? void 0 : accepts.map((accept) => `.${accept}`).join(', ') }),
        React__default.createElement(Button, { className: buttonClassName, disabled: false, label: label, onClick: handleButtonClick, product: product, theme: theme, size: "large", styleType: styleType, type: "button", leftIcon: customIconName !== null && customIconName !== void 0 ? customIconName : leftIconName, iconStroke: true, strokeSecond: strokeSecond }),
        description && React__default.createElement("div", { className: s$9.description }, description),
        warningMsg && React__default.createElement("div", { className: s$9.warning }, warningMsg),
        errorMsg && React__default.createElement("div", { className: s$9.error }, errorMsg),
        filename && (React__default.createElement("div", { className: s$9.file },
            React__default.createElement("div", { className: s$9.fileName },
                React__default.createElement("div", { className: s$9.fileIcon },
                    React__default.createElement(Icon, { iconStroke: true, name: "file_default", product: product, styleType: "borderless" })),
                React__default.createElement("div", { className: s$9.fileText }, filename)),
            React__default.createElement("button", { type: "button", className: s$9.fileButton, onClick: handleDeleteFile },
                React__default.createElement("div", { className: s$9.fileButtonIcon },
                    React__default.createElement(Icon, { iconStroke: true, name: "plus", product: "gosotchet", theme: "error" })),
                React__default.createElement("div", { className: s$9.fileButtonText }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"))))));
});
FileLoader.displayName = 'FileLoader';

var css_248z$e = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_Regular_400.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_SemiBold_600.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_Bold_700.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n.input-module_inputDiv__HDK4I {\n  position: relative;\n}\n\n.input-module_inputDivDisabled__8J1Rc .input-module_inputMain__4EJcu {\n  border-color: #eeeeee;\n  background: #f8f8f8;\n}\n\n.input-module_inputDivDisabled__8J1Rc .input-module_inputLabel__hCJMF {\n  color: #858594;\n  line-height: 1.6rem;\n}\n\n.input-module_inputDivDisabled__8J1Rc .input-module_inputMain__4EJcu::placeholder {\n  color: #254e5f;\n}\n\n.input-module_inputDivInactive__wkp0Q .input-module_inputLabel__hCJMF {\n  line-height: 3.2rem;\n  font-size: 1.4rem;\n}\n\n.input-module_inputDivActive__ct8dz .input-module_inputMain__4EJcu {\n  box-shadow: inset 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_gosotchet__hgxlq {\n  border: 0.1rem solid #ccd9e5;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_ofd__5L-ZV {\n  border: 0.1rem solid #bcd3d4;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_edo__9kJ9s {\n  border: 0.1rem solid #f7ebd4;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_epd__plU9N {\n  border: 0.1rem solid #f7ebd4;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_td__EjmM4 {\n  border: 0.1rem solid #f6e2d5;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_marking__ELHwr {\n  border: 0.1rem solid #c7e0e1;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_check-index__vp4iG {\n  border: 0.1rem solid #e0f0f5;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_big-data__Nh6Gk {\n  border: 0.1rem solid #b3dfe5;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_arenda__R5aF4 {\n  border: 0.1rem solid #f2d8d3;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_integrations__WVK4a {\n  border: 0.1rem solid #d9d9e3;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_onec__JvmqK {\n  border: 0.1rem solid #f3d6d3;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_mchd__Jg32L {\n  border: 0.1rem solid #cfd2e7;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputMain_elk__F7QJO {\n  border: 0.1rem solid #b9c2ca;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel__hCJMF {\n  color: #858594;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_ofd__5wM65 {\n  color: #4ba1a5;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_edo__yDFcL {\n  color: #f5a91b;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_epd__U2PDY {\n  color: #f5a91b;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_gosotchet__MLcJA {\n  color: #488bca;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_td__WOPjb {\n  color: #ea8242;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_marking__dydSM {\n  color: #4bb9ba;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_check-index__WdE3H {\n  color: #5bc0de;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_big-data__yiFW8 {\n  color: #5ab8c5;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_arenda__c4zTi {\n  color: #d58576;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_integrations__zS7oU {\n  color: #797ca4;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_onec__833zD {\n  color: #e36052;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_mchd__EYg-N {\n  color: #626ab7;\n}\n.input-module_inputDivActive__ct8dz .input-module_inputLabel_elk__22v2q {\n  color: #577590;\n}\n\n.input-module_inputDivWithText__8bL5u .input-module_storybook-input-label__EmuBS {\n  color: #858594;\n}\n\n.input-module_inputDivTabSelected__RVM1y .input-module_inputMain__4EJcu {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_ofd__5wM65 {\n  color: #4ba1a5;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_edo__yDFcL {\n  color: #f5a91b;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_epd__U2PDY {\n  color: #f5a91b;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_gosotchet__MLcJA {\n  color: #488bca;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_td__WOPjb {\n  color: #ea8242;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_marking__dydSM {\n  color: #4bb9ba;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_check-index__WdE3H {\n  color: #5bc0de;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_big-data__yiFW8 {\n  color: #5ab8c5;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_arenda__c4zTi {\n  color: #d58576;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_integrations__zS7oU {\n  color: #797ca4;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_onec__833zD {\n  color: #e36052;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_mchd__EYg-N {\n  color: #626ab7;\n}\n.input-module_inputDivTabSelected__RVM1y .input-module_inputLabel_elk__22v2q {\n  color: #577590;\n}\n\n.input-module_inputDivLeftIcon__CoXAx .input-module_inputMain__4EJcu {\n  padding-left: 4rem;\n}\n.input-module_inputDivLeftIcon__CoXAx .input-module_inputLabel__hCJMF {\n  padding-left: 4rem;\n}\n\n.input-module_inputLabel__hCJMF {\n  position: absolute;\n  top: 0.8rem;\n  padding-left: 1.6rem;\n  transition: all 0.3s;\n  font: 600 1.2rem/1.6rem \"Nunito Sans\", sans-serif;\n  color: #254e5f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: -webkit-fill-available;\n}\n.input-module_inputLabelGray__YkPQ2 {\n  color: #858594;\n}\n.input-module_inputLabel__hCJMF.input-module_labelWithIconRight__ZzigE {\n  padding-right: 4rem;\n}\n\n.input-module_inputIcon__8JNTw {\n  position: absolute;\n  width: 1.6rem;\n  height: 1.6rem;\n  top: 1.6rem;\n}\n\n.input-module_inputIconLeft__-wNzr {\n  left: 1.6rem;\n}\n\n.input-module_inputIconRight__iWXe0 {\n  right: 1.6rem;\n}\n\n.input-module_placeholderHidden__3IMkD {\n  visibility: hidden;\n  font: normal 400 1.4rem/2rem Roboto, sans-serif;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-left: 4rem;\n  position: absolute;\n}\n\n.input-module_inputMain__4EJcu {\n  height: 4.8rem;\n  box-sizing: border-box;\n  width: 100%;\n  outline: none;\n  background: #ffffff;\n  border: 0.1rem solid #d6d6d6;\n  border-radius: 0.2rem;\n  padding: 2.2rem 2rem 0.25rem 1.6rem;\n  transition: 0.3s;\n  font: 400 1.4rem/2rem Roboto, sans-serif;\n  color: #254e5f;\n  text-overflow: ellipsis;\n}\n.input-module_inputMain__4EJcu:hover {\n  box-shadow: inset 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n.input-module_inputMain__4EJcu.input-module_inputWithIconRight__7C8fL {\n  padding-right: 4rem;\n}\n\n.input-module_inputMain__4EJcu::placeholder {\n  color: #858594;\n}\n\n.input-module_inputMain_ofd__5L-ZV:not(:disabled):hover {\n  border-color: #4ba1a5;\n}\n\n.input-module_inputMain_edo__9kJ9s:not(:disabled):hover {\n  border-color: #f5a91b;\n}\n\n.input-module_inputMain_epd__plU9N:not(:disabled):hover {\n  border-color: #f5a91b;\n}\n\n.input-module_inputMain_gosotchet__hgxlq:not(:disabled):hover {\n  border-color: #488bca;\n}\n\n.input-module_inputMain_td__EjmM4:not(:disabled):hover {\n  border-color: #ea8242;\n}\n\n.input-module_inputMain_marking__ELHwr:not(:disabled):hover {\n  border-color: #4bb9ba;\n}\n\n.input-module_inputMain_check-index__vp4iG:not(:disabled):hover {\n  border-color: #5bc0de;\n}\n\n.input-module_inputMain_big-data__Nh6Gk:not(:disabled):hover {\n  border-color: #5ab8c5;\n}\n\n.input-module_inputMain_arenda__R5aF4:not(:disabled):hover {\n  border-color: #d58576;\n}\n\n.input-module_inputMain_integrations__WVK4a:not(:disabled):hover {\n  border-color: #797ca4;\n}\n\n.input-module_inputMain_onec__JvmqK:not(:disabled):hover {\n  border-color: #e36052;\n}\n\n.input-module_inputMain_mchd__Jg32L:not(:disabled):hover {\n  border-color: #626ab7;\n}\n\n.input-module_inputMain_elk__F7QJO:not(:disabled):hover {\n  border-color: #577590;\n}\n\n.input-module_inputMain_info__8yObA {\n  border-color: #5bc0de;\n}\n\n.input-module_inputMain_success__nXNSi {\n  border-color: #8bc34a;\n}\n\n.input-module_inputMain_warning__vsVLg {\n  border-color: #dcae1d;\n}\n\n.input-module_inputMain_error__Pt-r5 {\n  border-color: #d12e34;\n}\n\n.input-module_passDisplayBtn__dK1-6 {\n  position: absolute;\n  top: 1.6rem;\n  right: 0.625rem;\n  cursor: pointer;\n  border: 0rem;\n  background-color: transparent;\n}\n\n.input-module_storybook-input-hint-text__Vr0gf.input-module_visible__o5iYC {\n  display: block;\n}\n\n.input-module_inputHintText__cz0ke {\n  position: absolute;\n  padding-left: 1.6rem;\n  margin-top: 0.2rem;\n  font: 400 1.2rem/1.6rem Roboto, sans-serif;\n}\n\n.input-module_inputHintText_info__KYaA8 {\n  color: #5bc0de;\n}\n\n.input-module_inputHintText_success__mcFjt {\n  color: #8bc34a;\n}\n\n.input-module_inputHintText_warning__P3rWP {\n  color: #dcae1d;\n}\n\n.input-module_inputHintText_error__BTdF7 {\n  color: #d12e34;\n}\n\n.input-module_iconRequired__YO2bQ {\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 50%;\n  background-color: #d12e34;\n  position: absolute;\n  top: 0rem;\n  left: 0.6rem;\n}";
var s$8 = {"inputDiv":"input-module_inputDiv__HDK4I","inputDivDisabled":"input-module_inputDivDisabled__8J1Rc","inputMain":"input-module_inputMain__4EJcu","inputLabel":"input-module_inputLabel__hCJMF","inputDivInactive":"input-module_inputDivInactive__wkp0Q","inputDivActive":"input-module_inputDivActive__ct8dz","inputMain_gosotchet":"input-module_inputMain_gosotchet__hgxlq","inputMain_ofd":"input-module_inputMain_ofd__5L-ZV","inputMain_edo":"input-module_inputMain_edo__9kJ9s","inputMain_epd":"input-module_inputMain_epd__plU9N","inputMain_td":"input-module_inputMain_td__EjmM4","inputMain_marking":"input-module_inputMain_marking__ELHwr","inputMain_check-index":"input-module_inputMain_check-index__vp4iG","inputMain_big-data":"input-module_inputMain_big-data__Nh6Gk","inputMain_arenda":"input-module_inputMain_arenda__R5aF4","inputMain_integrations":"input-module_inputMain_integrations__WVK4a","inputMain_onec":"input-module_inputMain_onec__JvmqK","inputMain_mchd":"input-module_inputMain_mchd__Jg32L","inputMain_elk":"input-module_inputMain_elk__F7QJO","inputLabel_ofd":"input-module_inputLabel_ofd__5wM65","inputLabel_edo":"input-module_inputLabel_edo__yDFcL","inputLabel_epd":"input-module_inputLabel_epd__U2PDY","inputLabel_gosotchet":"input-module_inputLabel_gosotchet__MLcJA","inputLabel_td":"input-module_inputLabel_td__WOPjb","inputLabel_marking":"input-module_inputLabel_marking__dydSM","inputLabel_check-index":"input-module_inputLabel_check-index__WdE3H","inputLabel_big-data":"input-module_inputLabel_big-data__yiFW8","inputLabel_arenda":"input-module_inputLabel_arenda__c4zTi","inputLabel_integrations":"input-module_inputLabel_integrations__zS7oU","inputLabel_onec":"input-module_inputLabel_onec__833zD","inputLabel_mchd":"input-module_inputLabel_mchd__EYg-N","inputLabel_elk":"input-module_inputLabel_elk__22v2q","inputDivWithText":"input-module_inputDivWithText__8bL5u","storybook-input-label":"input-module_storybook-input-label__EmuBS","inputDivTabSelected":"input-module_inputDivTabSelected__RVM1y","inputDivLeftIcon":"input-module_inputDivLeftIcon__CoXAx","inputLabelGray":"input-module_inputLabelGray__YkPQ2","labelWithIconRight":"input-module_labelWithIconRight__ZzigE","inputIcon":"input-module_inputIcon__8JNTw","inputIconLeft":"input-module_inputIconLeft__-wNzr","inputIconRight":"input-module_inputIconRight__iWXe0","placeholderHidden":"input-module_placeholderHidden__3IMkD","inputWithIconRight":"input-module_inputWithIconRight__7C8fL","inputMain_info":"input-module_inputMain_info__8yObA","inputMain_success":"input-module_inputMain_success__nXNSi","inputMain_warning":"input-module_inputMain_warning__vsVLg","inputMain_error":"input-module_inputMain_error__Pt-r5","passDisplayBtn":"input-module_passDisplayBtn__dK1-6","storybook-input-hint-text":"input-module_storybook-input-hint-text__Vr0gf","visible":"input-module_visible__o5iYC","inputHintText":"input-module_inputHintText__cz0ke","inputHintText_info":"input-module_inputHintText_info__KYaA8","inputHintText_success":"input-module_inputHintText_success__mcFjt","inputHintText_warning":"input-module_inputHintText_warning__P3rWP","inputHintText_error":"input-module_inputHintText_error__BTdF7","iconRequired":"input-module_iconRequired__YO2bQ"};
styleInject(css_248z$e);

const innValidator = (inn, innType) => {
    let result = false;
    const error = { code: 0, message: '' };
    if (typeof inn === 'number') {
        inn = inn.toString();
    }
    else if (typeof inn !== 'string') {
        inn = '';
    }
    if (!inn.length) {
        error.code = 1;
        error.message = 'Введите ИНН';
    }
    else if (/[^0-9]/.test(inn)) {
        error.code = 2;
        error.message = 'ИНН может состоять только из цифр';
    }
    else if ([10, 12].indexOf(inn.length) === -1) {
        if (innType === 'person') {
            error.code = 3;
            error.message = 'ИНН физического лица должен состоять из 12 цифр';
        }
        else {
            error.code = 4;
            error.message = 'ИНН юридического лица должен состоять из 10 цифр';
        }
    }
    else {
        const checkDigit = (inn_, coefficients) => {
            let n = 0;
            let g;
            for (const i in coefficients) {
                g = parseInt(inn_[i], 10);
                n += coefficients[i] * g;
            }
            return (n % 11) % 10;
        };
        if (innType === 'person') {
            if (inn.length === 12) {
                const n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
                const n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
                if (n11 === parseInt(inn[10], 10) && n12 === parseInt(inn[11], 10)) {
                    result = true;
                }
            }
            else {
                error.code = 5;
                error.message = 'ИНН физического лица должен состоять из 12 цифр';
            }
        }
        else if (innType === 'organisation') {
            if (inn.length === 10) {
                const n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
                if (n10 === parseInt(inn[9], 10)) {
                    result = true;
                }
            }
            else {
                error.code = 6;
                error.message = 'ИНН юридического лица должен состоять из 10 цифр';
            }
        }
        if (!result) {
            error.code = 7;
            error.message = 'Неправильное контрольное число';
        }
    }
    return {
        success: result,
        error,
    };
};

const ogrnValidator = (ogrn, ogrnType) => {
    let result = false;
    let currentOgrn = ogrn;
    const ogrnLength = ogrnType === 'person' ? 15 : 13;
    const error = { code: 0, message: '' };
    if (typeof currentOgrn !== 'string') {
        currentOgrn = '';
    }
    if (!currentOgrn.length) {
        error.code = 1;
        error.message = 'Введите ОГРН';
    }
    else if (/[^0-9]/.test(currentOgrn)) {
        error.code = 2;
        error.message = 'ОГРН может состоять только из цифр';
    }
    else if (currentOgrn.length !== ogrnLength) {
        error.code = 3;
        error.message = `ОГРН может состоять только из ${ogrnLength} цифр`;
    }
    else {
        const controlNumber = parseInt((parseInt(currentOgrn.slice(0, -1), 10) % (ogrnType === 'person' ? 13 : 11)).toString().slice(-1), 10);
        if (controlNumber === parseInt(currentOgrn[(ogrnType === 'person' ? 14 : 12)], 10)) {
            result = true;
        }
        else {
            error.code = 4;
            error.message = 'Неправильное контрольное число';
        }
    }
    return {
        success: result,
        error,
    };
};

const kppValidator = (kpp) => {
    let result = false;
    const error = { code: 0, message: '' };
    if (typeof kpp === 'number') {
        kpp = kpp.toString();
    }
    else if (typeof kpp !== 'string') {
        kpp = '';
    }
    if (!kpp.length) {
        error.code = 1;
        error.message = 'Введите КПП';
    }
    else if (kpp.length !== 9) {
        error.code = 2;
        error.message = 'КПП может состоять только из 9 знаков (цифр или заглавных букв латинского алфавита от A до Z)';
    }
    else if (!/^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(kpp)) {
        error.code = 3;
        error.message = 'Неправильный формат КПП';
    }
    else {
        result = true;
    }
    return {
        success: result,
        error,
    };
};

const snilsValidator = (snils) => {
    let result = false;
    const error = {
        code: 0,
        message: ''
    };
    if (!snils.length) {
        error.code = 1;
        error.message = 'Введите СНИЛС';
    }
    else if (/[^0-9]/.test(snils)) {
        error.code = 2;
        error.message = 'СНИЛС может состоять только из цифр';
    }
    else if (snils.length !== 11) {
        error.code = 3;
        error.message = 'СНИЛС может состоять только из 11 цифр';
    }
    else {
        let sum = 0;
        for (let i = 0; i < 9; i += 1) {
            sum += parseInt(snils[i], 10) * (9 - i);
        }
        let checkDigit = 0;
        if (sum < 100) {
            checkDigit = sum;
        }
        else if (sum > 101) {
            checkDigit = parseInt(String(sum % 101), 10);
            if (checkDigit === 100) {
                checkDigit = 0;
            }
        }
        if (checkDigit === parseInt(snils.slice(-2), 10)) {
            result = true;
        }
        else {
            error.code = 4;
            error.message = 'Неправильное контрольное число';
        }
    }
    return {
        success: result,
        error
    };
};

const vehicleNumberValidator = (vehicleNumber) => {
    const privateRegExp = /^[АВЕКМНОРСТУХ](?!000)\d{3}[АВЕКМНОРСТУХ]{2}\d{2,3}$/iu;
    const transportOrtaxiRegExp = /^[АВЕКМНОРСТУХ]{2}(?!000)\d{3}\d{2,3}$/iu;
    const trailersRegExp = /^[АВЕКМНОРСТУХ]{2}(?!0000)\d{4}\d{2,3}$/iu;
    const motoOrAgriculturalEquipmentRegExp = /^(?!0000)\d{4}[АВЕКМНОРСТУХ]{2}\d{2,3}$/iu;
    const trazitRegExp = /^[АВЕКМНОРСТУХ]{2}(?!000)\d{3}[АВЕКМНОРСТУХ]\d{2,3}$/iu;
    const visitingRegExp = /^Т[АВЕКМНОРСТУХ]{2}(?!000)\d{3}\d{2,3}$/iu;
    let result = false;
    const error = {
        code: 0,
        message: '',
    };
    if (!vehicleNumber.length) {
        error.code = 1;
        error.message = 'Введите номер';
    }
    else if (privateRegExp.test(vehicleNumber) ||
        transportOrtaxiRegExp.test(vehicleNumber) ||
        trailersRegExp.test(vehicleNumber) ||
        motoOrAgriculturalEquipmentRegExp.test(vehicleNumber) ||
        trazitRegExp.test(vehicleNumber) ||
        visitingRegExp.test(vehicleNumber)) {
        result = true;
    }
    else {
        error.code = 2;
        error.message = 'Некорректный номер';
    }
    return {
        success: result,
        error,
    };
};

const phoneValidator = (phone) => {
    const { length } = phone;
    let result = false;
    const error = { code: 0, message: '' };
    const telephoneRegExp = 
    // eslint-disable-next-line
    /^(\+7|7|8)?[\s\-]?\(?\d{3}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
    if (!length || phone === '7' || phone === '8') {
        error.code = 1;
        error.message = 'Введите номер телефона';
    }
    else if (telephoneRegExp.test(phone) && length === 11) {
        result = true;
    }
    else {
        error.code = 2;
        error.message = 'Некорректный номер';
    }
    return {
        success: result,
        error,
    };
};

const emailValidator = (email) => {
    let result = false;
    const error = { code: 0, message: '' };
    const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
    if (!email.length) {
        error.code = 1;
        error.message = 'Введите e-mail';
    }
    else if (emailRegExp.test(email)) {
        result = true;
    }
    else {
        error.code = 2;
        error.message = 'Некорректный e-mail';
    }
    return {
        success: result,
        error,
    };
};

const passportCodeValidator = (code) => {
    let result = false;
    const error = { code: 0, message: '' };
    if (code.length === 7) {
        result = true;
    }
    else {
        error.code = 1;
        error.message = 'Введите код подразделения';
    }
    return {
        success: result,
        error,
    };
};

const passportValidator = (passport) => {
    let result = false;
    const error = { code: 0, message: '' };
    if (passport.length === 10) {
        result = true;
    }
    else {
        error.code = 1;
        error.message = 'Введите серию и номер пасспорта';
    }
    return {
        success: result,
        error,
    };
};

const validateGuid$1 = (guid) => {
    let result = false;
    const error = { code: 0, message: '' };
    const guidRegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (!guid.length) {
        error.code = 1;
        error.message = 'Введите идентификатор';
    }
    else if (guidRegExp.test(guid)) {
        result = true;
    }
    else {
        error.code = 2;
        error.message = 'Некорректный идентификатор';
    }
    return {
        success: result,
        error,
    };
};

const validateInnPerson = (inn) => innValidator(inn, 'person');
const validateInnOrganization = (inn) => innValidator(inn, 'organisation');
const validatePassport = (passport) => passportValidator(passport);
const validatePassportCode = (code) => passportCodeValidator(code);
const validateOgrn = (ogrn) => ogrnValidator(ogrn, 'organisation');
const validateOgrnIp = (ogrn) => ogrnValidator(ogrn, 'person');
const validateKpp = (kpp) => kppValidator(kpp);
const validateSnils = (snils) => snilsValidator(snils);
const validateVehicleNumber = (vehicleNumber) => vehicleNumberValidator(vehicleNumber);
const validateEmail = (email) => emailValidator(email);
const validatePhone = (phone) => phoneValidator(phone);
const validateGuid = (guid) => validateGuid$1(guid);

const passportCodeMask = (e, passportCode) => {
    const regexp = /(\d{3})(\d{3})/g;
    e.target.value = passportCode.replace(regexp, '$1-$2');
};
/**
 * Маска Паспорта гражданина Российской Федерации
 */
const passportCitizenMask = (e, documentValue) => {
    const regexNumbersFormat = /([0-9]{2})([0-9]{2})([0-9]{6})/g;
    const regexAlternateFormat = /([0-9]{2})(\s[0-9]{2})(\s[0-9]{6})/g;
    if (regexNumbersFormat.test(documentValue)) {
        e.target.value = documentValue.replace(regexNumbersFormat, '$1 $2 $3');
    }
    if (regexAlternateFormat.test(documentValue)) {
        e.target.value = documentValue;
    }
};
/**
 * Маска СНИЛС
 */
const snilsMask = (e, documentValue) => {
    const regexNumbersFormat = /([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})/g;
    const regexAlternateFormat = /([0-9]{3})(-[0-9]{3})(-[0-9]{3})(\s[0-9]{2})/g;
    if (regexNumbersFormat.test(documentValue)) {
        e.target.value = documentValue.replace(regexNumbersFormat, '$1-$2-$3 $4');
    }
    if (regexAlternateFormat.test(documentValue)) {
        e.target.value = documentValue;
    }
};

const phoneMask = (e, keyPressed) => {
    let readyField;
    let input = e.target.value;
    const emptyMask = '+7 (   )    -  -  '; // для расчета позиции
    const startMask = '+7 ($1) --'; // при первом вводе кроме 7 ли 8
    const regularMask = '+7 ($2) $3-$4-$5'; // последующие нажатия
    /** позиция элементов в маске +{countryCode} ({cityCode}) {part1}-{part2}-{part3} */
    const poses = {
        currentPos: Number(e.target.selectionStart),
        countryCode: emptyMask.indexOf('+') + 1,
        cityCodeStart: emptyMask.indexOf('(') + 1,
        cityCodeFinish: emptyMask.indexOf(')'),
        part1Start: emptyMask.indexOf(')') + 2,
        part1Finish: emptyMask.indexOf('-'),
        part2Start: emptyMask.indexOf('-') + 1,
        part2Finish: emptyMask.lastIndexOf('-'),
        part3Start: emptyMask.lastIndexOf('-') + 1,
    };
    /** Ограничение на ввод */
    if (input.length > emptyMask.length) {
        input = input.slice(0, emptyMask.length);
    }
    /** Очистка введённых данных от символов, кроме цифр */
    const digits = input.replace(/[^0-9]/g, '');
    const setCursor = (pos) => {
        e.target.selectionStart = pos;
        e.target.selectionEnd = pos;
    };
    /** Замена цифр на маску */
    const regexp = /(\d)(\d{1,3})(\d{1,3})?(\d{1,2})?(\d{1,2})?/;
    readyField = digits.replace(regexp, regularMask);
    /** Логика обработки позиции курсора */
    let newPos = poses.currentPos;
    if (digits.length === 1) {
        if (digits === '7' || digits === '8') {
            readyField = digits.replace(/(\d)/, emptyMask);
            newPos = poses.cityCodeStart;
        }
        else {
            readyField = digits.replace(/(\d)/, startMask);
            newPos = poses.cityCodeStart + 1;
        }
    }
    else if (/^\d$/g.test(keyPressed)) {
        if (poses.currentPos === poses.cityCodeFinish) {
            newPos = poses.part1Start;
        }
        else if (poses.currentPos === poses.cityCodeFinish + 1) {
            newPos = poses.currentPos + 2;
        }
        else if (poses.currentPos === poses.part1Finish) {
            newPos = poses.part2Start;
        }
        else if (poses.currentPos === poses.part1Finish + 1) {
            newPos = poses.part2Start + 1;
        }
        else if (poses.currentPos === poses.part2Finish + 1) {
            newPos = poses.part3Start + 1;
        }
    }
    else if (keyPressed === 'Backspace') {
        if (poses.currentPos === poses.part3Start) {
            newPos = poses.part2Finish;
        }
        else if (poses.currentPos === poses.part2Start) {
            newPos = poses.part1Finish;
        }
        else if (poses.currentPos === poses.part1Start) {
            newPos = poses.cityCodeFinish;
        }
        else if (poses.currentPos === poses.cityCodeStart) {
            newPos = 2;
        }
    }
    /** Очищение маски */
    if (keyPressed === 'Backspace' && digits === '7') {
        readyField = emptyMask;
        newPos = poses.cityCodeStart;
    }
    /** Удаление маски */
    if (keyPressed === 'Backspace' && input === emptyMask.replace('(', '')) {
        readyField = '';
    }
    e.target.value = readyField;
    setCursor(newPos);
};

const warned = new Set();
function warnOnce(condition, message, element) {
    if (condition || warned.has(message))
        return;
    console.warn(message);
    warned.add(message);
}

function createDOMMotionComponentProxy(componentFactory) {
    if (typeof Proxy === "undefined") {
        return componentFactory;
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */
    const componentCache = new Map();
    const deprecatedFactoryFunction = (...args) => {
        if (process.env.NODE_ENV !== "production") {
            warnOnce(false, "motion() is deprecated. Use motion.create() instead.");
        }
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */
        get: (_target, key) => {
            if (key === "create")
                return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */
            if (!componentCache.has(key)) {
                componentCache.set(key, componentFactory(key));
            }
            return componentCache.get(key);
        },
    });
}

function isAnimationControls(v) {
    return (v !== null &&
        typeof v === "object" &&
        typeof v.start === "function");
}

const isKeyframesTarget = (v) => {
    return Array.isArray(v);
};

function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    const prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (let i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

function getValueState(visualElement) {
    const state = [{}, {}];
    visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach((value, key) => {
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function resolveVariantFromProps(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */
    if (typeof definition === "function") {
        const [current, velocity] = getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */
    if (typeof definition === "string") {
        definition = props.variants && props.variants[definition];
    }
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */
    if (typeof definition === "function") {
        const [current, velocity] = getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

const variantPriorityOrder = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit",
];
const variantProps = ["initial", ...variantPriorityOrder];

/**
 * Generate a list of every possible transform key.
 */
const transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
];
/**
 * A quick lookup for transform props.
 */
const transformProps = new Set(transformPropOrder);

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
const secondsToMilliseconds = (seconds) => seconds * 1000;
const millisecondsToSeconds = (milliseconds) => milliseconds / 1000;

const underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10,
};
const criticallyDampedSpring = (target) => ({
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
});
const keyframesTransition = {
    type: "keyframes",
    duration: 0.8,
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */
const ease = {
    type: "keyframes",
    ease: [0.25, 0.1, 0.35, 1],
    duration: 0.3,
};
const getDefaultTransition = (valueKey, { keyframes }) => {
    if (keyframes.length > 2) {
        return keyframesTransition;
    }
    else if (transformProps.has(valueKey)) {
        return valueKey.startsWith("scale")
            ? criticallyDampedSpring(keyframes[1])
            : underDampedSpring;
    }
    return ease;
};

function getValueTransition(transition, key) {
    return transition
        ? transition[key] ||
            transition["default"] ||
            transition
        : undefined;
}

const MotionGlobalConfig = {
    skipAnimations: false,
    useManualTiming: false,
};

const isNotNull = (value) => value !== null;
function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter(isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1
        ? 0
        : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined
        ? resolvedKeyframes[index]
        : finalKeyframe;
}

const noop = (any) => any;

function createRenderStep(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */
    let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */
    let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */
    const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false,
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            if (!queue.has(callback))
                queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */
        cancel: (callback) => {
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */
        process: (frameData) => {
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [nextFrame, thisFrame];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}

const stepsOrder = [
    "read", // Read
    "resolveKeyframes", // Write/Read/Write/Read
    "update", // Compute
    "preRender", // Compute
    "render", // Write
    "postRender", // Compute
];
const maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false,
    };
    const flagRunNextFrame = () => (runNextFrame = true);
    const steps = stepsOrder.reduce((acc, key) => {
        acc[key] = createRenderStep(flagRunNextFrame);
        return acc;
    }, {});
    const { read, resolveKeyframes, update, preRender, render, postRender } = steps;
    const processBatch = () => {
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed
            ? 1000 / 60
            : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = () => {
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) {
            scheduleNextBatch(processBatch);
        }
    };
    const schedule = stepsOrder.reduce((acc, key) => {
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false) => {
            if (!runNextFrame)
                wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process) => {
        for (let i = 0; i < stepsOrder.length; i++) {
            steps[stepsOrder[i]].cancel(process);
        }
    };
    return { schedule, cancel, state, steps };
}

const { schedule: frame, cancel: cancelFrame, state: frameData, steps: frameSteps, } = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true);

/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) *
    t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) {
            upperBound = currentT;
        }
        else {
            lowerBound = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2)
        return noop;
    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const reverseEasing = (easing) => (p) => 1 - easing(1 - p);

const backOut = /*@__PURE__*/ cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = /*@__PURE__*/ reverseEasing(backOut);
const backInOut = /*@__PURE__*/ mirrorEasing(backIn);

const anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circIn);

/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
const isZeroValueString = (v) => /^0[^.\s]+$/u.test(v);

function isNone(value) {
    if (typeof value === "number") {
        return value === 0;
    }
    else if (value !== null) {
        return value === "none" || value === "0" || isZeroValueString(value);
    }
    else {
        return true;
    }
}

let warning = noop;
let invariant = noop;
if (process.env.NODE_ENV !== "production") {
    warning = (check, message) => {
        if (!check && typeof console !== "undefined") {
            console.warn(message);
        }
    };
    invariant = (check, message) => {
        if (!check) {
            throw new Error(message);
        }
    };
}

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
const isNumericalString = (v) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

const checkStringStartsWith = (token) => (key) => typeof key === "string" && key.startsWith(token);
const isCSSVariableName = 
/*@__PURE__*/ checkStringStartsWith("--");
const startsAsVariableToken = 
/*@__PURE__*/ checkStringStartsWith("var(--");
const isCSSVariableToken = (value) => {
    const startsWithToken = startsAsVariableToken(value);
    if (!startsWithToken)
        return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
const splitCSSVariableRegex = 
// eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function parseCSSVariable(current) {
    const match = splitCSSVariableRegex.exec(current);
    if (!match)
        return [,];
    const [, token1, token2, fallback] = match;
    return [`--${token1 !== null && token1 !== void 0 ? token1 : token2}`, fallback];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
    invariant(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = parseCSSVariable(current);
    // No CSS variable detected
    if (!token)
        return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return isCSSVariableToken(fallback)
        ? getVariableValue(fallback, element, depth + 1)
        : fallback;
}

const clamp = (min, max, v) => {
    if (v > max)
        return max;
    if (v < min)
        return min;
    return v;
};

const number = {
    test: (v) => typeof v === "number",
    parse: parseFloat,
    transform: (v) => v,
};
const alpha = {
    ...number,
    transform: (v) => clamp(0, 1, v),
};
const scale = {
    ...number,
    default: 1,
};

const createUnitType = (unit) => ({
    test: (v) => typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
    parse: parseFloat,
    transform: (v) => `${v}${unit}`,
});
const degrees = /*@__PURE__*/ createUnitType("deg");
const percent = /*@__PURE__*/ createUnitType("%");
const px = /*@__PURE__*/ createUnitType("px");
const vh = /*@__PURE__*/ createUnitType("vh");
const vw = /*@__PURE__*/ createUnitType("vw");
const progressPercentage = {
    ...percent,
    parse: (v) => percent.parse(v) / 100,
    transform: (v) => percent.transform(v * 100),
};

const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY",
]);
const isNumOrPxType = (v) => v === number || v === px;
const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
    if (transform === "none" || !transform)
        return 0;
    const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
    if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
    }
    else {
        const matrix = transform.match(/^matrix\((.+)\)$/u);
        if (matrix) {
            return getPosFromMatrix(matrix[1], pos2);
        }
        else {
            return 0;
        }
    }
};
const transformKeys = new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    nonTranslationalTransformKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const positionalValues = {
    // Dimensions
    width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top }) => parseFloat(top),
    left: (_bbox, { left }) => parseFloat(left),
    bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
    right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;

/**
 * Tests a provided value against a ValueType
 */
const testValueType = (v) => (type) => type.test(v);

/**
 * ValueType for "auto"
 */
const auto = {
    test: (v) => v === "auto",
    parse: (v) => v,
};

/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

const toResolve = new Set();
let isScheduled = false;
let anyNeedsMeasurement = false;
function measureAllKeyframes() {
    if (anyNeedsMeasurement) {
        const resolversToMeasure = Array.from(toResolve).filter((resolver) => resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver) => resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */
        elementsToMeasure.forEach((element) => {
            const removedTransforms = removeNonTranslationalTransform(element);
            if (!removedTransforms.length)
                return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver) => resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element) => {
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) {
                restore.forEach(([key, value]) => {
                    var _a;
                    (_a = element.getValue(key)) === null || _a === void 0 ? void 0 : _a.set(value);
                });
            }
        });
        // Read
        resolversToMeasure.forEach((resolver) => resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver) => {
            if (resolver.suspendedScrollY !== undefined) {
                window.scrollTo(0, resolver.suspendedScrollY);
            }
        });
    }
    anyNeedsMeasurement = false;
    isScheduled = false;
    toResolve.forEach((resolver) => resolver.complete());
    toResolve.clear();
}
function readAllKeyframes() {
    toResolve.forEach((resolver) => {
        resolver.readKeyframes();
        if (resolver.needsMeasurement) {
            anyNeedsMeasurement = true;
        }
    });
}
function flushKeyframeResolvers() {
    readAllKeyframes();
    measureAllKeyframes();
}
class KeyframeResolver {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false) {
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */
        this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */
        this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */
        this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */
        this.isScheduled = false;
        this.unresolvedKeyframes = [...unresolvedKeyframes];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            toResolve.add(this);
            if (!isScheduled) {
                isScheduled = true;
                frame.read(readAllKeyframes);
                frame.resolveKeyframes(measureAllKeyframes);
            }
        }
        else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes, name, element, motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */
        for (let i = 0; i < unresolvedKeyframes.length; i++) {
            if (unresolvedKeyframes[i] === null) {
                /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */
                if (i === 0) {
                    const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                    const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                    if (currentValue !== undefined) {
                        unresolvedKeyframes[0] = currentValue;
                    }
                    else if (element && name) {
                        const valueAsRead = element.readValue(name, finalKeyframe);
                        if (valueAsRead !== undefined && valueAsRead !== null) {
                            unresolvedKeyframes[0] = valueAsRead;
                        }
                    }
                    if (unresolvedKeyframes[0] === undefined) {
                        unresolvedKeyframes[0] = finalKeyframe;
                    }
                    if (motionValue && currentValue === undefined) {
                        motionValue.set(unresolvedKeyframes[0]);
                    }
                }
                else {
                    unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
                }
            }
        }
    }
    setFinalKeyframe() { }
    measureInitialState() { }
    renderEndStyles() { }
    measureEndState() { }
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete)
            this.scheduleResolve();
    }
}

// If this number is a decimal, make it just five decimal places
// to avoid exponents
const sanitize = (v) => Math.round(v * 100000) / 100000;

const floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

function isNullish(v) {
    return v == null;
}

const singleColorRegex = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
const isColorString = (type, testProp) => (v) => {
    return Boolean((typeof v === "string" &&
        singleColorRegex.test(v) &&
        v.startsWith(type)) ||
        (testProp &&
            !isNullish(v) &&
            Object.prototype.hasOwnProperty.call(v, testProp)));
};
const splitColor = (aName, bName, cName) => (v) => {
    if (typeof v !== "string")
        return v;
    const [a, b, c, alpha] = v.match(floatRegex);
    return {
        [aName]: parseFloat(a),
        [bName]: parseFloat(b),
        [cName]: parseFloat(c),
        alpha: alpha !== undefined ? parseFloat(alpha) : 1,
    };
};

const clampRgbUnit = (v) => clamp(0, 255, v);
const rgbUnit = {
    ...number,
    transform: (v) => Math.round(clampRgbUnit(v)),
};
const rgba = {
    test: /*@__PURE__*/ isColorString("rgb", "red"),
    parse: /*@__PURE__*/ splitColor("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" +
        rgbUnit.transform(red) +
        ", " +
        rgbUnit.transform(green) +
        ", " +
        rgbUnit.transform(blue) +
        ", " +
        sanitize(alpha.transform(alpha$1)) +
        ")",
};

function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
        // Or we have 3 characters, ie #F00
    }
    else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
const hex = {
    test: /*@__PURE__*/ isColorString("#"),
    parse: parseHex,
    transform: rgba.transform,
};

const hsla = {
    test: /*@__PURE__*/ isColorString("hsl", "hue"),
    parse: /*@__PURE__*/ splitColor("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
        return ("hsla(" +
            Math.round(hue) +
            ", " +
            percent.transform(sanitize(saturation)) +
            ", " +
            percent.transform(sanitize(lightness)) +
            ", " +
            sanitize(alpha.transform(alpha$1)) +
            ")");
    },
};

const color = {
    test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
    parse: (v) => {
        if (rgba.test(v)) {
            return rgba.parse(v);
        }
        else if (hsla.test(v)) {
            return hsla.parse(v);
        }
        else {
            return hex.parse(v);
        }
    },
    transform: (v) => {
        return typeof v === "string"
            ? v
            : v.hasOwnProperty("red")
                ? rgba.transform(v)
                : hsla.transform(v);
    },
};

const colorRegex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

function test(v) {
    var _a, _b;
    return (isNaN(v) &&
        typeof v === "string" &&
        (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) +
            (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) >
            0);
}
const NUMBER_TOKEN = "number";
const COLOR_TOKEN = "color";
const VAR_TOKEN = "var";
const VAR_FUNCTION_TOKEN = "var(";
const SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function analyseComplexValue(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: [],
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace(complexRegex, (parsedValue) => {
        if (color.test(parsedValue)) {
            indexes.color.push(i);
            types.push(COLOR_TOKEN);
            values.push(color.parse(parsedValue));
        }
        else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push(VAR_TOKEN);
            values.push(parsedValue);
        }
        else {
            indexes.number.push(i);
            types.push(NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return SPLIT_TOKEN;
    });
    const split = tokenised.split(SPLIT_TOKEN);
    return { values, split, indexes, types };
}
function parseComplexValue(v) {
    return analyseComplexValue(v).values;
}
function createTransformer(source) {
    const { split, types } = analyseComplexValue(source);
    const numSections = split.length;
    return (v) => {
        let output = "";
        for (let i = 0; i < numSections; i++) {
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === NUMBER_TOKEN) {
                    output += sanitize(v[i]);
                }
                else if (type === COLOR_TOKEN) {
                    output += color.transform(v[i]);
                }
                else {
                    output += v[i];
                }
            }
        }
        return output;
    };
}
const convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone$1(v) {
    const parsed = parseComplexValue(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = {
    test,
    parse: parseComplexValue,
    createTransformer,
    getAnimatableNone: getAnimatableNone$1,
};

/**
 * Properties that should default to 1 or 100%
 */
const maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow")
        return v;
    const [number] = value.match(floatRegex) || [];
    if (!number)
        return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const filter = {
    ...complex,
    getAnimatableNone: (v) => {
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    },
};

const browserNumberValueTypes = {
    // Border props
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    // Positioning props
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    // Spacing props
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    // Misc
    backgroundPositionX: px,
    backgroundPositionY: px,
};

const transformValueTypes = {
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
};

const int$1 = {
    ...number,
    transform: Math.round,
};

const numberValueTypes = {
    ...browserNumberValueTypes,
    ...transformValueTypes,
    zIndex: int$1,
    size: px,
    // SVG
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int$1,
};

/**
 * A map of default value types for common values
 */
const defaultValueTypes = {
    ...numberValueTypes,
    // Color props
    color,
    backgroundColor: color,
    outlineColor: color,
    fill: color,
    stroke: color,
    // Border props
    borderColor: color,
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: color,
    filter,
    WebkitFilter: filter,
};
/**
 * Gets the default ValueType for the provided value key
 */
const getDefaultValueType = (key) => defaultValueTypes[key];

function getAnimatableNone(key, value) {
    let defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter)
        defaultValueType = complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone
        ? defaultValueType.getAnimatableNone(value)
        : undefined;
}

/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */
const invalidTemplates = new Set(["auto", "none", "0"]);
function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while (i < unresolvedKeyframes.length && !animatableTemplate) {
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" &&
            !invalidTemplates.has(keyframe) &&
            analyseComplexValue(keyframe).values.length) {
            animatableTemplate = unresolvedKeyframes[i];
        }
        i++;
    }
    if (animatableTemplate && name) {
        for (const noneIndex of noneKeyframeIndexes) {
            unresolvedKeyframes[noneIndex] = getAnimatableNone(name, animatableTemplate);
        }
    }
}

class DOMKeyframesResolver extends KeyframeResolver {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element) {
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes, element, name } = this;
        if (!element || !element.current)
            return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */
        for (let i = 0; i < unresolvedKeyframes.length; i++) {
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if (isCSSVariableToken(keyframe)) {
                    const resolved = getVariableValue(keyframe, element.current);
                    if (resolved !== undefined) {
                        unresolvedKeyframes[i] = resolved;
                    }
                    if (i === unresolvedKeyframes.length - 1) {
                        this.finalKeyframe = keyframe;
                    }
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */
        this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */
        if (!positionalKeys.has(name) || unresolvedKeyframes.length !== 2) {
            return;
        }
        const [origin, target] = unresolvedKeyframes;
        const originType = findDimensionValueType(origin);
        const targetType = findDimensionValueType(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */
        if (originType === targetType)
            return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */
        if (isNumOrPxType(originType) && isNumOrPxType(targetType)) {
            for (let i = 0; i < unresolvedKeyframes.length; i++) {
                const value = unresolvedKeyframes[i];
                if (typeof value === "string") {
                    unresolvedKeyframes[i] = parseFloat(value);
                }
            }
        }
        else {
            /**
             * Else, the only way to resolve this is by measuring the element.
             */
            this.needsMeasurement = true;
        }
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes, name } = this;
        const noneKeyframeIndexes = [];
        for (let i = 0; i < unresolvedKeyframes.length; i++) {
            if (isNone(unresolvedKeyframes[i])) {
                noneKeyframeIndexes.push(i);
            }
        }
        if (noneKeyframeIndexes.length) {
            makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name);
        }
    }
    measureInitialState() {
        const { element, unresolvedKeyframes, name } = this;
        if (!element || !element.current)
            return;
        if (name === "height") {
            this.suspendedScrollY = window.pageYOffset;
        }
        this.measuredOrigin = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) {
            element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
        }
    }
    measureEndState() {
        var _a;
        const { element, name, unresolvedKeyframes } = this;
        if (!element || !element.current)
            return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) {
            this.finalKeyframe = finalKeyframe;
        }
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) {
            this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue]) => {
                element
                    .getValue(unsetTransformName)
                    .set(unsetTransformValue);
            });
        }
        this.resolveNoneKeyframes();
    }
}

function isGenerator(type) {
    return typeof type === "function";
}

let now;
function clearTime() {
    now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */
const time = {
    now: () => {
        if (now === undefined) {
            time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming
                ? frameData.timestamp
                : performance.now());
        }
        return now;
    },
    set: (newTime) => {
        now = newTime;
        queueMicrotask(clearTime);
    },
};

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
const isAnimatable = (value, name) => {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex")
        return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" && // It's animatable if we have a string
        (complex.test(value) || value === "0") && // And it contains numbers and/or colors
        !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
    }
    return false;
};

function hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1)
        return true;
    for (let i = 0; i < keyframes.length; i++) {
        if (keyframes[i] !== current)
            return true;
    }
}
function canAnimate(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */
    const originKeyframe = keyframes[0];
    if (originKeyframe === null)
        return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */
    if (name === "display" || name === "visibility")
        return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = isAnimatable(originKeyframe, name);
    const isTargetAnimatable = isAnimatable(targetKeyframe, name);
    warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) {
        return false;
    }
    return (hasKeyframesChanged(keyframes) ||
        ((type === "spring" || isGenerator(type)) && velocity));
}

/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */
const MAX_RESOLVE_DELAY = 40;
class BaseAnimation {
    constructor({ autoplay = true, delay = 0, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", ...options }) {
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = time.now();
        this.options = {
            autoplay,
            delay,
            type,
            repeat,
            repeatDelay,
            repeatType,
            ...options,
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */
    calcStartTime() {
        if (!this.resolvedAt)
            return this.createdAt;
        return this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY
            ? this.resolvedAt
            : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */
    get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) {
            flushKeyframeResolvers();
        }
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */
    onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = time.now();
        this.hasAttemptedResolve = true;
        const { name, type, velocity, delay, onComplete, onUpdate, isGenerator, } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */
        if (!isGenerator && !canAnimate(keyframes, name, type, velocity)) {
            // Finish immediately
            if (!delay) {
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(getFinalKeyframe(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                this.resolveFinishedPromise();
                return;
            }
            // Finish after a delay
            else {
                this.options.duration = 0;
            }
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false)
            return;
        this._resolved = {
            keyframes,
            finalKeyframe,
            ...resolvedAnimation,
        };
        this.onPostResolved();
    }
    onPostResolved() { }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */
    then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve) => {
            this.resolveFinishedPromise = resolve;
        });
    }
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

const velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - velocitySampleDuration, 0);
    return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration$1 = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1, }) {
    let envelope;
    let derivative;
    warning(duration <= secondsToMilliseconds(maxDuration$1), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */
    dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
    duration = clamp(minDuration, maxDuration$1, millisecondsToSeconds(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */
        envelope = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        /**
         * Critically-damped spring
         */
        envelope = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = secondsToMilliseconds(duration);
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration,
        };
    }
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration,
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for (let i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some((key) => options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options,
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        const derived = findSpring(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0,
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring({ keyframes, restDelta, restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    const { stiffness, damping, mass, duration, velocity, isResolvedFromDuration, } = getSpringOptions({
        ...options,
        velocity: -millisecondsToSeconds(options.velocity || 0),
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */
    const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t) => {
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return (target -
                envelope *
                    (((initialVelocity +
                        dampingRatio * undampedAngularFreq * initialDelta) /
                        angularFreq) *
                        Math.sin(angularFreq * t) +
                        initialDelta * Math.cos(angularFreq * t)));
        };
    }
    else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t) => target -
            Math.exp(-undampedAngularFreq * t) *
                (initialDelta +
                    (initialVelocity + undampedAngularFreq * initialDelta) * t);
    }
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t) => {
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return (target -
                (envelope *
                    ((initialVelocity +
                        dampingRatio * undampedAngularFreq * initialDelta) *
                        Math.sinh(freqForT) +
                        dampedAngularFreq *
                            initialDelta *
                            Math.cosh(freqForT))) /
                    dampedAngularFreq);
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t) => {
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */
                if (dampingRatio < 1) {
                    currentVelocity =
                        t === 0
                            ? secondsToMilliseconds(initialVelocity)
                            : calcGeneratorVelocity(resolveSpring, t, current);
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? target : current;
            return state;
        },
    };
}

function inertia({ keyframes, velocity = 0.0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed, }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin,
    };
    const isOutOfBounds = (v) => (min !== undefined && v < min) || (max !== undefined && v > max);
    const nearestBoundary = (v) => {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */
    if (target !== ideal)
        amplitude = target - origin;
    const calcDelta = (t) => -amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t) => target + calcDelta(t);
    const applyFriction = (t) => {
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */
    let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t) => {
        if (!isOutOfBounds(state.value))
            return;
        timeReachedBoundary = t;
        spring$1 = spring({
            keyframes: [state.value, nearestBoundary(state.value)],
            velocity: calcGeneratorVelocity(calcLatest, t, state.value), // TODO: This should be passing * 1000
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta,
            restSpeed,
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t) => {
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */
            let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */
            if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) {
                return spring$1.next(t - timeReachedBoundary);
            }
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        },
    };
}

const easeIn = /*@__PURE__*/ cubicBezier(0.42, 0, 1, 1);
const easeOut = /*@__PURE__*/ cubicBezier(0, 0, 0.58, 1);
const easeInOut = /*@__PURE__*/ cubicBezier(0.42, 0, 0.58, 1);

const isEasingArray = (ease) => {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

const isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

const easingLookup = {
    linear: noop,
    easeIn,
    easeInOut,
    easeOut,
    circIn,
    circInOut,
    circOut,
    backIn,
    backInOut,
    backOut,
    anticipate,
};
const easingDefinitionToFunction = (definition) => {
    if (isBezierDefinition(definition)) {
        // If cubic bezier definition, create bezier curve
        invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        // Else lookup from table
        invariant(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return easingLookup[definition];
    }
    return definition;
};

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);

/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
const progress = (from, to, value) => {
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
const mixNumber$1 = (from, to, progress) => {
    return from + (to - from) * progress;
};

// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) {
        red = green = blue = lightness;
    }
    else {
        const q = lightness < 0.5
            ? lightness * (1 + saturation)
            : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha,
    };
}

function mixImmediate(a, b) {
    return (p) => (p > 0 ? b : a);
}

// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v) => {
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const colorTypes = [hex, rgba, hsla];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color) {
    const type = getColorType(color);
    warning(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type))
        return false;
    let model = type.parse(color);
    if (type === hsla) {
        // TODO Remove this cast - needed since Motion's stricter typing
        model = hslaToRgba(model);
    }
    return model;
}
const mixColor = (from, to) => {
    const fromRGBA = asRGBA(from);
    const toRGBA = asRGBA(to);
    if (!fromRGBA || !toRGBA) {
        return mixImmediate(from, to);
    }
    const blended = { ...fromRGBA };
    return (v) => {
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = mixNumber$1(fromRGBA.alpha, toRGBA.alpha, v);
        return rgba.transform(blended);
    };
};

const invisibleValues = new Set(["none", "hidden"]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */
function mixVisibility(origin, target) {
    if (invisibleValues.has(origin)) {
        return (p) => (p <= 0 ? origin : target);
    }
    else {
        return (p) => (p >= 1 ? target : origin);
    }
}

function mixNumber(a, b) {
    return (p) => mixNumber$1(a, b, p);
}
function getMixer(a) {
    if (typeof a === "number") {
        return mixNumber;
    }
    else if (typeof a === "string") {
        return isCSSVariableToken(a)
            ? mixImmediate
            : color.test(a)
                ? mixColor
                : mixComplex;
    }
    else if (Array.isArray(a)) {
        return mixArray;
    }
    else if (typeof a === "object") {
        return color.test(a) ? mixColor : mixObject;
    }
    return mixImmediate;
}
function mixArray(a, b) {
    const output = [...a];
    const numValues = output.length;
    const blendValue = a.map((v, i) => getMixer(v)(v, b[i]));
    return (p) => {
        for (let i = 0; i < numValues; i++) {
            output[i] = blendValue[i](p);
        }
        return output;
    };
}
function mixObject(a, b) {
    const output = { ...a, ...b };
    const blendValue = {};
    for (const key in output) {
        if (a[key] !== undefined && b[key] !== undefined) {
            blendValue[key] = getMixer(a[key])(a[key], b[key]);
        }
    }
    return (v) => {
        for (const key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
}
function matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = { color: 0, var: 0, number: 0 };
    for (let i = 0; i < target.values.length; i++) {
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const mixComplex = (origin, target) => {
    const template = complex.createTransformer(target);
    const originStats = analyseComplexValue(origin);
    const targetStats = analyseComplexValue(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length &&
        originStats.indexes.color.length === targetStats.indexes.color.length &&
        originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((invisibleValues.has(origin) &&
            !targetStats.values.length) ||
            (invisibleValues.has(target) &&
                !originStats.values.length)) {
            return mixVisibility(origin, target);
        }
        return pipe(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
    }
    else {
        warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return mixImmediate(origin, target);
    }
};

function mix(from, to, p) {
    if (typeof from === "number" &&
        typeof to === "number" &&
        typeof p === "number") {
        return mixNumber$1(from, to, p);
    }
    const mixer = getMixer(from);
    return mixer(from, to);
}

function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || mix;
    const numMixers = output.length - 1;
    for (let i = 0; i < numMixers; i++) {
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || noop : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    invariant(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */
    if (inputLength === 1)
        return () => output[0];
    if (inputLength === 2 && input[0] === input[1])
        return () => output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [...input].reverse();
        output = [...output].reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v) => {
        let i = 0;
        if (numMixers > 1) {
            for (; i < input.length - 2; i++) {
                if (v < input[i + 1])
                    break;
            }
        }
        const progressInRange = progress(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp
        ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v))
        : interpolator;
}

function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for (let i = 1; i <= remaining; i++) {
        const offsetProgress = progress(0, remaining, i);
        offset.push(mixNumber$1(min, 1, offsetProgress));
    }
}

function defaultOffset(arr) {
    const offset = [0];
    fillOffset(offset, arr.length - 1);
    return offset;
}

function convertOffsetToTimes(offset, duration) {
    return offset.map((o) => o * duration);
}

function defaultEasing(values, easing) {
    return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function keyframes({ duration = 300, keyframes: keyframeValues, times, ease = "easeInOut", }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */
    const easingFunctions = isEasingArray(ease)
        ? ease.map(easingDefinitionToFunction)
        : easingDefinitionToFunction(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = {
        done: false,
        value: keyframeValues[0],
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */
    const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length
        ? times
        : defaultOffset(keyframeValues), duration);
    const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions)
            ? easingFunctions
            : defaultEasing(keyframeValues, easingFunctions),
    });
    return {
        calculatedDuration: duration,
        next: (t) => {
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        },
    };
}

/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
const maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while (!state.done && duration < maxGeneratorDuration) {
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= maxGeneratorDuration ? Infinity : duration;
}

const frameloopDriver = (update) => {
    const passTimestamp = ({ timestamp }) => update(timestamp);
    return {
        start: () => frame.update(passTimestamp, true),
        stop: () => cancelFrame(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */
        now: () => (frameData.isProcessing ? frameData.timestamp : time.now()),
    };
};

const generators = {
    decay: inertia,
    inertia,
    tween: keyframes,
    keyframes: keyframes,
    spring,
};
const percentToProgress = (percent) => percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */
class MainThreadAnimation extends BaseAnimation {
    constructor(options) {
        super(options);
        /**
         * The time at which the animation was paused.
         */
        this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */
        this.cancelTime = null;
        /**
         * The current time of the animation.
         */
        this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */
        this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */
        this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */
        this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */
        this.stop = () => {
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle")
                return;
            this.teardown();
            const { onStop } = this.options;
            onStop && onStop();
        };
        const { name, motionValue, element, keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || KeyframeResolver;
        const onResolved = (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type = "keyframes", repeat = 0, repeatDelay = 0, repeatType, velocity = 0, } = this.options;
        const generatorFactory = isGenerator(type)
            ? type
            : generators[type] || keyframes;
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */
        let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== keyframes &&
            typeof keyframes$1[0] !== "number") {
            if (process.env.NODE_ENV !== "production") {
                invariant(keyframes$1.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$1}`);
            }
            mapPercentToKeyframes = pipe(percentToProgress, mix(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [0, 100];
        }
        const generator = generatorFactory({ ...this.options, keyframes: keyframes$1 });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */
        if (repeatType === "mirror") {
            mirroredGenerator = generatorFactory({
                ...this.options,
                keyframes: [...keyframes$1].reverse(),
                velocity: -velocity,
            });
        }
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */
        if (generator.calculatedDuration === null) {
            generator.calculatedDuration = calcGeneratorDuration(generator);
        }
        const { calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator,
            mirroredGenerator,
            mapPercentToKeyframes,
            calculatedDuration,
            resolvedDuration,
            totalDuration,
        };
    }
    onPostResolved() {
        const { autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) {
            this.pause();
        }
        else {
            this.state = this.pendingPlayState;
        }
    }
    tick(timestamp, sample = false) {
        const { resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes } = this.options;
            return { done: true, value: keyframes[keyframes.length - 1] };
        }
        const { finalKeyframe, generator, mirroredGenerator, mapPercentToKeyframes, keyframes, calculatedDuration, totalDuration, resolvedDuration, } = resolved;
        if (this.startTime === null)
            return generator.next(0);
        const { delay, repeat, repeatType, repeatDelay, onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */
        if (this.speed > 0) {
            this.startTime = Math.min(this.startTime, timestamp);
        }
        else if (this.speed < 0) {
            this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        }
        // Update currentTime
        if (sample) {
            this.currentTime = timestamp;
        }
        else if (this.holdTime !== null) {
            this.currentTime = this.holdTime;
        }
        else {
            // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
            // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
            // example.
            this.currentTime =
                Math.round(timestamp - this.startTime) * this.speed;
        }
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0
            ? timeWithoutDelay < 0
            : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) {
            this.currentTime = totalDuration;
        }
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */
            const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */
            let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */
            let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */
            if (!iterationProgress && progress >= 1) {
                iterationProgress = 1;
            }
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */
            const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) {
                        iterationProgress -= repeatDelay / resolvedDuration;
                    }
                }
                else if (repeatType === "mirror") {
                    frameGenerator = mirroredGenerator;
                }
            }
            elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */
        const state = isInDelayPhase
            ? { done: false, value: keyframes[0] }
            : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) {
            state.value = mapPercentToKeyframes(state.value);
        }
        let { done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) {
            done =
                this.speed >= 0
                    ? this.currentTime >= totalDuration
                    : this.currentTime <= 0;
        }
        const isAnimationFinished = this.holdTime === null &&
            (this.state === "finished" || (this.state === "running" && done));
        if (isAnimationFinished && finalKeyframe !== undefined) {
            state.value = getFinalKeyframe(keyframes, this.options, finalKeyframe);
        }
        if (onUpdate) {
            onUpdate(state.value);
        }
        if (isAnimationFinished) {
            this.finish();
        }
        return state;
    }
    get duration() {
        const { resolved } = this;
        return resolved ? millisecondsToSeconds(resolved.calculatedDuration) : 0;
    }
    get time() {
        return millisecondsToSeconds(this.currentTime);
    }
    set time(newTime) {
        newTime = secondsToMilliseconds(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) {
            this.holdTime = newTime;
        }
        else if (this.driver) {
            this.startTime = this.driver.now() - newTime / this.speed;
        }
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) {
            this.time = millisecondsToSeconds(this.currentTime);
        }
    }
    play() {
        if (!this.resolver.isScheduled) {
            this.resolver.resume();
        }
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped)
            return;
        const { driver = frameloopDriver, onPlay, startTime } = this.options;
        if (!this.driver) {
            this.driver = driver((timestamp) => this.tick(timestamp));
        }
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) {
            this.startTime = now - this.holdTime;
        }
        else if (!this.startTime) {
            this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        }
        else if (this.state === "finished") {
            this.startTime = now;
        }
        if (this.state === "finished") {
            this.updateFinishedPromise();
        }
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */
        this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") {
            this.play();
        }
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) {
            this.tick(this.cancelTime);
        }
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver)
            return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}

/**
 * A list of values that can be hardware-accelerated.
 */
const acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
    // or until we implement support for linear() easing.
    // "background-color"
]);

// Create a linear easing point for every 10 ms
const resolution = 10;
const generateLinearEasing = (easing, duration // as milliseconds
) => {
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for (let i = 0; i < numPoints; i++) {
        points += easing(progress(0, numPoints - 1, i)) + ", ";
    }
    return `linear(${points.substring(0, points.length - 2)})`;
};

function memo(callback) {
    let result;
    return () => {
        if (result === undefined)
            result = callback();
        return result;
    };
}

/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */
const supportsFlags = {
    linearEasing: undefined,
};

function memoSupports(callback, supportsFlag) {
    const memoized = memo(callback);
    return () => { var _a; return (_a = supportsFlags[supportsFlag]) !== null && _a !== void 0 ? _a : memoized(); };
}

const supportsLinearEasing = /*@__PURE__*/ memoSupports(() => {
    try {
        document
            .createElement("div")
            .animate({ opacity: 0 }, { easing: "linear(0, 1)" });
    }
    catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

function isWaapiSupportedEasing(easing) {
    return Boolean((typeof easing === "function" && supportsLinearEasing()) ||
        !easing ||
        (typeof easing === "string" &&
            (easing in supportedWaapiEasing || supportsLinearEasing())) ||
        isBezierDefinition(easing) ||
        (Array.isArray(easing) && easing.every(isWaapiSupportedEasing)));
}
const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ cubicBezierAsString([0, 0.65, 0.55, 1]),
    circOut: /*@__PURE__*/ cubicBezierAsString([0.55, 0, 1, 0.45]),
    backIn: /*@__PURE__*/ cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
    backOut: /*@__PURE__*/ cubicBezierAsString([0.33, 1.53, 0.69, 0.99]),
};
function mapEasingToNativeEasing(easing, duration) {
    if (!easing) {
        return undefined;
    }
    else if (typeof easing === "function" && supportsLinearEasing()) {
        return generateLinearEasing(easing, duration);
    }
    else if (isBezierDefinition(easing)) {
        return cubicBezierAsString(easing);
    }
    else if (Array.isArray(easing)) {
        return easing.map((segmentEasing) => mapEasingToNativeEasing(segmentEasing, duration) ||
            supportedWaapiEasing.easeOut);
    }
    else {
        return supportedWaapiEasing[easing];
    }
}

function startWaapiAnimation(element, valueName, keyframes, { delay = 0, duration = 300, repeat = 0, repeatType = "loop", ease = "easeInOut", times, } = {}) {
    const keyframeOptions = { [valueName]: keyframes };
    if (times)
        keyframeOptions.offset = times;
    const easing = mapEasingToNativeEasing(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */
    if (Array.isArray(easing))
        keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay,
        duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal",
    });
}

function attachTimeline(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}

const supportsWaapi = /*@__PURE__*/ memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));

/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
const sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
const maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */
function requiresPregeneratedKeyframes(options) {
    return (isGenerator(options.type) ||
        options.type === "spring" ||
        !isWaapiSupportedEasing(options.ease));
}
function pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */
    const sampleAnimation = new MainThreadAnimation({
        ...options,
        keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true,
    });
    let state = { done: false, value: keyframes[0] };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */
    let t = 0;
    while (!state.done && t < maxDuration) {
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - sampleDelta,
        ease: "linear",
    };
}
const unsupportedEasingFunctions = {
    anticipate,
    backInOut,
    circInOut,
};
function isUnsupportedEase(key) {
    return key in unsupportedEasingFunctions;
}
class AcceleratedAnimation extends BaseAnimation {
    constructor(options) {
        super(options);
        const { name, motionValue, element, keyframes } = this.options;
        this.resolver = new DOMKeyframesResolver(keyframes, (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration = 300, times, ease, type, motionValue, name, startTime, } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */
        if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) {
            return false;
        }
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */
        if (typeof ease === "string" &&
            supportsLinearEasing() &&
            isUnsupportedEase(ease)) {
            ease = unsupportedEasingFunctions[ease];
        }
        /**
         * If this animation needs pre-generated keyframes then generate.
         */
        if (requiresPregeneratedKeyframes(this.options)) {
            const { onComplete, onUpdate, motionValue, element, ...options } = this.options;
            const pregeneratedAnimation = pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) {
                keyframes[1] = keyframes[0];
            }
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = startWaapiAnimation(motionValue.owner.current, name, keyframes, { ...this.options, duration, times, ease });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            attachTimeline(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        else {
            /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */
            animation.onfinish = () => {
                const { onComplete } = this.options;
                motionValue.set(getFinalKeyframe(keyframes, this.options, finalKeyframe));
                onComplete && onComplete();
                this.cancel();
                this.resolveFinishedPromise();
            };
        }
        return {
            animation,
            duration,
            times,
            type,
            ease,
            keyframes: keyframes,
        };
    }
    get duration() {
        const { resolved } = this;
        if (!resolved)
            return 0;
        const { duration } = resolved;
        return millisecondsToSeconds(duration);
    }
    get time() {
        const { resolved } = this;
        if (!resolved)
            return 0;
        const { animation } = resolved;
        return millisecondsToSeconds(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved } = this;
        if (!resolved)
            return;
        const { animation } = resolved;
        animation.currentTime = secondsToMilliseconds(newTime);
    }
    get speed() {
        const { resolved } = this;
        if (!resolved)
            return 1;
        const { animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved } = this;
        if (!resolved)
            return;
        const { animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved } = this;
        if (!resolved)
            return "idle";
        const { animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved } = this;
        if (!resolved)
            return null;
        const { animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */
    attachTimeline(timeline) {
        if (!this._resolved) {
            this.pendingTimeline = timeline;
        }
        else {
            const { resolved } = this;
            if (!resolved)
                return noop;
            const { animation } = resolved;
            attachTimeline(animation, timeline);
        }
        return noop;
    }
    play() {
        if (this.isStopped)
            return;
        const { resolved } = this;
        if (!resolved)
            return;
        const { animation } = resolved;
        if (animation.playState === "finished") {
            this.updateFinishedPromise();
        }
        animation.play();
    }
    pause() {
        const { resolved } = this;
        if (!resolved)
            return;
        const { animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle")
            return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved } = this;
        if (!resolved)
            return;
        const { animation, keyframes, duration, type, ease, times } = resolved;
        if (animation.playState === "idle" ||
            animation.playState === "finished") {
            return;
        }
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */
        if (this.time) {
            const { motionValue, onUpdate, onComplete, element, ...options } = this.options;
            const sampleAnimation = new MainThreadAnimation({
                ...options,
                keyframes,
                duration,
                type,
                ease,
                times,
                isGenerator: true,
            });
            const sampleTime = secondsToMilliseconds(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - sampleDelta).value, sampleAnimation.sample(sampleTime).value, sampleDelta);
        }
        const { onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved } = this;
        if (!resolved)
            return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved } = this;
        if (!resolved)
            return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue, name, repeatDelay, repeatType, damping, type } = options;
        return (supportsWaapi() &&
            name &&
            acceleratedValues.has(name) &&
            motionValue &&
            motionValue.owner &&
            motionValue.owner.current instanceof HTMLElement &&
            /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */
            !motionValue.owner.getProps().onUpdate &&
            !repeatDelay &&
            repeatType !== "mirror" &&
            damping !== 0 &&
            type !== "inertia");
    }
}

const supportsScrollTimeline = memo(() => window.ScrollTimeline !== undefined);

class GroupPlaybackControls {
    constructor(animations) {
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = () => this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */
    getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for (let i = 0; i < this.animations.length; i++) {
            this.animations[i][propName] = newValue;
        }
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation) => {
            if (supportsScrollTimeline() && animation.attachTimeline) {
                return animation.attachTimeline(timeline);
            }
            else {
                return fallback(animation);
            }
        });
        return () => {
            subscriptions.forEach((cancel, i) => {
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for (let i = 0; i < this.animations.length; i++) {
            max = Math.max(max, this.animations[i].duration);
        }
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls) => controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}

/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}

const animateMotionValue = (name, value, target, transition = {}, element, isHandoff) => (onComplete) => {
    const valueTransition = getValueTransition(transition, name) || {};
    /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */
    const delay = valueTransition.delay || transition.delay || 0;
    /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */
    let { elapsed = 0 } = transition;
    elapsed = elapsed - secondsToMilliseconds(delay);
    let options = {
        keyframes: Array.isArray(target) ? target : [null, target],
        ease: "easeOut",
        velocity: value.getVelocity(),
        ...valueTransition,
        delay: -elapsed,
        onUpdate: (v) => {
            value.set(v);
            valueTransition.onUpdate && valueTransition.onUpdate(v);
        },
        onComplete: () => {
            onComplete();
            valueTransition.onComplete && valueTransition.onComplete();
        },
        name,
        motionValue: value,
        element: isHandoff ? undefined : element,
    };
    /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */
    if (!isTransitionDefined(valueTransition)) {
        options = {
            ...options,
            ...getDefaultTransition(name, options),
        };
    }
    /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */
    if (options.duration) {
        options.duration = secondsToMilliseconds(options.duration);
    }
    if (options.repeatDelay) {
        options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
    }
    if (options.from !== undefined) {
        options.keyframes[0] = options.from;
    }
    let shouldSkip = false;
    if (options.type === false ||
        (options.duration === 0 && !options.repeatDelay)) {
        options.duration = 0;
        if (options.delay === 0) {
            shouldSkip = true;
        }
    }
    /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */
    if (shouldSkip && !isHandoff && value.get() !== undefined) {
        const finalKeyframe = getFinalKeyframe(options.keyframes, valueTransition);
        if (finalKeyframe !== undefined) {
            frame.update(() => {
                options.onUpdate(finalKeyframe);
                options.onComplete();
            });
            // We still want to return some animation controls here rather
            // than returning undefined
            return new GroupPlaybackControls([]);
        }
    }
    /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    if (!isHandoff && AcceleratedAnimation.supports(options)) {
        return new AcceleratedAnimation(options);
    }
    else {
        return new MainThreadAnimation(options);
    }
};

const isCustomValue = (v) => {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = (v) => {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1)
        arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1)
        arr.splice(index, 1);
}

class SubscriptionManager {
    constructor() {
        this.subscriptions = [];
    }
    add(handler) {
        addUniqueItem(this.subscriptions, handler);
        return () => removeItem(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (let i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                const handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */
const MAX_VELOCITY_DELTA = 30;
const isFloat = (value) => {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    constructor(init, options = {}) {
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */
        this.version = "11.11.15";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        this.updateAndNotify = (v, render = true) => {
            const currentTime = time.now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */
            if (this.updatedAt !== currentTime) {
                this.setPrevFrameValue();
            }
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) {
                this.events.change.notify(this.current);
            }
            // Update render subscribers
            if (render && this.events.renderRequest) {
                this.events.renderRequest.notify(this.current);
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = time.now();
        if (this.canTrackVelocity === null && current !== undefined) {
            this.canTrackVelocity = isFloat(this.current);
        }
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */
    onChange(subscription) {
        if (process.env.NODE_ENV !== "production") {
            warnOnce(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
        }
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") {
            return () => {
                unsubscribe();
                /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */
                frame.read(() => {
                    if (!this.events.change.getSize()) {
                        this.stop();
                    }
                });
            };
        }
        return unsubscribe;
    }
    clearListeners() {
        for (const eventManagers in this.events) {
            this.events[eventManagers].clear();
        }
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    set(v, render = true) {
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */
    jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect)
            this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    get() {
        return this.current;
    }
    /**
     * @public
     */
    getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    getVelocity() {
        const currentTime = time.now();
        if (!this.canTrackVelocity ||
            this.prevFrameValue === undefined ||
            currentTime - this.updatedAt > MAX_VELOCITY_DELTA) {
            return 0;
        }
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return velocityPerSecond(parseFloat(this.current) -
            parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    start(startAnimation) {
        this.stop();
        return new Promise((resolve) => {
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) {
                this.events.animationStart.notify();
            }
        }).then(() => {
            if (this.events.animationComplete) {
                this.events.animationComplete.notify();
            }
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) {
                this.events.animationCancel.notify();
            }
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) {
            this.stopPassiveEffect();
        }
    }
}
function motionValue(init, options) {
    return new MotionValue(init, options);
}

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, motionValue(value));
    }
}
function setTarget(visualElement, definition) {
    const resolved = resolveVariant(visualElement, definition);
    let { transitionEnd = {}, transition = {}, ...target } = resolved || {};
    target = { ...target, ...transitionEnd };
    for (const key in target) {
        const value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}

/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = (str) => str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

function getOptimisedAppearId(visualElement) {
    return visualElement.props[optimizedAppearDataAttribute];
}

const isMotionValue = (value) => Boolean(value && value.getVelocity);

function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue(value) && value.add);
}

function addValueToWillChange(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */
    if (isWillChangeMotionValue(willChange)) {
        return willChange.add(key);
    }
}

/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition, { delay = 0, transitionOverride, type } = {}) {
    var _a;
    let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride)
        transition = transitionOverride;
    const animations = [];
    const animationTypeState = type &&
        visualElement.animationState &&
        visualElement.animationState.getState()[type];
    for (const key in target) {
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        const valueTransition = {
            delay,
            ...getValueTransition(transition || {}, key),
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */
        let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = getOptimisedAppearId(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, frame);
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        addValueToWillChange(visualElement, key);
        value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key)
            ? { type: false }
            : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) {
            animations.push(animation);
        }
    }
    if (transitionEnd) {
        Promise.all(animations).then(() => {
            frame.update(() => {
                transitionEnd && setTarget(visualElement, transitionEnd);
            });
        });
    }
    return animations;
}

function animateVariant(visualElement, variant, options = {}) {
    var _a;
    const resolved = resolveVariant(visualElement, variant, options.type === "exit"
        ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom
        : undefined);
    let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getAnimation = resolved
        ? () => Promise.all(animateTarget(visualElement, resolved, options))
        : () => Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size
        ? (forwardDelay = 0) => {
            const { delayChildren = 0, staggerChildren, staggerDirection, } = transition;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : () => Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */
    const { when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation];
        return first().then(() => last());
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1
        ? (i = 0) => i * staggerChildren
        : (i = 0) => maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach((child, i) => {
        child.notify("AnimationStart", variant);
        animations.push(animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i),
        }).then(() => child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}

function animateVisualElement(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant) => animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        const resolvedDefinition = typeof definition === "function"
            ? resolveVariant(visualElement, definition, options.custom)
            : definition;
        animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
    }
    return animation.then(() => {
        visualElement.notify("AnimationComplete", definition);
    });
}

const numVariantProps = variantProps.length;
function getVariantContext(visualElement) {
    if (!visualElement)
        return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent
            ? getVariantContext(visualElement.parent) || {}
            : {};
        if (visualElement.props.initial !== undefined) {
            context.initial = visualElement.props.initial;
        }
        return context;
    }
    const context = {};
    for (let i = 0; i < numVariantProps; i++) {
        const name = variantProps[i];
        const prop = visualElement.props[name];
        if (isVariantLabel(prop) || prop === false) {
            context[name] = prop;
        }
    }
    return context;
}

const reversePriorityOrder = [...variantPriorityOrder].reverse();
const numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return (animations) => Promise.all(animations.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
    let animate = animateList(visualElement);
    let state = createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */
    const buildResolvedTypeValues = (type) => (acc, definition) => {
        var _a;
        const resolved = resolveVariant(visualElement, definition, type === "exit"
            ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom
            : undefined);
        if (resolved) {
            const { transition, transitionEnd, ...target } = resolved;
            acc = { ...acc, ...target, ...transitionEnd };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */
    function animateChanges(changedActiveType) {
        const { props } = visualElement;
        const context = getVariantContext(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */
        const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */
        const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */
        let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */
        let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */
        for (let i = 0; i < numAnimationTypes; i++) {
            const type = reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined
                ? props[type]
                : context[type];
            const propIsVariant = isVariantLabel(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */
            const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */
            let isInherited = prop === context[type] &&
                prop !== props[type] &&
                propIsVariant;
            /**
             *
             */
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */
            typeState.protectedKeys = { ...encounteredKeys };
            // Check if we can skip analysing this prop early
            if (
            // If it isn't active and hasn't *just* been set as inactive
            (!typeState.isActive && activeDelta === null) ||
                // If we didn't and don't have any defined prop for this animation type
                (!prop && !typeState.prevProp) ||
                // Or if the prop doesn't define an animation
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */
            const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange ||
                // If we're making this variant active, we want to always make it active
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                // If we removed a higher-priority variant (i is in reverse order)
                (i > removedVariantIndex && propIsVariant);
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */
            const definitionList = Array.isArray(prop) ? prop : [prop];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */
            let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false)
                resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */
            const { prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues,
            };
            const markToAnimate = (key) => {
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue)
                    motionValue.liveStyle = false;
            };
            for (const key in allKeys) {
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */
                let valueHasChanged = false;
                if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                    valueHasChanged = !shallowCompare(next, prev);
                }
                else {
                    valueHasChanged = next !== prev;
                }
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) {
                        // If next is defined and doesn't equal prev, it needs animating
                        markToAnimate(key);
                    }
                    else {
                        // If it's undefined, it's been removed.
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */
                    markToAnimate(key);
                }
                else {
                    /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */
                    typeState.protectedKeys[key] = true;
                }
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */
            if (typeState.isActive) {
                encounteredKeys = { ...encounteredKeys, ...resolvedValues };
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */
            const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) {
                animations.push(...definitionList.map((animation) => ({
                    animation: animation,
                    options: { type },
                })));
            }
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */
        if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key) => {
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue)
                    motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({ animation: fallbackAnimation });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            (props.initial === false || props.initial === props.animate) &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */
    function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive)
            return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for (const key in state) {
            state[key].protectedKeys = {};
        }
        return animations;
    }
    return {
        animateChanges,
        setActive,
        setAnimateFunction,
        getState: () => state,
        reset: () => {
            state = createState();
            isInitialRender = true;
        },
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if (Array.isArray(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive = false) {
    return {
        isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    return {
        animate: createTypeState(true),
        whileInView: createTypeState(),
        whileHover: createTypeState(),
        whileTap: createTypeState(),
        whileDrag: createTypeState(),
        whileFocus: createTypeState(),
        exit: createTypeState(),
    };
}

class Feature {
    constructor(node) {
        this.isMounted = false;
        this.node = node;
    }
    update() { }
}

class AnimationFeature extends Feature {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */
    constructor(node) {
        super(node);
        node.animationState || (node.animationState = createAnimationState(node));
    }
    updateAnimationControlsSubscription() {
        const { animate } = this.node.getProps();
        if (isAnimationControls(animate)) {
            this.unmountControls = animate.subscribe(this.node);
        }
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */
    mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) {
            this.updateAnimationControlsSubscription();
        }
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 ? void 0 : _a.call(this);
    }
}

let id$1 = 0;
class ExitAnimationFeature extends Feature {
    constructor() {
        super(...arguments);
        this.id = id$1++;
    }
    update() {
        if (!this.node.presenceContext)
            return;
        const { isPresent, onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) {
            return;
        }
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) {
            exitAnimation.then(() => onExitComplete(this.id));
        }
    }
    mount() {
        const { register } = this.node.presenceContext || {};
        if (register) {
            this.unmount = register(this.id);
        }
    }
    unmount() { }
}

const animations = {
    animation: {
        Feature: AnimationFeature,
    },
    exit: {
        Feature: ExitAnimationFeature,
    },
};

const isPrimaryPointer = (event) => {
    if (event.pointerType === "mouse") {
        return typeof event.button !== "number" || event.button <= 0;
    }
    else {
        /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */
        return event.isPrimary !== false;
    }
};

function extractEventInfo(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`],
        },
    };
}
const addPointerInfo = (handler) => {
    return (event) => isPrimaryPointer(event) && handler(event, extractEventInfo(event));
};

function addDomEvent(target, eventName, handler, options = { passive: true }) {
    target.addEventListener(eventName, handler, options);
    return () => target.removeEventListener(eventName, handler);
}

function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, eventName, addPointerInfo(handler), options);
}

const distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

/**
 * @internal
 */
class PanSession {
    constructor(event, handlers, { transformPagePoint, contextWindow, dragSnapToOrigin = false } = {}) {
        /**
         * @internal
         */
        this.startEvent = null;
        /**
         * @internal
         */
        this.lastMoveEvent = null;
        /**
         * @internal
         */
        this.lastMoveEventInfo = null;
        /**
         * @internal
         */
        this.handlers = {};
        /**
         * @internal
         */
        this.contextWindow = window;
        this.updatePoint = () => {
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const info = getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = distance2D(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            const { point } = info;
            const { timestamp } = frameData;
            this.history.push({ ...point, timestamp });
            const { onStart, onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info) => {
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            frame.update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info) => {
            this.end();
            const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin)
                resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const panInfo = getPanInfo(event.type === "pointercancel"
                ? this.lastMoveEventInfo
                : transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!isPrimaryPointer(event))
            return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = extractEventInfo(event);
        const initialInfo = transformPoint(info, this.transformPagePoint);
        const { point } = initialInfo;
        const { timestamp } = frameData;
        this.history = [{ ...point, timestamp }];
        const { onSessionStart } = handlers;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        cancelFrame(this.updatePoint);
    }
}
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo({ point }, history) {
    return {
        point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    const time = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}

function createLock(name) {
    let lock = null;
    return () => {
        const openLock = () => {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const globalHorizontalLock = createLock("dragHorizontal");
const globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    let lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        const openHorizontal = globalHorizontalLock();
        const openVertical = globalVerticalLock();
        if (openHorizontal && openVertical) {
            lock = () => {
                openHorizontal();
                openVertical();
            };
        }
        else {
            // Release the locks because we don't use them
            if (openHorizontal)
                openHorizontal();
            if (openVertical)
                openVertical();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}

function isRefObject(ref) {
    return (ref &&
        typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}

const SCALE_PRECISION = 0.0001;
const SCALE_MIN = 1 - SCALE_PRECISION;
const SCALE_MAX = 1 + SCALE_PRECISION;
const TRANSLATE_PRECISION = 0.01;
const TRANSLATE_MIN = 0 - TRANSLATE_PRECISION;
const TRANSLATE_MAX = 0 + TRANSLATE_PRECISION;
function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = mixNumber$1(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    delta.translate =
        mixNumber$1(target.min, target.max, delta.origin) - delta.originPoint;
    if ((delta.scale >= SCALE_MIN && delta.scale <= SCALE_MAX) ||
        isNaN(delta.scale)) {
        delta.scale = 1.0;
    }
    if ((delta.translate >= TRANSLATE_MIN &&
        delta.translate <= TRANSLATE_MAX) ||
        isNaN(delta.translate)) {
        delta.translate = 0.0;
    }
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, { min, max }, elastic) {
    if (min !== undefined && point < min) {
        // If we have a min point defined, and this is outside of that, constrain
        point = elastic
            ? mixNumber$1(min, point, elastic.min)
            : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        // If we have a max point defined, and this is outside of that, constrain
        point = elastic
            ? mixNumber$1(max, point, elastic.max)
            : Math.min(point, max);
    }
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        [min, max] = [max, min];
    }
    return { min, max };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function calcOrigin$1(source, target) {
    let origin = 0.5;
    const sourceLength = calcLength(source);
    const targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = progress(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = progress(source.min, source.max - targetLength, target.min);
    }
    return clamp(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic(dragElastic = defaultElastic) {
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number"
        ? dragElastic
        : dragElastic[label] || 0;
}

const createAxisDelta = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
});
const createDelta = () => ({
    x: createAxisDelta(),
    y: createAxisDelta(),
});
const createAxis = () => ({ min: 0, max: 0 });
const createBox = () => ({
    x: createAxis(),
    y: createAxis(),
});

function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox({ top, left, right, bottom, }) {
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertBoxToBoundingBox({ x, y }) {
    return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
    if (!transformPoint)
        return point;
    const topLeft = transformPoint({ x: point.left, y: point.top });
    const bottomRight = transformPoint({ x: point.right, y: point.bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}

function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale({ scale, scaleX, scaleY }) {
    return (!isIdentityScale(scale) ||
        !isIdentityScale(scaleX) ||
        !isIdentityScale(scaleY));
}
function hasTransform(values) {
    return (hasScale(values) ||
        has2DTranslate(values) ||
        values.z ||
        values.rotate ||
        values.rotateX ||
        values.rotateY ||
        values.skewX ||
        values.skewY);
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}

/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, { x, y }) {
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
const TREE_SCALE_SNAP_MIN = 0.999999999999;
const TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength)
        return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for (let i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */
        const { visualElement } = node.options;
        if (visualElement &&
            visualElement.props.style &&
            visualElement.props.style.display === "contents") {
            continue;
        }
        if (isSharedTransition &&
            node.options.layoutScroll &&
            node.scroll &&
            node !== node.root) {
            transformBox(box, {
                x: -node.scroll.offset.x,
                y: -node.scroll.offset.y,
            });
        }
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && hasTransform(node.latestValues)) {
            transformBox(box, node.latestValues);
        }
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */
    if (treeScale.x < TREE_SCALE_SNAP_MAX &&
        treeScale.x > TREE_SCALE_SNAP_MIN) {
        treeScale.x = 1.0;
    }
    if (treeScale.y < TREE_SCALE_SNAP_MAX &&
        treeScale.y > TREE_SCALE_SNAP_MIN) {
        treeScale.y = 1.0;
    }
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function transformAxis(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = mixNumber$1(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function transformBox(box, transform) {
    transformAxis(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    transformAxis(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}

function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = measureViewportBox(element, transformPagePoint);
    const { scroll } = rootProjectionNode;
    if (scroll) {
        translateAxis(viewportBox.x, scroll.offset.x);
        translateAxis(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

// Fixes https://github.com/framer/motion/issues/2270
const getContextWindow = ({ current }) => {
    return current ? current.ownerDocument.defaultView : null;
};

const elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: PointerEvent
class VisualElementDragControls {
    constructor(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = { x: 0, y: 0 };
        /**
         * The permitted boundaries of travel, in pixels.
         */
        this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */
        this.elastic = createBox();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */
        const { presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false)
            return;
        const onSessionStart = (event) => {
            const { dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) {
                this.snapToCursor(extractEventInfo(event, "page").point);
            }
        };
        const onStart = (event, info) => {
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag, dragPropagation, onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock)
                    this.openGlobalLock();
                this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock)
                    return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */
            eachAxis((axis) => {
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */
                if (percent.test(current)) {
                    const { projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = calcLength(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) {
                frame.postRender(() => onDragStart(event, info));
            }
            addValueToWillChange(this.visualElement, "transform");
            const { animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info) => {
            // latestPointerEvent = event
            const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag, } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock)
                return;
            const { offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) {
                    onDirectionLock && onDirectionLock(this.currentDirection);
                }
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */
            this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */
            onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info) => this.stop(event, info);
        const resumeAnimation = () => eachAxis((axis) => {
            var _a;
            return this.getAnimationState(axis) === "paused" &&
                ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
        });
        const { dragSnapToOrigin } = this.getProps();
        this.panSession = new PanSession(originEvent, {
            onSessionStart,
            onStart,
            onMove,
            onSessionEnd,
            resumeAnimation,
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin,
            contextWindow: getContextWindow(this.visualElement),
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging)
            return;
        const { velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd } = this.getProps();
        if (onDragEnd) {
            frame.postRender(() => onDragEnd(event, info));
        }
    }
    cancel() {
        this.isDragging = false;
        const { projection, animationState } = this.visualElement;
        if (projection) {
            projection.isAnimationBlocked = false;
        }
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection))
            return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) {
            next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
        }
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints, dragElastic } = this.getProps();
        const layout = this.visualElement.projection &&
            !this.visualElement.projection.layout
            ? this.visualElement.projection.measure(false)
            : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && isRefObject(dragConstraints)) {
            if (!this.constraints) {
                this.constraints = this.resolveRefConstraints();
            }
        }
        else {
            if (dragConstraints && layout) {
                this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
            }
            else {
                this.constraints = false;
            }
        }
        this.elastic = resolveDragElastic(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */
        if (prevConstraints !== this.constraints &&
            layout &&
            this.constraints &&
            !this.hasMutatedConstraints) {
            eachAxis((axis) => {
                if (this.constraints !== false &&
                    this.getAxisMotionValue(axis)) {
                    this.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], this.constraints[axis]);
                }
            });
        }
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
        if (!constraints || !isRefObject(constraints))
            return false;
        const constraintsElement = constraints.current;
        invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout)
            return false;
        const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */
        if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = convertBoundingBoxToBox(userConstraints);
            }
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd, } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = eachAxis((axis) => {
            if (!shouldDrag(axis, drag, this.currentDirection)) {
                return;
            }
            let transition = (constraints && constraints[axis]) || {};
            if (dragSnapToOrigin)
                transition = { min: 0, max: 0 };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */
            const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness,
                bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition,
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        addValueToWillChange(this.visualElement, axis);
        return axisValue.start(animateMotionValue(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        eachAxis((axis) => this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        eachAxis((axis) => { var _a; return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause(); });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */
    getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue
            ? externalMotionValue
            : this.visualElement.getValue(axis, (props.initial
                ? props.initial[axis]
                : undefined) || 0);
    }
    snapToCursor(point) {
        eachAxis((axis) => {
            const { drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, this.currentDirection))
                return;
            const { projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min, max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - mixNumber$1(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */
    scalePositionWithinConstraints() {
        if (!this.visualElement.current)
            return;
        const { drag, dragConstraints } = this.getProps();
        const { projection } = this.visualElement;
        if (!isRefObject(dragConstraints) || !projection || !this.constraints)
            return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */
        this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */
        const boxProgress = { x: 0, y: 0 };
        eachAxis((axis) => {
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = calcOrigin$1({ min: latest, max: latest }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */
        const { transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */
        eachAxis((axis) => {
            if (!shouldDrag(axis, drag, null))
                return;
            /**
             * Calculate a new transform based on the previous box progress
             */
            const axisValue = this.getAxisMotionValue(axis);
            const { min, max } = this.constraints[axis];
            axisValue.set(mixNumber$1(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current)
            return;
        elementDragControls.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */
        const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
            const { drag, dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = () => {
            const { dragConstraints } = this.getProps();
            if (isRefObject(dragConstraints) && dragConstraints.current) {
                this.constraints = this.resolveRefConstraints();
            }
        };
        const { projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        frame.read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */
        const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */
        const stopLayoutUpdateListener = projection.addEventListener("didUpdate", (({ delta, hasLayoutChanged }) => {
            if (this.isDragging && hasLayoutChanged) {
                eachAxis((axis) => {
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue)
                        return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        }));
        return () => {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true, } = props;
        return {
            ...props,
            drag,
            dragDirectionLock,
            dragPropagation,
            dragConstraints,
            dragElastic,
            dragMomentum,
        };
    }
}
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}

class DragGesture extends Feature {
    constructor(node) {
        super(node);
        this.removeGroupControls = noop;
        this.removeListeners = noop;
        this.controls = new VisualElementDragControls(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls } = this.node.getProps();
        if (dragControls) {
            this.removeGroupControls = dragControls.subscribe(this.controls);
        }
        this.removeListeners = this.controls.addListeners() || noop;
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

const asyncHandler = (handler) => (event, info) => {
    if (handler) {
        frame.postRender(() => handler(event, info));
    }
};
class PanGesture extends Feature {
    constructor() {
        super(...arguments);
        this.removePointerDownListener = noop;
    }
    onPointerDown(pointerDownEvent) {
        this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: getContextWindow(this.node),
        });
    }
    createPanHandlers() {
        const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
        return {
            onSessionStart: asyncHandler(onPanSessionStart),
            onStart: asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info) => {
                delete this.session;
                if (onPanEnd) {
                    frame.postRender(() => onPanEnd(event, info));
                }
            },
        };
    }
    mount() {
        this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

/**
 * @public
 */
const PresenceContext = createContext(null);

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
    const context = useContext(PresenceContext);
    if (context === null)
        return [true, null];
    const { isPresent, onExitComplete, register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = useId$1();
    useEffect(() => register(id), []);
    const safeToRemove = useCallback(() => onExitComplete && onExitComplete(id), [id, onExitComplete]);
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}

const LayoutGroupContext = createContext({});

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = createContext({});

/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */
const globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */
    hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */
    hasEverUpdated: false,
};

function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min)
        return 0;
    return (pixels / (axis.max - axis.min)) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
const correctBorderRadius = {
    correct: (latest, node) => {
        if (!node.target)
            return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */
        if (typeof latest === "string") {
            if (px.test(latest)) {
                latest = parseFloat(latest);
            }
            else {
                return latest;
            }
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */
        const x = pixelsToPercent(latest, node.target.x);
        const y = pixelsToPercent(latest, node.target.y);
        return `${x}% ${y}%`;
    },
};

const correctBoxShadow = {
    correct: (latest, { treeScale, projectionDelta }) => {
        const original = latest;
        const shadow = complex.parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5)
            return original;
        const template = complex.createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */
        const averageScale = mixNumber$1(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number")
            shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number")
            shadow[3 + offset] /= averageScale;
        return template(shadow);
    },
};

const scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}

const { schedule: microtask, cancel: cancelMicrotask } = createRenderBatcher(queueMicrotask, false);

class MeasureLayoutWithContext extends Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */
    componentDidMount() {
        const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
        const { projection } = visualElement;
        addScaleCorrector(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group)
                layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
                switchLayoutGroup.register(projection);
            }
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", () => {
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: () => this.safeToRemove(),
            });
        }
        globalProjectionState.hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency, visualElement, drag, isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection)
            return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */
        projection.isPresent = isPresent;
        if (drag ||
            prevProps.layoutDependency !== layoutDependency ||
            layoutDependency === undefined) {
            projection.willUpdate();
        }
        else {
            this.safeToRemove();
        }
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) {
                projection.promote();
            }
            else if (!projection.relegate()) {
                /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */
                frame.postRender(() => {
                    const stack = projection.getStack();
                    if (!stack || !stack.members.length) {
                        this.safeToRemove();
                    }
                });
            }
        }
        return null;
    }
    componentDidUpdate() {
        const { projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            microtask.postRender(() => {
                if (!projection.currentAnimation && projection.isLead()) {
                    this.safeToRemove();
                }
            });
        }
    }
    componentWillUnmount() {
        const { visualElement, layoutGroup, switchLayoutGroup: promoteContext, } = this.props;
        const { projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group)
                layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister)
                promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function MeasureLayout(props) {
    const [isPresent, safeToRemove] = usePresence();
    const layoutGroup = useContext(LayoutGroupContext);
    return (jsx(MeasureLayoutWithContext, { ...props, layoutGroup: layoutGroup, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent: isPresent, safeToRemove: safeToRemove }));
}
const defaultScaleCorrectors = {
    borderRadius: {
        ...correctBorderRadius,
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ],
    },
    borderTopLeftRadius: correctBorderRadius,
    borderTopRightRadius: correctBorderRadius,
    borderBottomLeftRadius: correctBorderRadius,
    borderBottomRightRadius: correctBorderRadius,
    boxShadow: correctBoxShadow,
};

const borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
const numBorders = borders.length;
const asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
const isPx = (value) => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = mixNumber$1(0, 
        // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
        target.opacityExit = mixNumber$1(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
    }
    else if (isOnlyMember) {
        target.opacity = mixNumber$1(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    }
    /**
     * Mix border radius
     */
    for (let i = 0; i < numBorders; i++) {
        const borderLabel = `border${borders[i]}Radius`;
        let followRadius = getRadius(follow, borderLabel);
        let leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined)
            continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 ||
            leadRadius === 0 ||
            isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max(mixNumber$1(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if (percent.test(leadRadius) || percent.test(followRadius)) {
                target[borderLabel] += "%";
            }
        }
        else {
            target[borderLabel] = leadRadius;
        }
    }
    /**
     * Mix rotation
     */
    if (follow.rotate || lead.rotate) {
        target.rotate = mixNumber$1(follow.rotate || 0, lead.rotate || 0, progress);
    }
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined
        ? values[radiusName]
        : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const easeCrossfadeIn = /*@__PURE__*/ compress(0, 0.5, circOut);
const easeCrossfadeOut = /*@__PURE__*/ compress(0.5, 0.95, noop);
function compress(min, max, easing) {
    return (p) => {
        // Could replace ifs with clamp
        if (p < min)
            return 0;
        if (p > max)
            return 1;
        return easing(progress(min, max, p));
    };
}

/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisDeltaInto(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if (percent.test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = mixNumber$1(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number")
        return;
    let originPoint = mixNumber$1(originAxis.min, originAxis.max, origin);
    if (axis === originAxis)
        originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys = ["x", "scaleX", "originX"];
const yKeys = ["y", "scaleY", "originY"];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function axisEquals(a, b) {
    return a.min === b.min && a.max === b.max;
}
function boxEquals(a, b) {
    return axisEquals(a.x, b.x) && axisEquals(a.y, b.y);
}
function axisEqualsRounded(a, b) {
    return (Math.round(a.min) === Math.round(b.min) &&
        Math.round(a.max) === Math.round(b.max));
}
function boxEqualsRounded(a, b) {
    return axisEqualsRounded(a.x, b.x) && axisEqualsRounded(a.y, b.y);
}
function aspectRatio(box) {
    return calcLength(box.x) / calcLength(box.y);
}
function axisDeltaEquals(a, b) {
    return (a.translate === b.translate &&
        a.scale === b.scale &&
        a.originPoint === b.originPoint);
}

class NodeStack {
    constructor() {
        this.members = [];
    }
    add(node) {
        addUniqueItem(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        removeItem(this.members, node);
        if (node === this.prevLead) {
            this.prevLead = undefined;
        }
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) {
                this.promote(prevLead);
            }
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member) => node === member);
        if (indexOfNode === 0)
            return false;
        /**
         * Find the next projection node that is present
         */
        let prevLead;
        for (let i = indexOfNode; i >= 0; i--) {
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        }
        else {
            return false;
        }
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead)
            return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) {
                node.resumeFrom.preserveOpacity = true;
            }
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues =
                    prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) {
                node.isLayoutDirty = true;
            }
            const { crossfade } = node.options;
            if (crossfade === false) {
                prevLead.hide();
            }
            /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */
        }
    }
    exitAnimationComplete() {
        this.members.forEach((node) => {
            const { options, resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) {
                resumingFrom.options.onExitComplete &&
                    resumingFrom.options.onExitComplete();
            }
        });
    }
    scheduleRender() {
        this.members.forEach((node) => {
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */
    removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) {
            this.lead.snapshot = undefined;
        }
    }
}

function buildProjectionTransform(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */
    const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) {
        transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    }
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */
    if (treeScale.x !== 1 || treeScale.y !== 1) {
        transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    }
    if (latestTransform) {
        const { transformPerspective, rotate, rotateX, rotateY, skewX, skewY } = latestTransform;
        if (transformPerspective)
            transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate)
            transform += `rotate(${rotate}deg) `;
        if (rotateX)
            transform += `rotateX(${rotateX}deg) `;
        if (rotateY)
            transform += `rotateY(${rotateY}deg) `;
        if (skewX)
            transform += `skewX(${skewX}deg) `;
        if (skewY)
            transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */
    const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) {
        transform += `scale(${elementScaleX}, ${elementScaleY})`;
    }
    return transform || "none";
}

const compareByDepth = (a, b) => a.depth - b.depth;

class FlatTree {
    constructor() {
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        addUniqueItem(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        removeItem(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort(compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
    const unwrappedValue = isMotionValue(value) ? value.get() : value;
    return isCustomValue(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
    const start = time.now();
    const checkElapsed = ({ timestamp }) => {
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            cancelFrame(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    frame.read(checkElapsed, true);
    return () => cancelFrame(checkElapsed);
}

function isSVGElement(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

function animateSingleValue(value, keyframes, options) {
    const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
    motionValue$1.start(animateMotionValue("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

const metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0,
};
const isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const transformAxes = ["", "X", "Y", "Z"];
const hiddenVisibility = { visibility: "hidden" };
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */
const animationTarget = 1000;
let id = 0;
function resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) {
            sharedAnimationValues[key] = 0;
        }
    }
}
function cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode)
        return;
    const { visualElement } = projectionNode.options;
    if (!visualElement)
        return;
    const appearId = getOptimisedAppearId(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout, layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", frame, !(layout || layoutId));
    }
    const { parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) {
        cancelTreeOptimisedTransformAnimations(parent);
    }
}
function createProjectionNode$1({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform, }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
            /**
             * A unique ID generated for every projection node.
             */
            this.id = id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */
            this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */
            this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */
            this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */
            this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */
            this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */
            this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */
            this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */
            this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */
            this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */
            this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */
            this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */
            this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */
            this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */
            this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */
            this.treeScale = { x: 1, y: 1 };
            /**
             *
             */
            this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = () => this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = () => {
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */
            this.updateProjection = () => {
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */
                if (isDebug) {
                    metrics.totalNodes =
                        metrics.resolvedTargetDeltas =
                            metrics.recalculatedProjection =
                                0;
                }
                this.nodes.forEach(propagateDirtyNodes);
                this.nodes.forEach(resolveTargetDelta);
                this.nodes.forEach(calcProjection);
                this.nodes.forEach(cleanDirtyNodes);
                if (isDebug) {
                    window.MotionDebug.record(metrics);
                }
            };
            /**
             * Frame calculations
             */
            this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */
            // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [...parent.path, parent] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for (let i = 0; i < this.path.length; i++) {
                this.path[i].shouldResetTransform = true;
            }
            if (this.root === this)
                this.nodes = new FlatTree();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) {
                this.eventHandlers.set(name, new SubscriptionManager());
            }
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */
        mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance)
                return;
            this.isSVG = isSVGElement(instance);
            this.instance = instance;
            const { layoutId, layout, visualElement } = this.options;
            if (visualElement && !visualElement.current) {
                visualElement.mount(instance);
            }
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) {
                this.isLayoutDirty = true;
            }
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = () => (this.root.updateBlockedByResize = false);
                attachResizeListener(instance, () => {
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = delay(resizeUnblockUpdate, 250);
                    if (globalProjectionState.hasAnimatedSinceResize) {
                        globalProjectionState.hasAnimatedSinceResize = false;
                        this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) {
                this.root.registerSharedNode(layoutId, this);
            }
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false &&
                visualElement &&
                (layoutId || layout)) {
                this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout, }) => {
                    if (this.isTreeAnimationBlocked()) {
                        this.target = undefined;
                        this.relativeTarget = undefined;
                        return;
                    }
                    // TODO: Check here if an animation exists
                    const layoutTransition = this.options.transition ||
                        visualElement.getDefaultTransition() ||
                        defaultLayoutTransition;
                    const { onLayoutAnimationStart, onLayoutAnimationComplete, } = visualElement.getProps();
                    /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */
                    const targetChanged = !this.targetLayout ||
                        !boxEqualsRounded(this.targetLayout, newLayout) ||
                        hasRelativeTargetChanged;
                    /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */
                    const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                    if (this.options.layoutRoot ||
                        (this.resumeFrom && this.resumeFrom.instance) ||
                        hasOnlyRelativeTargetChanged ||
                        (hasLayoutChanged &&
                            (targetChanged || !this.currentAnimation))) {
                        if (this.resumeFrom) {
                            this.resumingFrom = this.resumeFrom;
                            this.resumingFrom.resumingFrom = undefined;
                        }
                        this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        const animationOptions = {
                            ...getValueTransition(layoutTransition, "layout"),
                            onPlay: onLayoutAnimationStart,
                            onComplete: onLayoutAnimationComplete,
                        };
                        if (visualElement.shouldReduceMotion ||
                            this.options.layoutRoot) {
                            animationOptions.delay = 0;
                            animationOptions.type = false;
                        }
                        this.startAnimation(animationOptions);
                    }
                    else {
                        /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */
                        if (!hasLayoutChanged) {
                            finishAnimation(this);
                        }
                        if (this.isLead() && this.options.onExitComplete) {
                            this.options.onExitComplete();
                        }
                    }
                    this.targetLayout = newLayout;
                });
            }
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            cancelFrame(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return (this.isAnimationBlocked ||
                (this.parent && this.parent.isTreeAnimationBlocked()) ||
                false);
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked())
                return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach(resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */
            if (window.MotionCancelOptimisedAnimation &&
                !this.hasCheckedOptimisedAppear) {
                cancelTreeOptimisedTransformAnimations(this);
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty)
                return;
            this.isLayoutDirty = true;
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) {
                    node.willUpdate(false);
                }
            }
            const { layoutId, layout } = this.options;
            if (layoutId === undefined && !layout)
                return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate
                ? transformTemplate(this.latestValues, "")
                : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating) {
                this.nodes.forEach(clearIsLayoutDirty);
            }
            this.isUpdating = false;
            /**
             * Write
             */
            this.nodes.forEach(resetTransformStyle);
            /**
             * Read ==================
             */
            // Update layout measurements of updated children
            this.nodes.forEach(updateLayout);
            /**
             * Write
             */
            // Notify listeners that the layout is updated
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */
            const now = time.now();
            frameData.delta = clamp(0, 1000 / 60, now - frameData.timestamp);
            frameData.timestamp = now;
            frameData.isProcessing = true;
            frameSteps.update.process(frameData);
            frameSteps.preRender.process(frameData);
            frameSteps.render.process(frameData);
            frameData.isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                microtask.read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                frame.preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */
            frame.postRender(() => {
                if (this.isLayoutDirty) {
                    this.root.didUpdate();
                }
                else {
                    this.root.checkUpdateFailed();
                }
            });
        }
        /**
         * Update measurements
         */
        updateSnapshot() {
            if (this.snapshot || !this.instance)
                return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance)
                return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) &&
                !this.isLayoutDirty) {
                return;
            }
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */
            if (this.resumeFrom && !this.resumeFrom.instance) {
                for (let i = 0; i < this.path.length; i++) {
                    const node = this.path[i];
                    node.updateScroll();
                }
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = createBox();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement } = this.options;
            visualElement &&
                visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll &&
                this.scroll.animationId === this.root.animationId &&
                this.scroll.phase === phase) {
                needsMeasurement = false;
            }
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase,
                    isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot,
                };
            }
        }
        resetTransform() {
            if (!resetTransform)
                return;
            const isResetRequested = this.isLayoutDirty ||
                this.shouldResetTransform ||
                this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate
                ? transformTemplate(this.latestValues, "")
                : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested &&
                (hasProjection ||
                    hasTransform(this.latestValues) ||
                    transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */
            if (removeTransform) {
                layoutBox = this.removeTransform(layoutBox);
            }
            roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox,
                latestValues: {},
                source: this.id,
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement } = this.options;
            if (!visualElement)
                return createBox();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some(checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll } = this.root;
                if (scroll) {
                    translateAxis(box.x, scroll.offset.x);
                    translateAxis(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = createBox();
            copyBoxInto(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) {
                return boxWithoutScroll;
            }
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                const { scroll, options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */
                    if (scroll.wasRoot) {
                        copyBoxInto(boxWithoutScroll, box);
                    }
                    translateAxis(boxWithoutScroll.x, scroll.offset.x);
                    translateAxis(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = createBox();
            copyBoxInto(withTransforms, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!transformOnly &&
                    node.options.layoutScroll &&
                    node.scroll &&
                    node !== node.root) {
                    transformBox(withTransforms, {
                        x: -node.scroll.offset.x,
                        y: -node.scroll.offset.y,
                    });
                }
                if (!hasTransform(node.latestValues))
                    continue;
                transformBox(withTransforms, node.latestValues);
            }
            if (hasTransform(this.latestValues)) {
                transformBox(withTransforms, this.latestValues);
            }
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = createBox();
            copyBoxInto(boxWithoutTransform, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!node.instance)
                    continue;
                if (!hasTransform(node.latestValues))
                    continue;
                hasScale(node.latestValues) && node.updateSnapshot();
                const sourceBox = createBox();
                const nodeBox = node.measurePageBox();
                copyBoxInto(sourceBox, nodeBox);
                removeBoxTransforms(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if (hasTransform(this.latestValues)) {
                removeBoxTransforms(boxWithoutTransform, this.latestValues);
            }
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true,
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent)
                return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */
            if (this.relativeParent.resolvedRelativeTargetAt !==
                frameData.timestamp) {
                this.relativeParent.resolveTargetDelta(true);
            }
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */
            const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */
            const canSkip = !(forceRecalculation ||
                (isShared && this.isSharedProjectionDirty) ||
                this.isProjectionDirty ||
                ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) ||
                this.attemptToResolveRelativeTarget ||
                this.root.updateBlockedByResize);
            if (canSkip)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */
            if (!this.layout || !(layout || layoutId))
                return;
            this.resolvedRelativeTargetAt = frameData.timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */
            if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent &&
                    relativeParent.layout &&
                    this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */
            if (!this.relativeTarget && !this.targetDelta)
                return;
            /**
             * Lazy-init target data structure
             */
            if (!this.target) {
                this.target = createBox();
                this.targetWithTransforms = createBox();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */
            if (this.relativeTarget &&
                this.relativeTargetOrigin &&
                this.relativeParent &&
                this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
                /**
                 * If we've only got a targetDelta, resolve it into a target
                 */
            }
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) {
                    // TODO: This is creating a new object every frame
                    this.target = this.applyTransform(this.layout.layoutBox);
                }
                else {
                    copyBoxInto(this.target, this.layout.layoutBox);
                }
                applyBoxDelta(this.target, this.targetDelta);
            }
            else {
                /**
                 * If no target, use own layout as target
                 */
                copyBoxInto(this.target, this.layout.layoutBox);
            }
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */
            if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent &&
                    Boolean(relativeParent.resumingFrom) ===
                        Boolean(this.resumingFrom) &&
                    !relativeParent.options.layoutScroll &&
                    relativeParent.target &&
                    this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
            /**
             * Increase debug counter for resolved target deltas
             */
            if (isDebug) {
                metrics.resolvedTargetDeltas++;
            }
        }
        getClosestProjectingParent() {
            if (!this.parent ||
                hasScale(this.parent.latestValues) ||
                has2DTranslate(this.parent.latestValues)) {
                return undefined;
            }
            if (this.parent.isProjecting()) {
                return this.parent;
            }
            else {
                return this.parent.getClosestProjectingParent();
            }
        }
        isProjecting() {
            return Boolean((this.relativeTarget ||
                this.targetDelta ||
                this.options.layoutRoot) &&
                this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */
            if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
                canSkip = false;
            }
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */
            if (isShared &&
                (this.isSharedProjectionDirty || this.isTransformDirty)) {
                canSkip = false;
            }
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */
            if (this.resolvedRelativeTargetAt === frameData.timestamp) {
                canSkip = false;
            }
            if (canSkip)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */
            this.isTreeAnimating = Boolean((this.parent && this.parent.isTreeAnimating) ||
                this.currentAnimation ||
                this.pendingAnimation);
            if (!this.isTreeAnimating) {
                this.targetDelta = this.relativeTarget = undefined;
            }
            if (!this.layout || !(layout || layoutId))
                return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */
            copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */
            applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */
            if (lead.layout &&
                !lead.target &&
                (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = createBox();
            }
            const { target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */
                if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) {
                this.createProjectionDeltas();
            }
            else {
                copyAxisDeltaInto(this.prevProjectionDelta.x, this.projectionDelta.x);
                copyAxisDeltaInto(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX ||
                this.treeScale.y !== prevTreeScaleY ||
                !axisDeltaEquals(this.projectionDelta.x, this.prevProjectionDelta.x) ||
                !axisDeltaEquals(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */
            if (isDebug) {
                metrics.recalculatedProjection++;
            }
        }
        hide() {
            this.isVisible = false;
            // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
            // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) {
                this.resumingFrom = undefined;
            }
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = createDelta();
            this.projectionDelta = createDelta();
            this.projectionDeltaWithTransform = createDelta();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot
                ? snapshot.latestValues
                : {};
            const mixedValues = { ...this.latestValues };
            const targetDelta = createDelta();
            if (!this.relativeParent ||
                !this.relativeParent.options.layoutRoot) {
                this.relativeTarget = this.relativeTargetOrigin = undefined;
            }
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = createBox();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation &&
                !isOnlyMember &&
                this.options.crossfade === true &&
                !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest) => {
                const progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget &&
                    this.relativeTargetOrigin &&
                    this.layout &&
                    this.relativeParent &&
                    this.relativeParent.layout) {
                    calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */
                    if (prevRelativeTarget &&
                        boxEquals(this.relativeTarget, prevRelativeTarget)) {
                        this.isProjectionDirty = false;
                    }
                    if (!prevRelativeTarget)
                        prevRelativeTarget = createBox();
                    copyBoxInto(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) {
                this.resumingFrom.currentAnimation.stop();
            }
            if (this.pendingAnimation) {
                cancelFrame(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */
            this.pendingAnimation = frame.update(() => {
                globalProjectionState.hasAnimatedSinceResize = true;
                this.currentAnimation = animateSingleValue(0, animationTarget, {
                    ...options,
                    onUpdate: (latest) => {
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: () => {
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    },
                });
                if (this.resumingFrom) {
                    this.resumingFrom.currentAnimation = this.currentAnimation;
                }
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom =
                this.currentAnimation =
                    this.animationValues =
                        undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta(animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms, target, layout, latestValues } = lead;
            if (!targetWithTransforms || !target || !layout)
                return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */
            if (this !== lead &&
                this.layout &&
                layout &&
                shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || createBox();
                const xLength = calcLength(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = calcLength(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            copyBoxInto(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */
            transformBox(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */
            calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) {
                this.sharedNodes.set(layoutId, new NodeStack());
            }
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity
                    ? config.shouldPreserveFollowOpacity(node)
                    : undefined,
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId } = this.options;
            if (layoutId)
                return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset, transition, preserveFollowOpacity, } = {}) {
            const stack = this.getStack();
            if (stack)
                stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition)
                this.setOptions({ transition });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) {
                return stack.relegate(this);
            }
            else {
                return false;
            }
        }
        resetSkewAndRotation() {
            const { visualElement } = this.options;
            if (!visualElement)
                return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */
            const { latestValues } = visualElement;
            if (latestValues.z ||
                latestValues.rotate ||
                latestValues.rotateX ||
                latestValues.rotateY ||
                latestValues.rotateZ ||
                latestValues.skewX ||
                latestValues.skewY) {
                hasDistortingTransform = true;
            }
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform)
                return;
            const resetValues = {};
            if (latestValues.z) {
                resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            }
            // Check the skew and rotate value of all axes and reset to 0
            for (let i = 0; i < transformAxes.length; i++) {
                resetDistortingTransform(`rotate${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                resetDistortingTransform(`skew${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for (const key in resetValues) {
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) {
                    this.animationValues[key] = resetValues[key];
                }
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG)
                return undefined;
            if (!this.isVisible) {
                return hiddenVisibility;
            }
            const styles = {
                visibility: "",
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents =
                    resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate
                    ? transformTemplate(this.latestValues, "")
                    : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity =
                        this.latestValues.opacity !== undefined
                            ? this.latestValues.opacity
                            : 1;
                    emptyStyles.pointerEvents =
                        resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !hasTransform(this.latestValues)) {
                    emptyStyles.transform = transformTemplate
                        ? transformTemplate({}, "")
                        : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) {
                styles.transform = transformTemplate(valuesToRender, styles.transform);
            }
            const { x, y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) {
                /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */
                styles.opacity =
                    lead === this
                        ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1
                        : this.preserveOpacity
                            ? this.latestValues.opacity
                            : valuesToRender.opacityExit;
            }
            else {
                /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */
                styles.opacity =
                    lead === this
                        ? valuesToRender.opacity !== undefined
                            ? valuesToRender.opacity
                            : ""
                        : valuesToRender.opacityExit !== undefined
                            ? valuesToRender.opacityExit
                            : 0;
            }
            /**
             * Apply scale correction
             */
            for (const key in scaleCorrectors) {
                if (valuesToRender[key] === undefined)
                    continue;
                const { correct, applyTo } = scaleCorrectors[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */
                const corrected = styles.transform === "none"
                    ? valuesToRender[key]
                    : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for (let i = 0; i < num; i++) {
                        styles[applyTo[i]] = corrected;
                    }
                }
                else {
                    styles[key] = corrected;
                }
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */
            if (this.options.layoutId) {
                styles.pointerEvents =
                    lead === this
                        ? resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || ""
                        : "none";
            }
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node) => { var _a; return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop(); });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() &&
        node.layout &&
        snapshot &&
        node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(axisSnapshot);
                axisSnapshot.min = layout[axis].min;
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(layout[axis]);
                axisSnapshot.max = axisSnapshot.min + length;
                /**
                 * Ensure relative target gets resized and rerendererd
                 */
                if (node.relativeTarget && !node.currentAnimation) {
                    node.isProjectionDirty = true;
                    node.relativeTarget[axis].max =
                        node.relativeTarget[axis].min + length;
                }
            });
        }
        const layoutDelta = createDelta();
        calcBoxDelta(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = createDelta();
        if (isShared) {
            calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        }
        else {
            calcBoxDelta(visualDelta, layout, snapshot.layoutBox);
        }
        const hasLayoutChanged = !isDeltaZero(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */
            if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = createBox();
                    calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = createBox();
                    calcRelativePosition(relativeLayout, layout, parentLayout.layoutBox);
                    if (!boxEqualsRounded(relativeSnapshot, relativeLayout)) {
                        hasRelativeTargetChanged = true;
                    }
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout,
            snapshot,
            delta: visualDelta,
            layoutDelta,
            hasLayoutChanged,
            hasRelativeTargetChanged,
        });
    }
    else if (node.isLead()) {
        const { onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */
    node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */
    if (isDebug) {
        metrics.totalNodes++;
    }
    if (!node.parent)
        return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */
    if (!node.isProjecting()) {
        node.isProjectionDirty = node.parent.isProjectionDirty;
    }
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */
    node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty ||
        node.parent.isProjectionDirty ||
        node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function cleanDirtyNodes(node) {
    node.isProjectionDirty =
        node.isSharedProjectionDirty =
            node.isTransformDirty =
                false;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function resetTransformStyle(node) {
    const { visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
        visualElement.notify("BeforeLayoutMeasure");
    }
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = mixNumber$1(delta.translate, 0, p);
    output.scale = mixNumber$1(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = mixNumber$1(from.min, to.min, p);
    output.max = mixNumber$1(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return (node.animationValues && node.animationValues.opacityExit !== undefined);
}
const defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
const userAgentContains = (string) => typeof navigator !== "undefined" &&
    navigator.userAgent &&
    navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */
const roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/")
    ? Math.round
    : noop;
function roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = roundPoint(axis.min);
    axis.max = roundPoint(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return (animationType === "position" ||
        (animationType === "preserve-aspect" &&
            !isNear(aspectRatio(snapshot), aspectRatio(layout), 0.2)));
}
function checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}

const DocumentProjectionNode = createProjectionNode$1({
    attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
    measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }),
    checkIsScrollRoot: () => true,
});

const rootProjectionNode = {
    current: undefined,
};
const HTMLProjectionNode = createProjectionNode$1({
    measureScroll: (instance) => ({
        x: instance.scrollLeft,
        y: instance.scrollTop,
    }),
    defaultParent: () => {
        if (!rootProjectionNode.current) {
            const documentNode = new DocumentProjectionNode({});
            documentNode.mount(window);
            documentNode.setOptions({ layoutScroll: true });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: (instance, value) => {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed"),
});

const drag = {
    pan: {
        Feature: PanGesture,
    },
    drag: {
        Feature: DragGesture,
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};

function addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info) => {
        if (event.pointerType === "touch" || isDragActive())
            return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) {
            node.animationState.setActive("whileHover", isActive);
        }
        const callback = props[callbackName];
        if (callback) {
            frame.postRender(() => callback(event, info));
        }
    };
    return addPointerEvent(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName],
    });
}
class HoverGesture extends Feature {
    mount() {
        this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
    }
    unmount() { }
}

class FocusGesture extends Feature {
    constructor() {
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */
        try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        }
        catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState)
            return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState)
            return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
    }
    unmount() { }
}

/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
const isNodeOrChild = (parent, child) => {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};

function fireSyntheticPointerEvent(name, handler) {
    if (!handler)
        return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
class PressGesture extends Feature {
    constructor() {
        super(...arguments);
        this.removeStartListeners = noop;
        this.removeEndListeners = noop;
        this.removeAccessibleListeners = noop;
        this.startPointerPress = (startEvent, startInfo) => {
            if (this.isPressing)
                return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo) => {
                if (!this.checkPressEnd())
                    return;
                const { onTap, onTapCancel, globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */
                const handler = !globalTapTarget &&
                    !isNodeOrChild(this.node.current, endEvent.target)
                    ? onTapCancel
                    : onTap;
                if (handler) {
                    frame.update(() => handler(endEvent, endInfo));
                }
            };
            const removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"]),
            });
            const removePointerCancelListener = addPointerEvent(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel ||
                    props["onPointerCancel"]),
            });
            this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = () => {
            const handleKeydown = (keydownEvent) => {
                if (keydownEvent.key !== "Enter" || this.isPressing)
                    return;
                const handleKeyup = (keyupEvent) => {
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd())
                        return;
                    fireSyntheticPointerEvent("up", (event, info) => {
                        const { onTap } = this.node.getProps();
                        if (onTap) {
                            frame.postRender(() => onTap(event, info));
                        }
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = addDomEvent(this.node.current, "keyup", handleKeyup);
                fireSyntheticPointerEvent("down", (event, info) => {
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = addDomEvent(this.node.current, "keydown", handleKeydown);
            const handleBlur = () => {
                if (!this.isPressing)
                    return;
                fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = addDomEvent(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart, whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */
        if (whileTap && this.node.animationState) {
            this.node.animationState.setActive("whileTap", true);
        }
        if (onTapStart) {
            frame.postRender(() => onTapStart(event, info));
        }
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) {
            this.node.animationState.setActive("whileTap", false);
        }
        return !isDragActive();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd())
            return;
        const { onTapCancel } = this.node.getProps();
        if (onTapCancel) {
            frame.postRender(() => onTapCancel(event, info));
        }
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = addPointerEvent(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart ||
                props["onPointerStart"]),
        });
        const removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}

/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */
const observers = new WeakMap();
const fireObserverCallback = (entry) => {
    const callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const fireAllObserverCallbacks = (entries) => {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */
    if (!observers.has(lookupRoot)) {
        observers.set(lookupRoot, {});
    }
    const rootObservers = observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */
    if (!rootObservers[key]) {
        rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root, ...options });
    }
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    const rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return () => {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

const thresholdNames = {
    some: 0,
    all: 1,
};
class InViewFeature extends Feature {
    constructor() {
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport = {} } = this.node.getProps();
        const { root, margin: rootMargin, amount = "some", once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount],
        };
        const onIntersectionUpdate = (entry) => {
            const { isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */
            if (this.isInView === isIntersecting)
                return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */
            if (once && !isIntersecting && this.hasEnteredView) {
                return;
            }
            else if (isIntersecting) {
                this.hasEnteredView = true;
            }
            if (this.node.animationState) {
                this.node.animationState.setActive("whileInView", isIntersecting);
            }
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */
            const { onViewportEnter, onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return observeIntersection(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined")
            return;
        const { props, prevProps } = this.node;
        const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) {
            this.startObserver();
        }
    }
    unmount() { }
}
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name) => viewport[name] !== prevViewport[name];
}

const gestureAnimations = {
    inView: {
        Feature: InViewFeature,
    },
    tap: {
        Feature: PressGesture,
    },
    focus: {
        Feature: FocusGesture,
    },
    hover: {
        Feature: HoverGesture,
    },
};

const layout = {
    layout: {
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};

/**
 * @public
 */
const MotionConfigContext = createContext({
    transformPagePoint: (p) => p,
    isStatic: false,
    reducedMotion: "never",
});

const MotionContext = createContext({});

const isBrowser$1 = typeof window !== "undefined";

const useIsomorphicLayoutEffect = isBrowser$1 ? useLayoutEffect : useEffect;

const LazyContext = createContext({ strict: false });

function useVisualElement(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = useContext(MotionContext);
    const lazyContext = useContext(LazyContext);
    const presenceContext = useContext(PresenceContext);
    const reducedMotionConfig = useContext(MotionConfigContext).reducedMotion;
    const visualElementRef = useRef();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */
    createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState,
            parent,
            props,
            presenceContext,
            blockInitialAnimation: presenceContext
                ? presenceContext.initial === false
                : false,
            reducedMotionConfig,
        });
    }
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */
    const initialLayoutGroupConfig = useContext(SwitchLayoutGroupContext);
    if (visualElement &&
        !visualElement.projection &&
        ProjectionNodeConstructor &&
        (visualElement.type === "html" || visualElement.type === "svg")) {
        createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    }
    const isMounted = useRef(false);
    useInsertionEffect$1(() => {
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */
        if (visualElement && isMounted.current) {
            visualElement.update(props, presenceContext);
        }
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */
    const optimisedAppearId = props[optimizedAppearDataAttribute];
    const wantsHandoff = useRef(Boolean(optimisedAppearId) &&
        !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) &&
        ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    useIsomorphicLayoutEffect(() => {
        if (!visualElement)
            return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        microtask.render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */
        if (wantsHandoff.current && visualElement.animationState) {
            visualElement.animationState.animateChanges();
        }
    });
    useEffect(() => {
        if (!visualElement)
            return;
        if (!wantsHandoff.current && visualElement.animationState) {
            visualElement.animationState.animateChanges();
        }
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(() => {
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId, layout, drag, dragConstraints, layoutScroll, layoutRoot, } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"]
        ? undefined
        : getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId,
        layout,
        alwaysMeasureLayout: Boolean(drag) || (dragConstraints && isRefObject(dragConstraints)),
        visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig,
        layoutScroll,
        layoutRoot,
    });
}
function getClosestProjectingNode(visualElement) {
    if (!visualElement)
        return undefined;
    return visualElement.options.allowProjection !== false
        ? visualElement.projection
        : getClosestProjectingNode(visualElement.parent);
}

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
    return useCallback((instance) => {
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) {
                visualElement.mount(instance);
            }
            else {
                visualElement.unmount();
            }
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    }, 
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]);
}

function isControllingVariants(props) {
    return (isAnimationControls(props.animate) ||
        variantProps.some((name) => isVariantLabel(props[name])));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

function getCurrentTreeVariants(props, context) {
    if (isControllingVariants(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}

function useCreateMotionContext(props) {
    const { initial, animate } = getCurrentTreeVariants(props, useContext(MotionContext));
    return useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

const featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag",
    ],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"],
};
const featureDefinitions = {};
for (const key in featureProps) {
    featureDefinitions[key] = {
        isEnabled: (props) => featureProps[key].some((name) => !!props[name]),
    };
}

function loadFeatures(features) {
    for (const key in features) {
        featureDefinitions[key] = {
            ...featureDefinitions[key],
            ...features[key],
        };
    }
}

const motionComponentSymbol = Symbol.for("motionComponentSymbol");

/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */
function createRendererMotionComponent({ preloadedFeatures, createVisualElement, useRender, useVisualState, Component, }) {
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */
        let MeasureLayout;
        const configAndProps = {
            ...useContext(MotionConfigContext),
            ...props,
            layoutId: useLayoutId(props),
        };
        const { isStatic } = configAndProps;
        const context = useCreateMotionContext(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && isBrowser$1) {
            useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */
            context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */
        return (jsxs(MotionContext.Provider, { value: context, children: [MeasureLayout && context.visualElement ? (jsx(MeasureLayout, { visualElement: context.visualElement, ...configAndProps })) : null, useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)] }));
    }
    const ForwardRefMotionComponent = forwardRef(MotionComponent);
    ForwardRefMotionComponent[motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function useLayoutId({ layoutId }) {
    const layoutGroupId = useContext(LayoutGroupContext).id;
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}
function useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = useContext(LazyContext).strict;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */
    if (process.env.NODE_ENV !== "production" &&
        preloadedFeatures &&
        isStrict) {
        const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
        configAndProps.ignoreStrict
            ? warning(false, strictMessage)
            : invariant(false, strictMessage);
    }
}
function getProjectionFunctionality(props) {
    const { drag, layout } = featureDefinitions;
    if (!drag && !layout)
        return {};
    const combined = { ...drag, ...layout };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props))
            ? combined.MeasureLayout
            : undefined,
        ProjectionNode: combined.ProjectionNode,
    };
}

/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
const lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view",
];

function isSVGComponent(Component) {
    if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component !== "string" ||
        /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */
        Component.includes("-")) {
        return false;
    }
    else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /**
         * If it contains a capital letter, it's an SVG component
         */
        /[A-Z]/u.test(Component)) {
        return true;
    }
    return false;
}

function renderHTML(element, { style, vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for (const key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
const camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
]);

function renderSVG(element, renderState, _styleProp, projection) {
    renderHTML(element, renderState, undefined, projection);
    for (const key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}

function isForcedMotionValue(key, { layout, layoutId }) {
    return (transformProps.has(key) ||
        key.startsWith("origin") ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}

function scrapeMotionValuesFromProps$1(props, prevProps, visualElement) {
    var _a;
    const { style } = props;
    const newValues = {};
    for (const key in style) {
        if (isMotionValue(style[key]) ||
            (prevProps.style &&
                isMotionValue(prevProps.style[key])) ||
            isForcedMotionValue(key, props) ||
            ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}

function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    const newValues = scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
    for (const key in props) {
        if (isMotionValue(props[key]) ||
            isMotionValue(prevProps[key])) {
            const targetKey = transformPropOrder.indexOf(key) !== -1
                ? "attr" + key.charAt(0).toUpperCase() + key.substring(1)
                : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}

/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    const ref = useRef(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}

function makeState({ scrapeMotionValuesFromProps, createRenderState, onMount, }, props, context, presenceContext) {
    const state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = (instance) => onMount(props, instance, state);
    }
    return state;
}
const makeUseVisualState = (config) => (props, isStatic) => {
    const context = useContext(MotionContext);
    const presenceContext = useContext(PresenceContext);
    const make = () => makeState(config, props, context, presenceContext);
    return isStatic ? make() : useConstant(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for (const key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    let { initial, animate } = props;
    const isControllingVariants$1 = isControllingVariants(props);
    const isVariantNode$1 = isVariantNode(props);
    if (context &&
        isVariantNode$1 &&
        !isControllingVariants$1 &&
        props.inherit !== false) {
        if (initial === undefined)
            initial = context.initial;
        if (animate === undefined)
            animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext
        ? presenceContext.initial === false
        : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        for (let i = 0; i < list.length; i++) {
            const resolved = resolveVariantFromProps(props, list[i]);
            if (resolved) {
                const { transitionEnd, transition, ...target } = resolved;
                for (const key in target) {
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */
                        const index = isInitialAnimationBlocked
                            ? valueTarget.length - 1
                            : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) {
                        values[key] = valueTarget;
                    }
                }
                for (const key in transitionEnd) {
                    values[key] = transitionEnd[key];
                }
            }
        }
    }
    return values;
}

const createHtmlRenderState = () => ({
    style: {},
    transform: {},
    transformOrigin: {},
    vars: {},
});

const createSvgRenderState = () => ({
    ...createHtmlRenderState(),
    attrs: {},
});

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
const getValueAsType = (value, type) => {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};

const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
const numTransforms = transformPropOrder.length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */
    for (let i = 0; i < numTransforms; i++) {
        const key = transformPropOrder[i];
        const value = latestValues[key];
        if (value === undefined)
            continue;
        let valueIsDefault = true;
        if (typeof value === "number") {
            valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        }
        else {
            valueIsDefault = parseFloat(value) === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = getValueAsType(value, numberValueTypes[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) {
                transform[key] = valueAsType;
            }
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}

function buildHTMLStyles(state, latestValues, transformTemplate) {
    const { style, vars, transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */
    for (const key in latestValues) {
        const value = latestValues[key];
        if (transformProps.has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        }
        else if (isCSSVariableName(key)) {
            vars[key] = value;
            continue;
        }
        else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = getValueAsType(value, numberValueTypes[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] =
                    valueAsType;
            }
            else {
                style[key] = valueAsType;
            }
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) {
            style.transform = buildTransform(latestValues, state.transform, transformTemplate);
        }
        else if (style.transform) {
            /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */
            style.transform = "none";
        }
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */
    if (hasTransformOrigin) {
        const { originX = "50%", originY = "50%", originZ = 0, } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

function calcOrigin(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
    const pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

const dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
const camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = px.transform(-offset);
    // Build the dash array
    const pathLength = px.transform(length);
    const pathSpacing = px.transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, { attrX, attrY, attrScale, originX, originY, pathLength, pathSpacing = 1, pathOffset = 0, 
// This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    buildHTMLStyles(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */
    if (isSVGTag) {
        if (state.style.viewBox) {
            state.attrs.viewBox = state.style.viewBox;
        }
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs, style, dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    if (attrScale !== undefined)
        attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) {
        buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
    }
}

const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

const svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: (props, instance, { renderState, latestValues }) => {
            frame.read(() => {
                try {
                    renderState.dimensions =
                        typeof instance.getBBox ===
                            "function"
                            ? instance.getBBox()
                            : instance.getBoundingClientRect();
                }
                catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0,
                    };
                }
            });
            frame.render(() => {
                buildSVGAttrs(renderState, latestValues, isSVGTag(instance.tagName), props.transformTemplate);
                renderSVG(instance, renderState);
            });
        },
    }),
};

const htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
        createRenderState: createHtmlRenderState,
    }),
};

function copyRawValuesOnly(target, source, props) {
    for (const key in source) {
        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues({ transformTemplate }, visualState) {
    return useMemo(() => {
        const state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [visualState]);
}
function useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState));
    return style;
}
function useHTMLProps(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect =
            style.WebkitUserSelect =
                style.WebkitTouchCallout =
                    "none";
        // Disable scrolling on the draggable direction
        style.touchAction =
            props.drag === true
                ? "none"
                : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined &&
        (props.onTap || props.onTapStart || props.whileTap)) {
        htmlProps.tabIndex = 0;
    }
    htmlProps.style = style;
    return htmlProps;
}

/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
const validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport",
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
    return (key.startsWith("while") ||
        (key.startsWith("drag") && key !== "draggable") ||
        key.startsWith("layout") ||
        key.startsWith("onTap") ||
        key.startsWith("onPan") ||
        key.startsWith("onLayout") ||
        validMotionProps.has(key));
}

let shouldForward = (key) => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp)
        return;
    // Explicitly filter our events
    shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */
    loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
}
catch (_a) {
    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for (const key in props) {
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */
        if (key === "values" && typeof props.values === "object")
            continue;
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key)) ||
            // If trying to use native HTML drag events, forward drag listeners
            (props["draggable"] &&
                key.startsWith("onDrag"))) {
            filteredProps[key] =
                props[key];
        }
    }
    return filteredProps;
}

function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = useMemo(() => {
        const state = createSvgRenderState();
        buildSVGAttrs(state, visualState, isSVGTag(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: { ...state.style },
        };
    }, [visualState]);
    if (props.style) {
        const rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = { ...rawStyles, ...visualProps.style };
    }
    return visualProps;
}

function createUseRender(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues }, isStatic) => {
        const useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== Fragment
            ? { ...filteredProps, ...visualProps, ref }
            : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */
        const { children } = props;
        const renderedChildren = useMemo(() => (isMotionValue(children) ? children.get() : children), [children]);
        return createElement(Component, {
            ...elementProps,
            children: renderedChildren,
        });
    };
    return useRender;
}

function createMotionComponentFactory(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps } = { forwardMotionProps: false }) {
        const baseConfig = isSVGComponent(Component)
            ? svgMotionConfig
            : htmlMotionConfig;
        const config = {
            ...baseConfig,
            preloadedFeatures,
            useRender: createUseRender(forwardMotionProps),
            createVisualElement,
            Component,
        };
        return createRendererMotionComponent(config);
    };
}

// Does this device prefer reduced motion? Returns `null` server-side.
const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };

function initPrefersReducedMotion() {
    hasReducedMotionListener.current = true;
    if (!isBrowser$1)
        return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = () => (prefersReducedMotion.current = motionMediaQuery.matches);
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    }
    else {
        prefersReducedMotion.current = false;
    }
}

function updateMotionValuesFromProps(element, next, prev) {
    for (const key in next) {
        const nextValue = next[key];
        const prevValue = prev[key];
        if (isMotionValue(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */
            element.addValue(key, nextValue);
            /**
             * Check the version of the incoming motion value with this version
             * and warn against mismatches.
             */
            if (process.env.NODE_ENV === "development") {
                warnOnce(nextValue.version === "11.11.15", `Attempting to mix Motion versions ${nextValue.version} with 11.11.15 may not work as expected.`);
            }
        }
        else if (isMotionValue(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */
            element.addValue(key, motionValue(nextValue, { owner: element }));
        }
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */
            if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) {
                    existingValue.jump(nextValue);
                }
                else if (!existingValue.hasAnimated) {
                    existingValue.set(nextValue);
                }
            }
            else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, motionValue(latestValue !== undefined ? latestValue : nextValue, { owner: element }));
            }
        }
    }
    // Handle removed values
    for (const key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}

const visualElementStore = new WeakMap();

/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensionValueTypes, color, complex];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = (v) => valueTypes.find(testValueType(v));

const propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete",
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
class VisualElement {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */
    scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent, props, presenceContext, reducedMotionConfig, blockInitialAnimation, visualState, }, options = {}) {
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */
        this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */
        this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */
        this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */
        this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */
        this.values = new Map();
        this.KeyframeResolver = KeyframeResolver;
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */
        this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */
        this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */
        this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */
        this.propEventSubscriptions = {};
        this.notifyUpdate = () => this.notify("Update", this.latestValues);
        this.render = () => {
            if (!this.current)
                return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = () => {
            const now = time.now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                frame.render(this.render, false, true);
            }
        };
        const { latestValues, renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = { ...latestValues };
        this.initialValues = props.initial ? { ...latestValues } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = isControllingVariants(props);
        this.isVariantNode = isVariantNode(props);
        if (this.isVariantNode) {
            this.variantChildren = new Set();
        }
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */
        const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for (const key in initialMotionValues) {
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) {
                value.set(latestValues[key], false);
            }
        }
    }
    mount(instance) {
        this.current = instance;
        visualElementStore.set(instance, this);
        if (this.projection && !this.projection.instance) {
            this.projection.mount(instance);
        }
        if (this.parent && this.isVariantNode && !this.isControllingVariants) {
            this.removeFromVariantTree = this.parent.addVariantChild(this);
        }
        this.values.forEach((value, key) => this.bindToMotionValue(key, value));
        if (!hasReducedMotionListener.current) {
            initPrefersReducedMotion();
        }
        this.shouldReduceMotion =
            this.reducedMotionConfig === "never"
                ? false
                : this.reducedMotionConfig === "always"
                    ? true
                    : prefersReducedMotion.current;
        if (process.env.NODE_ENV !== "production") {
            warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
        }
        if (this.parent)
            this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        visualElementStore.delete(this.current);
        this.projection && this.projection.unmount();
        cancelFrame(this.notifyUpdate);
        cancelFrame(this.render);
        this.valueSubscriptions.forEach((remove) => remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for (const key in this.events) {
            this.events[key].clear();
        }
        for (const key in this.features) {
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) {
            this.valueSubscriptions.get(key)();
        }
        const valueIsTransform = transformProps.has(key);
        const removeOnChange = value.on("change", (latestValue) => {
            this.latestValues[key] = latestValue;
            this.props.onUpdate && frame.preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) {
                this.projection.isTransformDirty = true;
            }
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) {
            removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        }
        this.valueSubscriptions.set(key, () => {
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck)
                removeSyncCheck();
            if (value.owner)
                value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */
        if (!this.current ||
            !this.sortInstanceNodePosition ||
            this.type !== other.type) {
            return 0;
        }
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for (key in featureDefinitions) {
            const featureDefinition = featureDefinitions[key];
            if (!featureDefinition)
                continue;
            const { isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */
            if (!this.features[key] &&
                FeatureConstructor &&
                isEnabled(this.props)) {
                this.features[key] = new FeatureConstructor(this);
            }
            /**
             * If we have a feature, mount or update it.
             */
            if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) {
                    feature.update();
                }
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */
    measureViewportBox() {
        return this.current
            ? this.measureInstanceViewportBox(this.current, this.props)
            : createBox();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */
    update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) {
            this.scheduleRender();
        }
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */
        for (let i = 0; i < propEventHandlers.length; i++) {
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = ("on" + key);
            const listener = props[listenerName];
            if (listener) {
                this.propEventSubscriptions[key] = this.on(key, listener);
            }
        }
        this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) {
            this.handleChildMotionValue();
        }
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */
    getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */
    getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode
            ? this
            : this.parent
                ? this.parent.getClosestVariantNode()
                : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */
    addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren &&
                closestVariantNode.variantChildren.add(child);
            return () => closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */
    addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue)
                this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */
    removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */
    hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) {
            return this.props.values[key];
        }
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = motionValue(defaultValue === null ? undefined : defaultValue, { owner: this });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */
    readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current
            ? this.latestValues[key]
            : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" &&
                (isNumericalString(value) || isZeroValueString(value))) {
                // If this is a number read as a string, ie "0" or "200", convert it to a number
                value = parseFloat(value);
            }
            else if (!findValueType(value) && complex.test(target)) {
                value = getAnimatableNone(key, target);
            }
            this.setBaseTarget(key, isMotionValue(value) ? value.get() : value);
        }
        return isMotionValue(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */
    setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */
    getBaseTarget(key) {
        var _a;
        const { initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = resolveVariantFromProps(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) {
                valueFromInitial = variant[key];
            }
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */
        if (initial && valueFromInitial !== undefined) {
            return valueFromInitial;
        }
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */
        const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !isMotionValue(target))
            return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */
        return this.initialValues[key] !== undefined &&
            valueFromInitial === undefined
            ? undefined
            : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) {
            this.events[eventName].notify(...args);
        }
    }
}

class DOMVisualElement extends VisualElement {
    constructor() {
        super(...arguments);
        this.KeyframeResolver = DOMKeyframesResolver;
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style
            ? props.style[key]
            : undefined;
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
}

function getComputedStyle$1(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.type = "html";
        this.renderInstance = renderHTML;
    }
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            const computedStyle = getComputedStyle$1(instance);
            const value = (isCSSVariableName(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return measureViewportBox(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        buildHTMLStyles(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children } = this.props;
        if (isMotionValue(children)) {
            this.childSubscription = children.on("change", (latest) => {
                if (this.current)
                    this.current.textContent = `${latest}`;
            });
        }
    }
}

class SVGVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = createBox;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return scrapeMotionValuesFromProps(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        buildSVGAttrs(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderSVG(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = isSVGTag(instance.tagName);
        super.mount(instance);
    }
}

const createDomVisualElement = (Component, options) => {
    return isSVGComponent(Component)
        ? new SVGVisualElement(options)
        : new HTMLVisualElement(options, {
            allowProjection: Component !== Fragment,
        });
};

const createMotionComponent = /*@__PURE__*/ createMotionComponentFactory({
    ...animations,
    ...gestureAnimations,
    ...drag,
    ...layout,
}, createDomVisualElement);

const motion = /*@__PURE__*/ createDOMMotionComponentProxy(createMotionComponent);

/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */
class PopChildMeasure extends React$1.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */
    componentDidUpdate() { }
    render() {
        return this.props.children;
    }
}
function PopChild({ children, isPresent }) {
    const id = useId$1();
    const ref = useRef(null);
    const size = useRef({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
    });
    const { nonce } = useContext(MotionConfigContext);
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */
    useInsertionEffect$1(() => {
        const { width, height, top, left } = size.current;
        if (isPresent || !ref.current || !width || !height)
            return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce)
            style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) {
            style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        }
        return () => {
            document.head.removeChild(style);
        };
    }, [isPresent]);
    return (jsx(PopChildMeasure, { isPresent: isPresent, childRef: ref, sizeRef: size, children: React$1.cloneElement(children, { ref }) }));
}

const PresenceChild = ({ children, initial, isPresent, onExitComplete, custom, presenceAffectsLayout, mode, }) => {
    const presenceChildren = useConstant(newChildrenMap);
    const id = useId$1();
    const memoizedOnExitComplete = useCallback((childId) => {
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()) {
            if (!isComplete)
                return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [presenceChildren, onExitComplete]);
    const context = useMemo(() => ({
        id,
        initial,
        isPresent,
        custom,
        onExitComplete: memoizedOnExitComplete,
        register: (childId) => {
            presenceChildren.set(childId, false);
            return () => presenceChildren.delete(childId);
        },
    }), 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout
        ? [Math.random(), memoizedOnExitComplete]
        : [isPresent, memoizedOnExitComplete]);
    useMemo(() => {
        presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    React$1.useEffect(() => {
        !isPresent &&
            !presenceChildren.size &&
            onExitComplete &&
            onExitComplete();
    }, [isPresent]);
    if (mode === "popLayout") {
        children = jsx(PopChild, { isPresent: isPresent, children: children });
    }
    return (jsx(PresenceContext.Provider, { value: context, children: children }));
};
function newChildrenMap() {
    return new Map();
}

const getChildKey = (child) => child.key || "";
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    Children.forEach(children, (child) => {
        if (isValidElement(child))
            filtered.push(child);
    });
    return filtered;
}

/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
const AnimatePresence = ({ children, exitBeforeEnter, custom, initial = true, onExitComplete, presenceAffectsLayout = true, mode = "sync", }) => {
    invariant(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */
    const presentChildren = useMemo(() => onlyElements(children), [children]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */
    const presentKeys = presentChildren.map(getChildKey);
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */
    const isInitialRender = useRef(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */
    const pendingPresentChildren = useRef(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */
    const exitComplete = useConstant(() => new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */
    const [diffedChildren, setDiffedChildren] = useState(presentChildren);
    const [renderedChildren, setRenderedChildren] = useState(presentChildren);
    useIsomorphicLayoutEffect(() => {
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */
        for (let i = 0; i < renderedChildren.length; i++) {
            const key = getChildKey(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) {
                    exitComplete.set(key, false);
                }
            }
            else {
                exitComplete.delete(key);
            }
        }
    }, [renderedChildren, presentKeys.length, presentKeys.join("-")]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [...presentChildren];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */
        for (let i = 0; i < renderedChildren.length; i++) {
            const child = renderedChildren[i];
            const key = getChildKey(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */
        if (mode === "wait" && exitingChildren.length) {
            nextChildren = exitingChildren;
        }
        setRenderedChildren(onlyElements(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */
        return;
    }
    if (process.env.NODE_ENV !== "production" &&
        mode === "wait" &&
        renderedChildren.length > 1) {
        console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */
    const { forceRender } = useContext(LayoutGroupContext);
    return (jsx(Fragment$1, { children: renderedChildren.map((child) => {
            const key = getChildKey(child);
            const isPresent = presentChildren === renderedChildren ||
                presentKeys.includes(key);
            const onExit = () => {
                if (exitComplete.has(key)) {
                    exitComplete.set(key, true);
                }
                else {
                    return;
                }
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete) => {
                    if (!isExitComplete)
                        isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 ? void 0 : forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    onExitComplete && onExitComplete();
                }
            };
            return (jsx(PresenceChild, { isPresent: isPresent, initial: !isInitialRender.current || initial
                    ? undefined
                    : false, custom: isPresent ? undefined : custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, onExitComplete: isPresent ? undefined : onExit, children: child }, key));
        }) }));
};

var css_248z$d = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.Tooltip-module_wrapper__V567h {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 0.8rem;\n  color: #333333;\n  background-color: #eeeeee;\n  border-radius: 0.4rem;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n  z-index: 100;\n}\n.Tooltip-module_wrapper__V567h svg {\n  position: absolute;\n  fill: #eeeeee;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_topLeftCorner__1XkoM {\n  right: calc(100% + 0.5rem);\n  bottom: calc(100% + 0.2rem);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_topLeftCorner__1XkoM svg {\n  right: -0.4rem;\n  bottom: -0.5rem;\n  rotate: 70deg;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_topLeft__0bQFP {\n  right: 75%;\n  bottom: calc(100% + 1rem);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_topLeft__0bQFP svg {\n  right: 0.8rem;\n  bottom: -1rem;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_top__HZqEk {\n  left: 50%;\n  bottom: calc(100% + 1rem);\n  transform: translateX(-50%);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_top__HZqEk svg {\n  bottom: -1.2rem;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_topRight__46iZ3 {\n  left: 75%;\n  bottom: calc(100% + 1rem);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_topRight__46iZ3 svg {\n  left: 0.8rem;\n  bottom: -1rem;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_topRightCorner__vnbjw {\n  left: calc(100% + 0.5rem);\n  bottom: calc(100% + 0.2rem);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_topRightCorner__vnbjw svg {\n  left: -0.4rem;\n  bottom: -0.5rem;\n  rotate: -70deg;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottomLeftCorner__9t-xO {\n  right: calc(100% + 0.5rem);\n  top: calc(100% + 0.2rem);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottomLeftCorner__9t-xO svg {\n  right: -0.9rem;\n  top: -0.6rem;\n  rotate: -130deg;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottomLeft__qYqv5 {\n  right: 75%;\n  top: calc(100% + 1rem);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottomLeft__qYqv5 svg {\n  right: 0.8rem;\n  top: -1rem;\n  rotate: 180deg;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottom__hrxCa {\n  left: 50%;\n  top: calc(100% + 1rem);\n  transform: translateX(-50%);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottom__hrxCa svg {\n  top: -1.2rem;\n  rotate: 180deg;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottomRight__uUfLP {\n  left: 75%;\n  top: calc(100% + 1rem);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottomRight__uUfLP svg {\n  left: 0.8rem;\n  top: -1rem;\n  rotate: 180deg;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottomRightCorner__9JGMm {\n  left: calc(100% + 0.5rem);\n  top: calc(100% + 0.2rem);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_bottomRightCorner__9JGMm svg {\n  left: -0.9rem;\n  top: -0.6rem;\n  rotate: 130deg;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_right__LGQTD {\n  top: 50%;\n  left: calc(100% + 1rem);\n  transform: translateY(-50%);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_right__LGQTD svg {\n  left: -1.2rem;\n  rotate: 90deg;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_left__-LZ0w {\n  top: 50%;\n  right: calc(100% + 1rem);\n  transform: translateY(-50%);\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_left__-LZ0w svg {\n  right: -1.2rem;\n  rotate: -90deg;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_ofd__vsifm {\n  background-color: #e3eff0;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_ofd__vsifm svg {\n  fill: #e3eff0;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_edo__mes-1 {\n  background-color: #fcf6ea;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_edo__mes-1 svg {\n  fill: #fcf6ea;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_epd__--2X2 {\n  background-color: #fcf6ea;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_epd__--2X2 svg {\n  fill: #fcf6ea;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_gosotchet__SQFQf {\n  background-color: #254e5f;\n  color: #ffffff;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_gosotchet__SQFQf svg {\n  fill: #254e5f;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_td__DVchH {\n  background-color: #fcf3ed;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_td__DVchH svg {\n  fill: #fcf3ed;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_marking__pBLvM {\n  background-color: #f1f9f9;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_marking__pBLvM svg {\n  fill: #f1f9f9;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_check-index__dapNZ {\n  background-color: #f3fafc;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_check-index__dapNZ svg {\n  fill: #f3fafc;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_big-data__Atmfk {\n  background-color: #e7f2f3;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_big-data__Atmfk svg {\n  fill: #e7f2f3;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_arenda__VrUol {\n  background-color: #f9f2f1;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_arenda__VrUol svg {\n  fill: #f9f2f1;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_integrations__L-JCE {\n  background-color: #f3f3f7;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_integrations__L-JCE svg {\n  fill: #f3f3f7;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_onec__b1Bps {\n  background-color: #fbefee;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_onec__b1Bps svg {\n  fill: #fbefee;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_mchd__gZ4RY {\n  background-color: #fbefee;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_mchd__gZ4RY svg {\n  fill: #fbefee;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_elk__4-Gwa {\n  background-color: #f0f2f5;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_elk__4-Gwa svg {\n  fill: #f0f2f5;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_success__TcJo9 {\n  color: #ffffff;\n  background-color: #8bc34a;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_success__TcJo9 svg {\n  fill: #8bc34a;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_info__Ku40p {\n  color: #ffffff;\n  background-color: #5bc0de;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_info__Ku40p svg {\n  fill: #5bc0de;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_warning__FeIfu {\n  color: #ffffff;\n  background-color: #dcae1d;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_warning__FeIfu svg {\n  fill: #dcae1d;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_error__XqmPU {\n  color: #ffffff;\n  background-color: #d12e34;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_error__XqmPU svg {\n  fill: #d12e34;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_grey__D5sNW {\n  color: #ffffff;\n  background-color: #858594;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_grey__D5sNW svg {\n  fill: #858594;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_common__hToEo {\n  color: #ffffff;\n  background-color: #254e5f;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_common__hToEo svg {\n  fill: #254e5f;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_white__1Na5C {\n  background-color: #ffffff;\n}\n.Tooltip-module_wrapper__V567h.Tooltip-module_white__1Na5C svg {\n  fill: #ffffff;\n}\n\n.Tooltip-module_text__3J5sB {\n  width: max-content;\n  text-align: center;\n  max-width: 100%;\n  font: 600 1.4rem/1.6rem \"Nunito Sans\", sans-serif;\n}";
var s$7 = {"wrapper":"Tooltip-module_wrapper__V567h","topLeftCorner":"Tooltip-module_topLeftCorner__1XkoM","topLeft":"Tooltip-module_topLeft__0bQFP","top":"Tooltip-module_top__HZqEk","topRight":"Tooltip-module_topRight__46iZ3","topRightCorner":"Tooltip-module_topRightCorner__vnbjw","bottomLeftCorner":"Tooltip-module_bottomLeftCorner__9t-xO","bottomLeft":"Tooltip-module_bottomLeft__qYqv5","bottom":"Tooltip-module_bottom__hrxCa","bottomRight":"Tooltip-module_bottomRight__uUfLP","bottomRightCorner":"Tooltip-module_bottomRightCorner__9JGMm","right":"Tooltip-module_right__LGQTD","left":"Tooltip-module_left__-LZ0w","ofd":"Tooltip-module_ofd__vsifm","edo":"Tooltip-module_edo__mes-1","epd":"Tooltip-module_epd__--2X2","gosotchet":"Tooltip-module_gosotchet__SQFQf","td":"Tooltip-module_td__DVchH","marking":"Tooltip-module_marking__pBLvM","check-index":"Tooltip-module_check-index__dapNZ","big-data":"Tooltip-module_big-data__Atmfk","arenda":"Tooltip-module_arenda__VrUol","integrations":"Tooltip-module_integrations__L-JCE","onec":"Tooltip-module_onec__b1Bps","mchd":"Tooltip-module_mchd__gZ4RY","elk":"Tooltip-module_elk__4-Gwa","success":"Tooltip-module_success__TcJo9","info":"Tooltip-module_info__Ku40p","warning":"Tooltip-module_warning__FeIfu","error":"Tooltip-module_error__XqmPU","grey":"Tooltip-module_grey__D5sNW","common":"Tooltip-module_common__hToEo","white":"Tooltip-module_white__1Na5C","text":"Tooltip-module_text__3J5sB"};
styleInject(css_248z$d);

const Tooltip = memo$1(({ className, product = 'default', theme, text, isShown, placement = 'bottom', children }) => (React__default.createElement(AnimatePresence, null, isShown && (React__default.createElement(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.3, ease: 'easeOut' }, className: cn$i(s$7.wrapper, className, s$7[placement], s$7[product], s$7[theme !== null && theme !== void 0 ? theme : '']), "data-testid": "tooltip_body" },
    !!text && React__default.createElement("div", { className: s$7.text }, text),
    !!children && React__default.createElement("div", null, children),
    React__default.createElement(Icon, { height: "17", iconFill: true, name: "tooltip_tail", product: product, theme: theme, width: "20", "data-testid": "tooltip_tail" }))))));
Tooltip.displayName = 'Tooltip';

const Input = ({ name, value, inputId, onChange, type, label, placeholder, hintText, // TODO Возможно, стоит переименовать в "errorMessage"
defaultValue, disabled, maxLength, minLength, fieldType, product, theme, icon, iconLeft, iconStroke, iconFill, iconPosition, passwordOpener, required, testId, btnTestId, legacyMode = true, className = '', inputClassName = '', onValidate = () => null, onKeyDown = () => null, onKeyUp = () => null, onBlur = () => null, iconStrokeSecond, }, ref) => {
    const [typeState, setTypeState] = useState(type);
    const [passwordEyeType, setPasswordEyeType] = useState('eye_closed');
    const [isInputActive, setIsInputActive] = useState(!!value && !!String(value).trim().length);
    const [isMouseFocused, setIsMouseFocused] = useState(false);
    const [isTabSelected, setIsTabSelected] = useState(false);
    const [isTooltipVisible, setIsTooltipVisible] = useState({
        label: false,
        placeholder: false,
        value: false,
    });
    const labelRef = useRef(null);
    const inputRef = useRef(null);
    const placeholderRef = useRef(null);
    const uniqueId = v4();
    let keyPressed;
    let valResult;
    useEffect(() => {
        onValidate(!hintText);
    }, [onValidate, hintText]);
    useEffect(() => {
        if (!placeholderRef.current)
            return;
        placeholderRef.current.innerText = placeholder || '';
    }, [placeholder]);
    if (icon && !iconPosition) {
        iconPosition = 'left';
    }
    const handleKeyDown = (e) => {
        onKeyDown(e);
        if (fieldType === 'phone') {
            keyPressed = e.key;
        }
    };
    // FIXME: если есть onChange, зачем использовать onInput?
    const handleInputChange = (e) => {
        const digits = e.target.value.replace(/[^0-9]/g, '');
        switch (fieldType) {
            case 'email':
                valResult = validateEmail(e.target.value.replace(/\s/g, ''));
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'innPerson':
                valResult = validateInnPerson(e.target.value);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'innOrganization':
                valResult = validateInnOrganization(e.target.value);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'passport':
                passportCitizenMask(e, e.target.value);
                valResult = validatePassport(digits);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'passportCode':
                passportCodeMask(e, e.target.value);
                valResult = validatePassportCode(e.target.value);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'phone':
                phoneMask(e, keyPressed);
                if (digits.length < 12) {
                    valResult = validatePhone(digits);
                    hintText = !valResult.success ? valResult.error.message : hintText;
                }
                break;
            case 'snils':
                snilsMask(e, e.target.value);
                valResult = validateSnils(digits);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'ogrn':
                valResult = validateOgrn(e.target.value);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'ogrnIp':
                valResult = validateOgrnIp(e.target.value);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'vehicleNumber':
                valResult = validateVehicleNumber(e.target.value);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'kpp':
                valResult = validateKpp(e.target.value);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
            case 'guid':
                valResult = validateGuid(e.target.value);
                hintText = !valResult.success ? valResult.error.message : hintText;
                break;
        }
        if (minLength) {
            hintText = e.target.value.length < minLength ? hintText : '';
        }
    };
    const triggerPassword = useCallback(() => {
        if (typeState === 'text') {
            setTypeState('password');
            setPasswordEyeType('eye_closed');
        }
        else {
            setTypeState('text');
            setPasswordEyeType('eye_opened');
        }
    }, [typeState]);
    const handleInputFocus = () => {
        setIsInputActive(true);
        setIsTabSelected(false);
        setIsMouseFocused(true);
    };
    const handleInputBlur = (e) => {
        setIsTabSelected(false);
        setIsInputActive(false);
        setIsMouseFocused(false);
        onBlur(e);
    };
    const handleKeyUp = useCallback((ev) => {
        const { code } = ev;
        code === 'Tab' ? setIsTabSelected(true) : setIsTabSelected(false);
        onKeyUp(ev);
    }, [onKeyUp]);
    const handleChange = useCallback((e) => {
        onChange(e);
    }, [onChange]);
    const handleMouseDown = useCallback(() => {
        setIsTabSelected(false);
    }, []);
    const checkOverflow = (element, maxWidth) => {
        if (!element)
            return false;
        return element.scrollWidth > (maxWidth !== null && maxWidth !== void 0 ? maxWidth : element.clientWidth);
    };
    const handleMouseEnter = (type) => {
        var _a;
        if (type === 'label' && labelRef.current && checkOverflow(labelRef.current)) {
            setIsTooltipVisible((prev) => (Object.assign(Object.assign({}, prev), { label: true })));
        }
        else if (type === 'value' &&
            !value &&
            placeholderRef.current &&
            checkOverflow(placeholderRef.current, (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth)) {
            setIsTooltipVisible((prev) => (Object.assign(Object.assign({}, prev), { placeholder: true })));
        }
        else if (type === 'value' && value && inputRef.current && checkOverflow(inputRef.current)) {
            setIsTooltipVisible((prev) => (Object.assign(Object.assign({}, prev), { value: true })));
        }
    };
    const handleMouseLeave = (type) => {
        if (type === 'label') {
            setIsTooltipVisible((prev) => (Object.assign(Object.assign({}, prev), { label: false })));
        }
        else if (type === 'value') {
            setIsTooltipVisible((prev) => (Object.assign(Object.assign({}, prev), { value: false, placeholder: false })));
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: cn$i(s$8.inputDiv, className, {
                [s$8.inputDivLeftIcon]: (icon && iconPosition === 'left') || iconLeft,
                [s$8.inputDivDisabled]: disabled,
                [s$8.inputDivInactive]: !legacyMode && !isInputActive && !(value === null || value === void 0 ? void 0 : value.length),
                [s$8.inputDivActive]: isMouseFocused,
                [s$8.inputDivWithText]: !!(value === null || value === void 0 ? void 0 : value.length),
                [s$8.inputDivTabSelected]: isTabSelected,
            }) },
            React__default.createElement("label", { htmlFor: inputId !== null && inputId !== void 0 ? inputId : uniqueId, className: cn$i(s$8.inputLabel, s$8[`inputLabel_${product}`], {
                    [s$8.labelWithIconRight]: icon && iconPosition === 'right',
                    [s$8.inputLabelGray]: !!value && !isInputActive,
                }), ref: labelRef, onMouseEnter: () => handleMouseEnter('label'), onMouseLeave: () => handleMouseLeave('label') },
                label,
                required && React__default.createElement("div", { className: s$8.iconRequired })),
            isTooltipVisible.label && label && (React__default.createElement(Tooltip, { text: label, isShown: isTooltipVisible.label, product: product, placement: "top" })),
            isTooltipVisible.placeholder && (React__default.createElement(Tooltip, { text: placeholder, isShown: isTooltipVisible.placeholder, product: product, placement: "bottom" })),
            isTooltipVisible.value && value && (React__default.createElement(Tooltip, { text: value, isShown: isTooltipVisible.value, product: product, placement: "bottom" })),
            ((iconLeft && icon) || (icon && iconPosition === 'left')) && (React__default.createElement("div", { className: cn$i(s$8.inputIcon, s$8.inputIconLeft) },
                React__default.createElement(Icon, { name: iconLeft !== null && iconLeft !== void 0 ? iconLeft : icon, iconFill: iconFill, iconStroke: iconStroke, product: product, width: "16", height: "16" }))),
            React__default.createElement("input", { "data-testid": testId, id: inputId !== null && inputId !== void 0 ? inputId : uniqueId, name: name, type: typeState, className: cn$i(s$8.inputMain, s$8[`inputMain_${product}`], inputClassName, {
                    [s$8[`inputMain_${theme}`]]: theme,
                    [s$8.inputWithIconRight]: icon && iconPosition === 'right',
                }), onInput: handleInputChange, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, onBlur: handleInputBlur, onFocus: handleInputFocus, onChange: handleChange, onMouseDown: handleMouseDown, disabled: disabled, placeholder: legacyMode || isInputActive ? placeholder : '', defaultValue: defaultValue, value: value, maxLength: maxLength, minLength: minLength, "aria-required": required, ref: ref || inputRef, onMouseEnter: () => handleMouseEnter('value'), onMouseLeave: () => handleMouseLeave('value') }),
            ((icon && iconLeft) || (icon && iconPosition === 'right')) && (React__default.createElement("div", { className: cn$i(s$8.inputIcon, s$8.inputIconRight) },
                React__default.createElement(Icon, { name: icon, theme: theme, product: product, iconFill: iconFill, iconStroke: iconStroke, strokeSecond: iconStrokeSecond, width: "16", height: "16" }))),
            passwordOpener && (React__default.createElement("button", { type: "button", className: s$8.passDisplayBtn, onClick: triggerPassword, "data-testid": btnTestId, "aria-label": "triggerPassword" },
                React__default.createElement(Icon, { name: passwordEyeType, product: product, iconFill: false, iconStroke: true, width: "16", height: "16", strokeSecond: iconStrokeSecond }))),
            !!hintText && React__default.createElement("p", { className: cn$i(s$8.inputHintText, s$8[`inputHintText_${theme}`]) }, hintText)),
        React__default.createElement("div", { className: s$8.placeholderHidden, ref: placeholderRef })));
};
var Input$1 = forwardRef(Input);

const services = [
    {
        id: 1,
        name: 'ofd',
        label: 'ОФД',
        testLink: 'https://lk-test.platformaofd.ru/web/auth/dashboard/',
        prodLink: 'https://lk.platformaofd.ru/web/auth/dashboard/',
        icon: 'services_ofd',
    },
    {
        id: 2,
        name: 'edo',
        label: 'ЭДО',
        testLink: 'https://edo-test.platformaofd.ru/',
        prodLink: 'https://new-edo.platformaofd.ru/',
        icon: 'services_edo',
    },
    {
        id: 3,
        name: 'gosotchet',
        label: 'Госотчет',
        testLink: 'https://go-test.platformaofd.ru/',
        prodLink: 'https://go.platformaofd.ru/',
        icon: 'services_go',
    },
    {
        id: 4,
        name: 'epd',
        label: 'ЭПД',
        testLink: 'https://epd-lk-test.platformaofd.ru/',
        prodLink: 'https://epd.platformaofd.ru/',
        icon: 'services_epd',
    },
    {
        id: 5,
        name: 'mchd',
        label: 'МЧД',
        testLink: 'https://m4d-test.platformaofd.ru/',
        prodLink: 'https://m4d.platformaofd.ru/',
        icon: 'services_mchd',
    },
];

var css_248z$c = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.ServiceSwitcher-module_switcher__7GCmG {\n  width: min-content;\n  font: 600 1.2rem/1.6rem Nunito Sans, sans-serif;\n  color: #254e5f;\n}\n\n.ServiceSwitcher-module_list__aWTf- {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  list-style-type: none;\n}\n\n.ServiceSwitcher-module_link__L5OiI {\n  width: 6.4rem;\n  height: 6.4rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  border-radius: 0.8rem;\n  background-color: transparent;\n  text-decoration: none;\n  color: inherit;\n  transition: background-color 300ms ease-out;\n  outline: none;\n}\n.ServiceSwitcher-module_link__L5OiI:hover {\n  background-color: rgba(0, 0, 0, 0.0509803922);\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.ServiceSwitcher-module_link__L5OiI:focus, .ServiceSwitcher-module_link__L5OiI:focus-visible {\n  outline: 0.3rem solid #5bc0de;\n  outline-offset: -0.3rem;\n  background: rgba(0, 0, 0, 0.0509803922);\n}\n.ServiceSwitcher-module_link__L5OiI:active {\n  background-color: rgba(0, 0, 0, 0.0509803922);\n  box-shadow: inset 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n.ServiceSwitcher-module_link--current__UlER4 {\n  background-color: #ffffff;\n  outline: 0.1rem solid #eeeeee;\n  outline-offset: -0.1rem;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n  pointer-events: none;\n  cursor: default;\n}";
var s$6 = {"switcher":"ServiceSwitcher-module_switcher__7GCmG","list":"ServiceSwitcher-module_list__aWTf-","link":"ServiceSwitcher-module_link__L5OiI","link--current":"ServiceSwitcher-module_link--current__UlER4"};
styleInject(css_248z$c);

const ServiceSwitcher = ({ className, product = 'default', idOrg }) => {
    const { hostname } = window.location;
    const isTestEnv = useMemo(() => hostname.includes('test') || hostname.includes('localhost'), [hostname]);
    const getProductLink = useCallback((service) => {
        // TODO: убрать условие для EPD, когда все продукты смогут поддерживать idOrg
        const queryOid = idOrg && service.name === 'epd' ? `?idOrg=${idOrg}` : '';
        return isTestEnv ? service.testLink + queryOid : service.prodLink + queryOid;
    }, [idOrg, isTestEnv]);
    return (React__default.createElement("div", { "data-testid": "service-switcher", className: cn$i(s$6.switcher, className) },
        React__default.createElement("ul", { className: s$6.list }, services.map((service) => (React__default.createElement("li", { key: service.id, className: s$6.item },
            React__default.createElement("a", { href: getProductLink(service), className: cn$i(s$6.link, {
                    [s$6['link--current']]: service.name.includes(product),
                }) },
                React__default.createElement(Icon, { product: "default", name: service.icon, width: "24", height: "24" }),
                React__default.createElement("span", { className: s$6.link__name }, service.label))))))));
};
ServiceSwitcher.displayName = 'ServiceSwitcher';

var css_248z$b = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.storybook-link {\n  text-decoration: underline;\n  transition: 0.3s;\n  /* ofd */\n  /* gosotchet */\n  /* td */\n  /* edo */\n  /* epd */\n  /* arenda */\n  /* marking */\n  /* check-index */\n  /* big-data */\n  /* mchd */\n  /* elk */\n  /* success */\n}\n.storybook-link:hover, .storybook-link:active {\n  text-decoration: none;\n  transition: 0.3s;\n}\n.storybook-link:focus-visible {\n  outline: 2px solid #5bc0de;\n  text-decoration: none;\n}\n.storybook-link__ofd {\n  color: #4ba1a5;\n}\n.storybook-link__ofd:hover {\n  color: #40898c;\n  transition: 0.3s;\n}\n.storybook-link__ofd:active {\n  color: #357d81;\n}\n.storybook-link__gosotchet {\n  color: #488bca;\n}\n.storybook-link__gosotchet:hover {\n  color: #367aba;\n  transition: 0.3s;\n}\n.storybook-link__gosotchet:active {\n  color: #2c70af;\n}\n.storybook-link__td {\n  color: #ea8242;\n}\n.storybook-link__td:hover {\n  color: #e76e23;\n  transition: 0.3s;\n}\n.storybook-link__td:active {\n  color: #e26212;\n}\n.storybook-link__edo {\n  color: #f5a91b;\n}\n.storybook-link__edo:hover {\n  color: #eb9d0c;\n  transition: 0.3s;\n}\n.storybook-link__edo:active {\n  color: #e89700;\n}\n.storybook-link__epd {\n  color: #f5a91b;\n}\n.storybook-link__epd:hover {\n  color: #eb9d0c;\n  transition: 0.3s;\n}\n.storybook-link__epd:active {\n  color: #e89700;\n}\n.storybook-link__arenda {\n  color: #d58576;\n}\n.storybook-link__arenda:hover {\n  color: #cd6d5b;\n  transition: 0.3s;\n}\n.storybook-link__arenda:active {\n  color: #ce5a46;\n}\n.storybook-link__marking {\n  color: #4bb9ba;\n}\n.storybook-link__marking:hover {\n  color: #3ea1a2;\n  transition: 0.3s;\n}\n.storybook-link__marking:active {\n  color: #339799;\n}\n.storybook-link__check-index {\n  color: #5bc0de;\n}\n.storybook-link__check-index:hover {\n  color: #3cb4d8;\n  transition: 0.3s;\n}\n.storybook-link__check-index:active {\n  color: #23a5cd;\n}\n.storybook-link__big-data {\n  color: #5ab8c5;\n}\n.storybook-link__big-data:hover {\n  color: #41aab9;\n  transition: 0.3s;\n}\n.storybook-link__big-data:active {\n  color: #36a1b0;\n}\n.storybook-link__mchd {\n  color: #626ab7;\n}\n.storybook-link__mchd:hover {\n  color: #4c55a9;\n  transition: 0.3s;\n}\n.storybook-link__mchd:active {\n  color: #434ca3;\n}\n.storybook-link__elk {\n  color: #577590;\n}\n.storybook-link__elk:hover {\n  color: #466077;\n  transition: 0.3s;\n}\n.storybook-link__elk:active {\n  color: #344b60;\n}\n.storybook-link__check-index {\n  color: #8bc34a;\n}\n.storybook-link__check-index:hover {\n  color: #7ab03a;\n  transition: 0.3s;\n}\n.storybook-link__check-index:active {\n  color: #5d8a28;\n}";
styleInject(css_248z$b);

const StorybookLink = ({ href, label, product, target, testId, }) => (React__default.createElement("a", { "data-testid": testId, target: target, className: ['storybook-link', `storybook-link__${product}`].join(' '), href: href }, label));

var css_248z$a = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_Regular_400.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_SemiBold_600.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Nunito Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/NunitoSans_Bold_700.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://cdn1.platformaofd.ru/fonts/RobotoFlex.woff2\") format(\"woff2\");\n}\n.switch-module_switch-tabs__bgMb3 {\n  display: flex;\n  background: #f2f2f2;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  height: 3.2rem;\n  transition: all 0.3s ease-in;\n}\n.switch-module_switch-tabs__bgMb3.switch-module_no-top-left-radius__mGa7y {\n  border-top-left-radius: 0;\n}\n.switch-module_switch-tabs__bgMb3.switch-module_no-top-right-radius__ILGoi {\n  border-top-right-radius: 0;\n}\n.switch-module_switch-tabs__bgMb3.switch-module_no-bottom-left-radius__eKXfv {\n  border-bottom-left-radius: 0;\n}\n.switch-module_switch-tabs__bgMb3.switch-module_no-bottom-right-radius__n7qHx {\n  border-bottom-right-radius: 0;\n}\n.switch-module_switch-tabs-large__qzV4X {\n  height: 4.8rem;\n}\n.switch-module_switch-tabs-large__qzV4X .switch-module_label__TZSO8 {\n  line-height: 3.6rem;\n}\n\n.switch-module_switch-tab__sWKja {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  text-align: center;\n  border-radius: 0.2rem;\n  transition: all 0.3s ease-in;\n}\n\n.switch-module_switch-tab__sWKja:nth-child(1) {\n  padding-left: 0.2rem;\n}\n\n.switch-module_switch-tab__sWKja:nth-last-child(1) {\n  padding-right: 0.2rem;\n}\n\n.switch-module_switch-tab--accent__xjZlQ:hover {\n  transition: 0.3s;\n  border-color: #e76e23;\n}\n\n.switch-module_switch-tab--common__IEhKE:hover {\n  transition: 0.3s;\n  border-color: #375d6c;\n}\n\n.switch-module_switch-tab--common__IEhKE:focus-visible {\n  transition: 0.3s;\n  outline: none;\n  border-color: #5bc0de;\n}\n\n.switch-module_title__7Uoze,\n.switch-module_label__TZSO8 {\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n  transition: all 0.3s ease-in;\n}\n\n.switch-module_title__7Uoze {\n  color: #c7c7cc;\n  transition: all 0.3s ease-in;\n}\n\n.switch-module_input__rH-bS {\n  display: none;\n}\n\n.switch-module_label__TZSO8 {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  cursor: pointer;\n  text-wrap: nowrap;\n  transition: all 0.3s ease-in;\n  z-index: 1;\n}\n.switch-module_label-slider__xgFCz {\n  position: absolute;\n  width: 100%;\n  height: 2.8rem;\n  background-color: #ffffff;\n  border-radius: 0.2rem;\n  z-index: -1;\n}\n.switch-module_label-slider-large__NQyN7 {\n  height: 4.4rem;\n}\n\n.switch-module_divider__2Q8Js {\n  right: 30rem;\n  width: 0.1rem;\n  height: 1.6rem;\n  background: #e3e3e4;\n}\n\n.switch-module_label--accent__V1NqX {\n  color: #ea8242;\n  transition: all 0.3s ease-in;\n}\n\n.switch-module_label--common__yO5xf {\n  color: #254e5f;\n  transition: all 0.3s ease-in;\n}\n\n.switch-module_input__rH-bS:checked + .switch-module_label--accent__V1NqX {\n  color: #254e5f;\n  transition: all 0.3s ease-in;\n}\n\n.switch-module_input__rH-bS:checked + .switch-module_label--common__yO5xf {\n  color: #4ba1a5;\n  transition: all 0.3s ease-in;\n}\n\n.switch-module_switch-tabs--disabled__ki5Vn {\n  transition: all 0.3s ease-in;\n}\n.switch-module_switch-tabs--disabled__ki5Vn .switch-module_label__TZSO8 {\n  color: #858594;\n  cursor: auto;\n  transition: all 0.3s ease-in;\n}\n.switch-module_switch-tabs--disabled__ki5Vn .switch-module_input__rH-bS:checked + .switch-module_label__TZSO8 {\n  background: #f8f8f8;\n  color: #858594;\n  transition: all 0.3s ease-in;\n}\n.switch-module_switch-tabs--disabled__ki5Vn .switch-module_switch-tab--common__IEhKE:hover,\n.switch-module_switch-tabs--disabled__ki5Vn .switch-module_switch-tab--accent__xjZlQ:hover {\n  transition: none;\n  border-color: transparent;\n}\n.switch-module_switch-tabs--disabled__ki5Vn .switch-module_switch-tab--common__IEhKE:focus-visible {\n  transition: none;\n  outline: none;\n  border-color: transparent;\n}";
var styles$2 = {"switch-tabs":"switch-module_switch-tabs__bgMb3","no-top-left-radius":"switch-module_no-top-left-radius__mGa7y","no-top-right-radius":"switch-module_no-top-right-radius__ILGoi","no-bottom-left-radius":"switch-module_no-bottom-left-radius__eKXfv","no-bottom-right-radius":"switch-module_no-bottom-right-radius__n7qHx","switch-tabs-large":"switch-module_switch-tabs-large__qzV4X","label":"switch-module_label__TZSO8","switch-tab":"switch-module_switch-tab__sWKja","switch-tab--accent":"switch-module_switch-tab--accent__xjZlQ","switch-tab--common":"switch-module_switch-tab--common__IEhKE","title":"switch-module_title__7Uoze","input":"switch-module_input__rH-bS","label-slider":"switch-module_label-slider__xgFCz","label-slider-large":"switch-module_label-slider-large__NQyN7","divider":"switch-module_divider__2Q8Js","label--accent":"switch-module_label--accent__V1NqX","label--common":"switch-module_label--common__yO5xf","switch-tabs--disabled":"switch-module_switch-tabs--disabled__ki5Vn"};
styleInject(css_248z$a);

const cn$g = classNames.bind(styles$2);
const SwitchTabs = ({ common, disabled = false, isCheckedSwitch, switchDataArr, noTopLeftRadius, noTopRightRadius, noBottomLeftRadius, noBottomRightRadius, onChange, onClick = () => null, testId, large, name, }) => {
    const theme = common ? '--common' : '--accent';
    const handleKeyDownClick = useCallback((e) => {
        if (e.key === 'Space' || e.key === 'Enter') {
            const target = e.target;
            const attr = target.getAttribute('data-attrid');
            if (!(attr === null || attr === void 0 ? void 0 : attr.includes('disabled'))) {
                onChange(attr);
            }
        }
    }, [onChange]);
    const shouldShowDivider = useCallback((index, value) => {
        return (index !== switchDataArr.length - 1 &&
            isCheckedSwitch !== value &&
            isCheckedSwitch !== switchDataArr[index + 1].value);
    }, [isCheckedSwitch, switchDataArr]);
    const borderRadiusClass = useMemo(() => cn$g({
        'no-top-left-radius': noTopLeftRadius,
        'no-top-right-radius': noTopRightRadius,
        'no-bottom-left-radius': noBottomLeftRadius,
        'no-bottom-right-radius': noBottomRightRadius,
    }), [noTopLeftRadius, noTopRightRadius, noBottomLeftRadius, noBottomRightRadius]);
    const handleChange = useCallback((e, isDisabled) => {
        const target = e.target;
        const { value } = target;
        !isDisabled && !disabled && onChange(value);
    }, [disabled, onChange]);
    return (React__default.createElement("div", { className: cn$g('switch-tabs', borderRadiusClass, {
            'switch-tabs-large': large,
            'switch-tabs--disabled': disabled,
        }) }, switchDataArr === null || switchDataArr === void 0 ? void 0 : switchDataArr.map((item, index) => (React__default.createElement("div", { tabIndex: 0, role: "button", className: cn$g('switch-tab', `switch-tab${theme}`, {
            'switch-tabs--disabled': item.disabled || disabled,
        }), key: item.id, "data-attrid": item.id, onKeyDown: handleKeyDownClick, onClick: () => !item.disabled && onClick(item.value) },
        React__default.createElement("input", { "data-testid": `${testId}-${index + 1}`, checked: isCheckedSwitch === item.value, onChange: (e) => handleChange(e, item.disabled), className: styles$2.input, name: name || 'choice', type: "radio", value: item.value, id: item.id, disabled: item.disabled || disabled }),
        React__default.createElement("label", { className: cn$g('label', `label${theme}`), htmlFor: item.id },
            item.label,
            isCheckedSwitch === item.value && (React__default.createElement(motion.div, { layoutId: `slider-${name}`, transition: { duration: 0.3 }, className: cn$g('label-slider', { 'label-slider-large': large }) }))),
        shouldShowDivider(index, item.value) && React__default.createElement("div", { className: styles$2.divider }))))));
};

var css_248z$9 = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.TariffWidget-module_container__gXZRI {\n  width: 23.2rem;\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.6rem;\n  padding: 2.4rem;\n  border: 0.1rem solid #eeeeee;\n  border-radius: 0.4rem;\n  font-family: \"Nunito Sans\", sans-serif;\n  color: #333333;\n  box-shadow: 0 2px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);\n}\n\n.TariffWidget-module_container-add-button__OCIRf {\n  padding-bottom: 1.6rem;\n}\n\n.TariffWidget-module_product__RCxDY {\n  font-size: 1.4rem;\n  line-height: 2rem;\n}\n\n.TariffWidget-module_tariff-wrap__CAzzm {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  column-gap: 0.8rem;\n  margin-top: 0.8rem;\n}\n\n.TariffWidget-module_icon-status__6Wgff {\n  display: flex;\n  align-items: center;\n}\n\n.TariffWidget-module_tariff-status__FNWM2 {\n  font-size: 2rem;\n  line-height: 2.2rem;\n  font-weight: 700;\n}\n\n.TariffWidget-module_tariff-info__pOlx1 {\n  color: #858594;\n}\n\n.TariffWidget-module_divider__Wsj7O {\n  width: 100%;\n  min-height: 0.2rem;\n  background: #eeeeee;\n  border-radius: 0.8rem;\n}\n\n.TariffWidget-module_divider-license__juPOc {\n  min-height: 0.1rem;\n}\n\n.TariffWidget-module_tariff-name__0KvJC {\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #858594;\n  margin-bottom: 0.8rem;\n}\n\n.TariffWidget-module_tariff-expiration__EkoCX {\n  font-weight: 700;\n}\n\n.TariffWidget-module_tariff-exp-wrap__UqutV {\n  display: flex;\n  column-gap: 0.8rem;\n}\n\n.TariffWidget-module_icon__mu2Ux {\n  max-height: 2rem;\n}\n\n.TariffWidget-module_docs-margin__sZDE6 {\n  margin-right: auto;\n}\n\n.TariffWidget-module_license-wrap__jEneA {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1.2rem;\n}\n\n.TariffWidget-module_license__whkNz {\n  text-decoration: underline;\n}\n\n.TariffWidget-module_roaming-info__iZVzn {\n  margin-bottom: 0;\n}\n\n.TariffWidget-module_button-wrap__S73KR {\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.8rem;\n  margin-top: 0.8rem;\n}\n\n.TariffWidget-module_warning-color__KDQH0 {\n  color: #dcae1d;\n}\n\n.TariffWidget-module_warning-border__cVr-6 {\n  border-color: #ecdcac;\n}\n\n.TariffWidget-module_alert-color__AZLZY {\n  color: #d12e34;\n}\n\n.TariffWidget-module_alert-border__-ORnY {\n  border-color: #e6b7b9;\n}\n\n.TariffWidget-module_edo-color__0tEfT {\n  color: #f5a91b;\n}";
var styles$1 = {"container":"TariffWidget-module_container__gXZRI","container-add-button":"TariffWidget-module_container-add-button__OCIRf","product":"TariffWidget-module_product__RCxDY","tariff-wrap":"TariffWidget-module_tariff-wrap__CAzzm","icon-status":"TariffWidget-module_icon-status__6Wgff","tariff-status":"TariffWidget-module_tariff-status__FNWM2","tariff-info":"TariffWidget-module_tariff-info__pOlx1","divider":"TariffWidget-module_divider__Wsj7O","divider-license":"TariffWidget-module_divider-license__juPOc","tariff-name":"TariffWidget-module_tariff-name__0KvJC","tariff-expiration":"TariffWidget-module_tariff-expiration__EkoCX","tariff-exp-wrap":"TariffWidget-module_tariff-exp-wrap__UqutV","icon":"TariffWidget-module_icon__mu2Ux","docs-margin":"TariffWidget-module_docs-margin__sZDE6","license-wrap":"TariffWidget-module_license-wrap__jEneA","license":"TariffWidget-module_license__whkNz","roaming-info":"TariffWidget-module_roaming-info__iZVzn","button-wrap":"TariffWidget-module_button-wrap__S73KR","warning-color":"TariffWidget-module_warning-color__KDQH0","warning-border":"TariffWidget-module_warning-border__cVr-6","alert-color":"TariffWidget-module_alert-color__AZLZY","alert-border":"TariffWidget-module_alert-border__-ORnY","edo-color":"TariffWidget-module_edo-color__0tEfT"};
styleInject(css_248z$9);

const cn$f = classNames.bind(styles$1);
const TariffWidget = memo$1(({ productName = '', title = '', subtitle, tariffName, expiredStatus, licenseQuantity, iconStatus, icon, payButton, addButton, roamingInfo, docsQuantity, expirationDate, licenseQueue, customClassNames = '', }) => {
    return (React__default.createElement("div", { className: cn$f('container', [customClassNames], {
            'container-add-button': !!addButton,
            'warning-border': !expiredStatus && expiredStatus !== undefined,
            'alert-border': expiredStatus,
        }), "data-testid": "tariff-widget" },
        React__default.createElement("div", null,
            React__default.createElement("div", { className: cn$f('product') }, productName),
            React__default.createElement("div", { className: cn$f('tariff-wrap') },
                iconStatus && (React__default.createElement("div", { className: cn$f('icon-status'), "data-testid": "icon-status" }, iconStatus)),
                React__default.createElement("div", null,
                    React__default.createElement("div", { className: cn$f('tariff-status') }, title),
                    subtitle && React__default.createElement("div", { className: cn$f('product', 'tariff-info') }, subtitle)))),
        React__default.createElement("div", { className: cn$f('divider') }),
        tariffName && React__default.createElement("div", { className: cn$f('tariff-name') }, tariffName),
        (docsQuantity || icon || expirationDate) && (React__default.createElement("div", { className: cn$f('product', 'tariff-expiration', {
                'tariff-exp-wrap': docsQuantity || icon,
            }) },
            icon && (React__default.createElement("div", { className: cn$f('icon'), "data-testid": "icon" }, icon)),
            docsQuantity && (React__default.createElement("span", { className: cn$f('product', 'tariff-expiration', 'docs-margin'), "data-testid": "docs-quantity" }, docsQuantity)),
            expirationDate && React__default.createElement("span", { "data-testid": "expiration-date" }, expirationDate))),
        licenseQuantity && (React__default.createElement("div", { className: cn$f('product', 'tariff-expiration') },
            React__default.createElement("div", { className: cn$f('divider', 'divider-license') }),
            React__default.createElement("div", { className: cn$f('license-wrap') },
                React__default.createElement("div", null, licenseQueue),
                React__default.createElement("div", null,
                    "+",
                    licenseQuantity)))),
        !licenseQuantity && roamingInfo && React__default.createElement("div", { className: cn$f('tariff-name', 'roaming-info') }, roamingInfo),
        React__default.createElement("div", { className: cn$f('button-wrap') },
            payButton,
            addButton)));
});
TariffWidget.displayName = 'TariffWidget';

var css_248z$8 = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.storybook-textarea__wrapper {\n  position: relative;\n}\n\n.storybook-textarea__label {\n  color: #254e5f;\n  font-family: Roboto, sans-serif;\n  font-size: 1.2rem;\n  font-weight: 400;\n  line-height: 1.6rem;\n  left: 1rem;\n  position: absolute;\n  top: 0.8rem;\n}\n\n.storybook-textarea__wrapper textarea {\n  background: #ffffff;\n  border: 0.1rem solid #d6d6d6;\n  border-radius: 0.2rem;\n  color: #254e5f;\n  font-family: Roboto, sans-serif;\n  font-size: 1.4rem;\n  height: 5rem;\n  line-height: 1.25rem;\n  outline: none;\n  padding: 2.2rem 3rem 0.25rem 1rem;\n  resize: none;\n  transition: 0.3s;\n  width: 100%;\n  display: block;\n}\n\n.storybook-textarea__wrapper textarea::placeholder {\n  color: #858594;\n}\n\n.storybook-textarea__wrapper textarea:disabled {\n  opacity: 0.3;\n  background: #eeeeee;\n}\n\n.storybook-textarea__wrapper.storybook-textarea--tab-selected textarea {\n  outline: 0.3rem solid #5bc0de;\n}\n\n.storybook-textarea__wrapper textarea:hover {\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  transition: 0.3s;\n}\n\n.storybook-textarea__wrapper--ofd textarea:hover {\n  border-color: #4ba1a5;\n}\n\n.storybook-textarea__wrapper--edo textarea:hover {\n  border-color: #f5a91b;\n}\n\n.storybook-textarea__wrapper--epd textarea:hover {\n  border-color: #f5a91b;\n}\n\n.storybook-textarea__wrapper--arenda textarea:hover {\n  border-color: #d58576;\n}\n\n.storybook-textarea__wrapper--gosotchet textarea:hover {\n  border-color: #488bca;\n}\n\n.storybook-textarea__wrapper--marking textarea:hover {\n  border-color: #4bb9ba;\n}\n\n.storybook-textarea__wrapper--check-index textarea:hover {\n  border-color: #5bc0de;\n}\n\n.storybook-textarea__wrapper--big-data textarea:hover {\n  border-color: #5ab8c5;\n}\n\n.storybook-textarea__wrapper--td textarea:hover {\n  border-color: #ea8242;\n}\n\n.storybook-textarea__wrapper--mchd textarea:hover {\n  border-color: #626ab7;\n}\n\n.storybook-textarea__wrapper--elk textarea:hover {\n  border-color: #577590;\n}\n\n.storybook-textarea__wrapper--error textarea {\n  border-color: #d12e34;\n}\n\n.storybook-textarea__wrapper--error .storybook-textarea__help-block {\n  color: #d12e34;\n}\n\n.storybook-textarea--warning textarea {\n  border-color: #dcae1d;\n}\n\n.storybook-textarea--warning .storybook-textarea__help-block {\n  color: #dcae1d;\n}\n\n.storybook-textarea--not-empty .storybook-textarea__label {\n  color: #858594;\n}\n\n.storybook-textarea__hintText,\n.storybook-textarea__help-block {\n  padding: 0.25rem 0 0.25rem 1rem;\n  margin: 0;\n  font-size: 1.4rem;\n}\n\n.storybook-textarea--active .storybook-textarea__label {\n  color: #858594;\n}\n.storybook-textarea--active .storybook-textarea__label_ofd {\n  color: #4ba1a5;\n}\n.storybook-textarea--active .storybook-textarea__label_edo {\n  color: #f5a91b;\n}\n.storybook-textarea--active .storybook-textarea__label_epd {\n  color: #f5a91b;\n}\n.storybook-textarea--active .storybook-textarea__label_gosotchet {\n  color: #488bca;\n}\n.storybook-textarea--active .storybook-textarea__label_td {\n  color: #ea8242;\n}\n.storybook-textarea--active .storybook-textarea__label_marking {\n  color: #4bb9ba;\n}\n.storybook-textarea--active .storybook-textarea__label_check-index {\n  color: #5bc0de;\n}\n.storybook-textarea--active .storybook-textarea__label_big-data {\n  color: #5ab8c5;\n}\n.storybook-textarea--active .storybook-textarea__label_arenda {\n  color: #d58576;\n}\n.storybook-textarea--active .storybook-textarea__label_integrations {\n  color: #797ca4;\n}\n.storybook-textarea--active .storybook-textarea__label_onec {\n  color: #e36052;\n}\n.storybook-textarea--active .storybook-textarea__label_mchd {\n  color: #626ab7;\n}\n.storybook-textarea--active .storybook-textarea__label_elk {\n  color: #577590;\n}\n\n.storybook-textarea--error .storybook-textarea__help-block {\n  color: #d12e34;\n}\n.storybook-textarea--error.storybook-textarea__wrapper textarea {\n  border-color: #d12e34;\n}\n\n.storybook-textarea--warning.storybook-textarea__wrapper textarea {\n  border-color: #dcae1d;\n}";
styleInject(css_248z$8);

const Textarea = ({ label, product, placeholder, disabled, error, warning, helpBlockText, testId, hintText = '', onChange = () => null, onKeyDown = () => null, onKeyUp = () => null, onBlur = () => null, innerText = '', maxLength, rows = 2, textAreaClassName = '', }) => {
    const [state, setState] = useState({
        text: '',
        isTabSelected: false,
        isActive: false,
    });
    const handleTextareaChange = (e) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { text: e.target.value })));
        onChange(e);
    };
    const handleKeyUp = useCallback((ev) => {
        const { code } = ev;
        setState((prev) => (Object.assign(Object.assign({}, prev), { isTabSelected: code === 'Tab' ? true : false })));
        onKeyUp(ev);
    }, [onKeyUp]);
    const handleMouseDown = useCallback(() => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { isTabSelected: false })));
    }, []);
    const handleBlur = useCallback((e) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { isTabSelected: false, isActive: false })));
        onBlur(e);
    }, [onBlur]);
    const handleFocus = useCallback(() => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { isTabSelected: false, isActive: true })));
    }, []);
    useEffect(() => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { text: innerText || '' })));
    }, [innerText]);
    return (React__default.createElement("div", { className: [
            'storybook-textarea__wrapper',
            `storybook-textarea__wrapper--${product}`,
            error ? 'storybook-textarea--error' : '',
            warning ? 'storybook-textarea--warning' : '',
            state.isTabSelected ? 'storybook-textarea--tab-selected' : '',
            state.text.length ? 'storybook-textarea--not-empty' : '',
            state.isActive ? 'storybook-textarea--active' : '',
        ].join(' ') },
        React__default.createElement("textarea", { className: textAreaClassName, "data-testid": testId, onInput: handleTextareaChange, onKeyDown: onKeyDown, onKeyUp: handleKeyUp, onBlur: handleBlur, onMouseDown: handleMouseDown, onFocus: handleFocus, disabled: disabled, placeholder: placeholder, value: state.text, maxLength: maxLength, rows: rows }),
        React__default.createElement("label", { htmlFor: "", className: ['storybook-textarea__label', `storybook-textarea__label_${product}`].join(' ') }, label),
        error || warning ? React__default.createElement("span", { className: "storybook-textarea__help-block" }, helpBlockText) : null,
        hintText && React__default.createElement("div", { className: "storybook-textarea__hintText" }, hintText)));
};

var css_248z$7 = ".MaskedTimeInput-module_masked__EEwV0 {\n  outline: none;\n}";
var s$5 = {"masked":"MaskedTimeInput-module_masked__EEwV0"};
styleInject(css_248z$7);

const MaskedTimeInput = forwardRef((props, ref) => {
    const { onClick, placeholder, value, onChange, onKeyDown, disabled } = props;
    return (React__default.createElement("div", { ref: ref, onClick: onClick, role: "button", tabIndex: 0, onKeyDown: () => null, className: s$5.masked, "aria-label": "onClick" },
        React__default.createElement(MaskedInputPackage, { mask: TIME_MASK$1, type: "text", placeholder: placeholder, value: value, onChange: onChange, onKeyDown: onKeyDown, disabled: disabled })));
});
MaskedTimeInput.displayName = 'MaskedTimeInput';

var css_248z$6 = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.datepicker {\n  position: relative;\n}\n.datepicker ::-webkit-scrollbar {\n  width: 8px;\n  background: #c7c7cc;\n}\n.datepicker ::-webkit-scrollbar-thumb {\n  background: #c7c7cc;\n}\n.datepicker ::-webkit-scrollbar-thumb:hover {\n  background-color: #c7c7cc;\n}\n.datepicker ::-webkit-scrollbar-button:vertical:start:decrement,\n.datepicker ::-webkit-scrollbar-button:horizontal:start:decrement,\n.datepicker ::-webkit-scrollbar-button:horizontal:end:increment {\n  display: none;\n}\n.datepicker .react-datepicker {\n  font-family: \"Nunito Sans\", sans-serif;\n  font-size: 1.2rem;\n  border: 0.1rem solid #bcd3d4;\n  border-radius: 0.2rem;\n  width: 100%;\n  top: -0.3rem;\n}\n.datepicker .react-datepicker__triangle {\n  display: none;\n}\n.datepicker .react-datepicker__header {\n  background-color: #ffffff;\n  border: none;\n  font-size: 1.4rem;\n}\n.datepicker .react-datepicker-popper {\n  z-index: 100;\n}\n.datepicker .react-datepicker__navigation-icon::before {\n  top: 1.2rem;\n}\n.datepicker .react-datepicker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.datepicker .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  border-bottom-color: #bcd3d4;\n}\n.datepicker .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  border-bottom-color: #ffffff;\n}\n\n.datepicker[class~=gosotchet] .react-datepicker__day--selected,\n.datepicker[class~=gosotchet] .react-datepicker__day--keyboard-selected {\n  background-color: #488bca;\n}\n.datepicker[class~=gosotchet] .react-datepicker__day--selected:hover,\n.datepicker[class~=gosotchet] .react-datepicker__day--keyboard-selected:hover {\n  background-color: #2c70af;\n}\n.datepicker[class~=gosotchet] ::-webkit-scrollbar-thumb {\n  background: #488bca;\n}\n.datepicker[class~=gosotchet] ::-webkit-scrollbar-thumb:hover {\n  background-color: #2c70af;\n}\n\n.datepicker[class~=edo] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #f5a91b;\n}\n.datepicker[class~=edo] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #e89700;\n}\n.datepicker[class~=edo] ::-webkit-scrollbar-thumb {\n  background: #f5a91b;\n}\n.datepicker[class~=edo] ::-webkit-scrollbar-thumb:hover {\n  background-color: #e89700;\n}\n\n.datepicker[class~=arenda] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #d58576;\n}\n.datepicker[class~=arenda] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #d58576;\n}\n.datepicker[class~=arenda] ::-webkit-scrollbar-thumb {\n  background: #d58576;\n}\n.datepicker[class~=arenda] ::-webkit-scrollbar-thumb:hover {\n  background-color: #d58576;\n}\n\n.datepicker[class~=marking] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #4bb9ba;\n}\n.datepicker[class~=marking] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #4bb9ba;\n}\n.datepicker[class~=marking] ::-webkit-scrollbar-thumb {\n  background: #4bb9ba;\n}\n.datepicker[class~=marking] ::-webkit-scrollbar-thumb:hover {\n  background-color: #4bb9ba;\n}\n\n.datepicker[class~=check-index] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #5bc0de;\n}\n.datepicker[class~=check-index] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #5bc0de;\n}\n.datepicker[class~=check-index] ::-webkit-scrollbar-thumb {\n  background: #5bc0de;\n}\n.datepicker[class~=check-index] ::-webkit-scrollbar-thumb:hover {\n  background-color: #5bc0de;\n}\n\n.datepicker[class~=big-data] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #5ab8c5;\n}\n.datepicker[class~=big-data] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #5ab8c5;\n}\n.datepicker[class~=big-data] ::-webkit-scrollbar-thumb {\n  background: #5ab8c5;\n}\n.datepicker[class~=big-data] ::-webkit-scrollbar-thumb:hover {\n  background-color: #5ab8c5;\n}\n\n.datepicker[class~=elk] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #577590;\n}\n.datepicker[class~=elk] .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #577590;\n}\n.datepicker[class~=elk] ::-webkit-scrollbar-thumb {\n  background: #577590;\n}\n.datepicker[class~=elk] ::-webkit-scrollbar-thumb:hover {\n  background-color: #577590;\n}";
styleInject(css_248z$6);

registerLocale('ru', ru);
const TimePicker = memo$1((props) => {
    const { product = '', selected, placeholder, name, setupDate, setupRawChange = () => null } = props;
    const [startDate, setStartDate] = useState(selected || null);
    useEffect(() => {
        setupDate(startDate);
    }, 
    /* eslint-disable-next-line */
    [startDate]);
    const handleRawChange = useCallback((event) => {
        setupRawChange(event);
    }, 
    /* eslint-disable-next-line */
    []);
    return (React__default.createElement("div", { className: `datepicker ${product}` },
        React__default.createElement(DatePicker$1, { locale: "ru", showTimeSelect: true, showTimeSelectOnly: true, timeIntervals: 15, timeCaption: "\u0412\u0440\u0435\u043C\u044F", dateFormat: "HH:mm", selected: startDate, onChange: setStartDate, onChangeRaw: handleRawChange, placeholderText: placeholder, shouldCloseOnSelect: false, customInput: React__default.createElement(MaskedTimeInput, null), name: name })));
});
TimePicker.displayName = 'TimePicker';

const FIRST_TIME = '12:00';
const INPUT_LENGTH = 4;

var css_248z$5 = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.TimeInput-module_timeInput__2QLxs .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #858594;\n}\n.TimeInput-module_timeInput__2QLxs .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #858594;\n}\n.TimeInput-module_timeInput__2QLxs:focus:not(.TimeInput-module_disabled__tHREC), .TimeInput-module_timeInput__2QLxs:focus-within:not(.TimeInput-module_disabled__tHREC) {\n  outline: none;\n}\n.TimeInput-module_timeInput__2QLxs:focus:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R, .TimeInput-module_timeInput__2QLxs:focus-within:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs.TimeInput-module_warning__gDaON .TimeInput-module_title__l1FD3 {\n  font-size: 1.4rem;\n}\n.TimeInput-module_timeInput__2QLxs.TimeInput-module_warning__gDaON .TimeInput-module_inputs__OnI-R {\n  outline: 0.1rem solid #dcae1d;\n}\n.TimeInput-module_timeInput__2QLxs.TimeInput-module_error__vcz8k .TimeInput-module_title__l1FD3 {\n  font-size: 1.4rem;\n}\n.TimeInput-module_timeInput__2QLxs.TimeInput-module_error__vcz8k .TimeInput-module_inputs__OnI-R {\n  outline: 0.1rem solid #d12e34;\n}\n.TimeInput-module_timeInput__2QLxs.TimeInput-module_disabled__tHREC {\n  outline: none;\n}\n.TimeInput-module_timeInput__2QLxs.TimeInput-module_disabled__tHREC .TimeInput-module_title__l1FD3 {\n  opacity: 0.3;\n}\n.TimeInput-module_timeInput__2QLxs.TimeInput-module_disabled__tHREC .TimeInput-module_inputs__OnI-R {\n  outline: 0.1rem solid rgba(214, 214, 214, 0.3);\n  background: rgba(255, 255, 255, 0.3);\n  opacity: 1;\n}\n.TimeInput-module_timeInput__2QLxs.TimeInput-module_disabled__tHREC .TimeInput-module_left__apyux svg {\n  opacity: 0.3;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=ofd]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=ofd]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #4ba1a5;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=ofd]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #4ba1a5;\n}\n.TimeInput-module_timeInput__2QLxs[class~=ofd]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=ofd]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #4ba1a5;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=ofd] .TimeInput-module_title__l1FD3 {\n  color: #4ba1a5;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=gosotchet]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=gosotchet]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #488bca;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=gosotchet]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #488bca;\n}\n.TimeInput-module_timeInput__2QLxs[class~=gosotchet]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=gosotchet]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #488bca;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=gosotchet] .TimeInput-module_title__l1FD3 {\n  color: #488bca;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=td]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=td]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #ea8242;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=td]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #ea8242;\n}\n.TimeInput-module_timeInput__2QLxs[class~=td]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=td]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #ea8242;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=td] .TimeInput-module_title__l1FD3 {\n  color: #ea8242;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=edo]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=edo]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #f5a91b;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=edo]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #f5a91b;\n}\n.TimeInput-module_timeInput__2QLxs[class~=edo]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=edo]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #f5a91b;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=edo] .TimeInput-module_title__l1FD3 {\n  color: #f5a91b;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=check-index]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=check-index]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=check-index]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #5bc0de;\n}\n.TimeInput-module_timeInput__2QLxs[class~=check-index]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=check-index]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #5bc0de;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=check-index] .TimeInput-module_title__l1FD3 {\n  color: #5bc0de;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=marking]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=marking]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #4bb9ba;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=marking]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #4bb9ba;\n}\n.TimeInput-module_timeInput__2QLxs[class~=marking]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=marking]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #4bb9ba;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=marking] .TimeInput-module_title__l1FD3 {\n  color: #4bb9ba;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=big-data]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=big-data]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #5ab8c5;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=big-data]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #5ab8c5;\n}\n.TimeInput-module_timeInput__2QLxs[class~=big-data]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=big-data]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #5ab8c5;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=big-data] .TimeInput-module_title__l1FD3 {\n  color: #5ab8c5;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=arenda]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=arenda]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #d58576;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=arenda]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #d58576;\n}\n.TimeInput-module_timeInput__2QLxs[class~=arenda]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=arenda]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #d58576;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=arenda] .TimeInput-module_title__l1FD3 {\n  color: #d58576;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=mchd]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=mchd]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #626ab7;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=mchd]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #626ab7;\n}\n.TimeInput-module_timeInput__2QLxs[class~=mchd]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=mchd]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #626ab7;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=mchd] .TimeInput-module_title__l1FD3 {\n  color: #626ab7;\n}\n\n.TimeInput-module_timeInput__2QLxs[class~=elk]:hover:not(.TimeInput-module_disabled__tHREC) {\n  cursor: pointer;\n}\n.TimeInput-module_timeInput__2QLxs[class~=elk]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  outline: 0.1rem solid #577590;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n}\n.TimeInput-module_timeInput__2QLxs[class~=elk]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(1) {\n  transition: 0.3s;\n  stroke: #577590;\n}\n.TimeInput-module_timeInput__2QLxs[class~=elk]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(2), .TimeInput-module_timeInput__2QLxs[class~=elk]:hover:not(.TimeInput-module_disabled__tHREC) .TimeInput-module_left__apyux svg path:nth-child(3) {\n  transition: 0.3s;\n  fill: #577590;\n}\n\n.TimeInput-module_typingStatus__typing__c-68i[class~=elk] .TimeInput-module_title__l1FD3 {\n  color: #577590;\n}\n\n.TimeInput-module_typingStatus__default__H5tp6 .TimeInput-module_title__l1FD3 {\n  color: #254e5f;\n}\n.TimeInput-module_typingStatus__typing__c-68i {\n  color: #488bca;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n.TimeInput-module_typingStatus__typing__c-68i .TimeInput-module_title__l1FD3 {\n  color: #488bca;\n}\n.TimeInput-module_typingStatus__cpomplete__JVD8x .TimeInput-module_title__l1FD3 {\n  color: #c7c7cc;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n\n.TimeInput-module_inputs__OnI-R {\n  transition: 0.3s;\n  height: 4.8rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  outline: 0.1rem solid #d6d6d6;\n  border-radius: 0.2rem;\n  padding: 0.8rem 1rem 0.8rem 1.8rem;\n  background-color: #ffffff;\n}\n\n.TimeInput-module_left__apyux {\n  display: flex;\n  margin: 0 0.9rem 0 0;\n}\n.TimeInput-module_left_icon__0Of7e path:nth-child(1) {\n  stroke: #c7c7cc;\n}\n.TimeInput-module_left_icon__0Of7e path:nth-child(2), .TimeInput-module_left_icon__0Of7e path:nth-child(3) {\n  fill: #c7c7cc;\n}\n.TimeInput-module_left__apyux svg {\n  display: inline-block;\n  width: 1.6rem;\n}\n\n.TimeInput-module_center__iheBy {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.TimeInput-module_title__l1FD3 {\n  font-family: \"Nunito Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n  color: #254e5f;\n}\n\n.TimeInput-module_dates__wOrbr {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.TimeInput-module_dates__wOrbr input {\n  border: none;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #254e5f;\n  width: 7.1rem;\n  background-color: transparent;\n}\n.TimeInput-module_dates__wOrbr input:focus {\n  outline: none;\n}\n.TimeInput-module_dates__wOrbr input::placeholder {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  color: #c7c7cc;\n}\n\n.TimeInput-module_delimiter__AzYwg {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  margin: 0 0.5rem;\n  color: #c7c7cc;\n}\n.TimeInput-module_delimiter__cpomplete__R-emG {\n  color: #254e5f;\n}\n\n.TimeInput-module_right__eor4L svg {\n  display: block;\n  width: 1.6rem;\n}\n\n.TimeInput-module_clear__n0Ji8 {\n  outline: none;\n  border: none;\n  box-shadow: none;\n  background: transparent;\n  transform: rotate(45deg);\n  width: 1rem;\n  margin-left: auto;\n  cursor: pointer;\n}\n.TimeInput-module_clear__n0Ji8 svg {\n  display: block;\n  width: 1.3rem;\n  stroke: #858594;\n}\n\n.TimeInput-module_messages__RhvxZ {\n  padding: 0 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n.TimeInput-module_messages_warning__ftVIh {\n  color: #dcae1d;\n}\n.TimeInput-module_messages_error__1JlYE {\n  color: #d12e34;\n}";
var s$4 = {"timeInput":"TimeInput-module_timeInput__2QLxs","left":"TimeInput-module_left__apyux","disabled":"TimeInput-module_disabled__tHREC","inputs":"TimeInput-module_inputs__OnI-R","warning":"TimeInput-module_warning__gDaON","title":"TimeInput-module_title__l1FD3","error":"TimeInput-module_error__vcz8k","typingStatus__typing":"TimeInput-module_typingStatus__typing__c-68i","typingStatus__default":"TimeInput-module_typingStatus__default__H5tp6","typingStatus__cpomplete":"TimeInput-module_typingStatus__cpomplete__JVD8x","left_icon":"TimeInput-module_left_icon__0Of7e","center":"TimeInput-module_center__iheBy","dates":"TimeInput-module_dates__wOrbr","delimiter":"TimeInput-module_delimiter__AzYwg","delimiter__cpomplete":"TimeInput-module_delimiter__cpomplete__R-emG","right":"TimeInput-module_right__eor4L","clear":"TimeInput-module_clear__n0Ji8","messages":"TimeInput-module_messages__RhvxZ","messages_warning":"TimeInput-module_messages_warning__ftVIh","messages_error":"TimeInput-module_messages_error__1JlYE"};
styleInject(css_248z$5);

const TimeInput = memo$1((props) => {
    const { valueFrom, valueTo, product = 'default', label = 'Период', nameFrom = '', placeholderFrom = FIRST_TIME, warningMsg = '', errorMsg = '', isDisabled = false, onChange = () => null, } = props;
    const [dateFrom, setDateFrom] = useState(valueFrom || '');
    const [dateTo, setDateTo] = useState(valueTo || '');
    const [isInputsVisible, setIsInputsVisible] = useState(false);
    const ref = useRef(null);
    const typingStatus = useMemo(() => {
        var _a, _b;
        const allLength = (_b = (_a = dateFrom.match(/\d/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        const maxLength = INPUT_LENGTH;
        if (allLength > 0 && allLength < maxLength) {
            return 'typing';
        }
        if (allLength === maxLength) {
            return 'complete';
        }
        return 'default';
    }, [dateFrom]);
    const handleClick = useCallback(() => {
        if (!isDisabled)
            setIsInputsVisible(true);
    }, [isDisabled]);
    const handleChangeFrom = useCallback((date) => {
        setDateFrom(date ? moment(new Date(date)).format('HH:mm') : '');
    }, []);
    const handleTypingFrom = useCallback((event) => {
        if (!event.target.value)
            return;
        setDateFrom(event.target.value);
    }, []);
    const selectedDate = useMemo(() => {
        if (valueFrom) {
            const [h, m] = valueFrom.split(':');
            const date = new Date();
            date.setHours(Number(h), Number(m));
            return date;
        }
        return new Date();
    }, [valueFrom]);
    const handleClear = useCallback((e) => {
        e.stopPropagation();
        setDateFrom('');
        setDateTo('');
    }, []);
    useEffect(() => {
        if (dateFrom || dateTo) {
            setIsInputsVisible(true);
        }
        if (!dateFrom && !dateTo) {
            setIsInputsVisible(false);
        }
    }, [dateFrom, dateTo]);
    useEffect(() => {
        onChange({
            from: dateFrom,
            to: dateTo,
        });
    }, 
    /* eslint-disable-next-line */
    [dateFrom, dateTo]);
    return (React__default.createElement("div", { className: cn$i(s$4.timeInput, {
            [s$4.error]: errorMsg,
            [s$4.warning]: warningMsg,
            [s$4.disabled]: isDisabled,
            [product]: product,
            [s$4.typingStatus__default]: typingStatus === 'default',
            [s$4.typingStatus__typing]: typingStatus === 'typing' && isInputsVisible,
            [s$4.typingStatus__cpomplete]: typingStatus === 'complete',
        }) },
        React__default.createElement("div", { ref: ref, className: s$4.inputs, onClick: handleClick, role: "button", onKeyDown: () => null, tabIndex: 0 },
            React__default.createElement("div", { className: s$4.left },
                React__default.createElement(Icon, { name: "clock", product: product })),
            React__default.createElement("div", { className: s$4.center },
                React__default.createElement("div", { className: s$4.title }, label),
                isInputsVisible && (React__default.createElement("div", { className: s$4.dates },
                    React__default.createElement(TimePicker, { product: product, selected: dateFrom === '' ? null : selectedDate, placeholder: placeholderFrom, name: nameFrom, setupDate: handleChangeFrom, setupRawChange: handleTypingFrom })))),
            (warningMsg || errorMsg) && (React__default.createElement("div", { className: s$4.right },
                errorMsg && React__default.createElement(Icon, { name: "exclamation", product: "gosotchet", theme: "error" }),
                warningMsg && React__default.createElement(Icon, { name: "exclamationTriangle", product: "gosotchet", theme: "warning" }))),
            (!!dateFrom || !!dateTo) && (React__default.createElement("button", { type: "button", className: cn$i(s$4.clear), onClick: handleClear, "aria-label": "handleClear" },
                React__default.createElement(Icon, { name: "plus", product: "gosotchet" })))),
        (warningMsg || errorMsg) && (React__default.createElement("div", { className: s$4.messages },
            warningMsg && React__default.createElement("div", { className: s$4.messages_warning }, warningMsg),
            errorMsg && React__default.createElement("div", { className: s$4.messages_error }, errorMsg)))));
});
TimeInput.displayName = 'TimeInput';

var css_248z$4 = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n/** Преобразует SCSS-переменные в CSS-переменные  */\n:root {\n  --DEFAULT_Primary_Color: #4ba1a5;\n  --DEFAULT_Primary_Middle: #40898c;\n  --OFD_Primary_Color: #4ba1a5;\n  --OFD_Primary_Middle: #40898c;\n  --EDO_Primary_Color: #f5a91b;\n  --EDO_Primary_Middle: #eb9d0c;\n  --EPD_Primary_Color: #f5a91b;\n  --EPD_Primary_Middle: #eb9d0c;\n  --GOSOTCHET_Primary_Color: #488bca;\n  --GOSOTCHET_Primary_Middle: #367aba;\n  --TD_Primary_Color: #ea8242;\n  --TD_Primary_Middle: #e76e23;\n  --MARKING_Primary_Color: #4bb9ba;\n  --MARKING_Primary_Middle: #3ea1a2;\n  --CHECK-INDEX_Primary_Color: #5bc0de;\n  --CHECK-INDEX_Primary_Middle: #3cb4d8;\n  --BIG-DATA_Primary_Color: #5ab8c5;\n  --BIG-DATA_Primary_Middle: #41aab9;\n  --ARENDA_Primary_Color: #d58576;\n  --ARENDA_Primary_Middle: #cd6d5b;\n  --INTEGRATIONS_Primary_Color: #797ca4;\n  --INTEGRATIONS_Primary_Middle: #646796;\n  --ONEC_Primary_Color: #e36052;\n  --ONEC_Primary_Middle: #cf3726;\n  --MCHD_Primary_Color: #626ab7;\n  --MCHD_Primary_Middle: #4c55a9;\n  --ELK_Primary_Color: #577590;\n  --ELK_Primary_Middle: #466077;\n}\n\n.Tumbler-module_tumbler__4izFR.Tumbler-module_disabled__CRTW1 {\n  opacity: 0.3;\n}\n.Tumbler-module_tumbler__4izFR.Tumbler-module_disabled__CRTW1 label {\n  cursor: default;\n}\n.Tumbler-module_tumbler__4izFR input[type=checkbox] {\n  display: none;\n}\n.Tumbler-module_tumbler__4izFR input[type=checkbox]:hover {\n  cursor: crosshair;\n}\n.Tumbler-module_tumbler__4izFR input[type=checkbox]:checked + label {\n  background-color: #4ba1a5;\n  border-color: #40898c;\n}\n.Tumbler-module_tumbler__4izFR input[type=checkbox]:checked + label .Tumbler-module_handler__JqEiK {\n  left: 1.4rem;\n}\n.Tumbler-module_tumbler__4izFR input[type=checkbox]:checked + label .Tumbler-module_center__uaeui {\n  background-color: #4ba1a5;\n  border-color: #4ba1a5;\n}\n.Tumbler-module_tumbler__4izFR label {\n  display: block;\n  width: 3rem;\n  height: 1.6rem;\n  border-radius: 2.5rem;\n  cursor: pointer;\n  transition: all 0.15s;\n  background-color: #eeeeee;\n  border: 0.1rem solid #eeeeee;\n  position: relative;\n}\n\n.Tumbler-module_handler__JqEiK {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  height: 1.4rem;\n  width: 1.4rem;\n  border-radius: 200rem;\n  left: 0;\n  top: 0;\n  box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.1), inset 0 0.1rem 0.4rem rgba(255, 255, 255, 0.3), inset 0 -0.1rem 0.4rem rgba(248, 248, 248, 0.3);\n  transition: all 0.15s;\n  background-color: #ffffff;\n  border: 0.1rem solid #f8f8f8;\n}\n\n.Tumbler-module_center__uaeui {\n  display: block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 200rem;\n  transition: all 0.15s;\n  background-color: #f8f8f8;\n  border: 0.1rem solid #eeeeee;\n}";
var styles = {"tumbler":"Tumbler-module_tumbler__4izFR","disabled":"Tumbler-module_disabled__CRTW1","handler":"Tumbler-module_handler__JqEiK","center":"Tumbler-module_center__uaeui"};
styleInject(css_248z$4);

const Tumbler = ({ product, isActive = false, isDisabled = false, onChange, testId = `tumbler-test-id`, }) => {
    const [state, setState] = useState({
        isChecked: false,
    });
    const uniqCompId = v4();
    useEffect(() => setState((prev) => (Object.assign(Object.assign({}, prev), { isChecked: isActive }))), [isActive]);
    const { labelColors } = useMemo(() => ({
        labelColors: state.isChecked
            ? {
                backgroundColor: `var(--${product.toUpperCase()}_Primary_Color)`,
                borderColor: `var(--${product.toUpperCase()}_Primary_Middle)`,
            }
            : {},
    }), [state.isChecked, product]);
    const { centerColors } = useMemo(() => ({
        centerColors: state.isChecked
            ? {
                backgroundColor: `var(--${product.toUpperCase()}_Primary_Color)`,
                borderColor: `var(--${product.toUpperCase()}_Primary_Color)`,
            }
            : {},
    }), [state.isChecked, product]);
    const handleClick = useCallback(() => {
        setState((prev) => {
            const newResult = !prev.isChecked;
            onChange(newResult);
            return Object.assign(Object.assign({}, prev), { isChecked: newResult });
        });
    }, [onChange]);
    return (React__default.createElement("div", { className: cn$i(styles.tumbler, styles[product], {
            [styles.disabled]: isDisabled,
            [styles.product]: product,
        }) },
        React__default.createElement("input", { id: uniqCompId, type: "checkbox", "data-testid": testId, onChange: handleClick, disabled: isDisabled, checked: state.isChecked }),
        React__default.createElement("label", { htmlFor: uniqCompId, style: labelColors },
            React__default.createElement("span", { className: styles.handler },
                React__default.createElement("span", { className: styles.center, style: centerColors })))));
};

var css_248z$3 = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.Alert-module_alert__zP4AL {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  position: relative;\n  color: #333333;\n  font-family: \"Nunito Sans\", sans-serif;\n  border-radius: 0.4rem;\n  min-width: 30rem;\n  max-width: 40rem;\n  padding: 2.4rem;\n  padding-left: 2rem;\n  border: 0.1rem solid;\n  border-left-width: 0.4rem;\n  margin-bottom: 1rem;\n  margin-right: 1.6rem;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.07);\n}\n.Alert-module_alert-success__c8onA {\n  background-color: #f5f9f0;\n  border-color: #8bc34a;\n}\n.Alert-module_alert-danger__yyITn {\n  background-color: #faebec;\n  border-color: #d12e34;\n}\n.Alert-module_alert-warning__vlL1c {\n  background-color: #faf5e5;\n  border-color: #dcae1d;\n}\n.Alert-module_alert-info__-h2bW {\n  background-color: #f3fafc;\n  border-color: #5bc0de;\n}\n.Alert-module_alert-left-border-reduce__97oXF {\n  border-left-width: 0.1rem;\n}\n.Alert-module_alert__zP4AL .Alert-module_cross__zTCfj {\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0.8rem;\n  right: 0.8rem;\n  border: none;\n  background-color: transparent;\n}\n.Alert-module_alert__zP4AL .Alert-module_cross__zTCfj.Alert-module_success__lftZT svg {\n  stroke: #d7e4c8;\n}\n.Alert-module_alert__zP4AL .Alert-module_cross__zTCfj.Alert-module_error__ah9Kg svg {\n  stroke: #e6b7b9;\n}\n.Alert-module_alert__zP4AL .Alert-module_cross__zTCfj.Alert-module_warning__uOpos svg {\n  stroke: #ecdcac;\n}\n.Alert-module_alert__zP4AL .Alert-module_cross__zTCfj.Alert-module_info__-J-F1 svg {\n  stroke: #ddeef4;\n}\n.Alert-module_alert__zP4AL .Alert-module_alert-info__-h2bW .Alert-module_leftIcon__x-aO7 {\n  transform: rotate(180deg);\n}\n.Alert-module_alert__zP4AL .Alert-module_leftIcon__x-aO7 {\n  margin-right: 1.6rem;\n}\n.Alert-module_alert__zP4AL .Alert-module_middle-block__IqcRf {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  margin-left: 3.6rem;\n  font-size: 1.4rem;\n  white-space: pre-line;\n  line-height: 1.8rem;\n  word-break: break-word;\n}\n.Alert-module_alert__zP4AL .Alert-module_title__QHuwO {\n  font-size: 1.8rem;\n  line-height: 2.4rem;\n  font-weight: 700;\n}\n.Alert-module_alert__zP4AL .Alert-module_upper-block__g6V42 {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 0.4rem;\n}";
var s$3 = {"alert":"Alert-module_alert__zP4AL","alert-success":"Alert-module_alert-success__c8onA","alert-danger":"Alert-module_alert-danger__yyITn","alert-warning":"Alert-module_alert-warning__vlL1c","alert-info":"Alert-module_alert-info__-h2bW","alert-left-border-reduce":"Alert-module_alert-left-border-reduce__97oXF","cross":"Alert-module_cross__zTCfj","success":"Alert-module_success__lftZT","error":"Alert-module_error__ah9Kg","warning":"Alert-module_warning__uOpos","info":"Alert-module_info__-J-F1","leftIcon":"Alert-module_leftIcon__x-aO7","middle-block":"Alert-module_middle-block__IqcRf","title":"Alert-module_title__QHuwO","upper-block":"Alert-module_upper-block__g6V42"};
styleInject(css_248z$3);

const cn$e = classNames.bind(s$3);
const SUCCESS_ALERT_SHOW_TIME = 5000;
const ERROR_ALERT_SHOW_TIME = 30000;
const PageAlert = memo$1(({ id, headerText, text, variant, removeAlert, successAlertShowTime, errorAlertShowTime, leftBorderReduce, isRemoveButtonHidden = false, }) => {
    const showAlertTime = variant === 'success'
        ? successAlertShowTime || SUCCESS_ALERT_SHOW_TIME
        : errorAlertShowTime || ERROR_ALERT_SHOW_TIME;
    const iconData = useMemo(() => {
        let iconLeft;
        switch (variant) {
            case 'success':
                iconLeft = { name: 'flowStatusOk', title: 'Уведомление', theme: 'success' };
                break;
            case 'warning':
                iconLeft = { name: 'exclamationTriangle', title: 'Уведомление', theme: 'warning' };
                break;
            case 'danger':
                iconLeft = { name: 'circle_cross', title: 'Ошибка', theme: 'error' };
                break;
            case 'info':
                iconLeft = { name: 'flowStatusAlert', title: 'Информация', theme: 'info' };
                break;
            default:
                iconLeft = { name: 'exclamationTriangle', title: 'Уведомление', theme: 'warning' };
        }
        return iconLeft;
    }, [variant]);
    const closeAlert = useCallback((showTime) => {
        setTimeout(() => {
            removeAlert(id);
        }, showTime);
    }, [removeAlert, id]);
    const handleAlertClose = useCallback(() => {
        closeAlert(0);
    }, [closeAlert]);
    useEffect(() => {
        const timerID = setTimeout(() => {
            closeAlert(showAlertTime);
        }, showAlertTime);
        return () => {
            clearTimeout(timerID);
        };
    }, [showAlertTime, closeAlert]);
    return (React__default.createElement("div", { className: cn$e('alert-container', `alert-${variant}`, 'alert', {
            'alert-left-border-reduce': leftBorderReduce,
        }), "data-testid": "alert-wrapper" },
        React__default.createElement("div", { className: cn$e('upper-block') },
            React__default.createElement("div", { className: cn$e('leftIcon'), "data-testid": "left-icon" },
                React__default.createElement(Icon, Object.assign({ name: iconData.name, product: "edo", width: "2rem", iconFill: true, iconStroke: false, theme: variant === 'warning' ? 'grey' : 'info' }, (variant === 'warning' && { strokeSecond: '#EEAF41' })))),
            React__default.createElement("div", { className: cn$e('title'), "data-testid": "alert-text" }, headerText || iconData.title)),
        React__default.createElement("div", { className: cn$e('middle-block'), "data-testid": "alert-header" }, Array.isArray(text) ? text.map((text, index) => React__default.createElement("div", { key: text + index, "data-testid": "alert-text-element" }, text)) : React__default.createElement("div", null, text)),
        !isRemoveButtonHidden && (React__default.createElement("button", { onClick: handleAlertClose, className: cn$e('cross', iconData.theme), "data-testid": "close-btn" },
            React__default.createElement(Icon, { name: "cross", iconStroke: true, product: "edo", height: "1.6rem", width: "1.6rem" })))));
});
PageAlert.displayName = 'PageAlert';

var css_248z$2 = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.SearchInput-module_searchInput__v28H1 {\n  position: relative;\n  width: 100%;\n}\n.SearchInput-module_searchInput__v28H1 .SearchInput-module_icon__wZurk {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 1.6rem;\n  transform: translateY(-50%);\n}\n.SearchInput-module_searchInput__v28H1 .SearchInput-module_icon__wZurk svg {\n  transition: all 300ms;\n}\n.SearchInput-module_searchInput__v28H1 .SearchInput-module_input__kG-Ma {\n  width: 100%;\n  padding: 2.3rem 0 0.9rem 4rem;\n  color: #333333;\n  background-color: #f8f8f8;\n  font-family: Roboto, sans-serif;\n  font-size: 1.4rem;\n  line-height: 1.6rem;\n  border: 0.1rem solid #d6d6d6;\n  border-radius: 200rem;\n  outline: none;\n  transition: all 300ms;\n}\n.SearchInput-module_searchInput--default__WgTay .SearchInput-module_input__kG-Ma:focus {\n  border-color: #858594;\n}\n.SearchInput-module_searchInput--default__WgTay .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #858594;\n}\n.SearchInput-module_searchInput--default__WgTay .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #858594;\n}\n.SearchInput-module_searchInput--edo__Qd5H1 .SearchInput-module_input__kG-Ma:focus {\n  border-color: #f5a91b;\n}\n.SearchInput-module_searchInput--edo__Qd5H1 .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #f5a91b;\n}\n.SearchInput-module_searchInput--edo__Qd5H1 .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #f5a91b;\n}\n.SearchInput-module_searchInput--epd__Z1fQ3 .SearchInput-module_input__kG-Ma:focus {\n  border-color: #f5a91b;\n}\n.SearchInput-module_searchInput--epd__Z1fQ3 .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #f5a91b;\n}\n.SearchInput-module_searchInput--epd__Z1fQ3 .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #f5a91b;\n}\n.SearchInput-module_searchInput--ofd__Qhr0I .SearchInput-module_input__kG-Ma:focus {\n  border-color: #4ba1a5;\n}\n.SearchInput-module_searchInput--ofd__Qhr0I .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #4ba1a5;\n}\n.SearchInput-module_searchInput--ofd__Qhr0I .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #4ba1a5;\n}\n.SearchInput-module_searchInput--gosotchet__HMusG .SearchInput-module_input__kG-Ma:focus {\n  border-color: #488bca;\n}\n.SearchInput-module_searchInput--gosotchet__HMusG .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #488bca;\n}\n.SearchInput-module_searchInput--gosotchet__HMusG .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #488bca;\n}\n.SearchInput-module_searchInput--td__uE830 .SearchInput-module_input__kG-Ma:focus {\n  border-color: #ea8242;\n}\n.SearchInput-module_searchInput--td__uE830 .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #ea8242;\n}\n.SearchInput-module_searchInput--td__uE830 .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #ea8242;\n}\n.SearchInput-module_searchInput--marking__pQCaw .SearchInput-module_input__kG-Ma:focus {\n  border-color: #4bb9ba;\n}\n.SearchInput-module_searchInput--marking__pQCaw .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #4bb9ba;\n}\n.SearchInput-module_searchInput--marking__pQCaw .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #4bb9ba;\n}\n.SearchInput-module_searchInput--check-index__zm3vQ .SearchInput-module_input__kG-Ma:focus {\n  border-color: #5bc0de;\n}\n.SearchInput-module_searchInput--check-index__zm3vQ .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #5bc0de;\n}\n.SearchInput-module_searchInput--check-index__zm3vQ .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #5bc0de;\n}\n.SearchInput-module_searchInput--big-data__P3O80 .SearchInput-module_input__kG-Ma:focus {\n  border-color: #5ab8c5;\n}\n.SearchInput-module_searchInput--big-data__P3O80 .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #5ab8c5;\n}\n.SearchInput-module_searchInput--big-data__P3O80 .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #5ab8c5;\n}\n.SearchInput-module_searchInput--arenda__-Ku5q .SearchInput-module_input__kG-Ma:focus {\n  border-color: #d58576;\n}\n.SearchInput-module_searchInput--arenda__-Ku5q .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #d58576;\n}\n.SearchInput-module_searchInput--arenda__-Ku5q .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #d58576;\n}\n.SearchInput-module_searchInput--integrations__HrvqX .SearchInput-module_input__kG-Ma:focus {\n  border-color: #797ca4;\n}\n.SearchInput-module_searchInput--integrations__HrvqX .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #797ca4;\n}\n.SearchInput-module_searchInput--integrations__HrvqX .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #797ca4;\n}\n.SearchInput-module_searchInput--onec__MY5AQ .SearchInput-module_input__kG-Ma:focus {\n  border-color: #e36052;\n}\n.SearchInput-module_searchInput--onec__MY5AQ .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #e36052;\n}\n.SearchInput-module_searchInput--onec__MY5AQ .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #e36052;\n}\n.SearchInput-module_searchInput--mchd__LIJjh .SearchInput-module_input__kG-Ma:focus {\n  border-color: #626ab7;\n}\n.SearchInput-module_searchInput--mchd__LIJjh .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #626ab7;\n}\n.SearchInput-module_searchInput--mchd__LIJjh .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #626ab7;\n}\n.SearchInput-module_searchInput--elk__fK6AO .SearchInput-module_input__kG-Ma:focus {\n  border-color: #577590;\n}\n.SearchInput-module_searchInput--elk__fK6AO .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_label__5Mjrx {\n  color: #577590;\n}\n.SearchInput-module_searchInput--elk__fK6AO .SearchInput-module_input__kG-Ma:focus ~ .SearchInput-module_icon__wZurk svg {\n  stroke: #577590;\n}\n.SearchInput-module_searchInput__v28H1 .SearchInput-module_label__5Mjrx {\n  position: absolute;\n  top: 0.9rem;\n  left: 4.1rem;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n  font-weight: 600;\n  color: #254e5f;\n  transition: all 300ms;\n}";
var s$2 = {"searchInput":"SearchInput-module_searchInput__v28H1","icon":"SearchInput-module_icon__wZurk","input":"SearchInput-module_input__kG-Ma","searchInput--default":"SearchInput-module_searchInput--default__WgTay","label":"SearchInput-module_label__5Mjrx","searchInput--edo":"SearchInput-module_searchInput--edo__Qd5H1","searchInput--epd":"SearchInput-module_searchInput--epd__Z1fQ3","searchInput--ofd":"SearchInput-module_searchInput--ofd__Qhr0I","searchInput--gosotchet":"SearchInput-module_searchInput--gosotchet__HMusG","searchInput--td":"SearchInput-module_searchInput--td__uE830","searchInput--marking":"SearchInput-module_searchInput--marking__pQCaw","searchInput--check-index":"SearchInput-module_searchInput--check-index__zm3vQ","searchInput--big-data":"SearchInput-module_searchInput--big-data__P3O80","searchInput--arenda":"SearchInput-module_searchInput--arenda__-Ku5q","searchInput--integrations":"SearchInput-module_searchInput--integrations__HrvqX","searchInput--onec":"SearchInput-module_searchInput--onec__MY5AQ","searchInput--mchd":"SearchInput-module_searchInput--mchd__LIJjh","searchInput--elk":"SearchInput-module_searchInput--elk__fK6AO"};
styleInject(css_248z$2);

const cn$d = classNames.bind(s$2);
const SearchInput = memo$1(({ name, value, placeholder, onChange, className, label, autoFocus = false, product }) => {
    return (React__default.createElement("div", { className: cn$d('searchInput', {
            ['searchInput--' + product]: product,
        }) },
        React__default.createElement("input", { id: "searchInput", className: cn$d('input', className), name: name, type: "text", placeholder: placeholder, value: value, onChange: onChange, 
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: autoFocus }),
        React__default.createElement("label", { htmlFor: "searchInput", className: cn$d('label') }, label),
        React__default.createElement("div", { className: cn$d('icon') },
            React__default.createElement(Icon, { name: "search", product: product, width: "16", height: "16", iconStroke: true, theme: "grey" }))));
});
SearchInput.displayName = 'SearchInput';

const useClickOutside = (ref, callback) => {
    const handleClick = (e) => {
        if (ref.current && !ref.current.contains(e.target)) {
            callback();
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    });
};

var css_248z$1 = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.Select-module_select__U4LyF {\n  width: 100%;\n  border-radius: 0.2rem;\n  cursor: pointer;\n  position: relative;\n}\n.Select-module_select__U4LyF.Select-module_disabled__kkzG- {\n  opacity: 0.3;\n}\n.Select-module_select__U4LyF.Select-module_short__IruIg .Select-module_options__wEx3O {\n  max-height: 19rem;\n}\n\n.Select-module_top__tb3rg {\n  width: inherit;\n  border: none;\n  text-align: left;\n  background-color: #ffffff;\n  position: relative;\n  padding: 0.7rem 1.6rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 0.2rem;\n  transition: 0.3s;\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_top__tb3rg:hover {\n  transition: 0.3s;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.Select-module_top__tb3rg:active {\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.Select-module_top__tb3rg.Select-module_warning__S-Obb {\n  border: 0.1rem solid #dcae1d;\n}\n.Select-module_top__tb3rg.Select-module_error__yikGO {\n  border: 0.1rem solid #d12e34;\n}\n.Select-module_top__tb3rg:focus {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.Select-module_top__tb3rg.Select-module_disabled__kkzG- {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_top_left__ymu4x svg {\n  width: 1.5rem;\n}\n.Select-module_top_center__PidWF {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 1%;\n}\n.Select-module_top_title__l5BCV {\n  font: 1.2rem/1.6rem \"Nunito Sans\", sans-serif;\n  color: #254e5f;\n}\n.Select-module_top_title_grey__OGNau {\n  color: #858594;\n}\n.Select-module_top_subTitle__BOyHI {\n  font: 1.4rem/1.6rem Roboto, sans-serif;\n  color: #858594;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.Select-module_top_subTitle__BOyHI.Select-module_completed__-73Y2 {\n  color: #254e5f;\n}\n.Select-module_top_leftIcon__luaLY {\n  display: block;\n  margin-right: 1rem;\n}\n.Select-module_top_leftIcon__luaLY svg {\n  display: block;\n}\n\n.Select-module_inputSearch__u2qpM {\n  width: inherit;\n  border: none;\n  text-align: left;\n  padding: 0;\n}\n\n.Select-module_alerts__C8ZjW {\n  font: 400 1.2rem/1.6rem Roboto, sans-serif;\n  margin: 0.2rem 0 0.4rem 1.8rem;\n  position: absolute;\n}\n.Select-module_alerts_error__je9Cp {\n  color: #d12e34;\n}\n.Select-module_alerts_warning__Ny0Qp {\n  color: #dcae1d;\n}\n\n.Select-module_options_container__wCKqI {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  bottom: -0.4rem;\n}\n\n.Select-module_options_container_up__Ty0bE {\n  top: -0.4rem;\n  bottom: auto;\n}\n\n.Select-module_options__wEx3O {\n  box-sizing: border-box;\n  position: absolute;\n  width: 100%;\n  border-radius: 0.2rem;\n  max-height: 50vh;\n  overflow-y: scroll;\n  box-shadow: 0 0.3rem 0.8rem 0 rgba(0, 0, 0, 0.07);\n  border: 0.1rem solid #eeeeee;\n  scrollbar-width: none;\n}\n.Select-module_options__wEx3O ::-webkit-scrollbar {\n  width: 0px;\n}\n.Select-module_options__wEx3O ::-webkit-scrollbar-thumb {\n  background-color: transparent;\n}\n\n.Select-module_options_up__7JRhJ {\n  bottom: 0;\n}\n\n.Select-module_option__Ad-4R {\n  width: inherit;\n  border: none;\n  text-align: left;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 1rem 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-size: 1.4rem;\n  color: #254e5f;\n  background-color: #ffffff;\n  cursor: pointer;\n  border: 0.1rem solid transparent;\n  border-bottom: 0.1rem solid #eeeeee;\n}\n.Select-module_option__Ad-4R:hover {\n  background-color: #f8f8f8;\n}\n.Select-module_optionLength__G5jdF {\n  padding: 1rem 1.8rem;\n  font: 400 1.4rem/1.6rem Roboto, sans-serif;\n  color: #858594;\n  border: 0.1rem solid transparent;\n  cursor: default;\n  background-color: #ffffff;\n}\n.Select-module_option__Ad-4R:last-child {\n  border-bottom: none;\n}\n\n/* ofd product */\n.Select-module_select__U4LyF[class~=ofd] svg {\n  stroke: #4ba1a5;\n}\n.Select-module_select__U4LyF[class~=ofd] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=ofd] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=ofd] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=ofd] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=ofd] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #4ba1a5;\n}\n.Select-module_select__U4LyF[class~=ofd] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #4ba1a5;\n}\n.Select-module_select__U4LyF[class~=ofd] .Select-module_top_open_options__j6lmw {\n  border: 0.1rem solid #bcd3d4;\n}\n.Select-module_select__U4LyF[class~=ofd] .Select-module_top_open__3kDM2 .Select-module_top_title__l5BCV {\n  color: #4ba1a5;\n}\n.Select-module_select__U4LyF[class~=ofd] .Select-module_option_selected__xpRMd {\n  color: #4ba1a5;\n}\n.Select-module_select__U4LyF[class~=ofd] .Select-module_option__Ad-4R:hover {\n  color: #4ba1a5;\n}\n\n/* gosotchet product */\n.Select-module_select__U4LyF[class~=gosotchet] svg {\n  stroke: #488bca;\n}\n.Select-module_select__U4LyF[class~=gosotchet] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=gosotchet] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=gosotchet] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=gosotchet] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=gosotchet] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #488bca;\n}\n.Select-module_select__U4LyF[class~=gosotchet] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #488bca;\n}\n.Select-module_select__U4LyF[class~=gosotchet] .Select-module_option_selected__xpRMd {\n  color: #488bca;\n}\n.Select-module_select__U4LyF[class~=gosotchet] .Select-module_option__Ad-4R:hover {\n  color: #488bca;\n}\n\n/* td product */\n.Select-module_select__U4LyF[class~=td] svg {\n  stroke: #ea8242;\n}\n.Select-module_select__U4LyF[class~=td] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=td] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=td] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=td] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=td] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #ea8242;\n}\n.Select-module_select__U4LyF[class~=td] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #ea8242;\n}\n.Select-module_select__U4LyF[class~=td] .Select-module_option_selected__xpRMd {\n  color: #ea8242;\n}\n.Select-module_select__U4LyF[class~=td] .Select-module_option__Ad-4R:hover {\n  color: #ea8242;\n}\n\n/* arenda product */\n.Select-module_select__U4LyF[class~=arenda] svg {\n  stroke: #d58576;\n}\n.Select-module_select__U4LyF[class~=arenda] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=arenda] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=arenda] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=arenda] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=arenda] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #d58576;\n}\n.Select-module_select__U4LyF[class~=arenda] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #d58576;\n}\n.Select-module_select__U4LyF[class~=arenda] .Select-module_option_selected__xpRMd {\n  color: #d58576;\n}\n.Select-module_select__U4LyF[class~=arenda] .Select-module_option__Ad-4R:hover {\n  color: #d58576;\n}\n\n/* check-index product */\n.Select-module_select__U4LyF[class~=check-index] svg {\n  stroke: #5bc0de;\n}\n.Select-module_select__U4LyF[class~=check-index] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=check-index] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=check-index] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=check-index] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=check-index] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #5bc0de;\n}\n.Select-module_select__U4LyF[class~=check-index] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #5bc0de;\n}\n.Select-module_select__U4LyF[class~=check-index] .Select-module_option_selected__xpRMd {\n  color: #5bc0de;\n}\n.Select-module_select__U4LyF[class~=check-index] .Select-module_option__Ad-4R:hover {\n  color: #5bc0de;\n}\n\n/* marking product */\n.Select-module_select__U4LyF[class~=marking] svg {\n  stroke: #4bb9ba;\n}\n.Select-module_select__U4LyF[class~=marking] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=marking] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=marking] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=marking] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=marking] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #4bb9ba;\n}\n.Select-module_select__U4LyF[class~=marking] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #4bb9ba;\n}\n.Select-module_select__U4LyF[class~=marking] .Select-module_option_selected__xpRMd {\n  color: #4bb9ba;\n}\n.Select-module_select__U4LyF[class~=marking] .Select-module_option__Ad-4R:hover {\n  color: #4bb9ba;\n}\n\n/* big-data product */\n.Select-module_select__U4LyF[class~=big-data] svg {\n  stroke: #5ab8c5;\n}\n.Select-module_select__U4LyF[class~=big-data] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=big-data] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=big-data] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=big-data] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=big-data] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #5ab8c5;\n}\n.Select-module_select__U4LyF[class~=big-data] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #5ab8c5;\n}\n.Select-module_select__U4LyF[class~=big-data] .Select-module_option_selected__xpRMd {\n  color: #5ab8c5;\n}\n.Select-module_select__U4LyF[class~=big-data] .Select-module_option__Ad-4R:hover {\n  color: #5ab8c5;\n}\n\n/* edo product */\n.Select-module_select__U4LyF[class~=edo] svg {\n  stroke: #f5a91b;\n}\n.Select-module_select__U4LyF[class~=edo] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=edo] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=edo] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=edo] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=edo] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #f5a91b;\n}\n.Select-module_select__U4LyF[class~=edo] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #f5a91b;\n}\n.Select-module_select__U4LyF[class~=edo] .Select-module_option_selected__xpRMd {\n  color: #f5a91b;\n}\n.Select-module_select__U4LyF[class~=edo] .Select-module_option__Ad-4R:hover {\n  color: #f5a91b;\n}\n\n/* epd product */\n.Select-module_select__U4LyF[class~=epd] svg {\n  stroke: #f5a91b;\n}\n.Select-module_select__U4LyF[class~=epd] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=epd] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=epd] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=epd] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=epd] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #f5a91b;\n}\n.Select-module_select__U4LyF[class~=epd] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #f5a91b;\n}\n.Select-module_select__U4LyF[class~=epd] .Select-module_option_selected__xpRMd {\n  color: #f5a91b;\n}\n.Select-module_select__U4LyF[class~=epd] .Select-module_option__Ad-4R:hover {\n  color: #f5a91b;\n}\n\n/* mchd product */\n.Select-module_select__U4LyF[class~=mchd] svg {\n  stroke: #626ab7;\n}\n.Select-module_select__U4LyF[class~=mchd] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=mchd] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=mchd] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=mchd] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=mchd] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #626ab7;\n}\n.Select-module_select__U4LyF[class~=mchd] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #626ab7;\n}\n.Select-module_select__U4LyF[class~=mchd] .Select-module_option_selected__xpRMd {\n  color: #626ab7;\n}\n.Select-module_select__U4LyF[class~=mchd] .Select-module_option__Ad-4R:hover {\n  color: #626ab7;\n}\n\n/* elk product */\n.Select-module_select__U4LyF[class~=elk] svg {\n  stroke: #577590;\n}\n.Select-module_select__U4LyF[class~=elk] .Select-module_top__tb3rg {\n  outline: none;\n}\n.Select-module_select__U4LyF[class~=elk] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:hover, .Select-module_select__U4LyF[class~=elk] .Select-module_top__tb3rg.Select-module_disabled__kkzG-:active {\n  border: 0.1rem solid #d6d6d6;\n}\n.Select-module_select__U4LyF[class~=elk] .Select-module_top__tb3rg:hover, .Select-module_select__U4LyF[class~=elk] .Select-module_top__tb3rg:active {\n  border: 0.1rem solid #577590;\n}\n.Select-module_select__U4LyF[class~=elk] .Select-module_top__tb3rg.Select-module_top_open_options__j6lmw .Select-module_top_title__l5BCV {\n  color: #577590;\n}\n.Select-module_select__U4LyF[class~=elk] .Select-module_option_selected__xpRMd {\n  color: #577590;\n}\n.Select-module_select__U4LyF[class~=elk] .Select-module_option__Ad-4R:hover {\n  color: #577590;\n}\n\n.Select-module_iconRequired__moWmK {\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 50%;\n  background-color: #d12e34;\n  position: absolute;\n  top: 0.6rem;\n  left: 0.6rem;\n}";
var s$1 = {"select":"Select-module_select__U4LyF","disabled":"Select-module_disabled__kkzG-","short":"Select-module_short__IruIg","options":"Select-module_options__wEx3O","top":"Select-module_top__tb3rg","warning":"Select-module_warning__S-Obb","error":"Select-module_error__yikGO","top_left":"Select-module_top_left__ymu4x","top_center":"Select-module_top_center__PidWF","top_title":"Select-module_top_title__l5BCV","top_title_grey":"Select-module_top_title_grey__OGNau","top_subTitle":"Select-module_top_subTitle__BOyHI","completed":"Select-module_completed__-73Y2","top_leftIcon":"Select-module_top_leftIcon__luaLY","inputSearch":"Select-module_inputSearch__u2qpM","alerts":"Select-module_alerts__C8ZjW","alerts_error":"Select-module_alerts_error__je9Cp","alerts_warning":"Select-module_alerts_warning__Ny0Qp","options_container":"Select-module_options_container__wCKqI","options_container_up":"Select-module_options_container_up__Ty0bE","options_up":"Select-module_options_up__7JRhJ","option":"Select-module_option__Ad-4R","optionLength":"Select-module_optionLength__G5jdF","top_open_options":"Select-module_top_open_options__j6lmw","top_open":"Select-module_top_open__3kDM2","option_selected":"Select-module_option_selected__xpRMd","iconRequired":"Select-module_iconRequired__moWmK"};
styleInject(css_248z$1);

const cn$c = classNames.bind(s$1);
const Select = memo$1((props) => {
    const { options, title, subTitle, onSelect, isShort = false, isMultiple = false, isDisabled = false, errorMessage = '', warningMessage = '', iconName, product, iconStroke, iconFill, dropDirection = 'down', dropDownId = '', isSearch = false, onChangeValueSearch = () => { }, valueSearch, isInitialLoad = true, numberOptions, placeholderAtIsSearch = 'Введите наименование для поиска', required, } = props;
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    const selected = useMemo(() => options.filter((opt) => opt.isSelected), [options]);
    const isDropDirectionUp = useMemo(() => {
        return dropDirection === 'up';
    }, [dropDirection]);
    useClickOutside(ref, () => setIsOpen(false));
    const handleOptionClick = useCallback((option) => {
        const newOptions = options.map((o) => {
            const newOption = Object.assign({}, o);
            if (!isMultiple) {
                newOption.isSelected = false;
            }
            if (newOption.value === option.value) {
                newOption.isSelected = !newOption.isSelected;
            }
            return newOption;
        });
        onSelect(newOptions);
        return isMultiple || setIsOpen(false);
    }, [isMultiple, options, onSelect]);
    const handleTitleClick = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);
    const isAlertsVisible = useMemo(() => !!errorMessage || !!warningMessage, [errorMessage, warningMessage]);
    const isViewOptions = useMemo(() => isOpen && !isDisabled && (!!options.length || (isSearch && numberOptions)), [isOpen, isDisabled, isSearch, options, numberOptions]);
    useEffect(() => {
        if ((valueSearch === null || valueSearch === void 0 ? void 0 : valueSearch.length) && isSearch && !isInitialLoad) {
            setIsOpen(true);
        }
        else {
            setIsOpen(false);
        }
    }, [valueSearch, isSearch, isInitialLoad]);
    return (React__default.createElement("div", { className: cn$c('select', { disabled: isDisabled, [product]: product, short: isShort, top_open_options: isOpen }), ref: ref },
        isSearch && (React__default.createElement("button", { className: cn$c('inputSearch'), type: "button", onClick: (e) => {
                if (e.detail === 0) {
                    e.preventDefault();
                    return;
                }
                handleTitleClick();
            } },
            React__default.createElement(Input$1, { label: title, placeholder: selected.length && valueSearch ? selected === null || selected === void 0 ? void 0 : selected.map((sel) => sel.text).join(', ') : placeholderAtIsSearch, onChange: onChangeValueSearch, type: "text", product: product, fieldType: "default", icon: 'search', iconLeft: iconName, value: valueSearch, iconStrokeSecond: "#254E5F", iconPosition: 'right', required: required, theme: errorMessage ? 'error' : undefined }))),
        !isSearch && (React__default.createElement("button", { className: cn$c('top', {
                disabled: isDisabled,
                warning: warningMessage,
                error: errorMessage,
                top_open_options: isOpen,
            }), type: "button", onClick: (e) => {
                e.preventDefault();
                handleTitleClick();
            } },
            React__default.createElement("div", { className: cn$c('top_left') }, iconName && (React__default.createElement("div", { className: cn$c('top_leftIcon') },
                React__default.createElement(Icon, { name: iconName, product: product, iconStroke: iconStroke, iconFill: iconFill })))),
            React__default.createElement("div", { className: cn$c('top_center') },
                required && React__default.createElement("div", { className: s$1.iconRequired }),
                React__default.createElement("div", { className: cn$c('top_title', { top_title_grey: selected.length }) }, title),
                React__default.createElement("div", { className: cn$c('top_subTitle', {
                        completed: !!selected.length,
                    }) },
                    !selected.length && subTitle,
                    !!selected.length &&
                        (selected === null || selected === void 0 ? void 0 : selected.map((sel) => {
                            return React__default.isValidElement(sel.text) ? sel.value : sel.text;
                        }).join(', ')))),
            React__default.createElement(Icon, { name: isOpen && !isDisabled ? 'arrowUpMini' : 'arrowDownMini', product: product, iconStroke: iconStroke, iconFill: iconFill, width: "16", height: "16" }))),
        isAlertsVisible && (React__default.createElement("div", { className: cn$c('alerts', {
                alerts_error: errorMessage,
                alerts_warning: warningMessage,
            }) },
            !!errorMessage && errorMessage,
            !!warningMessage && warningMessage)),
        isViewOptions && (React__default.createElement("div", { className: cn$c('options_container', {
                options_container_up: isDropDirectionUp,
            }) },
            React__default.createElement("div", { className: cn$c('options', {
                    options_up: isDropDirectionUp,
                }), id: dropDownId },
                options.map(({ value, text, isSelected }) => (React__default.createElement("button", { key: value, className: cn$c('option', {
                        option_selected: isSelected,
                    }), type: "button", onClick: (e) => {
                        e.preventDefault();
                        handleOptionClick({ value, text, isSelected });
                    } },
                    React__default.createElement("div", null, text),
                    isSelected && React__default.createElement(Icon, { name: "check", product: product, height: "16", width: "16" })))),
                isSearch && numberOptions && (React__default.createElement("div", { className: cn$c('optionLength') },
                    "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E ",
                    options.length,
                    " \u0438\u0437 ",
                    numberOptions,
                    ". \u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0439\u0442\u0435 \u0432\u0432\u043E\u0434\u0438\u0442\u044C \u043A\u043E\u0434 \u0438\u043B\u0438 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u043E\u0435")))))));
});
Select.displayName = 'Select';

var css_248z = "@charset \"UTF-8\";\n/**\n * Цвета по всем темам и продуктам:\n * https://www.figma.com/file/9nN2jHqSNFuJy8PipvZcw7/Colors?node-id=0%3A1&t=b80nEqs5uRi3rD0p-3\n * */\n/* МЧД */\n/* ЕЛК */\n.SelectMultiple-module_select__KwcHz {\n  width: 100%;\n  border-radius: 0.2rem;\n  cursor: pointer;\n  position: relative;\n}\n.SelectMultiple-module_select__KwcHz.SelectMultiple-module_disabled__CldRi {\n  cursor: default;\n}\n.SelectMultiple-module_select__KwcHz svg {\n  stroke: #254e5f;\n}\n\n.SelectMultiple-module_top__5kp4P {\n  position: relative;\n  padding: 0.9rem 1.3rem 0.7rem 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  outline: 0.1rem solid #d6d6d6;\n  border-radius: 0.2rem;\n  background: #ffffff;\n  border: none;\n  transition: box-shadow 0.3s;\n}\n.SelectMultiple-module_top__5kp4P:hover {\n  transition: box-shadow 0.3s;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.SelectMultiple-module_top__5kp4P:active {\n  outline: 0.1rem solid #ccd9e5;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_warning__EBxGO {\n  outline: 0.1rem solid #dcae1d;\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_error__k1Ctt {\n  outline: 0.1rem solid #d12e34;\n}\n.SelectMultiple-module_top__5kp4P:focus {\n  outline: 0.3rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_disabled__CldRi {\n  outline: 0.1rem solid #f8f8f8;\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_disabled__CldRi:hover {\n  box-shadow: none;\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_disabled__CldRi .SelectMultiple-module_top_title__6c2xz {\n  color: #d6d6d6;\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_disabled__CldRi.SelectMultiple-module_completed__qdhdn .SelectMultiple-module_top_title__6c2xz {\n  color: #858594;\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_disabled__CldRi svg {\n  stroke: #becacf;\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_opened__fvGXl {\n  padding: 0.6rem 1.3rem 0.6rem 0;\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_completed__qdhdn {\n  padding: 0.6rem 1.3rem 0.2rem 0;\n}\n.SelectMultiple-module_top__5kp4P.SelectMultiple-module_completed__qdhdn .SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_search__4WCMc input {\n  padding: 0 0 0 0.6rem;\n}\n.SelectMultiple-module_top_left__BHKBx svg {\n  width: 1.5rem;\n}\n.SelectMultiple-module_top_center__9KL01 {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 1%;\n}\n.SelectMultiple-module_top_title__6c2xz {\n  font-family: \"Nunito Sans\", sans-serif;\n  font-size: 1.4rem;\n  color: #254e5f;\n  line-height: 1.6rem;\n  padding: 0.8rem 1.6rem;\n}\n.SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_legacy__4dLZ4 {\n  padding: 0;\n  font-size: 1.2rem;\n  color: #333333;\n}\n.SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_legacy__4dLZ4.SelectMultiple-module_completed__qdhdn {\n  color: #c7c7cc;\n}\n.SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_completed__qdhdn {\n  color: #858594;\n  font-size: 1.2rem;\n  padding: 0 1.6rem;\n}\n.SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  padding: 0 1.6rem;\n  font-size: 1.2rem;\n}\n.SelectMultiple-module_top_subTitle__d1wcg {\n  font-family: Roboto, sans-serif;\n  font-size: 1.4rem;\n  color: #858594;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.6rem;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  padding: 0 0 0 1.4rem;\n}\n.SelectMultiple-module_top_subTitle__d1wcg.SelectMultiple-module_completed__qdhdn {\n  padding: 0;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__8hkHb {\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  padding: 0.1rem 0;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__opened__grxee {\n  justify-content: end;\n  padding: 0.2rem 0 0.2rem 1.6rem;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__opened__grxee::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 1.6rem;\n  height: 100%;\n  background: linear-gradient(90deg, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__closed__Dr22d {\n  justify-content: start;\n  padding: 0.2rem 1rem 0.2rem 1.6rem;\n  width: 100%;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__closed__Dr22d::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 4rem;\n  height: 100%;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 50%);\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__8hkHb .SelectMultiple-module_cheap__Kg1xj {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  line-height: 1;\n  font-family: Roboto, sans-serif;\n  font-size: 1.2rem;\n  color: #254e5f;\n  background: #f8f8f8;\n  margin: 0 0.2rem 0 0;\n  padding: 0.4rem 0.5rem;\n  border-radius: 0.3rem;\n  cursor: default;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__8hkHb .SelectMultiple-module_cheap__Kg1xj:focus, .SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__8hkHb .SelectMultiple-module_cheap__Kg1xj:focus-within, .SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__8hkHb .SelectMultiple-module_cheap__Kg1xj:focus-visible {\n  outline: none;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__8hkHb .SelectMultiple-module_cheap__Kg1xj.SelectMultiple-module_focused__SM-py {\n  outline: 0.2rem solid #5bc0de;\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__8hkHb .SelectMultiple-module_cheap__Kg1xj button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  margin: 0 0 0 0.4rem;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__8hkHb .SelectMultiple-module_cheap__Kg1xj button svg {\n  display: block;\n  stroke: #858594;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_cheaps__8hkHb .SelectMultiple-module_cheap__Kg1xj button:hover svg {\n  stroke: #b4272c;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_search__4WCMc {\n  width: auto;\n  min-width: 5rem;\n  max-width: 100%;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  margin: 0 1.5rem 0 0;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_search__4WCMc:focus {\n  outline: none;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_search__4WCMc input {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  color: #333333;\n  padding: 0.5rem 0 0 0.2rem;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_search__4WCMc input:focus {\n  outline: none;\n}\n.SelectMultiple-module_top_subTitle__d1wcg .SelectMultiple-module_search__4WCMc input::placeholder {\n  color: #858594;\n  font-size: 1.4rem;\n}\n.SelectMultiple-module_top_leftIcon__04DeD {\n  display: block;\n  margin-right: 1rem;\n}\n.SelectMultiple-module_top_leftIcon__04DeD svg {\n  display: block;\n}\n\n.SelectMultiple-module_alerts__L-4Lo {\n  font-family: Roboto, sans-serif;\n  font-weight: 400;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n  margin: 0.4rem 0 0.4rem 1.8rem;\n  position: absolute;\n}\n.SelectMultiple-module_alerts_error__SjI7y {\n  color: #d12e34;\n}\n.SelectMultiple-module_alerts_warning__dUotK {\n  color: #dcae1d;\n}\n\n.SelectMultiple-module_options_container__c31VE {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  bottom: 0;\n  margin-top: 0.4rem;\n}\n\n.SelectMultiple-module_options_container_up__Gldhx {\n  top: 0;\n  bottom: auto;\n}\n\n.SelectMultiple-module_options__lLdsz {\n  position: absolute;\n  width: 100%;\n  background-color: #ffffff;\n  outline: 0.1rem solid #d6d6d6;\n  border-radius: 0.2rem;\n  overflow-y: scroll;\n}\n\n.SelectMultiple-module_options_up__Qw-87 {\n  bottom: 0;\n  margin-bottom: 1.4rem;\n}\n\n.SelectMultiple-module_options_down__2n8eH {\n  margin-top: 0.4rem;\n}\n\n.SelectMultiple-module_option__QDOSW {\n  padding: 1rem 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-size: 1.4rem;\n  color: #254e5f;\n  cursor: pointer;\n  border: 0.1rem solid transparent;\n  border-bottom: 0.1rem solid #f8f8f8;\n  display: flex;\n  align-items: center;\n}\n.SelectMultiple-module_option__QDOSW:focus {\n  outline: none;\n}\n.SelectMultiple-module_option__QDOSW:hover, .SelectMultiple-module_option_focused__Uga9O {\n  box-shadow: inset 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.05);\n  border-radius: 0.2rem;\n  background: rgba(0, 0, 0, 0.0509803922);\n}\n.SelectMultiple-module_optionLength__faVOj {\n  margin-top: auto;\n  padding: 1rem 1.8rem;\n  font: 400 1.4rem Roboto, sans-serif;\n  color: #858594;\n  border: 0.1rem solid transparent;\n  cursor: default;\n}\n.SelectMultiple-module_option_beforeGroup__HmnxW {\n  border-bottom: none;\n}\n.SelectMultiple-module_option__QDOSW label {\n  outline: none;\n}\n.SelectMultiple-module_option__QDOSW .SelectMultiple-module_checkBox__2fjBN {\n  left: 1.8rem;\n  background: #eeeeee;\n}\n.SelectMultiple-module_option_innerText__6MTsB {\n  display: block;\n  margin: 0 0 0 0.9rem;\n}\n.SelectMultiple-module_option__QDOSW .storybook-check--focus:hover,\n.SelectMultiple-module_option__QDOSW .storybook-check--focus {\n  outline: none;\n  border: red;\n  box-shadow: none;\n}\n\n.SelectMultiple-module_emptySearchOption__UfSvR {\n  padding: 1rem 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-size: 1.4rem;\n  color: #858594;\n  cursor: default;\n}\n\n.SelectMultiple-module_toggleAll__2JTt7 {\n  padding: 1rem 1.6rem;\n  border: 0.1rem solid transparent;\n  border-bottom: 0.1rem solid #f8f8f8;\n  display: flex;\n  align-items: center;\n  outline: none;\n  background: none;\n  width: 100%;\n  cursor: pointer;\n  font-family: Roboto, sans-serif;\n  font-size: 1.4rem;\n  color: #254e5f;\n}\n.SelectMultiple-module_toggleAll__2JTt7:hover, .SelectMultiple-module_toggleAll__2JTt7:focus-visible {\n  background: rgba(0, 0, 0, 0.0509803922);\n}\n\n.SelectMultiple-module_groupTitle__Vsha4 {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 3.2rem);\n  margin: 1rem auto 0;\n  padding: 2.5rem 0 1.5rem;\n  color: #858594;\n  font-size: 1.4rem;\n  font-family: Roboto, sans-serif;\n  border-top: 1px solid #eeeeee;\n}\n\n/* ofd product */\n.SelectMultiple-module_select__KwcHz[class~=ofd]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #4ba1a5;\n}\n.SelectMultiple-module_select__KwcHz[class~=ofd]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #4ba1a5;\n}\n.SelectMultiple-module_select__KwcHz[class~=ofd] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #4ba1a5;\n}\n.SelectMultiple-module_select__KwcHz[class~=ofd] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #4ba1a5;\n}\n\n/* gosotchet product */\n.SelectMultiple-module_select__KwcHz[class~=gosotchet] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #488bca;\n}\n.SelectMultiple-module_select__KwcHz[class~=gosotchet]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #488bca;\n}\n.SelectMultiple-module_select__KwcHz[class~=gosotchet]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #488bca;\n}\n.SelectMultiple-module_select__KwcHz[class~=gosotchet] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #488bca;\n}\n\n/* td product */\n.SelectMultiple-module_select__KwcHz[class~=td] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #ea8242;\n}\n.SelectMultiple-module_select__KwcHz[class~=td]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #ea8242;\n}\n.SelectMultiple-module_select__KwcHz[class~=td]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #ea8242;\n}\n.SelectMultiple-module_select__KwcHz[class~=td] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #ea8242;\n}\n\n/* arenda product */\n.SelectMultiple-module_select__KwcHz[class~=arenda] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #d58576;\n}\n.SelectMultiple-module_select__KwcHz[class~=arenda]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #d58576;\n}\n.SelectMultiple-module_select__KwcHz[class~=arenda]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #d58576;\n}\n.SelectMultiple-module_select__KwcHz[class~=arenda] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #d58576;\n}\n\n/* check-index product */\n.SelectMultiple-module_select__KwcHz[class~=check-index] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #5bc0de;\n}\n.SelectMultiple-module_select__KwcHz[class~=check-index]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #5bc0de;\n}\n.SelectMultiple-module_select__KwcHz[class~=check-index]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #5bc0de;\n}\n.SelectMultiple-module_select__KwcHz[class~=check-index] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #5bc0de;\n}\n\n/* marking product */\n.SelectMultiple-module_select__KwcHz[class~=marking] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #4bb9ba;\n}\n.SelectMultiple-module_select__KwcHz[class~=marking]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #4bb9ba;\n}\n.SelectMultiple-module_select__KwcHz[class~=marking]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #4bb9ba;\n}\n.SelectMultiple-module_select__KwcHz[class~=marking] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #4bb9ba;\n}\n\n/* big-data product */\n.SelectMultiple-module_select__KwcHz[class~=big-data] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #5ab8c5;\n}\n.SelectMultiple-module_select__KwcHz[class~=big-data]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #5ab8c5;\n}\n.SelectMultiple-module_select__KwcHz[class~=big-data]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #5ab8c5;\n}\n.SelectMultiple-module_select__KwcHz[class~=big-data] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #5ab8c5;\n}\n\n/* edo product */\n.SelectMultiple-module_select__KwcHz[class~=edo] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #f5a91b;\n}\n.SelectMultiple-module_select__KwcHz[class~=edo]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #f5a91b;\n}\n.SelectMultiple-module_select__KwcHz[class~=edo]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #f5a91b;\n}\n.SelectMultiple-module_select__KwcHz[class~=edo] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #f5a91b;\n}\n\n/* epd product */\n.SelectMultiple-module_select__KwcHz[class~=epd] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #f5a91b;\n}\n.SelectMultiple-module_select__KwcHz[class~=epd]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #f5a91b;\n}\n.SelectMultiple-module_select__KwcHz[class~=epd]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #f5a91b;\n}\n.SelectMultiple-module_select__KwcHz[class~=epd] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #f5a91b;\n}\n\n/* mchd product */\n.SelectMultiple-module_select__KwcHz[class~=mchd] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #626ab7;\n}\n.SelectMultiple-module_select__KwcHz[class~=mchd]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #626ab7;\n}\n.SelectMultiple-module_select__KwcHz[class~=mchd]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #626ab7;\n}\n.SelectMultiple-module_select__KwcHz[class~=mchd] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #626ab7;\n}\n\n/* elk product */\n.SelectMultiple-module_select__KwcHz[class~=elk] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #577590;\n}\n.SelectMultiple-module_select__KwcHz[class~=elk]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #577590;\n}\n.SelectMultiple-module_select__KwcHz[class~=elk]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #577590;\n}\n.SelectMultiple-module_select__KwcHz[class~=elk] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #577590;\n}\n\n/* integrations product */\n.SelectMultiple-module_select__KwcHz[class~=integrations] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #797ca4;\n}\n.SelectMultiple-module_select__KwcHz[class~=integrations]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #797ca4;\n}\n.SelectMultiple-module_select__KwcHz[class~=integrations]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #797ca4;\n}\n.SelectMultiple-module_select__KwcHz[class~=integrations] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #797ca4;\n}\n\n/* onec product */\n.SelectMultiple-module_select__KwcHz[class~=onec] .SelectMultiple-module_top_title__6c2xz.SelectMultiple-module_opened__fvGXl {\n  color: #e36052;\n}\n.SelectMultiple-module_select__KwcHz[class~=onec]:active .SelectMultiple-module_top_title__6c2xz {\n  color: #e36052;\n}\n.SelectMultiple-module_select__KwcHz[class~=onec]:hover:not(.SelectMultiple-module_disabled__CldRi) {\n  outline: 0.2rem solid #e36052;\n}\n.SelectMultiple-module_select__KwcHz[class~=onec] .SelectMultiple-module_option__QDOSW.SelectMultiple-module_selected__-pNP4 .SelectMultiple-module_checkBox__2fjBN {\n  border: 1px solid #e36052;\n}";
var s = {"select":"SelectMultiple-module_select__KwcHz","disabled":"SelectMultiple-module_disabled__CldRi","top":"SelectMultiple-module_top__5kp4P","warning":"SelectMultiple-module_warning__EBxGO","error":"SelectMultiple-module_error__k1Ctt","top_title":"SelectMultiple-module_top_title__6c2xz","completed":"SelectMultiple-module_completed__qdhdn","opened":"SelectMultiple-module_opened__fvGXl","top_subTitle":"SelectMultiple-module_top_subTitle__d1wcg","search":"SelectMultiple-module_search__4WCMc","top_left":"SelectMultiple-module_top_left__BHKBx","top_center":"SelectMultiple-module_top_center__9KL01","legacy":"SelectMultiple-module_legacy__4dLZ4","cheaps":"SelectMultiple-module_cheaps__8hkHb","cheaps__opened":"SelectMultiple-module_cheaps__opened__grxee","cheaps__closed":"SelectMultiple-module_cheaps__closed__Dr22d","cheap":"SelectMultiple-module_cheap__Kg1xj","focused":"SelectMultiple-module_focused__SM-py","top_leftIcon":"SelectMultiple-module_top_leftIcon__04DeD","alerts":"SelectMultiple-module_alerts__L-4Lo","alerts_error":"SelectMultiple-module_alerts_error__SjI7y","alerts_warning":"SelectMultiple-module_alerts_warning__dUotK","options_container":"SelectMultiple-module_options_container__c31VE","options_container_up":"SelectMultiple-module_options_container_up__Gldhx","options":"SelectMultiple-module_options__lLdsz","options_up":"SelectMultiple-module_options_up__Qw-87","options_down":"SelectMultiple-module_options_down__2n8eH","option":"SelectMultiple-module_option__QDOSW","option_focused":"SelectMultiple-module_option_focused__Uga9O","optionLength":"SelectMultiple-module_optionLength__faVOj","option_beforeGroup":"SelectMultiple-module_option_beforeGroup__HmnxW","checkBox":"SelectMultiple-module_checkBox__2fjBN","option_innerText":"SelectMultiple-module_option_innerText__6MTsB","emptySearchOption":"SelectMultiple-module_emptySearchOption__UfSvR","toggleAll":"SelectMultiple-module_toggleAll__2JTt7","groupTitle":"SelectMultiple-module_groupTitle__Vsha4","selected":"SelectMultiple-module_selected__-pNP4"};
styleInject(css_248z);

const cn$b = classNames.bind(s);
const SelectMultipleTop = memo$1((props) => {
    const { isDisabled, warningMessage, errorMessage, product, title, handleTitleClick, selected, isOpen, children, isSearchLoading, } = props;
    return (React__default.createElement("div", { className: cn$b('top', {
            disabled: isDisabled,
            warning: warningMessage,
            error: errorMessage,
            opened: isOpen,
            completed: !!selected.length,
            [product]: product,
        }), onClick: handleTitleClick, onKeyDown: () => null, tabIndex: 0, role: 'button' },
        React__default.createElement("div", { className: cn$b('top_center') },
            React__default.createElement("div", { className: cn$b('top_title', {
                    completed: !!selected.length,
                    opened: isOpen,
                }) }, title),
            React__default.createElement("div", { className: cn$b('top_subTitle', {
                    completed: !!selected.length,
                }) }, children)),
        React__default.createElement("div", { tabIndex: -1 },
            isSearchLoading && (React__default.createElement("div", null,
                React__default.createElement(Icon, { name: 'animatedSpinner', product: product, width: "18", height: "18" }))),
            !isSearchLoading && (React__default.createElement(Icon, { name: isOpen && !isDisabled ? 'arrowUp' : 'arrowDown', product: product, strokeSecond: isDisabled ? '#BECACF' : '#254E5F', width: "12", height: "12" })))));
});
SelectMultipleTop.displayName = 'SelectMultipleTop';

const cn$a = classNames.bind(s);
const SelectMultipleChips = memo$1((props) => {
    const { selected, isOpen } = props;
    if (!selected.length)
        return null;
    return (React__default.createElement("div", { className: cn$a('cheaps', {
            cheaps__opened: isOpen,
            cheaps__closed: !isOpen,
        }), tabIndex: -1 }, props.children));
});
SelectMultipleChips.displayName = 'SelectMultipleChips';

const cn$9 = classNames.bind(s);
const SelectMultipleChip = memo$1((props) => {
    const { selectedItem, isOpen, handleOptionClick, handleCheapsKeyUp, setIsOpen } = props;
    const [isMouseInteraction, setIsMouseInteraction] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    return (React__default.createElement("div", { key: selectedItem.value, className: cn$9('cheap', {
            focused: isFocused,
        }), tabIndex: 0, role: "button", onMouseDown: () => {
            setIsMouseInteraction(true);
            setIsFocused(false);
        }, onMouseUp: () => {
            setIsMouseInteraction(false);
            setIsFocused(false);
        }, onClick: (e) => {
            e.stopPropagation();
            setIsFocused(false);
            setIsOpen(true);
        }, onKeyUp: (ev) => {
            if (!isFocused)
                return;
            handleCheapsKeyUp(ev, selectedItem);
        }, onFocus: () => {
            if (isMouseInteraction)
                return;
            setIsFocused(true);
        }, onBlur: () => {
            setIsFocused(false);
        } },
        React__default.createElement("span", null, React__default.isValidElement(selectedItem.text) ? selectedItem.value : selectedItem.text),
        isOpen && (React__default.createElement("button", { onClick: (e) => {
                e.stopPropagation();
                handleOptionClick({ value: selectedItem.value, text: selectedItem.text, isSelected: false });
            }, tabIndex: -1 },
            React__default.createElement(Icon, { height: "10", width: "10", iconStroke: true, name: "cross", product: "default", theme: "grey" })))));
});
SelectMultipleChip.displayName = 'SelectMultipleChip';

const cn$8 = classNames.bind(s);
const SelectMultipleSearch = memo$1((props) => {
    const { valueSearch, onChangeValueSearch, isOpen, setIsOpen, selected, subTitle, isDisabled } = props;
    const ref = React__default.useRef(null);
    useEffect(() => {
        var _a;
        if (!isOpen)
            return;
        (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [isOpen]);
    if (!isOpen)
        return null;
    if (isDisabled)
        return null;
    return (React__default.createElement("div", { className: cn$8('search') },
        React__default.createElement("input", { ref: ref, onFocus: () => setIsOpen(true), onClick: (e) => e.stopPropagation(), type: "text", onChange: onChangeValueSearch, value: valueSearch, placeholder: selected.length ? '' : subTitle })));
});
SelectMultipleSearch.displayName = 'SelectMultipleSearch';

const cn$7 = classNames.bind(s);
const SelectMultipleList = memo$1((props) => {
    const { isOpen, isDisabled, isDropDirectionUp } = props;
    return (React__default.createElement("div", { onFocus: () => props.setIsDropdownFocused(true), onBlur: () => props.setIsDropdownFocused(false), onKeyUp: props.handleOptionKeyUp, role: "button", tabIndex: -1 }, isOpen && !isDisabled && (React__default.createElement("div", { className: cn$7('options_container', {
            options_container_up: isDropDirectionUp,
        }) },
        React__default.createElement("div", { className: cn$7('options', {
                options_up: isDropDirectionUp,
                options_down: !isDropDirectionUp,
            }), style: { overflow: 'hidden' } }, props.children)))));
});
SelectMultipleList.displayName = 'SelectMultipleList';

const cn$6 = classNames.bind(s);
const SelectMultipleOption = memo$1((props) => {
    const { option: { isSelected = false, value, text, isFocused = false }, handleOptionClick, product, isDisabled = false, setFocusedOption, className = '', } = props;
    const handleClick = useCallback(() => {
        handleOptionClick({ value, text, isSelected });
        setFocusedOption(null);
    }, [handleOptionClick, value, text, isSelected, setFocusedOption]);
    const handleFocus = useCallback(() => {
        setFocusedOption(props.option);
    }, [props.option, setFocusedOption]);
    const handleBlur = useCallback(() => {
        if (isFocused) {
            setFocusedOption(null);
        }
    }, [isFocused, setFocusedOption]);
    return (React__default.createElement("div", { role: "button", tabIndex: 0, className: cn$6('option', {
            selected: isSelected,
            option_focused: isFocused,
            [className]: !!className,
        }), onClick: handleClick, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: () => null },
        React__default.createElement(Checkbox, { simple: true,
            label: 'CheckBoxBase',
            value: String(value),
            checked: isSelected,
            partiallyChecked: false,
            onClick: handleClick,
            product: product,
            helpBlockText: '',
            error: false,
            warning: false,
            disabled: isDisabled,
            onKeyDown: (e) => e.preventDefault(),
            inputTabIndex: -1,
            checkBoxClassName: cn$6('checkBox') }),
        React__default.createElement("span", { className: cn$6('option_innerText') }, text)));
});
SelectMultipleOption.displayName = 'SelectMultipleOption';

const cn$5 = classNames.bind(s);
const SelectMultipleMessage = memo$1((props) => {
    const { isAlertsVisible, errorMessage, warningMessage } = props;
    if (!isAlertsVisible)
        return null;
    return (React__default.createElement("div", { className: cn$5('alerts', {
            alerts_error: errorMessage,
            alerts_warning: warningMessage,
        }) },
        !!errorMessage && errorMessage,
        !!warningMessage && warningMessage));
});
SelectMultipleMessage.displayName = 'SelectMultipleMessage';

const cn$4 = classNames.bind(s);
const SelectMultipleGroup = memo$1((props) => {
    return (React__default.createElement(React__default.Fragment, null,
        props.option.groupTitle && React__default.createElement("div", { className: cn$4('groupTitle') }, props.option.groupTitle),
        props.children));
});
SelectMultipleGroup.displayName = 'SelectMultipleGroup';

const cn$3 = classNames.bind(s);
const SelectMultipleStat = memo$1((props) => {
    const { flatSearchedOptions, flatOptions } = props;
    return (React__default.createElement("div", { className: cn$3('optionLength') }, `Показано ${flatSearchedOptions.length} из ${flatOptions.length}. Продолжайте вводить код или название, чтобы увидеть остальное`));
});
SelectMultipleStat.displayName = 'SelectMultipleStat';

var isArray = Array.isArray;
var toClassName = function (val) {
    var str = '';
    if (typeof val === 'string')
        str += val;
    else if (typeof val === 'object') {
        var tmp = void 0;
        if (isArray(val)) {
            var i = 0;
            var l = val.length;
            while (i < l) {
                tmp = toClassName(val[i++]);
                if (tmp) {
                    if (str) {
                        str += ' ';
                    }
                    str += tmp;
                }
            }
        }
        else {
            // eslint-disable-next-line guard-for-in
            for (tmp in val) {
                if (tmp && val[tmp]) {
                    if (str) {
                        str += ' ';
                    }
                    str += tmp;
                }
            }
        }
    }
    return str;
};
function cnb() {
    var l = arguments.length;
    var i = 0;
    var n;
    var tmp;
    var str = '';
    while (i < l) {
        n = arguments[i++];
        if (n) {
            tmp = toClassName(n);
            if (tmp) {
                if (str) {
                    str += ' ';
                }
                str += tmp;
            }
        }
    }
    return str;
}

function e(e,i,t,o){for(;i>=t&&!e("(min-resolution: "+i/o+"dppx)").matches;)i--;return i}function i(i){if(void 0===i&&(i=window),!i)return 1;if(void 0!==i.devicePixelRatio)return i.devicePixelRatio;var t=i.document.frames;return void 0!==t?void 0!==t.devicePixelRatio?t.devicePixelRatio:t.screen.deviceXDPI/t.screen.systemXDPI:void 0!==i.matchMedia?function(i){for(var t=i.matchMedia,o=10,n=.1,r=1,a=o,c=0;c<4;c++)o=(a=10*e(t,o,n,r))+9,n=a,r*=10;return a/r}(i):1}

var cjs = {exports: {}};

var Draggable$1 = {};

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

var clsx_m = /*#__PURE__*/Object.freeze({
  __proto__: null,
  clsx: clsx,
  default: clsx
});

var require$$3 = /*@__PURE__*/getAugmentedNamespace(clsx_m);

var domFns = {};

var shims = {};

Object.defineProperty(shims, "__esModule", {
  value: true
});
shims.dontSetMe = dontSetMe;
shims.findInArray = findInArray;
shims.int = int;
shims.isFunction = isFunction;
shims.isNum = isNum$1;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/{
  for (let i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}
function isFunction(func /*: any*/) /*: boolean %checks*/{
  // $FlowIgnore[method-unbinding]
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function isNum$1(num /*: any*/) /*: boolean %checks*/{
  return typeof num === 'number' && !isNaN(num);
}
function int(a /*: string*/) /*: number*/{
  return parseInt(a, 10);
}
function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) /*: ?Error*/{
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}

var getPrefix$1 = {};

Object.defineProperty(getPrefix$1, "__esModule", {
  value: true
});
getPrefix$1.browserPrefixToKey = browserPrefixToKey;
getPrefix$1.browserPrefixToStyle = browserPrefixToStyle;
getPrefix$1.default = void 0;
getPrefix$1.getPrefix = getPrefix;
const prefixes = ['Moz', 'Webkit', 'O', 'ms'];
function getPrefix() /*: string*/{
  var _window$document;
  let prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
  // Ensure we're running in an environment where there is actually a global
  // `window` obj
  if (typeof window === 'undefined') return '';

  // If we're in a pseudo-browser server-side environment, this access
  // path may not exist, so bail out if it doesn't.
  const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
  if (!style) return '';
  if (prop in style) return '';
  for (let i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }
  return '';
}
function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/{
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}
function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/{
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function kebabToTitleCase(str /*: string*/) /*: string*/{
  let out = '';
  let shouldCapitalize = true;
  for (let i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}

// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
getPrefix$1.default = (getPrefix() /*: string*/);

Object.defineProperty(domFns, "__esModule", {
  value: true
});
domFns.addClassName = addClassName;
domFns.addEvent = addEvent;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.getTranslation = getTranslation;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.removeClassName = removeClassName;
domFns.removeEvent = removeEvent;
domFns.removeUserSelectStyles = removeUserSelectStyles;
var _shims$2 = shims;
var _getPrefix = _interopRequireWildcard$1(getPrefix$1);
function _getRequireWildcardCache$1(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$1 = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard$1(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$1(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/
let matchesSelectorFunc = '';
function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/{
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims$2.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims$2.isFunction)(el[method]);
    });
  }

  // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable
  if (!(0, _shims$2.isFunction)(el[matchesSelectorFunc])) return false;

  // $FlowIgnore: Doesn't think elements are indexable
  return el[matchesSelectorFunc](selector);
}

// Works up the tree to the draggable itself attempting to match selector.
function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/{
  let node = el;
  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    // $FlowIgnore[incompatible-type]
    node = node.parentNode;
  } while (node);
  return false;
}
function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/, inputOptions /*: Object*/) /*: void*/{
  if (!el) return;
  const options = {
    capture: true,
    ...inputOptions
  };
  // $FlowIgnore[method-unbinding]
  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}
function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/, inputOptions /*: Object*/) /*: void*/{
  if (!el) return;
  const options = {
    capture: true,
    ...inputOptions
  };
  // $FlowIgnore[method-unbinding]
  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}
function outerHeight(node /*: HTMLElement*/) /*: number*/{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  let height = node.clientHeight;
  const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims$2.int)(computedStyle.borderTopWidth);
  height += (0, _shims$2.int)(computedStyle.borderBottomWidth);
  return height;
}
function outerWidth(node /*: HTMLElement*/) /*: number*/{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  let width = node.clientWidth;
  const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims$2.int)(computedStyle.borderLeftWidth);
  width += (0, _shims$2.int)(computedStyle.borderRightWidth);
  return width;
}
function innerHeight(node /*: HTMLElement*/) /*: number*/{
  let height = node.clientHeight;
  const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims$2.int)(computedStyle.paddingTop);
  height -= (0, _shims$2.int)(computedStyle.paddingBottom);
  return height;
}
function innerWidth(node /*: HTMLElement*/) /*: number*/{
  let width = node.clientWidth;
  const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims$2.int)(computedStyle.paddingLeft);
  width -= (0, _shims$2.int)(computedStyle.paddingRight);
  return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/
// Get from offsetParent
function offsetXYFromParent(evt /*: EventWithOffset*/, offsetParent /*: HTMLElement*/, scale /*: number*/) /*: ControlPosition*/{
  const isBody = offsetParent === offsetParent.ownerDocument.body;
  const offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x,
    y
  };
}
function createCSSTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: Object*/{
  const translation = getTranslation(controlPos, positionOffset, 'px');
  return {
    [(0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default)]: translation
  };
}
function createSVGTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: string*/{
  const translation = getTranslation(controlPos, positionOffset, '');
  return translation;
}
function getTranslation(_ref /*:: */, positionOffset /*: PositionOffsetControlPosition*/, unitSuffix /*: string*/) /*: string*/{
  let {
    x,
    y
  } /*: ControlPosition*/ = _ref /*: ControlPosition*/;
  let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
  if (positionOffset) {
    const defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
    const defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }
  return translation;
}
function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/{
  return e.targetTouches && (0, _shims$2.findInArray)(e.targetTouches, t => identifier === t.identifier) || e.changedTouches && (0, _shims$2.findInArray)(e.changedTouches, t => identifier === t.identifier);
}
function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/{
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}

// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.

// Note we're passing `document` b/c we could be iframed
function addUserSelectStyles(doc /*: ?Document*/) {
  if (!doc) return;
  let styleEl = doc.getElementById('react-draggable-style-el');
  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }
  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}
function removeUserSelectStyles(doc /*: ?Document*/) {
  if (!doc) return;
  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
    // $FlowIgnore: IE
    if (doc.selection) {
      // $FlowIgnore: IE
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      const selection = (doc.defaultView || window).getSelection();
      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {
    // probably IE
  }
}
function addClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}
function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
  }
}

var positionFns = {};

Object.defineProperty(positionFns, "__esModule", {
  value: true
});
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;
positionFns.getBoundPosition = getBoundPosition;
positionFns.getControlPosition = getControlPosition;
positionFns.snapToGrid = snapToGrid;
var _shims$1 = shims;
var _domFns$1 = domFns;
/*:: import type Draggable from '../Draggable';*/
/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
/*:: import type DraggableCore from '../DraggableCore';*/
function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/{
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y];

  // Clone new bounds
  let {
    bounds
  } = draggable.props;
  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  const node = findDOMNode(draggable);
  if (typeof bounds === 'string') {
    const {
      ownerDocument
    } = node;
    const ownerWindow = ownerDocument.defaultView;
    let boundNode;
    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }
    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }
    const boundNodeEl /*: HTMLElement*/ = boundNode; // for Flow, can't seem to refine correctly
    const nodeStyle = ownerWindow.getComputedStyle(node);
    const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
    bounds = {
      left: -node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingLeft) + (0, _shims$1.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingTop) + (0, _shims$1.int)(nodeStyle.marginTop),
      right: (0, _domFns$1.innerWidth)(boundNodeEl) - (0, _domFns$1.outerWidth)(node) - node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingRight) - (0, _shims$1.int)(nodeStyle.marginRight),
      bottom: (0, _domFns$1.innerHeight)(boundNodeEl) - (0, _domFns$1.outerHeight)(node) - node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingBottom) - (0, _shims$1.int)(nodeStyle.marginBottom)
    };
  }

  // Keep x and y below right and bottom limits...
  if ((0, _shims$1.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims$1.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);

  // But above left and top limits.
  if ((0, _shims$1.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims$1.isNum)(bounds.top)) y = Math.max(y, bounds.top);
  return [x, y];
}
function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/{
  const x = Math.round(pendingX / grid[0]) * grid[0];
  const y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}
function canDragX(draggable /*: Draggable*/) /*: boolean*/{
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function canDragY(draggable /*: Draggable*/) /*: boolean*/{
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}

// Get {x, y} positions from event.
function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/{
  const touchObj = typeof touchIdentifier === 'number' ? (0, _domFns$1.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
  const node = findDOMNode(draggableCore);
  // User can provide an offsetParent if desired.
  const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns$1.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}

// Create an data object exposed by <DraggableCore>'s events
function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/{
  const isStart = !(0, _shims$1.isNum)(draggable.lastX);
  const node = findDOMNode(draggable);
  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x,
      y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node,
      deltaX: x - draggable.lastX,
      deltaY: y - draggable.lastY,
      lastX: draggable.lastX,
      lastY: draggable.lastY,
      x,
      y
    };
  }
}

// Create an data exposed by <Draggable>'s events
function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/{
  const scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}

// A lot faster than stringify/parse
function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/{
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}
function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/{
  const node = draggable.findDOMNode();
  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  }
  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
  return node;
}

var DraggableCore$2 = {};

var log$1 = {};

Object.defineProperty(log$1, "__esModule", {
  value: true
});
log$1.default = log;
/*eslint no-console:0*/
function log() {
}

Object.defineProperty(DraggableCore$2, "__esModule", {
  value: true
});
DraggableCore$2.default = void 0;
var React = _interopRequireWildcard(React__default);
var _propTypes = _interopRequireDefault(propTypesExports);
var _reactDom = _interopRequireDefault(ReactDOM__default);
var _domFns = domFns;
var _positionFns = positionFns;
var _shims = shims;
var _log = _interopRequireDefault(log$1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/
/*:: import type {Element as ReactElement} from 'react';*/
// Simple abstraction for dragging events names.
const eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
};

// Default to mouse events.
let dragEventFor = eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/
/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/
/*:: export type ControlPosition = {x: number, y: number};*/
/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/
/*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/
/*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/
//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//

let DraggableCore$1 = class DraggableCore extends React.Component /*:: <DraggableCoreProps>*/{
  constructor() {
    super(...arguments);
    _defineProperty(this, "dragging", false);
    // Used while dragging to determine deltas.
    _defineProperty(this, "lastX", NaN);
    _defineProperty(this, "lastY", NaN);
    _defineProperty(this, "touchIdentifier", null);
    _defineProperty(this, "mounted", false);
    _defineProperty(this, "handleDragStart", e => {
      // Make it possible to attach event handlers on top of this one.
      this.props.onMouseDown(e);

      // Only accept left-clicks.
      if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;

      // Get nodes. Be sure to grab relative document (could be iframed)
      const thisNode = this.findDOMNode();
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }
      const {
        ownerDocument
      } = thisNode;

      // Short circuit if handle or cancel prop was provided and selector doesn't match.
      if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) {
        return;
      }

      // Prevent scrolling on mobile devices, like ipad/iphone.
      // Important that this is after handle/cancel.
      if (e.type === 'touchstart') e.preventDefault();

      // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.
      const touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
      this.touchIdentifier = touchIdentifier;

      // Get the current drag point from the event. This is used as the offset.
      const position = (0, _positionFns.getControlPosition)(e, touchIdentifier, this);
      if (position == null) return; // not possible but satisfies flow
      const {
        x,
        y
      } = position;

      // Create an event object with all the data parents need to make a decision here.
      const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent);

      // Call event handler. If it returns explicit false, cancel.
      (0, _log.default)('calling', this.props.onStart);
      const shouldUpdate = this.props.onStart(e, coreEvent);
      if (shouldUpdate === false || this.mounted === false) return;

      // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.
      if (this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);

      // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.
      this.dragging = true;
      this.lastX = x;
      this.lastY = y;

      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, this.handleDragStop);
    });
    _defineProperty(this, "handleDrag", e => {
      // Get the current drag point from the event. This is used as the offset.
      const position = (0, _positionFns.getControlPosition)(e, this.touchIdentifier, this);
      if (position == null) return;
      let {
        x,
        y
      } = position;

      // Snap to grid if prop has been provided
      if (Array.isArray(this.props.grid)) {
        let deltaX = x - this.lastX,
          deltaY = y - this.lastY;
        [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
        if (!deltaX && !deltaY) return; // skip useless drag
        x = this.lastX + deltaX, y = this.lastY + deltaY;
      }
      const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent);

      // Call event handler. If it returns explicit false, trigger end.
      const shouldUpdate = this.props.onDrag(e, coreEvent);
      if (shouldUpdate === false || this.mounted === false) {
        try {
          // $FlowIgnore
          this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          const event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
          // I see why this insanity was deprecated
          // $FlowIgnore
          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          this.handleDragStop(event);
        }
        return;
      }
      this.lastX = x;
      this.lastY = y;
    });
    _defineProperty(this, "handleDragStop", e => {
      if (!this.dragging) return;
      const position = (0, _positionFns.getControlPosition)(e, this.touchIdentifier, this);
      if (position == null) return;
      let {
        x,
        y
      } = position;

      // Snap to grid if prop has been provided
      if (Array.isArray(this.props.grid)) {
        let deltaX = x - this.lastX || 0;
        let deltaY = y - this.lastY || 0;
        [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
        x = this.lastX + deltaX, y = this.lastY + deltaY;
      }
      const coreEvent = (0, _positionFns.createCoreData)(this, x, y);

      // Call event handler
      const shouldContinue = this.props.onStop(e, coreEvent);
      if (shouldContinue === false || this.mounted === false) return false;
      const thisNode = this.findDOMNode();
      if (thisNode) {
        // Remove user-select hack
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }
      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent);

      // Reset the el.
      this.dragging = false;
      this.lastX = NaN;
      this.lastY = NaN;
      if (thisNode) {
        // Remove event handlers
        (0, _log.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, this.handleDragStop);
      }
    });
    _defineProperty(this, "onMouseDown", e => {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return this.handleDragStart(e);
    });
    _defineProperty(this, "onMouseUp", e => {
      dragEventFor = eventsFor.mouse;
      return this.handleDragStop(e);
    });
    // Same as onMouseDown (start drag), but now consider this a touch device.
    _defineProperty(this, "onTouchStart", e => {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return this.handleDragStart(e);
    });
    _defineProperty(this, "onTouchEnd", e => {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return this.handleDragStop(e);
    });
  }
  componentDidMount() {
    this.mounted = true;
    // Touch handlers must be added with {passive: false} to be cancelable.
    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
    const thisNode = this.findDOMNode();
    if (thisNode) {
      (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
        passive: false
      });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
    // Remove any leftover event handlers. Remove both touch and mouse handlers in case
    // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
    const thisNode = this.findDOMNode();
    if (thisNode) {
      const {
        ownerDocument
      } = thisNode;
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
      (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
        passive: false
      });
      if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
    }
  }

  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() /*: ?HTMLElement*/{
    var _this$props, _this$props2;
    return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : _reactDom.default.findDOMNode(this);
  }
  render() /*: React.Element<any>*/{
    // Reuse the child provided
    // This makes it flexible to use whatever element is wanted (div, ul, etc)
    return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
DraggableCore$2.default = DraggableCore$1;
_defineProperty(DraggableCore$1, "displayName", 'DraggableCore');
_defineProperty(DraggableCore$1, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function (props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes.default.arrayOf(_propTypes.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
_defineProperty(DraggableCore$1, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function () {},
  onDrag: function () {},
  onStop: function () {},
  onMouseDown: function () {},
  scale: 1
});

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DraggableCore", {
	  enumerable: true,
	  get: function () {
	    return _DraggableCore.default;
	  }
	});
	exports.default = void 0;
	var React = _interopRequireWildcard(React__default);
	var _propTypes = _interopRequireDefault(propTypesExports);
	var _reactDom = _interopRequireDefault(ReactDOM__default);
	var _clsx = _interopRequireDefault(require$$3);
	var _domFns = domFns;
	var _positionFns = positionFns;
	var _shims = shims;
	var _DraggableCore = _interopRequireDefault(DraggableCore$2);
	var _log = _interopRequireDefault(log$1);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/
	/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/
	/*:: import type {Element as ReactElement} from 'react';*/
	/*:: type DraggableState = {
	  dragging: boolean,
	  dragged: boolean,
	  x: number, y: number,
	  slackX: number, slackY: number,
	  isElementSVG: boolean,
	  prevPropsPosition: ?ControlPosition,
	};*/
	/*:: export type DraggableDefaultProps = {
	  ...DraggableCoreDefaultProps,
	  axis: 'both' | 'x' | 'y' | 'none',
	  bounds: Bounds | string | false,
	  defaultClassName: string,
	  defaultClassNameDragging: string,
	  defaultClassNameDragged: string,
	  defaultPosition: ControlPosition,
	  scale: number,
	};*/
	/*:: export type DraggableProps = {
	  ...DraggableCoreProps,
	  ...DraggableDefaultProps,
	  positionOffset: PositionOffsetControlPosition,
	  position: ControlPosition,
	};*/
	//
	// Define <Draggable>
	//
	class Draggable extends React.Component /*:: <DraggableProps, DraggableState>*/{
	  // React 16.3+
	  // Arity (props, state)
	  static getDerivedStateFromProps(_ref /*:: */, _ref2 /*:: */) /*: ?Partial<DraggableState>*/{
	    let {
	      position
	    } /*: DraggableProps*/ = _ref /*: DraggableProps*/;
	    let {
	      prevPropsPosition
	    } /*: DraggableState*/ = _ref2 /*: DraggableState*/;
	    // Set x/y if a new position is provided in props that is different than the previous.
	    if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
	      (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
	        position,
	        prevPropsPosition
	      });
	      return {
	        x: position.x,
	        y: position.y,
	        prevPropsPosition: {
	          ...position
	        }
	      };
	    }
	    return null;
	  }
	  constructor(props /*: DraggableProps*/) {
	    super(props);
	    _defineProperty(this, "onDragStart", (e, coreData) => {
	      (0, _log.default)('Draggable: onDragStart: %j', coreData);

	      // Short-circuit if user's callback killed it.
	      const shouldStart = this.props.onStart(e, (0, _positionFns.createDraggableData)(this, coreData));
	      // Kills start event on core as well, so move handlers are never bound.
	      if (shouldStart === false) return false;
	      this.setState({
	        dragging: true,
	        dragged: true
	      });
	    });
	    _defineProperty(this, "onDrag", (e, coreData) => {
	      if (!this.state.dragging) return false;
	      (0, _log.default)('Draggable: onDrag: %j', coreData);
	      const uiData = (0, _positionFns.createDraggableData)(this, coreData);
	      const newState = {
	        x: uiData.x,
	        y: uiData.y,
	        slackX: 0,
	        slackY: 0
	      };

	      // Keep within bounds.
	      if (this.props.bounds) {
	        // Save original x and y.
	        const {
	          x,
	          y
	        } = newState;

	        // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.
	        newState.x += this.state.slackX;
	        newState.y += this.state.slackY;

	        // Get bound position. This will ceil/floor the x and y within the boundaries.
	        const [newStateX, newStateY] = (0, _positionFns.getBoundPosition)(this, newState.x, newState.y);
	        newState.x = newStateX;
	        newState.y = newStateY;

	        // Recalculate slack by noting how much was shaved by the boundPosition handler.
	        newState.slackX = this.state.slackX + (x - newState.x);
	        newState.slackY = this.state.slackY + (y - newState.y);

	        // Update the event we fire to reflect what really happened after bounds took effect.
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - this.state.x;
	        uiData.deltaY = newState.y - this.state.y;
	      }

	      // Short-circuit if user's callback killed it.
	      const shouldUpdate = this.props.onDrag(e, uiData);
	      if (shouldUpdate === false) return false;
	      this.setState(newState);
	    });
	    _defineProperty(this, "onDragStop", (e, coreData) => {
	      if (!this.state.dragging) return false;

	      // Short-circuit if user's callback killed it.
	      const shouldContinue = this.props.onStop(e, (0, _positionFns.createDraggableData)(this, coreData));
	      if (shouldContinue === false) return false;
	      (0, _log.default)('Draggable: onDragStop: %j', coreData);
	      const newState /*: Partial<DraggableState>*/ = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      };

	      // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	      const controlled = Boolean(this.props.position);
	      if (controlled) {
	        const {
	          x,
	          y
	        } = this.props.position;
	        newState.x = x;
	        newState.y = y;
	      }
	      this.setState(newState);
	    });
	    this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,
	      // Whether or not we have been dragged before.
	      dragged: false,
	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,
	      prevPropsPosition: {
	        ...props.position
	      },
	      // Used for compensating for out-of-bounds drags
	      slackX: 0,
	      slackY: 0,
	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };
	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	  }
	  componentDidMount() {
	    // Check to see if the element passed is an instanceof SVGElement
	    if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
	      this.setState({
	        isElementSVG: true
	      });
	    }
	  }
	  componentWillUnmount() {
	    this.setState({
	      dragging: false
	    }); // prevents invariant if unmounted while dragging
	  }

	  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	  // the underlying DOM node ourselves. See the README for more information.
	  findDOMNode() /*: ?HTMLElement*/{
	    var _this$props$nodeRef$c, _this$props;
	    return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
	  }
	  render() /*: ReactElement<any>*/{
	    const {
	      axis,
	      bounds,
	      children,
	      defaultPosition,
	      defaultClassName,
	      defaultClassNameDragging,
	      defaultClassNameDragged,
	      position,
	      positionOffset,
	      scale,
	      ...draggableCoreProps
	    } = this.props;
	    let style = {};
	    let svgTransform = null;

	    // If this is controlled, we don't want to move it - unless it's dragging.
	    const controlled = Boolean(position);
	    const draggable = !controlled || this.state.dragging;
	    const validPosition = position || defaultPosition;
	    const transformOpts = {
	      // Set left if horizontal drag is enabled
	      x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
	      // Set top if vertical drag is enabled
	      y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
	    };

	    // If this element was SVG, we use the `transform` attribute.
	    if (this.state.isElementSVG) {
	      svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
	    } else {
	      // Add a CSS transform to move the element around. This allows us to move the element around
	      // without worrying about whether or not it is relatively or absolutely positioned.
	      // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	      // has a clean slate.
	      style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
	    }

	    // Mark with class while dragging
	    const className = (0, _clsx.default)(children.props.className || '', defaultClassName, {
	      [defaultClassNameDragging]: this.state.dragging,
	      [defaultClassNameDragged]: this.state.dragged
	    });

	    // Reuse the child provided
	    // This makes it flexible to use whatever element is wanted (div, ul, etc)
	    return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
	      onStart: this.onDragStart,
	      onDrag: this.onDrag,
	      onStop: this.onDragStop
	    }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
	      className: className,
	      style: {
	        ...children.props.style,
	        ...style
	      },
	      transform: svgTransform
	    }));
	  }
	}
	exports.default = Draggable;
	_defineProperty(Draggable, "displayName", 'Draggable');
	_defineProperty(Draggable, "propTypes", {
	  // Accepts all props <DraggableCore> accepts.
	  ..._DraggableCore.default.propTypes,
	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
	    left: _propTypes.default.number,
	    right: _propTypes.default.number,
	    top: _propTypes.default.number,
	    bottom: _propTypes.default.number
	  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
	  defaultClassName: _propTypes.default.string,
	  defaultClassNameDragging: _propTypes.default.string,
	  defaultClassNameDragged: _propTypes.default.string,
	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  positionOffset: _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }),
	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	});
	_defineProperty(Draggable, "defaultProps", {
	  ..._DraggableCore.default.defaultProps,
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: {
	    x: 0,
	    y: 0
	  },
	  scale: 1
	}); 
} (Draggable$1));

const {
  default: Draggable,
  DraggableCore
} = Draggable$1;

// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
cjs.exports = Draggable;
cjs.exports.default = Draggable;
var DraggableCore_1 = cjs.exports.DraggableCore = DraggableCore;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

var doc = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' ? document : null;
var isBrowser = typeof window !== 'undefined' && typeof navigator !== 'undefined' && typeof document !== 'undefined';
var isUndef = function isUndef(v) {
  return typeof v === 'undefined';
};
var isFun = function isFun(v) {
  return typeof v === 'function';
};
var isNum = function isNum(v) {
  return typeof v === 'number';
};
/**
 * @description Will return renderer result if presented, div element otherwise.
 * If renderer is presented it'll receive `elementRef` function which should be used as HTMLElement's ref.
 *
 * @param props {ElementPropsWithElementRefAndRenderer}
 * @param elementRef {ElementRef}
 */

var renderDivWithRenderer = function renderDivWithRenderer(props, elementRef) {
  if (isFun(props.renderer)) {
    props.elementRef = elementRef;
    var renderer = props.renderer;
    delete props.renderer;
    return renderer(props);
  }

  delete props.elementRef;
  return React$1.createElement("div", __assign({}, props, {
    ref: elementRef
  }));
};

var getInnerSize = function getInnerSize(el, dimension, padding1, padding2) {
  var styles = getComputedStyle(el);

  if (styles.boxSizing === 'border-box') {
    return Math.max(0, (Number.parseFloat(styles[dimension]) || 0) - (Number.parseFloat(styles[padding1]) || 0) - (Number.parseFloat(styles[padding2]) || 0));
  }

  return Number.parseFloat(styles[dimension]) || 0;
};
/**
 * @description Return element's height without padding
 */


var getInnerHeight = function getInnerHeight(el) {
  return getInnerSize(el, 'height', 'paddingTop', 'paddingBottom');
};
/**
 * @description Return element's width without padding
 */

var getInnerWidth = function getInnerWidth(el) {
  return getInnerSize(el, 'width', 'paddingLeft', 'paddingRight');
};
/**
 * @description Return unique UUID v4
 */

var uuid = function uuid() {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  var uuid = '';

  for (var i = 0; i < 32; i++) {
    switch (i) {
      case 8:
      case 20:
        {
          uuid += "-".concat(Math.trunc(Math.random() * 16).toString(16));
          break;
        }

      case 12:
        {
          uuid += '-4';
          break;
        }

      case 16:
        {
          uuid += "-".concat((Math.random() * 16 | 0 & 3 | 8).toString(16));
          break;
        }

      default:
        {
          uuid += Math.trunc(Math.random() * 16).toString(16);
        }
    }
  }

  return uuid;
};
/**
 * @description Calculate thumb size for given viewport and track parameters
 *
 * @param {number} contentSize - Scrollable content size
 * @param {number} viewportSize - Viewport size
 * @param {number} trackSize - Track size thumb can move
 * @param {number} minimalSize - Minimal thumb's size
 * @param {number} maximalSize - Maximal thumb's size
 */

var calcThumbSize = function calcThumbSize(contentSize, viewportSize, trackSize, minimalSize, maximalSize) {
  if (viewportSize >= contentSize) {
    return 0;
  }

  var thumbSize = viewportSize / contentSize * trackSize;

  if (isNum(maximalSize)) {
    thumbSize = Math.min(maximalSize, thumbSize);
  }

  if (isNum(minimalSize)) {
    thumbSize = Math.max(minimalSize, thumbSize);
  }

  return thumbSize;
};
/**
 * @description Calculate thumb offset for given viewport, track and thumb parameters
 *
 * @param {number} contentSize - Scrollable content size
 * @param {number} viewportSize - Viewport size
 * @param {number} trackSize - Track size thumb can move
 * @param {number} thumbSize - Thumb size
 * @param {number} scroll - Scroll value to represent
 */

var calcThumbOffset = function calcThumbOffset(contentSize, viewportSize, trackSize, thumbSize, scroll) {
  if (!scroll || !thumbSize || viewportSize >= contentSize) {
    return 0;
  }

  return (trackSize - thumbSize) * scroll / (contentSize - viewportSize);
};
/**
 * @description Calculate scroll for given viewport, track and thumb parameters
 *
 * @param {number} contentSize - Scrollable content size
 * @param {number} viewportSize - Viewport size
 * @param {number} trackSize - Track size thumb can move
 * @param {number} thumbSize - Thumb size
 * @param {number} thumbOffset - Thumb's offset representing the scroll
 */

var calcScrollForThumbOffset = function calcScrollForThumbOffset(contentSize, viewportSize, trackSize, thumbSize, thumbOffset) {
  if (!thumbOffset || !thumbSize || viewportSize >= contentSize) {
    return 0;
  }

  return thumbOffset * (contentSize - viewportSize) / (trackSize - thumbSize);
};
/**
 * @description Returns scrollbar width specific for current environment. Can return undefined if DOM is not ready yet.
 */

var getScrollbarWidth = function getScrollbarWidth(force) {
  if (force === void 0) {
    force = false;
  }

  if (!doc) {
    getScrollbarWidth._cache = 0;
    return getScrollbarWidth._cache;
  }

  if (!force && !isUndef(getScrollbarWidth._cache)) {
    return getScrollbarWidth._cache;
  }

  var el = doc.createElement('div');
  el.setAttribute('style', 'position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;');
  doc.body.append(el);
  /* istanbul ignore next */

  if (el.clientWidth === 0) {
    // Do not even cache this value because there is no calculations. Issue https://github.com/xobotyi/react-scrollbars-custom/issues/123
    el.remove();
    return;
  }

  getScrollbarWidth._cache = 100 - el.clientWidth;
  el.remove();
  return getScrollbarWidth._cache;
};
/**
 * @description Detect need of horizontal scroll reverse while RTL.
 */

var shouldReverseRtlScroll = function shouldReverseRtlScroll(force) {
  if (force === void 0) {
    force = false;
  }

  if (!force && !isUndef(shouldReverseRtlScroll._cache)) {
    return shouldReverseRtlScroll._cache;
  }

  if (!doc) {
    shouldReverseRtlScroll._cache = false;
    return shouldReverseRtlScroll._cache;
  }

  var el = doc.createElement('div');
  var child = doc.createElement('div');
  el.append(child);
  el.setAttribute('style', 'position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;direction:rtl');
  child.setAttribute('style', 'width:1000px;height:1000px');
  doc.body.append(el);
  el.scrollLeft = -50;
  shouldReverseRtlScroll._cache = el.scrollLeft === -50;
  el.remove();
  return shouldReverseRtlScroll._cache;
};

var Emittr =
/** @class */
function () {
  function Emittr(maxHandlers) {
    if (maxHandlers === void 0) {
      maxHandlers = 10;
    }

    this.setMaxHandlers(maxHandlers);
    this._handlers = Object.create(null);
  }

  Emittr._callEventHandlers = function (emitter, handlers, args) {
    if (!handlers.length) {
      return;
    }

    if (handlers.length === 1) {
      Reflect.apply(handlers[0], emitter, args);
      return;
    }

    handlers = __spreadArray([], handlers);
    var idx;

    for (idx = 0; idx < handlers.length; idx++) {
      Reflect.apply(handlers[idx], emitter, args);
    }
  };

  Emittr.prototype.setMaxHandlers = function (count) {
    if (!isNum(count) || count <= 0) {
      throw new TypeError("Expected maxHandlers to be a positive number, got '".concat(count, "' of type ").concat(_typeof(count)));
    }

    this._maxHandlers = count;
    return this;
  };

  Emittr.prototype.getMaxHandlers = function () {
    return this._maxHandlers;
  };

  Emittr.prototype.emit = function (name) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    if (_typeof(this._handlers[name]) !== 'object' || !Array.isArray(this._handlers[name])) {
      return false;
    }

    Emittr._callEventHandlers(this, this._handlers[name], args);

    return true;
  };

  Emittr.prototype.on = function (name, handler) {
    Emittr._addHandler(this, name, handler);

    return this;
  };

  Emittr.prototype.prependOn = function (name, handler) {
    Emittr._addHandler(this, name, handler, true);

    return this;
  };

  Emittr.prototype.once = function (name, handler) {
    if (!isFun(handler)) {
      throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(handler)));
    }

    Emittr._addHandler(this, name, this._wrapOnceHandler(name, handler));

    return this;
  };

  Emittr.prototype.prependOnce = function (name, handler) {
    if (!isFun(handler)) {
      throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(handler)));
    }

    Emittr._addHandler(this, name, this._wrapOnceHandler(name, handler), true);

    return this;
  };

  Emittr.prototype.off = function (name, handler) {
    Emittr._removeHandler(this, name, handler);

    return this;
  };

  Emittr.prototype.removeAllHandlers = function () {
    var handlers = this._handlers;
    this._handlers = Object.create(null);
    var removeHandlers = handlers.removeHandler;
    delete handlers.removeHandler;
    var idx;
    var eventName; // eslint-disable-next-line guard-for-in,no-restricted-syntax

    for (eventName in handlers) {
      for (idx = handlers[eventName].length - 1; idx >= 0; idx--) {
        Emittr._callEventHandlers(this, removeHandlers, [eventName, handlers[eventName][idx].handler || handlers[eventName][idx]]);
      }
    }

    return this;
  };

  Emittr.prototype._wrapOnceHandler = function (name, handler) {
    var onceState = {
      fired: false,
      handler: handler,
      wrappedHandler: undefined,
      emitter: this,
      event: name
    };

    var wrappedHandler = Emittr._onceWrapper.bind(onceState);

    onceState.wrappedHandler = wrappedHandler;
    wrappedHandler.handler = handler;
    wrappedHandler.event = name;
    return wrappedHandler;
  };

  Emittr._addHandler = function (emitter, name, handler, prepend) {
    if (prepend === void 0) {
      prepend = false;
    }

    if (!isFun(handler)) {
      throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(handler)));
    }

    emitter._handlers[name] = emitter._handlers[name] || [];
    emitter.emit('addHandler', name, handler);

    if (prepend) {
      emitter._handlers[name].unshift(handler);
    } else {
      emitter._handlers[name].push(handler);
    }

    return emitter;
  };

  Emittr._onceWrapper = function _onceWrapper() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (!this.fired) {
      this.fired = true;
      this.emitter.off(this.event, this.wrappedHandler);
      Reflect.apply(this.handler, this.emitter, args);
    }
  };

  Emittr._removeHandler = function (emitter, name, handler) {
    if (!isFun(handler)) {
      throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(handler)));
    }

    if (isUndef(emitter._handlers[name]) || !emitter._handlers[name].length) {
      return emitter;
    }

    var idx = -1;

    if (emitter._handlers[name].length === 1) {
      if (emitter._handlers[name][0] === handler || emitter._handlers[name][0].handler === handler) {
        idx = 0;
        handler = emitter._handlers[name][0].handler || emitter._handlers[name][0];
      }
    } else {
      for (idx = emitter._handlers[name].length - 1; idx >= 0; idx--) {
        if (emitter._handlers[name][idx] === handler || emitter._handlers[name][idx].handler === handler) {
          handler = emitter._handlers[name][idx].handler || emitter._handlers[name][idx];
          break;
        }
      }
    }

    if (idx === -1) {
      return emitter;
    }

    if (idx === 0) {
      emitter._handlers[name].shift();
    } else {
      emitter._handlers[name].splice(idx, 1);
    }

    emitter.emit('removeHandler', name, handler);
    return emitter;
  };

  return Emittr;
}();

var RAFLoop =
/** @class */
function () {
  function RAFLoop() {
    var _this = this;
    /**
     * @description List of targets to update
     */


    this.targets = [];
    /**
     * @description ID of requested animation frame. Valuable only if loop is active and has items to iterate.
     */

    this.animationFrameID = 0;
    /**
     * @description Loop's state.
     */

    this._isActive = false;
    /**
     * @description Start the loop if it wasn't yet.
     */

    this.start = function () {
      if (!_this._isActive && _this.targets.length) {
        _this._isActive = true;
        if (_this.animationFrameID) cancelAnimationFrame(_this.animationFrameID);
        _this.animationFrameID = requestAnimationFrame(_this.rafCallback);
      }

      return _this;
    };
    /**
     * @description Stop the loop if is was active.
     */


    this.stop = function () {
      if (_this._isActive) {
        _this._isActive = false;
        if (_this.animationFrameID) cancelAnimationFrame(_this.animationFrameID);
        _this.animationFrameID = 0;
      }

      return _this;
    };
    /**
     * @description Add target to the iteration list if it's not there.
     */


    this.addTarget = function (target, silent) {
      if (silent === void 0) {
        silent = false;
      }

      if (!_this.targets.includes(target)) {
        _this.targets.push(target);

        if (_this.targets.length === 1 && !silent) _this.start();
      }

      return _this;
    };
    /**
     * @description Remove target from iteration list if it was there.
     */


    this.removeTarget = function (target) {
      var idx = _this.targets.indexOf(target);

      if (idx !== -1) {
        _this.targets.splice(idx, 1);

        if (_this.targets.length === 0) _this.stop();
      }

      return _this;
    };
    /**
     * @description Callback that called each animation frame.
     */


    this.rafCallback = function () {
      if (!_this._isActive) {
        return 0;
      }

      for (var i = 0; i < _this.targets.length; i++) {
        if (!_this.targets[i]._unmounted) _this.targets[i].update();
      }

      _this.animationFrameID = requestAnimationFrame(_this.rafCallback);
      return _this.animationFrameID;
    };
  }

  Object.defineProperty(RAFLoop.prototype, "isActive", {
    /**
     * @description Loop's state.
     */
    get: function get() {
      return this._isActive;
    },
    enumerable: false,
    configurable: true
  });
  return RAFLoop;
}();
var Loop = new RAFLoop();

var AXIS_DIRECTION;

(function (AXIS_DIRECTION) {
  AXIS_DIRECTION["X"] = "x";
  AXIS_DIRECTION["Y"] = "y";
})(AXIS_DIRECTION || (AXIS_DIRECTION = {}));

var TRACK_CLICK_BEHAVIOR;

(function (TRACK_CLICK_BEHAVIOR) {
  TRACK_CLICK_BEHAVIOR["JUMP"] = "jump";
  TRACK_CLICK_BEHAVIOR["STEP"] = "step";
})(TRACK_CLICK_BEHAVIOR || (TRACK_CLICK_BEHAVIOR = {}));

var ScrollbarThumb =
/** @class */
function (_super) {
  __extends(ScrollbarThumb, _super);

  function ScrollbarThumb() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.element = null;
    _this.initialOffsetX = 0;
    _this.initialOffsetY = 0;
    _this.elementRefHack = React$1.createRef();
    _this.lastDragData = {
      x: 0,
      y: 0,
      deltaX: 0,
      deltaY: 0,
      lastX: 0,
      lastY: 0
    };

    _this.handleOnDragStart = function (ev, data) {
      if (!_this.element) {
        _this.handleOnDragStop(ev, data);

        return;
      }

      if (isBrowser) {
        _this.prevUserSelect = document.body.style.userSelect;
        document.body.style.userSelect = 'none';
        _this.prevOnSelectStart = document.onselectstart;
        document.addEventListener('selectstart', ScrollbarThumb.selectStartReplacer);
      }

      if (_this.props.onDragStart) {
        _this.props.onDragStart(_this.lastDragData = {
          x: data.x - _this.initialOffsetX,
          y: data.y - _this.initialOffsetY,
          lastX: data.lastX - _this.initialOffsetX,
          lastY: data.lastY - _this.initialOffsetY,
          deltaX: data.deltaX,
          deltaY: data.deltaY
        });
      }

      _this.element.classList.add('dragging');
    };

    _this.handleOnDrag = function (ev, data) {
      if (!_this.element) {
        _this.handleOnDragStop(ev, data);

        return;
      }

      if (_this.props.onDrag) {
        _this.props.onDrag(_this.lastDragData = {
          x: data.x - _this.initialOffsetX,
          y: data.y - _this.initialOffsetY,
          lastX: data.lastX - _this.initialOffsetX,
          lastY: data.lastY - _this.initialOffsetY,
          deltaX: data.deltaX,
          deltaY: data.deltaY
        });
      }
    };

    _this.handleOnDragStop = function (ev, data) {
      var resultData = data ? {
        x: data.x - _this.initialOffsetX,
        y: data.y - _this.initialOffsetY,
        lastX: data.lastX - _this.initialOffsetX,
        lastY: data.lastY - _this.initialOffsetY,
        deltaX: data.deltaX,
        deltaY: data.deltaY
      } : _this.lastDragData;
      if (_this.props.onDragEnd) _this.props.onDragEnd(resultData);
      if (_this.element) _this.element.classList.remove('dragging');

      if (isBrowser) {
        document.body.style.userSelect = _this.prevUserSelect;

        if (_this.prevOnSelectStart) {
          document.addEventListener('selectstart', _this.prevOnSelectStart);
        }

        _this.prevOnSelectStart = null;
      }

      _this.initialOffsetX = 0;
      _this.initialOffsetY = 0;
      _this.lastDragData = {
        x: 0,
        y: 0,
        deltaX: 0,
        deltaY: 0,
        lastX: 0,
        lastY: 0
      };
    };

    _this.handleOnMouseDown = function (ev) {
      if (!_this.element) {
        return;
      }

      ev.preventDefault();
      ev.stopPropagation();

      if (!isUndef(ev.offsetX)) {
        /* istanbul ignore next */
        _this.initialOffsetX = ev.offsetX;
        /* istanbul ignore next */

        _this.initialOffsetY = ev.offsetY;
      } else {
        var rect = _this.element.getBoundingClientRect();

        _this.initialOffsetX = (ev.clientX || ev.touches[0].clientX) - rect.left;
        _this.initialOffsetY = (ev.clientY || ev.touches[0].clientY) - rect.top;
      }
    };

    _this.elementRef = function (ref) {
      if (isFun(_this.props.elementRef)) _this.props.elementRef(ref);
      _this.element = ref; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore

      _this.elementRefHack.current = ref;
    };

    return _this;
  }

  ScrollbarThumb.prototype.componentDidMount = function () {
    if (!this.element) {
      this.setState(function () {
        throw new Error("<ScrollbarThumb> Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
      });
    }
  };

  ScrollbarThumb.prototype.componentWillUnmount = function () {
    this.handleOnDragStop();
    this.elementRef(null);
  };

  ScrollbarThumb.prototype.render = function () {
    var _a = this.props;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.elementRef;
        var axis = _a.axis;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.onDrag;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.onDragEnd;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.onDragStart;
        var props = __rest(_a, ["elementRef", "axis", "onDrag", "onDragEnd", "onDragStart"]);

    props.className = cnb('ScrollbarsCustom-Thumb', axis === AXIS_DIRECTION.X ? 'ScrollbarsCustom-ThumbX' : 'ScrollbarsCustom-ThumbY', props.className);

    if (props.renderer) {
      props.axis = axis;
    }

    return React$1.createElement(DraggableCore_1, {
      allowAnyClick: false,
      enableUserSelectHack: false,
      onMouseDown: this.handleOnMouseDown,
      onDrag: this.handleOnDrag,
      onStart: this.handleOnDragStart,
      onStop: this.handleOnDragStop,
      nodeRef: this.elementRefHack
    }, renderDivWithRenderer(props, this.elementRef));
  };

  ScrollbarThumb.selectStartReplacer = function () {
    return false;
  };

  return ScrollbarThumb;
}(React$1.Component);

var ScrollbarTrack =
/** @class */
function (_super) {
  __extends(ScrollbarTrack, _super);

  function ScrollbarTrack() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.element = null;

    _this.elementRef = function (ref) {
      if (isFun(_this.props.elementRef)) _this.props.elementRef(ref);
      _this.element = ref;
    };

    _this.handleClick = function (ev) {
      if (!ev || !_this.element || ev.button !== 0) {
        return;
      }

      if (isFun(_this.props.onClick) && ev.target === _this.element) {
        if (!isUndef(ev.offsetX)) {
          _this.props.onClick(ev, {
            axis: _this.props.axis,
            offset: _this.props.axis === AXIS_DIRECTION.X ? ev.offsetX : ev.offsetY
          });
        } else {
          // support for old browsers

          /* istanbul ignore next */
          var rect = _this.element.getBoundingClientRect();
          /* istanbul ignore next */


          _this.props.onClick(ev, {
            axis: _this.props.axis,
            offset: _this.props.axis === AXIS_DIRECTION.X ? (ev.clientX || ev.touches[0].clientX) - rect.left : (ev.clientY || ev.touches[0].clientY) - rect.top
          });
        }
      }

      return true;
    };

    return _this;
  }

  ScrollbarTrack.prototype.componentDidMount = function () {
    if (!this.element) {
      this.setState(function () {
        throw new Error("Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
      });
      return;
    }

    this.element.addEventListener('click', this.handleClick);
  };

  ScrollbarTrack.prototype.componentWillUnmount = function () {
    if (this.element) {
      this.element.removeEventListener('click', this.handleClick);
      this.element = null;
      this.elementRef(null);
    }
  };

  ScrollbarTrack.prototype.render = function () {
    var _a = this.props;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.elementRef;
        var axis = _a.axis;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.onClick;
        var props = __rest(_a, ["elementRef", "axis", "onClick"]);

    props.className = cnb('ScrollbarsCustom-Track', axis === AXIS_DIRECTION.X ? 'ScrollbarsCustom-TrackX' : 'ScrollbarsCustom-TrackY', props.className);

    if (props.renderer) {
      props.axis = axis;
    }

    return renderDivWithRenderer(props, this.elementRef);
  };

  return ScrollbarTrack;
}(React$1.Component);

var style = {
  holder: {
    position: 'relative',
    width: '100%',
    height: '100%'
  },
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  content: {
    boxSizing: 'border-box'
  },
  track: {
    common: {
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 4,
      background: 'rgba(0,0,0,.1)',
      userSelect: 'none'
    },
    x: {
      height: 10,
      width: 'calc(100% - 20px)',
      bottom: 0,
      left: 10
    },
    y: {
      width: 10,
      height: 'calc(100% - 20px)',
      top: 10
    }
  },
  thumb: {
    common: {
      cursor: 'pointer',
      borderRadius: 4,
      background: 'rgba(0,0,0,.4)'
    },
    x: {
      height: '100%',
      width: 0
    },
    y: {
      width: '100%',
      height: 0
    }
  }
};

var pageZoomLevel = isBrowser ? i() : 1;

if (isBrowser) {
  window.addEventListener('resize', function () {
    pageZoomLevel = i();
  }, {
    passive: true
  });
}

var ScrollbarContext = React$1.createContext({
  parentScrollbar: null
});

var Scrollbar =
/** @class */
function (_super) {
  __extends(Scrollbar, _super);

  function Scrollbar(props) {
    var _this = _super.call(this, props) || this;
    /**
     * @description Get current scroll-related values.<br/>
     * If <i>force</i> if truthy - will recalculate them instead of returning cached values.
     *
     * @return ScrollState
     */


    _this.getScrollState = function (force) {
      if (force === void 0) {
        force = false;
      }

      if (_this.scrollValues && !force) {
        return __assign({}, _this.scrollValues);
      }

      var scrollState = {
        clientHeight: 0,
        clientWidth: 0,
        contentScrollHeight: 0,
        contentScrollWidth: 0,
        scrollHeight: 0,
        scrollWidth: 0,
        scrollTop: 0,
        scrollLeft: 0,
        scrollYBlocked: false,
        scrollXBlocked: false,
        scrollYPossible: false,
        scrollXPossible: false,
        trackYVisible: false,
        trackXVisible: false,
        zoomLevel: pageZoomLevel * 1,
        isRTL: undefined
      };
      var props = _this.props;
      scrollState.isRTL = _this.state.isRTL;
      scrollState.scrollYBlocked = props.noScroll || props.noScrollY;
      scrollState.scrollXBlocked = props.noScroll || props.noScrollX;

      if (_this.scrollerElement) {
        scrollState.clientHeight = _this.scrollerElement.clientHeight;
        scrollState.clientWidth = _this.scrollerElement.clientWidth;
        scrollState.scrollHeight = _this.scrollerElement.scrollHeight;
        scrollState.scrollWidth = _this.scrollerElement.scrollWidth;
        scrollState.scrollTop = _this.scrollerElement.scrollTop;
        scrollState.scrollLeft = _this.scrollerElement.scrollLeft;
        scrollState.scrollYPossible = !scrollState.scrollYBlocked && scrollState.scrollHeight > scrollState.clientHeight;
        scrollState.scrollXPossible = !scrollState.scrollXBlocked && scrollState.scrollWidth > scrollState.clientWidth;
        scrollState.trackYVisible = scrollState.scrollYPossible || props.permanentTracks || props.permanentTrackY;
        scrollState.trackXVisible = scrollState.scrollXPossible || props.permanentTracks || props.permanentTrackX;
      }

      if (_this.contentElement) {
        scrollState.contentScrollHeight = _this.contentElement.scrollHeight;
        scrollState.contentScrollWidth = _this.contentElement.scrollWidth;
      }

      return scrollState;
    };
    /**
     * @description Scroll to top border
     */


    _this.scrollToTop = function () {
      if (_this.scrollerElement) {
        _this.scrollerElement.scrollTop = 0;
      }

      return _this;
    };
    /**
     * @description Scroll to left border
     */


    _this.scrollToLeft = function () {
      if (_this.scrollerElement) {
        _this.scrollerElement.scrollLeft = 0;
      }

      return _this;
    };
    /**
     * @description Scroll to bottom border
     */


    _this.scrollToBottom = function () {
      if (_this.scrollerElement) {
        _this.scrollerElement.scrollTop = _this.scrollerElement.scrollHeight - _this.scrollerElement.clientHeight;
      }

      return _this;
    };
    /**
     * @description Scroll to right border
     */


    _this.scrollToRight = function () {
      if (_this.scrollerElement) {
        _this.scrollerElement.scrollLeft = _this.scrollerElement.scrollWidth - _this.scrollerElement.clientWidth;
      }

      return _this;
    };
    /**
     * @description Set the scrolls at given coordinates.<br/>
     * If coordinate is undefined - current scroll value will persist.
     */


    _this.scrollTo = function (x, y) {
      if (_this.scrollerElement) {
        if (isNum(x)) _this.scrollerElement.scrollLeft = x;
        if (isNum(y)) _this.scrollerElement.scrollTop = y;
      }

      return _this;
    };
    /**
     * @description Center the viewport at given coordinates.<br/>
     * If coordinate is undefined - current scroll value will persist.
     */


    _this.centerAt = function (x, y) {
      if (_this.scrollerElement) {
        if (isNum(x)) _this.scrollerElement.scrollLeft = x - _this.scrollerElement.clientWidth / 2;
        if (isNum(y)) _this.scrollerElement.scrollTop = y - _this.scrollerElement.clientHeight / 2;
      }

      return _this;
    };

    _this.update = function (force) {
      if (force === void 0) {
        force = false;
      }

      if (!_this.scrollerElement) {
        return;
      } // autodetect direction if not defined


      if (isUndef(_this.state.isRTL)) {
        _this.setState({
          isRTL: getComputedStyle(_this.scrollerElement).direction === 'rtl'
        });

        return _this.getScrollState();
      }

      var scrollState = _this.getScrollState(true);

      var prevScrollState = __assign({}, _this.scrollValues);

      var props = _this.props;
      var bitmask = 0;

      if (!force) {
        if (prevScrollState.clientHeight !== scrollState.clientHeight) bitmask |= Math.trunc(1);
        if (prevScrollState.clientWidth !== scrollState.clientWidth) bitmask |= 1 << 1;
        if (prevScrollState.scrollHeight !== scrollState.scrollHeight) bitmask |= 1 << 2;
        if (prevScrollState.scrollWidth !== scrollState.scrollWidth) bitmask |= 1 << 3;
        if (prevScrollState.scrollTop !== scrollState.scrollTop) bitmask |= 1 << 4;
        if (prevScrollState.scrollLeft !== scrollState.scrollLeft) bitmask |= 1 << 5;
        if (prevScrollState.scrollYBlocked !== scrollState.scrollYBlocked) bitmask |= 1 << 6;
        if (prevScrollState.scrollXBlocked !== scrollState.scrollXBlocked) bitmask |= 1 << 7;
        if (prevScrollState.scrollYPossible !== scrollState.scrollYPossible) bitmask |= 1 << 8;
        if (prevScrollState.scrollXPossible !== scrollState.scrollXPossible) bitmask |= 1 << 9;
        if (prevScrollState.trackYVisible !== scrollState.trackYVisible) bitmask |= 1 << 10;
        if (prevScrollState.trackXVisible !== scrollState.trackXVisible) bitmask |= 1 << 11;
        if (prevScrollState.isRTL !== scrollState.isRTL) bitmask |= 1 << 12;
        if (prevScrollState.contentScrollHeight !== scrollState.contentScrollHeight) bitmask |= 1 << 13;
        if (prevScrollState.contentScrollWidth !== scrollState.contentScrollWidth) bitmask |= 1 << 14;
        if (prevScrollState.zoomLevel !== scrollState.zoomLevel) bitmask |= 1 << 15; // if not forced and nothing has changed - skip this update

        if (bitmask === 0) {
          return prevScrollState;
        }
      } else {
        bitmask = 32767;
      }

      if (!props.native && _this.holderElement) {
        if (bitmask & 1 << 13 && (props.translateContentSizesToHolder || props.translateContentSizeYToHolder)) {
          _this.holderElement.style.height = "".concat(scrollState.contentScrollHeight, "px");
        }

        if (bitmask & 1 << 14 && (props.translateContentSizesToHolder || props.translateContentSizeXToHolder)) {
          _this.holderElement.style.width = "".concat(scrollState.contentScrollWidth, "px");
        }

        if (props.translateContentSizesToHolder || props.translateContentSizeYToHolder || props.translateContentSizeXToHolder) {
          if (!scrollState.clientHeight && scrollState.contentScrollHeight || !scrollState.clientWidth && scrollState.contentScrollWidth) {
            return;
          }
        }
      } // if scrollbars visibility has changed


      if (bitmask & 1 << 10 || bitmask & 1 << 11) {
        prevScrollState.scrollYBlocked = scrollState.scrollYBlocked;
        prevScrollState.scrollXBlocked = scrollState.scrollXBlocked;
        prevScrollState.scrollYPossible = scrollState.scrollYPossible;
        prevScrollState.scrollXPossible = scrollState.scrollXPossible;

        if (_this.trackYElement && bitmask & 1 << 10) {
          _this.trackYElement.style.display = scrollState.trackYVisible ? '' : 'none';
        }

        if (_this.trackXElement && bitmask & 1 << 11) {
          _this.trackXElement.style.display = scrollState.trackXVisible ? '' : 'none';
        }

        _this.scrollValues = prevScrollState;

        _this.setState({
          trackYVisible: _this.scrollValues.trackYVisible = scrollState.trackYVisible,
          trackXVisible: _this.scrollValues.trackXVisible = scrollState.trackXVisible
        });

        return;
      }

      (props.native ? _this.updaterNative : _this.updaterCustom)(bitmask, scrollState);
      _this.scrollValues = scrollState;

      if (!props.native && bitmask & 1 << 15) {
        getScrollbarWidth(true);

        _this.forceUpdate();
      }

      _this.eventEmitter.emit('update', __assign({}, scrollState), prevScrollState);

      if (bitmask & 1 << 4 || bitmask & 1 << 5) _this.eventEmitter.emit('scroll', __assign({}, scrollState), prevScrollState);
      return _this.scrollValues;
    }; // eslint-disable-next-line class-methods-use-this


    _this.updaterNative = function () {
      // just for future
      return true;
    };

    _this.updaterCustom = function (bitmask, scrollValues) {
      var props = _this.props;

      if (_this.trackYElement) {
        if (_this.thumbYElement && (bitmask & Math.trunc(1) || bitmask & 1 << 2 || bitmask & 1 << 4 || bitmask & 1 << 6 || bitmask & 1 << 8)) {
          if (scrollValues.scrollYPossible) {
            var trackInnerSize = getInnerHeight(_this.trackYElement);
            var thumbSize = calcThumbSize(scrollValues.scrollHeight, scrollValues.clientHeight, trackInnerSize, props.minimalThumbYSize || props.minimalThumbSize, props.maximalThumbYSize || props.maximalThumbSize);
            var thumbOffset = calcThumbOffset(scrollValues.scrollHeight, scrollValues.clientHeight, trackInnerSize, thumbSize, scrollValues.scrollTop);
            _this.thumbYElement.style.transform = "translateY(".concat(thumbOffset, "px)");
            _this.thumbYElement.style.height = "".concat(thumbSize, "px");
            _this.thumbYElement.style.display = '';
          } else {
            _this.thumbYElement.style.transform = '';
            _this.thumbYElement.style.height = '0px';
            _this.thumbYElement.style.display = 'none';
          }
        }
      }

      if (_this.trackXElement) {
        if (_this.thumbXElement && (bitmask & 1 << 1 || bitmask & 1 << 3 || bitmask & 1 << 5 || bitmask & 1 << 7 || bitmask & 1 << 9 || bitmask & 1 << 12)) {
          if (scrollValues.scrollXPossible) {
            var trackInnerSize = getInnerWidth(_this.trackXElement);
            var thumbSize = calcThumbSize(scrollValues.scrollWidth, scrollValues.clientWidth, trackInnerSize, props.minimalThumbXSize || props.minimalThumbSize, props.maximalThumbXSize || props.maximalThumbSize);
            var thumbOffset = calcThumbOffset(scrollValues.scrollWidth, scrollValues.clientWidth, trackInnerSize, thumbSize, scrollValues.scrollLeft);

            if (_this.state.isRTL && shouldReverseRtlScroll()) {
              thumbOffset += trackInnerSize - thumbSize;
            }

            _this.thumbXElement.style.transform = "translateX(".concat(thumbOffset, "px)");
            _this.thumbXElement.style.width = "".concat(thumbSize, "px");
            _this.thumbXElement.style.display = '';
          } else {
            _this.thumbXElement.style.transform = '';
            _this.thumbXElement.style.width = '0px';
            _this.thumbXElement.style.display = 'none';
          }
        }
      }

      return true;
    };

    _this.elementRefHolder = function (ref) {
      _this.holderElement = ref;

      if (isFun(_this.props.elementRef)) {
        _this.props.elementRef(ref);
      }
    };

    _this.elementRefWrapper = function (ref) {
      _this.wrapperElement = ref;

      if (isFun(_this.props.wrapperProps.elementRef)) {
        _this.props.wrapperProps.elementRef(ref);
      }
    };

    _this.elementRefScroller = function (ref) {
      _this.scrollerElement = ref;

      if (isFun(_this.props.scrollerProps.elementRef)) {
        _this.props.scrollerProps.elementRef(ref);
      }
    };

    _this.elementRefContent = function (ref) {
      _this.contentElement = ref;

      if (isFun(_this.props.contentProps.elementRef)) {
        _this.props.contentProps.elementRef(ref);
      }
    };

    _this.elementRefTrackX = function (ref) {
      _this.trackXElement = ref;

      if (isFun(_this.props.trackXProps.elementRef)) {
        _this.props.trackXProps.elementRef(ref);
      }
    };

    _this.elementRefTrackY = function (ref) {
      _this.trackYElement = ref;

      if (isFun(_this.props.trackYProps.elementRef)) {
        _this.props.trackYProps.elementRef(ref);
      }
    };

    _this.elementRefThumbX = function (ref) {
      _this.thumbXElement = ref;

      if (isFun(_this.props.thumbXProps.elementRef)) {
        _this.props.thumbXProps.elementRef(ref);
      }
    };

    _this.elementRefThumbY = function (ref) {
      _this.thumbYElement = ref;

      if (isFun(_this.props.thumbYProps.elementRef)) {
        _this.props.thumbYProps.elementRef(ref);
      }
    };

    _this.handleTrackXClick = function (ev, values) {
      if (_this.props.trackXProps.onClick) {
        _this.props.trackXProps.onClick(ev, values);
      }

      if (!_this.scrollerElement || !_this.trackXElement || !_this.thumbXElement || !_this.scrollValues || !_this.scrollValues.scrollXPossible) {
        return;
      }

      _this._scrollDetection();

      var thumbSize = _this.thumbXElement.clientWidth;
      var trackInnerSize = getInnerWidth(_this.trackXElement);
      var thumbOffset = (_this.scrollValues.isRTL && shouldReverseRtlScroll() ? values.offset + thumbSize / 2 - trackInnerSize : values.offset - thumbSize / 2) - (Number.parseFloat(getComputedStyle(_this.trackXElement).paddingLeft) || 0);
      var target = calcScrollForThumbOffset(_this.scrollValues.scrollWidth, _this.scrollValues.clientWidth, trackInnerSize, thumbSize, thumbOffset);

      if (_this.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.STEP) {
        target = (_this.scrollValues.isRTL ? _this.scrollValues.scrollLeft > target : _this.scrollValues.scrollLeft < target) ? _this.scrollValues.scrollLeft + _this.scrollValues.clientWidth : _this.scrollValues.scrollLeft - _this.scrollValues.clientWidth;
      }

      _this.scrollerElement.scrollLeft = target;
    };

    _this.handleTrackYClick = function (ev, values) {
      if (_this.props.trackYProps.onClick) _this.props.trackYProps.onClick(ev, values);

      if (!_this.scrollerElement || !_this.trackYElement || !_this.thumbYElement || !_this.scrollValues || !_this.scrollValues.scrollYPossible) {
        return;
      }

      _this._scrollDetection();

      var thumbSize = _this.thumbYElement.clientHeight;
      var target = calcScrollForThumbOffset(_this.scrollValues.scrollHeight, _this.scrollValues.clientHeight, getInnerHeight(_this.trackYElement), thumbSize, values.offset - thumbSize / 2) - (Number.parseFloat(getComputedStyle(_this.trackYElement).paddingTop) || 0);

      if (_this.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.JUMP) {
        _this.scrollerElement.scrollTop = target;
      } else {
        _this.scrollerElement.scrollTop = _this.scrollValues.scrollTop < target ? _this.scrollValues.scrollTop + _this.scrollValues.clientHeight : _this.scrollValues.scrollTop - _this.scrollValues.clientHeight;
      }
    };

    _this.handleTrackYMouseWheel = function (ev) {
      var props = _this.props;

      if (props.trackYProps && props.trackYProps.onWheel) {
        props.trackYProps.onWheel(ev);
      }

      if (props.disableTracksMousewheelScrolling || props.disableTrackYMousewheelScrolling) {
        return;
      }

      _this._scrollDetection();

      if (!_this.scrollerElement || _this.scrollValues.scrollYBlocked) {
        return;
      }

      _this.scrollTop += ev.deltaY;
    };

    _this.handleTrackXMouseWheel = function (ev) {
      var props = _this.props;

      if (props.trackXProps && props.trackXProps.onWheel) {
        props.trackXProps.onWheel(ev);
      }

      if (props.disableTracksMousewheelScrolling || props.disableTrackXMousewheelScrolling) {
        return;
      }

      _this._scrollDetection();

      if (!_this.scrollerElement || _this.scrollValues.scrollXBlocked) {
        return;
      }

      _this.scrollLeft += ev.deltaX;
    };

    _this.handleThumbXDrag = function (data) {
      var _a;

      if (!_this.trackXElement || !_this.thumbXElement || !_this.scrollerElement || !_this.scrollValues || !_this.scrollValues.scrollXPossible) {
        return;
      }

      _this._scrollDetection();

      var trackRect = _this.trackXElement.getBoundingClientRect();

      var styles = getComputedStyle(_this.trackXElement);
      var paddingLeft = Number.parseFloat(styles.paddingLeft) || 0;
      var paddingRight = Number.parseFloat(styles.paddingRight) || 0;
      var trackInnerSize = trackRect.width - paddingLeft - paddingRight;
      var thumbSize = _this.thumbXElement.clientWidth;
      var offset = _this.scrollValues.isRTL && shouldReverseRtlScroll() ? data.x + thumbSize - trackInnerSize + paddingLeft : data.lastX - paddingLeft;
      _this.scrollerElement.scrollLeft = calcScrollForThumbOffset(_this.scrollValues.scrollWidth, _this.scrollValues.clientWidth, trackInnerSize, thumbSize, offset);

      if ((_a = _this.props.thumbXProps) === null || _a === void 0 ? void 0 : _a.onDrag) {
        _this.props.thumbXProps.onDrag(data);
      }
    };

    _this.handleThumbXDragEnd = function (data) {
      var _a;

      _this.handleThumbXDrag(data);

      if ((_a = _this.props.thumbXProps) === null || _a === void 0 ? void 0 : _a.onDragEnd) {
        _this.props.thumbXProps.onDragEnd(data);
      }
    };

    _this.handleThumbYDrag = function (data) {
      var _a;

      if (!_this.scrollerElement || !_this.trackYElement || !_this.thumbYElement || !_this.scrollValues || !_this.scrollValues.scrollYPossible) {
        return;
      }

      _this._scrollDetection();

      var trackRect = _this.trackYElement.getBoundingClientRect();

      var styles = getComputedStyle(_this.trackYElement);
      var paddingTop = Number.parseFloat(styles.paddingTop) || 0;
      var paddingBottom = Number.parseFloat(styles.paddingBottom) || 0;
      var trackInnerSize = trackRect.height - paddingTop - paddingBottom;
      var thumbSize = _this.thumbYElement.clientHeight;
      var offset = data.y - paddingTop;
      _this.scrollerElement.scrollTop = calcScrollForThumbOffset(_this.scrollValues.scrollHeight, _this.scrollValues.clientHeight, trackInnerSize, thumbSize, offset);

      if ((_a = _this.props.thumbYProps) === null || _a === void 0 ? void 0 : _a.onDrag) {
        _this.props.thumbYProps.onDrag(data);
      }
    };

    _this.handleThumbYDragEnd = function (data) {
      var _a;

      _this.handleThumbYDrag(data);

      if ((_a = _this.props.thumbYProps) === null || _a === void 0 ? void 0 : _a.onDragEnd) {
        _this.props.thumbYProps.onDragEnd(data);
      }
    };

    _this.handleScrollerScroll = function () {
      _this._scrollDetection();
    };

    _this._scrollDetection = function () {
      if (!_this._scrollDetectionTO) {
        _this.eventEmitter.emit('scrollStart', _this.getScrollState());
      } else if (isBrowser) {
        window.clearTimeout(_this._scrollDetectionTO);
      }

      _this._scrollDetectionTO = isBrowser ? window.setTimeout(_this._scrollDetectionCallback, _this.props.scrollDetectionThreshold || 0) : null;
    };

    _this._scrollDetectionCallback = function () {
      _this._scrollDetectionTO = null;

      _this.eventEmitter.emit('scrollStop', _this.getScrollState());
    };

    _this.state = {
      trackXVisible: false,
      trackYVisible: false,
      isRTL: props.rtl
    };
    _this.scrollValues = _this.getScrollState(true);
    _this.eventEmitter = new Emittr(15);
    if (props.onUpdate) _this.eventEmitter.on('update', props.onUpdate);
    if (props.onScroll) _this.eventEmitter.on('scroll', props.onScroll);
    if (props.onScrollStart) _this.eventEmitter.on('scrollStart', props.onScrollStart);
    if (props.onScrollStop) _this.eventEmitter.on('scrollStop', props.onScrollStop);
    _this.id = uuid();
    return _this;
  }

  Object.defineProperty(Scrollbar.prototype, "scrollTop", {
    // eslint-disable-next-line react/sort-comp
    get: function get() {
      if (this.scrollerElement) {
        return this.scrollerElement.scrollTop;
      }

      return 0;
    },
    set: function set(top) {
      if (this.scrollerElement) {
        this.scrollerElement.scrollTop = top;
        this.update();
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
    get: function get() {
      if (this.scrollerElement) {
        return this.scrollerElement.scrollLeft;
      }

      return 0;
    },
    set: function set(left) {
      if (this.scrollerElement) {
        this.scrollerElement.scrollLeft = left;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Scrollbar.prototype, "scrollHeight", {
    get: function get() {
      if (this.scrollerElement) {
        return this.scrollerElement.scrollHeight;
      }

      return 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Scrollbar.prototype, "scrollWidth", {
    get: function get() {
      if (this.scrollerElement) {
        return this.scrollerElement.scrollWidth;
      }

      return 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Scrollbar.prototype, "clientHeight", {
    get: function get() {
      if (this.scrollerElement) {
        return this.scrollerElement.clientHeight;
      }

      return 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Scrollbar.prototype, "clientWidth", {
    get: function get() {
      if (this.scrollerElement) {
        return this.scrollerElement.clientWidth;
      }

      return 0;
    },
    enumerable: false,
    configurable: true
  }); // eslint-disable-next-line react/sort-comp

  Scrollbar.calculateStyles = function (props, state, scrollValues, scrollbarWidth) {
    var _a, _b, _c, _d;

    var useDefaultStyles = !props.noDefaultStyles;
    return {
      holder: __assign(__assign(__assign({}, useDefaultStyles && style.holder), {
        position: 'relative'
      }), props.style),
      wrapper: __assign(__assign(__assign({}, useDefaultStyles && __assign(__assign(__assign({}, style.wrapper), !props.disableTracksWidthCompensation && !props.disableTrackYWidthCompensation && (_a = {}, _a[state.isRTL ? 'left' : 'right'] = state.trackYVisible ? 10 : 0, _a)), !props.disableTracksWidthCompensation && !props.disableTrackXWidthCompensation && {
        bottom: state.trackXVisible ? 10 : 0
      })), props.wrapperProps.style), {
        position: 'absolute',
        overflow: 'hidden'
      }),
      content: __assign(__assign(__assign(__assign(__assign({}, useDefaultStyles && style.content), props.translateContentSizesToHolder || props.translateContentSizeYToHolder || props.translateContentSizeXToHolder ? {
        display: 'table-cell'
      } : {
        padding: 0.05 // needed to disable margin collapsing without flexboxes, other possible solutions here: https://stackoverflow.com/questions/19718634/how-to-disable-margin-collapsing

      }), useDefaultStyles && !(props.translateContentSizesToHolder || props.translateContentSizeYToHolder) && {
        minHeight: '100%'
      }), useDefaultStyles && !(props.translateContentSizesToHolder || props.translateContentSizeXToHolder) && {
        minWidth: '100%'
      }), props.contentProps.style),
      scroller: __assign(__assign(__assign(__assign((_b = {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        paddingBottom: !scrollbarWidth && scrollValues.scrollXPossible ? props.fallbackScrollbarWidth : undefined
      }, _b[state.isRTL ? 'paddingLeft' : 'paddingRight'] = !scrollbarWidth && scrollValues.scrollYPossible ? props.fallbackScrollbarWidth : undefined, _b), props.scrollerProps.style), !isUndef(props.rtl) && {
        direction: props.rtl ? 'rtl' : 'ltr'
      }), props.momentum && {
        WebkitOverflowScrolling: 'touch'
      }), (_c = {
        overflowY: scrollValues.scrollYPossible ? 'scroll' : 'hidden',
        overflowX: scrollValues.scrollXPossible ? 'scroll' : 'hidden',
        marginBottom: scrollValues.scrollXPossible ? -(scrollbarWidth || props.fallbackScrollbarWidth) - Number(scrollValues.zoomLevel !== 1) : undefined
      }, _c[state.isRTL ? 'marginLeft' : 'marginRight'] = scrollValues.scrollYPossible ? -(scrollbarWidth || props.fallbackScrollbarWidth) - Number(scrollValues.zoomLevel !== 1) : undefined, _c)),
      trackX: __assign(__assign(__assign(__assign({}, useDefaultStyles && style.track.common), useDefaultStyles && style.track.x), props.trackXProps.style), !state.trackXVisible && {
        display: 'none'
      }),
      trackY: __assign(__assign(__assign(__assign(__assign({}, useDefaultStyles && style.track.common), useDefaultStyles && style.track.y), useDefaultStyles && (_d = {}, _d[state.isRTL ? 'left' : 'right'] = 0, _d)), props.trackYProps.style), !state.trackYVisible && {
        display: 'none'
      }),
      thumbX: __assign(__assign(__assign({}, useDefaultStyles && style.thumb.common), useDefaultStyles && style.thumb.x), props.thumbXProps.style),
      thumbY: __assign(__assign(__assign({}, useDefaultStyles && style.thumb.common), useDefaultStyles && style.thumb.y), props.thumbYProps.style)
    };
  };

  Scrollbar.prototype.componentDidMount = function () {
    if (!this.scrollerElement) {
      this.setState(function () {
        throw new Error("scroller element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
      });
      return;
    }

    if (!this.contentElement) {
      this.setState(function () {
        throw new Error("content element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
      });
      return;
    }

    var props = this.props;

    if (!props.native && !props.mobileNative) {
      // ToDo: move native state to the state so it can be synchronized
      if (!this.holderElement) {
        this.setState(function () {
          throw new Error("holder element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
        });
        return;
      }

      if (!this.wrapperElement) {
        this.setState(function () {
          throw new Error("wrapper element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
        });
        return;
      }
    }

    Loop.addTarget(this);

    if (!isUndef(props.scrollTop)) {
      this.scrollerElement.scrollTop = props.scrollTop;
    }

    if (!isUndef(props.scrollLeft)) {
      this.scrollerElement.scrollLeft = props.scrollLeft;
    }

    this.update(true);
  };

  Scrollbar.prototype.componentWillUnmount = function () {
    Loop.removeTarget(this);
  };

  Scrollbar.prototype.componentDidUpdate = function (prevProps, prevState) {
    if (!this.scrollerElement) {
      return;
    }

    var props = this.props;

    if (props.rtl !== prevProps.rtl && props.rtl !== this.state.isRTL) {
      this.setState({
        isRTL: props.rtl
      });
    }

    if (this.state.isRTL !== prevState.isRTL) {
      this.update();
    }

    if (!isUndef(props.scrollTop) && props.scrollTop !== this.scrollerElement.scrollTop) {
      this.scrollerElement.scrollTop = props.scrollTop;
    }

    if (!isUndef(props.scrollLeft) && props.scrollLeft !== this.scrollerElement.scrollLeft) {
      this.scrollerElement.scrollLeft = props.scrollLeft;
    }

    if (prevProps.onUpdate !== props.onUpdate) {
      if (prevProps.onUpdate) this.eventEmitter.off('update', prevProps.onUpdate);
      if (props.onUpdate) this.eventEmitter.on('update', props.onUpdate);
    }

    if (prevProps.onScroll !== props.onScroll) {
      if (prevProps.onScroll) this.eventEmitter.off('scroll', prevProps.onScroll);
      if (props.onScroll) this.eventEmitter.on('scroll', props.onScroll);
    }

    if (prevProps.onScrollStart !== props.onScrollStart) {
      if (prevProps.onScrollStart) this.eventEmitter.off('scrollStart', prevProps.onScrollStart);
      if (props.onScrollStart) this.eventEmitter.on('scrollStart', props.onScrollStart);
    }

    if (prevProps.onScrollStop !== props.onScrollStop) {
      if (prevProps.onScrollStop) this.eventEmitter.off('scrollStop', prevProps.onScrollStop);
      if (props.onScrollStop) this.eventEmitter.on('scrollStop', props.onScrollStop);
    }
  }; // eslint-disable-next-line react/sort-comp


  Scrollbar.prototype.render = function () {
    var _a = this.props,
        createContext = _a.createContext,
        rtl = _a.rtl,
        native = _a.native,
        mobileNative = _a.mobileNative,
        momentum = _a.momentum;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.noDefaultStyles;
        var disableTracksMousewheelScrolling = _a.disableTracksMousewheelScrolling,
        disableTrackXMousewheelScrolling = _a.disableTrackXMousewheelScrolling,
        disableTrackYMousewheelScrolling = _a.disableTrackYMousewheelScrolling;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.disableTracksWidthCompensation;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.disableTrackXWidthCompensation;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.disableTrackYWidthCompensation;
        var noScrollX = _a.noScrollX,
        noScrollY = _a.noScrollY,
        noScroll = _a.noScroll,
        permanentTrackX = _a.permanentTrackX,
        permanentTrackY = _a.permanentTrackY,
        permanentTracks = _a.permanentTracks,
        removeTracksWhenNotUsed = _a.removeTracksWhenNotUsed,
        removeTrackYWhenNotUsed = _a.removeTrackYWhenNotUsed,
        removeTrackXWhenNotUsed = _a.removeTrackXWhenNotUsed;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.minimalThumbSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.maximalThumbSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.minimalThumbXSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.maximalThumbXSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.minimalThumbYSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.maximalThumbYSize;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.fallbackScrollbarWidth;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.scrollTop;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.scrollLeft;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.trackClickBehavior;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.scrollDetectionThreshold;
        var propsWrapperProps = _a.wrapperProps,
        propsScrollerProps = _a.scrollerProps,
        propsContentProps = _a.contentProps,
        propsTrackXProps = _a.trackXProps,
        propsTrackYProps = _a.trackYProps,
        propsThumbXProps = _a.thumbXProps,
        propsThumbYProps = _a.thumbYProps,
        propsScrollbarWidth = _a.scrollbarWidth;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.elementRef;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.onUpdate;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.onScroll;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.onScrollStart;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.onScrollStop;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.translateContentSizesToHolder;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.translateContentSizeYToHolder;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.translateContentSizeXToHolder;
        var children = _a.children,
        propsHolderProps = __rest(_a, ["createContext", "rtl", "native", "mobileNative", "momentum", "noDefaultStyles", "disableTracksMousewheelScrolling", "disableTrackXMousewheelScrolling", "disableTrackYMousewheelScrolling", "disableTracksWidthCompensation", "disableTrackXWidthCompensation", "disableTrackYWidthCompensation", "noScrollX", "noScrollY", "noScroll", "permanentTrackX", "permanentTrackY", "permanentTracks", "removeTracksWhenNotUsed", "removeTrackYWhenNotUsed", "removeTrackXWhenNotUsed", "minimalThumbSize", "maximalThumbSize", "minimalThumbXSize", "maximalThumbXSize", "minimalThumbYSize", "maximalThumbYSize", "fallbackScrollbarWidth", "scrollTop", "scrollLeft", "trackClickBehavior", "scrollDetectionThreshold", "wrapperProps", "scrollerProps", "contentProps", "trackXProps", "trackYProps", "thumbXProps", "thumbYProps", "scrollbarWidth", "elementRef", "onUpdate", "onScroll", "onScrollStart", "onScrollStop", "translateContentSizesToHolder", "translateContentSizeYToHolder", "translateContentSizeXToHolder", "children"]);

    var scrollbarWidth = !isUndef(propsScrollbarWidth) ? propsScrollbarWidth : getScrollbarWidth() || 0;

    if (native || !scrollbarWidth && mobileNative) {
      this.elementRefHolder(null);
      this.elementRefWrapper(null);
      this.elementRefTrackX(null);
      this.elementRefTrackY(null);
      this.elementRefThumbX(null);
      this.elementRefThumbY(null);

      var contentProps_1 = __assign(__assign({}, propsContentProps), {
        key: 'ScrollbarsCustom-Content',
        className: cnb('ScrollbarsCustom-Content', propsContentProps.className),
        children: children
      });

      var scrollerProps_1 = __assign(__assign({}, propsHolderProps), {
        className: cnb('ScrollbarsCustom native', this.state.trackYVisible && 'trackYVisible', this.state.trackXVisible && 'trackXVisible', this.state.isRTL && 'rtl', propsHolderProps.className),
        style: __assign(__assign(__assign(__assign({}, propsHolderProps.style), !isUndef(rtl) && {
          direction: rtl ? 'rtl' : 'ltr'
        }), momentum && {
          WebkitOverflowScrolling: 'touch'
        }), {
          overflowX: noScroll || noScrollX ? 'hidden' : permanentTracks || permanentTrackX ? 'scroll' : 'auto',
          overflowY: noScroll || noScrollY ? 'hidden' : permanentTracks || permanentTrackY ? 'scroll' : 'auto'
        }),
        onScroll: this.handleScrollerScroll,
        children: renderDivWithRenderer(contentProps_1, this.elementRefContent),
        renderer: propsScrollerProps.renderer,
        elementRef: propsScrollerProps.elementRef
      });

      return renderDivWithRenderer(scrollerProps_1, this.elementRefScroller);
    }

    var styles = Scrollbar.calculateStyles(this.props, this.state, this.scrollValues, scrollbarWidth);
    var holderChildren = [];

    var contentProps = __assign(__assign({}, propsContentProps), {
      key: 'ScrollbarsCustom-Content',
      className: cnb('ScrollbarsCustom-Content', propsContentProps.className),
      style: styles.content,
      children: createContext ? // eslint-disable-next-line react/jsx-no-constructed-context-values
      React$1.createElement(ScrollbarContext.Provider, {
        value: {
          parentScrollbar: this
        }
      }, children) : children
    });

    var scrollerProps = __assign(__assign({}, propsScrollerProps), {
      key: 'ScrollbarsCustom-Scroller',
      className: cnb('ScrollbarsCustom-Scroller', propsScrollerProps.className),
      style: styles.scroller,
      children: renderDivWithRenderer(contentProps, this.elementRefContent),
      onScroll: this.handleScrollerScroll
    });

    var wrapperProps = __assign(__assign({}, propsWrapperProps), {
      key: 'ScrollbarsCustom-Wrapper',
      className: cnb('ScrollbarsCustom-Wrapper', propsWrapperProps.className),
      style: styles.wrapper,
      children: renderDivWithRenderer(scrollerProps, this.elementRefScroller)
    });

    holderChildren.push(renderDivWithRenderer(wrapperProps, this.elementRefWrapper));

    if (this.state.trackYVisible || !removeTracksWhenNotUsed && !removeTrackYWhenNotUsed) {
      var thumbYProps = __assign(__assign({}, propsThumbYProps), {
        key: 'ScrollbarsCustom-ThumbY',
        style: styles.thumbY,
        elementRef: this.elementRefThumbY,
        onDrag: this.handleThumbYDrag,
        onDragEnd: this.handleThumbYDragEnd,
        axis: AXIS_DIRECTION.Y
      });

      var trackYProps = __assign(__assign(__assign(__assign({}, propsTrackYProps), {
        key: 'ScrollbarsCustom-TrackY',
        style: styles.trackY,
        elementRef: this.elementRefTrackY,
        onClick: this.handleTrackYClick
      }), (disableTracksMousewheelScrolling || disableTrackYMousewheelScrolling) && {
        onWheel: this.handleTrackYMouseWheel
      }), {
        axis: AXIS_DIRECTION.Y
      });

      trackYProps.children = React$1.createElement(ScrollbarThumb, __assign({}, thumbYProps));
      holderChildren.push(React$1.createElement(ScrollbarTrack, __assign({}, trackYProps)));
    } else {
      this.elementRefTrackY(null);
      this.elementRefThumbY(null);
    }

    if (this.state.trackXVisible || !removeTracksWhenNotUsed && !removeTrackXWhenNotUsed) {
      var thumbXProps = __assign(__assign({}, propsThumbXProps), {
        key: 'ScrollbarsCustom-ThumbX',
        style: styles.thumbX,
        elementRef: this.elementRefThumbX,
        onDrag: this.handleThumbXDrag,
        onDragEnd: this.handleThumbXDragEnd,
        axis: AXIS_DIRECTION.X
      });

      var trackXProps = __assign(__assign(__assign(__assign({}, propsTrackXProps), {
        key: 'ScrollbarsCustom-TrackX',
        style: styles.trackX,
        elementRef: this.elementRefTrackX,
        onClick: this.handleTrackXClick
      }), (disableTracksMousewheelScrolling || disableTrackXMousewheelScrolling) && {
        onWheel: this.handleTrackXMouseWheel
      }), {
        axis: AXIS_DIRECTION.X
      });

      trackXProps.children = React$1.createElement(ScrollbarThumb, __assign({}, thumbXProps));
      holderChildren.push(React$1.createElement(ScrollbarTrack, __assign({}, trackXProps)));
    } else {
      this.elementRefTrackX(null);
      this.elementRefThumbX(null);
    }

    var holderProps = __assign(__assign({}, propsHolderProps), {
      className: cnb('ScrollbarsCustom', this.state.trackYVisible && 'trackYVisible', this.state.trackXVisible && 'trackXVisible', this.state.isRTL && 'rtl', propsHolderProps.className),
      style: styles.holder,
      children: holderChildren
    });

    return renderDivWithRenderer(holderProps, this.elementRefHolder);
  }; // eslint-disable-next-line react/static-property-placement


  Scrollbar.contextType = ScrollbarContext; // eslint-disable-next-line react/static-property-placement

  Scrollbar.defaultProps = {
    momentum: true,
    minimalThumbSize: 30,
    fallbackScrollbarWidth: 20,
    trackClickBehavior: TRACK_CLICK_BEHAVIOR.JUMP,
    scrollDetectionThreshold: 100,
    wrapperProps: {},
    scrollerProps: {},
    contentProps: {},
    trackXProps: {},
    trackYProps: {},
    thumbXProps: {},
    thumbYProps: {}
  };
  return Scrollbar;
}(React$1.Component);

const contentStyles = {
    style: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
    },
};
const thumbYStyles = {
    style: {
        backgroundColor: '#EEEEEE',
        borderRadius: '5px',
        width: '4px',
    },
};
const trackYStyles = {
    style: {
        width: '4px',
        backgroundColor: 'transparent',
        height: '100%',
        top: '0',
    },
};
const SelectMultipleScrollbar = memo$1((props) => {
    return (React__default.createElement(Scrollbar, { translateContentSizeYToHolder: true, style: { maxHeight: '30vh', width: '100%' }, thumbYProps: thumbYStyles, trackYProps: trackYStyles, contentProps: contentStyles, onKeyDown: (e) => {
            if (['Space'].some((code) => code === e.code)) {
                e.preventDefault();
            }
        } }, props.children));
});
SelectMultipleScrollbar.displayName = 'SelectMultipleScrollbar';

const cn$2 = classNames.bind(s);
const SelectMultipleToggleAll = memo$1((props) => {
    const { flatSearchedOptions, handleToggleAll } = props;
    const isAllSelected = useMemo(() => flatSearchedOptions.every((option) => option.isSelected), [flatSearchedOptions]);
    const buttonText = useMemo(() => (isAllSelected ? 'Очистить выбор' : 'Выбрать все'), [isAllSelected]);
    const handleClick = useCallback(() => handleToggleAll(!isAllSelected), [handleToggleAll, isAllSelected]);
    if (!flatSearchedOptions.length)
        return null;
    return (React__default.createElement("button", { className: cn$2('toggleAll'), tabIndex: 0, onClick: handleClick }, buttonText));
});
SelectMultipleToggleAll.displayName = 'SelectMultipleToggleAll';

const cn$1 = classNames.bind(s);
const SelectMultipleEmptyOption = memo$1((props) => {
    return React__default.createElement("div", { className: cn$1('emptySearchOption') }, props.children);
});
SelectMultipleEmptyOption.displayName = 'SelectMultipleEmptySearch';

const cn = classNames.bind(s);
const SelectMultiple = memo$1((props) => {
    const { isDisabled, product, setIsOpen, selected } = props;
    const ref = useRef(null);
    useClickOutside(ref, () => setIsOpen(false));
    return (React__default.createElement("div", { className: cn('select', {
            disabled: isDisabled,
            completed: !!selected.length,
            [product]: product,
        }), ref: ref },
        React__default.createElement(SelectMultipleTop, Object.assign({}, props),
            React__default.createElement(SelectMultipleChips, Object.assign({}, props), [...selected]
                .sort((prev, next) => prev.selectTime - next.selectTime)
                .map((selectedItem) => {
                return React__default.createElement(SelectMultipleChip, Object.assign({ key: selectedItem.value, selectedItem: selectedItem }, props));
            })),
            React__default.createElement(SelectMultipleSearch, Object.assign({}, props))),
        React__default.createElement(SelectMultipleList, Object.assign({}, props),
            React__default.createElement(SelectMultipleToggleAll, Object.assign({}, props)),
            React__default.createElement(SelectMultipleScrollbar, Object.assign({}, props),
                props.searchedOptions.map((option, index) => {
                    var _a, _b, _c;
                    /** Если есть дочерняя группа options */
                    if (option.items) {
                        return (React__default.createElement(SelectMultipleGroup, { key: option.groupName, option: option }, (_a = option.items) === null || _a === void 0 ? void 0 : _a.map((optionItem) => (React__default.createElement(SelectMultipleOption, Object.assign({}, props, { key: optionItem.value, option: optionItem }))))));
                    }
                    else {
                        const isBeforeGroup = !!((_c = (_b = props.searchedOptions[index + 1]) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.length);
                        return (React__default.createElement(SelectMultipleOption, Object.assign({}, props, { key: option.value, option: option, className: cn({ option_beforeGroup: isBeforeGroup }) })));
                    }
                }),
                !!props.flatSearchedOptions.length && props.flatSearchedOptions.length < props.flatOptions.length && (React__default.createElement(SelectMultipleStat, Object.assign({}, props))),
                !!props.valueSearch && !props.flatSearchedOptions.length && (React__default.createElement(SelectMultipleEmptyOption, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E")))),
        React__default.createElement(SelectMultipleMessage, Object.assign({}, props))));
});
SelectMultiple.displayName = 'SelectMultiple';

const MAX_OPTIONS_COUNT = 10;

const optionsToFlat = (options) => {
    return options.map((opt) => (opt.items ? [...opt.items] : opt)).flat();
};

/** Перебор всех options с учетом вложенности в группы */
const mapGroup = (group, cb) => {
    return group.map((item) => {
        if (item === null || item === void 0 ? void 0 : item.items) {
            item.items = mapGroup(item === null || item === void 0 ? void 0 : item.items, cb);
        }
        return cb(item);
    });
};
const useSelect = ({ options, dropDirection, errorMessage, warningMessage, onSelect, valueSearch = '', isDisabled, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isDropdownFocused, setIsDropdownFocused] = useState(false);
    const [focusedOption, setFocusedOption] = useState(null);
    const flatOptions = useMemo(() => {
        return optionsToFlat(options);
    }, [options]);
    const selected = useMemo(() => {
        return flatOptions.filter((opt) => opt.isSelected);
    }, [flatOptions]);
    const searchedOptions = useMemo(() => {
        /** Счетчик количества отображаемых option-ов */
        let optionsCounter = 0;
        /** Поиск вхождений */
        let searchList = options.reduce((newOptions, option) => {
            /** Не выводить больше максимально допустимого количества option-ов */
            if (optionsCounter >= MAX_OPTIONS_COUNT) {
                return [...newOptions];
            }
            /** Проверка на вхождение в отдельном option-е */
            if (option === null || option === void 0 ? void 0 : option.value) {
                if (String(option.text).toLowerCase().trim().includes(valueSearch.toLowerCase().trim())) {
                    optionsCounter++;
                    return [...newOptions, Object.assign({}, option)];
                }
            }
            /** Проверка на вхождение в дочерних option-ах */
            if (option === null || option === void 0 ? void 0 : option.items) {
                const newItems = option.items.filter((childOption) => {
                    const isReturned = String(childOption.text).toLowerCase().trim().includes(valueSearch.toLowerCase().trim());
                    isReturned && optionsCounter++;
                    return isReturned;
                });
                if (newItems.length) {
                    return [...newOptions, Object.assign(Object.assign({}, option), { items: newItems })];
                }
            }
            return [...newOptions];
        }, []);
        /** Выделение фокуса */
        searchList = mapGroup(searchList, (option) => {
            option.isFocused = option.value === (focusedOption === null || focusedOption === void 0 ? void 0 : focusedOption.value);
            return option;
        });
        return searchList;
    }, [focusedOption === null || focusedOption === void 0 ? void 0 : focusedOption.value, options, valueSearch]);
    const flatSearchedOptions = useMemo(() => {
        return optionsToFlat(searchedOptions);
    }, [searchedOptions]);
    const isDropDirectionUp = useMemo(() => {
        return dropDirection === 'up';
    }, [dropDirection]);
    const isAlertsVisible = useMemo(() => !isOpen && !!(errorMessage || warningMessage), [errorMessage, isOpen, warningMessage]);
    const handleToggleAll = useCallback((newStatus) => {
        const newOptions = mapGroup(options, (item) => {
            const isInSearch = flatSearchedOptions.some((flatOption) => {
                return flatOption.value === item.value;
            });
            if (isInSearch) {
                item.isSelected = newStatus;
            }
            return item;
        });
        onSelect(newOptions);
    }, [flatSearchedOptions, onSelect, options]);
    const handleOptionClick = useCallback((option) => {
        const newOptions = mapGroup(options, (item) => {
            if (item.value === option.value) {
                item.isSelected = !item.isSelected;
                item.selectTime = item.isSelected ? Date.now() : null;
            }
            return item;
        });
        onSelect(newOptions);
    }, [options, onSelect]);
    const handleOptionKeyUp = useCallback((ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        let currentOptionIndex = flatSearchedOptions.findIndex((option) => option.isFocused);
        currentOptionIndex = currentOptionIndex !== -1 ? currentOptionIndex : 0;
        const prevOption = currentOptionIndex === 0 ? flatSearchedOptions[0] : flatSearchedOptions[currentOptionIndex - 1];
        const nextOption = currentOptionIndex === flatSearchedOptions.length - 1
            ? flatSearchedOptions[flatSearchedOptions.length - 1]
            : flatSearchedOptions[currentOptionIndex + 1];
        if (ev.key === 'ArrowDown') {
            setFocusedOption(nextOption);
        }
        if (ev.key === 'ArrowUp') {
            setFocusedOption(prevOption);
        }
        if (ev.code === 'Space') {
            const currentOption = flatSearchedOptions.find((option) => option.isFocused);
            if (!currentOption)
                return;
            handleOptionClick(currentOption);
        }
    }, [flatSearchedOptions, handleOptionClick]);
    const handleCheapsKeyUp = useCallback((ev, option) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.key === 'Backspace') {
            handleOptionClick(option);
        }
    }, [handleOptionClick]);
    const handleTitleClick = useCallback(() => {
        if (isDisabled)
            return;
        setIsOpen((prev) => !prev);
    }, [isDisabled]);
    return {
        isOpen,
        setIsOpen,
        selected,
        isDropDirectionUp,
        isAlertsVisible,
        handleOptionClick,
        handleTitleClick,
        searchedOptions,
        flatSearchedOptions,
        flatOptions,
        isDropdownFocused,
        setIsDropdownFocused,
        handleOptionKeyUp,
        setFocusedOption,
        handleToggleAll,
        handleCheapsKeyUp,
    };
};

export { ActivityRing, PageAlert as Alert, Button, CertificateCard$1 as CertificateCard, Checkbox, ColorPicker, CopyToClipboard$1 as CopyToClipboard, DateInput, DateInputLite, DatePicker, DatePickerLite, FileLoader, Icon, Input$1 as Input, MaskedInput, SearchInput, Select, SelectMultiple, SelectMultipleChip, SelectMultipleChips, SelectMultipleEmptyOption, SelectMultipleGroup, SelectMultipleList, SelectMultipleMessage, SelectMultipleOption, SelectMultipleScrollbar, SelectMultipleSearch, SelectMultipleStat, SelectMultipleToggleAll, SelectMultipleTop, ServiceSwitcher, StorybookLink as StorybookLinktton, SwitchTabs as Switch, TariffWidget, Textarea, TimeInput, TimePicker, Tooltip, Tumbler, useSelect };
